const wpPosts = [
    {
        id: 7895,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=7895",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "ministro-do-mcti-paulo-alvim-participou-esta-semana-em-brasilia-do-lancamento-do-canal-de-libras",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ministro-do-mcti-paulo-alvim-participou-esta-semana-em-brasilia-do-lancamento-do-canal-de-libras/",
        title: {
            rendered:
                "Ministro do MCTI, Paulo Alvim, participou, esta semana em Brasília do lançamento do Canal de Libras.",
        },
        content: {
            rendered:
                '<p style="text-align: justify;">Ministro do MCTI, Paulo Alvim, participou, esta semana em Brasília do lançamento do Canal de Libras. o Canal Libras e o Canal Educação oferecerão programas de jornalismo e variedades, como culinária, entrevistas, documentários históricos e contemporâneos, atualidades, problemas atuais, perspectivas de futuro, entre outros, com uma grade voltada para educar, conscientizar e esclarecer o cidadão.</p>\n<p>Acompanhe a reportagem publicada no canal EDUCAÇÃO</p>\n<p><iframe loading="lazy" title="Educação | Canal Educação e Canal Libras" width="1200" height="675" src="https://www.youtube.com/embed/qJLVUWE6T3E?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Ministro do MCTI, Paulo Alvim, participou, esta semana em Brasília do lançamento do Canal de Libras. o Canal Libras e o Canal Educação oferecerão programas de jornalismo e variedades, como culinária, entrevistas, documentários históricos e contemporâneos, atualidades, problemas atuais, perspectivas de futuro, entre outros, com uma grade voltada para educar, conscientizar e esclarecer o cidadão.&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7896,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [56, 62],
        tags: [],
        class_list: [
            "post-7895",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque",
            "category-todas-as-noticias",
            "category-56",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7895",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7895",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7895/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7897,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7895/revisions/7897",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7896",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7895",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7895",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7895",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7688,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=7688",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "7688",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/7688/",
        title: {
            rendered: "CONVITE ESPECIAL",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-7689 size-large" src="https://cintespbr.org/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-30-at-20.58.55-1024x738.jpeg" alt="" width="1024" height="738" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-30-at-20.58.55-1024x738.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-30-at-20.58.55-300x216.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-30-at-20.58.55-768x554.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-30-at-20.58.55.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><a href="http://youtube.com/mcti/live">Participe clicando aqui</a></p>\n',
            protected: false,
        },
        excerpt: {
            rendered: "<p>Participe clicando aqui</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7689,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-7688",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7688",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7688",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7688/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7693,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7688/revisions/7693",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7689",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7688",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7688",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7688",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7377,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=7377",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "realizacoes-2021-do-ministerio-da-ciencia-tecnologia-e-inovacoes-ep1",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/realizacoes-2021-do-ministerio-da-ciencia-tecnologia-e-inovacoes-ep1/",
        title: {
            rendered:
                "Realizações 2021 do Ministério Da Ciência, Tecnologia E Inovações. Ep1",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h2-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>Realizações 2021 do Ministério Da Ciência, Tecnologia E Inovações - Episódio 01<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://www.youtube.com/watch?v=dnJfIRpdeZ0&#8243;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://www.youtube.com/watch?v=dnJfIRpdeZ0&#8243;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7380,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-7377",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7377",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7377",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7377/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7379,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7377/revisions/7379",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7380",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7377",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7377",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7377",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7375,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=7375",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "realizacoes-2021-do-ministerio-da-ciencia-tecnologia-e-inovacoes-ep2-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/realizacoes-2021-do-ministerio-da-ciencia-tecnologia-e-inovacoes-ep2-2/",
        title: {
            rendered:
                "Realizações 2021 do Ministério Da Ciência, Tecnologia E Inovações. Ep2",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h2-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>Realizações 2021 do Ministério Da Ciência, Tecnologia E Inovações - Episódio 02<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://www.youtube.com/watch?v=qxXyBUeAcs0&#8243;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://www.youtube.com/watch?v=qxXyBUeAcs0&#8243;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7372,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-7375",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7375",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7375",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7375/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7376,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7375/revisions/7376",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7372",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7375",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7375",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7375",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7371,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=7371",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "realizacoes-2021-do-ministerio-da-ciencia-tecnologia-e-inovacoes-ep2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/realizacoes-2021-do-ministerio-da-ciencia-tecnologia-e-inovacoes-ep2/",
        title: {
            rendered:
                "Realizações 2021 do Ministério Da Ciência, Tecnologia E Inovações. Ep3",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h2-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>Realizações 2021 do Ministério Da Ciência, Tecnologia E Inovações - Episódio 03<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://www.youtube.com/watch?v=KCuwGbMSU1Q&#8221;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://www.youtube.com/watch?v=KCuwGbMSU1Q&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7382,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-7371",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7371",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7371",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7371/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7374,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7371/revisions/7374",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7382",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7371",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7371",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7371",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7157,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=7157",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "chamada-de-propostas-fapesp-mcti-mc-cgi-br-para-centros-de-pesquisa-aplicada-em-inteligencia-artificial-cpas-ia-2021",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/chamada-de-propostas-fapesp-mcti-mc-cgi-br-para-centros-de-pesquisa-aplicada-em-inteligencia-artificial-cpas-ia-2021/",
        title: {
            rendered:
                "Chamada de Propostas FAPESP – MCTI-MC – CGI.BR para Centros de Pesquisa Aplicada em Inteligência Artificial (CPAs-IA) – 2021",
        },
        content: {
            rendered:
                '<p><a href="https://fapesp.br/15116/chamada-de-propostas-fapesp-mcti-mc-cgibr-para-centros-de-pesquisa-aplicada-em-inteligencia-artificial-cpas-ia-2021" target="_blank" rel="noopener">Colaboração entre a Fundação de Amparo à Pesquisa do Estado de São Paulo – FAPESP, o Ministério de Estado da Ciência, Tecnologia e Inovações – MCTI, o Ministério das Comunicações e o Comitê Gestor da Internet no Brasil – CGI.br.</a><a href="https://fapesp.br/15116/chamada-de-propostas-fapesp-mcti-mc-cgibr-para-centros-de-pesquisa-aplicada-em-inteligencia-artificial-cpas-ia-2021" target="_blank" rel="noopener"><img loading="lazy" decoding="async" class="aligncenter wp-image-7158 size-full" src="https://cintespbr.org/wp-content/uploads/2021/11/388874bd-79f0-4087-824d-91ce9b2f3efe.png" alt="" width="1152" height="360" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/11/388874bd-79f0-4087-824d-91ce9b2f3efe.png 1152w, https://cintespbr.institucional.ws/wp-content/uploads/2021/11/388874bd-79f0-4087-824d-91ce9b2f3efe-300x94.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/11/388874bd-79f0-4087-824d-91ce9b2f3efe-1024x320.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/11/388874bd-79f0-4087-824d-91ce9b2f3efe-768x240.png 768w" sizes="(max-width: 1152px) 100vw, 1152px" /></a></p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Colaboração entre a Fundação de Amparo à Pesquisa do Estado de São Paulo – FAPESP, o Ministério de Estado da Ciência, Tecnologia e Inovações – MCTI, o Ministério das Comunicações e o Comitê Gestor da Internet no Brasil – CGI.br. &nbsp; &nbsp;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7162,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-7157",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7157",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7157",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7157/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7161,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7157/revisions/7161",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7162",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7157",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7157",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7157",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7034,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=7034",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "nota-falecimento-professor-doutor-luiz-ricardo-goulart",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/nota-falecimento-professor-doutor-luiz-ricardo-goulart/",
        title: {
            rendered:
                "NOTA FALECIMENTO &#8211; Professor Doutor Luiz Ricardo Goulart",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="wp-image-7035 aligncenter" src="https://cintespbr.org/wp-content/uploads/2021/10/WhatsApp-Image-2021-10-26-at-12.33.08-300x169.jpeg" alt="" width="467" height="263" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/10/WhatsApp-Image-2021-10-26-at-12.33.08-300x169.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/WhatsApp-Image-2021-10-26-at-12.33.08.jpeg 768w" sizes="(max-width: 467px) 100vw, 467px" /></p>\n<p>&nbsp;</p>\n<h3><strong>O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos – CINTESP.Br</strong> lamenta a morte do professor e cientista Luiz Ricardo Goulart.</h3>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Com forte contribuição para a ciência brasileira , foi coordenador do Instituto Nacional de Ciência e Tecnologia em Teranóstica e Nanobiotecnologia (um núcleo de excelência que engloba 16 instituições federais, 30 laboratórios, 11 instituições estrangeiras e 11 empresas, financiado pelo CNPq, Fapemig, Capes e Finep) e do Laboratório de Nanobiotecnologia (associado ao Sistema Nacional de Laboratórios em Nanotecnologias).</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Entre as várias frentes de pesquisas desenvolvidas e coordenadas pelo professor Luiz Ricardo Goulart, começava a ser planejada uma nova frente de trabalho com doenças raras. No ano passado, Luiz Goulart esteve no CINTESP.Br para iniciar uma série de planejamentos e de estudos, juntamente com Dr. Luiz Alberto, para a área de pesquisas em doenças raras.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Luiz Ricardo Goulart, desde 1992 era professor titular da UFU, estava vinculado ao Instituto de Biotecnologia (IBTEC), e também era professor adjunto do Departamento de Microbiologia Médica e Imunologia da Universidade da Califórnia-Davis, Estados Unidos.</span><br />\n<span style="font-size: 12pt;">Ele era graduado em Ciências Bioló</span><span style="font-size: 12pt;">gicas, pela Faculdade Educacional de Machado, e em Agronomia pela Universidade Federal de Lavras, com mestrado em Genética e doutorado em Genética Molecular pela Purdue University, com 2 pós-doutorado: em Patologia Molecular Médica pela Virginia Commonwealth University, Microbiologia Médica e em Imunologia pela University of California Davis, onde também foi professor visitante.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">“Perdem a família, os amigos e o país pela capacidade de produção científica em diversos projetos que ele vinha desenvolvendo, uma pessoa incrível uma perda realmente irreparável para essa terrível doença”, </span><span style="font-size: 12pt;">lamenta Cleudmar Amaral, coordenador do CINTESP.Br.</span></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos – CINTESP.Br lamenta a morte do professor e cientista Luiz Ricardo Goulart. Com forte contribuição para a ciência brasileira , foi coordenador do Instituto Nacional de Ciência e Tecnologia em Teranóstica e Nanobiotecnologia (um núcleo de excelência que engloba 16 instituições federais, 30&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7039,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [62],
        tags: [],
        class_list: [
            "post-7034",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-todas-as-noticias",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7034",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7034",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7034/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7040,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7034/revisions/7040",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7039",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7034",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7034",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7034",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6846,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=6846",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "dia-nacional-de-luta-da-pessoa-com-deficiencia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/dia-nacional-de-luta-da-pessoa-com-deficiencia/",
        title: {
            rendered:
                "ESPECIAL DIA NACIONAL DE LUTA DA PESSOA COM DEFICIÊNCIA &#8211; 21/SETEMBRO ÀS 19:30H",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;6847&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221; onclick=&#8221;custom_link&#8221; link=&#8221;https://youtu.be/tGqJFg8h8Rw&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;6847&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221; onclick=&#8221;custom_link&#8221; link=&#8221;https://youtu.be/tGqJFg8h8Rw&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6850,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-6846",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6846",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6846",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6846/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6853,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6846/revisions/6853",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6850",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6846",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6846",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6846",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6373,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=6373",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "08-de-julho-dia-nacional-da-ciencia-e-o-dia-nacional-do-pesquisador-cientifico",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/08-de-julho-dia-nacional-da-ciencia-e-o-dia-nacional-do-pesquisador-cientifico/",
        title: {
            rendered:
                "08 de Julho Dia Nacional da Ciência e o Dia Nacional do Pesquisador Científico.",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="alignnone wp-image-6374 size-full" src="https://cintespbr.org/wp-content/uploads/2021/07/dia-08.png" alt="" width="1351" height="888" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/dia-08.png 1351w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/dia-08-300x197.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/dia-08-1024x673.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/dia-08-768x505.png 768w" sizes="(max-width: 1351px) 100vw, 1351px" /></p>\n',
            protected: false,
        },
        excerpt: {
            rendered: "",
            protected: false,
        },
        author: 4,
        featured_media: 6374,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-6373",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6373",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6373",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6373/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6375,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6373/revisions/6375",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6374",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6373",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6373",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6373",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5602,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=5602",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "reuniao-entre-cintesp-br-e-comite-paralimpico-brasileiro",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/reuniao-entre-cintesp-br-e-comite-paralimpico-brasileiro/",
        title: {
            rendered:
                "REUNIÃO ENTRE CINTESP.Br® E COMITÊ PARALÍMPICO BRASILEIRO",
        },
        content: {
            rendered:
                '<p><strong>REUNIÃO ENTRE CINTESP.Br® E COMITÊ PARALÍMPICO BRASILEIRO TEM COMO TEMA A ENTREGA DE EQUIPAMENTOS PARA VALIDAÇÃO E TESTES COM PARATLETAS INICIANTES E DE ALTO RENDIMENTO NA SEDE DO CPB EM SÃO PAULO</strong></p>\n<div id="attachment_5603" style="width: 423px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5603" class="wp-image-5603" src="https://cintespbr.org/wp-content/uploads/2021/04/reuniao-300x218.png" alt="" width="413" height="300" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/04/reuniao-300x218.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/reuniao-1024x743.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/reuniao-768x557.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/reuniao.png 1464w" sizes="(max-width: 413px) 100vw, 413px" /><p id="caption-attachment-5603" class="wp-caption-text">(reunião on line Cleudmar Amaral Araújo, da coordenadora geral do CINTESP.Br® Daniela Moura Yoshida e do coordenador de esporte escolar do CPB, Ramon Pereira.)</p></div>\n<p style="text-align: justify;">    De olho no futuro, CINTESP.Br® e <a href="https://www.cpb.org.br/">Comitê Paralímpico Brasileiro</a> preparam agenda para a entrega de equipamentos que serão validados por alunos de 08 a 17 anos de idade, paratletas selecionados em todo país e paratletas de alto rendimento.</p>\n<p style="text-align: justify;">A entrega acontece em parceria com o <a href="https://www.gov.br/mcti/pt-br">Ministério da Ciência, Tecnologia e Inovação (MCTI)</a>, que busca transformar a pesquisa de Tecnologia Assistiva em produto, de forma acessível à sociedade e em menor tempo.</p>\n<p style="text-align: justify;">A reunião foi entre o diretor geral do CINTESP.Br®, Cleudmar Amaral Araújo, a coordenadora geral do CINTESP.Br®, Daniela Yoshida, o coordenador de esporte escolar do CPB, Ramon Pereira. Os primeiros equipamentos em Tecnologia Assistiva (TA) serão entregues até o mês de agosto auxiliando nos treinos dos nossos medalhistas paralímpicos e na preparação de nossos futuros campeões. <em><a href="https://www.cpb.org.br/noticia/detalhe/2897/escola-de-esportes-paralimpicos-do-cpb-retornara-em-2021">https://www.cpb.org.br/noticia/detalhe/2897/escola-de-esportes-paralimpicos-do-cpb-retornara-em-2021</a></em></p>\n<p style="text-align: justify;">Os equipamentos selecionados fazem parte de mais de 60 Projetos em Tecnologia Assistiva desenvolvidos pelo CINTESP.Br®. Neste primeiro momento serão equipamentos voltados para a natação paralímpica, a bocha paralímpica tanto para paratleta iniciantes quanto para o de alto rendimento.</p>\n<div id="attachment_5604" style="width: 568px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5604" class="wp-image-5604" src="https://cintespbr.org/wp-content/uploads/2021/04/mt-300x130.png" alt="" width="558" height="242" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/04/mt-300x130.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/mt-1024x442.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/mt-768x332.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/mt.png 1426w" sizes="(max-width: 558px) 100vw, 558px" /><p id="caption-attachment-5604" class="wp-caption-text">(Matheus Carvalho campeão brasileiro 2018 e da Copa América 2019 apresentação da calha para a bocha adaptada desenvolvida no CINTESP.Br® em parceria com MCTI)</p></div>\n<p style="text-align: justify;">Jogo de Bocha adaptado ou Bocha paralímpica é similar ao bocha convencional, o jogador tem como objetivo encostar o maior número de bolas na bola alvo.</p>\n<p style="text-align: justify;">O jogo é formado por um conjunto de seis bolas azuis, seis bolas vermelhas e uma bola branca (bola alvo). A quadra deverá ser lisa e plana como o piso de um ginásio em madeira ou sintético. A área é delimitada por linhas que possui uma dimensão de 12,5m x 6m maiores detalhes em: <a href="http://www.ande.org.br/wp/wp-content/uploads/2012/01/Regras-da-Bocha.pdf">CP-ISRA</a></p>\n<p style="text-align: justify;"><a href="https://www.cpb.org.br/modalidades/51/bocha">https://www.cpb.org.br/modalidades/51/bocha</a>).</p>\n<p style="text-align: justify;">O outro equipamento a ser entregue é o elevador de transferência para piscina, a tecnologia desenvolvida além de oferecer segurança ao paratleta deverá apresentar custo de cerca de 60% menor do valor encontrado atualmente no mercado. A principal vantagens do elevador de transferência para piscina está na acessibilidade e na prevenção a acidentes. (maiores detalhes em  <a href="https://www.prefeitura.sp.gov.br/cidade/secretarias/upload/nbr_%2009050_acessibilidade%20-%202004%20-%20acessibilidade_a_edificacoes_mobiliario_1259175853.pdf">https://www.prefeitura.sp.gov.br/cidade/secretarias/upload/nbr_%2009050_acessibilidade%20-%202004%20-%20acessibilidade_a_edificacoes_mobiliario_1259175853.pdf</a>)</p>\n<p style="text-align: left;"><a href="https://www.flickr.com/photos/sintonizemcti/albums/72157716072046372">https://www.flickr.com/photos/sintonizemcti/albums/72157716072046372</a></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>REUNIÃO ENTRE CINTESP.Br® E COMITÊ PARALÍMPICO BRASILEIRO TEM COMO TEMA A ENTREGA DE EQUIPAMENTOS PARA VALIDAÇÃO E TESTES COM PARATLETAS INICIANTES E DE ALTO RENDIMENTO NA SEDE DO CPB EM SÃO PAULO     De olho no futuro, CINTESP.Br® e Comitê Paralímpico Brasileiro preparam agenda para a entrega de equipamentos que serão validados por alunos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5603,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-5602",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5602",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5602",
                },
            ],
            "version-history": [
                {
                    count: 11,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5602/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5625,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5602/revisions/5625",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5603",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5602",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5602",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5602",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5598,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=5598",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "02-da-abril-dia-mundial-de-conscientizacao-do-autismo",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/02-da-abril-dia-mundial-de-conscientizacao-do-autismo/",
        title: {
            rendered: "02 da abril, Dia Mundial de Conscientização do Autismo.",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-5599 size-full" src="https://cintespbr.org/wp-content/uploads/2021/04/WhatsApp-Image-2021-04-02-at-17.28.17.jpeg" alt="" width="1280" height="782" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/04/WhatsApp-Image-2021-04-02-at-17.28.17.jpeg 1280w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/WhatsApp-Image-2021-04-02-at-17.28.17-300x183.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/WhatsApp-Image-2021-04-02-at-17.28.17-1024x626.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/WhatsApp-Image-2021-04-02-at-17.28.17-768x469.jpeg 768w" sizes="(max-width: 1280px) 100vw, 1280px" /></p>\n<p>Segundo a ONU (Organização das Nações Unidas), cerca de 70 milhões de pessoas possuem autismo, o que representa cerca de 1% da população mundial. Diante dessa realidade, consideramos de grande importância falar sobre essa condição que afeta pessoas no mundo inteiro.</p>\n<p>Diante dessa realidade, o CINTESP.Br® considera de grande importância o desenvolvimento de Tecnologia Assistiva que podem ajudar no processo de aprendizagem para estudantes autistas.</p>\n<p>Todos juntos para um mundo de inclusão.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Segundo a ONU (Organização das Nações Unidas), cerca de 70 milhões de pessoas possuem autismo, o que representa cerca de 1% da população mundial. Diante dessa realidade, consideramos de grande importância falar sobre essa condição que afeta pessoas no mundo inteiro. Diante dessa realidade, o CINTESP.Br® considera de grande importância o desenvolvimento de Tecnologia Assistiva&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5599,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [62, 46],
        tags: [],
        class_list: [
            "post-5598",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-todas-as-noticias",
            "category-ultimas-noticias",
            "category-62",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5598",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5598",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5598/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5615,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5598/revisions/5615",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5599",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5598",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5598",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5598",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5403,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=5403",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "nossa-homenagem-na-semana-do-dia-nacional-da-escola",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/nossa-homenagem-na-semana-do-dia-nacional-da-escola/",
        title: {
            rendered: "NOSSA HOMENAGEM NA SEMANA DO DIA NACIONAL DA ESCOLA",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<h2><strong><img loading="lazy" decoding="async" class="alignnone wp-image-5404 size-full" src="https://cintespbr.org/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-14-at-20.46.35.jpeg" alt="" width="1280" height="851" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-14-at-20.46.35.jpeg 1280w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-14-at-20.46.35-300x199.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-14-at-20.46.35-1024x681.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-14-at-20.46.35-768x511.jpeg 768w" sizes="(max-width: 1280px) 100vw, 1280px" />NOSSA HOMENAGEM NA SEMANA DO DIA NACIONAL DA ESCOLA</strong></h2>\n<p><strong>Dia Nacional da Escola</strong></p>\n<p>Instituição de maior importância para a formação educacional do cidadão, a escola prepara a criança para um futuro de maiores possibilidades para termos um mundo melhor, mais sustentável, inclusivo e empreendedor com melhor qualidade de vida para toda a sociedade.</p>\n<p>É na Escola que se aprende a colocar em prática vários conceitos essenciais para manter uma vida em sociedade.</p>\n<p>A Escola tornou-se a base de conhecimento de todas as nações do mundo, e faz parte da nossa casa, onde confiamos nossas crianças.</p>\n<p>Dia 15 de Março é dia de celebrar a criação desta tão importante instituição para que juntos possamos transformar este conhecimento em um Mundo de Inclusão e Igualdade.</p>\n<p><strong>VAMOS CUIDAR COM CARINHO DAS NOSSAS ESCOLAS, A INSTITUIÇÃO QUE ENSINA E EDUCA OS FILHOS DO BRASIL.</strong></p>\n<p>Educação, um direito de todos os brasileiros &#8211; crianças, adolescentes, jovens, adultos e idosos.</p>\n<p><strong>Uma homenagem do MCTI, MEC, MMFDH e CINTESP.Br</strong>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] NOSSA HOMENAGEM NA SEMANA DO DIA NACIONAL DA ESCOLA Dia Nacional da Escola Instituição de maior importância para a formação educacional do cidadão, a escola prepara a criança para um futuro de maiores possibilidades para termos um mundo melhor, mais sustentável, inclusivo e empreendedor com melhor qualidade de vida para toda a sociedade. É&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5404,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 58, 62],
        tags: [],
        class_list: [
            "post-5403",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-hoomenagem",
            "category-todas-as-noticias",
            "category-47",
            "category-58",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5403",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5403",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5403/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5407,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5403/revisions/5407",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5404",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5403",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5403",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5403",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5168,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=5168",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "amazonia-1-e-lancado-com-sucesso-e-satelite-ja-esta-em-orbita",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/amazonia-1-e-lancado-com-sucesso-e-satelite-ja-esta-em-orbita/",
        title: {
            rendered:
                "Amazonia-1 é lançado com sucesso e satélite já está em órbita",
        },
        content: {
            rendered:
                '<h3>Equipamento vai fornecer imagens para monitoramento da região costeira, reservatórios de água, desastres ambientais e estarão à disposição da comunidade científica, órgãos de governo e quaisquer interessados</h3>\n<p><img loading="lazy" decoding="async" class="wp-image-5166 size-full aligncenter" src="https://cintespbr.org/wp-content/uploads/2021/02/f27c39d3-3b22-4413-9f2a-88670111cfeb.png" alt="" width="768" height="420" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/02/f27c39d3-3b22-4413-9f2a-88670111cfeb.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/02/f27c39d3-3b22-4413-9f2a-88670111cfeb-300x164.png 300w" sizes="(max-width: 768px) 100vw, 768px" /></p>\n<p style="text-align: justify;">O domingo, 28 de fevereiro de 2021, já é um dia histórico para o programa espacial brasileiro. Direto do Centro de Lançamento Satish Dhawan Space Centre, em Sriharikota, na Índia o satélite Amazonia-1 foi lançado, exatamente às 10h24 (hora local), 1h54 (horário de Brasília). Sem imprevistos, a operação foi um sucesso e o primeiro satélite de observação da Terra totalmente projetado, integrado, testado e operado pelo Brasil, já está no espaço, situado numa altitude média de 752 km acima da superfície terrestre. Uma comitiva do governo brasileiro liderada pelo ministro da Ciência, Tecnologia e Inovações, Marcos Pontes acompanhou o lançamento direto da Índia. Também fizeram parte da delegação o diretor do Instituto Nacional de Pesquisas Espaciais (INPE/MCTI), Clezio de Nardin, o presidente da Agência Espacial Brasileira (AEB/MCTI) Carlos Moura além de outras autoridades brasileiras.</p>\n<p style="text-align: justify;">Ao final do lançamento bem-sucedido, o ministro Pontes comentou a importância da missão para o Brasil. “O satélite será fundamental para o monitoramento da Amazônia e outros biomas no Brasil, além de inaugurar uma nova era para a indústria brasileira de satélites”, ressaltou.</p>\n<p style="text-align: justify;">O diretor do INPE/MCTI, Clezio de Nardin também comemorou o sucesso do lançamento, “um dos marcos mais importantes do desenvolvimento de um satélite” e confirmou a execução de procedimentos fundamentais para a operação do aparelho. “O satélite executou as primeiras atividades previstas, como a abertura do painel solar, a estabilização de sua orientação em relação à Terra, a verificação preliminar de seus subsistemas e a colocação no modo de prontidão. Iniciamos neste momento a fase de teste para verificação do satélite e ajustes de sua câmera, o que permitirá obter a primeira imagem de alta resolução gerada pelo Amazonia-1.</p>\n<p style="text-align: justify;">O Amazônia-1 é o terceiro satélite brasileiro de sensoriamento remoto em operação, junto com o CBERS-4 e CBERS-4A. O equipamento vai fornecer imagens para monitoramento da Terra. Os dados gerados também serão úteis para atender o monitoramento da região costeira, reservatórios de água, desastres ambientais e estarão à disposição da comunidade científica, órgãos de governo e quaisquer interessados.</p>\n<p style="text-align: justify;">O equipamento integra a Missão Amazônia, que tem, por objetivo, fornecer dados de sensoriamento remoto para observar e monitorar especialmente a região amazônica, além de monitorar a agricultura no pais, a região costeira, reservatórios de água e florestas (naturais e cultivadas). Há, ainda, a possibilidade de uso para observações de possíveis desastres ambientais. A Missão Amazônia pretende lançar, em data a ser definida, mais dois satélites de sensoriamento remoto: o Amazônia-1B e o Amazônia-2.</p>\n<p style="text-align: justify;">Entre os ganhos tecnológicos que a missão deverá render ao país se destacam a consolidação do conhecimento do Brasil no ciclo completo de desenvolvimento de satélites; o desenvolvimento da indústria nacional dos mecanismos de abertura de painéis solares, o desenvolvimento da propulsão do subsistema de controle de atitude e órbita na indústria nacional e a consolidação de conhecimentos na campanha de lançamento de satélites de maior complexidade.</p>\n<p style="text-align: justify;"><strong>Transmissão ao vivo</strong></p>\n<p style="text-align: justify;">O Ministério da Ciência, Tecnologia e Inovações (MCTI), em parceria com suas vinculadas INPE e AEB, realizou uma transmissão ao vivo repleta de vídeos, imagens e comentários de especialistas que participaram do projeto Amazonia-1. De Brasília, o diretor do Departamento de Promoção e Difusão da Ciência, Tecnologia e Inovação do MCTI, Daniel Lavouras, comandou a transmissão ao lado do chefe da Assessoria de Relações Institucionais e Comunicação da AEB/MCTI, André Barreto. Em São José dos Campos, na sede do INPE/MCTI, a diretora substituta, Monica Rocha,   participou do evento acompanhada de especialistas do instituto. Participaram, ainda, representantes da AEB/MCTI e de empresas envolvidas no desenvolvimento do satélite.</p>\n<p style="text-align: justify;">Aproximadamente uma hora antes do lançamento, o ministro Pontes entrou ao vivo do centro de lançamento. “São 26 técnicos do INPE trabalhando no satélite aqui na Índia há um bom tempo e a informação que tive do diretor Clezio é que está tudo luz verde, então os sistemas estão operacionais, em modo de voo e agora começam as desconexões, do modo de sustentação de solo para que ele fique independente”, explicou.</p>\n<p style="text-align: justify;">O ministro falou sobre os encontros com autoridades da Índia em ciência e tecnologia o estreitamento de relações para o setor, especialmente nas áreas de nanotecnologia, materiais avançados, inteligência artificial e espaço.</p>\n<p style="text-align: justify;">Antes de se despedir e seguir para o centro de controle de lançamento, o ministrou compartilhou sua euforia. “A expectativa é grande e estou bastante feliz por estar acompanhando com vocês. Sucesso pra todos nós — é o Brasil decolando!”</p>\n<p style="text-align: justify;">O presidente da AEB/MCTI, Carlos Moura, comemorou o acontecimento. “O Amazonia-1 coroa um esforço que vem lá de 79, 80 para que o país fosse capaz de desenvolver um satélite próprio de sensorialmente remoto ótico.”</p>\n<p style="text-align: justify;">Em uma mensagem gravada em vídeo, o embaixador da Índia no Brasil, Suresh K. Reddy, ressaltou a cooperação entre os países e destacou a operação espacial de seu país. “Vamos testemunhar um novo capítulo, com o lançamento do Amazonia-1 no foguete PSLV. Durante a visita do presidente Bolsonaro no ano passado, Brasil e Índia concordaram em tornar a cooperação na área espacial uma prioridade e estou satisfeito que esse lançamento esteja ocorrendo pouco tempo depois.”</p>\n<p style="text-align: justify;">A transmissão completa está disponível no canal do MCTI no YouTube, em <a class="external-link" title="" href="http://www.youtube.com/mctic" target="_self" rel="noopener" data-tippreview-enabled="false" data-tippreview-image="" data-tippreview-title="">www.YouTube.com/mctic</a></p>\n<p style="text-align: justify;"><strong>Amazônia-1</strong></p>\n<p style="text-align: justify;">Com seis quilômetros de fios e 14 mil conexões elétricas, o Amazônia-1 será o terceiro satélite brasileiro de sensoriamento remoto em operação junto ao CBERS-4 e ao CBERS-4A. O Amazônia-1 é um satélite de órbita Sol síncrona (polar) que irá gerar imagens do planeta a cada 5 dias. Para isso, possui um imageador óptico de visada larga (câmera com 3 bandas de frequências no espectro visível VIS e 1 banda próxima do infravermelho Near Infrared ou NIR) capaz de observar uma faixa de aproximadamente 850 km com 64 metros de resolução.</p>\n<p style="text-align: justify;">Sua órbita foi projetada para proporcionar uma alta taxa de revisita (5 dias), tendo, com isso, capacidade de disponibilizar uma significativa quantidade de dados de um mesmo ponto do planeta. Sob demanda, o Amazônia-1 poderá fornecer dados de um ponto específico em dois dias. Esta característica é extremamente valiosa em aplicações de observação da Terra, pois aumenta a probabilidade de captura de imagens úteis diante da cobertura de nuvens na região.</p>\n<p style="text-align: justify;">Os satélites da série Amazônia serão formados por dois módulos independentes: um Módulo de Serviço, que é a Plataforma Multimissão (PMM), e um Módulo de Carga Útil, que abriga câmeras imageadoras e equipamentos de gravação e transmissão de dados de imagens.</p>\n<p style="text-align: left;">\n<p>FONTE: https://www.gov.br/mcti</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Equipamento vai fornecer imagens para monitoramento da região costeira, reservatórios de água, desastres ambientais e estarão à disposição da comunidade científica, órgãos de governo e quaisquer interessados O domingo, 28 de fevereiro de 2021, já é um dia histórico para o programa espacial brasileiro. Direto do Centro de Lançamento Satish Dhawan Space Centre, em Sriharikota,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5169,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-5168",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5168",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5168",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5168/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5173,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5168/revisions/5173",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5169",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5168",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5168",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5168",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5157,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=5157",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "28-de-fevereiro-dia-mundial-das-doencas-raras",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/28-de-fevereiro-dia-mundial-das-doencas-raras/",
        title: {
            rendered: "28 DE FEVEREIRO &#8211; DIA MUNDIAL DAS DOENÇAS RARAS",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<h2><img loading="lazy" decoding="async" class="aligncenter wp-image-5197 size-full" src="https://cintespbr.org/wp-content/uploads/2021/02/WhatsApp-Image-2021-02-28-at-15.39.36.jpeg" alt="" width="1280" height="855" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/02/WhatsApp-Image-2021-02-28-at-15.39.36.jpeg 1280w, https://cintespbr.institucional.ws/wp-content/uploads/2021/02/WhatsApp-Image-2021-02-28-at-15.39.36-300x200.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/02/WhatsApp-Image-2021-02-28-at-15.39.36-1024x684.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/02/WhatsApp-Image-2021-02-28-at-15.39.36-768x513.jpeg 768w" sizes="(max-width: 1280px) 100vw, 1280px" />MUITOS SOMOS E TODOS SOMOS RAROS</h2>\n<p style="text-align: justify;">E Pensando nos RAROS!!!<br />\nO Brasil ganha um apoio significativo de referência nacional aos Raros que será implantado na cidade de Uberlândia/MG, o CNT, uma iniciativa do <a href="https://www.gov.br/mcti/pt-br">Ministério da Ciência, Tecnologia e Inovações &#8211; MCTI</a>, em parceria com a <a href="http://www.ufu.br/">Universidade Federal de Uberlândia</a>, <a href="http://cintespbr.org/">Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos – CINTESP.Br</a>, <a href="https://www.cpb.org.br/">Comitê Paralímpico Brasileiro</a> e <a href="https://www.algar.com.br/">Grupo Algar</a>.<br />\nO Centro Nacional de Tecnologias para Pessoas com Deficiência e Doenças Raras – CNT/MCTI, será o primeiro centro no Brasil com laboratórios dedicados ao desenvolvimento de tecnologia assistiva, para a área da saúde, lazer, vida-diária, educação e esportes, a fim de contribuir com a qualidade de vida, a autonomia e a inclusão das pessoas com deficiência, mobilidade reduzida e doenças raras.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_media_grid grid_id=&#8221;vc_gid:1614522300869-1b1418b2-6ab7-0&#8243; include=&#8221;5163,5162,5161,5160,5159&#8243;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] MUITOS SOMOS E TODOS SOMOS RAROS E Pensando nos RAROS!!! O Brasil ganha um apoio significativo de referência nacional aos Raros que será implantado na cidade de Uberlândia/MG, o CNT, uma iniciativa do Ministério da Ciência, Tecnologia e Inovações &#8211; MCTI, em parceria com a Universidade Federal de Uberlândia, Centro Brasileiro de Referência em&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5199,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-5157",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5157",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5157",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5157/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5200,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5157/revisions/5200",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5199",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5157",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5157",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5157",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5096,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=5096",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "mcti-transmite-ao-vivo-lancamento-do-satelite-amazonia-1-neste-sabado-27",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/mcti-transmite-ao-vivo-lancamento-do-satelite-amazonia-1-neste-sabado-27/",
        title: {
            rendered:
                "MCTI transmite ao vivo lançamento do satélite Amazonia-1 neste sábado (27)",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-5097 size-full" src="https://cintespbr.org/wp-content/uploads/2021/02/123010db-cccf-4598-b168-3ec9a11ec587.jpeg" alt="" width="768" height="432" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/02/123010db-cccf-4598-b168-3ec9a11ec587.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/02/123010db-cccf-4598-b168-3ec9a11ec587-300x169.jpeg 300w" sizes="(max-width: 768px) 100vw, 768px" /></p>\n<p style="text-align: justify;">Satélite totalmente projetado, integrado, testado e operado pelo Brasil, o Amazônia-1 será lançado ao espaço no dia 28 de fevereiro no Satish Dhawan Space Centre, em Sriharikota, na Índia. Uma delegação do Ministério da Ciência, Tecnologia e Inovações (MCTI), que inclui o ministro e astronauta Marcos Pontes, viajou em missão ao país para acompanhar a decolagem, além de reunir com autoridades e visitar instituições das áreas espacial e de ciência e tecnologia.</p>\n<p style="text-align: justify;"><b>O MCTI vai transmitir ao vivo neste sábado (27), a partir das 23h50, a cobertura do lançamento em: </b><a href="https://www.youtube.com/mctic/live"><b>https://www.youtube.com/mctic/live</b></a></p>\n<p style="text-align: justify;">Participam da transmissão especialistas do MCTI, do Instituto Nacional de Pesquisas Espaciais (INPE), unidade de pesquisa subordinada ao MCTI, e da Agência Espacial Brasileira (AEB), vinculada ao MCTI.</p>\n<p style="text-align: justify;">O Amazônia-1 será o terceiro satélite brasileiro de sensoriamento remoto em operação, junto com o CBERS-4 e CBERS-4A. O equipamento vai fornecer imagens para monitoramento da Terra. Os dados gerados também serão úteis para atender o monitoramento da região costeira, reservatórios de água, desastres ambientais e estarão à disposição da comunidade científica, órgãos de governo e quaisquer interessados.</p>\n<p style="text-align: justify;"><b>Amazônia-1</b></p>\n<p style="text-align: justify;">Com seis quilômetros de fios e 14 mil conexões elétricas, o Amazônia-1 será o terceiro satélite brasileiro de sensoriamento remoto em operação junto ao CBERS-4 e ao CBERS-4A. O Amazônia-1 é um satélite de órbita Sol síncrona (polar) que irá gerar imagens do planeta a cada 5 dias. Para isso, possui um imageador óptico de visada larga (câmera com 3 bandas de frequências no espectro visível VIS e 1 banda próxima do infravermelho Near Infrared ou NIR) capaz de observar uma faixa de aproximadamente 850 km com 64 metros de resolução.</p>\n<p style="text-align: justify;">Sua órbita foi projetada para proporcionar uma alta taxa de revisita (5 dias), tendo, com isso, capacidade de disponibilizar uma significativa quantidade de dados de um mesmo ponto do planeta. Sob demanda, o Amazônia-1 poderá fornecer dados de um ponto específico em dois dias. Esta característica é extremamente valiosa em aplicações de observação da Terra, pois aumenta a probabilidade de captura de imagens úteis diante da cobertura de nuvens na região.</p>\n<p style="text-align: justify;">Os satélites da série Amazônia serão formados por dois módulos independentes: um Módulo de Serviço, que é a Plataforma Multimissão (PMM), e um Módulo de Carga Útil, que abriga câmeras imageadoras e equipamentos de gravação e transmissão de dados de imagens.</p>\n<p>&nbsp;</p>\n<p>Fonte: https://www.gov.br/mcti/</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Satélite totalmente projetado, integrado, testado e operado pelo Brasil, o Amazônia-1 será lançado ao espaço no dia 28 de fevereiro no Satish Dhawan Space Centre, em Sriharikota, na Índia. Uma delegação do Ministério da Ciência, Tecnologia e Inovações (MCTI), que inclui o ministro e astronauta Marcos Pontes, viajou em missão ao país para acompanhar a&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5097,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-5096",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5096",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5096",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5096/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5098,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5096/revisions/5098",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5097",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5096",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5096",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5096",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4466,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=4466",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "bate-papo-ciencia-tecnologia-no-dia-a-dia-ministra-damares-alves-mmfdh",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/bate-papo-ciencia-tecnologia-no-dia-a-dia-ministra-damares-alves-mmfdh/",
        title: {
            rendered:
                "Bate-Papo Ciência &#038; Tecnologia no Dia a Dia &#8211; Ministra Damares Alves (MMFDH)",
        },
        content: {
            rendered:
                '<p><iframe loading="lazy" title="Bate-Papo Ciência &amp; Tecnologia no Dia a Dia - Ministra Damares Alves (MMFDH)" width="1200" height="675" src="https://www.youtube.com/embed/Hk80gs_jWz0?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></p>\n',
            protected: false,
        },
        excerpt: {
            rendered: "",
            protected: false,
        },
        author: 4,
        featured_media: 4467,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-4466",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4466",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4466",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4466/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4468,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4466/revisions/4468",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4467",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4466",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4466",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4466",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4444,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=4444",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "lancamento-nasa-spacex-crew-1",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/lancamento-nasa-spacex-crew-1/",
        title: {
            rendered: "Lançamento NASA Spacex Crew-1",
        },
        content: {
            rendered:
                '<p><iframe loading="lazy" title="Lançamento NASA Spacex Crew-1" width="1200" height="675" src="https://www.youtube.com/embed/zhH3W-UohkM?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></p>\n',
            protected: false,
        },
        excerpt: {
            rendered: "",
            protected: false,
        },
        author: 4,
        featured_media: 4446,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-4444",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4444",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4444",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4444/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4445,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4444/revisions/4445",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4446",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4444",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4444",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4444",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4333,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=4333",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "abertura-oficial-da-17a-semana-nacional-de-ciencia-e-tecnologia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/abertura-oficial-da-17a-semana-nacional-de-ciencia-e-tecnologia/",
        title: {
            rendered:
                "Abertura da 17ª SNCT tem lançamento de desafios virtuais em inteligência artificial, construção de foguetes, satélites e viagem a Marte",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<div id="meta" class="style-scope ytd-watch-flexy">\n<div id="meta-contents" class="style-scope ytd-watch-flexy">\n<div id="container" class="style-scope ytd-video-secondary-info-renderer">\n<div id="content" class="style-scope ytd-expander">\n<h3 id="description" class="style-scope ytd-video-secondary-info-renderer">Acompanhe na íntegra  a Cerimônia de Abertura Oficial da 17ª Semana Nacional de Ciência e Tecnologia que tem como o tema deste ano: Inteligência Artificial: A Fronteira da Ciência Brasileira</h3>\n</div>\n</div>\n</div>\n</div>\n<div id="ticket-shelf" class="style-scope ytd-watch-flexy">Com a participação do ministro Marcos Pontes, cerimônia deu a partida para a Semana Nacional de Ciência que acontece de 17 a 23 de outubro</div>\n<div id="merch-shelf" class="style-scope ytd-watch-flexy"></div>\n<div id="header" class="style-scope ytd-item-section-renderer">\n<h3 id="title" class="style-scope ytd-comments-header-renderer"></h3>\n</div>\n<p>[/vc_column_text][vc_video link=&#8221;https://www.youtube.com/watch?v=CtyPej7VE-Y&amp;feature=youtu.be&#8221; align=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Acompanhe na íntegra  a Cerimônia de Abertura Oficial da 17ª Semana Nacional de Ciência e Tecnologia que tem como o tema deste ano: Inteligência Artificial: A Fronteira da Ciência Brasileira Com a participação do ministro Marcos Pontes, cerimônia deu a partida para a Semana Nacional de Ciência que acontece de 17 a 23 de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4334,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-4333",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4333",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4333",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4333/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4338,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4333/revisions/4338",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4334",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4333",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4333",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4333",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3793,
        date: "2024-08-07T14:54:23",
        date_gmt: "2024-08-07T17:54:23",
        guid: {
            rendered: "https://cintespbr.org/?p=3793",
        },
        modified: "2024-08-07T14:54:23",
        modified_gmt: "2024-08-07T17:54:23",
        slug: "curso-ead-movimento-paralimpico",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/curso-ead-movimento-paralimpico/",
        title: {
            rendered: "Curso EAD &#8211; Movimento Paralímpico",
        },
        content: {
            rendered:
                '\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="687" src="https://cintespbr.org/wp-content/uploads/2020/08/curso-1024x687.jpg" alt="" class="wp-image-3808" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/08/curso-1024x687.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/curso-300x201.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/curso-768x516.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure>\n\n\n\n<h3 class="wp-block-heading"> O CINTESP.Br apoia a iniciativa do Comitê Paralímpico Brasileiro em parceria com a UFU na realização do curso on-line para área do esporte paralímpico. </h3>\n\n\n\n<p> <br> O Comitê Paraolímpico Brasileiro oferece este curso a profissionais da educação, professores de Educação Física, que pretendem conhecer ou ampliar seus conhecimentos no esporte paralímpico.</p>\n\n\n\n<p>A iniciativa é levar o conhecimento sobre este universo fantástico de superação do paratleta. <br> O CPB convida a todos a participar de sua missão, que é promover o esporte paralímpico da iniciação ao alto rendimento e a inclusão da pessoa com deficiência na sociedade.</p>\n\n\n\n<p><strong>Vamos todos juntos apoiar o <a href="https://www.cpb.org.br/">Comitê Paralímpico Brasileiro.</a></strong></p>\n\n\n\n<p>Acesse e inscreva-se no link   <a href="https://impulsiona.org.br/esporte-paralimpico/">https://impulsiona.org.br/esporte-paralimpico/</a> </p>\n\n\n\n<p></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O CINTESP.Br apoia a iniciativa do Comitê Paralímpico Brasileiro em parceria com a UFU na realização do curso on-line para área do esporte paralímpico. O Comitê Paraolímpico Brasileiro oferece este curso a profissionais da educação, professores de Educação Física, que pretendem conhecer ou ampliar seus conhecimentos no esporte paralímpico. A iniciativa é levar o conhecimento&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3808,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-3793",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3793",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3793",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3793/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3809,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3793/revisions/3809",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3808",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3793",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3793",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3793",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6924,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=6924",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "governo-federal-celebra-1000-dias-com-quatro-entregas-em-alcantara-ma",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/governo-federal-celebra-1000-dias-com-quatro-entregas-em-alcantara-ma/",
        title: {
            rendered:
                "Governo Federal celebra 1000 dias com quatro entregas em Alcântara (MA)",
        },
        content: {
            rendered:
                '<h5>Ministro da Ciência, Tecnologia e Inovações, astronauta Marcos Pontes, liderou comitiva do MCTI durante eventos no município maranhense</h5>\n<div id="viewlet-above-content-body">\n<div id="media">\n<p><img loading="lazy" decoding="async" src="https://www.gov.br/mcti/pt-br/acompanhe-o-mcti/noticias/2021/09/governo-federal-celebra-1000-dias-com-quatro-entregas-em-alcantara-ma/indice.jpg/@@images/fed8a8e9-bed6-49d4-8d1d-6f31e9ceb1a1.jpeg" alt="índice.jpg" width="768" height="432" /></p>\n<p class="discreet">\n</div>\n</div>\n<div id="content-core">\n<div id="parent-fieldname-text" class="">\n<div>\n<p style="text-align: justify;">Na semana em que completa 1000 dias de gestão do país, o Governo Federal preparou uma série eventos que celebram a data em diferentes cidades, nas cinco regiões do país. O município de Alcântara, no Maranhão, foi escolhido pelo MCTI para representar a região Nordeste. Nesta terça-feira (28), o ministro da Ciência, Tecnologia e Inovações, astronauta Marcos Pontes, realizou uma série de entregas para comemorar a data.</p>\n<p>Os diversos benefícios entregues para o município de Alcântara incluíram a contratação do cabo submarino que vai garantir internet de alta capacidade para a região, o programa de capacitação de estudantes em tecnologia e inovação, a premiação de medalhistas de olimpíadas científicas e o projeto de popularização da ciência junto à comunidade.</p>\n<p style="text-align: justify;">“O que nós conseguimos nesses 1000 dias foi mudar a realidade de décadas, como a gente teve aqui em Alcântara uma espera de mais de 30 anos nas agrovilas. O futuro não está mais distante. O futuro está aqui e agora”, afirmou o ministro da Ciência, Tecnologia e Inovações, astronauta Marcos Pontes. Ele também ressaltou a importância dos projetos que estimulam a formação de crianças e jovens da região.  “Quando a gente fala de Brasil do futuro, a gente fala de formação. Esses jovens vão estar trabalhando em breve nesses prédios do CLA (Centro de Lançamento de Alcântara), projetando foguetes e satélites”, reforçou.</p>\n<p style="text-align: justify;">O ministro também destacou a internet de alta capacidade que deverá chegar ao município em breve. “É importante a gente ter uma internet que funcione para tudo o que a gente faz hoje em dia. Dentro de um ano esse cabo de fibra óptica vai estar funcionando aqui, com internet de alta capacidade para a comunidade, empresas de Alcântara e de cidades próximas”.</p>\n<p style="text-align: justify;">Durante a solenidade em Alcântara houve a transmissão do discurso do presidente da República, Jair Bolsonaro, que cumpriu agenda de comemorações dos 1000 dias de governo em Teixeira de Freitas, na Bahia. No município, o presidente inaugurou obras e fez a entrega de títulos de propriedade rural. Jair Bolsonaro ressaltou a ajuda a 68 milhões de brasileiros com o auxílio emergencial. “Somente no ano passado, com o Auxílio, o Brasil gastou com vocês o equivalente a 13 Bolsas Famílias. Um sinal de que nós nos preocupamos com os mais humildes.”</p>\n<p style="text-align: justify;">Em Alcântara, o evento de celebração dos 1000 dias contou com uma grande participação da comunidade local, incluindo a presença de cerca de 300 alunos das agrovilas, além de autoridades locais. O prefeito do município, William Guimarães da Silva, disse que o dia era magnífico e histórico para Alcântara. “Vamos nos unir nessa corrente que deseja o crescimento e o progresso de Alcântara”, afirmou. Segundo o prefeito, o projeto de desenvolvimento do CLA já está promovendo dias melhores para as agrovilas da região.</p>\n<p style="text-align: justify;">O evento em Alcântara também contou com a participação de autoridades políticas do estado do Maranhão, além de representantes do MCTI e de suas unidades vinculadas. O deputado federal Pastor Gil (PL/MA) ressaltou que as entregas feitas nos 1000 dias mostram que o atual governo colocou o Brasil no rumo do desenvolvimento, mesmo em meio a uma grande crise mundial. “Quase 40 anos depois da instalação da base de Alcântara, finalmente teremos retorno dos investimentos feitos aqui com a assinatura do Acordo de Salvaguardas Tecnológicas”, afirmou.</p>\n<p style="text-align: justify;">Já a deputada federal Leda Sadala (Avante-AP) ressaltou a importância do desenvolvimento do Centro de Lançamento de Alcântara para os povos indígenas e quilombolas que vivem na região. ”O futuro é agora e começa aqui. Os mais excluídos e menos favorecidos têm vez nesse governo.” Para o presidente da Agência Espacial Brasileira (AEB/MCTI), Carlos Moura, o lançamento de foguetes e satélites a partir de Alcântara vai trazer uma série de benefícios para a sociedade em diferentes áreas, como agricultura e energias renováveis. ”Alcântara é a nossa solução para levar nossos satélites para o espaço, que trazem várias aplicações para o dia a dia das pessoas”, destacou.</p>\n<p style="text-align: justify;"><strong>Cabo submarino de fibra óptica</strong></p>\n<p style="text-align: justify;">A primeira entrega em Alcântara foi a cerimônia simbólica de assinatura para contratação do cabo submarino de fibra óptica que ligará a capital do estado, São Luís, até o município. O cabo levará conexão de internet em banda larga com velocidade e estabilidade para o local, essencial para a infraestrutura do Centro de Lançamento de Alcântara. O investimento previsto para a obra é de R$ 10 milhões.</p>\n<p style="text-align: justify;">O presidente da Rede Nacional de Ensino e Pesquisa (RNP/MCTI), Nelson Simões, lembrou que a RNP interliga com internet de alta velocidade e capacidade 1,6 mil localidades, onde estão instituições de educação de todo o país. De acordo com ele, graças ao MCTI essa infraestrutura vai chegar a Alcântara e impulsionar a educação, o aprendizado e a inovação no município. “O talento não está só em grandes centros, ele está por aí, em diferentes lugares.”</p>\n<p style="text-align: justify;"><strong>Programa MCTI Futuro</strong></p>\n<p style="text-align: justify;">O programa MCTI Futuro foi a segunda entrega do dia. A iniciativa tem o objetivo de capacitar 40 mil pessoas e apoiar ações para o desenvolvimento da transformação digital aplicadas ao ensino básico, médio, técnico e superior, e em pós-graduação, residência tecnológica e qualificação profissional. O programa ainda tem o foco em incentivar pesquisas e estudos nas áreas da computação em nuvem, big data, inteligência analítica, mídias sociais, cybersegurança, internet das coisas, comunicações avançadas, fotônica, manufatura avançada, design de circuitos integrados, robótica e inteligência artificial.</p>\n<p style="text-align: justify;">O secretário de Empreendedorismo e Inovação do MCTI, Paulo Alvim, ressaltou que as crianças e jovens representam o futuro do Brasil. “Precisamos atuar numa educação para o futuro. Essa iniciativa pensa no país e tem compromisso com o desenvolvimento das pessoas. O Maranhão não pode ficar de fora e daqui começará um novo futuro”, afirmou.</p>\n<p style="text-align: justify;"><strong> Premiação dos medalhistas das Olimpíadas Científicas MCTI 2020</strong></p>\n<p style="text-align: justify;">O terceiro evento do dia foi a premiação dos medalhistas das Olimpíadas Científicas MCTI. Os participantes das competições receberam do ministro Pontes as medalhas referentes às olimpíadas apoiadas pelo ministério via edital do Conselho Nacional de Desenvolvimento Científico e Tecnológico (CNPq), agência vinculada ao MCTI. Por ano, cerca de 20 milhões de alunos participam dos eventos nacionais, que premiam os melhores colocados, e servem como seletiva para disputas internacionais.</p>\n<p style="text-align: justify;">O diretor de Promoção e Difusão da Ciência, Tecnologia e Inovação do MCTI, Daniel Lavouras, destacou que o ministério cuida do presente e do futuro da ciência e tecnologia. “A gente tá premiando e celebrando a competência de vocês. O MCTI apoia quase 60 olimpíadas científicas.”</p>\n<p style="text-align: justify;"><strong>Pop Ciência MCTI</strong></p>\n<p style="text-align: justify;">O quarto evento realizado na comunidade foi o projeto Pop Ciência. Coordenado pela Secretaria de Articulação e Promoção da Ciência (SEAPC) do MCTI, a iniciativa consiste em uma série de atividades de divulgação científica que tem a intenção de aproximar a população do universo da ciência e demostrar como a ciência e tecnologia estão presentes no dia a dia de toda a sociedade. Na ocasião foram distribuídos materiais de divulgação científica e jogos didáticos para adultos e crianças.</p>\n</div>\n<p><strong>FONTE: MCTI</strong></p>\n</div>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Ministro da Ciência, Tecnologia e Inovações, astronauta Marcos Pontes, liderou comitiva do MCTI durante eventos no município maranhense Na semana em que completa 1000 dias de gestão do país, o Governo Federal preparou uma série eventos que celebram a data em diferentes cidades, nas cinco regiões do país. O município de Alcântara, no Maranhão, foi&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6925,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-6924",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6924",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6924",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6924/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6926,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6924/revisions/6926",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6925",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6924",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6924",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6924",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6797,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=6797",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "cintesp-br-em-assunto-nacional",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-em-assunto-nacional/",
        title: {
            rendered: "CINTESP.Br em assunto nacional!",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h3-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span> CINTESP.Br em assunto nacional!<span class="separator-holder separator-right"></span></div></div>[vc_column_text]O Centro de Nacional de Tecnologia para pessoas com deficiência e doenças raras (CNT), vinculado ao CINTESP.Br, Universidade Federal de Uberlândia (UFU) e Ministério da Ciencia, Tencologia e Inovações (MCTI), ganha destaque no programa “Ciência é tudo” da TV Brasil. O professor Dr. Valder Steffens Jr, reitor da UFU destacou em sua entrevista as pesquisas e criações de equipamentos especiais voltados à paratletas e demais pessoas com deficiência. É a inclusão sendo pauta nacional!</p>\n<p>&nbsp;</p>\n<p>FONTE: http://www.comunica.ufu.br/[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_video link=&#8221;https://www.youtube.com/watch?v=rcL759XEqgY&#8221; align=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text]O Centro de Nacional de Tecnologia para pessoas com deficiência e doenças raras (CNT), vinculado ao CINTESP.Br, Universidade Federal de Uberlândia (UFU) e Ministério da Ciencia, Tencologia e Inovações (MCTI), ganha destaque no programa “Ciência é tudo” da TV Brasil. O professor Dr. Valder Steffens Jr, reitor da UFU destacou em sua entrevista as pesquisas&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6798,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-6797",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6797",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6797",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6797/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6799,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6797/revisions/6799",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6798",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6797",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6797",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6797",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6753,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=6753",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "cintesp-uberlandia-e-referencia-no-desenvolvimento-de-equipamentos-para-paradesporto",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-uberlandia-e-referencia-no-desenvolvimento-de-equipamentos-para-paradesporto/",
        title: {
            rendered:
                "CINTESP.Br Uberlândia é referência no desenvolvimento de equipamentos para paradesporto",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h3-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>CINTESP.Br Uberlândia é referência no desenvolvimento de equipamentos para paradesporto<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; css=&#8221;.vc_custom_1630622822618{padding-top: 35px !important;}&#8221;][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">Com o entendimento de promover o conhecimento, gerar oportunidades e desenvolver inovação tecnológica que possa ser transferida para a sociedade, contemplando o máximo das necessidades das pessoas com deficiência e doenças raras, o CINTESP.Br® desenvolve pesquisas integrando diversas áreas do conhecimento da Universidade Federal de Uberlândia (UFU) e outras Instituições de ensino superior, em diversas regiões do país, parceiras do CINTESP.Br®, com o apoio do MCTI – Ministério da Ciência, Tecnologia e Inovações.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Veja a reportagem exibida no MGTv 1ª edição do do dia 02/09/2021 clicando no botão abaixo[/vc_column_text][vc_single_image image=&#8221;6775&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221; onclick=&#8221;custom_link&#8221; img_link_target=&#8221;_blank&#8221; link=&#8221;https://globoplay.globo.com/v/9823799&#8243;][vc_btn title=&#8221;ASSISTA A REPORTAGEM&#8221; color=&#8221;danger&#8221; size=&#8221;lg&#8221; align=&#8221;center&#8221; link=&#8221;url:https%3A%2F%2Fgloboplay.globo.com%2Fv%2F9823799|target:_blank&#8221;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; css=&#8221;.vc_custom_1630622822618{padding-top: 35px !important;}&#8221;][vc_column][vc_column_text] Com o entendimento de promover o conhecimento, gerar oportunidades e desenvolver inovação tecnológica que possa ser transferida para a sociedade, contemplando o máximo das necessidades das pessoas com deficiência e doenças raras, o CINTESP.Br® desenvolve pesquisas integrando diversas áreas do conhecimento da Universidade Federal de Uberlândia (UFU) e outras Instituições&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6775,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-6753",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6753",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6753",
                },
            ],
            "version-history": [
                {
                    count: 13,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6753/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6780,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6753/revisions/6780",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6775",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6753",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6753",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6753",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6745,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=6745",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "comunidade-cientifica-comemora-o-lancamento-da-chamada-publica-universal-do-mcti-cnpq",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/comunidade-cientifica-comemora-o-lancamento-da-chamada-publica-universal-do-mcti-cnpq/",
        title: {
            rendered:
                "COMUNIDADE CIENTÍFICA COMEMORA O LANÇAMENTO DA CHAMADA PÚBLICA UNIVERSAL DO MCTI/CNPq",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h3-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>COMUNIDADE CIENTÍFICA COMEMORA O LANÇAMENTO DA CHAMADA PÚBLICA UNIVERSAL DO MCTI/CNPq<span class="separator-holder separator-right"></span></div></div>[vc_column_text]<strong>Duzentos e cinquenta milhões de Reais, este foi o valor total da Chamada Pública Universal do Conselho Nacional de Desenvolvimento Científico e Tecnológico (CNPq). O lançamento da Chamada Pública foi transmitido ao vivo, nesta manhã (31), pelo canal do <a href="https://www.youtube.com/watch?v=UtH32SR2yp8">Youtube</a>, do Ministério da Ciência Tecnologia e Inovação</strong>[/vc_column_text][vc_video link=&#8221;https://www.youtube.com/watch?v=UtH32SR2yp8&#8243;][vc_column_text]</p>\n<p style="text-align: justify;">A Chamada Pública em caráter Universal é lançada a cada dois anos e é considerada uma das ações mais importantes do CNPq. Esta, de 2021, estava sendo esperada pela comunidade científica com bastante expectativa por conta dos contingenciamentos ocorridos desde 2018. Estavam presentes no lançamento, representantes das Secretarias especiais de Empreendedorismo, de Pesquisa e da Secretaria de Articulação da Ciência vinculadas ao MCTI senadores e representantes das Fundações de Pesquisas dos Estados, da Confap, Senai, SBPC, Finep e Consepe. Ela era a mais aguardada pela comunidade científica por se tratar de apoio a projetos de pesquisa de todo o sistema de Centros de Inovação e Tecnologia do Brasil que abrange todas as áreas do conhecimento.</p>\n<p style="text-align: justify;">Esta Chamada Pública está dividida em duas faixas de propostas: a Faixa “A” para atender a projetos emergentes de até R$165 mil e Faixa “B” para atender as propostas mais consolidadas até R$ 275 mil, além de possibilitar a solicitação de capital e consumo. A principal novidade desta Chamada Pública de número 18 do CNPq é a simplificação da seleção. As inscrições poderão ser feitas por formulário específico em um link “novas chamadas” no site do CNPq, “A Chamada Pública Universal é extremamente importante para irrigar o nosso processo de inovação para beneficiar a sociedade, faz parte da soberania de nosso país e é a nossa principal ajuda para a pesquisa brasileira, nosso objetivo é acelerar as análises das propostas para até no final do ano liberarmos os recursos”, disse o presidente do Conselho Nacional de Desenvolvimento Científico e Tecnológico Evaldo Vilela.</p>\n<p style="text-align: justify;">A Chamada valerá para 3 anos de desenvolvimento e com os dois tipos de bolsas, iniciação e apoio técnico as propostas poderão solicitar capital e consumo.</p>\n<p style="text-align: justify;">De acordo com o Ministro Marcos Pontes, a Chamada Universal vem aliviar a força do auxílio à pesquisa feito pelas Fundações, que vem sendo responsáveis por cerca de 82%. “Depois do forte contingenciamento tivemos o apoio do Congresso para a aprovação do Fundo Nacional de Desenvolvimento Científico e Tecnológico (FNDCT) que garantiu o recurso para essa Chamada Pública tão importante para o desenvolvimento e que servirá de força para a economia do Brasil e o benefício da sociedade”, completou o Ministro Pontes.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text]Duzentos e cinquenta milhões de Reais, este foi o valor total da Chamada Pública Universal do Conselho Nacional de Desenvolvimento Científico e Tecnológico (CNPq). O lançamento da Chamada Pública foi transmitido ao vivo, nesta manhã (31), pelo canal do Youtube, do Ministério da Ciência Tecnologia e Inovação[/vc_column_text][vc_video link=&#8221;https://www.youtube.com/watch?v=UtH32SR2yp8&#8243;][vc_column_text] A Chamada Pública em caráter Universal é&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6750,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-6745",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6745",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6745",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6745/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6752,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6745/revisions/6752",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6750",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6745",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6745",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6745",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6711,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=6711",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "mensagem-do-diretor-cintesp-br-aos-paratletlas-nos-jogos-paralimpicos-de-toquio",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/mensagem-do-diretor-cintesp-br-aos-paratletlas-nos-jogos-paralimpicos-de-toquio/",
        title: {
            rendered:
                "Mensagem do diretor Cintesp.Br aos paratletlas nos jogos paralímpicos de Tóquio!",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h1-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>Mensagem do diretor Cintesp.Br aos paratletlas nos jogos paralímpicos de Tóquio!<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row][vc_column][vc_video link=&#8221;https://youtu.be/_CWTfBAMZT4&#8243;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][/vc_column][/vc_row][vc_row][vc_column][vc_video link=&#8221;https://youtu.be/_CWTfBAMZT4&#8243;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6712,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-6711",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6711",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6711",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6711/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6713,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6711/revisions/6713",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6712",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6711",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6711",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6711",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5858,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=5858",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "ministro-marcos-pontes-fala-a-respeito-do-cnt-e-cintesp-br",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ministro-marcos-pontes-fala-a-respeito-do-cnt-e-cintesp-br/",
        title: {
            rendered:
                "Ministro Marcos Pontes fala a respeito do CNT e CINTESP.Br.",
        },
        content: {
            rendered:
                '<p><strong>Matéria do Programa Diário de Bordo do Ministro Marcos Pontes, ele falou da importância do CINTESP.Br e do CNT no processo de inclusão por meio de inovação com tecnologia assistiva desenvolvidas pelo CINTESP.Br, em Uberlândia.</strong></p>\n<p>&nbsp;</p>\n<p><iframe loading="lazy" title="Ministro Marcos Pontes fala sobre CINTESP.BR" width="1200" height="675" src="https://www.youtube.com/embed/yPpKMi56WYo?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></p>\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Matéria do Programa Diário de Bordo do Ministro Marcos Pontes, ele falou da importância do CINTESP.Br e do CNT no processo de inclusão por meio de inovação com tecnologia assistiva desenvolvidas pelo CINTESP.Br, em Uberlândia. &nbsp; &nbsp;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5859,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 55, 57, 62],
        tags: [],
        class_list: [
            "post-5858",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-cnt",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-55",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5858",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5858",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5858/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5860,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5858/revisions/5860",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5859",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5858",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5858",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5858",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5294,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=5294",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "reuniao-na-ufu-define-criacao-de-centro-de-tecnologias-assistivas-e-doencas-raras",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/reuniao-na-ufu-define-criacao-de-centro-de-tecnologias-assistivas-e-doencas-raras/",
        title: {
            rendered:
                "Reunião na UFU define criação de Centro de Tecnologias Assistivas e Doenças Raras",
        },
        content: {
            rendered:
                '<h3>Entidade é resultado de parceria entre universidade, Ministério da Ciência, Tecnologia e Inovações, Cintesp.br e iniciativa privada</h3>\n<div class="caption caption-center">\n<div class="caption-width-container">\n<div class="caption-inner">\n<p><div id="attachment_5295" style="width: 1546px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5295" class="wp-image-5295 size-full" src="https://cintespbr.org/wp-content/uploads/2021/03/imagem_destaque_img_7594.jpg" alt="" width="1536" height="1024" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/imagem_destaque_img_7594.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/imagem_destaque_img_7594-300x200.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/imagem_destaque_img_7594-1024x683.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/imagem_destaque_img_7594-768x512.jpg 768w" sizes="(max-width: 1536px) 100vw, 1536px" /><p id="caption-attachment-5295" class="wp-caption-text">Carlos Henrique de Carvalho (pró-reitor de Pesquisa e Pós-graduação/UFU), Valder Steffen Júnior (UFU), Marcos Pontes (MCTI), Cleudmar Araújo (Cintesp.br), Daniela Yoshida e Paulo Alvim (MCTI) se reuniram no dia 14/8 (foto: Marco Cavalcanti)</p></div></p>\n</div>\n</div>\n</div>\n<p>&nbsp;</p>\n<p style="text-align: justify;">A Universidade Federal de Uberlândia (UFU) sediou, no fim da tarde desta sexta-feira, 14 de agosto, uma reunião de trabalho com a presença do ministro da Ciência, Tecnologia e Inovações (MCTI), Marcos Pontes, para traçar as diretrizes do lançamento do Centro de Tecnologias Assistivas e Doenças Raras, que será criado em Uberlândia.</p>\n<p style="text-align: justify;">As tecnologias assistivas reúnem recursos e serviços que contribuem para proporcionar ou ampliar habilidades funcionais de pessoas com deficiência.</p>\n<p style="text-align: justify;">A concretização do centro é uma parceria da UFU, do <a href="http://www.cintespbr.org/"><strong>Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (Cintesp.br)</strong></a>, do grupo Algar e do MCTI. “Essa união de esforços vai trazer mais qualidade de vida para pessoas com necessidades especiais e atender muitas das demandas das pessoas e das famílias com doenças raras”, afirmou Marcos Pontes.</p>\n<p style="text-align: justify;">“A Universidade Federal de Uberlândia tem uma grande tradição no desenvolvimento de tecnologia para pessoas com deficiência. Isso evoluiu ao longo do tempo para o esporte paralímpico. Então, estamos juntando competências que englobam pessoal de engenharia, Educação Física e Fisioterapia e o pessoal da Medicina no sentido de integrar todas essas competências específicas para desenvolver tecnologia de alto nível”, resumiu o reitor da UFU, Valder Steffen Júnior.</p>\n<p style="text-align: justify;">O diretor-geral do Cintesp.br, Cleudmar Araújo, docente da Faculdade de Engenharia Mecânica da UFU, destacou o trabalho do centro na área de tecnologias assistivas para o esporte paralímpico, para a saúde, o lazer e na vida diária das pessoas.“Essa reunião eu entendo como um marco histórico para as pessoas com deficiências, pensando nas tecnologias que poderão ajudar essas pessoas no dia a dia, no lazer, no esporte, sempre pensando na melhoria da qualidade de vida e da inclusão social”, afirmou.</p>\n<p style="text-align: justify;">“Acho que essa parceria que vem sendo construída desde o ano passado, primeiro, integra os atores que são chaves nesse processo: quem tem capacidade de inovar [se referindo ao Cintesp.br], a universidade, que pode complementar com muito conhecimento e, com isso, a gente consegue transbordar o que hoje se leva ao esporte paralímpico para a sociedade como um todo”, destacou Paulo Alvim, Secretário de Empreendedorismo e Inovação do MCTI.</p>\n<p style="text-align: justify;">Alvim também destacou a abrangência do esforço: “Acho que estamos cumprindo o papel não só científico e tecnológico, mas social, integrando instituições que vão muito contribuir e que vão atrair empresas, e que vão atrair negócios e a gente pode ser, inclusive, referência internacional”.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Entidade é resultado de parceria entre universidade, Ministério da Ciência, Tecnologia e Inovações, Cintesp.br e iniciativa privada &nbsp; A Universidade Federal de Uberlândia (UFU) sediou, no fim da tarde desta sexta-feira, 14 de agosto, uma reunião de trabalho com a presença do ministro da Ciência, Tecnologia e Inovações (MCTI), Marcos Pontes, para traçar as diretrizes&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5295,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [55, 62],
        tags: [],
        class_list: [
            "post-5294",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cnt",
            "category-todas-as-noticias",
            "category-55",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5294",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5294",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5294/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5296,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5294/revisions/5296",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5295",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5294",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5294",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5294",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4651,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=4651",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "centro-de-tecnologias-e-exposicao-sao-destaques-do-mcti-no-dia-internacional-da-pessoa-com-deficiencia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/centro-de-tecnologias-e-exposicao-sao-destaques-do-mcti-no-dia-internacional-da-pessoa-com-deficiencia/",
        title: {
            rendered:
                "Centro de Tecnologias e exposição são destaques do MCTI no Dia Internacional da Pessoa com Deficiência",
        },
        content: {
            rendered:
                '<h4>Evento com participação do presidente Jair Bolsonaro e da primeira-dama Michelle Bolsonaro fez um balanço de ações do Governo Federal para pessoas com deficiência e anunciou novas iniciativas</h4>\n<p><div id="attachment_4649" style="width: 778px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-4649" class="wp-image-4649 size-full" src="https://cintespbr.org/wp-content/uploads/2020/12/6940853c-88b4-459f-9d4b-af8a590aa59f.jpeg" alt="" width="768" height="324" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/12/6940853c-88b4-459f-9d4b-af8a590aa59f.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/12/6940853c-88b4-459f-9d4b-af8a590aa59f-300x127.jpeg 300w" sizes="(max-width: 768px) 100vw, 768px" /><p id="caption-attachment-4649" class="wp-caption-text">Foto: Leonardo Marques &#8211; ASCOM/MCTI</p></div></p>\n<p style="text-align: justify;">Durante a cerimônia em comemoração ao Dia Internacional da Pessoa com Deficiência e o Dia Internacional do Voluntário, nesta quinta-feira (3), no Palácio do Planalto, o ministro da Ciência, Tecnologia e Inovações, Marcos Pontes, anunciou o lançamento do Centro de Tecnologias para Pessoas com Deficiência e Doenças Raras. Sediado em Uberlândia (MG), o centro será voltado ao desenvolvimento de tecnologias assistivas para o esporte paralímpico e que promovam maior independência e bem-estar a pessoas com deficiência e doenças raras.<img loading="lazy" decoding="async" class=" wp-image-4822 alignleft" src="https://cintespbr.org/wp-content/uploads/2020/12/WhatsApp-Image-2020-12-14-at-23.50.42-300x200.jpeg" alt="" width="442" height="294" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/12/WhatsApp-Image-2020-12-14-at-23.50.42-300x200.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/12/WhatsApp-Image-2020-12-14-at-23.50.42-768x512.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/12/WhatsApp-Image-2020-12-14-at-23.50.42.jpeg 1024w" sizes="(max-width: 442px) 100vw, 442px" /></p>\n<p style="text-align: justify;">O centro vai ser um ambiente de colaboração entre academia, governo e o setor privado, reunindo competências em ciência, tecnologia, empreendedorismo e inovação, e contribuindo para a saúde, lazer, vida diária, ocupacional e esportes. É uma iniciativa do Ministério da Ciência, Tecnologia e Inovações (MCTI), em parceria com a Universidade Federal de Uberlândia, Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (Cintesp.BR), Comitê Paralímpico Brasileiro, Fundação Uberlandense de Turismo Esporte e Lazer e Grupo Algar.</p>\n<p style="text-align: justify;">“A ideia desse centro é, não só o desenvolvimento dessas tecnologias que permitem melhorar a qualidade de vida das pessoas, mas também baratear o custo dessas tecnologias. Não adianta ter uma solução excelente, mas que tenha um custo que dificulta o acesso das pessoas, assim como advogar pela inclusão das pessoas com doenças raras e buscar, por meio da ciência e tecnologia, a produção de equipamentos e medicamentos úteis para essas pessoas”, disse o ministro Pontes.</p>\n<p style="text-align: justify;">Para mostrar a importância e o funcionamento dessas tecnologias, o ministério também inaugurou uma exposição na entrada principal do Palácio do Planalto com 16 peças, desenvolvidas pelo Cintesp.BR com investimento do MCTI, voltadas ao esporte paralímpico e autonomia de pessoas com deficiência. A exposição viajou de Uberlândia e os equipamentos fazem parte do acervo da instituição.</p>\n<p style="text-align: justify;"><img decoding="async" class="image-inline" src="https://www.gov.br/mcti/pt-br/acompanhe-o-mcti/noticias/2020/12/centro-de-tecnologias-e-exposicao-sao-destaques-do-mcti-no-dia-internacional-da-pessoa-com-deficiencia/50677339587_fffd23e811_k.jpg/@@images/7883b206-2f95-4c37-8583-98ca8915741d.jpeg" alt="Foto: Leonardo Marques - ASCOM/MCTI" /></p>\n<p style="text-align: justify;">O ministro também falou sobre o investimento de R$ 3,5 milhões para geração de competências em tecnologia assistiva para melhoria da infraestrutura do Cintesp.BR tendo em vista a criação do Centro Nacional de Tecnologias para Pessoas com Deficiência e Doenças Raras. Dentro do projeto, está prevista a finalização de 15 protótipos, sendo 10 deles alinhados com o Comitê Paraolímpico Brasileiro para os Jogos Paralímpicos de 2021, e 5 protótipos voltados para vida diária e inclusão a pessoas com mobilidade reduzida e doenças raras.</p>\n<p><strong>Decreto do Plano Nacional de Tecnologia Assistiva</strong></p>\n<p style="text-align: justify;">Marcos Pontes também anunciou a entrega para apreciação da Casa Civil da Presidência de uma proposta de decreto instituindo o Plano Nacional de Tecnologia Assistiva. Em parceria com o Ministério da Mulher, da Família e dos Direitos Humanos, o objetivo é regulamentar o artigo 75 da Lei Brasileira de Inclusão da Pessoa com Deficiência e definir diretrizes, objetivos e os eixos dessa política.</p>\n<p style="text-align: justify;">Além disso, ele lembrou do edital da Finep, empresa pública do MCTI, em parceria com o Ministério da Saúde que destinou R$ 40 milhões para produtos, equipamentos, dispositivos, metodologias, práticas e serviços voltados a pessoas com deficiência. Foram 40 projetos cadastrados na modalidade ICT-Empresa e 62 na modalidade Subvenção Econômica, totalizando uma demanda de R$ 152 milhões.</p>\n<p style="text-align: justify;"><strong>Comitê interministerial e prêmio</strong></p>\n<p style="text-align: left;">O presidente da República, Jair Bolsonaro, assinou na cerimônia dois decretos, ambos com participação do MCTI. Uma das medidas institui o Comitê Interministerial de Doenças Raras. A segunda medida cria o Prêmio de Acessibilidade para reconhecer instituições e pessoas que atuam na defesa do direito de pessoas com deficiência.</p>\n<p style="text-align: justify;">A primeira-dama e presidente do conselho do programa Pátria Voluntária, Michelle Bolsonaro, destacou as diferentes ações de governo apresentadas no evento e a importância de garantir os direitos de acessibilidade e convivência.</p>\n<p style="text-align: justify;">“Tivemos aqui uma amostra de todas as realizações do governo no último ano. Sabemos que ainda estamos longe de ser um país acessível e inclusivo, mas a semente da empatia e do respeito foi plantada. A cultura inclusiva é pedra fundamental para garantirmos os direitos das pessoas com deficiência. Nosso próximo passo é dar visibilidade as práticas voltadas as pessoas com deficiência em nosso país”.</p>\n<p style="text-align: left;">\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Evento com participação do presidente Jair Bolsonaro e da primeira-dama Michelle Bolsonaro fez um balanço de ações do Governo Federal para pessoas com deficiência e anunciou novas iniciativas Durante a cerimônia em comemoração ao Dia Internacional da Pessoa com Deficiência e o Dia Internacional do Voluntário, nesta quinta-feira (3), no Palácio do Planalto, o ministro&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4649,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [52, 55, 43, 62],
        tags: [],
        class_list: [
            "post-4651",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintesp-na-17-snct",
            "category-cnt",
            "category-mcti",
            "category-todas-as-noticias",
            "category-52",
            "category-55",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4651",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4651",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4651/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4826,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4651/revisions/4826",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4649",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4651",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4651",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4651",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4645,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=4645",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "cintesp-br-pesquisa-inovacao-em-tecnologias-assistivas-um-direito-das-pessoas-com-deficiencia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-pesquisa-inovacao-em-tecnologias-assistivas-um-direito-das-pessoas-com-deficiencia/",
        title: {
            rendered:
                "Cintesp.Br &#8211; Pesquisa, Inovação em Tecnologias Assistivas. Um direito das Pessoas com deficiência",
        },
        content: {
            rendered:
                '<div class="wpb_column vc_column_container vc_col-sm-8">\n<div class="vc_column-inner">\n<div class="wpb_wrapper">\n<div class="wpb_video_widget wpb_content_element vc_clearfix vc_video-aspect-ratio-169 vc_video-el-width-100 vc_video-align-center">\n<div class="wpb_wrapper">\n<div class="wpb_video_wrapper"><iframe loading="lazy" title="Cintesp.Br - Pesquisa, Inovação em Tecnologias Assistivas. Um direito das Pessoas com deficiência" src="https://www.youtube.com/embed/zjnh3lXcdec?feature=oembed" width="1200" height="675" frameborder="0" allowfullscreen="allowfullscreen" data-mce-fragment="1"></iframe></div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class="wpb_column vc_column_container vc_col-sm-4">\n<div class="vc_column-inner">\n<div class="wpb_wrapper">\n<div id="ultimate-heading-30875fcdad101950b" class="uvc-heading ult-adjust-bottom-margin ultimate-heading-30875fcdad101950b uvc-9467 uvc-heading-default-font-sizes" data-hspacer="no_spacer" data-halign="center">\n<div class="uvc-sub-heading ult-responsive" data-ultimate-target=".uvc-heading.ultimate-heading-30875fcdad101950b .uvc-sub-heading " data-responsive-json-new="{&quot;font-size&quot;:&quot;&quot;,&quot;line-height&quot;:&quot;&quot;}">\n<p>&nbsp;</p>\n<h4><strong>CINTESP.Br em parceria com o MCTI promove uma live em homenagem ao Setembro Verde/Azul e ao Dia Nacional de Luta das Pessoas com Deficiência com temas de Pesquisa, Inovação em Tecnologias Assistivas.</strong></h4>\n<p>Setembro <strong>Verde</strong>/<strong>Azul</strong> é oficialmente o mês de Inclusão, Acessibilidade, Conscientização, da visibilidade da Comunidade Surda Brasileira, do Atleta Paraolímpico e do Dia Nacional de Luta da Pessoa com Deficiência.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; CINTESP.Br em parceria com o MCTI promove uma live em homenagem ao Setembro Verde/Azul e ao Dia Nacional de Luta das Pessoas com Deficiência com temas de Pesquisa, Inovação em Tecnologias Assistivas. Setembro Verde/Azul é oficialmente o mês de Inclusão, Acessibilidade, Conscientização, da visibilidade da Comunidade Surda Brasileira, do Atleta Paraolímpico e do Dia Nacional de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4646,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-4645",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4645",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4645",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4645/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4647,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4645/revisions/4647",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4646",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4645",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4645",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4645",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4419,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=4419",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "ministro-destaca-papel-de-vinculadas-do-mcti-no-fomento-a-ciencia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ministro-destaca-papel-de-vinculadas-do-mcti-no-fomento-a-ciencia/",
        title: {
            rendered:
                "Ministro destaca papel de vinculadas do MCTI no fomento à ciência",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-4420 size-full" src="https://cintespbr.org/wp-content/uploads/2020/11/5784e4ce-6e2f-4353-ad3f-8b2faeefb93c.jpeg" alt="" width="768" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/11/5784e4ce-6e2f-4353-ad3f-8b2faeefb93c.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/11/5784e4ce-6e2f-4353-ad3f-8b2faeefb93c-300x200.jpeg 300w" sizes="(max-width: 768px) 100vw, 768px" /></p>\n<p>O ministro da Ciência, Tecnologia e Inovações, Marcos Pontes, destacou o papel das entidades de fomento do ministério no desenvolvimento de pesquisa e inovação, durante participação no 2º Simpósio de Intercâmbio em Medicina da Rede de Cooperação das Escolas Médicas de Língua Portuguesa (Codem- LP), nesta quarta-feira (4). “O trabalho realizado pelo CNPq, Finep e Embrapii tem nos dado resultados muito bons. O fomento à ciência nunca teve tanto impacto quanto agora neste momento da pandemia”, afirmou o ministro.</p>\n<p>O ministro destacou que o orçamento da União para ciência e tecnologia tem sido reduzido nos últimos anos, mas o MCTI tem garantido os investimentos no setor por meio de suas entidades de fomento. Marcos Pontes citou que outra iniciativa do ministério para ampliar os investimentos em pesquisa e inovação é o projeto de lei complementar 135, que prevê o descontingenciamento do Fundo Nacional de Desenvolvimento Científico e Tecnológico (FNDCT).</p>\n<p>O ministro acrescentou que o ministério também tem buscado financiar mais projetos com investimentos da iniciativa privada. “A ideia é que o orçamento do governo federal seja utilizado para o custeio das unidades de pesquisa, enquanto os projetos tenham outras fontes de recursos.”</p>\n<p><strong>Infraestrutura</strong></p>\n<p>O 2º Simpósio de Intercâmbio em Medicina da Rede de Cooperação das Escolas Médicas de Língua Portuguesa é promovido pela Universidade Federal do Rio de Janeiro (UFRJ), com participação de Faculdades de Medicina do Brasil, de Portugal, de Moçambique, de Angola e de Macau. O ministro lembrou que o MCTI possui várias parcerias com a UFRJ, algumas delas firmadas para o enfrentamento da Covid-19, como nos testes com a vacina BCG e no desenvolvimento de novos exames diagnósticos da doença.</p>\n<p>Marcos Pontes ressaltou que o ministério mobilizou sua infraestrutura de pesquisa e tem realizado vários esforços para reduzir os impactos da Covid-19. Entre as ações, o ministro citou a busca por remédios, novos testes diagnósticos desenvolvidos no Brasil, estruturação de laboratórios e produção de insumos farmacêuticos. “São redes de suporte, de formação profissional, de pesquisa, de inovação e de produtos. Todas essas redes são interligadas pelo ministério e funcionaram bem.”</p>\n<p>&nbsp;</p>\n<p>Fonte: https://www.gov.br/mcti/pt-br</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O ministro da Ciência, Tecnologia e Inovações, Marcos Pontes, destacou o papel das entidades de fomento do ministério no desenvolvimento de pesquisa e inovação, durante participação no 2º Simpósio de Intercâmbio em Medicina da Rede de Cooperação das Escolas Médicas de Língua Portuguesa (Codem- LP), nesta quarta-feira (4). “O trabalho realizado pelo CNPq, Finep e&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4420,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-4419",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4419",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4419",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4419/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4421,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4419/revisions/4421",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4420",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4419",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4419",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4419",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4297,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=4297",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "ministro-destaca-importancia-de-pesquisa-na-antartica-durante-simposio",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ministro-destaca-importancia-de-pesquisa-na-antartica-durante-simposio/",
        title: {
            rendered:
                "Ministro destaca importância de pesquisa na Antártica durante simpósio",
        },
        content: {
            rendered:
                '<p><div id="attachment_4298" style="width: 778px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-4298" class="wp-image-4298 size-full" src="https://cintespbr.org/wp-content/uploads/2020/10/aa1db40d-cbf6-458a-a145-23c65d536bd6.jpeg" alt="" width="768" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/10/aa1db40d-cbf6-458a-a145-23c65d536bd6.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/aa1db40d-cbf6-458a-a145-23c65d536bd6-300x200.jpeg 300w" sizes="(max-width: 768px) 100vw, 768px" /><p id="caption-attachment-4298" class="wp-caption-text">Foto: Neila Rocha &#8211; ASCOM/MCTI</p></div></p>\n<p>O ministro da Ciência, Tecnologia e Inovações, Marcos Pontes, destacou a importância do conhecimento produzido pela pesquisa científica na Antártica e nos Oceanos, nesta sexta-feira (16), durante a abertura do 1º Simpósio Ciência Antártica. O evento, promovido pelo MCTI de forma virtual, faz parte da programação do Mês Nacional da Ciência e Tecnologia.</p>\n<p>“Todo esse conhecimento gerado tem sido importante em vários aspectos, principalmente quando for somado aos dados de meteorologia, da Amazônia e de outros biomas”, afirmou Marcos Pontes. Segundo ele, o MCTI desenvolve pesquisas na Antártica e nos oceanos por meio de vários programas e iniciativas, como o Programa Antártico Brasileiro (Proantar) e o Criosfera 1.</p>\n<p>O ministro revelou que as informações científicas produzidas nessas diferentes regiões e biomas, juntamente com dados de clima, serão reunidas em um grande banco de dados do Instituto Nacional de Pesquisas Espaciais (INPE). Com isso, serão usados para fazer previsões e simulações de mudanças climáticas, com impactos positivos para o Brasil e outros países.</p>\n<p>Durante o 1º Simpósio Ciência Antártica: “A Importância da Ciência para a Antártica: Desafios e perspectivas” foram apresentadas as principais linhas de ação do Programa Ciência Antártica (PC Antártica), do MCTI, e  os  resultados do Proantar para a comunidade científica e parceiros. O PC Antártica tem por objetivo desenvolver pesquisa de excelência sobre a região Antártica e suas conexões com o Oceano Atlântico e a América do Sul, assegurando a permanência do Brasil como membro consultivo do Tratado da Antártica.</p>\n<p>O PC Antártica reúne seis grandes temas: o papel da criosfera no sistema terrestre e as interações com a América do Sul; biocomplexidade dos ecossistemas antárticos, suas conexões com a América do Sul e as mudanças climáticas; mudanças climáticas e o oceano austral; geodinâmica e história geológica da Antártica e suas relações com a América do Sul; dinâmica de alta atmosfera na Antártica, interações com o geoespaço e suas conexões com a América do Sul; e outras áreas de investigação, incluindo temas emergentes, como a área de Biologia Humana e Medicina Polar, além de pesquisa nas disciplinas das ciências sociais como arqueologia, sociologia da ciência, geografia política e relações internacionais.</p>\n<p><strong>Estação Antártica Comandante Ferraz</strong></p>\n<p>Na cerimônia de abertura do simpósio, o almirante Rocha Martins, representante da Marinha, destacou a atuação dos pesquisadores na região, na Estação Antártica Comandante Ferraz (EACF), por meio do Proantar. “Nossos pesquisadores são a razão de ser do nosso programa. Esse trabalho é que garante um lugar de destaque ao Brasil como membro consultivo no Tratado da Antártica”, afirmou.</p>\n<p>Diretamente da Estação Antártica, o comandante Assis participou da abertura do evento. Ele lembrou a inauguração da nova Estação Antártica pelo governo brasileiro, em janeiro deste ano, com uma ampliação do tamanho, infraestrutura e logística. “Aqui tem tudo o que o Brasil pode oferecer de melhor como suporte a todos os pesquisadores”, afirmou. A Estação  Antártica ocupa uma área de aproximadamente 4.500 m², com 17 laboratórios projetados para atender as prioridades do Proantar para as atividades científicas.</p>\n<p>A abertura do simpósio também contou com as participações do diretor de Ciências da Natureza do MCTI, Sávio Raeder, e do presidente do Conselho Nacional de Desenvolvimento Científico e Tecnológico (CNPq), Evaldo Vilela.</p>\n<p>A programação do Simpósio Ciência Antártica pode ser conferida em <a class="external-link" title="" href="http://cienciaantartica.mcti.gov.br/acoes/i-simposio-ciencia-antartica/" target="_blank" rel="noopener noreferrer" data-tippreview-enabled="false" data-tippreview-image="" data-tippreview-title="">http://cienciaantartica.mcti.gov.br/acoes/i-simposio-ciencia-antartica/</a></p>\n<p>&nbsp;</p>\n<p>Fonte: https://www.gov.br/mcti/</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O ministro da Ciência, Tecnologia e Inovações, Marcos Pontes, destacou a importância do conhecimento produzido pela pesquisa científica na Antártica e nos Oceanos, nesta sexta-feira (16), durante a abertura do 1º Simpósio Ciência Antártica. O evento, promovido pelo MCTI de forma virtual, faz parte da programação do Mês Nacional da Ciência e Tecnologia. “Todo esse&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4298,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-4297",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4297",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4297",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4297/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4299,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4297/revisions/4299",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4298",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4297",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4297",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4297",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4279,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=4279",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "museu-goeldi-recebe-o-ministro-marcos-pontes-nesta-terca",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/museu-goeldi-recebe-o-ministro-marcos-pontes-nesta-terca/",
        title: {
            rendered:
                "Museu Goeldi recebe o ministro Marcos Pontes nesta terça",
        },
        content: {
            rendered:
                '<p><div id="attachment_4280" style="width: 778px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-4280" class="wp-image-4280 size-full" src="https://cintespbr.org/wp-content/uploads/2020/10/a41b2bf1-e100-4eab-95a1-3c31ff8d655a.jpeg" alt="" width="768" height="511" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/10/a41b2bf1-e100-4eab-95a1-3c31ff8d655a.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/a41b2bf1-e100-4eab-95a1-3c31ff8d655a-300x200.jpeg 300w" sizes="(max-width: 768px) 100vw, 768px" /><p id="caption-attachment-4280" class="wp-caption-text">Foto: Neila Rocha &#8211; ASCOM/MCTI</p></div></p>\n<p style="text-justify: left;">No final da manhã desta terça, 06, o ministro da Ciência, Tecnologia e Inovações (MCTI), astronauta Marcos Pontes, foi recebido no Parque Zoobotânico do Museu Paraense Emílio Goeldi (MPEG), unidade de pesquisa do MCTI, pela diretora Ana Luisa Albernaz.</p>\n<p style="text-align: justify;">Realizada no dia em que o MPEG completa 154 anos, a visita é parte da programação do Mês Nacional da Ciência, Tecnologia e Inovações (MNCTI).</p>\n<p style="text-align: justify;">“Eu tenho uma grande expectativa nesse Museu, que completa hoje uma data bastante significativa. Um Museu com 154 anos. E você vê, ele mistura história, mistura prédios históricos com todo esse conhecimento de biodiversidade. Há também prédios novos sendo construídos, onde se vê a parte do moderno, além de toda a pesquisa envolvida com a biodiversidade e os povos da Amazônia”, destacou o ministro Marcos Pontes durante a visita, que incluiu um tour pelo Pavilhão Domingos Soares Ferreira Penna, conhecido como prédio da Rocinha, destinado a exposições e atividades educativas, e o Aquário Jacques Huber.</p>\n<p style="text-align: justify;">“Eu estava citando que eu estive há pouco tempo no Museu de História Natural de Viena, eles têm lá coleções trazidas do Brasil. Esse trabalho no país e o trabalho internacional têm uma representação muito grande. É muito importante que nós conheçamos a Amazônia, que a gente divulgue mais sobre o que tem aqui e os trabalhos que são feitos pelos nossos cientistas aqui nesse setor também”, acrescentou.</p>\n<p style="text-align: justify;">O ministro veio acompanhado dos secretários de Políticas para Formação e Ações Estratégicas, Marcelo Morales; de Empreendedorismo e Inovação, Paulo Alvim; e da Secretária de Articulação e Promoção da Ciência, Christiane Corrêa.</p>\n<p style="text-align: justify;">“A interação com um museu de pesquisa como esse é extremamente importante. É com ele que nós vamos fazer os projetos também com a Amazônia. Por exemplo, o Regenera Brasil, que é o reflorestamento de áreas degradadas mas com uma melhor ciência”, afirmou o secretário Marcelo Morales.</p>\n<p style="text-align: justify;">A agenda em Belém também inclui uma visita ao campus de pesquisa do Museu Goeldi, localizado no bairro da Terra Firme, onde no início da tarde a comitiva conhecerá as Coleções de Arqueologia, Obras Raras, Entomologia, assim como o Herbário e os Laboratórios de Biologia Molecular e de Análises Química.</p>\n<p style="text-align: justify;">Ainda no campus de pesquisa, a partir das 15h30, o ministro receberá a imprensa local e depois realizará uma entrevista ao vivo com a diretora Ana Luisa Albernaz, que será transmitida pelo YouTube do MCTI.</p>\n<p style="text-align: justify;"><b>Parque Zoobotânico &#8211;</b> Com uma área de 5,4 hectares, o Parque Zoobotânico do Museu Goeldi está situado no centro urbano de Belém. Foi fundado em 1895, sendo o mais antigo do Brasil no seu gênero. Além de abrigar uma significativa mostra da fauna e flora amazônicas, o Parque é o principal local das atividades educativas da instituição, funcionando tal como um laboratório para aulas práticas. Recebe anualmente cerca de 400 mil visitantes.</p>\n<p style="text-align: justify;">No Parque Zoobotânico estão instalados a Diretoria do Museu Goeldi, as coordenações de Comunicação e Extensão, Administração e Museologia, os serviços do Parque Zoobotânico e Comunicação Social e o Núcleo Editorial de Livros.</p>\n<p style="text-align: justify;"><b>MPEG –</b> Fundado em 1866, o Museu Goeldi<b> </b>é um centro pioneiro nos estudos científicos dos sistemas naturais e socioculturais da Amazônia,<b> </b>bem como na divulgação de conhecimento, organização e manutenção de acervos de referência mundial relacionados à região. Investiga a Floresta Amazônica, produzindo conhecimento de ponta nas áreas<b> </b>das Ciências Humanas, Biológicas, Sociais e da Terra.</p>\n<p style="text-align: justify;">É o segundo museu de ciências naturais mais antigo do Brasil, sendo muito popular na cidade de Belém e em toda a região. Compreende em Belém um campus de pesquisa e o Parque Zoobotânico do país. Na Ilha de Marajó, conta com uma estação científica localizada na Floresta Nacional de Caxiuanã, que funciona como um laboratório avançado sobre o funcionamento das florestas tropicais. Coordena também o Instituto Nacional de Pesquisa do Pantanal (MT), a Rede de Núcleos de Inovação Tecnológica da Amazônia Oriental e o Programa de Pesquisa em Biodiversidade da Amazônia Oriental.</p>\n<p>&nbsp;</p>\n<p>Fonte: <strong>Agência Museu Goeldi</strong></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>No final da manhã desta terça, 06, o ministro da Ciência, Tecnologia e Inovações (MCTI), astronauta Marcos Pontes, foi recebido no Parque Zoobotânico do Museu Paraense Emílio Goeldi (MPEG), unidade de pesquisa do MCTI, pela diretora Ana Luisa Albernaz. Realizada no dia em que o MPEG completa 154 anos, a visita é parte da programação&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4280,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-4279",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4279",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4279",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4279/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4281,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4279/revisions/4281",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4280",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4279",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4279",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4279",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3883,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=3883",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "o-cintesp-br-apoia-o-lancamento-do-edital-de-tecnologia-assistiva-mcti-finep-e-do-acordo-de-coop-mcti-e-instituto-villas-boas",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/o-cintesp-br-apoia-o-lancamento-do-edital-de-tecnologia-assistiva-mcti-finep-e-do-acordo-de-coop-mcti-e-instituto-villas-boas/",
        title: {
            rendered:
                "O CINTESP.Br apoia o Lançamento do Edital de Tecnologia Assistiva MCTI/FINEP",
        },
        content: {
            rendered:
                '\r\n<h3 class="wp-block-heading"><a href="https://www.gov.br/mcti/pt-br/acompanhe-o-mcti/noticias/2020/09/mcti-finep-edital-de-r-40-milhoes-apoiara-projetos-na-area-de-tecnologia-assistiva">O CINTESP.Br apoia o Lançamento do Edital de Tecnologia Assistiva MCTI/FINEP e do Acordo de Coop. MCTI e Instituto Villas Boas</a></h3>\r\n\r\n\r\n\r\n<figure class="wp-block-image alignwide size-large"><img loading="lazy" decoding="async" class="aligncenter wp-image-5749 size-full" src="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2021-04-25-at-13.27.42.jpeg" alt="" width="1280" height="853" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2021-04-25-at-13.27.42.jpeg 1280w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2021-04-25-at-13.27.42-300x200.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2021-04-25-at-13.27.42-1024x682.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2021-04-25-at-13.27.42-768x512.jpeg 768w" sizes="(max-width: 1280px) 100vw, 1280px" />\r\n<figcaption>Foto: Neila Rocha &#8211; ASCOM/MCTI</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<p><strong>O CINTESP.Br</strong> representado pelo seu <strong>Diretor Geral Cleudmar Amaral Araújo</strong> e a <strong>Coordenadora Geral Daniela Moura Yoshida</strong>, compareceram à cerimônia de lançamento do edital MCTI/Finep para apoiar projetos na área de Tecnologia Assistiva.<br />Este edital é de extrema importância para a área de Tecnologia Assistiva e Doenças Raras.</p>\r\n\r\n\r\n\r\n<p>Existem milhões de pessoas no Brasil que precisam de algum tipo de Tecnologia Assistiva para ajudá-las nas tarefas do dia a dia e ter melhor qualidade de vida.</p>\r\n\r\n\r\n\r\n<p><strong>Talvez você seja uma delas.<br />Talvez você conheça algumas delas.</strong></p>\r\n\r\n\r\n\r\n<p>Existem pessoas que sofrem com doenças raras e que não têm certeza do futuro, se haverá algum tratamento, se haverá cura, se conseguem pagar pelo remédio, se poderão sobreviver.</p>\r\n\r\n\r\n\r\n<p><strong>Talvez você seja uma delas.<br />Talvez você conheça algumas delas.</strong></p>\r\n\r\n\r\n\r\n<p>O MCTI tem Tecnologia Assistiva como uma das suas prioridades.</p>\r\n\r\n\r\n\r\n<p>Neste momento estamos criando o Centro Nacional de Tecnologia Assistiva e Doenças Raras em parceria com o Ministério da Mulher, Família e Direitos Humanos, Cintesp, UFU e muitos outros parceiros que, como nós, sabem da importância de se ter um Centro para congregar sinergicamente esforços e iniciativas em todo o país, além de desenvolver Tecnologia para contribuir com a qualidade de vida das pessoas.</p>\r\n\r\n\r\n\r\n<p>O evento apresenta outras duas iniciativas muito importantes do MCTI neste setor:</p>\r\n\r\n\r\n\r\n<ol class="wp-block-list">\r\n<li>O Lançamento do Edital FINEP de 40 Milhões (30M MCTI e 10M MS) para startups desenvolverem inovações em Tecnologia Assistiva Brasil.</li>\r\n<li>A parceria MCTI com o Instituto General Villas Boas, que é um exemplo que inspira a todos nós.</li>\r\n</ol>\r\n\r\n\r\n\r\n<p>Acompanhe o Lançamento do Edital na íntegra.</p>\r\n\r\n\r\n\r\n<figure class="wp-block-embed-youtube wp-block-embed is-type-video is-provider-youtube wp-embed-aspect-16-9 wp-has-aspect-ratio">\r\n<div class="wp-block-embed__wrapper">https://www.youtube.com/watch?v=m4vxpzr_bzY</div>\r\n</figure>\r\n\r\n\r\n\r\n<p>Reportagem completa:</p>\r\n\r\n\r\n\r\n<p><a href="https://www.gov.br/mcti/pt-br/acompanhe-o-mcti/noticias/2020/09/mcti-finep-edital-de-r-40-milhoes-apoiara-projetos-na-area-de-tecnologia-assistiva">https://www.gov.br/mcti/pt-br/acompanhe-o-mcti/noticias/2020/09/mcti-finep-edital-de-r-40-milhoes-apoiara-projetos-na-area-de-tecnologia-assistiva</a></p>\r\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O CINTESP.Br apoia o Lançamento do Edital de Tecnologia Assistiva MCTI/FINEP e do Acordo de Coop. MCTI e Instituto Villas Boas O CINTESP.Br representado pelo seu Diretor Geral Cleudmar Amaral Araújo e a Coordenadora Geral Daniela Moura Yoshida, compareceram à cerimônia de lançamento do edital MCTI/Finep para apoiar projetos na área de Tecnologia Assistiva.Este edital é&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3905,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [49],
        class_list: [
            "post-3883",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "tag-edital-tecnologia-assistiva-tecnologia",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3883",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3883",
                },
            ],
            "version-history": [
                {
                    count: 14,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3883/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5871,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3883/revisions/5871",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3905",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3883",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3883",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3883",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3491,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=3491",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "processo-seletivo-cintesp-br",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/processo-seletivo-cintesp-br/",
        title: {
            rendered: "Processo seletivo Cintesp.Br",
        },
        content: {
            rendered:
                '\n<blockquote style="text-align:center" class="wp-block-quote is-style-large is-layout-flow wp-block-quote-is-layout-flow"><p>Pequisador sênior</p><p>Pesquisador pleno</p><p>Pesquisador júnior</p></blockquote>\n\n\n\n<div class="wp-block-button aligncenter"><a class="wp-block-button__link" href="https://cintespbr.org/wp-content/uploads/2020/06/Divulgação-Processo-Seletivo-CintespBr.pdf">Divulgação do Processo Seletivo do Cintesp.Br</a></div>\n\n\n\n<div class="wp-block-button aligncenter"><a class="wp-block-button__link" href="https://www.sympla.com.br/processo-seletivo---bolsistas---cintespbr__873014">Inscrições</a></div>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter"><img loading="lazy" decoding="async" width="696" height="1024" src="https://cintespbr.org/wp-content/uploads/2020/06/cintespbr-696x1024.jpeg" alt="" class="wp-image-3495" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/06/cintespbr-696x1024.jpeg 696w, https://cintespbr.institucional.ws/wp-content/uploads/2020/06/cintespbr-204x300.jpeg 204w, https://cintespbr.institucional.ws/wp-content/uploads/2020/06/cintespbr-768x1129.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/06/cintespbr.jpeg 1242w" sizes="(max-width: 696px) 100vw, 696px" /></figure></div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Pequisador sênior Pesquisador pleno Pesquisador júnior</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3492,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [41],
        class_list: [
            "post-3491",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "tag-processo-seletivo",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3491",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3491",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3491/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3498,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3491/revisions/3498",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3492",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3491",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3491",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3491",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3323,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=3323",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "apresentacao-na-camara-municipal-de-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/apresentacao-na-camara-municipal-de-uberlandia/",
        title: {
            rendered:
                "Apresentação do CINTESP.Br no  I Fórum sobre Surdocegueira",
        },
        content: {
            rendered:
                '\r\n<p>por <a href="https://cintespbr.org/dt_team/daniela-moura-yoshida/">Daniela Moura Yoshida</a><br /><strong><em>DIRETORA DE RELAÇÕES PÚBLICAS EM TECNOLOGIAS ASSISTIVA</em></strong></p>\r\n\r\n\r\n\r\n<figure class="wp-block-embed-youtube wp-block-embed is-type-video is-provider-youtube wp-embed-aspect-4-3 wp-has-aspect-ratio">\r\n<div class="wp-block-embed__wrapper">https://youtu.be/q4qWgMOXgrs</div>\r\n</figure>\r\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>por Daniela Moura YoshidaDIRETORA DE RELAÇÕES PÚBLICAS EM TECNOLOGIAS ASSISTIVA</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4103,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-3323",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3323",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3323",
                },
            ],
            "version-history": [
                {
                    count: 9,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3323/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4104,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3323/revisions/4104",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4103",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3323",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3323",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3323",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3094,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=3094",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "agradecimentos",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/agradecimentos/",
        title: {
            rendered: "Agradecimentos e fotos do fórum Nacional Cintesp.Br",
        },
        content: {
            rendered:
                '\n<h4 class="wp-block-heading"><em>Astronauta Marcos Pontes reconhece pioneirismo em tecnologia Assistiva do CINTESP.Br para o Esporte Paralímpico junto ao Diretor do Cintesp.Br Cleudmar Amaral de Araújo e a Presidente do fórum Nacional Cintesp.Br, Daniela M. Yoshida, no momento de agradecimento pela participação.</em></h4>\n\n\n\n<p style="text-align:left"></p>\n\n\n\n<p>Prezados,</p>\n\n\n\n<p>A vida é feita de desafios e obstáculos\nque precisamos superar. Não podemos desistir de lutar! Em parceria podemos\nvencer e fazer a diferença.</p>\n\n\n\n<p>O CINTESP.Br agradece a presença e o\napoio recebido por todos que acreditam no sucesso deste importante <strong>FÓRUM NACIONAL CINTESP.Br e MOSTRA DE INOVAÇÕES EM TECNOLOGIAS ASSISTIVAS\nPARA O ESPORTE E SAÚDE</strong>,\nfruto da parceria do CGDS/DEPDS/MCTIC, UFU, CPB e FUTEL. </p>\n\n\n\n<p>Confiantes que as\ncontribuições em tecnologias Assistivas apresentadas no FÓRUM\nNACIONAL CINTESP.Br serão de grande valia para\nefetivação de uma parceria duradoura e satisfatória entre o MCTIC, CINTESP.BR/UFU, CPB e FUTEL, para nossas sociedades em especial o atleta Paralímpico\ne as pessoas com deficiência.</p>\n\n\n\n<p>Registramos mais uma\nvez, nossos agradecimentos a toda aos atletas Paralímpicos e Treinadores, em\nespecial a todas as pessoas com deficiência física e mobilidade reduzida, pelo\napoio que nos dedicaram, e a todas as pessoas que fizeram deste FÓRUM\nNACIONAL CINTESP.Br um sucesso. </p>\n\n\n\n<p>Reafirmamos que nossa missão\ne criar novos desafios em Tecnologias\nAssistivas para o Esporte e Saúde.</p>\n\n\n\n<p>Atenciosamente,<br><strong>Centro Brasileiro de Referência em Inovações Tecnológicas para o Esporte Paralímpico &#8211; CINTESP.BR</strong></p>\n\n\n\n<ul class="wp-block-gallery columns-4 is-cropped wp-block-gallery-1 is-layout-flex wp-block-gallery-is-layout-flex"><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-4-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-4-1024x693.jpg" alt="" data-id="3093" data-link="https://cintespbr.org/photo-2019-10-05-22-04-57-4/" class="wp-image-3093" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-4-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-4-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-4-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-4.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-3-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-3-1024x693.jpg" alt="" data-id="3092" data-link="https://cintespbr.org/photo-2019-10-05-22-04-57-3/" class="wp-image-3092" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-3-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-3-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-3-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-3.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-2-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-2-1024x693.jpg" alt="" data-id="3091" data-link="https://cintespbr.org/photo-2019-10-05-22-04-57-2/" class="wp-image-3091" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-2-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-2-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-2-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-2.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-1024x693.jpg" alt="" data-id="3090" data-link="https://cintespbr.org/photo-2019-10-05-22-04-57/" class="wp-image-3090" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-57.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-4-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-4-1024x693.jpg" alt="" data-id="3089" data-link="https://cintespbr.org/photo-2019-10-05-22-04-56-4/" class="wp-image-3089" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-4-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-4-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-4-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-4.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-3-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-3-1024x693.jpg" alt="" data-id="3088" data-link="https://cintespbr.org/photo-2019-10-05-22-04-56-3/" class="wp-image-3088" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-3-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-3-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-3-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-3.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-2-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-2-1024x693.jpg" alt="" data-id="3087" data-link="https://cintespbr.org/photo-2019-10-05-22-04-56-2/" class="wp-image-3087" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-2-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-2-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-2-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-2.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-1024x693.jpg" alt="" data-id="3086" data-link="https://cintespbr.org/photo-2019-10-05-22-04-56/" class="wp-image-3086" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-56.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-54-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-54-1024x693.jpg" alt="" data-id="3085" data-link="https://cintespbr.org/photo-2019-10-05-22-04-54/" class="wp-image-3085" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-54-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-54-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-54-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-05-22-04-54.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/image015.jpg"><img loading="lazy" decoding="async" width="400" height="315" src="https://cintespbr.org/wp-content/uploads/2019/10/image015.jpg" alt="" data-id="3073" data-link="https://cintespbr.org/image015/" class="wp-image-3073" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image015.jpg 400w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image015-300x236.jpg 300w" sizes="(max-width: 400px) 100vw, 400px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/image014.jpg"><img loading="lazy" decoding="async" width="476" height="315" src="https://cintespbr.org/wp-content/uploads/2019/10/image014.jpg" alt="" data-id="3072" data-link="https://cintespbr.org/image014/" class="wp-image-3072" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image014.jpg 476w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image014-300x199.jpg 300w" sizes="(max-width: 476px) 100vw, 476px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/image013-498x1024.png"><img loading="lazy" decoding="async" width="498" height="1024" src="https://cintespbr.org/wp-content/uploads/2019/10/image013-498x1024.png" alt="" data-id="3071" data-link="https://cintespbr.org/image013/" class="wp-image-3071" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image013-498x1024.png 498w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image013-146x300.png 146w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image013.png 622w" sizes="(max-width: 498px) 100vw, 498px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/image012-1024x498.png"><img loading="lazy" decoding="async" width="1024" height="498" src="https://cintespbr.org/wp-content/uploads/2019/10/image012-1024x498.png" alt="" data-id="3070" data-link="https://cintespbr.org/image012/" class="wp-image-3070" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image012-1024x498.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image012-300x146.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image012-768x373.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image012.png 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/image011-1024x498.png"><img loading="lazy" decoding="async" width="1024" height="498" src="https://cintespbr.org/wp-content/uploads/2019/10/image011-1024x498.png" alt="" data-id="3069" data-link="https://cintespbr.org/image011/" class="wp-image-3069" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image011-1024x498.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image011-300x146.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image011-768x373.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image011.png 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/image010.png"><img loading="lazy" decoding="async" width="629" height="629" src="https://cintespbr.org/wp-content/uploads/2019/10/image010.png" alt="" data-id="3068" data-link="https://cintespbr.org/image010/" class="wp-image-3068" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image010.png 629w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image010-150x150.png 150w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image010-300x300.png 300w" sizes="(max-width: 629px) 100vw, 629px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/image009-1024x677.jpg"><img loading="lazy" decoding="async" width="1024" height="677" src="https://cintespbr.org/wp-content/uploads/2019/10/image009-1024x677.jpg" alt="" data-id="3067" data-link="https://cintespbr.org/image009/" class="wp-image-3067" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image009-1024x677.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image009-300x198.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image009-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image009.jpg 1386w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/image008-1024x677.jpg"><img loading="lazy" decoding="async" width="1024" height="677" src="https://cintespbr.org/wp-content/uploads/2019/10/image008-1024x677.jpg" alt="" data-id="3066" data-link="https://cintespbr.org/image008-2/" class="wp-image-3066" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image008-1024x677.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image008-300x198.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image008-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image008.jpg 1386w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/image007-1024x677.jpg"><img loading="lazy" decoding="async" width="1024" height="677" src="https://cintespbr.org/wp-content/uploads/2019/10/image007-1024x677.jpg" alt="" data-id="3065" data-link="https://cintespbr.org/image007-2/" class="wp-image-3065" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image007-1024x677.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image007-300x198.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image007-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image007.jpg 1386w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/image006-1024x677.jpg"><img loading="lazy" decoding="async" width="1024" height="677" src="https://cintespbr.org/wp-content/uploads/2019/10/image006-1024x677.jpg" alt="" data-id="3064" data-link="https://cintespbr.org/image006-3/" class="wp-image-3064" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image006-1024x677.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image006-300x198.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image006-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image006.jpg 1386w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/image005-1024x678.jpg"><img loading="lazy" decoding="async" width="1024" height="678" src="https://cintespbr.org/wp-content/uploads/2019/10/image005-1024x678.jpg" alt="" data-id="3063" data-link="https://cintespbr.org/image005-2/" class="wp-image-3063" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image005-1024x678.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image005-300x199.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image005-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image005.jpg 1289w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/image004-1024x677.jpg"><img loading="lazy" decoding="async" width="1024" height="677" src="https://cintespbr.org/wp-content/uploads/2019/10/image004-1024x677.jpg" alt="" data-id="3062" data-link="https://cintespbr.org/image004-2/" class="wp-image-3062" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image004-1024x677.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image004-300x198.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image004-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image004.jpg 1386w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/image003-1024x677.jpg"><img loading="lazy" decoding="async" width="1024" height="677" src="https://cintespbr.org/wp-content/uploads/2019/10/image003-1024x677.jpg" alt="" data-id="3061" data-link="https://cintespbr.org/image003-2/" class="wp-image-3061" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image003-1024x677.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image003-300x198.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image003-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image003.jpg 1386w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-30_48836380678_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-30_48836380678_o-1024x693.jpg" alt="" data-id="3096" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-30_48836380678_o/" class="wp-image-3096" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-30_48836380678_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-30_48836380678_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-30_48836380678_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-30_48836380678_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-129_48836749031_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-129_48836749031_o-1024x693.jpg" alt="" data-id="3097" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-129_48836749031_o/" class="wp-image-3097" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-129_48836749031_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-129_48836749031_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-129_48836749031_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-129_48836749031_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-141_48836927352_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-141_48836927352_o-1024x693.jpg" alt="" data-id="3098" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-141_48836927352_o/" class="wp-image-3098" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-141_48836927352_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-141_48836927352_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-141_48836927352_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-141_48836927352_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-147_48836927327_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-147_48836927327_o-1024x693.jpg" alt="" data-id="3099" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-147_48836927327_o/" class="wp-image-3099" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-147_48836927327_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-147_48836927327_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-147_48836927327_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-147_48836927327_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-159_48836379858_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-159_48836379858_o-1024x693.jpg" alt="" data-id="3100" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-159_48836379858_o/" class="wp-image-3100" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-159_48836379858_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-159_48836379858_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-159_48836379858_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-159_48836379858_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-168_48836748906_o-696x1024.jpg"><img loading="lazy" decoding="async" width="696" height="1024" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-168_48836748906_o-696x1024.jpg" alt="" data-id="3101" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-168_48836748906_o/" class="wp-image-3101" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-168_48836748906_o-696x1024.jpg 696w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-168_48836748906_o-204x300.jpg 204w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-168_48836748906_o-768x1130.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-168_48836748906_o.jpg 849w" sizes="(max-width: 696px) 100vw, 696px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-171_48836379808_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-171_48836379808_o-1024x693.jpg" alt="" data-id="3102" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-171_48836379808_o/" class="wp-image-3102" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-171_48836379808_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-171_48836379808_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-171_48836379808_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-171_48836379808_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-200_48836374343_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-200_48836374343_o-1024x693.jpg" alt="" data-id="3103" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-200_48836374343_o/" class="wp-image-3103" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-200_48836374343_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-200_48836374343_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-200_48836374343_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-200_48836374343_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-223_48836743326_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-223_48836743326_o-1024x693.jpg" alt="" data-id="3104" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-223_48836743326_o/" class="wp-image-3104" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-223_48836743326_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-223_48836743326_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-223_48836743326_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-223_48836743326_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-224_48836748691_o-696x1024.jpg"><img loading="lazy" decoding="async" width="696" height="1024" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-224_48836748691_o-696x1024.jpg" alt="" data-id="3105" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-224_48836748691_o/" class="wp-image-3105" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-224_48836748691_o-696x1024.jpg 696w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-224_48836748691_o-204x300.jpg 204w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-224_48836748691_o-768x1130.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-224_48836748691_o.jpg 849w" sizes="(max-width: 696px) 100vw, 696px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-225_48836927007_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-225_48836927007_o-1024x693.jpg" alt="" data-id="3106" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-225_48836927007_o/" class="wp-image-3106" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-225_48836927007_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-225_48836927007_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-225_48836927007_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-225_48836927007_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-294_48836379308_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-294_48836379308_o-1024x693.jpg" alt="" data-id="3107" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-294_48836379308_o/" class="wp-image-3107" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-294_48836379308_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-294_48836379308_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-294_48836379308_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-294_48836379308_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-305_48836374203_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-305_48836374203_o-1024x693.jpg" alt="" data-id="3108" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-305_48836374203_o/" class="wp-image-3108" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-305_48836374203_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-305_48836374203_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-305_48836374203_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-305_48836374203_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-308_48836379263_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-308_48836379263_o-1024x693.jpg" alt="" data-id="3109" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-308_48836379263_o/" class="wp-image-3109" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-308_48836379263_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-308_48836379263_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-308_48836379263_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-308_48836379263_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-321_48836743156_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-321_48836743156_o-1024x693.jpg" alt="" data-id="3110" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-321_48836743156_o/" class="wp-image-3110" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-321_48836743156_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-321_48836743156_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-321_48836743156_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-321_48836743156_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-345_48836378938_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-345_48836378938_o-1024x693.jpg" alt="" data-id="3111" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-345_48836378938_o/" class="wp-image-3111" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-345_48836378938_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-345_48836378938_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-345_48836378938_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-345_48836378938_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-347_48836747966_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-347_48836747966_o-1024x693.jpg" alt="" data-id="3112" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-347_48836747966_o/" class="wp-image-3112" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-347_48836747966_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-347_48836747966_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-347_48836747966_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-347_48836747966_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-363_48836743146_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-363_48836743146_o-1024x693.jpg" alt="" data-id="3113" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-363_48836743146_o/" class="wp-image-3113" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-363_48836743146_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-363_48836743146_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-363_48836743146_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-363_48836743146_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-366_48836747931_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-366_48836747931_o-1024x693.jpg" alt="" data-id="3114" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-366_48836747931_o/" class="wp-image-3114" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-366_48836747931_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-366_48836747931_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-366_48836747931_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-366_48836747931_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-367_48836926457_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-367_48836926457_o-1024x693.jpg" alt="" data-id="3115" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-367_48836926457_o/" class="wp-image-3115" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-367_48836926457_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-367_48836926457_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-367_48836926457_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-367_48836926457_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-368_48836926432_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-368_48836926432_o-1024x693.jpg" alt="" data-id="3116" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-368_48836926432_o/" class="wp-image-3116" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-368_48836926432_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-368_48836926432_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-368_48836926432_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-368_48836926432_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-370_48836378808_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-370_48836378808_o-1024x693.jpg" alt="" data-id="3117" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-370_48836378808_o/" class="wp-image-3117" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-370_48836378808_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-370_48836378808_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-370_48836378808_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-370_48836378808_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-379_48836747776_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-379_48836747776_o-1024x693.jpg" alt="" data-id="3118" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-379_48836747776_o/" class="wp-image-3118" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-379_48836747776_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-379_48836747776_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-379_48836747776_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-379_48836747776_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-382_48836926292_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-382_48836926292_o-1024x693.jpg" alt="" data-id="3119" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-382_48836926292_o/" class="wp-image-3119" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-382_48836926292_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-382_48836926292_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-382_48836926292_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-382_48836926292_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-386_48836743096_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-386_48836743096_o-1024x693.jpg" alt="" data-id="3120" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-386_48836743096_o/" class="wp-image-3120" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-386_48836743096_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-386_48836743096_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-386_48836743096_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-386_48836743096_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-389_48836926277_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-389_48836926277_o-1024x693.jpg" alt="" data-id="3121" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-389_48836926277_o/" class="wp-image-3121" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-389_48836926277_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-389_48836926277_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-389_48836926277_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-389_48836926277_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-393_48836747741_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-393_48836747741_o-1024x693.jpg" alt="" data-id="3122" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-393_48836747741_o/" class="wp-image-3122" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-393_48836747741_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-393_48836747741_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-393_48836747741_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-393_48836747741_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-396_48836926242_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-396_48836926242_o-1024x693.jpg" alt="" data-id="3123" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-396_48836926242_o/" class="wp-image-3123" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-396_48836926242_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-396_48836926242_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-396_48836926242_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-396_48836926242_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-400_48836378663_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-400_48836378663_o-1024x693.jpg" alt="" data-id="3124" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-400_48836378663_o/" class="wp-image-3124" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-400_48836378663_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-400_48836378663_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-400_48836378663_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-400_48836378663_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-428_48836926167_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-428_48836926167_o-1024x693.jpg" alt="" data-id="3125" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-428_48836926167_o/" class="wp-image-3125" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-428_48836926167_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-428_48836926167_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-428_48836926167_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-428_48836926167_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-448_48836926062_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-448_48836926062_o-1024x693.jpg" alt="" data-id="3126" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-448_48836926062_o/" class="wp-image-3126" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-448_48836926062_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-448_48836926062_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-448_48836926062_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-448_48836926062_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-452_48836374018_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-452_48836374018_o-1024x693.jpg" alt="" data-id="3127" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-452_48836374018_o/" class="wp-image-3127" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-452_48836374018_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-452_48836374018_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-452_48836374018_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-452_48836374018_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-455_48836926047_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-455_48836926047_o-1024x693.jpg" alt="" data-id="3128" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-455_48836926047_o/" class="wp-image-3128" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-455_48836926047_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-455_48836926047_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-455_48836926047_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-455_48836926047_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-456_48836926012_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-456_48836926012_o-1024x693.jpg" alt="" data-id="3129" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-456_48836926012_o/" class="wp-image-3129" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-456_48836926012_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-456_48836926012_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-456_48836926012_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-456_48836926012_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-459_48836925982_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-459_48836925982_o-1024x693.jpg" alt="" data-id="3130" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-459_48836925982_o/" class="wp-image-3130" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-459_48836925982_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-459_48836925982_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-459_48836925982_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-459_48836925982_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-481_48836373988_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-481_48836373988_o-1024x693.jpg" alt="" data-id="3131" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-481_48836373988_o/" class="wp-image-3131" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-481_48836373988_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-481_48836373988_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-481_48836373988_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-481_48836373988_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-492_48836378408_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-492_48836378408_o-1024x693.jpg" alt="" data-id="3132" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-492_48836378408_o/" class="wp-image-3132" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-492_48836378408_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-492_48836378408_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-492_48836378408_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-492_48836378408_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-535_48836925907_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-535_48836925907_o-1024x693.jpg" alt="" data-id="3133" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-535_48836925907_o/" class="wp-image-3133" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-535_48836925907_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-535_48836925907_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-535_48836925907_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-535_48836925907_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-536_48836378333_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-536_48836378333_o-1024x693.jpg" alt="" data-id="3134" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-536_48836378333_o/" class="wp-image-3134" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-536_48836378333_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-536_48836378333_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-536_48836378333_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-536_48836378333_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-542_48836742941_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-542_48836742941_o-1024x693.jpg" alt="" data-id="3135" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-542_48836742941_o/" class="wp-image-3135" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-542_48836742941_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-542_48836742941_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-542_48836742941_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-542_48836742941_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-553_48836925852_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-553_48836925852_o-1024x693.jpg" alt="" data-id="3136" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-553_48836925852_o/" class="wp-image-3136" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-553_48836925852_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-553_48836925852_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-553_48836925852_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-553_48836925852_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-557_48836747301_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-557_48836747301_o-1024x693.jpg" alt="" data-id="3137" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-557_48836747301_o/" class="wp-image-3137" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-557_48836747301_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-557_48836747301_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-557_48836747301_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-557_48836747301_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-595_48836378278_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-595_48836378278_o-1024x693.jpg" alt="" data-id="3138" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-595_48836378278_o/" class="wp-image-3138" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-595_48836378278_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-595_48836378278_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-595_48836378278_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-595_48836378278_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-597_48836378258_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-597_48836378258_o-1024x693.jpg" alt="" data-id="3139" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-597_48836378258_o/" class="wp-image-3139" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-597_48836378258_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-597_48836378258_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-597_48836378258_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-597_48836378258_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-600_48836378223_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-600_48836378223_o-1024x693.jpg" alt="" data-id="3140" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-600_48836378223_o/" class="wp-image-3140" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-600_48836378223_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-600_48836378223_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-600_48836378223_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-600_48836378223_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-601_48836742921_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-601_48836742921_o-1024x693.jpg" alt="" data-id="3141" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-601_48836742921_o/" class="wp-image-3141" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-601_48836742921_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-601_48836742921_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-601_48836742921_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-601_48836742921_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-615_48836747321_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-615_48836747321_o-1024x693.jpg" alt="" data-id="3142" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-615_48836747321_o/" class="wp-image-3142" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-615_48836747321_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-615_48836747321_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-615_48836747321_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-615_48836747321_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-643_48836747211_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-643_48836747211_o-1024x693.jpg" alt="" data-id="3143" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-643_48836747211_o/" class="wp-image-3143" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-643_48836747211_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-643_48836747211_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-643_48836747211_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-643_48836747211_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-763_48836747196_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-763_48836747196_o-1024x693.jpg" alt="" data-id="3144" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-763_48836747196_o/" class="wp-image-3144" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-763_48836747196_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-763_48836747196_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-763_48836747196_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-763_48836747196_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-767_48836925702_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-767_48836925702_o-1024x693.jpg" alt="" data-id="3145" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-767_48836925702_o/" class="wp-image-3145" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-767_48836925702_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-767_48836925702_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-767_48836925702_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-767_48836925702_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-789_48836925682_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-789_48836925682_o-1024x693.jpg" alt="" data-id="3146" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-789_48836925682_o/" class="wp-image-3146" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-789_48836925682_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-789_48836925682_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-789_48836925682_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-789_48836925682_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-792_48836925662_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-792_48836925662_o-1024x693.jpg" alt="" data-id="3147" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-792_48836925662_o/" class="wp-image-3147" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-792_48836925662_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-792_48836925662_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-792_48836925662_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-792_48836925662_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-799_48836925637_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-799_48836925637_o-1024x693.jpg" alt="" data-id="3148" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-799_48836925637_o/" class="wp-image-3148" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-799_48836925637_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-799_48836925637_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-799_48836925637_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-799_48836925637_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-802_48836373918_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-802_48836373918_o-1024x693.jpg" alt="" data-id="3149" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-802_48836373918_o/" class="wp-image-3149" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-802_48836373918_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-802_48836373918_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-802_48836373918_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-802_48836373918_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-818_48836925627_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-818_48836925627_o-1024x693.jpg" alt="" data-id="3150" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-818_48836925627_o/" class="wp-image-3150" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-818_48836925627_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-818_48836925627_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-818_48836925627_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-818_48836925627_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-822_48836378038_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-822_48836378038_o-1024x693.jpg" alt="" data-id="3151" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-822_48836378038_o/" class="wp-image-3151" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-822_48836378038_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-822_48836378038_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-822_48836378038_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-822_48836378038_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-833_48836747046_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-833_48836747046_o-1024x693.jpg" alt="" data-id="3152" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-833_48836747046_o/" class="wp-image-3152" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-833_48836747046_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-833_48836747046_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-833_48836747046_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-833_48836747046_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-837_48836373868_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-837_48836373868_o-1024x693.jpg" alt="" data-id="3153" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-837_48836373868_o/" class="wp-image-3153" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-837_48836373868_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-837_48836373868_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-837_48836373868_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-837_48836373868_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-864_48836925567_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-864_48836925567_o-1024x693.jpg" alt="" data-id="3154" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-864_48836925567_o/" class="wp-image-3154" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-864_48836925567_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-864_48836925567_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-864_48836925567_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-864_48836925567_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-865_48836377988_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-865_48836377988_o-1024x693.jpg" alt="" data-id="3155" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-865_48836377988_o/" class="wp-image-3155" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-865_48836377988_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-865_48836377988_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-865_48836377988_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-865_48836377988_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-873_48836925517_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-873_48836925517_o-1024x693.jpg" alt="" data-id="3156" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-873_48836925517_o/" class="wp-image-3156" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-873_48836925517_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-873_48836925517_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-873_48836925517_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-873_48836925517_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-875_48836925497_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-875_48836925497_o-1024x693.jpg" alt="" data-id="3157" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-875_48836925497_o/" class="wp-image-3157" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-875_48836925497_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-875_48836925497_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-875_48836925497_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-875_48836925497_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-884_48836925467_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-884_48836925467_o-1024x693.jpg" alt="" data-id="3158" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-884_48836925467_o/" class="wp-image-3158" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-884_48836925467_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-884_48836925467_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-884_48836925467_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-884_48836925467_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-925_48836377888_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-925_48836377888_o-1024x693.jpg" alt="" data-id="3159" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-925_48836377888_o/" class="wp-image-3159" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-925_48836377888_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-925_48836377888_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-925_48836377888_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-925_48836377888_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-926_48836925427_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-926_48836925427_o-1024x693.jpg" alt="" data-id="3160" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-926_48836925427_o/" class="wp-image-3160" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-926_48836925427_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-926_48836925427_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-926_48836925427_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-926_48836925427_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-931_48836377823_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-931_48836377823_o-1024x693.jpg" alt="" data-id="3161" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-931_48836377823_o/" class="wp-image-3161" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-931_48836377823_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-931_48836377823_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-931_48836377823_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-931_48836377823_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-948_48836373823_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-948_48836373823_o-1024x693.jpg" alt="" data-id="3162" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-948_48836373823_o/" class="wp-image-3162" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-948_48836373823_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-948_48836373823_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-948_48836373823_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-948_48836373823_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-990_48836925367_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-990_48836925367_o-1024x693.jpg" alt="" data-id="3163" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-990_48836925367_o/" class="wp-image-3163" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-990_48836925367_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-990_48836925367_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-990_48836925367_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-990_48836925367_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-991_48836377778_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-991_48836377778_o-1024x693.jpg" alt="" data-id="3164" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-991_48836377778_o/" class="wp-image-3164" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-991_48836377778_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-991_48836377778_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-991_48836377778_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-991_48836377778_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1003_48836925327_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1003_48836925327_o-1024x693.jpg" alt="" data-id="3165" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1003_48836925327_o/" class="wp-image-3165" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1003_48836925327_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1003_48836925327_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1003_48836925327_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1003_48836925327_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1028_48836742771_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1028_48836742771_o-1024x693.jpg" alt="" data-id="3166" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1028_48836742771_o/" class="wp-image-3166" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1028_48836742771_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1028_48836742771_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1028_48836742771_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1028_48836742771_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1049_48836925302_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1049_48836925302_o-1024x693.jpg" alt="" data-id="3167" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1049_48836925302_o/" class="wp-image-3167" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1049_48836925302_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1049_48836925302_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1049_48836925302_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1049_48836925302_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1061_48836925282_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1061_48836925282_o-1024x693.jpg" alt="" data-id="3168" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1061_48836925282_o/" class="wp-image-3168" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1061_48836925282_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1061_48836925282_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1061_48836925282_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1061_48836925282_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1074_48836746786_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1074_48836746786_o-1024x693.jpg" alt="" data-id="3169" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1074_48836746786_o/" class="wp-image-3169" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1074_48836746786_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1074_48836746786_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1074_48836746786_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1074_48836746786_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1076_48836925237_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1076_48836925237_o-1024x693.jpg" alt="" data-id="3170" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1076_48836925237_o/" class="wp-image-3170" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1076_48836925237_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1076_48836925237_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1076_48836925237_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1076_48836925237_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1077_48836925217_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1077_48836925217_o-1024x693.jpg" alt="" data-id="3171" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1077_48836925217_o/" class="wp-image-3171" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1077_48836925217_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1077_48836925217_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1077_48836925217_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1077_48836925217_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1078_48836921277_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1078_48836921277_o-1024x693.jpg" alt="" data-id="3172" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1078_48836921277_o/" class="wp-image-3172" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1078_48836921277_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1078_48836921277_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1078_48836921277_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1078_48836921277_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1080_48836746721_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1080_48836746721_o-1024x693.jpg" alt="" data-id="3173" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1080_48836746721_o/" class="wp-image-3173" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1080_48836746721_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1080_48836746721_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1080_48836746721_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1080_48836746721_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1111_48836377508_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1111_48836377508_o-1024x693.jpg" alt="" data-id="3174" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1111_48836377508_o/" class="wp-image-3174" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1111_48836377508_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1111_48836377508_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1111_48836377508_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1111_48836377508_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1114_48836746666_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1114_48836746666_o-1024x693.jpg" alt="" data-id="3175" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1114_48836746666_o/" class="wp-image-3175" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1114_48836746666_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1114_48836746666_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1114_48836746666_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1114_48836746666_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1122_48836925147_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1122_48836925147_o-1024x693.jpg" alt="" data-id="3176" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1122_48836925147_o/" class="wp-image-3176" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1122_48836925147_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1122_48836925147_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1122_48836925147_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1122_48836925147_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1125_48836746621_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1125_48836746621_o-1024x693.jpg" alt="" data-id="3177" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1125_48836746621_o/" class="wp-image-3177" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1125_48836746621_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1125_48836746621_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1125_48836746621_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1125_48836746621_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1126_48836746606_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1126_48836746606_o-1024x693.jpg" alt="" data-id="3178" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1126_48836746606_o/" class="wp-image-3178" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1126_48836746606_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1126_48836746606_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1126_48836746606_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1126_48836746606_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1139_48836925097_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1139_48836925097_o-1024x693.jpg" alt="" data-id="3179" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1139_48836925097_o/" class="wp-image-3179" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1139_48836925097_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1139_48836925097_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1139_48836925097_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1139_48836925097_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1140_48836746576_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1140_48836746576_o-1024x693.jpg" alt="" data-id="3180" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1140_48836746576_o/" class="wp-image-3180" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1140_48836746576_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1140_48836746576_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1140_48836746576_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1140_48836746576_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1146_48836925052_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1146_48836925052_o-1024x693.jpg" alt="" data-id="3181" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1146_48836925052_o/" class="wp-image-3181" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1146_48836925052_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1146_48836925052_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1146_48836925052_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1146_48836925052_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1147_48836742731_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1147_48836742731_o-1024x693.jpg" alt="" data-id="3182" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1147_48836742731_o/" class="wp-image-3182" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1147_48836742731_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1147_48836742731_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1147_48836742731_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1147_48836742731_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1149_48836746511_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1149_48836746511_o-1024x693.jpg" alt="" data-id="3183" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1149_48836746511_o/" class="wp-image-3183" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1149_48836746511_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1149_48836746511_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1149_48836746511_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1149_48836746511_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1151_48836377308_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1151_48836377308_o-1024x693.jpg" alt="" data-id="3184" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1151_48836377308_o/" class="wp-image-3184" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1151_48836377308_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1151_48836377308_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1151_48836377308_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1151_48836377308_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1160_48836746461_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1160_48836746461_o-1024x693.jpg" alt="" data-id="3185" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1160_48836746461_o/" class="wp-image-3185" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1160_48836746461_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1160_48836746461_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1160_48836746461_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1160_48836746461_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1165_48836746451_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1165_48836746451_o-1024x693.jpg" alt="" data-id="3186" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1165_48836746451_o/" class="wp-image-3186" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1165_48836746451_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1165_48836746451_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1165_48836746451_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1165_48836746451_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1167_48836924917_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1167_48836924917_o-1024x693.jpg" alt="" data-id="3187" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1167_48836924917_o/" class="wp-image-3187" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1167_48836924917_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1167_48836924917_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1167_48836924917_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1167_48836924917_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1172_48836742676_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1172_48836742676_o-1024x693.jpg" alt="" data-id="3188" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1172_48836742676_o/" class="wp-image-3188" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1172_48836742676_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1172_48836742676_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1172_48836742676_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1172_48836742676_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1175_48836377198_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1175_48836377198_o-1024x693.jpg" alt="" data-id="3189" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1175_48836377198_o/" class="wp-image-3189" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1175_48836377198_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1175_48836377198_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1175_48836377198_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1175_48836377198_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1181_48836377183_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1181_48836377183_o-1024x693.jpg" alt="" data-id="3190" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1181_48836377183_o/" class="wp-image-3190" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1181_48836377183_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1181_48836377183_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1181_48836377183_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1181_48836377183_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1184_48836924807_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1184_48836924807_o-1024x693.jpg" alt="" data-id="3191" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1184_48836924807_o/" class="wp-image-3191" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1184_48836924807_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1184_48836924807_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1184_48836924807_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1184_48836924807_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1185_48836746281_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1185_48836746281_o-1024x693.jpg" alt="" data-id="3192" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1185_48836746281_o/" class="wp-image-3192" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1185_48836746281_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1185_48836746281_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1185_48836746281_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1185_48836746281_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1187_48836742641_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1187_48836742641_o-1024x693.jpg" alt="" data-id="3193" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1187_48836742641_o/" class="wp-image-3193" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1187_48836742641_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1187_48836742641_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1187_48836742641_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1187_48836742641_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1189_48836377078_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1189_48836377078_o-1024x693.jpg" alt="" data-id="3194" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1189_48836377078_o/" class="wp-image-3194" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1189_48836377078_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1189_48836377078_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1189_48836377078_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1189_48836377078_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1196_48836377058_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1196_48836377058_o-1024x693.jpg" alt="" data-id="3195" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1196_48836377058_o/" class="wp-image-3195" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1196_48836377058_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1196_48836377058_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1196_48836377058_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1196_48836377058_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1198_48836746221_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1198_48836746221_o-1024x693.jpg" alt="" data-id="3196" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1198_48836746221_o/" class="wp-image-3196" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1198_48836746221_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1198_48836746221_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1198_48836746221_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1198_48836746221_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1199_48836746206_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1199_48836746206_o-1024x693.jpg" alt="" data-id="3197" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1199_48836746206_o/" class="wp-image-3197" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1199_48836746206_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1199_48836746206_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1199_48836746206_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1199_48836746206_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1209_48836376998_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1209_48836376998_o-1024x693.jpg" alt="" data-id="3198" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1209_48836376998_o/" class="wp-image-3198" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1209_48836376998_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1209_48836376998_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1209_48836376998_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1209_48836376998_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1211_48836376958_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1211_48836376958_o-1024x693.jpg" alt="" data-id="3199" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1211_48836376958_o/" class="wp-image-3199" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1211_48836376958_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1211_48836376958_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1211_48836376958_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1211_48836376958_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1212_48836376948_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1212_48836376948_o-1024x693.jpg" alt="" data-id="3200" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1212_48836376948_o/" class="wp-image-3200" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1212_48836376948_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1212_48836376948_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1212_48836376948_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1212_48836376948_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1213_48836746101_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1213_48836746101_o-1024x693.jpg" alt="" data-id="3201" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1213_48836746101_o/" class="wp-image-3201" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1213_48836746101_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1213_48836746101_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1213_48836746101_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1213_48836746101_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1217_48836924542_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1217_48836924542_o-1024x693.jpg" alt="" data-id="3202" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1217_48836924542_o/" class="wp-image-3202" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1217_48836924542_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1217_48836924542_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1217_48836924542_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1217_48836924542_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1220_48836924512_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1220_48836924512_o-1024x693.jpg" alt="" data-id="3203" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1220_48836924512_o/" class="wp-image-3203" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1220_48836924512_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1220_48836924512_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1220_48836924512_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1220_48836924512_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1226_48836921167_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1226_48836921167_o-1024x693.jpg" alt="" data-id="3204" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1226_48836921167_o/" class="wp-image-3204" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1226_48836921167_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1226_48836921167_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1226_48836921167_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1226_48836921167_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1231_48836746021_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1231_48836746021_o-1024x693.jpg" alt="" data-id="3205" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1231_48836746021_o/" class="wp-image-3205" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1231_48836746021_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1231_48836746021_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1231_48836746021_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1231_48836746021_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1241_48836376858_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1241_48836376858_o-1024x693.jpg" alt="" data-id="3206" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1241_48836376858_o/" class="wp-image-3206" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1241_48836376858_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1241_48836376858_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1241_48836376858_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1241_48836376858_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1254_48836924447_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1254_48836924447_o-1024x693.jpg" alt="" data-id="3207" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1254_48836924447_o/" class="wp-image-3207" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1254_48836924447_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1254_48836924447_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1254_48836924447_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1254_48836924447_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1255_48836376788_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1255_48836376788_o-1024x693.jpg" alt="" data-id="3208" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1255_48836376788_o/" class="wp-image-3208" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1255_48836376788_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1255_48836376788_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1255_48836376788_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1255_48836376788_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1262_48836745936_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1262_48836745936_o-1024x693.jpg" alt="" data-id="3209" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1262_48836745936_o/" class="wp-image-3209" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1262_48836745936_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1262_48836745936_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1262_48836745936_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1262_48836745936_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1266_48836745891_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1266_48836745891_o-1024x693.jpg" alt="" data-id="3210" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1266_48836745891_o/" class="wp-image-3210" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1266_48836745891_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1266_48836745891_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1266_48836745891_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1266_48836745891_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1267_48836924367_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1267_48836924367_o-1024x693.jpg" alt="" data-id="3211" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1267_48836924367_o/" class="wp-image-3211" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1267_48836924367_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1267_48836924367_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1267_48836924367_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1267_48836924367_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1272_48836745856_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1272_48836745856_o-1024x693.jpg" alt="" data-id="3212" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1272_48836745856_o/" class="wp-image-3212" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1272_48836745856_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1272_48836745856_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1272_48836745856_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1272_48836745856_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1274_48836924317_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1274_48836924317_o-1024x693.jpg" alt="" data-id="3213" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1274_48836924317_o/" class="wp-image-3213" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1274_48836924317_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1274_48836924317_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1274_48836924317_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1274_48836924317_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1275_48836921137_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1275_48836921137_o-1024x693.jpg" alt="" data-id="3214" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1275_48836921137_o/" class="wp-image-3214" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1275_48836921137_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1275_48836921137_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1275_48836921137_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1275_48836921137_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1277_48836376683_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1277_48836376683_o-1024x693.jpg" alt="" data-id="3215" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1277_48836376683_o/" class="wp-image-3215" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1277_48836376683_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1277_48836376683_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1277_48836376683_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1277_48836376683_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1282_48836924227_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1282_48836924227_o-1024x693.jpg" alt="" data-id="3216" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1282_48836924227_o/" class="wp-image-3216" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1282_48836924227_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1282_48836924227_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1282_48836924227_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1282_48836924227_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1291_48836924207_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1291_48836924207_o-1024x693.jpg" alt="" data-id="3217" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1291_48836924207_o/" class="wp-image-3217" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1291_48836924207_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1291_48836924207_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1291_48836924207_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1291_48836924207_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1293_48836924162_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1293_48836924162_o-1024x693.jpg" alt="" data-id="3218" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1293_48836924162_o/" class="wp-image-3218" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1293_48836924162_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1293_48836924162_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1293_48836924162_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1293_48836924162_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1309_48836376558_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1309_48836376558_o-1024x693.jpg" alt="" data-id="3219" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1309_48836376558_o/" class="wp-image-3219" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1309_48836376558_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1309_48836376558_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1309_48836376558_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1309_48836376558_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1314_48836745641_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1314_48836745641_o-1024x693.jpg" alt="" data-id="3220" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1314_48836745641_o/" class="wp-image-3220" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1314_48836745641_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1314_48836745641_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1314_48836745641_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1314_48836745641_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1320_48836745591_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1320_48836745591_o-1024x693.jpg" alt="" data-id="3221" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1320_48836745591_o/" class="wp-image-3221" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1320_48836745591_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1320_48836745591_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1320_48836745591_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1320_48836745591_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1322_48836742541_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1322_48836742541_o-1024x693.jpg" alt="" data-id="3222" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1322_48836742541_o/" class="wp-image-3222" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1322_48836742541_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1322_48836742541_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1322_48836742541_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1322_48836742541_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1329_48836376473_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1329_48836376473_o-1024x693.jpg" alt="" data-id="3223" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1329_48836376473_o/" class="wp-image-3223" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1329_48836376473_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1329_48836376473_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1329_48836376473_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1329_48836376473_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1332_48836745551_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1332_48836745551_o-1024x693.jpg" alt="" data-id="3224" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1332_48836745551_o/" class="wp-image-3224" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1332_48836745551_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1332_48836745551_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1332_48836745551_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1332_48836745551_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1411_48836745521_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1411_48836745521_o-1024x693.jpg" alt="" data-id="3225" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1411_48836745521_o/" class="wp-image-3225" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1411_48836745521_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1411_48836745521_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1411_48836745521_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1411_48836745521_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1413_48836924022_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1413_48836924022_o-1024x693.jpg" alt="" data-id="3226" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1413_48836924022_o/" class="wp-image-3226" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1413_48836924022_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1413_48836924022_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1413_48836924022_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1413_48836924022_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1421_48836923982_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1421_48836923982_o-1024x693.jpg" alt="" data-id="3227" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1421_48836923982_o/" class="wp-image-3227" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1421_48836923982_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1421_48836923982_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1421_48836923982_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1421_48836923982_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1428_48836745456_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1428_48836745456_o-1024x693.jpg" alt="" data-id="3228" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1428_48836745456_o/" class="wp-image-3228" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1428_48836745456_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1428_48836745456_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1428_48836745456_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1428_48836745456_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1439_48836745436_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1439_48836745436_o-1024x693.jpg" alt="" data-id="3229" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1439_48836745436_o/" class="wp-image-3229" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1439_48836745436_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1439_48836745436_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1439_48836745436_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1439_48836745436_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1440_48836373538_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1440_48836373538_o-1024x693.jpg" alt="" data-id="3230" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1440_48836373538_o/" class="wp-image-3230" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1440_48836373538_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1440_48836373538_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1440_48836373538_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1440_48836373538_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1442_48836745411_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1442_48836745411_o-1024x693.jpg" alt="" data-id="3231" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1442_48836745411_o/" class="wp-image-3231" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1442_48836745411_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1442_48836745411_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1442_48836745411_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1442_48836745411_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1447_48836376303_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1447_48836376303_o-1024x693.jpg" alt="" data-id="3232" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1447_48836376303_o/" class="wp-image-3232" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1447_48836376303_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1447_48836376303_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1447_48836376303_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1447_48836376303_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1458_48836376253_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1458_48836376253_o-1024x693.jpg" alt="" data-id="3233" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1458_48836376253_o/" class="wp-image-3233" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1458_48836376253_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1458_48836376253_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1458_48836376253_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1458_48836376253_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1488_48836745281_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1488_48836745281_o-1024x693.jpg" alt="" data-id="3234" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1488_48836745281_o/" class="wp-image-3234" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1488_48836745281_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1488_48836745281_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1488_48836745281_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1488_48836745281_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1492_48836745266_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1492_48836745266_o-1024x693.jpg" alt="" data-id="3235" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1492_48836745266_o/" class="wp-image-3235" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1492_48836745266_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1492_48836745266_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1492_48836745266_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1492_48836745266_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1504_48836745211_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1504_48836745211_o-1024x693.jpg" alt="" data-id="3236" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1504_48836745211_o/" class="wp-image-3236" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1504_48836745211_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1504_48836745211_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1504_48836745211_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1504_48836745211_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1512_48836376058_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1512_48836376058_o-1024x693.jpg" alt="" data-id="3237" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1512_48836376058_o/" class="wp-image-3237" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1512_48836376058_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1512_48836376058_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1512_48836376058_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1512_48836376058_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1518_48836923667_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1518_48836923667_o-1024x693.jpg" alt="" data-id="3238" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1518_48836923667_o/" class="wp-image-3238" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1518_48836923667_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1518_48836923667_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1518_48836923667_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1518_48836923667_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1530_48836376023_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1530_48836376023_o-1024x693.jpg" alt="" data-id="3239" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1530_48836376023_o/" class="wp-image-3239" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1530_48836376023_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1530_48836376023_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1530_48836376023_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1530_48836376023_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1535_48836745091_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1535_48836745091_o-1024x693.jpg" alt="" data-id="3240" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1535_48836745091_o/" class="wp-image-3240" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1535_48836745091_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1535_48836745091_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1535_48836745091_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1535_48836745091_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1564_48836375958_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1564_48836375958_o-1024x693.jpg" alt="" data-id="3241" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1564_48836375958_o/" class="wp-image-3241" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1564_48836375958_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1564_48836375958_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1564_48836375958_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1564_48836375958_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1574_48836745026_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1574_48836745026_o-1024x693.jpg" alt="" data-id="3242" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1574_48836745026_o/" class="wp-image-3242" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1574_48836745026_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1574_48836745026_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1574_48836745026_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1574_48836745026_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1608_48836920987_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1608_48836920987_o-1024x693.jpg" alt="" data-id="3243" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1608_48836920987_o/" class="wp-image-3243" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1608_48836920987_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1608_48836920987_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1608_48836920987_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1608_48836920987_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1615_48836923537_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1615_48836923537_o-1024x693.jpg" alt="" data-id="3244" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1615_48836923537_o/" class="wp-image-3244" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1615_48836923537_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1615_48836923537_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1615_48836923537_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1615_48836923537_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1617_48836923522_o-696x1024.jpg"><img loading="lazy" decoding="async" width="696" height="1024" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1617_48836923522_o-696x1024.jpg" alt="" data-id="3245" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1617_48836923522_o/" class="wp-image-3245" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1617_48836923522_o-696x1024.jpg 696w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1617_48836923522_o-204x300.jpg 204w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1617_48836923522_o-768x1130.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1617_48836923522_o.jpg 849w" sizes="(max-width: 696px) 100vw, 696px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1651_48836744936_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1651_48836744936_o-1024x693.jpg" alt="" data-id="3246" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1651_48836744936_o/" class="wp-image-3246" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1651_48836744936_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1651_48836744936_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1651_48836744936_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1651_48836744936_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1654_48836744911_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1654_48836744911_o-1024x693.jpg" alt="" data-id="3247" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1654_48836744911_o/" class="wp-image-3247" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1654_48836744911_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1654_48836744911_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1654_48836744911_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1654_48836744911_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1668_48836744891_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1668_48836744891_o-1024x693.jpg" alt="" data-id="3248" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1668_48836744891_o/" class="wp-image-3248" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1668_48836744891_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1668_48836744891_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1668_48836744891_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1668_48836744891_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1680_48836923432_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1680_48836923432_o-1024x693.jpg" alt="" data-id="3249" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1680_48836923432_o/" class="wp-image-3249" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1680_48836923432_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1680_48836923432_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1680_48836923432_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1680_48836923432_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1683_48836923407_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1683_48836923407_o-1024x693.jpg" alt="" data-id="3250" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1683_48836923407_o/" class="wp-image-3250" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1683_48836923407_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1683_48836923407_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1683_48836923407_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1683_48836923407_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1741_48836744846_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1741_48836744846_o-1024x693.jpg" alt="" data-id="3251" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1741_48836744846_o/" class="wp-image-3251" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1741_48836744846_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1741_48836744846_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1741_48836744846_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1741_48836744846_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1744_48836744821_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1744_48836744821_o-1024x693.jpg" alt="" data-id="3252" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1744_48836744821_o/" class="wp-image-3252" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1744_48836744821_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1744_48836744821_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1744_48836744821_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1744_48836744821_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1752_48836375698_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1752_48836375698_o-1024x693.jpg" alt="" data-id="3253" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1752_48836375698_o/" class="wp-image-3253" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1752_48836375698_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1752_48836375698_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1752_48836375698_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1752_48836375698_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1756_48836923337_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1756_48836923337_o-1024x693.jpg" alt="" data-id="3254" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1756_48836923337_o/" class="wp-image-3254" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1756_48836923337_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1756_48836923337_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1756_48836923337_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1756_48836923337_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1757_48836923317_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1757_48836923317_o-1024x693.jpg" alt="" data-id="3255" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1757_48836923317_o/" class="wp-image-3255" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1757_48836923317_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1757_48836923317_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1757_48836923317_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1757_48836923317_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1762_48836923297_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1762_48836923297_o-1024x693.jpg" alt="" data-id="3256" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1762_48836923297_o/" class="wp-image-3256" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1762_48836923297_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1762_48836923297_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1762_48836923297_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1762_48836923297_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1763_48836373413_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1763_48836373413_o-1024x693.jpg" alt="" data-id="3257" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1763_48836373413_o/" class="wp-image-3257" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1763_48836373413_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1763_48836373413_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1763_48836373413_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1763_48836373413_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1764_48836375583_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1764_48836375583_o-1024x693.jpg" alt="" data-id="3258" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1764_48836375583_o/" class="wp-image-3258" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1764_48836375583_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1764_48836375583_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1764_48836375583_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1764_48836375583_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1768_48836923232_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1768_48836923232_o-1024x693.jpg" alt="" data-id="3259" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1768_48836923232_o/" class="wp-image-3259" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1768_48836923232_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1768_48836923232_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1768_48836923232_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1768_48836923232_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1784_48836375533_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1784_48836375533_o-1024x693.jpg" alt="" data-id="3260" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1784_48836375533_o/" class="wp-image-3260" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1784_48836375533_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1784_48836375533_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1784_48836375533_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1784_48836375533_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1790_48836375518_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1790_48836375518_o-1024x693.jpg" alt="" data-id="3261" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1790_48836375518_o/" class="wp-image-3261" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1790_48836375518_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1790_48836375518_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1790_48836375518_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1790_48836375518_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1835_48836375488_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1835_48836375488_o-1024x693.jpg" alt="" data-id="3262" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1835_48836375488_o/" class="wp-image-3262" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1835_48836375488_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1835_48836375488_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1835_48836375488_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1835_48836375488_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1869_48836373298_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1869_48836373298_o-1024x693.jpg" alt="" data-id="3263" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1869_48836373298_o/" class="wp-image-3263" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1869_48836373298_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1869_48836373298_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1869_48836373298_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1869_48836373298_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1931_48836923032_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1931_48836923032_o-1024x693.jpg" alt="" data-id="3264" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1931_48836923032_o/" class="wp-image-3264" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1931_48836923032_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1931_48836923032_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1931_48836923032_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1931_48836923032_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1945_48836922972_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1945_48836922972_o-1024x693.jpg" alt="" data-id="3265" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1945_48836922972_o/" class="wp-image-3265" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1945_48836922972_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1945_48836922972_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1945_48836922972_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1945_48836922972_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1949_48836744406_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1949_48836744406_o-1024x693.jpg" alt="" data-id="3266" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1949_48836744406_o/" class="wp-image-3266" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1949_48836744406_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1949_48836744406_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1949_48836744406_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1949_48836744406_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1954_48836920837_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1954_48836920837_o-1024x693.jpg" alt="" data-id="3267" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1954_48836920837_o/" class="wp-image-3267" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1954_48836920837_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1954_48836920837_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1954_48836920837_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1954_48836920837_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1987_48836922907_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1987_48836922907_o-1024x693.jpg" alt="" data-id="3268" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1987_48836922907_o/" class="wp-image-3268" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1987_48836922907_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1987_48836922907_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1987_48836922907_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1987_48836922907_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1989_48836922867_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1989_48836922867_o-1024x693.jpg" alt="" data-id="3269" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-1989_48836922867_o/" class="wp-image-3269" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1989_48836922867_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1989_48836922867_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1989_48836922867_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-1989_48836922867_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2016_48836744301_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2016_48836744301_o-1024x693.jpg" alt="" data-id="3270" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2016_48836744301_o/" class="wp-image-3270" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2016_48836744301_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2016_48836744301_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2016_48836744301_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2016_48836744301_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2028_48836744206_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2028_48836744206_o-1024x693.jpg" alt="" data-id="3271" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2028_48836744206_o/" class="wp-image-3271" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2028_48836744206_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2028_48836744206_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2028_48836744206_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2028_48836744206_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2055_48836375173_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2055_48836375173_o-1024x693.jpg" alt="" data-id="3272" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2055_48836375173_o/" class="wp-image-3272" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2055_48836375173_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2055_48836375173_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2055_48836375173_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2055_48836375173_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2057_48836744171_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2057_48836744171_o-1024x693.jpg" alt="" data-id="3273" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2057_48836744171_o/" class="wp-image-3273" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2057_48836744171_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2057_48836744171_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2057_48836744171_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2057_48836744171_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2064_48836920717_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2064_48836920717_o-1024x693.jpg" alt="" data-id="3274" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2064_48836920717_o/" class="wp-image-3274" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2064_48836920717_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2064_48836920717_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2064_48836920717_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2064_48836920717_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2066_48836922692_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2066_48836922692_o-1024x693.jpg" alt="" data-id="3275" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2066_48836922692_o/" class="wp-image-3275" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2066_48836922692_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2066_48836922692_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2066_48836922692_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2066_48836922692_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2068_48836922657_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2068_48836922657_o-1024x693.jpg" alt="" data-id="3276" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2068_48836922657_o/" class="wp-image-3276" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2068_48836922657_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2068_48836922657_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2068_48836922657_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2068_48836922657_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2072_48836922627_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2072_48836922627_o-1024x693.jpg" alt="" data-id="3277" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2072_48836922627_o/" class="wp-image-3277" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2072_48836922627_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2072_48836922627_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2072_48836922627_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2072_48836922627_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2075_48836375013_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2075_48836375013_o-1024x693.jpg" alt="" data-id="3278" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2075_48836375013_o/" class="wp-image-3278" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2075_48836375013_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2075_48836375013_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2075_48836375013_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2075_48836375013_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2076_48836744046_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2076_48836744046_o-1024x693.jpg" alt="" data-id="3279" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2076_48836744046_o/" class="wp-image-3279" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2076_48836744046_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2076_48836744046_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2076_48836744046_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2076_48836744046_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2078_48836374998_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2078_48836374998_o-1024x693.jpg" alt="" data-id="3280" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2078_48836374998_o/" class="wp-image-3280" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2078_48836374998_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2078_48836374998_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2078_48836374998_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2078_48836374998_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2081_48836373153_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2081_48836373153_o-1024x693.jpg" alt="" data-id="3281" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2081_48836373153_o/" class="wp-image-3281" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2081_48836373153_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2081_48836373153_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2081_48836373153_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2081_48836373153_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2084_48836374913_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2084_48836374913_o-1024x693.jpg" alt="" data-id="3282" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2084_48836374913_o/" class="wp-image-3282" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2084_48836374913_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2084_48836374913_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2084_48836374913_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2084_48836374913_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2101_48836743951_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2101_48836743951_o-1024x693.jpg" alt="" data-id="3283" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2101_48836743951_o/" class="wp-image-3283" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2101_48836743951_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2101_48836743951_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2101_48836743951_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2101_48836743951_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2105_48836743906_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2105_48836743906_o-1024x693.jpg" alt="" data-id="3284" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2105_48836743906_o/" class="wp-image-3284" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2105_48836743906_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2105_48836743906_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2105_48836743906_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2105_48836743906_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2107_48836373133_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2107_48836373133_o-1024x693.jpg" alt="" data-id="3285" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2107_48836373133_o/" class="wp-image-3285" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2107_48836373133_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2107_48836373133_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2107_48836373133_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2107_48836373133_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2121_48836922462_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2121_48836922462_o-1024x693.jpg" alt="" data-id="3286" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2121_48836922462_o/" class="wp-image-3286" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2121_48836922462_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2121_48836922462_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2121_48836922462_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2121_48836922462_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2126_48836743836_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2126_48836743836_o-1024x693.jpg" alt="" data-id="3287" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2126_48836743836_o/" class="wp-image-3287" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2126_48836743836_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2126_48836743836_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2126_48836743836_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2126_48836743836_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2130_48836742186_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2130_48836742186_o-1024x693.jpg" alt="" data-id="3288" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2130_48836742186_o/" class="wp-image-3288" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2130_48836742186_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2130_48836742186_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2130_48836742186_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2130_48836742186_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2135_48836374788_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2135_48836374788_o-1024x693.jpg" alt="" data-id="3289" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2135_48836374788_o/" class="wp-image-3289" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2135_48836374788_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2135_48836374788_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2135_48836374788_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2135_48836374788_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2139_48836374793_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2139_48836374793_o-1024x693.jpg" alt="" data-id="3290" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2139_48836374793_o/" class="wp-image-3290" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2139_48836374793_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2139_48836374793_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2139_48836374793_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2139_48836374793_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2144_48836922317_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2144_48836922317_o-1024x693.jpg" alt="" data-id="3291" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2144_48836922317_o/" class="wp-image-3291" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2144_48836922317_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2144_48836922317_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2144_48836922317_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2144_48836922317_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2157_48836374708_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2157_48836374708_o-1024x693.jpg" alt="" data-id="3292" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2157_48836374708_o/" class="wp-image-3292" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2157_48836374708_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2157_48836374708_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2157_48836374708_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2157_48836374708_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2164_48836742146_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2164_48836742146_o-1024x693.jpg" alt="" data-id="3293" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2164_48836742146_o/" class="wp-image-3293" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2164_48836742146_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2164_48836742146_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2164_48836742146_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2164_48836742146_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2167_48836743691_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2167_48836743691_o-1024x693.jpg" alt="" data-id="3294" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2167_48836743691_o/" class="wp-image-3294" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2167_48836743691_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2167_48836743691_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2167_48836743691_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2167_48836743691_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2196_48836743666_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2196_48836743666_o-1024x693.jpg" alt="" data-id="3295" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2196_48836743666_o/" class="wp-image-3295" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2196_48836743666_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2196_48836743666_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2196_48836743666_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2196_48836743666_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2198_48836743656_o-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2198_48836743656_o-1024x693.jpg" alt="" data-id="3296" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2198_48836743656_o/" class="wp-image-3296" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2198_48836743656_o-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2198_48836743656_o-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2198_48836743656_o-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2198_48836743656_o.jpg 1649w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2202_48837242447_o-1024x683.jpg"><img loading="lazy" decoding="async" width="1024" height="683" src="https://cintespbr.org/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2202_48837242447_o-1024x683.jpg" alt="" data-id="3297" data-link="https://cintespbr.org/agradecimentos/forum_nacional_cintesp_uberlandia-2202_48837242447_o/" class="wp-image-3297" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2202_48837242447_o-1024x683.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2202_48837242447_o-300x200.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/forum_nacional_cintesp_uberlandia-2202_48837242447_o-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li></ul>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Astronauta Marcos Pontes reconhece pioneirismo em tecnologia Assistiva do CINTESP.Br para o Esporte Paralímpico junto ao Diretor do Cintesp.Br Cleudmar Amaral de Araújo e a Presidente do fórum Nacional Cintesp.Br, Daniela M. Yoshida, no momento de agradecimento pela participação. Prezados, A vida é feita de desafios e obstáculos que precisamos superar. Não podemos desistir de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3091,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-3094",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3094",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3094",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3094/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3304,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3094/revisions/3304",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3091",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3094",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3094",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3094",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3057,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=3057",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "forum-do-cintesp-br-mostra-de-inovacoes-em-tecnologias-assistivas-para-o-esporte-e-saude",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/forum-do-cintesp-br-mostra-de-inovacoes-em-tecnologias-assistivas-para-o-esporte-e-saude/",
        title: {
            rendered:
                "FORUM DO CINTESP.Br &#038; MOSTRA DE INOVAÇÕES EM TECNOLOGIAS ASSISTIVAS PARA O ESPORTE E SAÚDE.",
        },
        content: {
            rendered:
                '\r\n<h4 class="wp-block-heading"><strong>FORUM DO CINTESP.Br &amp; MOSTRA DE INOVAÇÕES EM TECNOLOGIAS ASSISTIVAS PARA O ESPORTE E SAÚDE, </strong>teve uma relevância especial, em função da celebração de um <strong>Acordo de Cooperação Técnica e Científica</strong> entre o MCTIC (SETAP/DEPDS/CGDS), o CINTESP/UFU, o CPB e a FUTEL para a promoção do Cintesp.Br como unidade de Referência Nacional do em Inovações Tecnológicas para Esportes Paralímpicos.</h4>\r\n\r\n\r\n\r\n<p class="has-background" style="background-color: #ddf0f9;"><strong>Daniela Moura Yoshida</strong><br />Presidente do Fórum Nacional CINTESP.Br<br />Traz o tema do <strong>Dia Nacional de Luta das Pessoas com deficiência em geral. </strong>Esse dia tem o objetivo de evidenciar as necessidades, reivindicações e lutas enfrentadas pelas Pessoas com Deﬁciência. Um dos objetivos do Fórum foi conscientizar a sociedade para as barreiras que ainda precisam ser enfrentadas para que a pessoa com deficiência possa ser tratada com igualdade, seja no ambiente profissional ou nos momentos de lazer e esporte. No dia 21 de setembro, é comemorado no Brasil, o Dia Nacional de Luta das Pessoas com Deficiência. Este dia é uma forma de garantir a integralização das pessoas que tem impedimento de natureza física, mental, intelectual ou sensorial na sociedade de maneira igualitária e sem preconceitos. Assim sendo, é reconhecido como um grande marco na luta das pessoas com deficiência.</p>\r\n\r\n\r\n\r\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="678" class="wp-image-3060" src="https://cintespbr.org/wp-content/uploads/2019/10/image002-1024x678.jpg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image002-1024x678.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image002-300x199.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image002-768x509.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image002.jpg 1546w" sizes="(max-width: 1024px) 100vw, 1024px" />\r\n<figcaption>Solenidade realizada na Arena Sabiazinho, local onde o Cintesp.Br também está instalado. (Foto: Milton Santos)</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<h4 class="wp-block-heading"><strong>UFU é referência em inovações tecnológicas para o esporte paralímpico</strong></h4>\r\n\r\n\r\n\r\n<p>Acordo de Cooperação Técnica e Científica entre o Centro de Inovações Tecnológicas em Esportes Paralímpicos e órgãos dos governos federal e municipal será assinado na próxima segunda-feira (30/09), em evento na Arena Sabiazinho<br /><strong>Autor: </strong>Hermom Dourado<br /><strong><a href="http://www.comunica.ufu.br/noticia/2019/09/ufu-e-referencia-nacional-em-inovacoes-tecnologicas-para-o-esporte-paralimpico">http://www.comunica.ufu.br/noticia/2019/09/ufu-e-referencia-nacional-em-inovacoes-tecnologicas-para-o-esporte-paralimpico</a></strong> <br /><br />Por iniciativa do <a href="https://cintespbr.org/"><strong>Centro de Inovações Tecnológicas em Esportes Paralímpicos da Universidade Federal de Uberlândia (Cintesp.Br/UFU)</strong></a>, em parceria com o Comitê Paralímpico Brasileiro (CPB) e a Fundação Uberlandense do Turismo, Esporte e Lazer (Futel), a maior cidade do interior de Minas Gerais recebe o Fórum Nacional Cintesp.Br e a Mostra de Inovações em Tecnologias Assistivas para Esportes e Saúde. Os eventos simultâneos estão com <a href="https://www.sympla.com.br/mostra-de-inovacoes-em-tecnologias-assistivas-para-esportes-e-saude__655834?token=c8d433f41c2d59b43d5049fdd8df63b2"><strong>inscrições abertas</strong></a> e serão realizados na manhã da próxima segunda-feira, 30 de setembro, na Arena Sabiazinho. Trata-se do ápice da programação uberlandense em comemoração ao “Dia Nacional de Luta das Pessoas com Deficiência” (21/09) e ao “Dia Nacional do Atleta Paralímpico” (22/09).<br /><br />De acordo com os organizadores, o principal objetivo destas atividades é conscientizar a sociedade das barreiras que ainda precisam ser enfrentadas para a inclusão social das pessoas com deficiência, seja no ambiente profissional ou nos momentos de lazer e esporte. “Também queremos evidenciar a luta dos paratletas brasileiros e suas conquistas nos esportes paralímpicos, que têm inspirado paixões pelo esporte e feito história em competições ao redor do mundo”, explica a Coordenadora Geral do Cintesp.Br, Daniela Moura Yoshida.<br /><br />A mesa de honra da solenidade de abertura do fórum será formada por autoridades da UFU, do CPB, do Ministério da Ciência, Tecnologia, Inovações e Comunicações (MCTIC), da Prefeitura Municipal de Uberlândia, da Futel, além de representantes de agências de fomento e de organizações envolvidas com o tema. “Estão sendo convidados representantes de associações e entidades voltadas ao esporte paralímpico e às pessoas com deficiência, bem como coordenadores e pesquisadores de áreas relacionadas com tecnologias assistivas”, acrescenta Cleudmar Amaral de Araújo, docente da Faculdade de Engenharia Mecânica (Femec/UFU) e diretor-geral do Cintesp.Br.<br /><br /><strong>Reconhecimento</strong><br />O Cintesp.Br foi criado na Universidade Federal de Uberlândia no ano de 2012, em atendimento ao primeiro chamamento público do MCTIC para a criação de núcleos de pesquisa e desenvolvimento em tecnologia assistiva. Originalmente, chamava-se “Núcleo de Habilitação/Reabilitação em Esportes Paralímpicos” (NH/Resp). A mudança de nome ocorreu em junho de 2018, devido aos diversos projetos inovadores na área do esporte paralímpico desenvolvidos no Laboratório de Projetos Mecânicos da Femec.<br /><br />Desde então, constituiu-se um centro multidisciplinar de pesquisadores, profissionais e associações parceiras e tem sido adotado no espaço um modelo destinado à criação de soluções em esportes e saúde para Pessoas em Desvantagem Funcional (PDF) – sigla esta que engloba os termos Pessoa com Capacidade Reduzida (PcR), Pessoa com Deficiência (PcD) e Pessoa com Incapacidade (PcI). Além da estrutura de 130 m2 disponibilizada na UFU, o Cintesp.Br conta também com uma área de 220 m2 situada na Arena Sabiazinho, fornecida pelo convênio firmado com a Futel. A Mostra de Inovações em Tecnologias Assistivas para Esportes e Saúde vai apresentar 37 tecnologias assistivas inovadoras voltadas para a saúde, o esporte e lazer que foram desenvolvidas pelo centro e por seus parceiros.<br /><br />O reconhecimento do nível de excelência destes trabalhos será reafirmado durante a abertura do fórum, com a celebração de um Acordo de Cooperação Técnica e Científica com MCTIC, CPB e Futel que promoverá o Cintesp.Br ao status de unidade de referência nacional em inovações tecnológicas para o esporte paralímpico. A programação também contemplará uma homenagem ao presidente do CPB, Mizael Conrado, e aos paratletas e treinadores que representaram Uberlândia e conquistaram medalhas na última edição dos Jogos Parapan-Americanos, em Lima, no Peru. Eles receberão um diploma de Mérito Esportivo chancelado pelo MCTIC e pelo Cintesp.Br.<br /><br /><strong>FORUM DO CINTESP.Br &amp; MOSTRA DE INOVAÇÕES EM TECNOLOGIAS ASSISTIVAS PARA O ESPORTE E SAÚDE contou com a presença de autoridades municipais e também:</strong><br /><br /><strong>Mauricio Ribeiro Gonçalves<br /></strong><em>Secretario De Tecnologias Aplicadas – SETAP</em><br /><strong>Profa. Dra. Maria Claudia Ferrari de Castro</strong><br /><em>Diretora do Departamento de Tecnologias para Programas de Desenvolvimento Sustentável e Sociais – DEPDS </em><br /><em>Secretaria de Tecnologias Aplicadas &#8211; SETAP</em><br /><strong>Sônia da Costa</strong><br /><em>Coordenadora-Geral de Tecnologias para Programas de Desenvolvimento Sustentável e Sociais -CGDS</em><br /><em>Secretaria de Tecnologias Aplicadas – SETAP<br /></em><strong>Zé Vitor</strong><br /><em>Deputado Federal (PR/MG)</em><br /><strong>Sr Hélio Ferraz &#8211; Baiano</strong><br /><em>Presidente da Câmara Municipal de Uberlândia <br /></em><strong>Carlos Augusto Ribeiro Braga </strong><br /><em>Presidente do Praia Clube</em></p>\r\n\r\n\r\n\r\n<h4 class="wp-block-heading"><strong>Ministro Marcos Pontes visita Uberlândia e assina acordo para esporte paralímpico</strong></h4>\r\n\r\n\r\n\r\n<p><strong><em>O chefe da pasta de Ciência, Tecnologia, Inovações e Comunicações esteve na feira científica da UFU. Veja entrevista.</em></strong><br /><strong>Por Fernanda Vieira, MG1</strong><br />30/09/2019<br /><a href="https://g1.globo.com/mg/triangulo-mineiro/noticia/2019/09/30/ministro-marcos-pontes-visita-uberlandia-e-assina-acordo-para-esporte-paralimpico.ghtml?fbclid=IwAR2Qq0X7b9PpZdv8zF8kIOqdN099TUm2Camsu4KdK_RFLA0ixO0XI8egUkw"><strong>https://g1.globo.com/mg/triangulo-mineiro/noticia/2019/09/30/ministro-marcos-pontes-visita-uberlandia-e-assina-acordo-para-esporte-paralimpico.ghtml?fbclid=IwAR2Qq0X7b9PpZdv8zF8kIOqdN099TUm2Camsu4KdK_RFLA0ixO0XI8egUkw </strong></a></p>\r\n\r\n\r\n\r\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="677" class="wp-image-3061" src="https://cintespbr.org/wp-content/uploads/2019/10/image003-1024x677.jpg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image003-1024x677.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image003-300x198.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image003-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image003.jpg 1386w" sizes="(max-width: 1024px) 100vw, 1024px" />\r\n<figcaption>Momento de assinatura entre o Astronauta Marcos Pontes ministro da Ciência, Tecnologia, Inovações e Comunicações e o Diretor Geral do CINTESP.Br Cleudmar A. Araujo.</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="677" class="wp-image-3062" src="https://cintespbr.org/wp-content/uploads/2019/10/image004-1024x677.jpg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image004-1024x677.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image004-300x198.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image004-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image004.jpg 1386w" sizes="(max-width: 1024px) 100vw, 1024px" />\r\n<figcaption>Momentos antes da abertura do Fórum o Astronauta Marcos Pontes ministro da Ciência, Tecnologia, Inovações e Comunicações, Diretor Geral do CINTESP.Br Cleudmar A. Araujo, Presidente do Fórum Nacional CINTESP.Br Daniela M. Yoshida, Embaixador Mirim do CINTESP.Br Lucio Kendy M. Yoshida e o Fundador do LPM Laboratório de Projetos Mecânicos Henner Alberto Gomide.</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="678" class="wp-image-3063" src="https://cintespbr.org/wp-content/uploads/2019/10/image005-1024x678.jpg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image005-1024x678.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image005-300x199.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image005-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image005.jpg 1289w" sizes="(max-width: 1024px) 100vw, 1024px" />\r\n<figcaption>O hino Nacional marca a abertura do FORUM DO CINTESP.Br &amp; MOSTRA DE INOVAÇÕES EM TECNOLOGIAS ASSISTIVAS PARA O ESPORTE E SAÚDE</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="677" class="wp-image-3064" src="https://cintespbr.org/wp-content/uploads/2019/10/image006-1024x677.jpg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image006-1024x677.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image006-300x198.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image006-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image006.jpg 1386w" sizes="(max-width: 1024px) 100vw, 1024px" />\r\n<figcaption>Momento solene de Nomeação do Embaixador Mirim do CINTESP.Br Lucio Kendy M. Yoshida, pelo Astronauta Marcos Pontes ministro da Ciência, Tecnologia, Inovações e Comunicações e o Diretor Geral do CINTESP.Br Cleudmar A. Araujo.</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="677" class="wp-image-3065" src="https://cintespbr.org/wp-content/uploads/2019/10/image007-1024x677.jpg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image007-1024x677.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image007-300x198.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image007-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image007.jpg 1386w" sizes="(max-width: 1024px) 100vw, 1024px" />\r\n<figcaption>Segundo o ministro, as pessoas com necessidades especiais são motivo maior de honra para que a ciência e a pesquisa sejam incentivadas. “São exemplo para todos nós e a vida nem sempre é fácil para eles. Com a tecnologia, tudo pode melhorar. Precisamos passar da fase do protótipo para o produto”.</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="677" class="wp-image-3066" src="https://cintespbr.org/wp-content/uploads/2019/10/image008-1024x677.jpg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image008-1024x677.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image008-300x198.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image008-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image008.jpg 1386w" sizes="(max-width: 1024px) 100vw, 1024px" />\r\n<figcaption>O documento foi assinado durante o Fórum Nacional Cintesp.Br e a Mostra de Inovações em Tecnologias Assistivas para Esportes e Saúde, que foram realizados na Arena Sabiazinho. Além do reitor da UFU, professor Valder Steffen, também subscreveram o documento as seguintes autoridades: astronauta Marcos Pontes, ministro da Ciência, Tecnologia, Inovações e Comunicações; Edson Cézar Zanatta, diretor da Futel; e o professor Cleudmar Amaral de Araújo, diretor-geral do Cintesp.Br – o presidente do Comitê Paralímpico Brasileiro, Mizael Conrado, não pôde comparecer ao evento, mas também irá assinar o Acordo de Cooperação Técnica e Científica.</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="677" class="wp-image-3067" src="https://cintespbr.org/wp-content/uploads/2019/10/image009-1024x677.jpg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image009-1024x677.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image009-300x198.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image009-768x508.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image009.jpg 1386w" sizes="(max-width: 1024px) 100vw, 1024px" />\r\n<figcaption>O cerimonial do evento também foi marcado pelo reconhecimento aos atletas que transformaram Uberlândia na cidade recordista de medalhas no Parapan 2019. Ao todo, 19 atletas e seis treinadores receberam um diploma de Mérito Esportivo chancelado pelo MCTIC e pelo Cintesp.Br.</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="629" height="629" class="wp-image-3068" src="https://cintespbr.org/wp-content/uploads/2019/10/image010.png" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image010.png 629w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image010-150x150.png 150w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image010-300x300.png 300w" sizes="(max-width: 629px) 100vw, 629px" />\r\n<figcaption>Além deles, dois jovens uberlandenses também tiveram seu momento de protagonismo. Lucio Kendy Moura Yoshida, de 8 anos, recebeu o certificado de embaixador mirim do Cintesp.Br. Já Gabriel Freitas Costantim, aluno do 9º ano do Ensino Fundamental na Eseba, foi agraciado pelo diploma da medalha de ouro conquistada na 14ª edição da Olimpíada Brasileira de Matemática (OBMEP). As duas distinções foram entregues pelo ministro Marcos Pontes.</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<h4 class="wp-block-heading"><strong>Tecnologias para os esportes paralímpicos são apresentadas em feira da UFU</strong><br />JORNAL PARANAÍBA</h4>\r\n\r\n\r\n\r\n<figure class="wp-block-embed-youtube wp-block-embed is-type-video is-provider-youtube wp-embed-aspect-16-9 wp-has-aspect-ratio">\r\n<div class="wp-block-embed__wrapper">https://www.youtube.com/watch?v=alCWCdecVOg&amp;feature=youtu.be</div>\r\n</figure>\r\n\r\n\r\n\r\n<p>O ministro da Ciência, Tecnologia, Inovações e Comunicações está na cidade nesta segunda-feira (30) em evento da UFU. Acordo beneficiará atletas paralímpicos.<br /><a href="http://g1.globo.com/minas-gerais/triangulo-mineiro/videos/v/ministro-marcos-pontes-visita-mostra-da-ufu-em-uberlandia-e-assina-acordo-de-cooperacao/7962207/">http://g1.globo.com/minas-gerais/triangulo-mineiro/videos/v/ministro-marcos-pontes-visita-mostra-da-ufu-em-uberlandia-e-assina-acordo-de-cooperacao/7962207/</a></p>\r\n\r\n\r\n\r\n<h4 class="wp-block-heading"><strong>Marcos Pontes reconhece pioneirismo da UFU em tecnologias assistivas</strong></h4>\r\n\r\n\r\n\r\n<p>Ministro foi um dos signatários do Acordo de Cooperação Técnica e Científica que elevou o Centro de Inovações Tecnológicas em Esportes Paralímpicos, iniciado em 2012 na Universidade Federal de Uberlândia, ao status de unidade de referência nacional<br /><strong>por Autor: </strong><br />Hermom Dourado<br /><a href="http://www.comunica.ufu.br/noticia/2019/09/marcos-pontes-reconhece-pioneirismo-da-ufu-em-tecnologias-assistivas"><strong>http://www.comunica.ufu.br/noticia/2019/09/marcos-pontes-reconhece-pioneirismo-da-ufu-em-tecnologias-assistivas</strong></a></p>\r\n\r\n\r\n\r\n<h4 class="wp-block-heading"><strong>Uberlândia sedia fórum de tecnologia para o esporte paralímpico<br /></strong>30 de set de 2019</h4>\r\n\r\n\r\n\r\n<figure class="wp-block-embed-youtube wp-block-embed is-type-video is-provider-youtube wp-embed-aspect-4-3 wp-has-aspect-ratio">\r\n<div class="wp-block-embed__wrapper">https://www.youtube.com/watch?v=52mRML4Ntm8&amp;feature=youtu.be</div>\r\n</figure>\r\n\r\n\r\n\r\n<h4 class="wp-block-heading"><strong>Reportagem com o ministro da Ciência, Tecnologia, Inovações e Comunicações Marcos Potes, Diretor do CINTES.Br Cleudmar A. Araújo, Presidente do Fórum Nacional CINTESP.Br Daniela M. Yoshida e pesquisadores.</strong><br />BAND CIDADE</h4>\r\n\r\n\r\n\r\n<figure class="wp-block-embed-youtube wp-block-embed is-type-video is-provider-youtube wp-embed-aspect-16-9 wp-has-aspect-ratio">\r\n<div class="wp-block-embed__wrapper">https://www.youtube.com/watch?v=ZHtwoSy1PV8</div>\r\n</figure>\r\n\r\n\r\n\r\n<h4 class="wp-block-heading"><strong> Apresentação de tecnologias Assistivas da mostra.</strong></h4>\r\n\r\n\r\n\r\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="498" class="wp-image-3069" src="https://cintespbr.org/wp-content/uploads/2019/10/image011-1024x498.png" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image011-1024x498.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image011-300x146.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image011-768x373.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image011.png 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure>\r\n\r\n\r\n\r\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="498" class="wp-image-3070" src="https://cintespbr.org/wp-content/uploads/2019/10/image012-1024x498.png" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image012-1024x498.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image012-300x146.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image012-768x373.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/image012.png 1280w" sizes="(max-width: 1024px) 100vw, 1024px" />\r\n<figcaption>Presidente do Fórum Nacional CINTESP.Br Daniela M. Yoshida Também pesquisadora do CINTESP.Br, apresenta tecnologia Assistiva para pessoas com deficiência surdocegueira ao ministro da Ciência, Tecnologia, Inovações e Comunicações Marcos Potes.</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<p>&nbsp;</p>\r\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>FORUM DO CINTESP.Br &amp; MOSTRA DE INOVAÇÕES EM TECNOLOGIAS ASSISTIVAS PARA O ESPORTE E SAÚDE, teve uma relevância especial, em função da celebração de um Acordo de Cooperação Técnica e Científica entre o MCTIC (SETAP/DEPDS/CGDS), o CINTESP/UFU, o CPB e a FUTEL para a promoção do Cintesp.Br como unidade de Referência Nacional do em Inovações Tecnológicas&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3059,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-3057",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3057",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3057",
                },
            ],
            "version-history": [
                {
                    count: 12,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3057/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5875,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3057/revisions/5875",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3059",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3057",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3057",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3057",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3045,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=3045",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "solenidade-de-outorga-da-camara-municipal-de-uberlandia-da-comenda-vital-severino-neto",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/solenidade-de-outorga-da-camara-municipal-de-uberlandia-da-comenda-vital-severino-neto/",
        title: {
            rendered:
                "Câmara Municipal de Uberlândia reconhece as ações sociais do CINTESP.Br como importantes atividades na Promoção da Paz.",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_single_image image=&#8221;3046&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p><strong>Data: 19/09/2019</strong></p>\n<p style="text-align: justify;">As homenagens aconteceram em sessão solene realizada em setembro quando é celebrado o Dia Internacional da Paz. A Comenda Vital Severino Neto, foi entregue também em homenagem ao Dia Nacional do Atleta Paralímpico. A solenidade, que acontece todos os anos em Uberlândia, faz parte do calendário oficial da cidade e reúne pessoas, empresas e instituições que desenvolveram ações, em favor da Paz, que se destacaram no ano em diferentes áreas.</p>\n<p style="text-align: justify;">Na mesma sessão solene foi entregue o diploma com a outorga de “Embaixador da Paz” no âmbito do Município de Uberlândia, uma homenagear as pessoas físicas e jurídicas que realizam e desempenham atividades de prevenção, cuidado e enfrentamento de todas as formas de violência e da dependência química. Na área de tecnologia, a coordenadora geral do CINTESP.Br, Daniela M. Yoshida, recebeu o Diploma de “Comendadora da Paz”, Vital Severino Neto, no Município de Uberlândia, pelas ações sociais do CINTESP.Br , que coordena com o apoio do Ministério de Ciência Tecnologia e Inovação que oferecem, em favor da inclusão com acessibilidade, a conscientização sobre a importância dos cuidados à saúde, da luta contra o câncer, do esporte iniciante, da leitura, da importância do Braille e libras, assim com a importância da conscientização a respeito do autismo. No início do ano, a coordenadora geral do CINTESP.Br participou do II Fórum Municipal de Doenças Raras, promovido pela Câmara Municipal que desenvolveu o tema:  &#8220;Unir saúde e assistência social&#8221;.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_masonry_media_grid gap=&#8221;10&#8243; item=&#8221;masonryGrid_GoTop&#8221; grid_id=&#8221;vc_gid:1619398058921-8d33c063-2ea1-4&#8243; include=&#8221;3052,3051,3050,3049,3048,3047&#8243;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;3046&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text] Data: 19/09/2019 As homenagens aconteceram em sessão solene realizada em setembro quando é celebrado o Dia Internacional da Paz. A Comenda Vital Severino Neto, foi entregue também em homenagem ao Dia Nacional do Atleta Paralímpico. A solenidade, que acontece todos os anos em Uberlândia, faz parte do calendário oficial da cidade&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3046,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62, 46],
        tags: [],
        class_list: [
            "post-3045",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-ultimas-noticias",
            "category-47",
            "category-62",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3045",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3045",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3045/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5757,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3045/revisions/5757",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3046",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3045",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3045",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3045",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 2984,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=2984",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "forum-nacional-de-tecnologia-assistiva-e-ii-mostra-de-pd-e-inovacao-em-tecnologia-assistiva",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/forum-nacional-de-tecnologia-assistiva-e-ii-mostra-de-pd-e-inovacao-em-tecnologia-assistiva/",
        title: {
            rendered:
                "Fórum Nacional de Tecnologia Assistiva e II Mostra de P&#038;D e Inovação em Tecnologia Assistiva",
        },
        content: {
            rendered:
                '\r\n<p><em><strong>fonte</strong>: <a href="https://www.mdh.gov.br/todas-as-noticias/2018/dezembro/eventos-celebram-o-dia-internacional-da-pessoa-com-deficiencia">https://www.mdh.gov.br/todas-as-noticias/2018/dezembro/eventos-celebram-o-dia-internacional-da-pessoa-com-deficiencia</a> </em></p>\r\n\r\n\r\n\r\n<p>Brasília, 14 de novembro de 2018 &#8211; Esplanada dos Ministérios</p>\r\n\r\n\r\n\r\n<p>O evento objetivou reunir coordenadores e pesquisadores dos principais projetos apoiados pelo MCTIC e demais instituições que fomentam a P&amp;D em tecnologia assistiva nas suas diversas modalidades. </p>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter"><img loading="lazy" decoding="async" width="768" height="1024" class="wp-image-2986" src="https://cintespbr.org/wp-content/uploads/2019/09/IMG-5039-1-1-e1568644636226-768x1024.jpg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/09/IMG-5039-1-1-e1568644636226-768x1024.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/09/IMG-5039-1-1-e1568644636226-225x300.jpg 225w" sizes="(max-width: 768px) 100vw, 768px" />\r\n<figcaption><strong>Sônia da Costa</strong> &#8211; Coordenadora-Geral de Tecnologias para Programas de Desenvolvimento Sustentável e Sociais – CGDS.<br /><strong>Daniela Moura Yoshida</strong> &#8211; Coordenadora Geral do CINTESP.Br/UFU.</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter"><img loading="lazy" decoding="async" width="768" height="1024" class="wp-image-2993" src="https://cintespbr.org/wp-content/uploads/2019/09/IMG-5054-e1568645569460-768x1024.jpg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/09/IMG-5054-e1568645569460-768x1024.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/09/IMG-5054-e1568645569460-225x300.jpg 225w" sizes="(max-width: 768px) 100vw, 768px" />\r\n<figcaption><strong>Priscila Lelis Cagni </strong>&#8211; Coordenadora de Programas de Indução e Inovação da Diretoria de Programas e Bolsa Pais da Capes.<br /><strong>Daniela Moura Yoshida</strong> -Coordenadora Geral do CINTESP.Br/UFU.</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="768" height="1024" class="wp-image-2997" src="https://cintespbr.org/wp-content/uploads/2019/09/IMG-5149-1-e1568646325309-768x1024.jpg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/09/IMG-5149-1-e1568646325309-768x1024.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/09/IMG-5149-1-e1568646325309-225x300.jpg 225w" sizes="(max-width: 768px) 100vw, 768px" />\r\n<figcaption><strong>Marco Antonio Pellegrini </strong>&#8211; Secretário Nacional dos Direitos da Pessoa com Deficiência (SEDPcD) <br /><strong>Daniela Moura Yoshida</strong> -Coordenadora Geral do CINTESP.Br/UFU.</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="768" class="wp-image-3002" src="https://cintespbr.org/wp-content/uploads/2019/09/IMG-6072-1024x768.jpg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/09/IMG-6072.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/09/IMG-6072-300x225.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/09/IMG-6072-768x576.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" />\r\n<figcaption><strong>Francisco Glauberto Bezerra </strong>&#8211; Diretor-geral do MP-Procon <br /><strong>Daniela Moura Yoshida</strong> &#8211; Diretora de Marketing e Publicidade do CINTESP.Br/UFU.</figcaption>\r\n</figure>\r\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>fonte: https://www.mdh.gov.br/todas-as-noticias/2018/dezembro/eventos-celebram-o-dia-internacional-da-pessoa-com-deficiencia Brasília, 14 de novembro de 2018 &#8211; Esplanada dos Ministérios O evento objetivou reunir coordenadores e pesquisadores dos principais projetos apoiados pelo MCTIC e demais instituições que fomentam a P&amp;D em tecnologia assistiva nas suas diversas modalidades. </p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 2991,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-2984",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2984",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=2984",
                },
            ],
            "version-history": [
                {
                    count: 9,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2984/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5878,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2984/revisions/5878",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/2991",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=2984",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=2984",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=2984",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 2867,
        date: "2024-08-07T14:54:00",
        date_gmt: "2024-08-07T17:54:00",
        guid: {
            rendered: "https://cintespbr.org/?p=2867",
        },
        modified: "2024-08-07T14:54:00",
        modified_gmt: "2024-08-07T17:54:00",
        slug: "setembro-azul",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/setembro-azul/",
        title: {
            rendered: "Setembro Azul",
        },
        content: {
            rendered:
                '\n<h4 class="wp-block-heading">O que é Setembro Azul?</h4>\n\n\n\n<p style="color:#0000cd" class="has-text-color">Setembro Azul&nbsp;é o mês da\nvisibilidade da Comunidade Surda Brasileira, uma ação que traz conscientização\ne homenagens a essa população.</p>\n\n\n\n<h4 class="wp-block-heading">Origem do Setembro Azul</h4>\n\n\n\n<p style="color:#0000cd" class="has-text-color">O\nSetembro Azul surgiu a partir da luta da Comunidade Surda por seus direitos.</p>\n\n\n\n<h4 class="wp-block-heading">Por que azul?</h4>\n\n\n\n<p style="color:#0000cd" class="has-text-color">A cor azul possui um\nsignificado que para muitos pode ser triste, mas também pode ser encarada como\num símbolo de orgulho e resistência da Comunidade Surda. A simbologia vem da\nSegunda Guerra Mundial quando, durante a tentativa dos nazistas de livrar o\nmundo daqueles considerados “inferiores”, todas as pessoas com deficiência eram\nidentificadas por uma faixa azul no braço — o que incluía a população surda. Essas\npessoas eram então encaminhadas a instituições na Alemanha e Áustria, onde eram\nexecutadas. O programa responsável pela morte de cerca de 20.000 pessoas\ndeficientes entre 1940 e 1945</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O que é Setembro Azul? Setembro Azul&nbsp;é o mês da visibilidade da Comunidade Surda Brasileira, uma ação que traz conscientização e homenagens a essa população. Origem do Setembro Azul O Setembro Azul surgiu a partir da luta da Comunidade Surda por seus direitos. Por que azul? A cor azul possui um significado que para muitos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 2868,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-2867",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2867",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=2867",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2867/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 2870,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2867/revisions/2870",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/2868",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=2867",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=2867",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=2867",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8012,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=8012",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "cintesp-br-desenvolvendo-inovacoes-em-tecnologia-assistiva-e-contribuindo-institucionalmente-com-a-ufu-classificada-entre-as-melhores-do-mundo",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-desenvolvendo-inovacoes-em-tecnologia-assistiva-e-contribuindo-institucionalmente-com-a-ufu-classificada-entre-as-melhores-do-mundo/",
        title: {
            rendered:
                "CINTESP.Br desenvolvendo inovações em tecnologia assistiva e contribuindo institucionalmente com a UFU, classificada entre as melhores do mundo",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8013" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8013" class="wp-image-8013" src="https://cintespbr.org/wp-content/uploads/2022/06/Reitor-1024x683.png" alt="" width="1024" height="683" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/06/Reitor-1024x683.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/Reitor-300x200.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/Reitor-768x512.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/Reitor.png 1063w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8013" class="wp-caption-text">Reitor da UFU, Valder Steffen Júnior em evento do CINTESP.Br de Lançamento de inovações em tecnologia assistiva</p></div></p>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8014" style="width: 921px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8014" class="wp-image-8014" src="https://cintespbr.org/wp-content/uploads/2022/06/sergio.png" alt="" width="911" height="683" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/06/sergio.png 944w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/sergio-300x225.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/sergio-768x576.png 768w" sizes="(max-width: 911px) 100vw, 911px" /><p id="caption-attachment-8014" class="wp-caption-text">Pesquisador do CINTESP.Br, Sérgio Vieira em entrevista sobre patente do ergômetro para cadeirante</p></div></p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">O ranking das melhores Universidades do Mundo 2023 (World University Rankings) é uma das classificações que analisam as melhores Universidades no Mundo. A pesquisa que ranqueou a Universidade Federal de Uberlândia (UFU).</p>\n<p style="text-align: justify;">Foram analisadas 2.462 Instituições de Ensino Superior no Mundo e classificadas menos da metade (1.422). A Universidade Federal de Uberlândia aparece entre as 35 Universidades Brasileiras ranqueadas, sendo a 3º de Minas Gerais, considerando apenas Universidades Brasileiras, a UFU aparece em 27º lugar e 1.201 na classificação mundial. A Universidade Federal de Minas Gerais (UFMG) e Universidade Federal de Juiz de Fora (UFJF) foram consideradas as melhores do Estado, na ordem citada.</p>\n<p style="text-align: justify;">A World University Rankings é uma seleta e concorrida lista encabeçada pelo Instituto de Tecnologia de Massachusetts, pela Universidade de Cambridge e pela Universidade Stanford e que desperta olhares e competições em todo o mundo para atrair seus alunos. No Brasil, lideram o ranking a Universidade de São Paulo (USP), Universidade Estadual de Campinas (Unicamp) e Universidade Federal do Rio de Janeiro (UFRJ).</p>\n<p style="text-align: justify;">Para classificar a Instituição de Ensino Superior a Quacquarelli Symonds do Reino Unido, autora da pesquisa, considera oito indicadores: citações científicas, reputação acadêmica; reputação entre empregadores; proporção de docente por aluno; proporção de estudantes estrangeiros; corpo docente internacional; rede internacional de pesquisa; e empregabilidade.</p>\n<p style="text-align: justify;"><strong>Referência Nacional &#8211; Contribuição do CINTESP.Br/UFU</strong></p>\n<p style="text-align: justify;">Considerando o aspecto da pesquisa, inovação e registros de publicação, o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU), se destaca na Universidade Federal de Uberlândia.</p>\n<p style="text-align: justify;">Desde 2019, com financiamentos do Ministério da Ciência, Tecnologia e Inovações (MCTI) e do Ministério Público do Trabalho (MPT/Região Uberlândia), o CINTESP.Br tem sido referência, na UFU, na produção de inovações e geração de patentes, as mais recentes, entregues este ano, foram para um equipamento para prescrição de cadeiras de rodas e outro equipamento, o ergômetro para cadeirantes que pode ser usado em academias e clínicas médicas.</p>\n<p style="text-align: justify;">Vinculado à UFU o CINTESP.Br, trabalha em forma de Rede Colaborativa, com pesquisadores multidisciplinares envolvendo ainda outras Universidades, Clubes de Serviço, empresas brasileiras e intercâmbios de cooperação internacional em Centros de pesquisa consolidados no mundo como o Laboratório de Engenharia Humana e Pesquisa de Pittsburgh e ao U.S. Department of Veterans Affairs nos EUA.</p>\n<p style="text-align: justify;">Com a alta concentração de pesquisadores e elevado número de pedidos de patentes, o CINTESP.Br passou a ser um dos principais parceiros da Agência de Fomento Intelecto, da UFU. Só em 2019, o CINTESP.Br produziu 14 invenções e que tiveram registros de pedido de patente, mais que o dobro do solicitado em 2018.</p>\n<p style="text-align: justify;">Em março deste ano, o Centro de inovações promoveu o Lançamento de inovações em Tecnologia Assistiva (LANCE PcD 2022), evento que oficializou a entrega de 21 produtos de tecnologia assistiva, além de inovações em metodologias e serviços. Um volume inédito no país de equipamentos desenvolvidos e disponibilizados, de uma só vez, por uma Universidade Pública Brasileira. “Nós já conseguimos um grande avanço, basta ver o aumento de registro de patentes e de vermos pesquisadores estimulados retomando projetos para a transferência de tecnologia, como o CINTESP.Br vem fazendo. Agora nosso próximo desafio é estimular o setor empresarial e a criação de startups para termos mais facilidade de promovermos essa transferência de tecnologia para as novas invenções chegarem mais rápido à população”, disse Carlos Henrique de Carvalho Pró-reitor de Pesquisa e Pós-Graduação da UFU, em matéria pelos 15 anos da Agência Intelecto.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text] O ranking das melhores Universidades do Mundo 2023 (World University Rankings) é uma das classificações que analisam as melhores Universidades no Mundo. A pesquisa que ranqueou a Universidade Federal de Uberlândia (UFU). Foram analisadas 2.462 Instituições de Ensino Superior no Mundo e classificadas menos da metade (1.422). A Universidade Federal&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8013,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [56, 62],
        tags: [],
        class_list: [
            "post-8012",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque",
            "category-todas-as-noticias",
            "category-56",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8012",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8012",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8012/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8069,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8012/revisions/8069",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8013",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8012",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8012",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8012",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7984,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=7984",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "cintesp-br-ufu-retoma-as-atividades-presenciais-com-resultados-de-repercussao-nacional-e-internacional",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-ufu-retoma-as-atividades-presenciais-com-resultados-de-repercussao-nacional-e-internacional/",
        title: {
            rendered:
                "CINTESP.Br/UFU retoma as atividades presenciais com resultados de repercussão nacional e internacional",
        },
        content: {
            rendered:
                '<p>&nbsp;</p>\n<p><span style="font-size: 10pt;">Texto: Cristiane de Paula (Ascom CINTESP.Br/UFU)<br />\nRevisão: Juliana Braga (Pesquisadora CINTESP.Br/UFU)</span></p>\n<p style="text-align: justify;">Depois de superar o desafio de não parar, completamente, as atividades de pesquisa em meio a pandemia, o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos, vinculado à Universidade Federal de Uberlândia (CINTESP.Br/UFU) retoma as atividades presenciais nas 4 unidades de pesquisa com saldo positivo e inovando na entrega de produtos.</p>\n<p style="text-align: justify;">A retomada das atividades, depois de 2 anos e meio vem com comemorações: duas patentes conquistadas, o sucesso do evento LANCE PcD 2022 com o lançamento de 21 produtos de Tecnologia Assistiva (TA) e que teve repercussão nacional por meio da transmissão ao vivo e a ação de pesquisadores do CINTESP.Br em um torneio internacional de tênis em cadeira de rodas e a possibilidade de ampliar os projetos atendendo demandas de paratletas do Município de Araguari, que retoma os investimentos no paradesporto.</p>\n<p style="text-align: justify;">Os avanços não param por aí, o cenário para pesquisas ainda contou com a inclusão de um novo espaço, a estrutura esportiva do SESI Gravatás, referência em paratletismo em Minas Gerais. Somando as 4 unidades de trabalho: o Laboratório de Projetos Mecânicos da UFU (LPM), a Arena Sabiazinho com salas para diferentes atividades de pesquisa, e as áreas de esportes do SESI Gravatás e do Praia Clube Uberlândia que possuem paratletas testando os equipamentos em ambiente relevante.</p>\n<p style="text-align: justify;">A criação do CINTESP.Br/UFU no final de 2019, financiado pelo Ministério da Ciência, Tecnologia e Inovações (MCTI), juntamente com o Ministério do Trabalho, regional Uberlândia (MPT/Uberlândia), com gestão do CNPq, aconteceu à frente do primeiro desafio; manter a cidade de Uberlândia na vanguarda em acessibilidade, paradesporto e inovações tecnológicas e seguindo todas as normas de saúde para enfrentar a covid-19, os quase 60 pesquisadores mantiveram os trabalhos em home office até a retomada gradativa de algumas atividades presenciais. <strong><em>“O apoio financeiro do MCTI com gestão do CNPq e, recentemente com o apoio do Ministério Público do Trabalho nos permitiu manter essa organização interna  e incluir na equipe colaboradores bolsistas em um formato profissional, tudo somou para, mesmo em tempo de pandemia, mantermos um certo ritmo dos trabalhos de pesquisa”,</em></strong> disse Cleudmar Araújo, coordenador do CINTESP.Br/UFU.</p>\n<p style="text-align: justify;">Com foco em 2023 o coordenador do CINTESP.Br/UFU destaca o desenvolvimento de novos projetos em Tecnologia Assistiva (TA) que serão lançados no Lance PcD 2023.  São tecnologias na área do esporte, saúde, lazer, vida diária e educação. A área da saúde está desenvolvendo produtos inovadores voltados para doenças raras, <strong><em>“podemos afirmar que no Brasil, somos um dos centros de referência no desenvolvimento de inovações em tecnologia assistiva, principalmente, no esporte paralímpico, e estamos apenas no início”</em></strong>, completa Cleudmar.</p>\n<p style="text-align: justify;"><strong>Conselho Consultivo</strong></p>\n<p style="text-align: justify;">Com o objetivo de auxiliar a coordenação geral do CINTESP.Br, foi criado um “Conselho Consultivo” formado por alguns pesquisadores, “neste caso, este conselho auxiliará a coordenação geral no planejamento das ações de forma mais rápida, ágil e direta e, por este motivo, é composto, neste momento, com poucos pesquisadores”, completa o coordenador do CINTESP.Br/UFU.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; Texto: Cristiane de Paula (Ascom CINTESP.Br/UFU) Revisão: Juliana Braga (Pesquisadora CINTESP.Br/UFU) Depois de superar o desafio de não parar, completamente, as atividades de pesquisa em meio a pandemia, o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos, vinculado à Universidade Federal de Uberlândia (CINTESP.Br/UFU) retoma as atividades presenciais nas 4 unidades de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7986,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-7984",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7984",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7984",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7984/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8062,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7984/revisions/8062",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7986",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7984",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7984",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7984",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6505,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=6505",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "ja-inscreveu-sua-escola-nao-perca-tempo",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ja-inscreveu-sua-escola-nao-perca-tempo/",
        title: {
            rendered: "JÁ INSCREVEU SUA ESCOLA? NÃO PERCA TEMPO!",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]<img loading="lazy" decoding="async" class="alignnone wp-image-6432 size-full" src="https://cintespbr.org/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-21-at-12.45.33.jpeg" alt="" width="768" height="438" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-21-at-12.45.33.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-21-at-12.45.33-300x171.jpeg 300w" sizes="(max-width: 768px) 100vw, 768px" /></p>\n<h4 style="text-align: justify;"> MCTI lança o 1º Desafio &#8220;Ideias Brilhantes-MCTI&#8221; em inovações para Tecnologia Assistiva.</h4>\n<p style="text-align: justify;">Objetivo do Desafio: é que alunos do 6º ao 9º ano do ensino fundamental de todo país desenvolvam seus próprios projetos inovadores na área de tecnologia assistiva.<br />\nInscrições: Em agosto de 2021.</p>\n<p>Saiba mais clicando <a href="https://www.gov.br/mcti/pt-br/acompanhe-o-mcti/noticias/2021/07/ministro-anuncia-hoje-programa-de-incentivo-a-tecnologia-assistiva-para-criancas">AQUI</a>[/vc_column_text][vc_btn title=&#8221;INSCREVA-SE CLICANDO AQUI&#8221; color=&#8221;primary&#8221; align=&#8221;center&#8221; link=&#8221;url:https%3A%2F%2Fwww.sympla.com.br%2F1-desafio-ideias-brilhantes-mcti&#8212;tecnologia-assistiva-para-a-vida-diaria-copia__1292644&#8243;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text]  MCTI lança o 1º Desafio &#8220;Ideias Brilhantes-MCTI&#8221; em inovações para Tecnologia Assistiva. Objetivo do Desafio: é que alunos do 6º ao 9º ano do ensino fundamental de todo país desenvolvam seus próprios projetos inovadores na área de tecnologia assistiva. Inscrições: Em agosto de 2021. Saiba mais clicando AQUI[/vc_column_text][vc_btn title=&#8221;INSCREVA-SE CLICANDO AQUI&#8221; color=&#8221;primary&#8221; align=&#8221;center&#8221; link=&#8221;url:https%3A%2F%2Fwww.sympla.com.br%2F1-desafio-ideias-brilhantes-mcti&#8212;tecnologia-assistiva-para-a-vida-diaria-copia__1292644&#8243;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6432,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 43, 62],
        tags: [],
        class_list: [
            "post-6505",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-mcti",
            "category-todas-as-noticias",
            "category-57",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6505",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6505",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6505/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6507,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6505/revisions/6507",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6432",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6505",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6505",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6505",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6385,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=6385",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "6385",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/6385/",
        title: {
            rendered:
                "Criado o Projeto e Lei que regulamenta a profissão de educação física",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="alignnone wp-image-6386 size-large" src="https://cintespbr.org/wp-content/uploads/2021/07/ImgProjetoLei-1024x681.png" alt="" width="1024" height="681" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/ImgProjetoLei-1024x681.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/ImgProjetoLei-300x200.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/ImgProjetoLei-768x511.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/ImgProjetoLei.png 1390w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p style="margin: 0cm; line-height: 150%; text-align: justify;">Esta semana uma das ações que marcaram foi o envio, ao Congresso Nacional, do Projeto de Lei que regulamenta a profissão de educação física.</p>\n<p style="margin-bottom: 0cm; line-height: 150%; text-align: justify;">O ato, realizado pelo Presidente Jair Bolsonaro aconteceu esta semana (06) em Brasília. São mais de 20 anos de espera por este momento e agora uma das profissões que mais chamaram a atenção neste tempo de pandemia, o profissional de educação física, e de grande relevância para a inclusão de pessoas com deficiência e doenças raras terá, ao ser aprovado, o instrumento legal que dará segurança jurídica para exercer a profissão, e trabalhar com respaldo.</p>\n<p style="margin-bottom: 0cm; line-height: 150%; text-align: justify;">O CINTESP.Br®, vinculado à UFU e apoiado pelo Ministério da Ciência Tecnologia e inovação (MCTI) trabalha em parceria com esse profissional nas pesquisas em favor de inovação em tecnologia assistiva para atender às necessidades de pessoas com deficiência e doenças raras.</p>\n<p>&nbsp;</p>\n<p>Leia a matéria completa clicando <a href="https://www.gov.br/mcti/pt-br/acompanhe-o-mcti/noticias/2021/07/presidente-jair-bolsonaro-assina-projeto-para-regulamentar-a-profissao-de-educacao-fisica">AQUI</a></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Esta semana uma das ações que marcaram foi o envio, ao Congresso Nacional, do Projeto de Lei que regulamenta a profissão de educação física. O ato, realizado pelo Presidente Jair Bolsonaro aconteceu esta semana (06) em Brasília. São mais de 20 anos de espera por este momento e agora uma das profissões que mais chamaram&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6386,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-6385",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6385",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6385",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6385/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6390,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6385/revisions/6390",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6386",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6385",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6385",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6385",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6291,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=6291",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "mcti-e-nasa",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/mcti-e-nasa/",
        title: {
            rendered: "MCTI E NASA",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">Veja o pronunciamento de Bill Nelson, administrador da NASA, dirigido ao Brasil. Especialmente ao Presidente Bolsonaro e ao Ministro Marcos Pontes, pela assinatura, no último dia 15, do acordo de cooperação científica no Programa da NASA , o ARTEMIS, colocando o Brasil como primeiro país da América do Sul, signatário do Programa. Entre os objetivos estão a exploração pacífica da lua e seus arredores com a missão pré estabelecida de enviar pessoas ao planeta Marte, com responsabilidade, transparência e benefício a todos para garantir um ambiente seguro e sustentável.</p>\n<p> [/vc_column_text][vc_video link=&#8221;https://youtu.be/UbLqTA60rbs&#8221;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Veja o pronunciamento de Bill Nelson, administrador da NASA, dirigido ao Brasil. Especialmente ao Presidente Bolsonaro e ao Ministro Marcos Pontes, pela assinatura, no último dia 15, do acordo de cooperação científica no Programa da NASA , o ARTEMIS, colocando o Brasil como primeiro país da América do Sul, signatário do Programa. Entre os&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6295,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-6291",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6291",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6291",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6291/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6294,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6291/revisions/6294",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6295",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6291",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6291",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6291",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6189,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=6189",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "visita-ao-centro-ciencia-viva-em-lisboa-encerra-agenda-oficial-do-mcti-em-portugal",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/visita-ao-centro-ciencia-viva-em-lisboa-encerra-agenda-oficial-do-mcti-em-portugal/",
        title: {
            rendered:
                "Visita ao Centro Ciência Viva, em Lisboa, encerra agenda oficial do MCTI em Portugal",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="wp-image-6190 aligncenter" src="https://cintespbr.org/wp-content/uploads/2021/06/dd96ec02-20d1-446c-8079-5bceadbcb1e3-300x225.jpeg" alt="" width="531" height="398" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/06/dd96ec02-20d1-446c-8079-5bceadbcb1e3-300x225.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/06/dd96ec02-20d1-446c-8079-5bceadbcb1e3.jpeg 768w" sizes="(max-width: 531px) 100vw, 531px" /></p>\n<h3>Espaço de divulgação científica abriga mostras e exposições e faz parte de uma rede de instituições científicas portuguesas</h3>\n<div id="content-core">\n<div id="parent-fieldname-text" class="">\n<div>\n<p style="text-align: justify;">Uma visita ao Pavilhão do Conhecimento no Centro Ciência Viva, em Lisboa, Portugal, marcou o encerramento da missão oficial do ministro da Ciência, Tecnologia e Inovações, astronauta Marcos Pontes, ao país nesta quarta-feira (2). O objetivo da visita é buscar projetos para o lançamento de uma rede de cooperação para a promoção da cultura científica e tecnológica entre os dois países.</p>\n<p style="text-align: justify;">O espaço de divulgação científica abriga mostras e exposições e faz parte de uma rede de instituições científicas portuguesas. O ministro Marcos Pontes elogiou o local e destacou a importância de iniciativas do tipo para atrair crianças e jovens para carreiras científicas no Brasil.</p>\n<p style="text-align: justify;">“É um lugar maravilhoso. Quem gosta de ciência entra aqui e fica maravilhado. É muito bacana. Eu falo no Brasil sobre a importância de motivar jovens e crianças para a ciência.  Nós assinamos na terça um memorando de entendimento com o ministro Manuel Heitor e esperamos ter possibilidades de parcerias”, disse.</p>\n<p style="text-align: justify;">A presidente do Centro Ciência Viva, Rosalia Vargas, falou sobre o desafio de levar ciência para todos os públicos. “Habitualmente, se vê espaços de divulgação científica como espaços dedicados aos mais novos. Na verdade, o nosso lema é ciência para todos. É uma questão de cidadania valorizarmos a cultura científica como instrumento para cidadania plena, para o cidadão ter melhores escolhas, expandir o conhecimento”.</p>\n<p style="text-align: justify;">Já a diretora executiva do Centro Ciência Viva, Ana Noronha, ressaltou o aspecto “mão na massa” do espaço, onde os visitantes podem interagir com os equipamentos. “Este é um espaço em que crianças podem experimentar tudo; fazer experiências com os fenômenos físicos, experimentar, tocar nos objetos”, disse.</p>\n<p style="text-align: justify;">A agenda oficial do ministro Marcos Pontes a Portugal contou também com a assinatura de memorandos de entendimento com o ministro de Ciência, Tecnologia e Ensino Superior de Portugal, Manuel Heitor; a inauguração do cabo submarino de fibra óptica ligando o Brasil à Europa e uma visita à Universidade Nova de Lisboa (UNL).</p>\n</div>\n</div>\n</div>\n<div id="formfield-form-widgets-categoria" class="field z3cformInlineValidation">Fonte: <a href="https://www.gov.br/mcti/">www.gov.br/mcti/</a></div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Espaço de divulgação científica abriga mostras e exposições e faz parte de uma rede de instituições científicas portuguesas Uma visita ao Pavilhão do Conhecimento no Centro Ciência Viva, em Lisboa, Portugal, marcou o encerramento da missão oficial do ministro da Ciência, Tecnologia e Inovações, astronauta Marcos Pontes, ao país nesta quarta-feira (2). O objetivo da visita&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6190,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-6189",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6189",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6189",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6189/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6191,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6189/revisions/6191",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6190",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6189",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6189",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6189",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5879,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=5879",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "sirius-a-maior-e-mais-complexa-infraestrutura-de-pesquisa-do-brasil",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sirius-a-maior-e-mais-complexa-infraestrutura-de-pesquisa-do-brasil/",
        title: {
            rendered:
                "Sirius, a maior e mais complexa infraestrutura de pesquisa do Brasil",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_single_image image=&#8221;5882&#8243; img_size=&#8221;full&#8221;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">Sirius, a maior e mais complexa infraestrutura de pesquisa do Brasil financiada pelo Ministério da Ciência, Tecnologia e Inovações recebe visita do Ministro Marcos Pontes às instalações.</p>\n<p style="text-align: justify;">Veja com riqueza de detalhes, assistindo a cobertura completa da visita do ministro da Ciência, Tecnologia e Inovações, astronauta Marcos Pontes ao Sirius, instalado no Centro Nacional de Pesquisa em Energia e Materiais (CNPEM) em celebração ao Dia Internacional da Luz.</p>\n<p style="text-align: justify;">O Centro Nacional de Pesquisa em Energia e Materiais (CNPEM), organização social vinculada à sua pasta &#8211; MCTI, em Campinas/SP. Projetado e construído por brasileiros, o Sirius é uma das fontes de luz sincrotron mais avançadas do mundo. Financiado pelo MCTI, o mais complexo projeto da ciência brasileira possui em seu núcleo um acelerador de elétrons de última geração, que gera um tipo de luz capaz de revelar a microestrutura de materiais orgânicos e inorgânicos, com impacto em pesquisas de diversas áreas, como saúde, agricultura, materiais avançados, defesa, energia meio ambiente, dentre outras.</p>\n<p style="text-align: justify;">A visita aconteceu hoje pela manhã e teve a cobertura com transmissão online pelo canal do <strong>CNPEM</strong> <a href="https://www.youtube.com/CNPEM">https://www.youtube.com/CNPEM</a> e do <strong>MCTI </strong><a href="https://www.youtube.com/mcti.">https://www.youtube.com/mcti.</a></p>\n<p style="text-align: justify;">Também estiveram presentes na visita ao Sirius, Christiane Gonçalves Corrêa, secretária de Articulação e Promoção da Ciência (SEAPC/MCTI), Diretor Geral do Centro Nacional de Pesquisa em Energia e Materiais (CNPEM/MCTI), Antônio José Roque da Silva, secretário de Pesquisa e Formação Científica do Ministério da Ciência, Tecnologia e Inovações (MCTI), Marcelo Morales, Sérgio Machado da secretaria executiva do MCTI.</p>\n<p style="text-align: justify;">A visita fez parte das comemorações do Dia Internacional da Luz (16), data proclamada pela Unesco, agência da Organização das Nações Unidas para a Educação, a Ciência e a Cultura para divulgar os impactos do conhecimento das propriedades da luz para o avanço científico e tecnológico e para a melhoria das condições da vida em sociedade.</p>\n<p style="text-align: justify;">No período da tarde, ministro Marcos Pontes recebeu o ministro da Saúde, Marcelo Queiroga no campus do CNPEM/MCTI. A visita teve como foco as aplicações do Sirius em pesquisas na área da Saúde. Dr. Queiroga teve a oportunidade de conhecer a linha de luz MANACÁ, a primeira estação de pesquisa do Sirius a ser disponibilizada para a comunidade acadêmica.</p>\n<p style="text-align: justify;">Desde o ano passado, essa linha de luz vem sendo usada, mesmo em fase de comissionamento científico, para análises de proteínas relacionadas ao Sars-Cov-2 e projetos em outras áreas da saúde, desenvolvidos por pesquisadores do CNPEM/MCTI e de diferentes universidades do País.</p>\n<p style="text-align: justify;">As técnicas disponíveis na Manacá têm também aplicações em pesquisas nas áreas de biotecnologia industrial, biorrenováveis, biocombustíveis, biologia vegetal, agricultura, nutrição, dentre outras.</p>\n<p style="text-align: justify;">Sobre o Sirius, a nova fonte de luz síncrotron brasileira, é a maior e mais complexa infraestrutura científica já construída no País. Este equipamento de grande porte usa aceleradores de partículas para produzir um tipo especial de luz, chamada luz síncrotron. Essa luz é utilizada para investigar a composição e a estrutura da matéria em suas mais variadas formas, com aplicações em praticamente todas as áreas do conhecimento. Sirius é uma infraestrutura aberta, à disposição da comunidade científica brasileira e internacional, desenvolvida no Centro Nacional de Pesquisa em Energia e Materiais (CNPEM) – Organização Social supervisionada pelo Ministério da Ciência, Tecnologia e Inovações (MCTI). Sirius é financiado com recursos do MCTI e projetado por pesquisadores e engenheiros do CNPEM/MCTI, em parceria com a indústria nacional. Sirius permitirá que centenas de pesquisas acadêmicas e industriais sejam realizadas anualmente, por milhares de pesquisadores, contribuindo para a solução de grandes desafios científicos e tecnológicos, como novos medicamentos e tratamentos para doenças, novos fertilizantes, espécies vegetais mais resistentes e adaptáveis e novas tecnologias para agricultura, fontes renováveis de energia, entre muitas outras potenciais aplicações, com fortes impactos econômicos e sociais.</p>\n<p style="text-align: justify;">SOBRE O CNPEM/MCTI Ambiente de pesquisa e desenvolvimento sofisticado e efervescente, único no País e presente em poucos polos científicos no mundo, o Centro Nacional de Pesquisa em Energia e Materiais (CNPEM) é uma organização social supervisionada pelo Ministério da Ciência, Tecnologia, Inovações (MCTI). O Centro é constituído por quatro Laboratórios Nacionais e é berço do mais complexo projeto da ciência brasileira – o Sirius – uma das mais avançadas fontes de luz síncrotron do mundo.</p>\n<p style="text-align: justify;">O CNPEM/MCTI reúne equipes multitemáticas altamente especializadas, infraestruturas laboratoriais mundialmente competitivas e abertas à comunidade científica, linhas de pesquisa em áreas estratégicas, projetos inovadores em parcerias com o setor produtivo e ações de treinamento para pesquisadores e estudantes.</p>\n<p style="text-align: justify;">O Centro constitui um ambiente movido pela busca de soluções com impacto nas áreas de saúde, energia, meio ambiente, novos materiais, entre outras. As competências singulares e complementares presentes no CNPEM/MCTI impulsionam pesquisas e desenvolvimentos inovadores nas áreas de luz síncrotron; engenharia de aceleradores; descoberta de novos medicamentos, inclusive a partir de espécies vegetais da biodiversidade brasileira; desenvolvimento de processos bio e nanotecnológicos com foco na produção de materiais avançados para aplicações nos setores químico, de alimentos e bebidas, têxtil, petróleo e gás, defesa e aeroespacial; além de soluções biotecnológicas para o desenvolvimento sustentável de biocombustíveis avançados, bioquímicos e biomateriais.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;5880&#8243; img_size=&#8221;full&#8221;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;5886&#8243; img_size=&#8221;full&#8221;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;5882&#8243; img_size=&#8221;full&#8221;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text] Sirius, a maior e mais complexa infraestrutura de pesquisa do Brasil financiada pelo Ministério da Ciência, Tecnologia e Inovações recebe visita do Ministro Marcos Pontes às instalações. Veja com riqueza de detalhes, assistindo a cobertura completa da visita do ministro da Ciência, Tecnologia e Inovações, astronauta Marcos Pontes ao Sirius, instalado no&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5886,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-5879",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5879",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5879",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5879/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5887,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5879/revisions/5887",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5886",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5879",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5879",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5879",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5790,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=5790",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "popularizacao-da-ciencia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/popularizacao-da-ciencia/",
        title: {
            rendered: "POPULARIZAÇÃO DA CIÊNCIA",
        },
        content: {
            rendered:
                '<p style="text-align: justify;">É importante conhecer os Programas do Ministério da Ciência Tecnologia e Inovação de reconhecimento Nacional e Internacional. Estes programas tem o objetivo de aproximar a Ciência e Tecnologia da população, promovendo eventos que congreguem instituições a fim de realizar atividades de divulgação científica em todo o País.</p>\n<p style="text-align: justify;">O Ministério da Ciência Tecnologia e Inovação promove e apoia diversas iniciativas que oferecem às crianças e jovens na educação, o estímulo para o conhecimento. Dentre suas atuações, destaca-se a Secretaria de Articulação e Promoção da Ciência SEAPC/MCTI, que vem apoiando a ciência, inclusão e acessibilidade na educação.</p>\n<p style="text-align: justify;">A Secretaria oferece apoio aos espaços científico-culturais, instituições de ensino e pesquisa, sociedades científicas, escolas, órgãos governamentais, empresas de base tecnológica e entidades da sociedade civil nas ações que gerem incentivos às crianças e jovens conscientizando da relevância de novos cientistas para desenvolvimento da Ciência, Tecnologia e Inovação no nosso país.</p>\n<p style="text-align: justify;">A SNCT abrange todo o território nacional e, em Brasília, organizada pelo MCTI em parceria com o Governo do Distrito Federal é apresentado ao público o evento âncora com exposições realizadas pelas instituições ligadas à Ciência e Tecnologia do DF instituições convidadas de outras Unidades Federativas.</p>\n<p style="text-align: justify;">O objetivo da SNCT-DF é democratizar o acesso ao conhecimento científico e aproximar a população da ciência, tecnologia e inovação, promovendo e estimulando atividades de divulgação científica no Distrito Federal, proporcionando debates e reflexões.</p>\n<p style="text-align: justify;">O CINTESP.Br® vem participando da SNCT-DF com tecnologia assistiva desenvolvidas com o apoio Governamental do MCTI, essas tecnologias assistivas visam a qualidade de vida das pessoas com deficiência e doenças raras nas áreas da Saúde, Educação, Esporte, Lazer e Vida Diária, desenvolvendo ação socioeducativa para a conscientização da importância da inclusão social e inclusão produtiva de pessoas com deficiência e doenças raras.</p>\n<p style="text-align: justify;">Este projeto é em parceria com a Secretaria de Articulação e Promoção da Ciência – SEAPC/MCTI, conta com a distribuição de livros lúdicos, brinquedos e dobraduras, o projeto envolve também a fabricação de recursos lúdicos pedagógicos sensoriais contemplando as áreas da educação, lazer e esporte, promovendo a Lei de Acessibilidade, um direto de todos.</p>\n<p style="text-align: justify;">A SNCT-DF é uma grande oportunidade para todos participarem com inovações tecnológicas e também para conhecer as ações do Ministério da Ciência Tecnologia e Inovação que vem promovendo e apoiando diversas iniciativas que oferecem na educação o estímulo à formação de novos pesquisadores e cientistas no Brasil, gerando conhecimento e inovações.</p>\n<p style="text-align: justify;">Conheça melhor estes programas do MCTI nesta edição do Programa Ciência e Tecnologia no seu Dia a Dia, apresentado pelo Ministro Marcos Pontes</p>\n<p><iframe loading="lazy" title="Lançamento da Semana Nacional de Ciência e Tecnologia" width="1200" height="675" src="https://www.youtube.com/embed/V3OROVZeJZE?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>É importante conhecer os Programas do Ministério da Ciência Tecnologia e Inovação de reconhecimento Nacional e Internacional. Estes programas tem o objetivo de aproximar a Ciência e Tecnologia da população, promovendo eventos que congreguem instituições a fim de realizar atividades de divulgação científica em todo o País. O Ministério da Ciência Tecnologia e Inovação promove&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5796,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-5790",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5790",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5790",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5790/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5797,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5790/revisions/5797",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5796",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5790",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5790",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5790",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5781,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=5781",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "19-anos-da-lei-de-libras-lei-n-10-436-2002",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/19-anos-da-lei-de-libras-lei-n-10-436-2002/",
        title: {
            rendered: "19 ANOS DA LEI DE LIBRAS (Lei n° 10.436/2002)",
        },
        content: {
            rendered:
                '<p style="text-align: justify;">Instituída pela Lei nº 10.436, de 24 de abril de 2002, a Libras completou 19 anos como língua da Comunidade Surda Brasileira. A Lei 10.436/2002 também reconhece a comunicação pela linguagem de libras como um meio legal de comunicação da comunidade surda do Brasil.</p>\n<p style="text-align: justify;">Este vídeo foi exibido no facebook do Programa Pátria Voluntária em homenagem a essa grande conquista.  Nele estão: a primeira-dama e presidente do Conselho do Programa Pátria Voluntária, Michelle Bolsonaro, a Ministra Damares Alves, (Ministério  da Mulher, da Família e dos Direitos Humanos), o assessor de acessibilidade do Programa Pátria Voluntária, Robson Peixoto, o cooperador técnico da Secretaria de Políticas de Educação Bilingue de surdos, Messias Ramos e a diretora da Secretaria de Políticas de Educação bilingue de Surdos, Crisiane Batti.</p>\n<p><iframe loading="lazy" title="Pátria Voluntária   Videoconferência sobre a Lei de Libras" width="1200" height="675" src="https://www.youtube.com/embed/Cwk4iYDjv1c?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Instituída pela Lei nº 10.436, de 24 de abril de 2002, a Libras completou 19 anos como língua da Comunidade Surda Brasileira. A Lei 10.436/2002 também reconhece a comunicação pela linguagem de libras como um meio legal de comunicação da comunidade surda do Brasil. Este vídeo foi exibido no facebook do Programa Pátria Voluntária em homenagem a&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5782,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-5781",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5781",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5781",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5781/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5785,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5781/revisions/5785",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5782",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5781",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5781",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5781",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5767,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=5767",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "sirius-acelerando-o-futuro-da-ciencia-brasileira",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sirius-acelerando-o-futuro-da-ciencia-brasileira/",
        title: {
            rendered: "SIRIUS: ACELERANDO O FUTURO DA CIÊNCIA BRASILEIRA",
        },
        content: {
            rendered:
                '<h3><strong>Conhece o SIRIUS?</strong></h3>\n<p><strong><em>Ele já tem pela frente o desafio no desenvolvimento de pesquisas para a fabricação de medicamentos e tratamentos para doenças.</em></strong></p>\n<p style="text-align: justify;">O SIRIUS é a maior e mais complexa infraestrutura científica já construída no Brasil à disposição da comunidade científica, o orgulho da nossa Nação. Referência mundial em inovação tecnológica para ajudar no desenvolvimento de pesquisas nas mais diversas áreas, entre elas a da saúde, do meio ambiente, da geração de energia com o que há de mais moderno no mundo e que teve a participação de nossa indústria brasileira desde a de pequeno porte com tecnologia e produção específicas até a de grande porte. A infraestrutura foi desenvolvida no Centro Nacional de Pesquisa em Energia e Materiais (CNPEM) – Organização Social supervisionada pelo Ministério da Ciência, Tecnologia e Inovações (MCTI). Sirius é financiado com recursos do MCTI e projetado por pesquisadores e engenheiros do CNPEM.</p>\n<p style="text-align: justify;">Veja esse vídeo apresentado pelo diretor geral do CNPEM, Antônio José Roque</p>\n<p><iframe loading="lazy" title="SIRIUS" width="1200" height="675" src="https://www.youtube.com/embed/dWreLSMpI-Q?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Conhece o SIRIUS? Ele já tem pela frente o desafio no desenvolvimento de pesquisas para a fabricação de medicamentos e tratamentos para doenças. O SIRIUS é a maior e mais complexa infraestrutura científica já construída no Brasil à disposição da comunidade científica, o orgulho da nossa Nação. Referência mundial em inovação tecnológica para ajudar no&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5770,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 43, 62],
        tags: [],
        class_list: [
            "post-5767",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-mcti",
            "category-todas-as-noticias",
            "category-57",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5767",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5767",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5767/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5769,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5767/revisions/5769",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5770",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5767",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5767",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5767",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5508,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=5508",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "primeira-vacina-brasileira-financiada-pelo-governo-federal-foi-protocolada-na-anvisa-na-quinta-feira-25",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/primeira-vacina-brasileira-financiada-pelo-governo-federal-foi-protocolada-na-anvisa-na-quinta-feira-25/",
        title: {
            rendered:
                "PRIMEIRA VACINA BRASILEIRA FINANCIADA PELO GOVERNO FEDERAL FOI PROTOCOLADA NA ANVISA NA QUINTA-FEIRA (25)",
        },
        content: {
            rendered:
                '<p><div id="attachment_5510" style="width: 706px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5510" class="wp-image-5510 size-full" src="https://cintespbr.org/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-26-at-20.08.45.jpeg" alt="" width="696" height="521" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-26-at-20.08.45.jpeg 696w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-26-at-20.08.45-300x225.jpeg 300w" sizes="(max-width: 696px) 100vw, 696px" /><p id="caption-attachment-5510" class="wp-caption-text">O deputado federal Daniel Freitas esteve, no início da noite desta sexta-feira, com o Ministro da Ciência e Tecnologia Marcos Pontes para falar sobre a primeira vacina brasileira financiada pelo Governo Federal</p></div></p>\n<p><em>Iniciativa fomentada pelo MCTI deu entrada de pedido para início dos testes clínicos em humanos com a vacina MCTI BR</em></p>\n<p style="text-align: justify;">    Na quinta-feira, 25 de março às 13h23, foi protocolado na Agência Nacional de Vigilância Sanitária (Anvisa) o pedido de autorização para testes clínicos fases 1 e 2 da primeira vacina brasileira, financiada pelo Governo Federal, a vacina MCTI BR. Antes mesmo da classificação pela OMS da pandemia de Covid-19, o <a href="https://www.gov.br/mcti/pt-br">Ministério da Ciência, Tecnologia e Inovações (MCTI)</a> criou, em fevereiro de 2020, a RedeVírus MCTI, fórum de assessoramento científico de caráter consultivo, para auxiliar na definição de diretrizes e prioridades no combate ao coronavírus pela pasta.<br />\nA partir do estabelecimento das prioridades foram realizados investimentos em pesquisas que promoveram o sequenciamento do vírus, a produção de testes diagnósticos com tecnologia nacional, o reposicionamento de fármacos e o desenvolvimento de vacinas contra a doença, bem como estudos sobre os impactos econômicos e sociais da pandemia. Neste contexto surgiu a primeira vacina totalmente desenvolvida no Brasil pelo Governo Federal que conta com o financiamento do Ministério da Ciência, Tecnologia e Inovações (MCTI), por meio de contratação de grupo de pesquisa.<br />\nOs resultados dos estudos não-clínicos (toxicidade e imunogenicidade) obtidos até o momento demonstram qualidade e competitividade para ser um sucesso nacional e global no controle da Covid-19. A vacina demonstrou capacidade de ativar todo o sistema imunológico – imunidade humoral, celular e inata, induzir memória imunológica e proteção de longo prazo.<br />\nA vacina, que é financiada pelo MCTI e está dentro das estratégias estipuladas pela RedeVírus MCTI, é fruto do financiamento da pesquisa coordenada pelo pesquisador Célio Lopes Silva em parceria com a empresa brasileira Farmacore Biotecnologia e a PDS Biotechnology Corporation.</p>\n<p>&nbsp;</p>\n<p><img loading="lazy" decoding="async" class=" wp-image-5511 aligncenter" src="https://cintespbr.org/wp-content/uploads/2021/03/Sem-titulo-1-1-300x211.png" alt="" width="405" height="285" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Sem-titulo-1-1-300x211.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Sem-titulo-1-1-1024x719.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Sem-titulo-1-1-768x539.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Sem-titulo-1-1-1536x1079.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Sem-titulo-1-1-2048x1438.png 2048w" sizes="(max-width: 405px) 100vw, 405px" /></p>\n<p style="text-align: left;"><strong>Recursos</strong><br />\nCom a aprovação também na quinta-feira (25) pelo Congresso Nacional do Orçamento de 2021, o MCTI tem garantidos R$ 200 milhões para o financiamento de estudos clínicos como continuidade do desenvolvimento de vacinas brasileiras.</p>\n<p style="text-align: justify;"><strong>Protocolo na Anvisa</strong></p>\n<p style="text-align: justify;">O imunizante tem como estratégia uma proteína recombinante do próprio SARS-CoV-2, tendo como carreador a nanopartícula da plataforma Versamune®&#xfe0f;, da PDS Biotech. A empresa já apresentou à Anvisa dados pré-clínicos promissores e robustos em testes já realizados em roedores com a proteína S1 associada à plataforma vacinal.<br />\nO número de protocolo na Anvisa é 25352692134202117 e o número do processo é 25351238531202157. O peticionamento foi realizado pela CEO da Farmacore, Helena Faccioli. Segundo informações das empresas, serão usados vários locais de pesquisa e desenvolvimento nos Estados Unidos e no Brasil para progredir no desenvolvimento clínico da vacina. A Farmacore liderará os esforços regulatórios e de ensaios clínicos no Brasil, enquanto a PDS Biotech continuará a contribuir com conhecimento científico e suporte operacional.</p>\n<p>&nbsp;</p>\n<p><strong>Informações à imprensa</strong><br />\nMinistério da Ciência, Tecnologia e Inovações (MCTI)<br />\nCoordenação-Geral de Comunicação em C&amp;T – CGCO<br />\nChristiane Corrêa – Secretária de Articulação e Popularização da Ciência<br />\n(11) 98181-9983<br />\nIvan Bicudo – Atendimento à imprensa<br />\n(61) 98164-9919</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Iniciativa fomentada pelo MCTI deu entrada de pedido para início dos testes clínicos em humanos com a vacina MCTI BR     Na quinta-feira, 25 de março às 13h23, foi protocolado na Agência Nacional de Vigilância Sanitária (Anvisa) o pedido de autorização para testes clínicos fases 1 e 2 da primeira vacina brasileira, financiada pelo&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5510,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [62, 46],
        tags: [],
        class_list: [
            "post-5508",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-todas-as-noticias",
            "category-ultimas-noticias",
            "category-62",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5508",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5508",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5508/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5514,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5508/revisions/5514",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5510",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5508",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5508",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5508",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5457,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=5457",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "fundo-nacional-de-desenvolvimento-cientifico-e-tecnologico-fndct",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/fundo-nacional-de-desenvolvimento-cientifico-e-tecnologico-fndct/",
        title: {
            rendered:
                "Fundo Nacional de Desenvolvimento Científico e Tecnológico FNDCT.",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="alignnone wp-image-5459 size-large" src="https://cintespbr.org/wp-content/uploads/2021/03/Destacada-3-1024x703.png" alt="" width="1024" height="703" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Destacada-3-1024x703.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Destacada-3-300x206.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Destacada-3-768x527.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Destacada-3.png 1140w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p style="text-align: left;">    Aprovado nesta quarta-feira (17), pelo Congresso Nacional a liberação de recursos para o Fundo Nacional de Desenvolvimento Científico e Tecnológico já havia sido aprovado nas Casas Legislativas. A liberação de mais investimentos poderá ser feita após o Congresso rejeitar o veto sobre descontingenciamento do <strong>FNDCT</strong>.</p>\n<p style="text-align: justify;">Com a aprovação do Congresso Nacional, o Governo Federal por meio do Ministério da Ciência Tecnologia e Inovação poderá garantir os investimentos, com retorno rápido na pesquisa, projetos, pesquisadores, cientistas, institutos e universidades que desenvolvem projetos. Os recursos também poderão ser investidos em financiamentos e apoio às iniciativas de nossas empresas nas mais diversas áreas, em especial, em soluções tecnológicas para produtos, metodologias e serviços para o combate à pandemia.</p>\n<p style="text-align: left;">A votação no Congresso foi considerada, pelo Ministro Marcos Pontes, um importante passo em favor do avanço no desenvolvimento das pesquisas brasileiras. “É uma data importante para a ciência, tecnologia e inovações do país, pois com o apoio do Congresso Nacional será possível impulsionar diversas políticas públicas estratégicas para o país, fomentando a pesquisa, projetos, pesquisadores, cientistas, institutos e universidades que desenvolvem projetos e, importante também, financiar e apoiar as iniciativas de nossas empresas nas mais diversas áreas, em especial, em soluções tecnológicas para produtos, metodologias e serviços para o combate à pandemia.”</p>\n<p style="text-align: justify;"><strong> </strong><strong>Votação com 457 votos favoráveis</strong></p>\n<p style="text-align: justify;">Os parlamentares optaram por derrubar o veto que tratava do dispositivo que impedia o governo federal de alocar os recursos na reserva de contingência, o que na prática, inviabilizava o uso dos recursos do FNDCT no financiamento de programas e projetos prioritários de desenvolvimento científico e tecnológico.</p>\n<p style="text-align: justify;">Na tramitação no Senado Federal, o Projeto de Lei Complementar n. 135 de 2020, de autoria do Senador Izalci Lucas (PSDB/DF), obteve 71 votos favoráveis no Plenário. Na Câmara dos Deputados, a proposição contou 385 votos favoráveis pelo Plenário. Após a tramitação e a aprovação nas Casas Legislativas, a Lei Complementar n. 177/2021 teve dispositivos vetados pela Presidência da República, tendo que seguir para análise do Congresso Nacional (deputados e senadores).</p>\n<p><em><strong>Fonte</strong>: site MCTI</em></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>    Aprovado nesta quarta-feira (17), pelo Congresso Nacional a liberação de recursos para o Fundo Nacional de Desenvolvimento Científico e Tecnológico já havia sido aprovado nas Casas Legislativas. A liberação de mais investimentos poderá ser feita após o Congresso rejeitar o veto sobre descontingenciamento do FNDCT. Com a aprovação do Congresso Nacional, o Governo&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5459,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [62, 46],
        tags: [],
        class_list: [
            "post-5457",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-todas-as-noticias",
            "category-ultimas-noticias",
            "category-62",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5457",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5457",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5457/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5462,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5457/revisions/5462",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5459",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5457",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5457",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5457",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5430,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=5430",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "o-brasil-unido-por-uma-escola-inclusiva",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/o-brasil-unido-por-uma-escola-inclusiva/",
        title: {
            rendered: "O BRASIL UNIDO POR UMA ESCOLA INCLUSIVA",
        },
        content: {
            rendered:
                '<h3><strong><img loading="lazy" decoding="async" class="aligncenter wp-image-4786 size-large" src="https://cintespbr.org/wp-content/uploads/2020/12/WhatsApp-Image-2020-12-12-at-19.11.16-1-1024x768.jpeg" alt="" width="1024" height="768" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/12/WhatsApp-Image-2020-12-12-at-19.11.16-1-1024x768.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/12/WhatsApp-Image-2020-12-12-at-19.11.16-1-300x225.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/12/WhatsApp-Image-2020-12-12-at-19.11.16-1-768x576.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/12/WhatsApp-Image-2020-12-12-at-19.11.16-1.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></strong></h3>\n<h4><strong>ACESSO À SALA DE AULA A ESTÍMULOS PARA NINGUÉM FICAR FORA DA ESCOLA E PROMOVER A IGUALDADE DE DIREITOS.</strong></h4>\n<p style="text-align: justify;">   A Escola é a grande aliada para inclusão social e na formação de uma sociedade democrática, cada dia mais consciente e conhecedora das ferramentas que promovem a inclusão.</p>\n<p style="text-align: justify;">Todos acreditam que o caminho para construir uma Escola Inclusiva e acessível ao alcance de todos e de forma igualitária, pode ser uma longa e difícil trajetória. Porém, ano a ano, os obstáculos vêm sendo vencidos e as dificuldades superadas Uma das mais importantes ferramentas acontece por meio da “<strong>educação inclusiva</strong>” que promove condições de igualdade de ensino e aprendizado das pessoas com deficiência e doenças raras estimulando a socialização a inclusão social e a inclusão produtiva.</p>\n<p style="text-align: justify;">Neste sentido as escolas que promovem a educação inclusiva como metodologia pedagógica, tornam-se importantes ambientes para contribuir com o aprendizado e combate ao analfabetismo. A metodologia empregada é voltada para a formação completa e livre de preconceitos que reconhece as diferenças e dá a elas seu direito de igualdade.</p>\n<p style="text-align: justify;">Em Uberlândia foi criado o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br<sup>®</sup>) em consonância com a Portaria SECIS/MCTI nº 39, de 28.06.2012 instituído pelo Plano Nacional dos Direitos da Pessoa com Deficiência &#8211; Plano Viver sem Limite, reconhecido institucionalmente no âmbito da Política Nacional de Ciência, Tecnologia e Inovação, vinculado ao <a href="https://www.gov.br/mcti/pt-br">Ministério de Ciências Tecnologias e Inovações – MCTI</a>,</p>\n<p style="text-align: justify;">O CINTESP.Br<sup>®</sup> apoiado pela iniciativa do MCTI reconhecendo a importância e necessidade de utilizar ciência, tecnologia, inovação e empreendedorismo para desenvolver tecnologia assistiva aplicada a qualidade de vida às pessoas com deficiência, pessoas com mobilidade reduzida e pessoas com doenças raras e, principalmente, melhorar a inclusão social e a inclusão produtiva, criarão o CENTRO NACIONAL DE TECNOLOGIAS PARA PESSOAS COM DEFICIÊNCIA E DOENÇAS RARAS (CNT), na cidade de Uberlândia/MG, apoiado pela <a href="http://www.ufu.br/">Universidade Federal de Uberlândia (UFU)</a>, o <a href="https://www.algar.com.br/">Grupo Algar Telecom S.A</a>., o <a href="https://www.cpb.org.br/">Comitê Paralímpico Brasileiro (CPB)</a>, buscando o desenvolvimento de uma infraestrutura baseada em rede de colaboradores, pesquisadores e laboratórios envolvidos com o tema TECNOLOGIAS ASSISTIVAS APLICADAS PARA A SAÚDE, EDUCAÇÃO, ESPORTES, LAZER E VIDA DIÁRIA.</p>\n<p style="text-align: justify;">O CNT/CINTESP.Br<sup>®</sup> é mais uma ferramenta do MCTI para contribuir com a educação inclusiva, considerando a educação um fator fundamental para o desenvolvimento de uma criança, jovem, adulto e idoso refletindo em todo segmento como na habitação, saúde, qualidade e expectativa de vida o CNT coloca como foco na área da Educação as pesquisas de apoio à área pedagógica inclusiva e projetos que dão à criança com deficiência as melhores condições de ensino e aprendizagem. Entre os tipos de projetos desenvolvidos pelo CNT estão: dispositivos, protótipos, materiais, processos e métodos. Os projetos são desenvolvidos por equipes multidisciplinares de pesquisadores com o foco na promoção e inclusão afim de ampliar as ferramentas de acessibilidade que atendam o público com deficiência e doenças raras desde a criança ao jovem, adulto e idoso.</p>\n<p style="text-align: justify;">Comunicação acessível para a promoção da inclusão na a educação, é uma das ferramentas desenvolvidas pelos pesquisadores do CNT, e neste sentido está sendo desenvolvido um glossário para pessoa surdocega. O Glossário de surdocegueira lançado em 2020, criado pelo Projeto Escuridão &amp; Silêncio – E&amp;S em parceria com o CINTESP.Br<sup>®</sup> e Lara Gontijo de Castro Souza, Idealizadora do Glossário, uma referência nacional de forma gratuita com acesso à todas às pessoas que será alimentado com novos sinais em libras por um grupo de surdocegos de todo Brasil, sendo disponibilizado na plataforma do site do CINTESP.Br<sup>®</sup> em português, inglês e francês. Esta ferramenta de inclusão, o glossário de Surdocegueira é bilíngue e será catalogado em Língua Brasileira de Sinais – Libras e Língua Portuguesa para pessoas surdocegas ou com surdocegueira.</p>\n<p>&nbsp;</p>\n<p>Quer saber mais sobre o projeto do glossário? Entre no link <a href="https://cintespbr.org/?page_id=4485">https://cintespbr.org/?page_id=4485</a></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>ACESSO À SALA DE AULA A ESTÍMULOS PARA NINGUÉM FICAR FORA DA ESCOLA E PROMOVER A IGUALDADE DE DIREITOS.    A Escola é a grande aliada para inclusão social e na formação de uma sociedade democrática, cada dia mais consciente e conhecedora das ferramentas que promovem a inclusão. Todos acreditam que o caminho para construir&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4786,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-5430",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5430",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5430",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5430/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5452,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5430/revisions/5452",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4786",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5430",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5430",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5430",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5389,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=5389",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "uma-nova-acao-do-mcti-para-incentivar-o-desenvolvimento-de-tecnologia-assistiva-para-pessoas-com-deficiencia-e-doencas-raras-no-brasil",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/uma-nova-acao-do-mcti-para-incentivar-o-desenvolvimento-de-tecnologia-assistiva-para-pessoas-com-deficiencia-e-doencas-raras-no-brasil/",
        title: {
            rendered:
                "Uma nova ação do MCTI para incentivar o desenvolvimento de Tecnologia assistiva para pessoas com deficiência e doenças raras no Brasil",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]<img loading="lazy" decoding="async" class="wp-image-5390 aligncenter" src="https://cintespbr.org/wp-content/uploads/2021/03/62295206-b41c-4c08-8f92-3a1e87774dee.jpeg" alt="" width="667" height="444" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/62295206-b41c-4c08-8f92-3a1e87774dee.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/62295206-b41c-4c08-8f92-3a1e87774dee-300x200.jpeg 300w" sizes="(max-width: 667px) 100vw, 667px" /></p>\n<h4 style="text-align: left;">Assinado o Decreto que agilizará a produção de pesquisas e fomentará o empreendedorismo na área de tecnologia assistiva</h4>\n<p><em>Assessoria de comunicação CINTESP.Br®&#xfe0f;</em></p>\n<p style="text-align: justify;">A assinatura do decreto que regulamenta o Plano Nacional de Tecnologia Assistiva foi realizada ontem (11/03), com a participação do Ministro da Ciência Tecnologia e Inovação (MCTI), Marcos Pontes, trata se de um dos passos mais importantes para o atendimento à população com deficiência e doenças raras, e deve impulsionar as pesquisas no Brasil. Um dos centros de pesquisa estará em Uberlândia, o Centro de Tecnologias para Pessoas com Deficiência e Doenças Raras (CNT), criado no final do ano passado pelo MCTI e que será implantado ainda em 2021.</p>\n<p style="text-align: justify;">Este Apoio do Governo Federal facilitará o acesso a crédito especializado, para aquisição de tecnologia assistiva e prevê o desenvolvimento de um plano de medidas específicas a serem implementadas pelo poder público com a renovação a cada 4 anos.  A medida, já estava prevista no Estatuto da Pessoa com Deficiência poderá beneficiar cerca de 46 milhões de pessoas, dados do IBGE censo 2010.</p>\n<p style="text-align: justify;">Os impactos do Decreto fomentarão as pesquisas no Brasil que poderão ser aceleradas ampliando a produção e eliminando as barreiras existentes no acesso à tecnologia assistiva. Com o Decreto o fomento à pesquisa ganha força bem como facilitará a aquisição e a implementação de novos processos e produtos na área da Tecnologia Assistiva, por meio de concessão de linhas de crédito.</p>\n<p style="text-align: justify;">O MCTI no âmbito da Política Nacional de Ciência, Tecnologia e Inovação já vem fomentando pesquisas para o desenvolvimento de inovações tecnológicas para pessoas com deficiência e doenças raras, estas tecnologias assistiva vem sendo desenvolvidas pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos &#8211; CINTESP.Br, uma parceria publicada no diário Oficial em, 19 de novembro de 2019, vinculado ao Ministério de Ciências Tecnologias e Inovações – MCTI.  A parceria fortaleceu as redes de pesquisas no campo da tecnologia assistiva são direcionadas as pessoas com Deficiência, com doença rara e comunidade em geral.</p>\n<p style="text-align: justify;">De acordo com a Coordenadora Geral do CINTESP.Br®&#xfe0f;, Daniela Moura Yoshida, o Decreto será uma ferramenta importante apoiada pelo MCTI, para auxiliar a transferência de tecnologia, desenvolvidas pelas redes colaborativas de Centros e Núcleos de pesquisas que já atuam no desenvolvimento de tecnologia assistiva assim como o CINTESP.Br®&#xfe0f; que desde 28.06.2012 instituído pelo Plano Nacional dos Direitos da Pessoa com Deficiência &#8211; Plano Viver sem Limite, pelo Decreto Nº 7.612/2011, vem desenvolvendo tecnologia assistiva visando a transferência de forma que seja acessível a sociedade em geral, que venha de fato assistir a pessoas com deficiência e doenças raras.</p>\n<p><em>Fonte: MCTI   https://www.gov.br/mcti/pt-br</em>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Assinado o Decreto que agilizará a produção de pesquisas e fomentará o empreendedorismo na área de tecnologia assistiva Assessoria de comunicação CINTESP.Br®&#xfe0f; A assinatura do decreto que regulamenta o Plano Nacional de Tecnologia Assistiva foi realizada ontem (11/03), com a participação do Ministro da Ciência Tecnologia e Inovação (MCTI), Marcos Pontes, trata se de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5390,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-5389",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5389",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5389",
                },
            ],
            "version-history": [
                {
                    count: 10,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5389/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5401,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5389/revisions/5401",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5390",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5389",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5389",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5389",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5324,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=5324",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "estadio-parque-do-sabia-recebe-nova-identidade-visual",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/estadio-parque-do-sabia-recebe-nova-identidade-visual/",
        title: {
            rendered: "Estádio Parque do Sabiá recebe nova identidade visual",
        },
        content: {
            rendered:
                '<h3>NO TOTAL, SÃO 156 ADESIVOS E 85 PLACAS EM PVC, COM UM LAYOUT MODERNO E PADRONIZADO</h3>\n<div class="elementor-element elementor-element-8c17f03 elementor-widget elementor-widget-theme-post-featured-image elementor-widget-image" data-id="8c17f03" data-element_type="widget" data-widget_type="theme-post-featured-image.default">\n<div class="elementor-widget-container">\n<div class="elementor-image">\n<figure class="wp-caption"><img loading="lazy" decoding="async" class="attachment-full size-full alignleft" src="https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Est%C3%A1dio-Parque-do-Sabi%C3%A1_3.jpg" sizes="(max-width: 1280px) 100vw, 1280px" srcset="https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Estádio-Parque-do-Sabiá_3.jpg 1280w, https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Estádio-Parque-do-Sabiá_3-300x225.jpg 300w, https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Estádio-Parque-do-Sabiá_3-768x576.jpg 768w, https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Estádio-Parque-do-Sabiá_3-1024x768.jpg 1024w" alt="" width="1280" height="960" /><figcaption class="widget-image-caption wp-caption-text"></figcaption></figure>\n</div>\n</div>\n</div>\n<div class="elementor-element elementor-element-27b24a0 elementor-widget elementor-widget-theme-post-content" data-id="27b24a0" data-element_type="widget" data-widget_type="theme-post-content.default">\n<div class="elementor-widget-container">\n<p style="text-align: justify;">A Prefeitura de Uberlândia, por meio da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel), concluiu a implantação de uma nova identidade visual no Estádio Parque do Sabiá. No total, são 156 adesivos e 85 placas em PVC, com um layout moderno e padronizado, em substituição às antigas que já estavam desgastadas pelo tempo. O objetivo da renovação do material é orientar o público assim que o estádio for liberado para os torcedores, ao fim da pandemia da Covid-19.</p>\n<p style="text-align: justify;">A nova comunicação visual abrange todos os setores do Estádio Parque do Sabiá, como arquibancadas, hall, cadeiras cativas e tribuna de honra, além de indicações de acessibilidade, saídas, entradas e sanitários.</p>\n<p style="text-align: justify;">Também foi feita a plotagem da cobertura dos bancos de reservas, que receberam adesivos com as logomarcas da Prefeitura de Uberlândia e da Futel. “Tudo foi pensado para orientar ao público da maneira mais clara possível, para que todos possam se sentir seguros e à vontade em um dos principais espaços esportivos do país”, disse o diretor geral da Futel, Edson Zanatta.</p>\n<p style="text-align: justify;"><strong>Obras</strong></p>\n<figure class="wp-block-image"><img decoding="async" class="wp-image-61292" src="https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Est%C3%A1dio-Parque-do-Sabi%C3%A1-1024x768.jpg" sizes="(max-width: 1024px) 100vw, 1024px" srcset="https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Estádio-Parque-do-Sabiá-1024x768.jpg 1024w, https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Estádio-Parque-do-Sabiá-300x225.jpg 300w, https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Estádio-Parque-do-Sabiá-768x576.jpg 768w, https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Estádio-Parque-do-Sabiá.jpg 1280w" alt="Estádio Parque do Sabiá recebe nova identidade visual 1" /></figure>\n<p style="text-align: justify;">A implantação da nova comunicação visual faz parte dos serviços de manutenção e revitalização que estão em fase de conclusão. Já foram feitos serviços como reforma do gramado, pintura interna do anel superior, que contorna todo o estádio; a pintura do anel que contorna o fosso; a pintura das estruturas metálicas que dividem as cadeiras cativas e numeradas da arquibancada especial; a pintura do piso dos banheiros; a limpeza de todas as arquibancadas de cimento; a pintura do meio fio (em volta ao gramado) e a recuperação e modernização do placar eletrônico.</p>\n<p style="text-align: justify;">Além disso, foram instalados 53 blocos de concreto nos degraus de acesso ao camarote, à tribuna de honra e às cabines de imprensa, colocados para tornar mais confortável para os jornalistas e torcedores.</p>\n<p style="text-align: justify;">Ainda serão realizados os serviços de limpeza e pintura da fachada principal, pintura do piso do saguão principal e das escadarias que dão acesso às cadeiras cativas e pintura das telas protetoras do bar principal.</p>\n</div>\n<p>Fonte: Futel</p>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>NO TOTAL, SÃO 156 ADESIVOS E 85 PLACAS EM PVC, COM UM LAYOUT MODERNO E PADRONIZADO A Prefeitura de Uberlândia, por meio da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel), concluiu a implantação de uma nova identidade visual no Estádio Parque do Sabiá. No total, são 156 adesivos e 85 placas em PVC, com&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5325,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [62],
        tags: [],
        class_list: [
            "post-5324",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-todas-as-noticias",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5324",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5324",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5324/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5326,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5324/revisions/5326",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5325",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5324",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5324",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5324",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5321,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=5321",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "mcti-participa-de-missao-a-israel-para-cooperacao-em-cti-no-combate-a-covid-19",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/mcti-participa-de-missao-a-israel-para-cooperacao-em-cti-no-combate-a-covid-19/",
        title: {
            rendered:
                "MCTI participa de missão a Israel para cooperação em CT&#038;I no combate à Covid-19",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-5322 size-full" src="https://cintespbr.org/wp-content/uploads/2021/03/440ab057-565b-4a99-8386-50e1188e7535.jpeg" alt="" width="768" height="511" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/440ab057-565b-4a99-8386-50e1188e7535.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/440ab057-565b-4a99-8386-50e1188e7535-300x200.jpeg 300w" sizes="(max-width: 768px) 100vw, 768px" /></p>\n<p style="text-align: justify;">O presidente Jair Bolsonaro <a class="external-link" title="" href="https://www.facebook.com/jairmessias.bolsonaro/videos/770618993885218" target="_blank" rel="noopener" data-tippreview-enabled="false" data-tippreview-image="" data-tippreview-title="">apresentou em vídeo</a> a comitiva brasileira chefiada pelo ministro das Relações Exteriores, Ernesto Araújo, que partiu para Israel neste sábado (6). O objetivo da missão é o intercâmbio de informações sobre a COVID-19, além da assinatura de acordos de cooperação entre os dois países.</p>\n<p style="text-align: justify;">O secretário de Pesquisa e Formação Científica do Ministério da Ciência, Tecnologia e Inovações (MCTI), Marcelo Morales, destacou o trabalho da RedeVírus MCTI e a colaboração com Israel em ciência, tecnologia e saúde. “O objetivo desta missão é levar tudo que estamos desenvolvendo no país para fazer esse acordo de cooperação em várias áreas do conhecimento, inclusive de medicamentos e de vacinas que estamos desenvolvendo na RedeVírus do Ministério da Ciência, Tecnologia e Inovações e no Ministério da Saúde. Esse acordo de cooperação vai ser muito importante para o Brasil porque integra as duas nações para o desenvolvimento de drogas e vacinas.”</p>\n<p style="text-align: justify;">Ao ser perguntado pelo presidente Bolsonaro sobre a vacina brasileira, Morales ainda completou: “Presidente, a vacina que está sendo desenvolvida no Brasil são 15 vacinas diferentes e 3 chegaram a um grau de maturação que pode iniciar no próximo mês os ensaios clínicos em pacientes, uma delas já deu entrada na ANVISA. Qual a vantagem disso? Se tivermos uma mutação no Brasil, nós dominamos a tecnologia e podemos mudar rapidamente a vacina, adaptando a nova mutação. Isso é uma questão de soberania nacional.”</p>\n<p style="text-align: justify;">Integram também a comitiva: O secretário de Ciência, Tecnologia e Inovação e Insumos Estratégicos em Saúde (SCTIE) do Ministério da Saúde, Hélio Angotti Neto, o Assessor Especial para Assuntos Internacionais do Palácio do Planalto, Filipe Martins, Eduardo Bolsonaro, Presidente da Comissão de Relações Exteriores e Defesa Nacional na Câmara dos Deputados e Helio Lopes, Integrante da Frente Parlamentar Mista da Saúde na Câmara dos Deputados.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O presidente Jair Bolsonaro apresentou em vídeo a comitiva brasileira chefiada pelo ministro das Relações Exteriores, Ernesto Araújo, que partiu para Israel neste sábado (6). O objetivo da missão é o intercâmbio de informações sobre a COVID-19, além da assinatura de acordos de cooperação entre os dois países. O secretário de Pesquisa e Formação Científica do Ministério&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5322,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-5321",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5321",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5321",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5321/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5323,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5321/revisions/5323",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5322",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5321",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5321",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5321",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5086,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=5086",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "rede-de-pesquisadores-do-mcti-e-responsavel-pelo-sequenciamento-de-virus-no-brasil",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/rede-de-pesquisadores-do-mcti-e-responsavel-pelo-sequenciamento-de-virus-no-brasil/",
        title: {
            rendered:
                "REDE DE PESQUISADORES DO MCTI É RESPONSÁVEL PELO SEQUENCIAMENTO DE VIRUS NO BRASIL",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="alignleft wp-image-5087 size-full" src="https://cintespbr.org/wp-content/uploads/2021/02/7ecayJL0_400x400.jpg" alt="" width="400" height="400" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/02/7ecayJL0_400x400.jpg 400w, https://cintespbr.institucional.ws/wp-content/uploads/2021/02/7ecayJL0_400x400-300x300.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/02/7ecayJL0_400x400-150x150.jpg 150w" sizes="(max-width: 400px) 100vw, 400px" />A Redevírus MCTI, criada pelo Ministério da Ciência, Tecnologia e Inovações (MCTI) em Fevereiro de 2020, mesmo antes da pandemia se estabelecer no Brasil, é a principal ferramenta de sequenciamento genético do vírus no Brasil.</p>\n<p>A RedeVírus MCTI é composta por cientistas e especialistas em viroses emergentes. Esse grupo permanente de especialistas dá diretrizes para o MCTI na estratégia de enfrentamento pela ciência do Covid no país.</p>\n<p>Além disso o MCTI financia as ações dos cientistas da RedeVírus MCTI em pesquisas e desenvolvimento de soluções para prevenção, testes diagnósticos nacionais, tratamentos, sequenciamento genético, patogênese, vacinas e infraestrutura para o combate ao COVID.</p>\n<p>A Rede CoronaOmica-BR MCTI é a parte da Redevirus MCTI responsável pelo sequenciamento genético e acompanhamento e alertas de Mutações em todos os Estados do Brasil.</p>\n<p>A RedeVírus MCTI fornece informações para cientistas no Brasil e no exterior, assim como informações para as políticas públicas do Ministério da Saude (MS).</p>\n<p>É um serviço do Ministério da Ciência, Tecnologia e Inovações para o MS, para a segurança dos brasileiros e para vencermos juntos o Covid-19 no planeta.</p>\n<p>Muito orgulho dos nossos cientistas!!</p>\n<p>Acredite na Ciência Brasileira.<br />\nAjude a divulgar o trabalho da RedeVírus MCTI!</p>\n<p>Grande abraço espacial</p>\n<p>Ministro Marcos Pontes</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>A Redevírus MCTI, criada pelo Ministério da Ciência, Tecnologia e Inovações (MCTI) em Fevereiro de 2020, mesmo antes da pandemia se estabelecer no Brasil, é a principal ferramenta de sequenciamento genético do vírus no Brasil. A RedeVírus MCTI é composta por cientistas e especialistas em viroses emergentes. Esse grupo permanente de especialistas dá diretrizes para&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5087,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-5086",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5086",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5086",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5086/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5088,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5086/revisions/5088",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5087",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5086",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5086",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5086",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4946,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=4946",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "brasil-e-japao-assinam-acordo-de-cooperacao-em-tecnologias-para-grafeno-e-niobio",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/brasil-e-japao-assinam-acordo-de-cooperacao-em-tecnologias-para-grafeno-e-niobio/",
        title: {
            rendered:
                "Brasil e Japão assinam acordo de cooperação em tecnologias para grafeno e nióbio",
        },
        content: {
            rendered:
                '<div id="viewlet-above-content-body">\n<div id="media">\n<p><img loading="lazy" decoding="async" src="https://www.gov.br/mcti/pt-br/acompanhe-o-mcti/noticias/2021/01/brasil-e-japao-assinam-acordo-de-cooperacao-em-tecnologias-para-grafeno-e-niobio/50814552281_a31e66fe30_k.jpg/@@images/812786e7-26ab-4339-a963-730df0be2af1.jpeg" alt="50814552281_a31e66fe30_k.jpg" width="768" height="432" /></p>\n<p class="discreet">Foto: Odjair Baena / ASCOM MCTI</p>\n</div>\n</div>\n<div id="content-core">\n<div id="parent-fieldname-text" class="">\n<div>\n<p>Em cerimônia realizada no Palácio Itamaraty, em Brasília, nesta sexta-feira (8), Brasil e Japão assinaram o Memorando de Cooperação entre os Governos Brasileiro e Japonês no Campo de Tecnologias Relacionadas à Produção e ao Uso de Nióbio e Grafeno. O objetivo do documento bilateral é aprofundar o entendimento mútuo para explorar a cooperação na cadeia de valor de produtos que usam nióbio ou grafeno e propiciar uma cooperação mais estruturada no futuro, incluindo potenciais projetos conjuntos.</p>\n<p>A iniciativa é resultado de tratativas iniciadas pelo presidente Jair Bolsonaro, que em 2019 manifestou interesse na cooperação ao então primeiro-ministro japonês, Shinzo Abe, durante o Fórum Econômico de Davos, e de reunião entre o ministro da Ciência, Tecnologia e Inovações, Marcos Pontes e o embaixador do Japão no Brasil, Akira Yamada em 2019. Assinaram o memorando o ministro das Relações Exteriores, Ernesto Araújo, e o ministro de Negócios Estrangeiros do Japão, Toshimitsu Motegi.</p>\n<p>O ministro da Ciência, Tecnologia e Inovações substituto, Leonidas Medeiros representou o MCTI na cerimônia e assinou o documento com o Secretário de Geologia, Mineração e Transformação Mineral do Ministério de Minas e Energia (MME), Alexandre Vidigal de Oliveira.</p>\n<p>“O acordo é fundamental porque o Japão é um país que tem alta tecnologia e nos une a ele na procura de explorar as capacidades do nióbio e do grafeno”, afirmou o secretário-executivo do MCTI. “Esses materiais são produtos do futuro, que vão alcançar toda a cadeia produtiva dos países, na parte industrial e no uso da tecnologia.”</p>\n<p>Durante a cerimônia, foram firmados também acordos de cooperação entre os dois países nas áreas de biodiversidade, desenvolvimento de sensores e plataforma de agricultura de precisão em apoio à agricultura sustentável brasileira e uso tecnologias avançadas de radar de abertura sintética e uso de inteligência artificial para o combate ao desmatamento ilegal.</p>\n<p><strong>Minerais estratégicos e cooperação</strong></p>\n<p>Em outubro de 2016, Brasil e Japão assinaram Memorando de Cooperação para a Promoção de Investimentos e Cooperação Econômica no Setor de Infraestrutura. Desde então, os governos de ambos países vêm manifestando interesse mútuo em ampliar o investimento japonês no Brasil, incluindo os minerais raros ou estratégicos, como o grafeno e o nióbio.</p>\n<p>Em julho de 2020, foi aberta chamada pública CNPq/MCTI para apoiar empreendimentos tecnológicos à base de grafeno, destinando aproximadamente R$ 1,5 milhão para apoiar propostas de pesquisa aplicada, desenvolvimento tecnológico e inovação que visem gerar empreendimentos e soluções de base tecnológica, tendo como principal objeto o grafeno.</p>\n<p>Já o nióbio é considerado um mineral estratégico para o país. O Brasil é o maior produtor mundial desse material, responsável por aproximadamente 86% da produção, e tem o Japão como um dos principais importadores da liga ferronióbio (9,6% do exportado pelo Brasil).<br />\nAtento à necessidade de apoio ao desenvolvimento das cadeias produtivas de minerais estratégicos, entre elas a do nióbio, o MCTI priorizou o tema na Estratégia Nacional de Ciência, Tecnologia e Inovação 2016-2022 e no Plano de C,T&amp;I para Minerais Estratégicos.</p>\n</div>\n<p>Fonte: https://www.gov.br/</p>\n</div>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Foto: Odjair Baena / ASCOM MCTI Em cerimônia realizada no Palácio Itamaraty, em Brasília, nesta sexta-feira (8), Brasil e Japão assinaram o Memorando de Cooperação entre os Governos Brasileiro e Japonês no Campo de Tecnologias Relacionadas à Produção e ao Uso de Nióbio e Grafeno. O objetivo do documento bilateral é aprofundar o entendimento mútuo&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4947,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-4946",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4946",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4946",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4946/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4952,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4946/revisions/4952",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4947",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4946",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4946",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4946",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4356,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=4356",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "assinatura-do-acordo-de-cooperacao-tecnica-mcti-mtur-turismo-4-0",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/assinatura-do-acordo-de-cooperacao-tecnica-mcti-mtur-turismo-4-0/",
        title: {
            rendered:
                "Assinatura do Acordo de Cooperação Técnica MCTI-MTur TURISMO 4.0",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://www.youtube.com/watch?v=JjYAo2Cl2O4&amp;feature=youtu.be&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://www.youtube.com/watch?v=JjYAo2Cl2O4&amp;feature=youtu.be&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4357,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-4356",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4356",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4356",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4356/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4358,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4356/revisions/4358",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4357",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4356",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4356",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4356",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3862,
        date: "2024-08-07T14:53:42",
        date_gmt: "2024-08-07T17:53:42",
        guid: {
            rendered: "https://cintespbr.org/?p=3862",
        },
        modified: "2024-08-07T14:53:42",
        modified_gmt: "2024-08-07T17:53:42",
        slug: "cintesp-br-apoia-a-conscientizacao-sobre-a-esclerose-multipla",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-apoia-a-conscientizacao-sobre-a-esclerose-multipla/",
        title: {
            rendered:
                "CINTESP.Br apoia a conscientização sobre a Esclerose Múltipla.",
        },
        content: {
            rendered:
                '\n<h2 class="wp-block-heading">CINTESP.Br apoia a conscientização sobre a Esclerose Múltipla.</h2>\n\n\n\n<h3 class="wp-block-heading">De 21 a 28 de agosto é comemorada a Semana Nacional da Pessoa com Deficiência Intelectual e Múltiplas</h3>\n\n\n\n<h3 class="wp-block-heading">Você sabe o que é Esclerose Múltipla? </h3>\n\n\n\n<p>A Esclerose Múltipla (EM) é uma doença neurológica, crônica e autoimune, ou seja, as células de defesa do organismo atacam o próprio sistema nervoso central, provocando lesões cerebrais e medulares. Os pacientes são geralmente jovens, em especial mulheres de 20 a 40 anos.<br>Sintomas da Esclerose múltipla: fadiga intensa, depressão, fraqueza muscular, alteração do equilíbrio da coordenação motora, dores articulares e disfunção intestinal e da bexiga.<br>A esclerose múltipla (EM) é uma doença crônica que afeta cerca de 35 mil pessoas no Brasil, segundo a&nbsp;<a href="http://abem.org.br/">Associação Brasileira de Esclerose Múltipla – ABEM.</a><br>O diagnóstico é feito por um médico neurologista através do exame de ressonância magnética.<br>A EM ainda não tem cura e o tratamento visa diminuir a quantidade de surtos retardando a ação da doença.</p>\n\n\n\n<p>A Esclerose Múltipla, não é uma doença mental, não é contagiosa, não é suscetível de prevenção, não tem cura e seu tratamento consiste em atenuar os efeitos e desacelerar a progressão da doença.</p>\n\n\n\n<p>No dia 30 de agosto é comemorado o <strong>DIA NACIONAL DE CONSCIENTIZAÇÃO SOBRE A ESCLEROSE MÚLTIPLA</strong></p>\n\n\n\n<p>Centro Brasileiro de Referência em Inovações Tecnológicas para o Esporte Paralímpico – CINTESP.Br trabalha de forma pontual desenvolvendo tecnologias assistivas para a inclusão da pessoa com deficiência, mobilidade reduzida e doenças raras, ele vem trazer a luz a conscientização de uma doença que aflinge a 35 mil brasileiros e que merece atenção, pois, a mesma não tem cura, apenas tratamento para que as pessoas com Esclerose Múltipla possam ter qualidade de vida e possam ser assistida pelas muitas tecnologias que estão sendo desenvolvidas pelo CINTESP.Br .</p>\n\n\n\n<p>Uma dica de filme para conhecer melhor sobre esta doença é 100 metros do diretor espanhol Marcel Barrena, é um filme baseado em uma história real que narra a luta contra a Esclerose Múltipla, doença que acomete 2,3 milhões de pessoas no mundo.</p>\n\n\n\n<p>Confira abaixo o Trailer</p>\n\n\n\n<figure class="wp-block-embed-youtube wp-block-embed is-type-video is-provider-youtube wp-embed-aspect-16-9 wp-has-aspect-ratio"><div class="wp-block-embed__wrapper">\n<iframe loading="lazy" title="100 metros - Trailer" width="1200" height="675" src="https://www.youtube.com/embed/Y8bg-g4dl8w?feature=oembed" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>\n</div></figure>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>CINTESP.Br apoia a conscientização sobre a Esclerose Múltipla. De 21 a 28 de agosto é comemorada a Semana Nacional da Pessoa com Deficiência Intelectual e Múltiplas Você sabe o que é Esclerose Múltipla? A Esclerose Múltipla (EM) é uma doença neurológica, crônica e autoimune, ou seja, as células de defesa do organismo atacam o próprio sistema&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3863,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-3862",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3862",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3862",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3862/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3948,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3862/revisions/3948",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3863",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3862",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3862",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3862",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8398,
        date: "2024-06-12T10:45:08",
        date_gmt: "2024-06-12T13:45:08",
        guid: {
            rendered: "https://cintespbr.org/?p=8398",
        },
        modified: "2024-06-12T11:09:41",
        modified_gmt: "2024-06-12T14:09:41",
        slug: "vaga-de-emprego",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/vaga-de-emprego/",
        title: {
            rendered: "VAGA DE EMPREGO",
        },
        content: {
            rendered:
                '<h2 style="text-align: center;">CENITA/ Sis-Assistiva/MCTI</h2>\n<h2 style="text-align: center;">Centro Nacional de Integração de Inovações<br />\nem Tecnologia Assistiva</h2>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Contrata designers, engenheiros, publicitários, jornalistas, administradores, gestores de projetos ou profissionais de áreas afins que sejam especialistas em gestão de projetos e marke;ng para atuar na gestão, coordenação, articulação e fomento da rede Sis-Assistiva/MCTI no âmbito do Laboratório Integrador CENITA/Sis-Assis;va/MCTI da Universidade Federal de Uberlândia.</span></p>\n<h3 style="text-align: center;"><strong>Inscrições:</strong></h3>\n<p style="text-align: center;"><strong>Enviar e-mail para: <span style="color: #0000ff;">ta.cenita@gmail.com</span> até 18/06/2024</strong></p>\n<p>&nbsp;</p>\n<p style="text-align: center;">Clique <a href="https://cintespbr.org/wp-content/uploads/2024/06/VAGA-EMPREGO-PROJETO-DE-PESQUISA-FINEP.pdf" target="_blank" rel="noopener">AQUI</a> e baixe o documento completo</p>\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>CENITA/ Sis-Assistiva/MCTI Centro Nacional de Integração de Inovações em Tecnologia Assistiva Contrata designers, engenheiros, publicitários, jornalistas, administradores, gestores de projetos ou profissionais de áreas afins que sejam especialistas em gestão de projetos e marke;ng para atuar na gestão, coordenação, articulação e fomento da rede Sis-Assistiva/MCTI no âmbito do Laboratório Integrador CENITA/Sis-Assis;va/MCTI da Universidade Federal de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8399,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [56],
        tags: [],
        class_list: [
            "post-8398",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque",
            "category-56",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8398",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8398",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8398/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8403,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8398/revisions/8403",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8399",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8398",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8398",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8398",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8391,
        date: "2023-09-21T16:47:56",
        date_gmt: "2023-09-21T19:47:56",
        guid: {
            rendered: "https://cintespbr.org/?p=8391",
        },
        modified: "2023-09-21T16:56:02",
        modified_gmt: "2023-09-21T19:56:02",
        slug: "8391",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/8391/",
        title: {
            rendered:
                "Festival Paralímpico Loterias Caixa 2023 continua com inscrições abertas; saiba como participar",
        },
        content: {
            rendered:
                '<p><div style="width: 2057px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" src="https://cpb.org.br/wp-content/uploads/2023/09/52912303366_f9fadce776_k.jpg" alt="" width="2047" height="1365" /><p class="wp-caption-text">Criança brinca com bola na 1º etapa do Festival Paralímpico Loterias Caixa 2023 | Foto: Ana Patrícia Almeida/CPB</p></div></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O Comitê Paralímpico Brasileiro (CPB), por meio da sua diretoria de Desenvolvimento Esportivo, continua com as inscrições abertas para a segunda edição do Festival Paralímpico 2023. O evento acontecerá no próximo dia 23 de setembro (sábado) em 118 localidades espalhadas pelas 27 unidades federativas do país. Até a manhã da última segunda-feira, 11, o CPB havia registrado mais de 5.200 inscrições<strong>. <a href="https://docs.google.com/forms/d/e/1FAIpQLSem3i7-77aB_MfW-tnGjC5q18XeknIDprHejPnHlxURE9cEuw/viewform" target="_blank" rel="noreferrer noopener">O</a><a href="https://docs.google.com/forms/d/e/1FAIpQLSem3i7-77aB_MfW-tnGjC5q18XeknIDprHejPnHlxURE9cEuw/viewform">s interessados podem se inscrever por meio deste link.</a></strong></span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O evento proporciona a crianças com e sem deficiência (até 20%) a vivência em modalidades paralímpicas, de maneira recreativa e lúdica, bem como difunde o Movimento Paralímpico por todo o território nacional.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">De maneira inédita, o Festival terá duas etapas no mesmo ano. A primeira edição do evento em 2023, realizada em maio deste ano, reuniu mais de 21 mil participantes e foi considerada o recorde do Festival, que é organizado pelo Comitê Paralímpico Brasileiro (CPB) desde 2018, superando os mais de 15 mil registrados em 2022.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">À época, o presidente do CPB e bicampeão paralímpico no futebol de cegos (Atenas 2004 e Pequim 2008), Mizael Conrado, afirmou que ficou bastante satisfeito com o que o Festival proporcionou às crianças e aos jovens. “Foi uma verdadeira festa da inclusão, com a interação de pessoas com e sem deficiências em todo o território nacional. Mostramos, claramente, que todos podem fazer as mesmas coisas, ainda que de forma diferente. É uma grande alegria para nós, do CPB, organizarmos este evento”, avaliou Mizael, no último mês de maio.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Ainda na primeira etapa de 2023, no núcleo de Colatina, Espírito Santo, aproximadamente 730 crianças e jovens se reuniram para experimentar atletismo, futebol de cegos, vôlei sentado e bocha. <strong><a href="https://cpb.org.br/noticias/festival-paralimpico-2023-conheca-modalidades-que-vao-estrear-no-evento-neste-sabado" target="_blank" rel="noreferrer noopener">A cidade gaúcha de Santo Ângelo proporcionou a prática de duas modalidades inéditas no Festival: hipismo e curling em cadeira de rodas</a></strong>.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">No outro extremo do país, em Boa Vista, capital de Roraima, aproximadamente 130 pessoas participaram de atividades relacionadas ao atletismo, à bocha e ao vôlei sentado. Dos participantes, 40 eram venezuelanos, como a jovem Angela Sara Velázquez, 16, que nasceu em Caracas e há dois anos mora no Brasil.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Em sua primeira participação no Festival, Sara, como é conhecida, afirmou que ficou encantada com o atletismo. Por ter perdido força nos membros inferiores, já na adolescência, a venezuelana se locomove com cadeira de rodas e praticou corridas curtas na pista do Parque Anauá, localizado no centro de Boa Vista. “Não conhecia o esporte paralímpico. Amei esta manhã. Eu me senti livre, sem vergonha de ser quem eu sou. Não sei explicar direito. Foi uma energia diferente e muito boa. Agora, não quero mais sair do atletismo. Vou procurar o Centro de Referência daqui”, prometeu, referindo-se ao projeto do CPB que aproveita espaços esportivos para a prática de modalidades paralímpicas, desde a base até o alto rendimento. <strong><a href="https://cpb.org.br/noticias/refugiados-da-venezuela-participam-do-festival-paralimpico-em-roraima/">Relembre como foi o Festival em Roraima.</a></strong></span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">No total, a fase realizada em maio deste ano reuniu <strong><a href="https://cpb.org.br/noticias/criancas-com-deficiencia-intelectual-sao-38-dos-inscritos-no-festival-paralimpico-deste-sabado" target="_blank" rel="noreferrer noopener">cerca de 36% participantes com deficiência intelectual</a></strong>. Depois, vieram as crianças e os jovens com transtorno do espectro autista (19,5 %) e os com deficiências físicas (10,2%). Os outros inscritos se dividiram entre os que tinham deficiências visual, auditiva e múltiplas, além dos 20% sem deficiências. </span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;"><strong>Segunda edição</strong></span><br />\n<span style="font-size: 12pt;">No próximo dia 23 de setembro, cada um dos 118 locais desta segunda fase vai disponibilizar quatro modalidades paralímpicas para a prática aos participantes no período. No Centro de Treinamento Paralímpico, em São Paulo, por exemplo, será realizada a prática do atletismo, badminton, tênis de mesa e vôlei sentado.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A primeira vez que o Festival foi realizado, há cinco anos, ocorreu em 48 locais com a participação de mais de 7 mil crianças. Em 2019, o evento teve 70 sedes e recebeu mais de 10 mil inscritos. No ano seguinte, a ação foi cancelada devido à pandemia de Covid-19 e retornou em 2021, com 8 mil participantes em 70 núcleos.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O Festival ocorre em setembro por causa da celebração ao Dia Nacional de Luta da Pessoa com Deficiência (21) e ao Dia Nacional do Atleta Paralímpico (22). Em 2021, devido à pandemia de Covid-19, o evento foi adiado e realizado em 4 de dezembro para acompanhar o Dia Internacional de Luta das Pessoas com Deficiência (3 de dezembro).</span></p>\n<p><span style="font-size: 12pt;"><strong>Imprensa<br />\n</strong>O profissional de imprensa interessado na cobertura do Festival Paralímpico Loterias Caixa necessita enviar um e-mail para imp@cpb.org.br, com os seguintes dados: nome completo, RG ou CPF, veículo para qual realizará o trabalho, e cidade em que será feita a cobertura.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;"><strong>Serviço</strong></span><br />\n<span style="font-size: 12pt;"><strong>Data</strong>: 23 de setembro (sábado)</span><br />\n<span style="font-size: 12pt;"><strong>Horário</strong>: das 8h30 às 12h</span><br />\n<span style="font-size: 12pt;"><strong>Público</strong>: crianças e adolescentes de 8 a 17 anos, com deficiência física, visual ou intelectual e sem deficiência</span><br />\n<span style="font-size: 12pt;"><strong>Modalidades</strong>: quatro modalidades paralímpicas por sede</span><br />\n<span style="font-size: 12pt;"><strong>Contato</strong>: festival.paralimpico@cpb.org.br</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;"><strong>Patrocínios</strong></span><br />\n<span style="font-size: 12pt;">As Loterias Caixa são a patrocinadora oficial do Festival Paralímpico</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Fonte: <strong>Assessoria de Comunicação do Comitê Paralímpico Brasileiro (imp@cpb.org.br)</strong></span></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O Comitê Paralímpico Brasileiro (CPB), por meio da sua diretoria de Desenvolvimento Esportivo, continua com as inscrições abertas para a segunda edição do Festival Paralímpico 2023. O evento acontecerá no próximo dia 23 de setembro (sábado) em 118 localidades espalhadas pelas 27 unidades federativas do país. Até a manhã da última segunda-feira, 11, o CPB&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8392,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [56, 62],
        tags: [],
        class_list: [
            "post-8391",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque",
            "category-todas-as-noticias",
            "category-56",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8391",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8391",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8391/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8395,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8391/revisions/8395",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8392",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8391",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8391",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8391",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8386,
        date: "2023-09-04T16:30:51",
        date_gmt: "2023-09-04T19:30:51",
        guid: {
            rendered: "https://cintespbr.org/?p=8386",
        },
        modified: "2023-09-21T16:56:19",
        modified_gmt: "2023-09-21T19:56:19",
        slug: "esporte-na-qualidade-de-vida",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/esporte-na-qualidade-de-vida/",
        title: {
            rendered: "Esporte na qualidade de vida.",
        },
        content: {
            rendered:
                '<h2>A matéria sobre o Cintesp.br e a importância para inclusão e autoestima foi ao ar pelo Canal Futura na primeira temporada do Programa Alô Comunidade.</h2>\n<p><div style="width: 848px;" class="wp-video"><!--[if lt IE 9]><script>document.createElement(\'video\');</script><![endif]-->\n<video class="wp-video-shortcode" id="video-8386-1" width="848" height="480" preload="metadata" controls="controls"><source type="video/mp4" src="https://cintespbr.org/wp-content/uploads/2023/09/VID-20230903-WA0016.mp4?_=1" /><a href="https://cintespbr.org/wp-content/uploads/2023/09/VID-20230903-WA0016.mp4">https://cintespbr.org/wp-content/uploads/2023/09/VID-20230903-WA0016.mp4</a></video></div></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>A matéria sobre o Cintesp.br e a importância para inclusão e autoestima foi ao ar pelo Canal Futura na primeira temporada do Programa Alô Comunidade.</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8388,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57],
        tags: [],
        class_list: [
            "post-8386",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-57",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8386",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8386",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8386/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8389,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8386/revisions/8389",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8388",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8386",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8386",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8386",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8365,
        date: "2023-08-16T23:53:58",
        date_gmt: "2023-08-17T02:53:58",
        guid: {
            rendered: "https://cintespbr.org/?p=8365",
        },
        modified: "2023-09-04T16:32:14",
        modified_gmt: "2023-09-04T19:32:14",
        slug: "cintesp-br-ufu-na-75a-reuniao-da-sociedade-brasileira-para-o-progresso-da-ciencia-sbpc",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-ufu-na-75a-reuniao-da-sociedade-brasileira-para-o-progresso-da-ciencia-sbpc/",
        title: {
            rendered:
                "CINTESP.Br/UFU na 75ª reunião da Sociedade Brasileira para o Progresso da Ciência (SBPC)",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8381" style="width: 1391px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8381" class="wp-image-8381 size-full" src="https://cintespbr.org/wp-content/uploads/2023/08/img4-1.jpg" alt="" width="1381" height="1181" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img4-1.jpg 1381w, https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img4-1-300x257.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img4-1-1024x876.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img4-1-768x657.jpg 768w" sizes="(max-width: 1381px) 100vw, 1381px" /><p id="caption-attachment-8381" class="wp-caption-text">Pesquisador e coordenador do Cintesp.Br/UFU, Cleudmar Araújo no stand.</p></div></p>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8378" style="width: 1392px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8378" class="wp-image-8378 size-full" src="https://cintespbr.org/wp-content/uploads/2023/08/img1-1.jpg" alt="" width="1382" height="1181" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img1-1.jpg 1382w, https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img1-1-300x256.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img1-1-1024x875.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img1-1-768x656.jpg 768w" sizes="(max-width: 1382px) 100vw, 1382px" /><p id="caption-attachment-8378" class="wp-caption-text">Ministra Luciana Santos, MCTI conhecendo ações do Cintesp.Br/UFU e jornalista Cristiane de Paula</p></div></p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]<span style="font-size: 10pt;">Texto: Cristiane de Paula – jornalista Cintesp.Br/UFU</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos da Universidade Federal de Uberlândia (Cintesp.Br/UFU) esteve presente na 75ª Reunião Anual da Sociedade Brasileira para o Progresso da Ciência (SBPC). O evento aconteceu na Universidade Federal do Paraná na cidade de Curitiba, entre os dias 23 a 29 de julho/2023.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A reunião da SBPC, deste ano, considerada como uma das maiores mostras de inovação da América Latina com a presença de diversos pesquisadores, onde foram realizadas 62 mesas-redondas, 41 conferências, 13 sessões especiais, 04 assembleias, 129 trabalhos apresentados e 244 trabalhos expostos na sessão de pôsteres. O evento contou com um total de mais de 10.000 pessoas inscritas, além de 700 participantes nos web-minicursos.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Foi neste cenário que o Cintesp.Br/UFU, com uma grande interação do público, apresentou equipamentos e dispositivos inovadores já patenteados, e já licenciados prontos para uso pela sociedade brasileira. A apresentação chamou a atenção pela variedade de equipamentos que atendem, não apenas ao esporte, como também à vida diária, lazer, educação inclusiva e saúde. Neste caso, a exposição de dispositivos apresentava soluções que podem ser aplicadas no cotidiano para promoção da inclusão de pessoas cegas. Por exemplo, jogos com peças em relevo para identificação por pessoas cegas ou com baixa visão. “A tecnologia, a ciência, o conhecimento têm que ter compromisso social. A Universidade Federal de Uberlândia tem um trabalho fundamental para o esporte paralímpico na produção de tecnologia assistiva. Isso é uma ação de pesquisa aliada à extensão para que as pessoas no Brasil todos se beneficiem com esse conhecimento tecnológico”, disse Hélder Eterno, Pró-Reitor de Extensão e Cultura da UFU, presente na SBPC.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">“Nós precisamos sempre mostrar para a sociedade e para nosso governo o que o Cintesp.Br desenvolve para a população e continuar a buscar apoio para entregar mais tecnologias inovadoras para as pessoas”, disse Cleudmar Araújo, coordenador geral do Cintesp.Br/UFU que acompanhou o evento na 75ª Reunião Anual da SBPC.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O Cintesp.Br/UFU desde 2012, desenvolve inovações em TA, buscando soluções para a sociedade, principalmente, para as pessoas com deficiência de baixa renda, com o intuito de acelerar a produção de PD&amp;I e licenciamentos. Um dos objetivos é gerar um ambiente empreendedor para que as tecnologias sejam direcionadas para toda a sociedade. “O que mais me chamou atenção no Cintesp.Br/UFU é a capacidade de tirar do papel as pesquisas em tecnologia assistiva, onde o maior desafio para quem faz TA é justamente viabilizar em produto para quem de fato precisa”, disse Emerson da Costa, pesquisador em TA e vice-presidente da Associação Brasileira de incentivo à Ciência (Abric).</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Entre os representantes do Ministério passaram pelo stand do Cintesp.Br/UFU e conheceram os equipamentos: Luis Fernandes, Secretário-Executivo do MCTI, e membro do Conselho de Administração da Finep, Inácio Arruda, Secretário de Ciência e Tecnologia para o Desenvolvimento Social, “tive uma percepção muito boa pela resposta que deu à população para atender pessoas com deficiência do nosso país. O que nós estamos vendo aqui, produzido em Uberlândia, é uma mostra da potência do país, temos cerca de 16 milhões de pessoas que precisam dessa tecnologia e essa é a resposta que a ciência está oferecendo, você vai desde a pesquisas básica, aplicada e inovação e entrega para a sociedade e também chamar as empresas, sobretudo as nacionais, que podemos oferecer essa tecnologia”, disse Inácio Arruda.</span></p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8379" style="width: 1393px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8379" class="wp-image-8379 size-full" src="https://cintespbr.org/wp-content/uploads/2023/08/img2-1.jpg" alt="" width="1383" height="1182" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img2-1.jpg 1383w, https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img2-1-300x256.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img2-1-1024x875.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img2-1-768x656.jpg 768w" sizes="(max-width: 1383px) 100vw, 1383px" /><p id="caption-attachment-8379" class="wp-caption-text">Visitação no stand e experimentação na petra-bike running, equipamento com inovações desenvolvidas pelo Cintesp.Br/UFU.</p></div></p>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8379" style="width: 1393px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8379" class="wp-image-8379 size-full" src="https://cintespbr.org/wp-content/uploads/2023/08/img2-1.jpg" alt="" width="1383" height="1182" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img2-1.jpg 1383w, https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img2-1-300x256.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img2-1-1024x875.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2023/08/img2-1-768x656.jpg 768w" sizes="(max-width: 1383px) 100vw, 1383px" /><p id="caption-attachment-8379" class="wp-caption-text">Área MCTI &#8211; Stands da ciência, tecnologia, inovação e empreendedorismo</p></div></p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Nesse período de mais de 10 anos, coordenou mais de 40 projetos de PD&amp;I em Tecnologia Assistiva (TA) por meio de redes colaborativas multidisciplinares envolvendo, mais de 60 pesquisadores e diversas parceiros como FUTEL/Uberlândia, Praia Clube, Instituto Brain/Algar, Sesi-Gravatás, dentre outros. As pesquisas financiadas pelo Ministério da Ciência, Tecnologia e Inovação (MCTI), Ministério Público do Trabalho (MPT-Uberlândia), CNPq, FAPEMIG, CAPES, FINEP, dentre outros.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Em visita ao stand do Cintesp.Br/UFU, a ministra do MCTI, Luciana Santos conheceu algumas das tecnologias inovadoras expostas, e recebeu o portfólio contendo as 34 tecnologias inovadoras em TA já disponíveis para toda a sociedade brasileira. “Tecnologia assistiva é uma de nossas prioridades”, disse a ministra do MCTI, Luciana Santos.</span></p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Texto: Cristiane de Paula – jornalista Cintesp.Br/UFU O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos da Universidade Federal de Uberlândia (Cintesp.Br/UFU) esteve presente na 75ª Reunião Anual da Sociedade Brasileira para o Progresso da Ciência (SBPC). O evento aconteceu na Universidade Federal do Paraná na cidade de Curitiba,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8370,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-8365",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8365",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8365",
                },
            ],
            "version-history": [
                {
                    count: 10,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8365/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8383,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8365/revisions/8383",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8370",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8365",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8365",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8365",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8239,
        date: "2023-03-25T15:39:04",
        date_gmt: "2023-03-25T18:39:04",
        guid: {
            rendered: "https://cintespbr.org/?p=8239",
        },
        modified: "2023-08-17T00:19:39",
        modified_gmt: "2023-08-17T03:19:39",
        slug: "tecnologia-assistiva-desenvolvida-na-universidade-federal-de-uberlandia-e-reconhecida-como-empreendedora-e-premiada-em-sao-paulo",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/tecnologia-assistiva-desenvolvida-na-universidade-federal-de-uberlandia-e-reconhecida-como-empreendedora-e-premiada-em-sao-paulo/",
        title: {
            rendered:
                "Tecnologia assistiva desenvolvida na Universidade Federal de Uberlândia é reconhecida como empreendedora e premiada em São Paulo",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8247" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8247" class="wp-image-8247 size-large" src="https://cintespbr.org/wp-content/uploads/2023/03/foto2-1024x874.jpg" alt="" width="1024" height="874" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2023/03/foto2-1024x874.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2023/03/foto2-300x256.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2023/03/foto2-768x655.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2023/03/foto2.jpg 1063w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8247" class="wp-caption-text">Presidente do CNPq, Ricardo Galvão, pesquisador e professor da UFU, Cleudmar Araújo e Odir Dellagostin presidente do CONFAP (Foto: Fernando de Lucena/CONFAP)</p></div></p>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8248" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8248" class="wp-image-8248 size-large" src="https://cintespbr.org/wp-content/uploads/2023/03/foto-1-1024x871.jpg" alt="" width="1024" height="871" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2023/03/foto-1-1024x871.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2023/03/foto-1-300x255.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2023/03/foto-1-768x653.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2023/03/foto-1.jpg 1063w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8248" class="wp-caption-text">Marcelo Speziali, diretor CT&amp;I; prof. Cleudmar Araújo; Paulo Beirão, presidente Fapemig</p></div></p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]<span style="font-size: 10pt;">Texto: Cristiane de Paula- jornalista Cintesp.Br/UFU</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A premiação fez parte do Congresso que reúne dirigentes das 27 Fundações Estaduais de Amparo à Pesquisa (FAPs), representantes do Ministério da Ciência, Tecnologia e Inovação (MCTI) e das agências federais de fomento à CT&amp;I para debater temas prioritários da política científica e tecnológica no Brasil.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O Prêmio CONFAP de CT&amp;I, com a premiação boas práticas em fomento à ciência, tecnologia e inovação, “Professora Odete Fátima Machado Da Silveira” é uma iniciativa do Conselho Nacional das Fundações Estaduais de Amparo à Pesquisa (CONFAP), com apoio do Conselho Nacional de Desenvolvimento Científico e Tecnológico (<a href="https://www.gov.br/cnpq/pt-br">CNPq</a>).</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O Professor e pesquisador da Universidade Federal de Uberlândia, Cleudmar Araújo recebeu o certificado e medalha de primeiro lugar na categoria “Inovação para o Setor Empresarial 2022”, no Fórum Nacional do CONFAP, realizado ontem (23) na cidade de São Paulo. A edição deste ano foi realizada em parceria da Fundação de Amparo à Pesquisa do Estado de São Paulo (FAPESP).</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Cleudmar Araújo também é coordenador geral do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos, vinculado à Universidade Federal de Uberlândia (Cintesp.Br/UFU). A unidade foi criada em 2019 pelo Ministério da Ciência Tecnologia e Inovações (MCTI) para desenvolver pesquisas de inovação em Tecnologia Assistiva (TA). O Cintesp.Br/UFU conseguiu gerar mais de 40 registros de patentes de equipamentos voltados para pessoas com deficiência, mobilidade reduzida e doenças raras nas áreas do esporte, saúde, lazer, educação e vida diária. Em março do ano passado 21 produtos foram entregues e 11 licenciados para fabricação pela indústria nacional.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">“As pesquisas coordenadas pelo Professor Cleudmar à frente do Cintesp.Br demonstram alto grau de inovação aliado ao interesse social, tendo em vista o desenvolvimento de tecnologias assistiva. Sendo assim, a escolha do professor Cleudmar, para o Prêmio CONFAP é o reconhecimento de seu trabalho e contribuição para a ciência,” destaca Thiago Paluma, diretor Agência Intelecto/UFU.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Os projetos são financiados pelo MCTI e pelo Ministério Público do Trabalho (MPT/Uberlândia-MG). As pesquisas são desenvolvidas em formato de redes colaborativas multidisciplinares com outros pesquisadores (<a href="https://cintespbr.org/?page_id=2657">https://cintespbr.org/?page_id=2657</a>) e em parcerias com a prefeitura de Uberlândia, por meio da Fundação de Turismo e Esportes (FUTEL), Praia Clube Uberlândia, SESI/Gravatás, CPB, Algar Telecom, Associações, e Instituições públicas que atuam com ações políticas e suporte às pessoas com deficiência, mobilidade reduzida e doenças raras.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">“Receber esse Prêmio foi uma honra, são quase 20 anos de trabalho voltados para pessoas com deficiência, doenças raras e mobilidade reduzida. O reconhecimento também é do trabalho dos colaboradores, de toda nossa rede que envolve pesquisadores, instituições e Governos do Município de Uberlândia, do Estado de Minas Gerais e do Brasil com a nossa UFU. Essa indicação da FAPEMIG e a premiação pelo CONFAP permite que possamos destacar a área da tecnologia assistiva que tem carência de importados. A proposta do Prêmio permite ainda dar atenção para as soluções inovadoras em TA, e, cito as áreas da saúde, do lazer, da educação, do esporte e vida diária. Tudo isso, aumenta nosso esforço e responsabilidade para que possamos implementar o setor empreendedor unindo forças inclusive com startups nessa área”, completa o pesquisador Cleudmar Araújo.  O pesquisador se referiu ao Centro Nacional de Tecnologias para Pessoas com Deficiência e Doenças Raras (CNT), em fase de implantação em Uberlândia, no Campus Glória da UFU. O CNT será voltado ao empreendedorismo e inovação para fortalecer esse cenário que se destaca no nosso país.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;"> “O Prêmio coloca a UFU num patamar importante ao se considerar o desenvolvimento da pesquisa tecnológica e da inovação no Brasil. O trabalho do professor é interdisciplinar, envolvendo, portanto, outras áreas do conhecimento, e trata de tecnologias assistivas, ou seja, tem grande apelo social. Isto significa que as pessoas com deficiência são diretamente beneficiadas através de equipamentos cada vez mais adaptados e que permitem melhor qualidade de vida. Num recorte voltado para a competição de alto desempenho, existe também contribuição para atletas de alto nível. E toda esta tecnologia se encontra disponível para o setor empresarial que, em parceria com a universidade, pode produzir os equipamentos em escala capaz de atender as pessoas com deficiência”,acrescenta Dr. Valder Steffen Jr, professor e Reitor da Universidade Federal de Uberlândia.</span></p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Texto: Cristiane de Paula- jornalista Cintesp.Br/UFU A premiação fez parte do Congresso que reúne dirigentes das 27 Fundações Estaduais de Amparo à Pesquisa (FAPs), representantes do Ministério da Ciência, Tecnologia e Inovação (MCTI) e das agências federais de fomento à CT&amp;I para debater temas prioritários da política científica e tecnológica no&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8240,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-8239",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8239",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8239",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8239/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8249,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8239/revisions/8249",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8240",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8239",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8239",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8239",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8236,
        date: "2023-03-18T14:45:07",
        date_gmt: "2023-03-18T17:45:07",
        guid: {
            rendered: "https://cintespbr.org/?p=8236",
        },
        modified: "2023-08-17T00:20:30",
        modified_gmt: "2023-08-17T03:20:30",
        slug: "curso-de-extensao-em-audiodescricao-promovido-pelo-cintesp-br-ufu-traz-a-uberlandia-mais-uma-ferramenta-de-inclusao",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/curso-de-extensao-em-audiodescricao-promovido-pelo-cintesp-br-ufu-traz-a-uberlandia-mais-uma-ferramenta-de-inclusao/",
        title: {
            rendered:
                "Curso de extensão em audiodescrição, promovido pelo Cintesp.Br/UFU, traz a Uberlândia mais uma ferramenta de inclusão",
        },
        content: {
            rendered:
                '<p><div id="attachment_8237" style="width: 549px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8237" class="wp-image-8237" src="https://cintespbr.org/wp-content/uploads/2023/03/WhatsApp-Image-2023-03-06-at-23.29.32-300x225.jpeg" alt="" width="539" height="404" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2023/03/WhatsApp-Image-2023-03-06-at-23.29.32-300x225.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2023/03/WhatsApp-Image-2023-03-06-at-23.29.32-1024x768.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2023/03/WhatsApp-Image-2023-03-06-at-23.29.32-768x576.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2023/03/WhatsApp-Image-2023-03-06-at-23.29.32-1536x1152.jpeg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2023/03/WhatsApp-Image-2023-03-06-at-23.29.32.jpeg 1600w" sizes="(max-width: 539px) 100vw, 539px" /><p id="caption-attachment-8237" class="wp-caption-text">Abertura curso de extensão em audiodescrição, realizado pelo Cintesp.Br/UFU</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula, jornalista Cintesp.Br/UFU</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A audiodescrição é um recurso desenvolvido para promover a inclusão de pessoas cegas com baixa visão e surdocega. O audiodescritor traduz a imagem ou vídeo em palavras permitindo a exploração de toda capacidade emocional da pessoa com deficiência visual e oferecendo maior envolvimento com a sociedade.  </span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A audiodescrição é um recurso oferecido, por exemplo, em teatros, salas de exposição de arte, museus, cinema e principalmente nas relações interpessoais proporcionando inclusão e acessibilidade cultural e cognitiva de todas as pessoas. “Comece uma conversa, escute um vídeo, uma cena de filme ou um trecho de peça de teatro de olhos fechados e repita a experiência com olhos abertos, perceba o nível de envolvimento emocional de cada situação”, assim teve início a aula inaugural do curso pela professora Mylena Rodrigues.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A audiodescrição começa com a própria descrição, a autodescrição, com a ação de se apresentar para uma pessoa. É se traduzir em palavras, dizer o nome, a altura, a cor da pele, descrever sobre o cabelo e a roupa usada, dando oportunidade à pessoa com deficiência visual identificar o interlocutor.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Serão 3 meses de curso sobre práticas inclusivas e legislação, o objetivo é despertar a vocação para quem deseja complementar o conhecimento. As aulas serão ministradas pela intérprete em audiodescrição, consultora e professora Mylena Rodrigues, acompanhada pelo roteirista e editor Valdivino Junior. De acordo com a professora, o curso não tem a pretensão de formar profissionais, é uma iniciação ao recurso. “Introduzir o conceito da audiodescrição é importante para o conhecimento, só assim nós cegos ou com baixa visão, nos conhecemos e conhecemos o mundo melhor”, enfatiza a professora Mylena.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O principal objetivo do primeiro curso de extensão em audiodescrição, oferecido pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos da Universidade Federal de Uberlândia (Cintesp.Br/UFU), é despertar a sociedade para essa importante ferramenta de inclusão. “As ações de inclusão nos tem colocado mais permanente em contato com pessoas cegas, fiz o primeiro curso de libras, agora estou nessa turma de audiodescrição e digo que eu é quem sou ‘deficiente’, ao não saber me comunicar, chego a sentir vergonha”, acrescenta Eliane Carvalho professora do curso de fisioterapia da UFU, aluna do curso.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O projeto realizado em parceria com a Pró-Reitoria de Extensão e Cultura (PROEXC/UFU), Rede de extensão, empresa Simetria Acessibilidade e FUTEL também contou com o apoio do Conselho Municipal para Pessoa com Deficiência do município de Uberlândia, “fico muito feliz com esse momento, nós do COMPOD, já investimos em equipamentos para audiodescrição para o Teatro Municipal e ocurso vem somar para fortalecer a promoção da inclusão. É mais uma oportunidade para despertar para atenção e acessibilidade”, completa Eduardo Charles Faustino, vice-presidente do COMPOD de Uberlândia.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Este já é o terceiro curso, na área da educação, gratuito e aberto para a sociedade, oferecido pelo Cintesp.Br/UFU. No ano passado foram desenvolvidos cursos de libras e Braille.  “Essa é a nossa função, mover parcerias, trazer recursos para desenvolver cada vez mais os projetos de extensão”, disse Fabíola Dutra Amaral da ProexC/UFU.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Para o coordenador do Cintesp.Br/UFU é preciso estar junto à sociedade e fazer projetos com as pessoas, “estamos contribuindo para a formação e inclusão, é o nosso papel enquanto centro de pesquisas da Universidade Federal de Uberlândia com união de forças fortalecer o que nossa cidade já desenvolve para inclusão com acessibilidade”, completa Cleudmar Araújo, coordenador geral do Cintesp.BBr/UFU.</span></p>\n<p style="text-align: justify;">\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula, jornalista Cintesp.Br/UFU A audiodescrição é um recurso desenvolvido para promover a inclusão de pessoas cegas com baixa visão e surdocega. O audiodescritor traduz a imagem ou vídeo em palavras permitindo a exploração de toda capacidade emocional da pessoa com deficiência visual e oferecendo maior envolvimento com a sociedade.   A audiodescrição&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8237,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-8236",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8236",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8236",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8236/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8238,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8236/revisions/8238",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8237",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8236",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8236",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8236",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8230,
        date: "2023-02-08T23:24:00",
        date_gmt: "2023-02-09T02:24:00",
        guid: {
            rendered: "https://cintespbr.org/?p=8230",
        },
        modified: "2023-03-18T14:45:46",
        modified_gmt: "2023-03-18T17:45:46",
        slug: "audiodescricao-como-projeto-de-extensao-na-ufu-oferecera-oportunidade-de-introducao-na-capacitacao-de-novos-profissionais",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/audiodescricao-como-projeto-de-extensao-na-ufu-oferecera-oportunidade-de-introducao-na-capacitacao-de-novos-profissionais/",
        title: {
            rendered:
                "Audiodescrição como projeto de extensão na UFU oferecerá oportunidade de introdução na capacitação de novos profissionais",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-8231" src="https://cintespbr.org/wp-content/uploads/2023/02/ads-1024x854.png" alt="" width="500" height="417" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2023/02/ads-1024x854.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2023/02/ads-300x250.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2023/02/ads-768x641.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2023/02/ads.png 1061w" sizes="(max-width: 500px) 100vw, 500px" /></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula – jornalista Cintesp.Br/UFU<br />\nRevisão técnica: Ana Sara Tomé, pesquisadora Cintesp.Br/UFU</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A realização do Curso de Extensão em Audiodescrição é uma iniciativa do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos da Universidade Federal de Uberlândia (Cintesp.Br/UFU) em parceria com a Rede de Extensão da UFU.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A audiodescrição ficou mais conhecida na aplicação em filmes, peças de teatro para auxiliar o entendimento da comunicação às pessoas cegas ou com níveis severos de baixa visão. É um recurso onde o profissional da audiodescrição descreve as imagens, vídeos, interpretações teatrais e fotos, traduzindo em palavras. O recurso oferece à pessoa com deficiência visual a oportunidade de acompanhar a cena possibilitando ter maior experiência do momento em que estaria limitado apenas a ouvir.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A técnica de descrever, de traduzir as imagens para o deficiente visual ser incluído é uma das mais poderosas ferramentas de inclusão. Ela é obrigatória desde 2011 e constantemente a aplicação da audiodescrição vem sendo ampliada com ajustes da Lei. O principal objetivo é ternar a inclusão cada dia mais efetiva e universal.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A pessoa cega, surdocega ou com baixa visão passa a ter autonomia, também para buscar a emoção oferecida nos espaços de cultura e lazer, podendo ampliar as possibilidades de ter mais sensações sem a necessidade de ter ao lado um guia intérprete ou um acompanhante.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Oferecer oportunidade de conhecimento da técnica passa a ser inclusiva também às pessoas que identificam ter habilidade para absorver mais um conhecimento de inclusão e possibilidade de mais um conhecimento para o restrito mercado de trabalho.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Sem falar que a cada novo estudo, o recurso da audiodescrição também amplia o entendimento de pessoas com deficiência intelectual, como TDAH, autistas, disléxicos, idosos e outras pessoas sem deficiência.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Por ser, a audiodescrição, um recurso de acessibilidade comunicacional ela se torna um estudo fundamental para todas as pessoas que queiram transformar seus espaços de convivência, seja pessoal ou profissional, em espaços cada vez mais inclusivos e acessíveis.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A audiodescrição como curso de extensão tem como objetivo apresentar aos participantes e promover o ensino bem como a compreensão dos conceitos e princípios de acessibilidade comunicacional considerando os aspectos técnicos da importante ferramenta de inclusão.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O curso terá carga horária de 50 horas com aulas gratuitas e emissão de certificados.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O período de inscrição, com vagas limitadas, vai até o dia 17 de fevereiro, podendo ser encerrado antes, caso as vagas sejam preenchidas.</span></p>\n<p style="text-align: center;"><a href="https://docs.google.com/forms/d/e/1FAIpQLSeDuETywyoTFnaC5C6nS8hJ-T6OMJbYu-bZcivoJ_kBVIJHAA/viewform"><span style="font-size: 18pt;"><strong>INSCREVA-SE CLICANDO AQUI</strong></span></a></p>\n<p>&nbsp;</p>\n<p style="text-align: justify;"><span style="font-size: 12pt;"><strong>Informações complementares:</strong> Para ser aprovado no 1° Módulo  e receber o  certificado, o participante   deverá obter frequência mínima de 75% da carga horária do curso, e nota média igual ou superior a 60%, bem como a realização das atividades do curso.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;"><strong>Prof.ª Me. Mylena Rodrigues Vaz </strong>(baixa visão)</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;"><strong>Início</strong>: 27/02/2023 (segunda-feira)</span><br />\n<span style="font-size: 12pt;"><strong>Interação</strong>: 18h45  </span><br />\n<span style="font-size: 12pt;"><strong>Horário das aulas:</strong> 19h às 21h</span><br />\n<span style="font-size: 12pt;"><strong>Carga horária:</strong>  50 horas</span><br />\n<span style="font-size: 12pt;"><strong>Endereço</strong>: Rua Benjamin Constant, nº 1286 &#8211; Nossa Sra. Aparecida &#8211; Local: Educação Física &#8211; Sala: 152.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;"><strong>Modalidade de ensino:</strong> Encontros presenciais.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;"><strong> </strong><strong>Avaliação e atividades do Curso:</strong> As provas são realizadas considerando todo o conteúdo programático da disciplina e a  avaliação será realizada com atividades práticas em Audiodescrição, com a  prática pedagógica, como em atividades profissionais como em: audiodescrição de vídeos gravados, vídeos Institucionais, filmes, exposições, concertos, teatros, acessibilidade cultural, atividades de estudo e pesquisas em grupos, atividades online, realização de áudio/vídeos, concomitante às  provas presenciais.</span></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula – jornalista Cintesp.Br/UFU Revisão técnica: Ana Sara Tomé, pesquisadora Cintesp.Br/UFU A realização do Curso de Extensão em Audiodescrição é uma iniciativa do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos da Universidade Federal de Uberlândia (Cintesp.Br/UFU) em parceria com a Rede de Extensão da UFU. A audiodescrição ficou mais&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8234,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47],
        tags: [],
        class_list: [
            "post-8230",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-47",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8230",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8230",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8230/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8233,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8230/revisions/8233",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8234",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8230",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8230",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8230",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8219,
        date: "2022-12-26T21:07:24",
        date_gmt: "2022-12-27T00:07:24",
        guid: {
            rendered: "https://cintespbr.org/?p=8219",
        },
        modified: "2023-08-17T00:20:05",
        modified_gmt: "2023-08-17T03:20:05",
        slug: "transpor-barreiras-por-meio-do-esporte-da-cultura-e-da-educacao-o-cintesp-br-ufu-desenvolve-diversas-atividades-no-mes-internacional-da-pessoa-com-deficiencia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/transpor-barreiras-por-meio-do-esporte-da-cultura-e-da-educacao-o-cintesp-br-ufu-desenvolve-diversas-atividades-no-mes-internacional-da-pessoa-com-deficiencia/",
        title: {
            rendered:
                "Transpor barreiras por meio do esporte, da cultura e da educação. O Cintesp.Br/UFU desenvolve diversas atividades no mês Internacional da Pessoa com Deficiência",
        },
        content: {
            rendered:
                '<p><div id="attachment_8220" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8220" class="wp-image-8220 size-large" src="https://cintespbr.org/wp-content/uploads/2022/12/Sem-titulo-1-1024x410.png" alt="" width="1024" height="410" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-1-1024x410.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-1-300x120.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-1-768x308.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-1-1536x615.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-1.png 1768w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8220" class="wp-caption-text">Apresentação, em São Paulo, de novo equipamento de personalização, avaliação, prescrição, treinamento e competição para esportes paralímpicos de arremessos e oficina realizada em um curso de Braile desenvolvido pelo Cintesp.Br/UFU com apoio da PROEXC/UFU, em Uberlândia.</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula – jornalista Cintesp.Br/UFU</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O projeto “Transpor Barreiras” foi uma das atividades desenvolvidas pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (Cintesp.Br/UFU) voltado para a sociedade em geral para comemorar o dia “Internacional da Pessoa com Deficiência”, comemorado no dia 03/12 sendo instituído pela ONU desde 1992.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;"><strong>“<a href="https://www.youtube.com/watch?v=RpDIL15WNds" target="_blank" rel="noopener">Transpor Barreiras &#8211; incluir e informar</a>”</strong> é um projeto de formação continuada da área de educação inclusiva do Cintesp.Br/UFU, apoio da PROEXC/UFU e que busca a melhoria da acessibilidade e inclusão de Pessoas com Deficiência e Pessoas com Doenças Raras. Nas primeiras semanas de dezembro, foram desenvolvidas diversas atividades voltadas para a cultura e a educação com a proposta de gerar conhecimentos e divulgação do Braille e a Língua de Sinais (Libras). Todas as ações envolveram a comunidade externa, promoveram a iniciação do saber e a importância de empreender em favor de uma sociedade. As práticas inclusivas buscam uma sociedade cada vez mais acessível, por meio da pesquisa e extensão no processo de formação continuada e profissional.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">As atividades oferecidas envolveram cerca de 100 pessoas associadas à Adeviudi (Associação dos Deficientes Visuais de Uberlândia) e profissionais de diversos setores da cidade de Uberlândia. Em todas as atividades, os participantes conheceram novas técnicas e dispositivos para facilitar o desenvolvimento de habilidades e potencialidades humanas no aprendizado do Braille, participando de aulas de iniciação ao Braille, e aulas voltadas para uma formação básica em Libras.</span></p>\n<p><div id="attachment_8221" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8221" class="wp-image-8221 size-large" src="https://cintespbr.org/wp-content/uploads/2022/12/Sem-titulo-2-1024x380.png" alt="" width="1024" height="380" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-2-1024x380.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-2-300x111.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-2-768x285.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-2-1536x569.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-2.png 1913w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8221" class="wp-caption-text">Visitas guiadas nos Museus de Uberlândia: Centro Cultural e MUnA Fotos: Cintesp.Br/UFU</p></div></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Na área cultural, as atividades envolveram exposições ligadas à diversidade étnica indígena com exposições montadas na cidade de Uberlândia. A primeira foi no Centro Cultural, ligado à Secretaria Municipal de Cultura. Em seguida, os alunos foram levados, também em visita guiada, ao Museu Universitário de Arte MUnA ligado à Universidade Federal de Uberlândia (UFU). A experiência de visitar Museus da cidade superou todas as expectativas, para muitos alunos cegos, surdocegos ou de baixa visão, pois foi a primeira visita a uma exposição de arte. “Estou emocionado de ter tocado na peça, estive tocando no olho e nos dentinhos dela. Para mim é como se eu tivesse a tela uivando. É um sentimento assim. Eu tô até emocionado, é indescritível”, disse Dinarte Roque de Oliveira cego há dois anos, se referindo à experiência de conhecer, entre outras peças uma escultura em madeira em formato de uma onça, peça feita por índios da região.</span></p>\n<p><div id="attachment_8222" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8222" class="wp-image-8222 size-large" src="https://cintespbr.org/wp-content/uploads/2022/12/Sem-titulo-3-1024x509.png" alt="" width="1024" height="509" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-3-1024x509.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-3-300x149.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-3-768x382.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-3.png 1425w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8222" class="wp-caption-text">Oficinas de Braile no Cintesp.Br/UFU &#8211; Fotos: Cintesp.Br/UFU</p></div></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">As atividades ainda envolveram cursos, oficinas sensorial e tátil, oficinas para prática de leitura e oficinas para coordenação motora fina. Ao final foram entregues certificados e a entrega de um exemplar de jornal escrito em braile, traduzido e impresso pelo Cintesp.Br/UFU, produzida por alunos do quinto ano do ensino fundamental de uma Escola Municipal, a Escola Leôncio do Carmo Chaves. “A gente conseguiu avançar muito com a questão da tecnologia assistiva. Conseguimos desenvolver uma oficina maravilhosa com os alunos que em breve, e talvez até fevereiro, a gente consiga fazer a exposição dessa mostra inclusive com a criação de um método novo para acessibilidade, por meio de áudio descrição, então foi muito interessante assim essa adesão da sociedade foi muito importante”, acrescenta Ana Sara Tomé, pesquisadora do Cintesp.Br/UFU, da área da educação.</span></p>\n<p><div id="attachment_8223" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8223" class="wp-image-8223 size-large" src="https://cintespbr.org/wp-content/uploads/2022/12/Sem-titulo-4-1024x553.png" alt="" width="1024" height="553" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-4-1024x553.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-4-300x162.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-4-768x415.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-4.png 1312w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8223" class="wp-caption-text">Apresentações do equipamento de prescrição, treinamento, competição de arremessos. Fotos: CPB e Cintesp.Br/UFU</p></div></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Na área do paradesporto, a atividade do Cintesp.Br/UFU programada para comemorar o Dia Internacional da Pessoa com Deficiente aconteceu na cidade de São Paulo.  Foram 3 dias de provas que aconteceram no Centro de Treinamento do Comitê Paralímpico Brasileiro. O treinador de paratletismo e pesquisador do Cintesp.Br/UFU, Leandro Garcia apresentou o equipamento desenvolvido e patenteado para avaliação, prescrição, treinamento e competição na modalidade paralímpica de arremessos. Vários atletas, treinadores, comissão técnica do CPB e arbitragem experimentaram o equipamento e conheceram as inovações e as vantagens que prometem revolucionar a modalidade de arremessos no esporte paralímpico.</span></p>\n<p><div id="attachment_8224" style="width: 579px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8224" class="wp-image-8224 " src="https://cintespbr.org/wp-content/uploads/2022/12/Sem-titulo-5-1024x708.png" alt="" width="569" height="393" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-5-1024x708.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-5-300x207.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-5-768x531.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/12/Sem-titulo-5.png 1365w" sizes="(max-width: 569px) 100vw, 569px" /><p id="caption-attachment-8224" class="wp-caption-text">Vista lateral do equipamento de prescrição, de treinamento e de arremessos fixo por sistema magnético em plataforma de aço sendo apresentado para técnicos do MMFDH e MCTI, em Uberlândia.</p></div></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O equipamento é fixado a uma plataforma de aço que repousa sobre o solo que por meio de um potente imã prende o aparelho eliminando as amarras comumente usadas. Ele permite ainda, que sejam experimentadas novas posições de arremesso, potencializando a performance de cada paratleta. Entre os atletas que subiram no equipamento está a Beth Gomes recordista mundial de arremesso do peso na classe F52. “Ele fazendo todos os ajustes que precisam ser feitos para cada atleta, sendo um equipamento universal para cada um com sua deficiência, ele vai dar certo, muito certo”, comentou a recordista.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Outro que destacou as qualidades do equipamento foi o treinador Daniel Sena da equipe de Campo Grande /MS, “realmente isso aqui chegou para revolucionar, foi uma surpresa ver essa tecnologia, fiquei encantado, isso vai vir pra somar. O que mais me chamou a atenção, ponto forte para treinamento e competição, foram as diversas possibilidades de ajustes, o que nos ajudará nas intervenções para o treinamento, realmente ela é surpreendente”, destaca o treinador paralímpico.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A apresentação aconteceu durante o Meeting Paralímpico Loterias Caixa de Atletismo, Halterofilismo e Natação, idealizado e criado pelo Comitê Paralímpico Brasileiro (CPB). “Garanto a vocês que esse equipamento será o futuro do esporte paralímpico nas categorias de lançamentos e arremessos. Fiquei encantado com todo projeto, tenho certeza que nossos atletas já estão aprovando e quem sabe já vamos ter um equipamento desses de primeira linha nas próximas Paralimpíadas em 2024 e quem sabe no Panamericano no próximo ano”, destacou Yohansson Nascimento, vice presidente do CPB.</span></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula – jornalista Cintesp.Br/UFU O projeto “Transpor Barreiras” foi uma das atividades desenvolvidas pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (Cintesp.Br/UFU) voltado para a sociedade em geral para comemorar o dia “Internacional da Pessoa com Deficiência”, comemorado no dia 03/12 sendo instituído pela ONU desde 1992. “Transpor Barreiras &#8211;&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8224,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-8219",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8219",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8219",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8219/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8228,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8219/revisions/8228",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8224",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8219",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8219",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8219",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8214,
        date: "2022-11-30T20:34:33",
        date_gmt: "2022-11-30T23:34:33",
        guid: {
            rendered: "https://cintespbr.org/?p=8214",
        },
        modified: "2022-12-26T21:11:57",
        modified_gmt: "2022-12-27T00:11:57",
        slug: "equipamento-inovador-para-esportes-paralimpicos-de-arremessos-e-lancamentos-de-uso-universal-sera-apresentado-no-meeting-paralimpico-loterias-caixa-em-sao-paulo",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/equipamento-inovador-para-esportes-paralimpicos-de-arremessos-e-lancamentos-de-uso-universal-sera-apresentado-no-meeting-paralimpico-loterias-caixa-em-sao-paulo/",
        title: {
            rendered:
                "Equipamento inovador para esportes paralímpicos de arremessos e lançamentos de uso universal será apresentado no Meeting Paralímpico Loterias Caixa em São Paulo",
        },
        content: {
            rendered:
                '<p><div id="attachment_8215" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8215" class="wp-image-8215 size-large" src="https://cintespbr.org/wp-content/uploads/2022/11/Banco-1024x399.jpg" alt="" width="1024" height="399" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Banco-1024x399.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Banco-300x117.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Banco-768x299.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Banco-1536x598.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Banco.jpg 1956w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8215" class="wp-caption-text">Equipamento de avaliação, prescrição, treinamento e competição para o Atletismo Paralímpico sendo preparado para envio ao CPB pelos pesquisadores Leandro, Silvio e Cleudmar, coordenador geral do Cintesp.Br/UFU</p></div></p>\n<p><span style="font-size: 8pt;">Texto Cristiane de Paula – jornalista Cintesp.Br/UFU</span></p>\n<p><span style="font-size: 8pt;">Revisão técnica: Silvio Soares pesquisador Cintesp.Br/UFU</span></p>\n<p style="text-align: justify;">O equipamento promete revolucionar o mundo Paralímpico na modalidade esportiva de paratletismo (arremessos e lançamentos). A proposta do equipamento é substituir os atuais modelos de bancos existentes melhorando as marcas e índices nas modalidades de club, dardo, disco e peso nas diversas categorias de deficiência, assim como, na dinâmica e desenvolvimento dessas provas durante as competições.</p>\n<p style="text-align: justify;">Ele poderá atender até 90% das categorias de deficiência catalogadas no paratletismo. Uma vez o atleta no equipamento, em forma de um banco de arremessos, ele terá à disposição mais de 20 regulagens: de encosto, de altura, de inclinação e de alinhamento com a pista, bem como ajustes para a barra de apoio.</p>\n<p style="text-align: justify;">Outra grande novidade é a ausência das fitas de amarração, usadas atualmente para fixar os bancos ao solo.</p>\n<p style="text-align: justify;">O equipamento desenvolvido e patenteado pelo Cintesp.Br/UFU é fixado a uma plataforma de aço que repousa sobre o solo, por meio de um potente imã. “Temos aqui algo que vem sendo desejado há anos pelos atletas, treinadores e até mesmo pela equipe de arbitragem. O equipamento permite ainda, que sejam experimentadas novas posições de arremesso, potencializando ainda mais a performance de cada paratleta”, completa Leandro Garcia treinador e pesquisador do Cintesp.Br/UFU.</p>\n<p style="text-align: justify;">Os ajustes permitirão ao paratleta adequar a melhor configuração do equipamento  à sua deficiência, otimizando, dessa forma, a sua performance. A variedade e simplicidade dos ajustes do equipamento, permitem que ele seja usado por vários paratletas de diferentes categorias, agilizando, assim, as competições, no sentido de que não serão mais necessários transportar e trocar os bancos a cada novo atleta que inicie sua participação nas provas.</p>\n<p style="text-align: justify;">Outra grande vantagem da utilização desse inovativo equipamento é que ele dispensa a necessidade de os atletas levarem seu próprio banco para a competição, eliminando transtornos tais como: danificação de bancos, custos adicionais de transporte, ganho de espaço em ônibus, vans e aviões.</p>\n<p style="text-align: justify;">A apresentação será feita de 1 a 3 de Dezembro no Meeting Paralímpico Loterias Caixa, que acontece no Comitê Paralímpico Brasileiro (CPB) em São Paulo, pelos treinadores do paratletismo da Fundação Uberlandense do Turismo, Esporte e Lazer (FUTEL), parceira do Cintesp.Br/UFU, Leandro e Nivaldo Vital, por meio da Prefeitura de Uberlândia.</p>\n<p style="text-align: justify;">Por ter esse equipamento para múltiplas funções ele poderá ser utilizado para a prescrição de bancos de arremessos e lançamentos personalizados, para avaliação de rendimento, para treinamento e competições, “estamos iniciando um processo de parceria com o CPB ao apresentar-lhes esse equipamento que, já passou por inúmeras avaliações e testes por parte dos paratletas da Futel (Uberlândia). Nessa nova etapa, vamos para mais uma sessão de testes e avaliações, agora, durante o meeting da Caixa, um importante evento que acontece em SP, nas instalações do Centro de Treinamento do CPB”, completa Cleudmar Araújo, coordenador do Cintesp.Br/UFU.</p>\n<p style="text-align: justify;">Nesta apresentação no Meeting Caixa em SP, no CPB, todos os atletas poderão colaborar por meio da experimentação do equipamento e relatar suas percepções, adicionando mais informações ao equipamento e ao banco de dados do Cintesp.Br/UFU. Com as novas informações os pesquisadores poderão aperfeiçoar a atual versão. São esperadas ainda, sugestões de árbitros, treinadores e de dirigentes que estarão participando nesse Meeting no CPB.</p>\n<p style="text-align: justify;">O projeto foi desenvolvido pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (Cintesp.Br/UFU). Participaram da pesquisa Jonas Profeta Borges, Diego Augusto Costa Alves técnico administrativo “mecânico de montagem e manutenção” na Faculdade de Engenharia Mecânica. Juliana Cardoso Braga, prof. do curso de Design, Lucas de Souza Cardoso pós graduando da Faculdade de mecânica, Mário Eduardo Santos Rodrigues pós graduando da Faculdade de Engenharia Biomédica, Cleiton Soares Camilo Júnior pós graduando da Faculdade de Engenharia Mecânica, Sílvio Soares dos Santos pós-graduação em Biomecânica e Leandro Garcia técnico de paratletismo e preparador físico da FUTEL sob a supervisão e orientação do pesquisador Cleudmar Araújo, coordenador geral do Cintesp.Br/UFU.</p>\n<p style="text-align: justify;">O Cintesp.Br/UFU é referência no desenvolvimento de inovações em tecnologia assistiva (TA) voltadas para o esporte paralímpico e vem atuando buscando soluções de acordo com as demandas de atletas e treinadores paralímpicos. Os projetos são financiados pelo Ministério da Ciência, Tecnologia e Inovação (MCTI) e pelo Ministério Público do Trabalho (MPT/Uberlândia-MG).</p>\n<p style="text-align: justify;">O Centro de Pesquisas atua em rede colaborativa, multidisciplinar e em parcerias fortalecendo as pesquisas, acelerando os processos e aproximando os pesquisadores da sociedade. Em Uberlândia, os projetos acontecem em conjunto com a Prefeitura Municipal de Uberlândia por meio da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel), o Praia Clube de Uberlândia, o Grupo Algar, Algar Telecom e Brain Instituto de Ciência e Tecnologia, e Sesi Gravatás (Fiemg).</p>\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto Cristiane de Paula – jornalista Cintesp.Br/UFU Revisão técnica: Silvio Soares pesquisador Cintesp.Br/UFU O equipamento promete revolucionar o mundo Paralímpico na modalidade esportiva de paratletismo (arremessos e lançamentos). A proposta do equipamento é substituir os atuais modelos de bancos existentes melhorando as marcas e índices nas modalidades de club, dardo, disco e peso nas diversas&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8216,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-8214",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8214",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8214",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8214/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8217,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8214/revisions/8217",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8216",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8214",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8214",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8214",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8205,
        date: "2022-11-27T11:32:54",
        date_gmt: "2022-11-27T14:32:54",
        guid: {
            rendered: "https://cintespbr.org/?p=8205",
        },
        modified: "2022-11-27T23:30:11",
        modified_gmt: "2022-11-28T02:30:11",
        slug: "pesquisas-em-tecnologia-assistiva-realizado-pelo-cintesp-br-ufu-e-apresentado-em-evento-promovido-pelo-instituto-de-inovacao-e-gestao-de-desenvolvimento-do-produto-igdp",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/pesquisas-em-tecnologia-assistiva-realizado-pelo-cintesp-br-ufu-e-apresentado-em-evento-promovido-pelo-instituto-de-inovacao-e-gestao-de-desenvolvimento-do-produto-igdp/",
        title: {
            rendered:
                "Pesquisas em Tecnologia Assistiva realizadas pelo Cintesp.Br/UFU são  apresentadas em evento promovido pelo Instituto de Inovação e Gestão de Desenvolvimento do Produto (IGDP)",
        },
        content: {
            rendered:
                '<p><div id="attachment_8193" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8193" class="wp-image-8193 size-large" src="https://cintespbr.org/wp-content/uploads/2022/11/apresentacao-1024x708.png" alt="" width="1024" height="708" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/11/apresentacao-1024x708.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/apresentacao-300x207.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/apresentacao-768x531.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/apresentacao-1536x1062.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/apresentacao-2048x1416.png 2048w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8193" class="wp-caption-text">Fernando Lourenço, pesquisador do Cintesp.Br/UFU no XII Workshop em IGPD, IGDP Foto: divulgação IGPD</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula/ jornalista Cintesp.Br</span></p>\n<p style="text-align: justify;">O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (Cintesp.Br/UFU) participou da 19ª Semana Nacional de Ciência e Tecnologia (SNCT) do Conselho Nacional de Desenvolvimento Científico e Tecnológico (CNPq) com o envolvimento com a comunidade na promoção da Ciência, Tecnologia e Inovação em Tecnologia Assistiva (TA) por diversas frentes.</p>\n<p style="text-align: justify;">Uma delas foi no XII Workshop promovido pelo Instituto de Inovação e Gestão de Desenvolvimento do Produto (IGDP) em conjunto com a Universidade Federal de Itajubá/MG. No evento o Cintesp.Br/UFU foi representado pelo pesquisador Fernando Lourenço, ele desenvolve projetos de pesquisas de estruturas, dinâmica dos sistemas mecânicos e biomecânicos e trabalha com o Cintesp.Br em cooperação em projetos para esportes paralímpicos.</p>\n<p style="text-align: justify;">No whorkshop o pesquisador apresentou a calha paralímpica, um dos equipamentos patenteados e falou sobre o desenvolvimento das pesquisas em tecnologia assistiva realizadas pelo Cintesp.Br que este ano entregou 22 produtos sendo 8 patenteados e 10 licenciados para fabricação por empresa privada.</p>\n<p style="text-align: justify;">O CINTESP.Br/UFU desenvolve inovações em Tecnologia Assistiva com apoio financeiro do MCTI e MPT/Uberlândia, em formato de redes colaborativas, e parcerias com a Prefeitura de Uberlândia/Futel, Comitê Paralímpico Brasileiro (CPB), Algar, Praia Clube Uberlândia, Sesi/Gravatás-Fiemg, Aparu, Cddu, Adeviudi, Além de Parcerias com Laboratórios da UFU que atuam com projetos em Tecnologia Assistiva como: Laboratório de Modelos e Protótipos (LAMOP) e Laboratório de Usabilidade e Design Ergonômico (LUDE) da Faculdade de Arquitetura e Urbanismo e Design, Laboratório de Projetos Mecânicos (LPM), (NTA) núcleo de Tecnologia Assistiva e Laboratório de projeto , automação e validação (FEMEC Maker) da Faculdade de Engenharia Mecânica.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula/ jornalista Cintesp.Br O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (Cintesp.Br/UFU) participou da 19ª Semana Nacional de Ciência e Tecnologia (SNCT) do Conselho Nacional de Desenvolvimento Científico e Tecnológico (CNPq) com o envolvimento com a comunidade na promoção da Ciência, Tecnologia e Inovação em Tecnologia Assistiva (TA) por&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8193,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-8205",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8205",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8205",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8205/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8213,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8205/revisions/8213",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8193",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8205",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8205",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8205",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8201,
        date: "2022-11-27T11:27:10",
        date_gmt: "2022-11-27T14:27:10",
        guid: {
            rendered: "https://cintespbr.org/?p=8201",
        },
        modified: "2022-11-27T11:54:39",
        modified_gmt: "2022-11-27T14:54:39",
        slug: "cintesp-br-apresenta-equipamentos-patenteados-na-semana-nacional-de-ciencia-e-tecnologia-realizada-na-ufu",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-apresenta-equipamentos-patenteados-na-semana-nacional-de-ciencia-e-tecnologia-realizada-na-ufu/",
        title: {
            rendered:
                "Cintesp.Br apresenta equipamentos patenteados na Semana Nacional de Ciência e Tecnologia realizada na UFU",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8194" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8194" class="wp-image-8194 size-large" src="https://cintespbr.org/wp-content/uploads/2022/11/petra-1024x688.png" alt="" width="1024" height="688" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/11/petra-1024x688.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/petra-300x202.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/petra-768x516.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/petra-1536x1032.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/petra-2048x1376.png 2048w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8194" class="wp-caption-text">Apresentação da petra pelos pesquisadores Frederico Santos e Juliana Braga com Thiago Paluma Foto: Marco Cavalcanti</p></div></p>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8202" style="width: 879px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8202" class="wp-image-8202 size-full" src="https://cintespbr.org/wp-content/uploads/2022/11/ap.png" alt="" width="869" height="605" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/11/ap.png 869w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/ap-300x209.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/ap-768x535.png 768w" sizes="(max-width: 869px) 100vw, 869px" /><p id="caption-attachment-8202" class="wp-caption-text">Apresentação da calha paralímpica e cadeira de rodas para tênis de quadra pelo pesquisador Frederico Santos</p></div></p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]<span style="font-size: 8pt;">Texto: Cristiane de Paula – jornalista Cintesp.Br/UFU</span></p>\n<p style="text-align: justify;">A 19ª Semana Nacional de Ciência e Tecnologia (SNCT) do Conselho Nacional de Desenvolvimento Científico e Tecnológico (CNPq) ocorreu simultaneamente em todo o Brasil, as Universidades Federais, Institutos de Pesquisas promoveram diversas atividades. Na Universidade Federal de Uberlândia os eventos para promoção da ciência, da tecnologia e da inovação aconteceram de 10 a 12 deste mês no Campus Santa Mônica.</p>\n<p style="text-align: justify;">A apresentação de alguns dos equipamentos desenvolvidos pelo Cintesp.Br ocorreu no II Seminário de Pesquisa, evento promovido pela Pró-reitora de Pesquisa e Pós-graduação (Propp) que movimentou o Campus Santa Mônica. O Cintesp.Br levou 3 itens: a calha para bocha paralímpica categoria BC3, já patenteada, a cadeira de rodas para tênis de quadra, feita a partir de um equipamento desenvolvido pelo Centro de Pesquisas e já patenteado que oferece mais de 20 ajustes para a produção de cadeiras de rodas sob medida, por prescrição. A cadeira também foi licenciada pela UFU para produção em escala.</p>\n<p style="text-align: justify;">O terceiro item apresentado foi o triciclo para Frame Running (petra), utilizado por atletas com paralisia cerebral que permite à pessoa com deficiência (PcD) corre em seus próprios pés apoiados em um suporte, o equipamento desenvolvido pelo Cintesp.Br foi apresentado pelo curso de Design com desenho industrial de autoria da pesquisadora e designer do Cintesp.Br, Juliana Braga que também conseguiu a patente do desenho industrial da petra apresentada. Para o aluno Frederico Santos, que participou do projeto petra, a mostra estimula a pesquisa desenvolvida na sala de aula e laboratórios de pesquisas, “comecei nesse projeto com a iniciação científica que acabou virando o tema do meu TCC e agora estou dando continuidade no mestrado e ter conseguido o registro do desenho industrial é uma forma de consolidar todos esses anos de estudos” disse o pesquisador e aluno de mestrado da engenharia mecânica da UFU Frederico Santos.</p>\n<p style="text-align: justify;">Esta foi uma das formas de apresentar as etapas da pesquisa universitária que se inicia bem antes da elaboração de um projeto científico, “pra gente que trabalha na área de tecnologia assistiva um dos nossos objetivos é levar essas tecnologias para quem precisa, então essa</p>\n<p style="text-align: justify;">etapa de proteção intelectual também é um degrau que tem que ser percorrido que é quando a gente pode inserir essas tecnologias no mercado”, conclui Frederico Santos</p>\n<p style="text-align: justify;"> A mostra de equipamentos registrados e patenteados aconteceu no mesmo ambiente onde ocorreu a apresentação de pôsteres dos alunos dos diversos cursos de graduação da UFU,  “a iniciativa permite uma integração entre toda a comunidade acadêmica, a partir de projetos da graduação e da pós-graduação, a partir de um diálogo entre a pesquisa e a inovação”, completou o diretor Thiago Paluma.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Texto: Cristiane de Paula – jornalista Cintesp.Br/UFU A 19ª Semana Nacional de Ciência e Tecnologia (SNCT) do Conselho Nacional de Desenvolvimento Científico e Tecnológico (CNPq) ocorreu simultaneamente em todo o Brasil, as Universidades Federais, Institutos de Pesquisas promoveram diversas atividades. Na Universidade Federal de Uberlândia os eventos para promoção da ciência,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8202,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-8201",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8201",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8201",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8201/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8212,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8201/revisions/8212",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8202",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8201",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8201",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8201",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8198,
        date: "2022-11-27T10:58:57",
        date_gmt: "2022-11-27T13:58:57",
        guid: {
            rendered: "https://cintespbr.org/?p=8198",
        },
        modified: "2022-11-27T11:35:44",
        modified_gmt: "2022-11-27T14:35:44",
        slug: "ii-forum-novembro-branco-e-vermelho-surdocegueira-consciencia-e-reconhecimento",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ii-forum-novembro-branco-e-vermelho-surdocegueira-consciencia-e-reconhecimento/",
        title: {
            rendered:
                "II Fórum novembro branco e vermelho ‘Surdocegueira: consciência e (re)conhecimento’",
        },
        content: {
            rendered:
                '<p><div id="attachment_8195" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8195" class="wp-image-8195 size-large" src="https://cintespbr.org/wp-content/uploads/2022/11/Sem-titulo-1-1024x356.png" alt="" width="1024" height="356" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Sem-titulo-1-1024x356.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Sem-titulo-1-300x104.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Sem-titulo-1-768x267.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Sem-titulo-1-1536x534.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Sem-titulo-1-2048x712.png 2048w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8195" class="wp-caption-text">Abertura II Fórum novembro branco e vermelho ‘Surdocegueira: consciência e (re)conhecimento Foto Secom/PMU – Valter de Paula</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula- jornalista Cintesp.Br</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Nesta 19ª edição o tema foi “Bicentenário da Independência: 200 anos de Ciência, Tecnologia e Inovação no Brasil” o Cintesp.Br/UFU participou de diferentes atividades que envolveram a comunidade externa e interna da UFU.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Uma das atividades foi em apoio ao II Fórum novembro branco e vermelho ‘Surdocegueira: consciência e (re)conhecimento, dentro também dos eventos do ‘Novembro Branco e Vermelho’. O CintespBr participou, como apoiador do Fórum que aconteceu no Auditório Cícero Diniz, na Prefeitura Municipal de Uberlândia.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Um dos coordenadores foi coordenado pelo professor do Instituto de Letras e Linguística da UFU, José Carlos de Oliveira e também um dos palestrantes. Além do apoio do Cintesp.Br por meio da pesquisadora Ana Sara, uma das guias intérpretes que auxiliaram na realização e que fez parte da comissão organizadora do Fórum.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">José Carlos falou dos desafios de uma pessoa surdocega no atendimento por políticas públicas. Ele teve rubéola neonatal e retinose pigmentar. A questão da surdez começou a ser percebida aos 13 anos de idade, e aos 17 identificada a baixa-visão. Em agosto deste ano terminou o doutorado em estudos linguísticos, classificado como surdocego, ele é uma das pessoas que estão sempre à frente de eventos pela conscientização da deficiência e aumentar as ferramentas de inclusão e de detecção precoce da surdocegueira.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">em Uberlândia o IBGE identificou, no censo de 2010, 23 mil pessoas com algum grau de dificuldade de audição e 84 mil pessoas possuem alguma dificuldade de visão. Ao todo, são 1.309 surdos e 2 mil cegos moradores no município e pelo menos 30 surdocegos, o preconceito e a baixa autoestima e falta de mais ações em políticas públicas, de acordo com os organizadores do II Fórum são algumas questões que são enfrentadas para melhorar a inclusão e a acessibilidade.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">“Estamos lutando, com eventos na cidade para despertar a sociedade e a prefeitura em torno dessa questão. Em Uberlândia existem guias-interpretes (ouvintes) formados pela AHIMSA/SP e também guias-intérpretes surdos que apoiam os surdocegos na cidade, inclusive o Cintesp/UFU que vem desenvolvendo tecnologias para auxiliar na inclusão dessas pessoas”, completa o professor Carlos.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">De acordo com o professor Carlos, um dos organizadores do  II Fórum Novembro Branco e Vermelho &#8211; &#8220;Surdocegueira: Consciência e (re)conhecimento desta condição única&#8221; a comunidade começa a se organizar para conscientizar, já existem grupos de apoio e mobilização, por exemplo: grupo na UFU, Associação de surdos de Uberlândia (ASUL), “já realizamos dois seminários, relacionados ao tema na UFU, e agora realizamos o segundo Fórum e este com o apoio da prefeitura, assim, totalizando 4 na cidade, além de uma oficina de formação de guia-intérprete”, completa o professor.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Para falar a respeito da consciência e reconhecimento da surdocegueira, considerada como deficiência única vieram palestrantes do Rio de Janeiro, São Paulo e Brasília. Eles falaram entres outros assuntos sobre a trajetória educacional de um surdocego na rede pública de ensino, das lutas pelo reconhecimento e difusão da surdocegueira e ainda foi promovida uma roda de conversa que despertou a atenção para as barreiras, das políticas públicas, de tecnologias desenvolvidas para pessoas com deficiência e da criação de um Centro específico para a promoção do empreendedorismo voltado para a área da tecnologia assistiva.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Sobre esse assunto o coordenador do Cintesp.Br, Cleudmar Araújo que falou da implantação em Uberlândia do CNT, “Centro Nacional de Tecnologias para Pessoas com Deficiência e Doenças. Uma iniciativa do Ministério de Ciência, Tecnologia e Inovações que será instalado em 2023 no Campus Glória da UFU. O coordenador falou das pesquisas do Cintesp.Br com inovação em tecnologia assistiva desde final de 2019 e da rede colaborativa formada por pesquisadores multidisciplinares não apenas da UFU mas também de outros estados. “Contamos ainda com o forte apoio da UFU e parceria com a Prefeitura de Uberlândia, por meio da FUTEL. Nossos primeiros recursos vieram, em 2020, do Ministério da Ciência Tecnologia e Inovações (MCTI) e Ministério Público do Trabalho, região Uberlândia , o CNT vai ser o que o Brasil terá de novidade para fomentar as pesquisas em TA para pessoas com deficiência e com doenças raras, nossa missão principal será atrair o empreendedorismo para essa área e despertar a criação de startups para oferecer de maneira mais rápida e com menor dependência de importados mais inovação em TA para a sociedade”, completou o coordenador.</span></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula- jornalista Cintesp.Br Nesta 19ª edição o tema foi “Bicentenário da Independência: 200 anos de Ciência, Tecnologia e Inovação no Brasil” o Cintesp.Br/UFU participou de diferentes atividades que envolveram a comunidade externa e interna da UFU. Uma das atividades foi em apoio ao II Fórum novembro branco e vermelho ‘Surdocegueira: consciência e&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8199,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-8198",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8198",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8198",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8198/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8200,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8198/revisions/8200",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8199",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8198",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8198",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8198",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8191,
        date: "2022-11-27T10:51:43",
        date_gmt: "2022-11-27T13:51:43",
        guid: {
            rendered: "https://cintespbr.org/?p=8191",
        },
        modified: "2022-12-26T21:13:40",
        modified_gmt: "2022-12-27T00:13:40",
        slug: "cintesp-br-ufu-na-19a-semana-nacional-de-ciencia-e-tecnologia-apresentacoes-de-tecnologia-assistiva-envolvendo-a-comunidade-academica-e-a-sociedade",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-ufu-na-19a-semana-nacional-de-ciencia-e-tecnologia-apresentacoes-de-tecnologia-assistiva-envolvendo-a-comunidade-academica-e-a-sociedade/",
        title: {
            rendered:
                "Cintesp.Br/UFU na 19ª Semana Nacional de Ciência e Tecnologia: apresentações de tecnologia assistiva envolvendo a comunidade acadêmica e a sociedade",
        },
        content: {
            rendered:
                '<p><div id="attachment_8192" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8192" class="wp-image-8192 size-large" src="https://cintespbr.org/wp-content/uploads/2022/11/destac-1024x681.png" alt="" width="1024" height="681" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/11/destac-1024x681.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/destac-300x200.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/destac-768x511.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/destac-1536x1022.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/destac-2048x1363.png 2048w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8192" class="wp-caption-text">Pesquisadores do Cintesp.Br/UFU na 19ª SNCT/UFU e diretor de Inovação e Transferência de Tecnologia da UFU &#8211;  Foto: Marco Cavalcanti</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula – jornalista Cintesp.Br/UFU</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU) participou da 19ª Semana Nacional de Ciência e Tecnologia (SNCT) do Conselho Nacional de Desenvolvimento Científico e Tecnológico (CNPq) com o envolvimento com a comunidade na promoção da Ciência, Tecnologia e Inovação em Tecnologia Assistiva (TA) por diversas frentes.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A Semana Nacional de Ciência e Tecnologia (SNCT) ocorreu simultaneamente em todo o Brasil, as Universidades Federais e Institutos de Pesquisa promoveram diversas atividades. Na Universidade Federal de Uberlândia os eventos para promoção da ciência, da tecnologia e da inovação aconteceram de 10 a 12 deste mês no Campus Santa Mônica da UFU.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Nesta 19ª edição o tema foi “Bicentenário da Independência: 200 anos de Ciência, Tecnologia e Inovação no Brasil” o Cintesp.Br/UFU participou de diferentes atividades que envolveram a comunidade externa e interna da UFU.</span></p>\n<p><div id="attachment_8193" style="width: 510px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8193" class="wp-image-8193" src="https://cintespbr.org/wp-content/uploads/2022/11/apresentacao-300x207.png" alt="" width="500" height="346" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/11/apresentacao-300x207.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/apresentacao-1024x708.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/apresentacao-768x531.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/apresentacao-1536x1062.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/apresentacao-2048x1416.png 2048w" sizes="(max-width: 500px) 100vw, 500px" /><p id="caption-attachment-8193" class="wp-caption-text">Fernando Lourenço, pesquisador do Cintesp.Br/UFU no XII Workshop em IGPD, IGDP  &#8211; Foto: divulgação IGPD</p></div></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Dentro da programação do XII Workshop promovido pelo Instituto de Inovação e Gestão de Desenvolvimento do Produto (IGDP) em conjunto com a Universidade Federal de Itajubá/MG o pesquisador Fernando Lourenço fez uma palestra, no dia 10 sobre <strong><a href="https://cintespbr.org/?p=8205">desenvolvimento das pesquisas em tecnologia assistiva realizadas pelo Cintesp.Br/UFU</a></strong>.</span></p>\n<p><div id="attachment_8194" style="width: 510px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8194" class="wp-image-8194" src="https://cintespbr.org/wp-content/uploads/2022/11/petra-300x202.png" alt="" width="500" height="336" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/11/petra-300x202.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/petra-1024x688.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/petra-768x516.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/petra-1536x1032.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/petra-2048x1376.png 2048w" sizes="(max-width: 500px) 100vw, 500px" /><p id="caption-attachment-8194" class="wp-caption-text">Apresentação do Triciclo para Frame Running (Petra) pelos pesquisadores Frederico Santos e Juliana Braga ao diretor de Inovação e Transferência de Tecnologia da UFU, Thiago Paluma.</p></div></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Durante os dias 10 e 11 a participação foi no II Seminário de Pesquisa, evento promovido pela Pró-Reitoria de Pesquisa e Pós-Graduação (Propp). Na<a href="https://cintespbr.org/?p=8201"><strong> mostra de tecnologias </strong></a>presentou equipamentos patenteados e licenciados representando todas as pesquisas e produtos lançados este ano pelo Cintesp.Br.</span></p>\n<p><div id="attachment_8189" style="width: 510px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8189" class="wp-image-8189" src="https://cintespbr.org/wp-content/uploads/2022/11/juliana-300x200.png" alt="" width="500" height="333" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/11/juliana-300x200.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/juliana-1024x681.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/juliana-768x511.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/juliana-1536x1022.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/juliana-2048x1363.png 2048w" sizes="(max-width: 500px) 100vw, 500px" /><p id="caption-attachment-8189" class="wp-caption-text">Pesquisadora Juliana C. Braga recebendo Prêmio categoria: Desenho Industrial das mãos do diretor de Inovação e Transferência de Tecnologia da UFU, Thiago Paluma. Fotos: Ítana Santos</p></div></p>\n<p>No auditório da Fundação de Apoio Universitário (FAU) a doutora de design e pesquisadora do Cintesp.Br/UFU, Juliana C. Braga recebeu o <a href="https://cintespbr.org/?p=8188"><strong>1º Prêmio Professor Luiz Ricardo Goulart Filho para Inovação Tecnológica</strong>.</a></p>\n<p><div id="attachment_8195" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8195" class="wp-image-8195 size-large" src="https://cintespbr.org/wp-content/uploads/2022/11/Sem-titulo-1-1024x356.png" alt="" width="1024" height="356" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Sem-titulo-1-1024x356.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Sem-titulo-1-300x104.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Sem-titulo-1-768x267.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Sem-titulo-1-1536x534.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Sem-titulo-1-2048x712.png 2048w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8195" class="wp-caption-text">Abertura II Fórum novembro branco e vermelho ‘Surdocegueira: consciência e (re)conhecimento Foto Secom/PMU – Valter de Paula</p></div></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">E, encerrando as atividades externas dentro da Semana Nacional de Ciência e Tecnologia e como parte das comemorações do Novembro Branco e Vermelho, o Cintesp.Br/UFU participou, como apoiador do <a href="https://cintespbr.org/?p=8198"><strong>II Fórum novembro branco e vermelho ‘Surdocegueira: consciência e (re)conhecimento’. </strong></a>O Fórum aconteceu no Auditório Cícero Diniz, na Prefeitura Municipal de Uberlândia ele foi coordenado pelo professor do Instituto de Letras e Linguística da UFU, José Carlos de Oliveira e também um dos palestrantes. Além do apoio da pesquisadora do Cintesp.Br/UFU, Ana Sara, uma das guias intérpretes que auxiliaram na realização e parte da comissão organizadora do Fórum.  </span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O CINTESP.Br/UFU desenvolve inovações em Tecnologia Assistiva com apoio financeiro do MCTI e MPT/Uberlândia, em formato de redes colaborativas, e parcerias com a Prefeitura de Uberlândia/Futel, Comitê Paralímpico Brasileiro (CPB), Algar, Praia Clube Uberlândia, Sesi/Gravatás-Fiemg, Aparu, Cddu, Adeviudi, além de parcerias com laboratórios da UFU que atuam com projetos em Tecnologia Assistiva como: Laboratório de Modelos e Protótipos (LAMOP) e Laboratório de Usabilidade e Design Ergonômico (LUDE) da Faculdade de Arquitetura e Urbanismo e Design, Laboratório de Projetos Mecânicos (LPM), (NTA) núcleo de Tecnologia Assistiva e Laboratório de projeto , automação e validação (FEMEC Maker) da Faculdade de Engenharia Mecânica. Em março deste ano o CINTESP.Br/UFU realizou o Lançamento de 22 equipamentos em tecnologia assistiva, inovações das quais 8 com patentes e 11 com licenciamento e já em produção por empresa fabricante de cadeira de rodas.</span></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula – jornalista Cintesp.Br/UFU O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU) participou da 19ª Semana Nacional de Ciência e Tecnologia (SNCT) do Conselho Nacional de Desenvolvimento Científico e Tecnológico (CNPq) com o envolvimento com a comunidade na promoção da Ciência, Tecnologia e Inovação em Tecnologia Assistiva (TA)&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8192,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-8191",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8191",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8191",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8191/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8208,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8191/revisions/8208",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8192",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8191",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8191",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8191",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8188,
        date: "2022-11-27T10:24:54",
        date_gmt: "2022-11-27T13:24:54",
        guid: {
            rendered: "https://cintespbr.org/?p=8188",
        },
        modified: "2022-12-26T21:14:44",
        modified_gmt: "2022-12-27T00:14:44",
        slug: "pesquisadora-do-cintesp-br-recebe-premio-de-inovacao-tecnologica-da-universidade-federal-de-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/pesquisadora-do-cintesp-br-recebe-premio-de-inovacao-tecnologica-da-universidade-federal-de-uberlandia/",
        title: {
            rendered:
                "Pesquisadora do Cintesp.Br recebe prêmio de Inovação Tecnológica da Universidade Federal de Uberlândia",
        },
        content: {
            rendered:
                '<p><div id="attachment_8189" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8189" class="wp-image-8189 size-large" src="https://cintespbr.org/wp-content/uploads/2022/11/juliana-1024x681.png" alt="" width="1024" height="681" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/11/juliana-1024x681.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/juliana-300x200.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/juliana-768x511.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/juliana-1536x1022.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/juliana-2048x1363.png 2048w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8189" class="wp-caption-text">Pesquisadora Juliana Cardoso Braga recebendo Prêmio categoria: Desenho Industrial das mãos do diretor de Inovação e Transferência de Tecnologia da UFU, Thiago Paluma</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula-jornalista Cintesp.Br</span></p>\n<p style="text-align: justify;">A doutora em design e pesquisadora do Cintesp.Br/UFU, Juliana Cardoso Braga recebeu o 1º Prêmio Professor Luiz Ricardo Goulart Filho, criado este ano para homenagear pesquisadores da UFU na categoria Inovação Tecnológica.  A premiação aconteceu no auditório da Fundação de Apoio Universitário (FAU). O evento fez parte das atividades dentro da 19ª Semana Nacional de Ciência e Tecnologia (SNCT) do Conselho Nacional de Desenvolvimento Científico e Tecnológico (CNPq) com o envolvimento com a comunidade na promoção da Ciência, Tecnologia e Inovação. A “Premiação do Sistema de Pós-Graduação, Pesquisa e Inovação”, busca reconhecer trabalhos de destaque dentro da Universidade Federal de Uberlândia (UFU). É oferecido a professores e alunos que fazem pesquisa na Educação Básica, no Ensino Médio e Técnico, na Graduação e Pós-Graduação da UFU.</p>\n<p style="text-align: justify;">Juliana C. Braga é pesquisadora do Cintesp.Br/UFU onde desenvolve e colabora em diversos projetos de inovação em Tecnologia Assistiva (TA) para atender pessoas com deficiência, mobilidade reduzida e doenças raras nas áreas do paradesporto e vida diária. Ela é professora do curso de Design da Faculdade de Arquitetura Urbanismo e Design (Faued/UFU) e recentemente registrou no Instituto Nacional de Propriedade Intelectual – INPI, por meio da Agência Intelecto da UFU, o desenho industrial do triciclo para Frame Running (petra) em conjunto com outros pesquisadores do CINTESP.Br/UFU, entre eles, Cleudmar Araújo e Frederico Santos. O triciclo é voltado para a prática de esporte ou lazer de pessoas com paralisia cerebral.</p>\n<p style="text-align: justify;">O curso de Design, de acordo com dados da Agência Intelecto, é o maior depositário de registro de desenho industrial da UFU, nos últimos 5 anos saltou de 6 para 72 pedidos de registros de desenho industrial, contribuindo para classificação da UFU em posição de destaque no <em>ranking</em> de melhores universidades do mundo. “Os desafios continuarão a existir, o curso de Design continuará a trabalhar sem esmorecer, pois, sabemos onde queremos chegar e como isso irá contribuir para a UFU e para a sociedade. Me parece que somos um curso pequeno, mas que insiste em se comportar como um grande curso”, disse a doutora em design e pesquisadora do Cintesp.Br/UFU, Juliana C. Braga ganhadora do 1º Prêmio Professor Luiz Ricardo Goulart Filho de Inovação Tecnológica, categoria desenho industrial.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula-jornalista Cintesp.Br A doutora em design e pesquisadora do Cintesp.Br/UFU, Juliana Cardoso Braga recebeu o 1º Prêmio Professor Luiz Ricardo Goulart Filho, criado este ano para homenagear pesquisadores da UFU na categoria Inovação Tecnológica.  A premiação aconteceu no auditório da Fundação de Apoio Universitário (FAU). O evento fez parte das atividades dentro&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8189,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-8188",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8188",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8188",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8188/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8190,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8188/revisions/8190",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8189",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8188",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8188",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8188",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8181,
        date: "2022-11-07T21:55:40",
        date_gmt: "2022-11-08T00:55:40",
        guid: {
            rendered: "https://cintespbr.org/?p=8181",
        },
        modified: "2022-11-07T22:47:42",
        modified_gmt: "2022-11-08T01:47:42",
        slug: "defesa-de-mestrado-com-a-participacao-do-prof-rory-cooper-da-universidade-de-pittsburgh-eua-marca-o-processo-de-internacionalizacao-do-cintesp-br-ufu",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/defesa-de-mestrado-com-a-participacao-do-prof-rory-cooper-da-universidade-de-pittsburgh-eua-marca-o-processo-de-internacionalizacao-do-cintesp-br-ufu/",
        title: {
            rendered:
                "Defesa de mestrado com a participação do Prof. Rory Cooper da Universidade de Pittsburgh/EUA marca o processo de internacionalização do CINTESP.Br/UFU",
        },
        content: {
            rendered:
                '<p><div id="attachment_8182" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8182" class="wp-image-8182 size-large" src="https://cintespbr.org/wp-content/uploads/2022/11/Desta-1024x323.jpg" alt="" width="1024" height="323" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Desta-1024x323.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Desta-300x95.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Desta-768x243.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/Desta.jpg 1349w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8182" class="wp-caption-text">Banca internacional &#8211; vídeo conferência para defesa de mestrado do pesquisador do CINTESP.Br/UFU, Cleiton Soares. Imagem: internet</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula – jornalista CINTESP.Br/UFU</span></p>\n<p><span style="font-size: 8pt;">Revisão: Cleudmar Araújo – coord. CINTESP.Br/UFU</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Um momento histórico e importante para o Cintesp.Br, em seus quase 13 anos de existência, ocorreu no último dia 23/09, dando início ao seu processo de internacionalização.  Esta foi a primeira defesa de mestrado de um aluno/pesquisador do CINTESP.Br/UFU com a comunidade internacional.   Cleiton Soares fez a apresentação de sua pesquisa que resultou em um produto, com proteção junto ao INPI, de um &#8220;Elevador de transferência de PcD ou mobilidade reduzida para piscinas”. A banca foi aprovada pelo Programa de Pós-graduação em Engenharia Mecânica da UFU, um programa de pós-graduação de excelência da UFU e que faz parte da Faculdade de Engenharia Mecânica &#8211; UFU.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A apresentação aconteceu por meio de vídeo conferência, ela foi feita para o Prof. Rory Cooper e a equipe de engenharia humana de um dos laboratórios da Universidade de Pittsburgh, nos Estados Unidos.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Pelo Brasil a banca foi composta pelo coordenador geral do CINTESP.Br, professor Cleudmar Araújo como orientador e presidente da banca, professor pesquisador do CINTESP.Br Arthur Fiocchi pelo Programa de Pós-graduação em Engenharia Mecânica/UFU e pelos Estados Unidos participaram a pesquisadora do CINTESP.Br/UFU, Célia Lopes, professora da FAEFI/UFU que está em intercâmbio com o  HERL – Laboratório de Pesquisas em Engenharia Humana. Participaram também como convidados do HERL, Sara Peterson pesquisadora protética do Departamento de Assuntos de Veteranos, Shantanu A. Satpute aluno de doutorado da área de bioengenharia, Sivashankar Sivakanthan  doutorado em Ciências da Reabilitação, Jorge Candiotti pós-doutorando em Engenharia Humana e o Professor da Universidade de Pittsburgh e diretor do HERL, Dr. Rory Cooper. “Hoje foi um momento histórico de realização importante para  aprofundar a  parceria entre o  Cintesp.Br e o HERL/VA/Pitt, momentos como este fazem parte daqueles momentos inesquecíveis na vida que valem a pena; tornar realidade o sonho em ajudar as pessoas com deficiência a e vivermos num mundo melhor”, completa a Profa Célia Lopes.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O aluno e pesquisador Cleiton Soares respondeu perguntas de todos os integrantes da equipe do diretor Rory Cooper. A Banca durou quase duas horas até ser divulgado o resultado, com a aprovação do trabalho intitulado: &#8220;prototype of a swimming pool lift for people with disabilities&#8221;, considerado um dos momentos históricos na vida do pesquisador. Cleiton teve 10 minutos para apresentar o trabalho, em seguida respondeu às perguntas do prof. Rory Cooper que explorou a aplicação do elevador, as características inovadoras e concluiu destacando a importância do equipamento, sendo a acessibilidade um desafio de todos os países diferentemente da classificação econômica ou nível de pesquisas, sendo muito mais grave, a falta de equipamentos e pesquisas de promoção da inclusão de PcD em países de maior vulnerabilidade social. “Eu espero ter contribuído de alguma forma para o Cintesp.Br/UFU. Foi bem desafiador, mas conseguimos.”, Cleiton Soares, pesquisador do CINTESP.Br/UFU e aluno do programa de pós-graduação em engenharia mecânica-UFU candidato ao título de mestre.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">“Honrosamente participamos desse momento, fico feliz de fazer parte de um time com propósito tão nobre e que muda para melhor a vida das pessoas com deficiência e mobilidade reduzida. “Foi a primeira defesa internacional do CINTESPBr e já começamos com a participação de um dos maiores pesquisadores na área de tecnologia assistiva, que é o professor e doutor Rory Cooper”, acrescenta Arthur Fiocchi, pesquisador do CINTESP.Br/UFU</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O Cintesp.Br/UFU tem a missão de desenvolver inovações tem tecnologia assistiva para a realidade brasileira visando contribuir para a melhoria da qualidade de vida das pessoas com deficiência. De acordo com o coordenador do Cintesp.Br, Cleudmar Araújo, “Este produto está em fase de otimizações, sendo avaliado em ambiente relevante e até o final do ano estará licenciado para a sociedade brasileira. A banca discutiu pontos importantes, melhorias e sinalizou o potencial do projeto aprovando por unanimidade o Cleiton. Em especial, é um momento histórico que marca o início de muitas ações e parcerias com importantes pesquisadores do mundo que atuam com TA e fiquei muito honrado com a participação do Prof Rory Cooper, que é um dos maiores pesquisadores do mundo em TA.”</span></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula – jornalista CINTESP.Br/UFU Revisão: Cleudmar Araújo – coord. CINTESP.Br/UFU Um momento histórico e importante para o Cintesp.Br, em seus quase 13 anos de existência, ocorreu no último dia 23/09, dando início ao seu processo de internacionalização.  Esta foi a primeira defesa de mestrado de um aluno/pesquisador do CINTESP.Br/UFU com a comunidade&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8184,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-8181",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8181",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8181",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8181/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8186,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8181/revisions/8186",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8184",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8181",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8181",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8181",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8178,
        date: "2022-11-04T11:06:39",
        date_gmt: "2022-11-04T14:06:39",
        guid: {
            rendered: "https://cintespbr.org/?p=8178",
        },
        modified: "2022-11-30T20:37:07",
        modified_gmt: "2022-11-30T23:37:07",
        slug: "conhecimento-em-empreendedorismo-para-fortalecer-a-pesquisa-academica-e-a-industria-nacional",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/conhecimento-em-empreendedorismo-para-fortalecer-a-pesquisa-academica-e-a-industria-nacional/",
        title: {
            rendered:
                "Conhecimento em empreendedorismo para fortalecer a pesquisa acadêmica e a indústria nacional",
        },
        content: {
            rendered:
                '<p><div id="attachment_8179" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8179" class="wp-image-8179 size-large" src="https://cintespbr.org/wp-content/uploads/2022/11/dest-1024x566.png" alt="" width="1024" height="566" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/11/dest-1024x566.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/dest-300x166.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/dest-768x425.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/dest-1536x850.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/11/dest-2048x1133.png 2048w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8179" class="wp-caption-text">Roda de conversa sobre empreendedorismo no Programa de Pós-Graduação em Engenharia Mecânica da Universidade Federal de Uberlândia</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula – jornalista CINTESP.Br/UFU</span></p>\n<p><span style="font-size: 8pt;">Revisão técnica: Arthur Fiocchi – pesquisador CINTESP.Br/UFU</span></p>\n<p style="text-align: justify;">Imagine alunos de pós-graduação tendo noções de empreendedorismo. Este está sendo o direcionamento que um professor do Programa de Pós-Graduação em Engenharia Mecânica da Universidade Federal de Uberlândia (PPGEM/FEMEC/UFU) vem adotando em sala de aula. A novidade começou na retomada das aulas, depois do período de férias.</p>\n<p style="text-align: justify;">A proposta de colocar o assunto, “inovação e o mercado de trabalho”, nas questões diárias de sala de aula e das pesquisas acadêmicas foi do professor Arthur Alves Fiocchi, do (PPGEM/FEMEC/UFU) que também é pesquisador do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU). “Queremos conhecer mais do processo de inovação, transferência e licenciamento de tecnologia, estamos vivenciando essa necessidade no CINTESP.Br/UFU, que este ano entregou 22 equipamentos em Tecnologia Assistiva (TA), percebemos tantos projetos bons com potencial para gerar resultados para a sociedade e não discutimos em sala de aula o empreendedorismo como uma das metas para levar as pesquisas além da sala de aula”, comenta o professor Arthur Fiocchi. “Não fomos ensinados a inovar e esse vai ser um desafio que começará a ser apresentado aos alunos de graduação e pós-graduação para que usemos nossos conhecimentos em engenharia para resolver problemas da indústria e da sociedade. “Temos que incentivar o empreendedorismo e a inovação entre os alunos e professores”, completa Arthur.</p>\n<p style="text-align: justify;">A proposta provocou uma união de esforços além do professor Arthur Fiocchi do curso de manufatura aditiva, também está fazendo parte do novo desafio o professor de desenho de máquina Alexandre Zuquete Guarato, e os alunos da pós graduação.</p>\n<p style="text-align: justify;">Nesta primeira reunião, que terá agenda frequente, a convidada foi a professora Michelle Castro, da Faculdade de Gestão e Negócios (FAGEN/UFU), que também é consultora do Centro de Incubação de Atividades Empreendedoras (CIAEM/UFU), ela apresentou, no formato de roda de conversa, noções básicas sobre empreendedorismo. O bate papo superou as expectativas, a principal curiosidade foi sobre: quem pode ser empreendedor? “No caso dos alunos da Universidade, às vezes, eles não querem ter um negócio próprio, mas eles podem fazer parcerias e uma empresa, uma indústria pode produzir a ideia deles em escala e eles gerenciarem a ideia”, completa Michelle.</p>\n<p style="text-align: justify;">Para a consultora do CIAEM/UFU, é preciso desmistificar a palavra empreendedorismo, e divulgar o conceito de que empreender pode ser feito de diversas formas desde a abrir um negócio próprio até a levar inovação às empresas que já existem, forma conhecida como intraempreendedoríssimo, fazendo parcerias, fazendo licenciamentos ou como colaborador que desenvolve inovação em produtos ou processos.</p>\n<p style="text-align: justify;">Outra forma de empreender que demandou explicações foi a aplicação na área social,  questão levantada pelo doutorando e engenheiro mecânico, Henry Fong Hwang, “nós queremos conhecer mais formas de facilitar a transferência de tecnologia, de ampliar o acesso da população às inovações que desenvolvemos aqui nos laboratórios da Universidade”, disse Henry.</p>\n<p style="text-align: justify;">A professora, Juliana C. Braga, do curso de design e também pesquisadora do CINTESP.Br/UFU não só participou da iniciativa como convidou alunos do curso para incluírem o empreendedorismo nos projetos acadêmicos.</p>\n<p style="text-align: justify;">De acordo com o professor e pesquisador Arthur Fiocchi esse direcionamento com empreendedorismo e participação de áreas diferentes fortalece o processo de busca por inovação, tanto tecnológica ou de gestão, otimiza os resultados acadêmicos e os projetos de extensão. Ele considera que a iniciativa pode despertar para a mudança da realidade brasileira no caminho do desenvolvimento, com foco, inclusive, na redução da dependência tecnológica estrangeira e na promoção do desenvolvimento econômico e social, “entender que a união entre universidade, indústria, governo e sociedade é um dos caminhos de prosperidade para o Brasil”, completa o professor Arthur Fiocchi.</p>\n<p style="text-align: justify;">A principal questão discutida nessa roda de conversa foi entregar para a sociedade a inovação pesquisada e desenvolvida na Universidade. “toda a sociedade se beneficia, a empresa por ser diferente enquanto ela leva algo novo para o mercado e ela passa a ser diferente, consegue gerar maiores retornos, passa a ter diferencial competitivo no mercado, gera empregos de maior valor agregado, maior receita, mais renda, gera mais impostos para o governo e gera soluções inovadoras para o mercado. Então, toda a sociedade se beneficia disso” conclui a consultora e professora da FAGEN/UFU.</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula – jornalista CINTESP.Br/UFU Revisão técnica: Arthur Fiocchi – pesquisador CINTESP.Br/UFU Imagine alunos de pós-graduação tendo noções de empreendedorismo. Este está sendo o direcionamento que um professor do Programa de Pós-Graduação em Engenharia Mecânica da Universidade Federal de Uberlândia (PPGEM/FEMEC/UFU) vem adotando em sala de aula. A novidade começou na retomada das&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8179,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-8178",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8178",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8178",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8178/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8180,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8178/revisions/8180",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8179",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8178",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8178",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8178",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8171,
        date: "2022-10-05T11:46:55",
        date_gmt: "2022-10-05T14:46:55",
        guid: {
            rendered: "https://cintespbr.org/?p=8171",
        },
        modified: "2023-03-25T15:49:59",
        modified_gmt: "2023-03-25T18:49:59",
        slug: "libras-curso-oferecido-pelo-cintesp-br-inova-com-pesquisadores-da-area-da-educacao-inclusiva-na-formacao-continuada",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/libras-curso-oferecido-pelo-cintesp-br-inova-com-pesquisadores-da-area-da-educacao-inclusiva-na-formacao-continuada/",
        title: {
            rendered:
                "LIBRAS, Curso oferecido pelo CINTESP.Br inova com pesquisadores da área da educação inclusiva na Formação Continuada",
        },
        content: {
            rendered:
                '<p><div id="attachment_8172" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8172" class="wp-image-8172 size-large" src="https://cintespbr.org/wp-content/uploads/2022/10/imgPost-1024x351.jpg" alt="" width="1024" height="351" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/10/imgPost-1024x351.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/10/imgPost-300x103.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/10/imgPost-768x263.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/10/imgPost-1536x527.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/10/imgPost.jpg 1724w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8172" class="wp-caption-text">Aula inaugural do Curso de Formação Continuada Educação promovido pelo CINTESP.Br/UFU</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula – jornalista CINTESP.Br/UFU<br />\nRevisão técnica: Cleudmar Araújo – coord. CINTESP.Br/UFU</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU) deu início, nesta semana, ao primeiro Curso de Formação Continuada Educação, Pesquisa e Tecnologia em Libras. Com menos de 24 horas de inscrições pela internet, as  vagas haviam sido esgotadas e ainda foi gerada uma lista de espera com quase 200 interessados em aprender a Língua de Sinais, segunda língua oficial brasileira, “nós ficamos muito surpresos com a busca da população pelo conhecimento de aprender Libras, isso mostra que estamos no caminho certo e que a sociedade também busca ferramentas de inclusão e de maior acessibilidade e vamos buscar formas de atender ainda mais”, comenta Cleudmar Araújo, coordenador geral do CINTESP.Br/UFU, a respeito da grande procura pelo curso.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O curso é gratuito, uma iniciativa do Cintesp.Br/UFU na área de “Educação Inclusiva”, ele está associado às ações de inovação em tecnologia assistiva que propõe, nesta fase, o ensino de conhecimentos teórico-práticos introdutórios em Libras voltado à comunidade externa e aos pesquisadores e profissionais. É um projeto com apoio institucional da Pró-reitoria de Extensão, Cultura – PROEXC/UFU, Ministério Público do Trabalho-MPT/Uberlândia. As aulas acontecerão na Faculdade de Educação Física da UFU, o curso propõe a formação de 33 participantes que terão aulas até dezembro para cumprirem a carga de 80 horas, todas presenciais. As provas são realizadas considerando atividades práticas em Libras, textos complementares, participação ativa no grupo de estudo e pesquisas, atividades on-line, realização de vídeos em Libras, realização práticas com o uso de tecnologias concomitante à realização de provas presenciais, “para nós é importante ter essa sala cheia e a extensão, que esse momento de interação e troca de conhecimento, possa acontecer e acrescentar também a todos nós”, destaca Marlei José de Souza Dias, professora da divisão de Formação – Escola de Extensão da UFU e representante do  pró-reitor de Extensão, Cultura , professor Hélder Silveira.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O curso de Educação, Pesquisa e Tecnologia em Libras envolverá conhecimentos teórico-práticos com aspectos introdutórios em Libras com interface aos diversos campos do conhecimento e o fortalecimento no processo inclusivo de ensino-aprendizagem que propõe superar a fragmentação do saber e as barreiras comunicacionais e a importância considerando a cultura e história da pessoa com surdez. Com foco na inclusão e acessibilidade também farão parte da base do curso a fonologia, morfologia e sintaxe, bem como noções de escrita de sinais. “Não podemos tratar do aprendizado em Libras sem considerar o ser humano e o valor dele para esse processo de aquisição da Língua de Sinais, a história da educação e as organizações e marcos históricos no Brasil, leis e acessibilidade e o que mais venho aprendendo é o que desejamos oferecer aqui, me refiro ao potencial humano para uma comunicação sem barreiras”, completa Ana Sara Tomé, pesquisadora do CINTESP.Br/UFU.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O CINTESP.Br/UFU trabalha em formato de rede colaborativa com a sociedade e tem por excelência a pesquisa multidisciplinar envolvendo diversos laboratórios da UFU. Uma das pesquisadoras que fazem parte da área de educação inclusiva é professora da Faculdade de Educação Física e Fisioterapia (FAEFI), Eliane Maria de Carvalho, tem doutorado em Ciências em Fisiopatologia Experimental e participa da coordenação do curso de Libras. O formato do curso associa o conhecimento científico e o conteúdo que se forma entorno da pessoa com surdez. Desta forma é um projeto que envolve a academia e a sociedade. Estendendo até na criação de um Grupo de Estudos e Pesquisas com possibilidade de propor novas diretrizes para promover cada vez mais a difusão do ensino às pessoas com deficiência com o desenvolvimento de produções cientificas, “me emociono com o caminhar das ações propostas pela educação inclusiva, oferecer oportunidades para a ampliação do conhecimento do ser humano e suas necessidades para a promoção da inclusão seja em qual setor for, da educação, da saúde, lazer, qualidade de vida e no setor produtivo, foi surpreendente ver que a procura pelo curso foi de profissionais do comércio, da educação e prestação de serviços em geral, isso se trata de necessidade de ferramentas de inclusão acessíveis, a sociedade deseja inclusão”, completa a professora da Faculdade de Fisioterapia da UFU Eliane de Carvalho.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Uma das professoras do curso “Educação Inclusiva” será a intérprete de Libras e coordenadora do Pólen – Núcleo de Adequação, Acessibilidade e Pesquisa para a Diferença Humana do Centro Universitário do Triângulo (UNITRI), Alessandra da Silva, coautora do livro “Língua de Sinais Brasileira no Contexto do Ensino Superior”, uma publicação que reúne termos técnico-científicos publicado em 2005. O livro é uma das referências para alunos do ensino superior com surdez e baixa audição. Uma das raras publicações para o auxílio voltado para inclusão, em sala de aula, na formação de profissionais, “hoje promovemos acessibilidade a todas as doenças, temos muitos profissionais com surdez em diversas áreas que se formaram com a gente, neste curso não temos a pretensão de formar intérpretes, o importante agora é promovermos ferramentas em acessibilidade para formarmos interlocutores e com respeito às diferenças”, completa Alessandra Silva.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Também faz parte do time de professores do curso, Elaine Cristina Barbosa de Paula Bragança, pesquisadora do CINTESP.Br/UFU, na área da educação inclusiva. Surda desde um ano e meio de idade por complicações de meningite, ela atua na área de pesquisa e já ocupou o cargo de supervisora de conteúdo do MEC/SEESP no Programa Educação Inclusiva Direito à Diversidade, na área da surdez, “o surdo não pensa diferente do ouvinte, ele tem uma língua diferente, nós seres humanos, temos limites e nisso somos iguais. Cada pessoa tem seu jeito, o que se busca com a pesquisa e educação inclusiva é respeitar as necessidades e assim ultrapassar barreiras, o que é um sonho constante, bem como este que está sendo realizado por meio desse curso que vamos oferecer até dezembro”, completa Elaine, professora de Libras e pesquisadora do CINTESP.Br/UFU.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O CINTESP.Br/UFU desenvolve inovações em Tecnologia Assistiva com apoio financeiro do MCTI e MPT/Uberlândia, em formato de redes colaborativas, e parcerias com a Prefeitura de Uberlândia/Futel, Comitê Paralímpico Brasileiro (CPB), Algar, Praia Clube Uberlândia, Sesi/Gravatás-Fiemg, Aparu, Apavu, Cddu, Adeviudi, Além de Parcerias com Laboratórios da UFU que atuam com projetos em Tecnologia Assistiva como: Laboratório de Modelos e Protótipos (LAMOP) e Laboratório de Usabilidade e Design Ergonômico (LUDE) da Faculdade de Arquitetura e Urbanismo e Design, Laboratório de Projetos Mecânicos (LPM), (NTA) núcleo de Tecnologia Assistiva e Laboratório de projeto , automação e validação (FEMEC Maker) da Faculdade de Engenharia Mecânica.</span></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula – jornalista CINTESP.Br/UFU Revisão técnica: Cleudmar Araújo – coord. CINTESP.Br/UFU O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU) deu início, nesta semana, ao primeiro Curso de Formação Continuada Educação, Pesquisa e Tecnologia em Libras. Com menos de 24 horas de inscrições pela internet, as  vagas haviam sido&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8173,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [62],
        tags: [],
        class_list: [
            "post-8171",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-todas-as-noticias",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8171",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8171",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8171/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8176,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8171/revisions/8176",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8173",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8171",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8171",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8171",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8163,
        date: "2022-09-26T23:43:12",
        date_gmt: "2022-09-27T02:43:12",
        guid: {
            rendered: "https://cintespbr.org/?p=8163",
        },
        modified: "2022-10-05T11:49:10",
        modified_gmt: "2022-10-05T14:49:10",
        slug: "associacao-dos-deficientes-visuais-de-uberlandia-visita-sede-do-cintesp-br-ufu-para-conhecer-tecnologias-desenvolvidas-para-pessoas-cegas-e-realiza-visita-guiada-ao-parque-siquierolli",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/associacao-dos-deficientes-visuais-de-uberlandia-visita-sede-do-cintesp-br-ufu-para-conhecer-tecnologias-desenvolvidas-para-pessoas-cegas-e-realiza-visita-guiada-ao-parque-siquierolli/",
        title: {
            rendered:
                "Associação dos Deficientes Visuais de Uberlândia visita sede do CINTESP.Br/UFU para conhecer tecnologias desenvolvidas para pessoas cegas e realiza visita guiada ao parque Siquierolli",
        },
        content: {
            rendered:
                '<p><div id="attachment_8165" style="width: 2330px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8165" class="wp-image-8165 size-full" src="https://cintespbr.org/wp-content/uploads/2022/09/adeviudi-1.png" alt="" width="2320" height="838" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/09/adeviudi-1.png 2320w, https://cintespbr.institucional.ws/wp-content/uploads/2022/09/adeviudi-1-300x108.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/09/adeviudi-1-1024x370.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/09/adeviudi-1-768x277.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/09/adeviudi-1-1536x555.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/09/adeviudi-1-2048x740.png 2048w" sizes="(max-width: 2320px) 100vw, 2320px" /><p id="caption-attachment-8165" class="wp-caption-text">Visitação guiada de deficientes visuais e auditivos às instalações do CINTESP.Br/UFU e Parque Siquierolli em Uberlândia</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula – jornalista CINTESP.Br/UFU</span></p>\n<p style="text-align: justify;">Com um setor voltado para a área de educação inclusiva, o CINTESP.Br/UFU inicia o projeto de visitas guiadas para integrar deficientes auditivos, pessoas cegas e com baixa visão a espaços públicos instalados na cidade de Uberlândia.</p>\n<p style="text-align: justify;">Prestes a completar 3 anos, o CINTESP.Br/UFU iniciou mais um projeto para atender a sociedade com deficiência visual, é a visita guiada. A primeira instituição a receber a ação foi a <a href="https://adeviudi.com/">Associação dos Deficientes Visuais de Uberlândia (ADEVIUDI)</a>. A programação teve início nos laboratórios instalados na Arena Sabiazinho, uma parceria com a Prefeitura de Uberlândia, por meio da FUTEL. A visita guiada consiste em ter o acompanhamento de uma ou mais pesquisadoras da área da educação inclusiva. Com o conhecimento das técnicas de transcrição, a pesquisadora Ana Sara apresentava os ambientes dando detalhes do espaço, dos equipamentos com riqueza de detalhes descrevendo todo o cenário por onde o grupo passava. Participaram da visita guiada 11 pessoas cegas e com baixa visão já atendidas pela ADEVIUDI, “foi muito importante conhecermos o que está sendo feito aqui no CINTESP, os materiais que estão sendo adaptados, a bengala especial que vibra antes do obstáculo para deficiente visual ou acende uma luzinha pra quem tem baixa visão e o que vocês tem aqui para melhorar o aprendizado do braile que pra nós é muito importante”, destaca Fernanda de Oliveira, deficiente visual e professora de Braile da ADEVIUDI.</p>\n<p style="text-align: justify;">Depois de conhecerem as instalações e alguns projetos do CINTESP.Br/UFU, o grupo foi levado ao Parque Siquierolli, um dos parques preservados da cidade de Uberlândia, localizado na Zona Norte. Além de conhecerem o local, vivenciando os ambientes do Parque, os visitantes conheceram na metodologia “Para Cego Ver”, o Museu do Cerrado e puderam ter despertadas sensações por meio dos sentidos ao terem a descrição do espaço, objetos e natureza, por onde passavam. “Foi muita coisa boa, muita emoção ao mesmo tempo”, completa Fernanda.</p>\n<p style="text-align: justify;">Antes de programar as visitas, a pesquisadora Ana Sara fez o levantamento dos principais locais públicos que já estavam na lista da Associação para promover o momento de lazer aos deficientes visuais e auditivos. “Essa ação da área de ensino do CINTESP.Br/UFU tem o objetivo de mostrar os recursos e tecnologias que desenvolvemos voltados para pessoas com deficiência, como também de promover essa interação e envolvimento social. Fiz uma pesquisa com eles, participei de rodas de conversa e descobri que eles tinham muita vontade de conhecer outros lugares daqui de Uberlândia e decidimos então ir ao Parque Siquierolli. Então, essa é a proposta de apresentar nosso trabalho desenvolvido na área de Educação Inclusiva aqui no CINTESP.Br/UFU e levar ao fortalecimento de vínculos”, completa a pesquisadora Ana Sara.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula – jornalista CINTESP.Br/UFU Com um setor voltado para a área de educação inclusiva, o CINTESP.Br/UFU inicia o projeto de visitas guiadas para integrar deficientes auditivos, pessoas cegas e com baixa visão a espaços públicos instalados na cidade de Uberlândia. Prestes a completar 3 anos, o CINTESP.Br/UFU iniciou mais um projeto para&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8164,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-8163",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8163",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8163",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8163/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8166,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8163/revisions/8166",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8164",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8163",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8163",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8163",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8159,
        date: "2022-09-22T23:12:18",
        date_gmt: "2022-09-23T02:12:18",
        guid: {
            rendered: "https://cintespbr.org/?p=8159",
        },
        modified: "2022-09-26T23:44:42",
        modified_gmt: "2022-09-27T02:44:42",
        slug: "inovacao-em-tecnologia-assistiva-produzida-pelo-cintesp-br-ufu-sera-usada-em-campeonato-nacional-realizado-em-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/inovacao-em-tecnologia-assistiva-produzida-pelo-cintesp-br-ufu-sera-usada-em-campeonato-nacional-realizado-em-uberlandia/",
        title: {
            rendered:
                "Inovação em Tecnologia Assistiva produzida pelo CINTESP.Br/UFU será usada em Campeonato Nacional realizado em Uberlândia",
        },
        content: {
            rendered:
                '<p><div id="attachment_8160" style="width: 810px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8160" class="wp-image-8160" src="https://cintespbr.org/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-22-at-15.56.28-1024x572.jpeg" alt="" width="800" height="446" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-22-at-15.56.28-1024x572.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-22-at-15.56.28-300x167.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-22-at-15.56.28-768x429.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-22-at-15.56.28.jpeg 1213w" sizes="(max-width: 800px) 100vw, 800px" /><p id="caption-attachment-8160" class="wp-caption-text">Paratleta usando uma calha para bocha paralímpica categoria BC3 &#8211; Imagem: arquivo CINTESP.Br/UFU</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula – jornalista CINTESP.Br/UFU</span></p>\n<p><span style="font-size: 8pt;">Revisão: Silvio Soares – pesquisador CINTESP.Br/UFU</span></p>\n<p style="text-align: justify;">A calha para bocha paralímpica para categoria BC3, será a inovação em tecnologia assistiva (TA) desenvolvida pelo CINTESP.Br/UFU que será testada neste Campeonato Nacional. Ela é um equipamento que apresenta características inéditas e já patenteado pela Universidade Federal de Uberlândia.</p>\n<p style="text-align: justify;">As competições do Campeonato Nacional de Bocha Paralímpica terão início neste domingo (25). Elas serão realizadas na Arena Sabiazinho, em Uberlândia. O Torneio é uma realização da Associação Nacional de Desporto para Deficientes (Ande), com o apoio da Prefeitura de Uberlândia, por meio da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel).</p>\n<p style="text-align: justify;">Para a realização do Campeonato, a Arena do Ginásio Sabiazinho será dividida em 10 quadras para competição da bocha paralímpica. Cada partida será importante para somar pontos e melhorar a posição dos paratletas nos rankings nacional e internacional.</p>\n<p style="text-align: justify;">Serão quase 400 participantes, o maior evento já realizado no Brasil, dos quais 149 são paratletas em competição até o dia 30. Cristiano Silva, Luiz Humberto Naves Filho, Pedro Henrique e Gustavo David da Aparu, o treinador da seleção brasileira Glênio Fernandes que também é profissional de educação física da Futel além de, Mateus Carvalho do Clube Desportivo para Deficientes de Uberlândia (CDDU/Praia/ Futel), devem participar deste evento. Mateus foi, este ano, ouro e prata no World Boccia Challenger, em Roma, na Itália.</p>\n<p style="text-align: justify;">Quem utilizará a calha da bocha paralímpica, produzida pelo CINTESP.Br/UFU para categoria BC3, será a paratleta Karen da Adefu (Associação dos Deficientes Físicos de Uberaba).  Karen utiliza a nova calha há dois meses, estreou no Campeonato Brasileiro de Jovens conseguindo ganhar 4 parciais, superando os resultados do Campeonato anterior. “É muito boa, (a calha), o equipamento é muito fácil de manusear, ela (a Karen) usava um bocha importada. Essa calha agora é mais para o jeito dela soltar a bola, é mais funcional,  e ela desenvolve mais o potencial técnico de jogo, estamos fazendo uma experiência com os pesquisadores para chegar ao modelo ideal pra Karen, já tivemos um grande avanço”, completa Janaína Pessato, mãe e treinadora da Karen.</p>\n<p style="text-align: justify;">O CINTESP.Br/UFU fez o lançamento ao público da calha em março deste ano durante o LANCE PcD 2022, evento onde também foram lançados outros 20 produtos de inovação em tecnologia assistiva. Todos os produtos com registro de patente e alguns já licenciados pela UFU. São equipamentos voltados para o paradesporto, vida diária,  para o lazer, saúde e educação para pessoas com deficiência, com mobilidade reduzida e com doenças raras. Além da inovação tecnológica uma outra característica da tecnologia assistiva é a de ser 100% nacional, possibilitando menor custo de aquisição que os equipamentos encontrados no mercado.</p>\n<p style="text-align: justify;">O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU), desde o final de 2019, com financiamentos do Ministério da Ciência, Tecnologia e Inovação (MCTI)  e Ministério Público do Trabalho (MPT/Região Uberlândia), desenvolve pesquisas de inovações em tecnologia assistiva (TA) em diversas modalidades do esporte paralímpico. Uma parceria que envolve a Prefeitura Municipal de Uberlândia por meio da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel), o Comitê Paralímpico Brasileiro (CPB), o Praia Clube de Uberlândia, o Grupo Algar, Algar Telecom e Brain Instituto de Ciência e Tecnologia, Sesi Gravatás (Fiemg) além de trabalhar  em Rede Colaborativa multidisciplinar com diversos Centros de pesquisas do país.</p>\n<p style="text-align: justify;">A tecnologia assistiva desenvolvida pelo CINTESP.Br/UFU para as calhas auxilia no direcionamento das jogadas proporcionando um aumento cada vez maior da eficiência das jogadas, somando com o paratleta a técnica e o talento para alcançar resultados cada vez melhores.</p>\n<p style="text-align: justify;">De acordo com, Sílvio Soares, pesquisador do CINTESP.Br, para se chegar à inovação em tecnologia assistiva da calha e de outros equipamentos desenvolvidos, foi tomado como base, depoimentos de paratletas de alto rendimento, à partir de suas percepções acerca desses equipamentos: “foram muitos estudos feitos, vários eventos-teste desenvolvidos para validação deles, busca de soluções para os problemas que se apresentavam, desde a curvatura e largura da calha à forma que a bola sai da mesma e entra em contato com o solo, aferição de velocidades etc.”, completa o pesquisador Silvio Soares. Outra inovação da calha desenvolvida pelo CINTESP.Br/UFU é a fabricação por manufatura aditiva (impressão 3D) reduzindo seu custo e peso o que facilita, sobremaneira, o transporte.</p>\n<p style="text-align: justify;">A bocha adaptada estreou em 1984, nos Jogos Paralímpicos de Stoke Mandeville. O jogo de bocha consiste em empurrar as bolas coloridas o mais perto possível de uma bola branca.</p>\n<p style="text-align: justify;">No caso dos paratletas, eles disputam em classes de acordo com o nível da deficiência. Para o jogo eles ficam sentados em cadeiras de rodas e limitados a um espaço demarcado para fazer os arremessos. Para aqueles com limitação severa de movimentos, a maioria com paralisia cerebral, o movimento da bola dentro da calha é produzido pelo acionamento de uma ponteira ou antena fixada a um capacete utilizado pelo atleta. Para o êxito da jogada cabe ao paratleta toda a competência em obter o melhor ângulo e inclinação da calha para que a bola atinja o objetivo, que é o de chegar o mais perto possível da bola branca ou bloquear as jogadas do adversário. Os jogadores são auxiliados pelos “calheiros”, que posicionam a canaleta conforme a orientação do paratleta.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula – jornalista CINTESP.Br/UFU Revisão: Silvio Soares – pesquisador CINTESP.Br/UFU A calha para bocha paralímpica para categoria BC3, será a inovação em tecnologia assistiva (TA) desenvolvida pelo CINTESP.Br/UFU que será testada neste Campeonato Nacional. Ela é um equipamento que apresenta características inéditas e já patenteado pela Universidade Federal de Uberlândia. As competições&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8160,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-8159",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8159",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8159",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8159/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8162,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8159/revisions/8162",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8160",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8159",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8159",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8159",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8149,
        date: "2022-09-14T17:29:32",
        date_gmt: "2022-09-14T20:29:32",
        guid: {
            rendered: "https://cintespbr.org/?p=8149",
        },
        modified: "2022-09-22T23:13:12",
        modified_gmt: "2022-09-23T02:13:12",
        slug: "cintesp-br-em-especial-no-ciencia-o-pe-do-ouvido-um-programa-no-spotify-da-universidade-federal-de-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-em-especial-no-ciencia-o-pe-do-ouvido-um-programa-no-spotify-da-universidade-federal-de-uberlandia/",
        title: {
            rendered:
                "Tecnologia no paradesporto e a participação do CINTESP.Br no &#8220;Ciência o Pé do Ouvido&#8221;, o Podcast produzido pela Diretoria de Comunicação da  Universidade Federal de Uberlândia.",
        },
        content: {
            rendered:
                '<p><div id="attachment_8150" style="width: 1290px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8150" class="wp-image-8150 size-full" src="https://cintespbr.org/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-13-at-16.38.25.jpeg" alt="" width="1280" height="725" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-13-at-16.38.25.jpeg 1280w, https://cintespbr.institucional.ws/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-13-at-16.38.25-300x170.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-13-at-16.38.25-1024x580.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-13-at-16.38.25-768x435.jpeg 768w" sizes="(max-width: 1280px) 100vw, 1280px" /><p id="caption-attachment-8150" class="wp-caption-text">Arte: Ludimila de Castro</p></div></p>\n<p><span style="font-size: 10pt;">Texto: Cristiane de Paula</span></p>\n<p style="text-align: justify;">No mês em que se comemora o Dia Nacional de Luta da Pessoa com Deficiência (21/09) o instituído em 2005 pela Lei de nº 11.133, o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos CINTESP.Br/UFU, representado pelo pesquisador Lucas Cardoso juntamente com a paratleta  em arremessos, Fabiana Fernandes da Associação dos Paraplégicos de Uberlândia (APARU) foram os convidados para participarem do Podcast Ciência ao Pé do Ouvido da Universidade Federal de Uberlândia (UFU).</p>\n<p style="text-align: justify;">O programa #64, do Ciência ao Pé do Ouvido, foi um especial para o Mês em que se comemora o Dia Nacional de Luta da Pessoa com Deficiência. O tema do bate papo com os jornalistas Túlio Daniel e Cristiane de Paula foi: Tecnologia assistiva: a ciência por trás do paradesporto.</p>\n<p style="text-align: justify;">No programa eles falaram das etapas de uma pesquisa na área de Tecnologia Assistiva (TA), da importância do esporte na vida e recuperação da pessoa com deficiência e as etapas de uma pesquisa até ser disponibilizada para o uso da população.</p>\n<p style="text-align: justify;">Você pode ouvir o podcast na sua plataforma de Streaming favorita:</p>\n<p style="text-align: justify;"><strong><a href="https://open.spotify.com/show/5DcAFQhER3S1xFVsYLfuc9" target="_blank" rel="noopener">Spotify</a></strong>, <strong><a href="https://podcasts.apple.com/br/podcast/ci%C3%AAncia-ao-p%C3%A9-do-ouvido/id1579938868" target="_blank" rel="noopener">Apple Podcasts</a></strong>, <strong><a href="https://music.amazon.com.br/podcasts/cb53097d-7e66-47d1-89ba-207a23c8df83/ci%C3%AAncia-ao-p%C3%A9-do-ouvido" target="_blank" rel="noopener">Amazon Music</a></strong>, <strong><a href="https://www.deezer.com/br/show/2874722" target="_blank" rel="noopener">Deezer</a></strong>, <strong><a href="https://radiopublic.com/cincia-ao-p-do-ouvido-6VZn50" target="_blank" rel="noopener">Radio Public</a></strong> e <strong><a href="https://anchor.fm/cienciaaopedoouvido" target="_blank" rel="noopener">Anchor</a></strong>.</p>\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula No mês em que se comemora o Dia Nacional de Luta da Pessoa com Deficiência (21/09) o instituído em 2005 pela Lei de nº 11.133, o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos CINTESP.Br/UFU, representado pelo pesquisador Lucas Cardoso juntamente com a paratleta  em arremessos, Fabiana Fernandes da&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8150,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-8149",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8149",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8149",
                },
            ],
            "version-history": [
                {
                    count: 7,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8149/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8157,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8149/revisions/8157",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8150",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8149",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8149",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8149",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8104,
        date: "2022-08-27T14:09:06",
        date_gmt: "2022-08-27T17:09:06",
        guid: {
            rendered: "https://cintespbr.org/?p=8104",
        },
        modified: "2023-03-25T15:49:16",
        modified_gmt: "2023-03-25T18:49:16",
        slug: "cadeiras-de-rodas-de-vida-diaria-e-de-alto-rendimento-desenvolvidas-no-cintesp-br-ufu-com-metodologia-inedita-de-personalizacao-sao-licenciadas-para-comercializacao-pela-industria",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cadeiras-de-rodas-de-vida-diaria-e-de-alto-rendimento-desenvolvidas-no-cintesp-br-ufu-com-metodologia-inedita-de-personalizacao-sao-licenciadas-para-comercializacao-pela-industria/",
        title: {
            rendered:
                "Cadeiras de rodas de vida diária e de alto rendimento desenvolvidas no Cintesp.Br/UFU, com metodologia inédita de personalização são licenciadas para comercialização pela indústria.",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8105" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8105" class="wp-image-8105 size-large" src="https://cintespbr.org/wp-content/uploads/2022/08/cad1-1024x988.jpg" alt="" width="1024" height="988" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/08/cad1-1024x988.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/cad1-300x289.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/cad1-768x741.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/cad1.jpg 1356w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8105" class="wp-caption-text">Equipamento para prescrição de cadeira de rodas com metodologia inédita. Imagem: Marco Cavalcanti &#8211; Dirco/UFU</p></div></p>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8106" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8106" class="wp-image-8106 size-large" src="https://cintespbr.org/wp-content/uploads/2022/08/cad2-1024x903.jpg" alt="" width="1024" height="903" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/08/cad2-1024x903.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/cad2-300x265.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/cad2-768x677.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/cad2.jpg 1464w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8106" class="wp-caption-text">Cadeiras de rodas para esgrima e para tênis de quadra feitas por prescrição. Imagem: SECOM-PMU/Valter de Paula</p></div></p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]<span style="font-size: 8pt;">Texto: Cristiane de Paula – jornalista CINTESP.Br/UFU</span></p>\n<p><span style="font-size: 8pt;">Revisão: Lucas Cardoso: pesquisador CINTESP.Br/UFU e Cleudmar Araújo- coord. geral CINTESP.Br/UFU</span></p>\n<p>Fazer uma cadeira de rodas personalizada, sob medida de acordo com a deficiência e com a necessidade de uso, seja no esporte ou para a vida diária é um desejo da sociedade que agora está ao alcance das pessoas com deficiência, com mobilidade reduzida e com doenças raras.</p>\n<p>Utilizando metodologia inédita de prescrição, com o auxílio de um equipamento desenvolvido pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos CINTESP.Br/UFU, A Universidade Federal de Uberlândia licenciou dez modelos de cadeiras de rodas e outros dois dispositivos para cadeiras de rodas. O licenciamento permite a fabricação pela indústria e a comercialização para a sociedade.</p>\n<p>“Este é o primeiro processo de licenciamento entre o CINTESP.Br, a UFU e o setor produtivo. É um momento histórico, pois o nosso sonho de levar as tecnologias além dos “muros” da Universidade, entregando-as para as pessoas,  começa a se concretizar e com isso, nossa missão de melhorar a qualidade de vida das pessoas, aumentar a inclusão social e gerar riquezas para o Brasil vai sendo cumprida”, destaca Cleudmar Araújo, coordenador-geral do CINTESP.Br/UFU.</p>\n<p>O fabricante que recebeu a concessão para produzir e vender as cadeiras de rodas personalizadas e os dispositivos tem sede em Goiânia. A Mover Cadeira de Rodas tem clientes em todo o país, a empresa vem sendo parceira do CINTESP.Br/UFU desde o início do processo de experimentação, fez vários modelos de testes até o ajuste final do equipamento.</p>\n<p>A empresa já começou a colher resultados, o primeiro contrato foi com a prefeitura de Araguari que adquiriu 13 cadeiras de rodas para o, recém formado, time de basquete em cadeira de rodas da cidade. As cadeiras além de serem feitas sob medida atendendo desde às necessidades ergométricas de cada paratleta ainda considera a posição de jogo de cada um.  “Nós estamos levando uma resposta exclusiva e inédita para a sociedade, e o licenciamento tem essa vantagem de entregar uma solução nova produzida pela Universidade, no caso pelo CINTESP.Br/UFU para a população, é um grande feito”, conclui Lucas Cardoso, pesquisador autor do projeto.</p>\n<p>O contrato de licenciamento é o oitavo concedido pela UFU e não tem exclusividade, o que significa que a Universidade poderá licenciar, simultaneamente, com outros fabricantes interessados na comercializar de cadeiras de rodas personalizadas, utilizando a metodologia inédita de prescrição desenvolvida pelo CINTESP.Br/UFU, possibilitando ampliar e favorecer o mercado, o empreendedorismo e a sociedade que terá ampla variedade de cadeira de rodas, além dos tamanhos padrões oferecidos no mercado. A meta do CINTESP.Br/UFU é democratizar o acesso à tecnologia assistiva produzida nos laboratórios da Universidade</p>\n<p>Com o licenciamento a Universidade Federal de Uberlândia, por meio do CINTESP.Br/UFU, mais uma vez, cumpre o papel de Instituição Pública junto ao MEC. De acordo com o Pró-reitor de Pesquisa Extensão e Cultura da UFU o licenciamento fortalece a importância das pesquisas quanto ao caráter social e o importante papel da Universidade para melhorar a qualidade de vida da população. “A Universidade, assim, promove pontes, ganha sentido social e ajuda a população, sobretudo, às pessoas que necessitam de tecnologias assistivas a se inserirem melhor no mundo da educação, do trabalho, do lazer, da cultura e da vida cotidiana. Essa é a função da Universidade Pública: levar o melhor de seu trabalho para a população brasileira” acrescenta o professor Hélder Silveira, Pró-reitor PROEXC/UFU.</p>\n<p>No caso da gestão da política, portfólio de propriedade intelectual, promoção, difusão e proteção do conhecimento gerado no âmbito da Universidade, a UFU conta com o trabalho da Agência Intelecto. A Agência ainda atua nos processos de transferência da tecnologia protegida para o setor produtivo, “quando a UFU licencia uma tecnologia, ela colabora para o desenvolvimento socioeconômico baseado no conhecimento, ela obtém retorno em ganhos financeiros (royalties) para Universidade e estimula a inovação com o avanço da ciência e tecnologia”, complementa Thiago Paluma, diretor de Inovação e Transferência de Tecnologia da UFU.</p>\n<p>&nbsp;</p>\n<p>De acordo com Cleudmar Araujo, em 2022, após a volta das atividades presenciais, o CINTESP.Br já entregou 21 inovações em tecnologia assistiva, apresentadas no evento LANCE PcD 2022. “ expectativa é que até o final do ano possamos fazer novos licenciamentos junto as empresas e, com isso, aumentar ainda mais a quantidade de equipamentos e dispositivos inovadores em tecnologia assistiva disponíveis para toda a sociedade”, completa o coordenador do CINTESP.Br/UFU[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Texto: Cristiane de Paula – jornalista CINTESP.Br/UFU Revisão: Lucas Cardoso: pesquisador CINTESP.Br/UFU e Cleudmar Araújo- coord. geral CINTESP.Br/UFU Fazer uma cadeira de rodas personalizada, sob medida de acordo com a deficiência e com a necessidade de uso, seja no esporte ou para a vida diária é um desejo da sociedade que&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8105,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47],
        tags: [],
        class_list: [
            "post-8104",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-47",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8104",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8104",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8104/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8110,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8104/revisions/8110",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8105",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8104",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8104",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8104",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8096,
        date: "2022-08-26T10:45:51",
        date_gmt: "2022-08-26T13:45:51",
        guid: {
            rendered: "https://cintespbr.org/?p=8096",
        },
        modified: "2023-03-25T15:49:36",
        modified_gmt: "2023-03-25T18:49:36",
        slug: "inovacoes-em-tecnologia-assistiva-e-rede-colaborativa-do-cintesp-br-ufu-sao-apresentadas-no-congresso-nacional-de-engenharia-mecanica",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/inovacoes-em-tecnologia-assistiva-e-rede-colaborativa-do-cintesp-br-ufu-sao-apresentadas-no-congresso-nacional-de-engenharia-mecanica/",
        title: {
            rendered:
                "Inovações em tecnologia assistiva e Rede Colaborativa do CINTESP.Br/UFU são apresentadas no Congresso Nacional de Engenharia Mecânica",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8097" style="width: 1401px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8097" class="wp-image-8097 size-full" src="https://cintespbr.org/wp-content/uploads/2022/08/PI.jpg" alt="" width="1391" height="784" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/08/PI.jpg 1391w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/PI-300x169.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/PI-1024x577.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/PI-768x433.jpg 768w" sizes="(max-width: 1391px) 100vw, 1391px" /><p id="caption-attachment-8097" class="wp-caption-text">Abertura XI Conem &#8211; Domingos Rade, presidente da ABCM; Vice-Reitor Viriato Campelo; Renata Miyabara, Pró-Reitora da Uninovafapi; e Simone Hoefel, presidente do evento Foto: reprodução Conem</p></div></p>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p><div id="attachment_8102" style="width: 2570px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8102" class="wp-image-8102 size-full" src="https://cintespbr.org/wp-content/uploads/2022/08/UFPI-scaled.jpg" alt="" width="2560" height="1406" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/08/UFPI-scaled.jpg 2560w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/UFPI-300x165.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/UFPI-1024x562.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/UFPI-768x422.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/UFPI-1536x843.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/UFPI-2048x1124.jpg 2048w" sizes="(max-width: 2560px) 100vw, 2560px" /><p id="caption-attachment-8102" class="wp-caption-text">Universidade Federal do Piauí &#8211; Terezina-PI</p></div></p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]<span style="font-size: 8pt;">Texto: Cristiane de Paula</span></p>\n<p>O Congresso Nacional de Engenharia Mecânica (CONEM), realizado em Teresina (PI), é um dos maiores e principais eventos promovidos pela Associação Brasileira de Engenharia e Ciências Mecânicas (ABCM). O Congresso aconteceu no início do deste mês em Teresina,</p>\n<p>foi promovido pela ABCM sendo a Universidade Federal do Piauí (UFPI) uma das instituições organizadoras.</p>\n<p>A apresentação do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU), foi feita pelo coordenador-geral e pesquisador Cleudmar Araújo, com o tema “DESAFIOS DA ENGENHARIA PARA O DESENVOLVIMENTO DE INOVAÇÕES EM TECNOLOGIA ASSISTIVA”, onde foram explorados e destacadas diversas inovações em tecnologia assistiva voltadas para as áreas do esporte, saúde, educação lazer e vida diária e a forma que o CINTESP.Br/UFU vem atuando para atender às demandas da sociedade<strong>. </strong>“Eventos desta natureza, como o CONEM 2022,  são de grande importância para mostrar que, por ser um tema, multidisciplinar, as soluções para o desenvolvimento de Tecnologia Assistiva precisam ser construídas por várias mãos, e com isso, quem ganha é a sociedade brasileira, em especial, as pessoas com deficiência, as pessoas com doenças raras e as pessoas com mobilidade reduzida”, destaca Cleudmar Araújo.</p>\n<p>A apresentação sobe o CINTESP.Br/UFU e a forma de atuação envolvendo toda a sociedade para desenvolver produtos com menor custo e com o máximo de tecnologia nacional com entrega de equipamentos chamou a atenção também de alunos da Faculdade de Engenharia Mecânica, de acordo com Raphael Lima de Paiva professor da Universidade Federal do Piauí e presidente do comitê científico do evento, “foi com certeza um dos pontos altos do evento apresentando a diversidade de parcerias e a motivação do prof Cleudmar despertou também a atenção dos alunos a olharem para as pesquisas em tecnologia assistiva por uma perspectiva diferente, mais focada par ao próximo. Sabemos que os desafios de trabalhar com tecnologia assistiva aqui no Brasil são muito grandes e tomar conhecimento desse bom trabalho que vem acontecendo aqui no Brasil,  para nós foi muito gratificante”, destaca o professor de engenharia mecânica Raphael Lima.</p>\n<p>Uma das abordagens apresentada pelo coordenador do CINTESP.Br/UFU foi a respeito da forma direta de trabalho no desenvolvimento de pesquisas onde o conhecimento parte do relacionamento entre pesquisadores e paratletas de alto rendimento com seus treinadores além do formato em rede colaborativa, mista e aberta. “A palestra mostrou diversas tecnologias e ficamos muito impressionados com os resultados apresentados, tivemos um grande retorno por parte dos alunos e profissionais presentes. Desejamos outras oportunidades para apresentação desta palestra e deste importante tema, agora, na ABCM Jovem &#8211; Associação Brasileira de Engenharia e Ciências Mecânicas e iniciarmos o pensamento de uma parceria para somar ao nosso curso da Federal do Piauí”, comenta Simone Hoefel, do Curso de Engenharia Mecânica da UFPI e presidente do evento.</p>\n<p>&nbsp;</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Texto: Cristiane de Paula O Congresso Nacional de Engenharia Mecânica (CONEM), realizado em Teresina (PI), é um dos maiores e principais eventos promovidos pela Associação Brasileira de Engenharia e Ciências Mecânicas (ABCM). O Congresso aconteceu no início do deste mês em Teresina, foi promovido pela ABCM sendo a Universidade Federal do&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8098,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47],
        tags: [],
        class_list: [
            "post-8096",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-47",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8096",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8096",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8096/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8103,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8096/revisions/8103",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8098",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8096",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8096",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8096",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8078,
        date: "2022-08-08T16:48:26",
        date_gmt: "2022-08-08T19:48:26",
        guid: {
            rendered: "https://cintespbr.org/?p=8078",
        },
        modified: "2022-08-26T10:52:56",
        modified_gmt: "2022-08-26T13:52:56",
        slug: "coordenador-do-cintesp-br-ufu-compora-equipe-tecnica-do-mcti-para-assessoria-consultiva-em-inovacao-tecnologica-lei-do-bem",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/coordenador-do-cintesp-br-ufu-compora-equipe-tecnica-do-mcti-para-assessoria-consultiva-em-inovacao-tecnologica-lei-do-bem/",
        title: {
            rendered:
                "Coordenador do CINTESP.Br/UFU comporá equipe técnica do MCTI para assessoria consultiva em inovação tecnológica – Lei do Bem",
        },
        content: {
            rendered:
                '<p><div id="attachment_8094" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8094" class="wp-image-8094 size-full" src="https://cintespbr.org/wp-content/uploads/2022/08/WhatsApp-Image-2022-08-22-at-16.20.43.jpeg" alt="" width="1024" height="696" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/08/WhatsApp-Image-2022-08-22-at-16.20.43.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/WhatsApp-Image-2022-08-22-at-16.20.43-300x204.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/08/WhatsApp-Image-2022-08-22-at-16.20.43-768x522.jpeg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-8094" class="wp-caption-text">Pesquisadores do CINTESP.Br/UFU em apresentação de um dos equipamentos desenvolvidos para o paradesporto de alto rendimento.</p></div></p>\n<p style="text-align: left;"><span style="font-size: 8pt;">Texto: Cristiane de Paula  &#8211; Ascom CINTESP.Br/UFU</span><br />\n<span style="font-size: 8pt;">Revisão Cleudmar Araújo </span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A formação da equipe de apoio técnico foi publicada no Diário Oficial da União sendo convidados 32 pesquisadores de Universidades brasileiras. O objetivo dos trabalhos será de auxiliar os técnicos da Coordenação-Geral de Mecanismos de Apoio à Inovação (CGMI/SEMPI/MCTI) na elaboração dos chamados diagnósticos opinativos dos programas de pesquisa, desenvolvimento e inovação tecnológica oferecidos pelo Ministério da Ciência Tecnologia e Inovações às empresas beneficiárias pela conhecida “Lei do Bem”, publicada em 2005 para acelerar as pesquisas e o desenvolvimento de inovação tecnológica por meio de incentivos fiscais às pessoas jurídicas.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A Universidade Federal de Uberlândia, considerada, este ano, como a 3º Universidade Pública de Minas Gerais e  em 27º lugar entre as Universidades Brasileiras no World University Rankings, pela Quacquarelli Symonds Instituição de Ensino Superior do Reino Unido, será representada na equipe de apoio técnico pelo professor Dr. Cleudmar Amaral Araújo da Faculdade de Engenharia Mecânica (FEMEC/UFU), atual coordenador-geral do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos CINTESP.Br/UFU.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Os trabalhos serão realizados de forma presencial com previsão para concluir a consultoria ao MCTI até o dia 26 de agosto. “A Lei do Bem possibilita a concessão de incentivos fiscais às pessoas jurídicas no desenvolvimento de inovações tecnológicas. Á frente do Cintesp.Br, ao longo de mais de 10 anos, desenvolvemos inovações em tecnologia assistiva. Espero contribuir com a equipe de apoio técnico dentro da minha área de competência para que a pesquisa científica no Brasil possa se desenvolver ainda mais, com os seus grandes pesquisadores, usufruindo deste importante fomento que pode ser gerado pelas empresas.”, destaca o Prof. Cleudmar.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;"><strong>Sobre o professor da UFU e coordenador do CINTESP.Br/UFU, Cleudmar Amaral Araújo</strong></span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Com Doutorado em Engenharia Mecânica pela UNICAMP (1998), é professor titular da FEMEC-UFU, desenvolvendo pesquisas em projeto de sistemas biomecânicos atuando, principalmente, no desenvolvimento de inovações em tecnologia assistiva. É coordenador do Centro Brasileiro de Referência em Inovações Tecnológicas Para Esportes Paralímpico (CINTESP.Br/UFU). Até este ano, são mais de 35 pedidos de patentes registrados no Instituto Nacional da Propriedade Industrial (INPI). No “LANCE PcD 2022”, um dos maiores eventos de lançamento de inovações em tecnologia assistiva no País, criados pelo CINTESP.Br/UFU, foram lançadas 21 novas tecnologias voltadas para pessoas com deficiência. Atualmente são cerca de 60 projetos em tecnologia assistiva dentro das áreas da educação inclusiva, esporte, saúde, lazer e vida diária que auxiliarão pessoas com deficiência, pessoas com mobilidade reduzida e pessoas com doenças raras. Este ano o CINTESP.Br/UFU, iniciou os processos de licenciamento das tecnologias para fortalecer a indústria nacional que tem como objetivos, promover a riqueza do país, reduzir a dependência de importados e retornar para a sociedade brasileira os diversos produtos assistivos desenvolvidos no CINTESP.Br/UFU.</span></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula  &#8211; Ascom CINTESP.Br/UFU Revisão Cleudmar Araújo A formação da equipe de apoio técnico foi publicada no Diário Oficial da União sendo convidados 32 pesquisadores de Universidades brasileiras. O objetivo dos trabalhos será de auxiliar os técnicos da Coordenação-Geral de Mecanismos de Apoio à Inovação (CGMI/SEMPI/MCTI) na elaboração dos chamados diagnósticos opinativos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8094,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-8078",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8078",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8078",
                },
            ],
            "version-history": [
                {
                    count: 12,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8078/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8095,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8078/revisions/8095",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8094",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8078",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8078",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8078",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 8004,
        date: "2022-06-15T00:59:39",
        date_gmt: "2022-06-15T03:59:39",
        guid: {
            rendered: "https://cintespbr.org/?p=8004",
        },
        modified: "2022-06-30T00:11:02",
        modified_gmt: "2022-06-30T03:11:02",
        slug: "camara-municipal-de-uberlandia-presta-homenagem-ao-cintesp-br-ufu",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/camara-municipal-de-uberlandia-presta-homenagem-ao-cintesp-br-ufu/",
        title: {
            rendered:
                "Câmara Municipal de Uberlândia presta homenagem ao CINTESP.Br/UFU",
        },
        content: {
            rendered:
                '<p><div id="attachment_8005" style="width: 1953px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8005" class="wp-image-8005 size-full" src="https://cintespbr.org/wp-content/uploads/2022/06/dest-SOlene.png" alt="" width="1943" height="631" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/06/dest-SOlene.png 1943w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/dest-SOlene-300x97.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/dest-SOlene-1024x333.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/dest-SOlene-768x249.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/dest-SOlene-1536x499.png 1536w" sizes="(max-width: 1943px) 100vw, 1943px" /><p id="caption-attachment-8005" class="wp-caption-text">Sessão solene na Câmara Municipal de Uberlândia</p></div></p>\n<p style="text-align: left;"><span style="font-size: 8pt;">Texto: Cristiane de Paula (Ascom CINTESP.Br/UFU)</span><br />\n<span style="font-size: 8pt;">Revisão: Arthur Alves Fiocchi (Pesquisador CINTESP.Br/UFU</span></p>\n<p style="text-align: justify;">    O reconhecimento público da Câmara Municipal de Uberlândia aconteceu em sessão solene para a entrega de Diplomas de Honra ao Mérito e Moção de Aplauso aos parceiros e aos pesquisadores do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos CINTESP.Br/UFU. Ao todo foram mais de 60 homenagens. O coordenador do CINTESP.Br/UFU, professor Cleudmar Araújo, apresentou a forma de desenvolvimento das atividades e os principais resultados das pesquisas, que no início deste ano resultaram em 21 equipamentos entregues à sociedade com diversos depósitos de patentes, alguns com patentes concedidas e outros em fase final de licenciamento. “Nossa missão é essa, desenvolver inovação e não deixar ela nos laboratórios, nossas pesquisas precisam chegar para quem precisa, e uma pessoa com deficiência, com mobilidade reduzida e com doenças raras não pode esperar e aproveitamos para convidar as forças políticas, empresários e população para conhecerem e apoiarem cada vez mais as nossas pesquisas”, disse Cleudmar Araújo. “Precisamos fomentar o desenvolvimento nacional de tecnologia assistiva para se tornar acessível e de qualidade por meio da indústria brasileira”, completa o pesquisador Arthur Alves Fiocchi, também homenageado na sessão.</p>\n<p style="text-align: justify;">     A sessão solene da Câmara Municipal de Uberlândia para outorga de Diploma de Honra ao Mérito ao CINTESP.Br/UFU e Moção de Aplausos aos pesquisadores, aos parceiros, apoiadores e financiadores contou com a presença de toda a comunidade local envolvida. Representando a Universidade Federal de Uberlândia o Vice-reitor Carlos Henrique Martins, a treinadora Fernanda Costa representou a Fundação de Esporte Turismo e Lazer(FUTEL), pelo SESI Gravatás esteve presente o gerente da unidade Jackson da Silva. Esteve presente para também ser homenageado o presidente do Praia Clube Uberlândia Guto Braga, pela CDL esteve presente a assessora jurídica Talita Lemes, pelo Brain Instituto de Ciência e Tecnologia Algar a presidente Zaima MIlazzo, da Associação dos Deficientes Visuais do Triângulo Mineiro ( Adevitrim) Edu Charles Ramos, representando a Associação dos Deficientes Visuais de Uberlândia (ADEVIUDI) Ivandro Pereira, da Associação dos Paraplégicos de Uberlândia (APARU) Adalci Ferreira.</p>\n<p style="text-align: justify;">     A vereadora que já foi a primeira presidente da Comissão da pessoa com deficiência da Assembleia de deputados de Minas Gerais e, há 10 anos, acompanha os trabalhos do CINTESP.Br/UFU falou da importância das pesquisas em Uberlândia e da rede colaborativa construída em favor da inovação em tecnologia assistiva, “é de encher os olhos e aquecer o coração; com todas as parcerias, o quanto que é importante o que vocês fazem aqui para que esse país possa desenvolver e valorizar a cultura ciência e a tecnologia. Que vocês possam ter apoio, não faz Ciência sem dinheiro, incentivando as ciências nossos pesquisadores, os nossos financiadores, nossos apoiadores e que a gente possa mostrar nesse mundo que nós somos capazes, portanto, receba aqui a nossa gratidão.” Falou a vereadora Liza Prado, autora da homenagem.</p>\n<p style="text-align: justify;">     O destaque ainda foi feito por um dos apoiadores, o presidente do Praia Clube, Guto Braga falou do ineditismo e exclusividade da rede colaborativa de Uberlândia unindo parceiros para promover a inclusão produtiva e social por meio do paradesporto. Confiante na força da rede colaborativa desenvolvida na cidade, o presidente do Praia lançou o desafio de mais que dobrar a conquista de medalhas Paralímpicas pelos atletas da cidade, “nas Paralimpíadas de Tóquio nossos paratletas de Uberlândia ganharam 10 % do total de medalhas, para os jogos em Paris temos condições de trazer 25 % do total de medalhas”, enfatizou o presidente do Praia Clube Uberlândia.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula (Ascom CINTESP.Br/UFU) Revisão: Arthur Alves Fiocchi (Pesquisador CINTESP.Br/UFU     O reconhecimento público da Câmara Municipal de Uberlândia aconteceu em sessão solene para a entrega de Diplomas de Honra ao Mérito e Moção de Aplauso aos parceiros e aos pesquisadores do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8006,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-8004",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8004",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=8004",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8004/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8008,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/8004/revisions/8008",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8006",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=8004",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=8004",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=8004",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7992,
        date: "2022-06-09T00:29:15",
        date_gmt: "2022-06-09T03:29:15",
        guid: {
            rendered: "https://cintespbr.org/?p=7992",
        },
        modified: "2022-08-04T10:14:47",
        modified_gmt: "2022-08-04T13:14:47",
        slug: "coordenadores-do-ministerio-da-mulher-da-familia-e-dos-direitos-somam-forcas-aos-projetos-do-cintesp-br-ufu",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/coordenadores-do-ministerio-da-mulher-da-familia-e-dos-direitos-somam-forcas-aos-projetos-do-cintesp-br-ufu/",
        title: {
            rendered:
                "Coordenadores do Ministério da Mulher, da Família e dos Direitos Humanos somam forças aos projetos do CINTESP.Br/UFU",
        },
        content: {
            rendered:
                '<p style="text-align: justify;">Vencer o mercado e buscar mais fontes de recursos estas foram as missões apresentadas pelos Coordenadores da Secretaria Nacional dos Direitos da Pessoa com Deficiência (SNDPD) do Ministério da Mulher, da Família e dos Direitos Humanos (MMFDH), que anunciou somar esforços com o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos, vinculado à Universidade Federal de Uberlândia (CINTESP.Br/UFU), após a visita feita às unidades de pesquisas e validações do CINTESP.Br/UFU e de parceiros. “O mercado tem condições de adaptar-se muito bem para absorver estas novidades, fabricar e promover uma revolução para a sociedade com o tempo reduzido de fabricação”, disse Sergio Paulo da Silveira Nascimento coordenador Geral de Acessibilidade e Tecnologia do MMFDH.</p>\n<p style="text-align: justify;">A visita ocupou a agenda durante todo o dia (31/05) em Uberlândia. Os coordenadores Yara Helena de Carvalho Paiva, da Coordenadoria de Tecnologia Assistiva e Sergio Paulo da Silveira Nascimento coordenador Geral de Acessibilidade e Tecnologia, ligadas ao MMFDH, conheceram primeiro a unidade do SESI Gravatás, onde são feitas as validações com o uso dos equipamentos desenvolvidos para o alto rendimento do paradesporto. Eles conversaram com treinadores, com paratletas e conheceram detalhes do banco de arremesso e dos equipamentos da academia para cadeirantes.</p>\n<p style="text-align: justify;">Em seguida, na Arena Sabiazinho, os representantes do Ministério da Mulher, da Família e dos Direitos Humanos visitaram os laboratórios onde são desenvolvidas diferentes etapas de produção de projetos, entre elas as de desenhos, de automação, de prototipagem, de modelagem, de biomecânica e de educação inclusiva, conversaram com pesquisadores e crianças atendidas pelo projeto de educação inclusiva em acessibilidade.</p>\n<p style="text-align: justify;">Entre os projetos apresentados, os coordenadores conheceram a bengala para pessoa surdo cega que está em fase de montagem e testes. Equipamento que apresenta inovação quanto a amplitude de área, de altura de identificação de obstáculos, incluindo espaços vazios(buracos) alertando o usuário em forma de vibração. Projeto desenvolvido em parceria com pesquisadores do Centro Paula Souza (CPS/SP), da Faculdade de Tecnologia (Fatec) de Sorocaba, dentro do formato de rede colaborativa desenvolvido pelo CINTESP.Br/UFU. “Ainda estamos incorporando inovações, já reduzimos bastante o peso, a amplitude de alcance dos sensores investindo mais tecnologia e desta bengala vamos replicar no modelo de andador que será feito, também com tecnologia nossa, por prescrição para atender as modificações do corpo da pessoa surdo cega, uma jovem que está fazendo parte de nossas pesquisas”, acrescentou Lucas Cardoso, pesquisador autor do projeto.</p>\n<p style="text-align: justify;">No laboratório de biomecânica, conheceram o equipamento para prescrição de cadeiras de rodas e o ergômetro para cadeirante, equipamentos que recentemente receberam Carta Patente do Instituto Nacional de Propriedade Industrial (INPI). O equipamento, com tecnologia já à disposição para fabricação pelo mercado, poderá ser usado para acompanhamento físico e diagnósticos de saúde de pessoas em cadeiras de rodas. O uso do ergômetro para cadeirantes é similar ao ergômetro em esteiras usado para andantes. “Esse equipamento já foi testado por cardiologista que acompanhou o desenvolvimento do projeto e aprovou a eficácia dele em diagnósticos e monitoramento de frequência cardíaca similares ao uso em esteira com pessoas andando, o ergômetro para cadeirante vai oferecer fidelidade nos procedimentos médicos e de preparação física”, completa Sérgio Augusto, autor do projeto</p>\n<p><div id="attachment_7994" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7994" class="wp-image-7994 size-large" src="https://cintespbr.org/wp-content/uploads/2022/06/Cle-1024x391.jpg" alt="" width="1024" height="391" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/06/Cle-1024x391.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/Cle-300x115.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/Cle-768x293.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/Cle-1536x587.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/Cle.jpg 1547w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-7994" class="wp-caption-text">Oficina projetos inclusivos e pesquisador do CINTEPS.Br/UFU apresentando dispositivo em 3D para vida diária</p></div></p>\n<p style="text-align: justify;">Ainda na Arena Sabiazinho, os representantes do MMFDH conheceram o projeto de educação inclusiva feito com associações e escolas públicas. A visita foi acompanhada pela vereadora Amanda Gondim, relatora da Comissão de Direitos Humanos, Sociais e do Consumidor, além de fazer parte da Comissão Pessoa com Deficiência e da Pessoa com Doença Rara,  e pelo diretor da FUTEL, Edson Zanatta, um dos parceiros do CINTESP.Br/UFU, por meio da Prefeitura de Uberlândia. O diretor falou da importância da rede colaborativa de parceiros para atender a sociedade, pessoas com deficiência e mobilidade reduzida desde a iniciação até o alto rendimento. “Nossa cidade tem um projeto único e estamos sendo referência também na agenda de campeonatos do paradesporto, por oferecermos estrutura para isso, agora em setembro, por exemplo, teremos uma etapa do Nacional de Bocha paralímpica, aqui em nossa cidade”, completou o diretor da FUTEL.</p>\n<p style="text-align: justify;">E no setor de projetos inclusivos foram apresentados pelos pesquisadores ferramentas e dispositivos pedagógicos a partir da necessidade de uma criança com doença rara que faz parte de um experimento com impressão em 3D para fabricação de um dispositivo para vida diária. Na atividade pedagógica da semana um grupo de alunos da Instituição Pública Ação Moradia conheceu os espaços e projetos desenvolvidos pelo CINTESP.Br. No final da visita eles desenvolveram trabalhos visando contribuir com a mobilidade e acessibilidade de crianças com deficiência e doenças raras. Os jovens foram estimulados sobre a importância de recursos e mecanismos acessíveis como de identificar formas e texturas, sensações e objetos. O resultado foram trabalhos didáticos para percepções sensoriais para múltiplas deficiências.</p>\n<p style="text-align: justify;">Os coordenadores do MMFDH ainda se reuniram com o Vice-reitor, Carlos Henrique de Carvalho e o diretor da Agência Intelecto, professor Thiago Paluma. A reunião teve como objetivo principal conhecer, com mais detalhes, o projeto do Centro Nacional de Tecnologias para Pessoas com Deficiência e Doenças Raras (CNT-MCTI) que faz parte da Política de Desenvolvimento Científico, Tecnológico e Inovação para Qualidade de Vida do MCTI. “Nós reconhecemos o trabalho dos pesquisadores do CINTESP e vemos com muita satisfação o que estamos conseguindo fazer em tempo de momentos difíceis, aqui estamos conseguindo desenvolver um grande projeto para atender pessoas”, completa o Vice-reitor Carlos Henrique de Carvalho.</p>\n<p style="text-align: justify;">O CNT será o maior espaço criado para concentrar as pesquisas e criar ferramentas de incentivo ao empreendedorismo com a finalidade  de inovar, reduzir custos e aumentar as entregas de inovações tecnológicas para a sociedade, “o CNT surgiu por meio do CINTESP.Br/UFU, a referência da nossa Universidade pela quantidade e variedade de patentes conquistadas pela UFU, sem falar do nosso Hospital, o maior entre os 40, da Rede Ebserh e de nossos laboratórios” completa o diretor Thiago Paluma.</p>\n<p style="text-align: justify;">A visita e o conhecimento de detalhes do projeto do CNT/MCTI deixou entusiasmados os coordenadores que reforçaram a participação por meio do Comitê Interministerial, criado pelo Plano Nacional de Tecnologia Assistiva, de acordo com Sérgio NASCIMENTO, coordenador Geral de Acessibilidade e Tecnologia do MMFDH, poderá elaborar o primeiro Catálogo Nacional de tecnologia assistiva, “queremos elaborar o ‘Estado da Arte’ da tecnologia assistiva que envolve a vida diária das pessoas com deficiência e com doenças raras e a experiência que vocês têm de fazer com a interface da validação é algo muito importante nesse processo”, completa o coordenador.</p>\n<p style="text-align: justify;">A visita dos coordenadores do MMFDH encerrou no Praia Clube Uberlândia, parceiro na rede colaborativa na preparação dos paratletas que se destacam para a inclusão nos campeonatos nacionais e internacionais. Atualmente o Praia Clube tem mais de 80 atletas de diferentes modalidades que somaram nas Paralimpíadas de Tóquio 10% das medalhas do Brasil. “Nós investimos em toda a assistência de nossos atletas, Uberlândia faz no paradesporto, com essa rede colaborativa, o que não existe no Brasil e para as próximas paralimpíadas podemos mais que dobrar o número de medalhas”, completa Guto Braga, presidente do Praia Clube Uberlândia. “Nosso objetivo é desenvolver produtos e fortalecer essa rede de colaboradores para chegar com custo reduzido de inovações em TA e cada vez mais rápido para a sociedade, o que produzimos não pode ficar nos laboratórios e com a união dos Ministérios podemos encontrar caminhos para os equipamentos chegarem para uso de quem precisa”, reforça Cleudmar Araújo, coordenador do CINTESP.Br/UFU.</p>\n<p style="text-align: justify;">Os projetos do CINTESP.Br/UFU são financiados pelo Ministério da Ciência, Tecnologia e Inovação (MCTI) e pelo Ministério Público do Trabalho (MPT/Uberlândia-MG), pela UFU e agências de fomento brasileiras como a Fapemig, o CNPq e a CAPES. A forma de atuação em rede colaborativa, multidisciplinar e em parcerias, inédita no Brasil, fortalecem as pesquisas, aceleram os processos e aproximam os pesquisadores da sociedade. Em Uberlândia, os projetos acontecem em conjunto com a Prefeitura Municipal de Uberlândia por meio da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel), o Comitê Paralímpico Brasileiro (CPB), o Praia Clube de Uberlândia, o Grupo Algar/Brain Instituto de Ciência e Tecnologia, e Sesi Gravatás (Fiemg).  “Ver um projeto desse, com uma cidade toda envolvida nesse tema é muito emocionante, a gente sempre ouve falar mas não tínhamos a dimensão, essa integração concentrada em um objetivo comum é inovadora”, completa a coordenadora de Tecnologia Assistiva, Yara Helena de Carvalho Paiva, do MMFDH.</p>\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Vencer o mercado e buscar mais fontes de recursos estas foram as missões apresentadas pelos Coordenadores da Secretaria Nacional dos Direitos da Pessoa com Deficiência (SNDPD) do Ministério da Mulher, da Família e dos Direitos Humanos (MMFDH), que anunciou somar esforços com o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos, vinculado à&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7995,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-7992",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7992",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7992",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7992/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8077,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7992/revisions/8077",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7995",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7992",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7992",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7992",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7988,
        date: "2022-06-09T00:19:08",
        date_gmt: "2022-06-09T03:19:08",
        guid: {
            rendered: "https://cintespbr.org/?p=7988",
        },
        modified: "2022-06-30T00:11:02",
        modified_gmt: "2022-06-30T03:11:02",
        slug: "pesquisadores-do-cintesp-br-ufu-iniciam-projetos-para-o-halterofilismo-que-podera-oferecer-monitoramento-de-forca-a-distancia-e-em-tempo-real",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/pesquisadores-do-cintesp-br-ufu-iniciam-projetos-para-o-halterofilismo-que-podera-oferecer-monitoramento-de-forca-a-distancia-e-em-tempo-real/",
        title: {
            rendered:
                "Pesquisadores do CINTESP.Br/UFU iniciam projetos para o halterofilismo que poderá oferecer monitoramento de força à distância e em tempo real",
        },
        content: {
            rendered:
                '<p><div id="attachment_7989" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7989" class="wp-image-7989 size-large" src="https://cintespbr.org/wp-content/uploads/2022/06/art-1024x370.jpg" alt="" width="1024" height="370" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/06/art-1024x370.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/art-300x108.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/art-768x278.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/art-1536x555.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/06/art.jpg 1959w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-7989" class="wp-caption-text">Pesquisadores do CINTEPS.Br/UFU em visita à academia de halterofilismo do SESI Gravatás</p></div></p>\n<p>&nbsp;</p>\n<p style="text-align: left;"><span style="font-size: 8pt;">Texto: Cristiane de Paula &#8211; ASSCOM CINSPTESP.Br<br />\nRevisão: Arthur Alves Fiocchi -pesquisador CINTESP.Br</span></p>\n<p style="text-align: justify;">Ambiente de pesquisa privilegiado, este é um dos diferenciais do CINTESP.Br/UFU gerados por meio do trabalho feito em rede colaborativa e diretamente com o público a ser atendido, os paratletas brasileiros. Conhecendo a demanda dos treinadores do alto rendimento, os pesquisadores conseguem desenvolver em curto espaço de tempo equipamentos e dispositivos específicos, agilizando as fases de desenvolvimento e validação dos projetos.</p>\n<p style="text-align: justify;">Desta vez, o local de pesquisa foi a academia do halterofilismo, no SESI Gravatás, em Uberlândia, onde acontecem os treinos focados no alto rendimento. São 33 paratletas, dos quais 23 são medalhistas e a maioria entre os melhores do Brasil e do Mundo.</p>\n<p style="text-align: justify;">Foram mais de 3 horas de conversa com o treinador e técnico da equipe brasileira de halterofilismo Wéverton Santos. Os professores e pesquisadores Arthur Alves Fiocchi, do Laboratório de Ensino e Pesquisa em Usinagem, Márcio Peres, coordenador do Laboratório de Projetos Mecânicos, e Cleudmar Araújo, coordenador do CINTESP.Br/UFU, conheceram as principais demandas tecnológicas apontadas pelo treinador para aumentar o desempenho dos atletas por meio da instalação de sensores em alguns equipamentos da academia. “Esse contato com o pessoal do halterofilismo é fundamental, é aqui que a gente percebe as dificuldades, os problemas do outro lado, assim podemos aplicar o nosso conhecimento para ajudar na rotina do técnico e dos atletas”, completa o pesquisador do CINTESP.Br/UFU Márcio Peres.</p>\n<p style="text-align: justify;">O desafio é criar dispositivos de monitoramento em tempo real e a distância para até 9 barras de treinamento para arremesso. O objetivo é melhorar o rendimento dos atletas com maior controle de carga e estudo detalhado do movimento durante a prática da modalidade, evitando lesões por meio do acompanhamento com dispositivos eletrônicos. “Vamos ter a possibilidade de acompanhar a qualidade do treino de cada atleta e, também, arquivar os dados para avaliações futuras. O objetivo é desenvolver tecnologia nacional, acessível e mais barata que os produtos similares importados, por exemplo, um equipamento britânico que pode custar até 20 mil reais”, disse o treinador e técnico da equipe brasileira de halterofilismo Wéverton Santos.</p>\n<p style="text-align: justify;"> O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU) foi criado pelo Ministério da Ciência, Tecnologia e Inovações (MCTI) com o principal objetivo de desenvolver inovações em tecnologia assistiva voltadas para a melhoria da vida diária de pessoas com deficiência (PcD), com mobilidade reduzida e doenças raras nas áreas de lazer, esporte, saúde e educação. em parceria com o Comitê Paralímpico Brasileiro (CPB), “Inovações Tecnológicas” em esportes paralímpicos e viabilizar, em um menor tempo possível, a transferência destas tecnologias para a sociedade e por meio do setor produtivo em articulação com agentes socioeconômicos. “Com essa aproximação, esse trabalho em rede fica muito mais ágil, vamos empenhar para, neste caso apresentar, até o final do ano, uma primeira versão de dispositivos para eles testarem”, completa Cleudmar Araújo, coordenador do CINTESP.Br/UFU.</p>\n<p style="text-align: justify;">Atualmente os projetos de pesquisa são financiados pelo MCTI e Ministério Público do Trabalho de Uberlândia-MG, com gestão financeira do CNPq e são desenvolvidos em forma de rede colaborativa entre pesquisadores de diversas Faculdades, Universidades e apoiadores como a prefeitura de Uberlândia, por meio da FUTEL, Sesi Gravatás (Fiemg), o Praia Clube Uberlândia e o Grupo Algar Telecom e Brain Instituto de Ciência e Tecnologia.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; Texto: Cristiane de Paula &#8211; ASSCOM CINSPTESP.Br Revisão: Arthur Alves Fiocchi -pesquisador CINTESP.Br Ambiente de pesquisa privilegiado, este é um dos diferenciais do CINTESP.Br/UFU gerados por meio do trabalho feito em rede colaborativa e diretamente com o público a ser atendido, os paratletas brasileiros. Conhecendo a demanda dos treinadores do alto rendimento, os pesquisadores&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7990,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-7988",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7988",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7988",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7988/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7991,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7988/revisions/7991",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7990",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7988",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7988",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7988",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7975,
        date: "2022-05-27T17:25:08",
        date_gmt: "2022-05-27T20:25:08",
        guid: {
            rendered: "https://cintespbr.org/?p=7975",
        },
        modified: "2022-06-30T00:11:02",
        modified_gmt: "2022-06-30T03:11:02",
        slug: "o-cintesp-br-ufu-com-a-presenca-do-coordenador-geral-cleudmar-araujo-participou-do-1o-encontro-da-educacao-paralimpica-de-araguari-e-regiao",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/o-cintesp-br-ufu-com-a-presenca-do-coordenador-geral-cleudmar-araujo-participou-do-1o-encontro-da-educacao-paralimpica-de-araguari-e-regiao/",
        title: {
            rendered:
                "O CINTESP.Br/UFU, com a presença do coordenador geral, Cleudmar Araújo, participou do 1º Encontro da Educação Paralímpica de Araguari e Região.",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text]</p>\n<h3>Objetivo foi divulgar os trabalhos de pesquisa em tecnologia assistiva realizados pelo CINTESP.</h3>\n<p>O convite foi feito pelo Wesley de Mendonça, secretário de esportes e pelo coordenador de paradesporto de Araguari.<br />\nNo evento também foi realizada a entrega de certificados do curso Movimento Paralímpico, desenvolvido em Araguari: Fundamentos Básicos do Esporte para professores de Educação Física da Rede Municipal de Ensino.[/vc_column_text][vc_btn title=&#8221;CLICK AQUI E ACOMPANHE&#8221; color=&#8221;sky&#8221; size=&#8221;lg&#8221; link=&#8221;url:https%3A%2F%2Ffb.watch%2FdgV6Sq40lj%2F|title:CLICK%20AQUI%20E%20ASSISTA|target:_blank&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Objetivo foi divulgar os trabalhos de pesquisa em tecnologia assistiva realizados pelo CINTESP. O convite foi feito pelo Wesley de Mendonça, secretário de esportes e pelo coordenador de paradesporto de Araguari. No evento também foi realizada a entrega de certificados do curso Movimento Paralímpico, desenvolvido em Araguari: Fundamentos Básicos do Esporte para professores de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7980,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-7975",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7975",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7975",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7975/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7978,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7975/revisions/7978",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7980",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7975",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7975",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7975",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7969,
        date: "2022-05-25T15:04:29",
        date_gmt: "2022-05-25T18:04:29",
        guid: {
            rendered: "https://cintespbr.org/?p=7969",
        },
        modified: "2022-07-08T00:11:36",
        modified_gmt: "2022-07-08T03:11:36",
        slug: "cintesp-br-ufu-podera-ampliar-as-acoes-de-pesquisa-em-ta-com-parateltas-de-araguari",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-ufu-podera-ampliar-as-acoes-de-pesquisa-em-ta-com-parateltas-de-araguari/",
        title: {
            rendered:
                "CINTESP.Br/UFU poderá ampliar as ações de pesquisa em (TA) com paratletas de Araguari",
        },
        content: {
            rendered:
                '<p>&nbsp;</p>\n<p style="text-align: left;"><span style="font-size: 8pt;">Texto: Cristiane de Paula (Ascom CINTESP.Br/UFU)</span><br />\n<span style="font-size: 8pt;">Revisão: Cleudmar Araújo (Coord. CINTESP.Br/UFU)</span></p>\n<p style="text-align: justify;">    A possibilidade de ter a cidade de Araguari nos Projetos do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU), com tecnologia assistiva(TA), surgiu com a implantação de novas políticas de Governo daquele Município.</p>\n<p style="text-align: justify;">    Desde o início do ano a cidade de Araguari vem implementando Programas de incentivo ao paradesporto. O primeiro passo foi a criação de uma coordenadoria de paradesporto, vinculada à Secretaria Municipal de Esportes. Agora a cidade iniciou a implantação da Fundação Municipal de Esportes e Paradesporto(FAMEP), “pretendemos nos aproximar do CINTESP.Br/UFU para entrelaçar nossos convênios, fazermos acordos para avaliação de nossos atletas e ainda fazermos parte dos projetos de pesquisa, onde todos possam ganhar com a existência de um centro de pesquisa tão próximo, queremos aproveitar isso&#8221;, disse Rômulo Monteiro Fernandes, coordenador do paradesporto de Araguari.</p>\n<p style="text-align: justify;">    No final do mês (27 a 29) a cidade de Araguari sediará a etapa do Campeonato Mineiro em Cadeira de rodas acontecerá com a presença de 5 equipes da região, “nós queremos somar aos esforços que já acontecem em Uberlândia, como por exemplo, retomar o basquete em cadeira de rodas que tem tradição de 20 anos na cidade e só agora conta com um acordo de parceria com o Município” , disse Rômulo Monteiro Fernandes, coordenador do paradesporto de Araguari.</p>\n<p style="text-align: justify;">Com as novas ações na cidade de Araguari, o paradesporto ganha força no Triângulo Mineiro depois da Região de sediar, em Uberlândia, o International Wheelchair Tennis Open, com a participação de mais de 60 paratletas e 4 países, agora é a vez do basquete, na cidade de Araguari.</p>\n<p style="text-align: justify;">    Este mês o CINTESP.Br/UFU conquistou a patente de 2 equipamentos voltados ao paradesporto de alto rendimento, entre eles o aparelho para personalização de cadeiras de rodas esportivas que recebeu do Instituto Nacional da Propriedade Industrial a Carta Patente de nº BR 102016008499-7, registrado em nome da Universidade Federal de Uberlândia. Por meio do equipamento o CINTESP.Br/UFU fabricou as primeiras cadeiras de rodas personalizadas para o tênis de quadra, o rúgbi, a esgrima e para o basquete.</p>\n<p style="text-align: justify;">     O Centro de pesquisa conta com aproximadamente 50 pesquisadores, envolvendo profissionais técnicos, estudantes de graduação e de pós-graduação e docentes, atuando em mais de 60 projetos que passam pelas áreas de educação, saúde, lazer, esporte e vida diária, o CINTESP.Br/UFU ainda mais de 30 registros de pedidos de patentes em avaliação junto ao INPI.</p>\n<p style="text-align: justify;">    Na cidade de Araguari os Programas de incentivo ao paradesporto já envolvem 2 associações da cidade: a Associação dos Deficientes Físicos de Araguari (Adefa) e a Associação de Pais e Amigos dos Excepcionais (APAE), além do Praia Clube Uberlândia na capacitação de profissionais. Com os novos projetos a cidade já tem cadastrados em seus programas de treinamento 40 paratletas no futebol e basquete além de outros 20 na natação e no atletismo e vem estimulando crianças e jovens na iniciação ao paradesporto.</p>\n<p style="text-align: justify;">     Uberlândia se destaca no país por ter a única rede colaborativa de parceiros com foco à inclusão em acessibilidade por meio do esporte. Para jovens e adultos a porta de entrada são as instituições de apoio à PcD e rede básica de ensino, da Prefeitura da cidade, que identifica crianças com deficiência para iniciação ao esporte.  A capacitação e treinamento dos parateltas fica por conta  da Fundação de Turismo, Esporte e Lazer (FUTEL)  passando pela iniciativa privada com o Praia Clube Uberlândia que reforça a rede também investindo em cerca de 60 atletas de 17 a 55 anos de idade em 5 modalidades (natação, halterofilismo, tênis em cadeira de rodas, atletismo e bocha). Somada a essa rede estão o CINTESP.Br/UFU com financiamentos do MCTI e (MPT/Uberlândia-MG), com gestão do CNPq e o Grupo Algar, Algar Telecom e Brain Instituto de Ciência e Tecnologia, e Sesi Gravatás (Fiemg)</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; Texto: Cristiane de Paula (Ascom CINTESP.Br/UFU) Revisão: Cleudmar Araújo (Coord. CINTESP.Br/UFU)     A possibilidade de ter a cidade de Araguari nos Projetos do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU), com tecnologia assistiva(TA), surgiu com a implantação de novas políticas de Governo daquele Município.     Desde o início&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7971,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-7969",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7969",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7969",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7969/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8063,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7969/revisions/8063",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7971",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7969",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7969",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7969",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7927,
        date: "2022-05-18T17:39:02",
        date_gmt: "2022-05-18T20:39:02",
        guid: {
            rendered: "https://cintespbr.org/?p=7927",
        },
        modified: "2022-08-26T10:52:41",
        modified_gmt: "2022-08-26T13:52:41",
        slug: "inovacoes-em-tecnologia-assistiva-no-paradesporto-desenvolvidas-no-brasil-pelo-cintesp-br-ufu-recebem-cartas-patentes",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/inovacoes-em-tecnologia-assistiva-no-paradesporto-desenvolvidas-no-brasil-pelo-cintesp-br-ufu-recebem-cartas-patentes/",
        title: {
            rendered:
                "Inovações em Tecnologia Assistiva no paradesporto desenvolvidas no Brasil pelo Cintesp.Br/Ufu recebem cartas patentes",
        },
        content: {
            rendered:
                '<p><div id="attachment_7928" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7928" class="wp-image-7928 size-large" src="https://cintespbr.org/wp-content/uploads/2022/05/Patentes-1024x376.jpg" alt="" width="1024" height="376" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/05/Patentes-1024x376.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/Patentes-300x110.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/Patentes-768x282.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/Patentes-1536x564.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/Patentes.jpg 1607w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-7928" class="wp-caption-text">Pesquisadores do CINTESP.Br/UFU com paratletas e treinadores em testes de equipamentos com a nas unidades de Uberlândia</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula(Ascom CINTESP.Br/UFU)<br />\nRevisão: Cleudmar Araújo(Coord. CINTESP.Br/UFU)</span></p>\n<p style="text-align: justify;">O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU), encerrou o quadrimestre deste ano comemorando as publicações de duas novas cartas patentes.</p>\n<p style="text-align: justify;">Os produtos são inéditos no Brasil, um dos equipamentos patenteados, o ergômetro para cadeirantes, possibilita a avaliação do condicionamento físico de cadeirantes, permitindo ao treinador físico controlar e monitorar ao mesmo tempo a carga utilizada e o rendimento do paratleta durante o exercício físico. Este equipamento pode ser utilizado inclusive para treinamentos físicos e reabilitação, inclusive para pessoas com mobilidade reduzida. O outro equipamento, que recebeu Carta Patente, possibilitará realizar prescrição de cadeiras de rodas com metodologia inovadora no mundo, auxiliando no projeto de cadeiras de rodas esportivas personalizadas por atleta e por modalidade.</p>\n<p style="text-align: justify;">Com os dois equipamentos, os atletas paralímpicos de alto rendimento ganharão condições para melhorar sua performance com treinamentos dedicados podendo desenvolver mais suas habilidades em quadra ou na pista de atletismo. “Esse é o nosso objetivo, fazer chegar nossos projetos até a população, ajudar as equipes técnicas brasileiras na preparação e o paratleta a conquistar mais medalhas”, disse Cleudmar Araújo, coordenador do CINTESP.Br/UFU.</p>\n<p style="text-align: justify;">O Instituto Nacional da Propriedade Industrial, concedeu a Carta Patente de nº BR 102015024095-3 para o ergômetro para cadeirantes, classificação internacional registrada em nome da Universidade Federal de Uberlândia. Um dos diferenciais deste equipamento é utilizar aplicativo e sistema de resistência dedicado aplicando movimentos similares ao gesto motor dos cadeirantes. O equipamento é considerado altamente inclusivo possibilitando o mesmo nível de avaliação que é feito a um atleta não cadeirante. O ergômetro para cadeirantes é uma opção de baixo custo comparativamente a equipamentos importados como os rolos cilíndricos para avaliação do condicionamento físico.</p>\n<p style="text-align: justify;">A segunda patente foi concedida ao aparelho para Personalização de Cadeiras de Rodas Esportivas que recebeu do Instituto Nacional da Propriedade Industrial a Carta Patente de nº BR 102016008499-7, também registrado em nome da Universidade Federal de Uberlândia. Este equipamento promete revolucionar o mundo do paradesporto. O modelo patenteado é capaz de prescrever cadeiras de rodas de diversas modalidades esportivas para o alto rendimento por meio de ajustes mecânicos. O paratleta percebe, em tempo real, a variação dos ajustes com as regulagens associadas, considerando as características antropométricas do corpo de acordo com as necessidades de movimento durante a prática do esporte. “Eu acho que a cadeira vai ficar muito boa, estou sugerindo algumas medidas para diminuir as trincas em determinados pontos da cadeira quando eu levo impacto muito forte do adversário, queremos uma cadeira com o maior a resistência daquela que eu uso em quadra”, disse Rafael Hoffmann do rúgbi que já passou pelo equipamento. As dimensões anatômicas prescritas são avaliadas por meio de simulação do funcionamento unindo precisão das medidas, agilidade na fabricação e redução de custo. “Mais uma vitória dentre muitas, que nos impulsiona a seguir em frente com coragem e determinação”, disse Lucas Cardoso, pesquisadordo CINTESP.Br e autor do projeto.</p>\n<p style="text-align: justify;">O CINTESP.Br/UFU é referência no desenvolvimento de inovações em tecnologia assistiva voltadas para o esporte paralímpico e vem atuando buscando soluções diretas com as demandas de atletas paralímpicos e do Comitê Paralímpico Brasileiro (CPB). Os projetos são financiados pelo Ministério da Ciência, Tecnologia e Inovação (MCTI) e pelo Ministério Público do Trabalho (MPT/Uberlândia-MG). A forma de atuação em rede colaborativa, multidisciplinar e em parcerias fortalecem as pesquisas, aceleram os processos e aproximam os pesquisadores da sociedade. Em Uberlândia, os projetos acontecem em conjunto com a Prefeitura Municipal de Uberlândia por meio da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel), o Comitê Paralímpico Brasileiro (CPB), o Praia Clube de Uberlândia, o Grupo Algar, Algar Telecom e Brain Instituto de Ciência e Tecnologia, e Sesi Gravatás (Fiemg). “Está aí, parabéns aos pesquisadores autores e toda a equipe do CINTESP.Br. As Cartas patentes concedidas são resultados de muito esforço e dedicação e que vai auxiliar muitas pessoas, não tenham dúvida. Trabalho, esforço, muito suor e o reconhecimento de que estamos no caminho certo”, disse Cleudmar Araújo, coordenador do CINTESP.Br/UFU.</p>\n<p style="text-align: justify;">São aproximadamente 50 pesquisadores, envolvendo profissionais técnicos, estudantes de graduação e de pós-graduação e docentes, atuando em mais de 60 projetos que passam pelas áreas de educação, saúde, lazer, esporte e vida diária, o CINTESP.Br/UFU ainda mais de 30 registros de pedidos de patentes em avaliação junto ao INPI.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula(Ascom CINTESP.Br/UFU) Revisão: Cleudmar Araújo(Coord. CINTESP.Br/UFU) O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU), encerrou o quadrimestre deste ano comemorando as publicações de duas novas cartas patentes. Os produtos são inéditos no Brasil, um dos equipamentos patenteados, o ergômetro para cadeirantes, possibilita a avaliação do condicionamento físico de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7929,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-7927",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7927",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7927",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7927/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7930,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7927/revisions/7930",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7929",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7927",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7927",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7927",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7921,
        date: "2022-05-18T17:28:43",
        date_gmt: "2022-05-18T20:28:43",
        guid: {
            rendered: "https://cintespbr.org/?p=7921",
        },
        modified: "2022-05-18T17:34:26",
        modified_gmt: "2022-05-18T20:34:26",
        slug: "7921",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/7921/",
        title: {
            rendered:
                "O CINTESP.Br/UFU protagoniza surpreende união de parceiros na área de TA para o paradesporto e vida-diária",
        },
        content: {
            rendered:
                '<p><div id="attachment_7922" style="width: 2146px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7922" class="wp-image-7922 size-full" src="https://cintespbr.org/wp-content/uploads/2022/05/surpreende.jpg" alt="" width="2136" height="695" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/05/surpreende.jpg 2136w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/surpreende-300x98.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/surpreende-1024x333.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/surpreende-768x250.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/surpreende-1536x500.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/surpreende-2048x666.jpg 2048w" sizes="(max-width: 2136px) 100vw, 2136px" /><p id="caption-attachment-7922" class="wp-caption-text">LANCE PcD 2022 realizado no SESI Gravatás em Uberlândia-MG Fotos: DIRCO /UFU e SECOM/PMU &#8211; Valter de Paula</p></div></p>\n<p>&nbsp;</p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula- Ascom CINSTESP.Br /UFU</span><br />\n<span style="font-size: 8pt;">Revisão: Cleudmar Araújo – Coord. CINTESP.Br/UFU</span></p>\n<p style="text-align: justify;">O Lançamento de inovações em Tecnologia Assistiva &#8211; LANCE PcD 2022 realizado, em Uberlândia, pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU) na área de Tecnologia Assistiva (TA) revelou uma nova perspectiva para o paradesporto, além de projetos inovadores para a vida-diária de PcD.</p>\n<p style="text-align: justify;">O evento aconteceu no final do mês de março, no SESI Gravatás, unidade da Federação das Indústrias de MG, espaço com estrutura esportiva com pista de atletismo homologada para competições internacionais e onde a maioria dos 21 produtos lançados estarão disponíveis para uso dos paratletas em treinamento se tornando em uma efetiva vitrine e campo de testes para os produtos desenvolvidos tanto para o alto rendimento quanto na iniciação ao paradesporto.</p>\n<p style="text-align: justify;">A cerimônia de entrega lotou o salão e contou com a participação de representantes de todos os parceiros envolvidos na rede colaborativa formada pelo CINTESP.Br/UFU.</p>\n<p style="text-align: justify;">A cerimônia foi acompanhada pelo Reitor da UFU, pelo pró-reitor de extensão, por representantes da Agência Intelecto-UFU, secretários e diretor de 2 Ministérios do Governo Federal: o da Ciência, Tecnologia e Inovações e do Ministério da Cidadania. Agentes financiadores compareceram ao evento, como superintendentes da Caixa Federal, do Governo do Estado de Minas Gerais por meio da Secretaria de Estado de Desenvolvimento Social  (SEDESE), de empresas como a Companhia Brasileira de Metalurgia e Mineração (CBMM), de empresas como a Mover Cadeiras (fabricante de cadeira de rodas) e Metalurgia Ludy, do Comando Militar do Planalto e seus Centros de capacitação física e desportiva do Exército, Clubes de Serviço como o Praia Clube, da Prefeitura de Uberlândia por meio da FUTEL, da Secretaria Municipal de Educação, organizações do terceiro setor como a Associação dos Paraplégicos de Uberlândia (APARU) e Clube Desportivo para deficientes de Uberlândia (CDDU), Conselho Municipal dos Direitos da Criança e do Adolescente entre outros de apoio ao paradesporto e assistência social e educação de Uberlândia, além e representantes das prefeituras de Campina Verde e de Araguari e diversos pesquisadores e profissionais que atuam com Tecnologia Assistiva. A programação chamou a atenção pelo número de equipamentos, pela inovação tecnológica que eles apresentam e pela união de instituições Públicas, Particulares e Sociais que trabalham em rede colaborativa. <strong><em>“Então, eventos como esse agregam porque traz uma dimensão mais visual, sendo possível enxergar o resultado prático de tudo aquilo que está sendo desenvolvido e trazendo a devolutiva social que o estado está fazendo utilizando os recursos da população”</em></strong>, destacou Felipe Belucci, coordenador-Geral de Tecnologias Habilitadoras da SEMPI/MCTI.</p>\n<p style="text-align: justify;">O evento também foi acompanhado , em tempo real, por mais de 600 pessoas que participaram da transmição, em tempo real, pelo canal do youtube da UFU. <a href="https://www.youtube.com/watch?v=ebj9rERa_lA&amp;t=463s">https://www.youtube.com/watch?v=ebj9rERa_lA&amp;t=463s</a></p>\n<p style="text-align: justify;">A finalização dos projetos com registro de patentes contou com recursos do Ministério de Ciência, Tecnologia e Inovação (MCTI) e do Ministério Público do Trabalho (MPT), Regional Uberlândia. As demandas vieram do Comitê Paralímpico Brasileiro (CPB) e da parceria com a Fundação de Turismo Esporte e Lazer, da Prefeitura de Uberlândia (Futel) e Praia Clube Uberlândia que apoiam a iniciação e os paratletas de alto rendimento. Essa rede ainda envolve o Clube Desportivo para Deficientes de Uberlândia (CDDU), a Associação dos Paraplégicos de Uberlândia em parceria (Aparu), a Associação dos Deficientes Visuais do Triângulo Mineiro (Adevitrim) e a Associação dos Deficientes Visuais de Uberlândia (Adeviudi). <strong><em>“Essa receita está dando certo aqui com a união das iniciativas público e privada em favor do que vemos aqui hoje, esse é o Brasil que dá certo”</em></strong>, disse Guto Braga, presidente do Praia Clube Uberlândia.</p>\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; Texto: Cristiane de Paula- Ascom CINSTESP.Br /UFU Revisão: Cleudmar Araújo – Coord. CINTESP.Br/UFU O Lançamento de inovações em Tecnologia Assistiva &#8211; LANCE PcD 2022 realizado, em Uberlândia, pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU) na área de Tecnologia Assistiva (TA) revelou uma nova perspectiva para o paradesporto, além de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7923,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-7921",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7921",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7921",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7921/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7926,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7921/revisions/7926",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7923",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7921",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7921",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7921",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7916,
        date: "2022-05-18T16:38:16",
        date_gmt: "2022-05-18T19:38:16",
        guid: {
            rendered: "https://cintespbr.org/?p=7916",
        },
        modified: "2022-05-19T17:13:59",
        modified_gmt: "2022-05-19T20:13:59",
        slug: "educacao-inclusiva-com-estimulo-a-leitura-e-conhecimento-das-diferencas-faz-parte-dos-projetos-do-cintesp-br-ufuv",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/educacao-inclusiva-com-estimulo-a-leitura-e-conhecimento-das-diferencas-faz-parte-dos-projetos-do-cintesp-br-ufuv/",
        title: {
            rendered:
                "Educação inclusiva com estímulo à leitura e conhecimento das diferenças faz parte dos projetos do  CINTESP.Br/UFU",
        },
        content: {
            rendered:
                '<p><div id="attachment_7918" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7918" class="wp-image-7918 size-large" src="https://cintespbr.org/wp-content/uploads/2022/05/escola-1024x328.jpg" alt="" width="1024" height="328" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/05/escola-1024x328.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/escola-300x96.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/escola-768x246.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/escola-1536x491.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/escola.jpg 1844w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-7918" class="wp-caption-text">Secretária de Educação de Uberlândia, Tânia Toledo na entrega de livro para Enzo Yonemura acompanhado de sua mãe, Célia Naeko. Foto SECOM/PMU -Valter de Paula</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula- Ascom CINSTESP.Br /UFU<br />\nRevisão: Cleudmar Araújo – Coord. CINTESP.Br/UFU</span></p>\n<p>Ao longo do ano de 2021, seguindo as restrições de regras de controle da covid-19 o Centro Brasileiro de referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU) em parceria com a Coordenação-Geral de Articulação em Ciência, Tecnologia e Inovação do Ministério da Ciência, Tecnologia e Inovações (CGAR/SEAPC/MCTI) desenvolve um trabalho social por meio de ações voltadas ao conhecimento da ciência, de forma lúdica e promovendo o fortalecimento da cultura da inclusão por meio da acessibilidade com o estímulo à leitura.</p>\n<p>Os projetos foram desenvolvidos para atender a demanda espontânea vinda de instituições sociais e escolas públicas. As propostas sugeriam ações na educação com o objetivo de promover o conhecimento, de forma lúdica, da ciência e da tecnologia por meio de uma cultura pela inclusão em acessibilidade. Nessa primeira fase do projeto foram participaram 8 Instituições abrangendo mais de 2500 famílias.</p>\n<p>Ao longo do ano pesquisadores do CINTESP.Br/UFU, ligados a área da educação visitaram as Instituições, fizeram reuniões e palestras com educadores e profissionais que trabalham em salas de aula. Foram entregues materiais produzidos pelo MCTI para conhecimento dos projetos do Ministério ligados à educação e cartilhas a respeito de acessibilidade inclusiva.</p>\n<p>O resultado do trabalho foi à produção de cinco edições de cartilhas, impressas e doadas pelo CINTESP.Br/UFU em um total de 5 mil exemplares. A doação foi feita no Lançamento de inovações em Tecnologia Assistiva &#8211; LANCE PcD 2022, realizado em 28 de Março/2022, no SESI-Gravatás na cidade de Uberlândia-MG. Na oportunidade a secretária de Educação de Uberlândia, Tânia Toledo, realizou a entrega simbólica para Enzo Yonemura que representou as escolas beneficiadas pelo projeto.</p>\n<p>O material produzido fará parte do acervo das instituições e do MCTI por meio da Coordenadoria Geral de Articulação em Ciência, Tecnologia e Inovação da Secretaria de Articulação e Promoção da Ciência do Ministério, autora deste projeto juntamente com diversos pesquisadores do Cintesp.Br-UFU. Os livros editados e entregues foram:</p>\n<p>1 &#8211; Janela do Conhecimento</p>\n<p>2 &#8211;  Uma Escola Aberta às Diferenças humanas</p>\n<p>3 &#8211;  Novos Tempos</p>\n<p>4 &#8211; Inclusão no Coração, Respeito à Diversidade, Cooperação e Solidariedade</p>\n<p>5 &#8211; Guia para Mulheres Submetidas à Mastectomia.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula- Ascom CINSTESP.Br /UFU Revisão: Cleudmar Araújo – Coord. CINTESP.Br/UFU Ao longo do ano de 2021, seguindo as restrições de regras de controle da covid-19 o Centro Brasileiro de referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU) em parceria com a Coordenação-Geral de Articulação em Ciência, Tecnologia e Inovação do Ministério da&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7917,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-7916",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7916",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7916",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7916/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7967,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7916/revisions/7967",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7917",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7916",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7916",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7916",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7911,
        date: "2022-05-18T16:02:28",
        date_gmt: "2022-05-18T19:02:28",
        guid: {
            rendered: "https://cintespbr.org/?p=7911",
        },
        modified: "2022-05-18T16:06:12",
        modified_gmt: "2022-05-18T19:06:12",
        slug: "acessibilidade-lance-pcd-2022-com-entrega-de-dispositivos-para-a-vida-diaria-que-permitem-inclusao-social-e-produtiva",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/acessibilidade-lance-pcd-2022-com-entrega-de-dispositivos-para-a-vida-diaria-que-permitem-inclusao-social-e-produtiva/",
        title: {
            rendered:
                "Acessibilidade – LANCE PcD 2022 com entrega de dispositivos para a vida diária que permitem inclusão social e produtiva",
        },
        content: {
            rendered:
                '<p><div id="attachment_7913" style="width: 1803px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7913" class="wp-image-7913 size-full" src="https://cintespbr.org/wp-content/uploads/2022/05/adilson-telas.jpg" alt="" width="1793" height="590" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/05/adilson-telas.jpg 1793w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/adilson-telas-300x99.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/adilson-telas-1024x337.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/adilson-telas-768x253.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/adilson-telas-1536x505.jpg 1536w" sizes="(max-width: 1793px) 100vw, 1793px" /><p id="caption-attachment-7913" class="wp-caption-text">Adilson de Paula – artista plástico usando próteses para pintar telas Foto: DIRCO/UFU</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula- Ascom CINSTESP.Br /UFU<br />\nRevisão: Cleudmar Araújo – Coord. CINTESP.Br/UFU</span></p>\n<p style="text-align: justify;">Vida nova, esse é o sentido do Programa – Social / Vida Diária também desenvolvido pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos. Um Programa que faz parte da Missão do CINTESP.Br/UFU.</p>\n<p style="text-align: justify;">Na cerimônia do Lançamento de inovações em Tecnologia Assistiva &#8211; LANCE PcD 2022, que aconteceu no último dia 28 em Uberlândia foram lançados dispositivos que começaram a ser utilizados pelo artista plástico Adilson de Paula, profissional liberal voltado ao setor da construção civil que sofreu amputação dos braços e pernas, após acidente elétrico.</p>\n<p style="text-align: justify;">Com a impossibilidade de trabalhar como pintor de paredes, Adilson de Paula descobriu a habilidade nas artes plásticas e com o uso dos dispositivos desenvolvidos pelos pesquisadores do CINTESP.Br/UFU. São produtos fabricados por manufatura aditiva (Impressão 3D) que foram projetados com escaneamento digital e projetados para adaptação nos membros superiores para facilitar a utilização de acessórios como talheres, canetas e os pincéis usados pelo artista.</p>\n<p style="text-align: justify;">No evento, Adilson presentou 20 telas que ficaram em exposição e começaram a ser comercializadas. Os dispositivos permitem independência econômica e mais autonomia em tarefas simples do dia a dia.<strong><em> “é uma mudança radical de vida, eu não conseguia, eu mesmo me alimentar sozinho, escovar os dentes e fazer o que eu gosto que é pintar. Eu fiquei melhor com as próteses, eu me sinto mais confiante, estou muito feliz”</em></strong>, disse Adilson.</p>\n<p style="text-align: justify;">A inovação em TA, desenvolvida pelo CINTESP.Br/UFU passa pela versatilidade da rede colaborativa com pesquisadores multidisciplinares e pelos parceiros que vão desde à Prefeitura de Uberlândia, por meio da sua Fundação de Turismo Esporte e Lazer (FUTEL), passando pelo Comitê Paralímpico Brasileiro(CPB), o Praia Clube Uberlândia trabalhando com recursos do Ministério da Ciência, Tecnologia e Inovações(MCTI) e Ministério Público do Trabalho, região Uberlândia.</p>\n<p style="text-align: justify;">Neste sentido, o CINTESP.Br/UFU busca manter o Programa Social para Educação e Vida diária e desenvolve inovações tecnológicas em TA voltadas para a melhoria da vida diária de pessoas com deficiência (PcD), com mobilidade reduzida e doenças raras nas áreas de lazer, esporte, saúde e educação. O objetivo é de facilitar a reinserção dessa significativa parcela da sociedade brasileira na vida social, no mercado de trabalho e com melhoria da qualidade de vida.</p>\n<p>&nbsp;</p>\n<p><div id="attachment_7914" style="width: 402px" class="wp-caption alignleft"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7914" class="wp-image-7914 " src="https://cintespbr.org/wp-content/uploads/2022/05/jap-300x211.jpg" alt="" width="392" height="276" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/05/jap-300x211.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/jap-1024x719.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/jap-768x539.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/jap-1536x1078.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/05/jap-2048x1438.jpg 2048w" sizes="(max-width: 392px) 100vw, 392px" /><p id="caption-attachment-7914" class="wp-caption-text">General Rui Yutaka Matsuda, chefe do Comando Militar do Planalto destacou a importância da tecnologia assistiva, e a atuação e apoio do exército brasileiro na sociedade voltados para as pessoas com deficiência. Foto: DIRCO/UFU</p></div></p>\n<p style="text-align: justify;">O LANCE PcD 2022 chamou a atenção de outras Instituições do país que trabalham com projetos de reabilitação para o paradesporto e para a vida diária, como foi o caso do Centro de Capacitação Física do Exército coordenado pelo Comando do Estado Maior do Exército, “colocamos nossa força para somar nossos projetos e estamos aqui com os dirigentes de nossos Centros de capacitação física e desportiva do Exército para ajudar esse projeto tão grandioso para cooperar da melhor forma possível para ajudar nessa empreitada”, que disse o General Rui Yutaka Matsuda, chefe do Comando Militar do Planalto. O General esteve em Uberlândia para acompanhar o lançamento e viabilizar ações para agregar valor social por meio de projetos na região do Triângulo Mineiro.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula- Ascom CINSTESP.Br /UFU Revisão: Cleudmar Araújo – Coord. CINTESP.Br/UFU Vida nova, esse é o sentido do Programa – Social / Vida Diária também desenvolvido pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos. Um Programa que faz parte da Missão do CINTESP.Br/UFU. Na cerimônia do Lançamento de inovações em&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7912,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-7911",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7911",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7911",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7911/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7915,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7911/revisions/7915",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7912",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7911",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7911",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7911",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7886,
        date: "2022-04-24T23:34:00",
        date_gmt: "2022-04-25T02:34:00",
        guid: {
            rendered: "https://cintespbr.org/?p=7886",
        },
        modified: "2022-05-18T15:27:07",
        modified_gmt: "2022-05-18T18:27:07",
        slug: "torneio-internacional-de-tenis-em-cadeira-de-rodas-foi-cenario-de-conhecimento-para-pesquisadores-do-cintesp-br-ufu",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/torneio-internacional-de-tenis-em-cadeira-de-rodas-foi-cenario-de-conhecimento-para-pesquisadores-do-cintesp-br-ufu/",
        title: {
            rendered:
                "Torneio Internacional de tênis em cadeira de rodas foi cenário de conhecimento para pesquisadores do CINTESP.Br/UFU.",
        },
        content: {
            rendered:
                '<p><div id="attachment_7887" style="width: 2390px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7887" class="wp-image-7887 size-full" src="https://cintespbr.org/wp-content/uploads/2022/04/destac.jpg" alt="" width="2380" height="520" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/destac.jpg 2380w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/destac-300x66.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/destac-1024x224.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/destac-768x168.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/destac-1536x336.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/destac-2048x447.jpg 2048w" sizes="(max-width: 2380px) 100vw, 2380px" /><p id="caption-attachment-7887" class="wp-caption-text">Pesquisadores do CINTESP.Br/UFU no Torneio Internacional de tênis em cadeira de rodas realizado no Praia Clube, em Uberlândia</p></div></p>\n<p><span style="font-size: 10pt;">Texto: Cristiane de Paula ASCOM -CINTESP.Br/UFU<br />\n</span></p>\n<p style="text-align: left;"><span style="font-size: 12pt;">O Uberlândia International Wheelchair Tennis Open, que aconteceu neste final de semana foi o cenário ideal para os estudos dos pesquisadores do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos CINTESP.Br/UFU. Foram 4 dias de competições, envolvendo 5 países, (Brasil, Argentina, Chile, Canadá e Costa Rica), 64 paratletas de 4 categorias que movimentaram as quadras do Praia Clube.</span></p>\n<p style="text-align: left;"><span style="font-size: 12pt;">O que chamou a atenção dos pesquisadores foi o número recorde de participantes e a presença de destaques mundiais no tênis em cadeira de rodas, cenário perfeito para pesquisas de campo para atender o alto rendimento, um dos principais focos de inovação em tecnologia assistiva dos pesquisadores, “não podíamos deixar de participar, de conversar e conhecer não só os equipamentos que eles(paratletas) usam como principalmente das necessidades deles para se chegar ao alto rendimento, trabalhamos para isso e conversar com eles está sendo um grande conhecimento e o melhor, em casa, aqui em Uberlândia”, completa Mário físico e pesquisador do CINTESP.Br/UFU do Laboratório do Movimento Humano da UFU.</span></p>\n<p style="text-align: left;"><span style="font-size: 12pt;">Entre os atletas veteranos presentes no Torneio os pesquisadores do CINTESP.Br/UFU conversaram com Adalberto Rodrigues, jogador há mais de 30 anos e com o tempo de experiência em quadra  ele desempenha também a função de consultor mecânico de cadeira de rodas, sendo referência entre os paratletas e as indústrias fabricantes de cadeiras de rodas para esporte e vida diária, “muitas vezes um ajuste, com base em uma observação minha,  faz  a diferença no desempenho em quadra e conquista de medalhas, foi o que aconteceu, por exemplo com o Ymanitu Silva, oitavo no ranking mundial da classe  “quad”(atletas com deficiências em três ou mais extremidades do corpo).</span></p>\n<p style="text-align: left;"><span style="font-size: 12pt;">A variedade de paratletas ajuda na ampliação das pesquisas em busca do melhor equipamento, da melhor cadeira de rodas. Entre os competidores estavam em Uberlândia, Jade Lanai, há 5 anos em competições, referência em várias categorias, é terceira no ranking mundial juvenil feminino, primeira do Brasil e pela sexta vez joga em Uberlândia. Segundo Juliana Braga, pesquisadora do CINTESP.Br/UFU da área de designer de produtos, o Torneio ofereceu ambiente ideal de conhecimento “é dessa variedade de que estamos falando e buscando, nós temos como prioridade atender às necessidades do atleta e não tem preço estar aqui, conversando com eles e conhecendo os tipos de cadeiras e materiais que eles usam ou desejam usar, isso é pesquisa para inovação”,</span></p>\n<p style="text-align: left;"><span style="font-size: 12pt;">O Torneio International Wheelchair Tennis Open é um dos principais do Brasil e abriu, o calendário 2022 no país. Cada partida soma pontos para classificação mundial. Pelas qualidades estruturais e geográficas Uberlândia já é referência em eventos internacionais em cadeira de rodas e este ano, o campeonato de cadeira de rodas superou as expectativas em número de participantes e também já é eleito um dos preferidos tanto dos atletas quanto do organizador e patrocinadores, “viajo o mundo inteiro em torneios e realizo vários pelo Brasil, estamos em um dos melhores cenários do mundo para realização de esportes em cadeira de rodas, Uberlândia tem uma excelente infraestrutura para deslocamento, para hospedagem adaptada com conforto para atender a grandes públicos e estamos em um clube 100% adaptado”, disse Raphael Moraes, promotor do Torneio.</span></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula ASCOM -CINTESP.Br/UFU O Uberlândia International Wheelchair Tennis Open, que aconteceu neste final de semana foi o cenário ideal para os estudos dos pesquisadores do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos CINTESP.Br/UFU. Foram 4 dias de competições, envolvendo 5 países, (Brasil, Argentina, Chile, Canadá e Costa Rica), 64&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7888,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-7886",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7886",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7886",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7886/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7893,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7886/revisions/7893",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7888",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7886",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7886",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7886",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7880,
        date: "2022-04-19T22:12:53",
        date_gmt: "2022-04-20T01:12:53",
        guid: {
            rendered: "https://cintespbr.org/?p=7880",
        },
        modified: "2022-07-11T23:04:01",
        modified_gmt: "2022-07-12T02:04:01",
        slug: "cintesp-br-ufu-entrega-inovacoes-em-tecnologia-assistiva-ta-em-fase-de-licenciamento-para-serem-produzidos-para-toda-a-sociedade",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-ufu-entrega-inovacoes-em-tecnologia-assistiva-ta-em-fase-de-licenciamento-para-serem-produzidos-para-toda-a-sociedade/",
        title: {
            rendered:
                "Projetos de pesquisa saem dos laboratórios para o uso de paratletas do alto rendimento e toda a sociedade",
        },
        content: {
            rendered:
                '<p><div id="attachment_7881" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7881" class="wp-image-7881 size-large" src="https://cintespbr.org/wp-content/uploads/2022/04/alto-rendimeto-1024x323.jpg" alt="" width="1024" height="323" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/alto-rendimeto-1024x323.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/alto-rendimeto-300x95.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/alto-rendimeto-768x242.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/alto-rendimeto-1536x485.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/alto-rendimeto.jpg 1812w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-7881" class="wp-caption-text">Cadeira de alto rendimento para esgrima com metodologia inovadora de prescrição automatizada desenvolvida pelo CINTESP.Br/UFU e petra (Bike Running) também desenvolvida com metodologia de prescrição para personalização considerando medidas antropométricas do atleta. Foto: DIRCO/UFU</p></div></p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula ASCOM- CINTESSP.Br/UFU<br />\nRevisão: Cleudmar Araújo – Coord. CONTESP.Br/UFU</span></p>\n<p style="text-align: justify;">Após anos, alguns com 10 anos, conseguem ser finalizados por pesquisadores e com recursos do Ministério da Ciência Tecnologia e Inovações (MCTI) e do Ministério Público do Trabalho/Região Uberlândia.</p>\n<p style="text-align: justify;">A aceleração das pesquisas só foram possíveis a partir do final do ano de 2019 com a transformação pelo MCTI do “Núcleo De Habilitação Reabilitação em Esportes Paralímpicos, conhecido por NH/RESP em Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos – CINTESP.Br/UFU.</p>\n<p style="text-align: justify;">Nos últimos 2 anos, mesmo com as restrições em meio a pandemia, obedecendo todas as normas de segurança contra convid-19, os pesquisadores do CINTESP.Br/UFU se revezaram nas atividades, dentro e fora dos laboratórios, impulsionaram as etapas das pesquisas, os testes de validação e transformaram os vários anos de projetos em  diversos produtos estão prontos para a indústria.</p>\n<p style="text-align: justify;">Essa foi a grande novidade e o CINTESP.Br/UFU reuniu todo o esforço no Lançamento de inovações em Tecnologia Assistiva &#8211; LANCE PcD 2022 onde foram lançados para a sociedade 21 produtos inovadores em Tecnologia Assistiva (TA).</p>\n<p style="text-align: justify;">Alguns dos equipamentos já receberam Carta Patente do Instituto Nacional da Propriedade industrial (INPI), o restante já se encontra em processo de licenciamento com a iniciativa privada.</p>\n<p style="text-align: justify;">O que significa que 9 dos 21 equipamentos lançados encontra-se em processo de liberação para serem fabricados e gerarem as primeiras “Notas Fiscais” para a sociedade Brasileira, que foi uma das premissas do apoio do MCTI, por meio da Secretaria de Empreendedorismo e Inovação, a SEMPI/MCTI. “Este é o foco principal do CINTESP.Br/UFU, ou seja, proporcionar meios para que estas tecnologias inovadoras cheguem para a sociedade brasileira em um menor tempo possível”, de acordo com o coordenador-geral do CINTESP.Br/UFU, Cleudmar Araújo.</p>\n<p style="text-align: justify;">De acordo com o coordenador do CINTESP.Br/UFU, Cleudmar Araújo, equipamentos que irão contribuir para a produção nacional e fomentar o mercado de trabalho gerando riquezas para o País<strong><em>. “Um outro ponto importante é que devemos incentivar os alunos das Universidades que é uma área interessante e lembrando o seguinte: essa é uma área que tem, atualmente, mais de 45 milhões de consumidores, ou seja, podemos ter uma economia forte no país nessa área”</em></strong>, completou o Diretor do Departamento de Tecnologias Estruturantes do MCTI.</p>\n<p style="text-align: justify;">Os licenciamentos das cadeiras de rodas de alto rendimento encontram-se em fase final de negociação com a empresa “MOVER CADEIRAS”, instalada em Goiânia e com tradição na fabricação de cadeiras de rodas esportivas e convencionais. <strong><em>”Estamos vendo aqui o retorno de todo o investimento e, além disso, enxergando a importância de termos instituições como Universidades, como os Institutos de pesquisas, como as organizações do terceiro setor trabalhando juntos, é possível enxergar o resultado prático de tudo aquilo que está sendo desenvolvido e trazendo a devolutiva social que o estado está fazendo utilizando os recursos da população”, </em></strong>acrescentou o coord. geral da Secretaria de Empreendedorismo e Inovação do MCTI.</p>\n<p style="text-align: justify;">Os modelos de cadeiras de rodas a serem licenciados junto à UFU com a empresa, por meio do Cintesp.Br são: Cadeiras anatômicas otimizadas e parametrizadas para:</p>\n<p style="text-align: justify;">O Uso Diário; para o Basquetebol e o Handebol; para o Tênis, Tênis de Mesa e Esgrima; para o Rúgbi Ataque; para o Rúgbi Defesa; para o Parabadminton; Manocleta Infantil Anatômica Otimizada e Parametrizada para o Ciclismo; um Dispositivo Aplicado a Encosto para Cadeira de Rodas de Uso Diário e um Dispositivo Anti-tombo Aplicado à Cadeira de Rodas Parametrizada para Basquetebol e Handebol<strong><em>. “Foi mais uma vitória dentre muitas, que nos impulsiona a seguir em frente com coragem e determinação”</em></strong>, disse Lucas Cardoso, pesquisadordo CINTESP.Br e autor do equipamento de prescrição para cadeira de rodas.</p>\n<p style="text-align: justify;"><strong><em>“Todas essas tecnologias estão prontas para a sociedade e destacar que somente com a união é que podemos levar o que produzimos para as pessoas. As pessoas com deficiência não podem esperar, o tempo tem que ser reduzido e reduzir a dependência dos importados que é alta, vamos dar continuidade a esse trabalho, o CINTESP.Br vive para estas pessoas”,</em></strong> disse o Coordenador-Geral do CINTESP.Br/UFU, Cleudmar Araújo.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula ASCOM- CINTESSP.Br/UFU Revisão: Cleudmar Araújo – Coord. CONTESP.Br/UFU Após anos, alguns com 10 anos, conseguem ser finalizados por pesquisadores e com recursos do Ministério da Ciência Tecnologia e Inovações (MCTI) e do Ministério Público do Trabalho/Região Uberlândia. A aceleração das pesquisas só foram possíveis a partir do final do ano de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7882,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-7880",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7880",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7880",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7880/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8070,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7880/revisions/8070",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7882",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7880",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7880",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7880",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7876,
        date: "2022-04-19T22:00:43",
        date_gmt: "2022-04-20T01:00:43",
        guid: {
            rendered: "https://cintespbr.org/?p=7876",
        },
        modified: "2022-05-17T21:48:08",
        modified_gmt: "2022-05-18T00:48:08",
        slug: "cintesp-br-ufu-recebe-apoio-de-pesquisadores-internacionais-no-lance-pcd-2022-realizado-em-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-ufu-recebe-apoio-de-pesquisadores-internacionais-no-lance-pcd-2022-realizado-em-uberlandia/",
        title: {
            rendered:
                "CINTESP.Br – UFU recebe apoio de pesquisadores internacionais no LANCE PcD 2022 realizado em Uberlândia",
        },
        content: {
            rendered:
                '<p><div id="attachment_7877" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7877" class="wp-image-7877 size-large" src="https://cintespbr.org/wp-content/uploads/2022/04/rory-1024x277.jpg" alt="" width="1024" height="277" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/rory-1024x277.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/rory-300x81.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/rory-768x208.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/rory-1536x415.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/rory.jpg 1969w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-7877" class="wp-caption-text">Dr. Raúl Reina e Dr. Rory Cooper, pesquisadores da Espanha e Estados Unidos, respectivamente, em pronunciamento de apoio ao desenvolvimento de Tecnologia Assistiva, apresentado no evento LANCE PcD 2022 realizado pelo CINTESP.Br/UFU na cidade de Uberlândia-MG.</p></div></p>\n<p>&nbsp;</p>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula – ASCOM CINTESP.Br/UFU<br />\nRevisão: Cleudmar Araújo – Coord. CONTESP.Br/UFU</span></p>\n<p style="text-align: justify;">No início deste ano (2022) o CINTESP.Br/UFU consolidou o processo de internacionalização e ampliou a rede de colaboradores buscando conhecimento a respeito de Tecnologia Assistiva (TA), por meio de intercâmbios e cooperação internacional em Centros de pesquisa consolidados no mundo.</p>\n<p style="text-align: justify;">O primeiro intercâmbio envolve o Laboratório de Engenharia Humana e Pesquisa de Pittsburgh e ao U.S. Department of Veterans Affairs nos EUA. Centro de pesquisa que  trabalha na recuperação de veteranos, bem como, o uso de tecnologia assistiva para a inserção de pessoas com deficiência ao mercado de trabalho, <strong><em>“Durante esse processo é importante trabalharmos com pessoas com deficiência assim como com clínicos, nosso governo e parceiros da indústria”</em></strong>, disse o pesquisador Rory Cooper, diretor do Human Engineering and Research Laboratory, em mensagem enviada no Lançamento de inovações em Tecnologia Assistiva &#8211; Lance PcD 2022 realizado na cidade de Uberlândia-MG.</p>\n<p style="text-align: justify;">O trabalho em rede colaborativa também envolve pesquisadores da Espanha, como é o caso do professor Raúl Reina, professor da ciência do desporto da Universidade Miguel Hernández que também enviou mensagem de apoio ao lançamento de inovações em Tecnologia Assistiva apresentadas no evento LANCE PcD 2022, que aconteceu em Uberlândia-MG, <strong><em>“Considero um evento muito importante para compartilhar a tecnologia assistiva em favor ao paradesporto e romper a barreira de acesso dos paratletas a essa tecnologia e importante fator para todos os níveis do esporte paralímpico, o que pode ser a diferença para proporcionar o empoderamento, a melhor qualidade de vida e a inclusão social das pessoas com deficiência”</em></strong>, disse Raúl Reina.</p>\n<p style="text-align: justify;">Célia Regina Lopes, é a primeira pesquisadora do CINTESP.Br/UFU a fazer parte do intercâmbio, também é professora da Faculdade de Fisioterapia da Universidade Federal de Uberlândia – UFU. Desde o início do ano, ela faz parte da equipe do Dr. Rory Cooper nos EUA e vai atuar no desenvolvimento de pesquisas relacionadas com automação de veículos para pessoas com deficiência, inovações no sistema de transporte coletivo e novas tecnologias em transferências de pessoas da cadeira para o leito ou para atividades de vida diária, <strong><em>“Nós buscamos oferecer soluções inovadoras para pessoas com deficiência que necessitam de tecnologia assistiva para mobilidade, audição, fala e outras necessidades cotidianas e aqui estamos empenhados nas inovações para diferentes tipos de cadeiras de rodas”</em></strong>, disse Célia Regina, pesquisadora do CINTESP.Br em intercâmbio nos Estados Unidos.</p>\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; Texto: Cristiane de Paula – ASCOM CINTESP.Br/UFU Revisão: Cleudmar Araújo – Coord. CONTESP.Br/UFU No início deste ano (2022) o CINTESP.Br/UFU consolidou o processo de internacionalização e ampliou a rede de colaboradores buscando conhecimento a respeito de Tecnologia Assistiva (TA), por meio de intercâmbios e cooperação internacional em Centros de pesquisa consolidados no mundo. O&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7878,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-7876",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7876",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7876",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7876/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7906,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7876/revisions/7906",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7878",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7876",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7876",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7876",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7871,
        date: "2022-04-19T21:41:08",
        date_gmt: "2022-04-20T00:41:08",
        guid: {
            rendered: "https://cintespbr.org/?p=7871",
        },
        modified: "2022-04-19T21:42:26",
        modified_gmt: "2022-04-20T00:42:26",
        slug: "elevador-de-transferencia-para-piscinas-pra-pcd-ou-mobilidade-reduzida",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/elevador-de-transferencia-para-piscinas-pra-pcd-ou-mobilidade-reduzida/",
        title: {
            rendered:
                "Elevador de Transferência para Piscinas pra PcD ou Mobilidade Reduzida",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7873&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7873&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7868,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [67],
        tags: [],
        class_list: [
            "post-7871",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-lance-pcd",
            "category-67",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7871",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7871",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7871/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7874,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7871/revisions/7874",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7868",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7871",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7871",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7871",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7854,
        date: "2022-04-19T21:26:00",
        date_gmt: "2022-04-20T00:26:00",
        guid: {
            rendered: "https://cintespbr.org/?p=7854",
        },
        modified: "2022-04-19T21:35:01",
        modified_gmt: "2022-04-20T00:35:01",
        slug: "equipamento-de-prescricao",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/equipamento-de-prescricao/",
        title: {
            rendered: "Equipamento de Prescrição",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7855&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7855&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7868,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [67],
        tags: [],
        class_list: [
            "post-7854",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-lance-pcd",
            "category-67",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7854",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7854",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7854/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7867,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7854/revisions/7867",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7868",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7854",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7854",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7854",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7850,
        date: "2022-04-19T21:22:05",
        date_gmt: "2022-04-20T00:22:05",
        guid: {
            rendered: "https://cintespbr.org/?p=7850",
        },
        modified: "2022-04-19T21:33:31",
        modified_gmt: "2022-04-20T00:33:31",
        slug: "cadeira-de-rodas-para-esgrima",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cadeira-de-rodas-para-esgrima/",
        title: {
            rendered: "Cadeira de Rodas para Esgrima",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7851&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7851&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7852,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [67],
        tags: [],
        class_list: [
            "post-7850",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-lance-pcd",
            "category-67",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7850",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7850",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7850/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7866,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7850/revisions/7866",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7852",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7850",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7850",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7850",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7844,
        date: "2022-04-19T21:12:52",
        date_gmt: "2022-04-20T00:12:52",
        guid: {
            rendered: "https://cintespbr.org/?p=7844",
        },
        modified: "2022-04-19T21:35:28",
        modified_gmt: "2022-04-20T00:35:28",
        slug: "cadeira-de-rodas-para-basquetebol",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cadeira-de-rodas-para-basquetebol/",
        title: {
            rendered: "Cadeira de Rodas para Basquetebol",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7845&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7845&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7846,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [67],
        tags: [],
        class_list: [
            "post-7844",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-lance-pcd",
            "category-67",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7844",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7844",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7844/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7869,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7844/revisions/7869",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7846",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7844",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7844",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7844",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7840,
        date: "2022-04-19T21:09:09",
        date_gmt: "2022-04-20T00:09:09",
        guid: {
            rendered: "https://cintespbr.org/?p=7840",
        },
        modified: "2022-04-19T21:35:46",
        modified_gmt: "2022-04-20T00:35:46",
        slug: "cadeira-de-rodas-para-rugbi",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cadeira-de-rodas-para-rugbi/",
        title: {
            rendered: "Cadeira de Rodas para Rúgbi",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7841&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7841&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7842,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [67],
        tags: [],
        class_list: [
            "post-7840",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-lance-pcd",
            "category-67",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7840",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7840",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7840/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7870,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7840/revisions/7870",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7842",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7840",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7840",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7840",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7836,
        date: "2022-04-19T20:59:57",
        date_gmt: "2022-04-19T23:59:57",
        guid: {
            rendered: "https://cintespbr.org/?p=7836",
        },
        modified: "2022-04-19T20:59:57",
        modified_gmt: "2022-04-19T23:59:57",
        slug: "cadeira-de-rodas-para-tenis-de-quadra",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cadeira-de-rodas-para-tenis-de-quadra/",
        title: {
            rendered: "Cadeira de Rodas para Tênis de Quadra",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7837&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7837&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7838,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [67],
        tags: [],
        class_list: [
            "post-7836",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-lance-pcd",
            "category-67",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7836",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7836",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7836/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7839,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7836/revisions/7839",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7838",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7836",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7836",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7836",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7827,
        date: "2022-04-19T20:36:15",
        date_gmt: "2022-04-19T23:36:15",
        guid: {
            rendered: "https://cintespbr.org/?p=7827",
        },
        modified: "2022-04-19T20:36:15",
        modified_gmt: "2022-04-19T23:36:15",
        slug: "protese-de-punho-e-mao-para-amputacao-transradial-de-membro-superior-msd",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/protese-de-punho-e-mao-para-amputacao-transradial-de-membro-superior-msd/",
        title: {
            rendered:
                "Prótese de punho e mão para amputação transradial de membro superior (MSD)",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7828&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7828&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7829,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [67],
        tags: [],
        class_list: [
            "post-7827",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-lance-pcd",
            "category-67",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7827",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7827",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7827/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7830,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7827/revisions/7830",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7829",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7827",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7827",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7827",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7822,
        date: "2022-04-19T20:21:27",
        date_gmt: "2022-04-19T23:21:27",
        guid: {
            rendered: "https://cintespbr.org/?p=7822",
        },
        modified: "2022-04-19T20:21:27",
        modified_gmt: "2022-04-19T23:21:27",
        slug: "calha-para-bocha-paralimpica",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/calha-para-bocha-paralimpica/",
        title: {
            rendered: "Calha para Bocha Paralímpica",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7823&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][vc_single_image image=&#8221;7824&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7823&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][vc_single_image image=&#8221;7824&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7825,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [67],
        tags: [],
        class_list: [
            "post-7822",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-lance-pcd",
            "category-67",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7822",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7822",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7822/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7826,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7822/revisions/7826",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7825",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7822",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7822",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7822",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7815,
        date: "2022-04-13T21:27:10",
        date_gmt: "2022-04-14T00:27:10",
        guid: {
            rendered: "https://cintespbr.org/?p=7815",
        },
        modified: "2022-05-18T15:43:28",
        modified_gmt: "2022-05-18T18:43:28",
        slug: "equipamentos-em-tecnologia-assistiva-saem-dos-laboratorios-para-atenderem-pessoas-com-deficiencia-no-paradesporto-e-na-vida-diaria",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/equipamentos-em-tecnologia-assistiva-saem-dos-laboratorios-para-atenderem-pessoas-com-deficiencia-no-paradesporto-e-na-vida-diaria/",
        title: {
            rendered:
                "Conheça os equipamentos entregues no Lançamento de inovações em Tecnologia Assistiva LANCE PcD 2022",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<div id="attachment_7816" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7816" class="wp-image-7816 size-large" src="https://cintespbr.org/wp-content/uploads/2022/04/entregas-1024x335.jpg" alt="" width="1024" height="335" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/entregas-1024x335.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/entregas-300x98.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/entregas-768x251.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/entregas-1536x502.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/entregas.jpg 1916w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-7816" class="wp-caption-text">Exposição de equipamentos – Salão de eventos SESI Gravatás, Uberlândia/MG Fotos: DIRCO/UFU</p></div>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula – ASCOM CINTESP.Br/UFU<br />\nRevisão: Cleudmar Araújo – Coord. CONTESP.Br/UFU</span></p>\n<p style="text-align: justify;">A grande novidade do Lançamento de inovações em Tecnologia Assistiva &#8211; LANCE PcD 2022.</p>\n<p style="text-align: justify;">Foram lançados 21 produtos que envolvem também novas metodologias e serviços. Um volume de lançamentos de inovações em Tecnologia Assistiva inédito no Brasil, desenvolvidos por um Centro de Pesquisas vinculado à uma Universidade Federal.</p>\n<p style="text-align: justify;">O evento aconteceu na cidade de Uberlândia-MG, todos os produtos foram entregues para serem utilizados por atletas, treinadores que atuam no SESI-Gravatás sendo uma vitrine direta para empreendedores, associações e instituições que atuam com tecnologias assistiva no Brasil.</p>\n<p style="text-align: justify;">O trabalho foi desenvolvido em rede colaborativa com a participação de mais de 80 pessoas entre pesquisadores, profissionais, instituições e facilitadores ligados ao CINTESP.Br/UFU.</p>\n<p style="text-align: justify;">Os recursos para o desenvolvimento e finalização dos projetos  foram investidos pelo Ministério de Ciência, Tecnologia e Inovações (MCTI) e pelo Ministério Público do Trabalho/região Uberlândia e uma rede colaborativa externa envolvendo a Prefeitura de Uberlândia, por meio da Fundação de Turismo Esporte e Lazer (FUTEL), de instituições sociais &#8211; Associação dos Paraplégicos de Uberlândia(APARU), Instituto Brain(algar), SESI Gravatás/FIEMG e da iniciativa privada pela parceria como Praia Clube Uberlândia.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column]<style type="text/css" data-type="the7_shortcodes-inline-css">.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.dividers-on.classic-layout-list article {\n  padding-top: 0;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.dividers-on.classic-layout-list article:first-of-type {\n  margin-top: 0;\n  padding-top: 0;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.classic-layout-list.mode-list .post-entry-content {\n  width: calc(100% - );\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.classic-layout-list.mode-list .no-img .post-entry-content {\n  width: 100%;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .filter-bg-decoration .filter-categories a.act {\n  color: #fff;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255:not(.mode-masonry) article:first-of-type,\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255:not(.mode-masonry) article.visible.first:not(.product) {\n  margin-top: 0;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.dividers-on:not(.mode-masonry) article {\n  margin-top: 0;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.dividers-on:not(.mode-masonry) article:first-of-type,\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.dividers-on:not(.mode-masonry) article.visible.first:not(.product) {\n  margin-top: 0;\n  padding-top: 0;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .post-thumbnail-wrap {\n  padding: 0px 0px 0px 0px;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.enable-bg-rollover .post-thumbnail-rollover:after {\n  background: -webkit-linear-gradient();\n  background: linear-gradient();\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .gallery-zoom-ico {\n  width: 44px;\n  height: 44px;\n  line-height: 44px;\n  border-radius: 100px;\n  margin: -22px 0 0 -22px;\n  border-width: 0px;\n  color: #ffffff;\n}\n.bottom-overlap-layout-list.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .gallery-zoom-ico {\n  margin-top: -72px;\n}\n.gradient-overlay-layout-list.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .gallery-zoom-ico,\n.content-rollover-layout-list.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .gallery-zoom-ico {\n  margin: 0 0 10px;\n}\n.content-align-center.gradient-overlay-layout-list.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .gallery-zoom-ico,\n.content-align-center.content-rollover-layout-list.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .gallery-zoom-ico {\n  margin: 0 auto 10px;\n}\n.dt-icon-bg-on.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .gallery-zoom-ico {\n  background: rgba(255,255,255,0.3);\n  box-shadow: none;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .gallery-zoom-ico > span,\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .gallery-zoom-ico:before {\n  font-size: 32px;\n  line-height: 44px;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .gallery-zoom-ico > span,\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .gallery-zoom-ico:before {\n  color: #ffffff;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .entry-title,\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.owl-carousel .entry-title {\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .entry-meta {\n  margin-bottom: 15px;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .portfolio-categories {\n  margin-bottom: 15px;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .entry-excerpt {\n  margin-bottom: 5px;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255:not(.centered-layout-list) .post-entry-content {\n  padding: 25px 30px 30px 30px;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255:not(.centered-layout-list):not(.content-bg-on):not(.mode-list) .no-img .post-entry-content {\n  padding: 0;\n}\n@media screen and (max-width: ) {\n  .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 article {\n    -ms-flex-flow: column nowrap;\n    flex-flow: column nowrap;\n    margin-top: 20px;\n  }\n  .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.dividers-on article {\n    border: none;\n  }\n  .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.content-bg-on.centered-layout-list article {\n    padding: 0;\n  }\n  .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.blog-shortcode.dividers-on article,\n  .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.dividers-on.classic-layout-list article {\n    margin-top: 20px;\n    padding: 0;\n  }\n  .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.blog-shortcode.dividers-on article:first-of-type,\n  .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.dividers-on.classic-layout-list article:first-of-type {\n    padding: 0;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .post-thumbnail-wrap,\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .post-entry-content {\n    width: 100%;\n    margin: 0;\n    top: 0;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .post-thumbnail-wrap {\n    padding: 0;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .post-entry-content:after {\n    display: none;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .project-even .post-thumbnail-wrap,\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.centered-layout-list .post-thumbnail-wrap {\n    -ms-flex-order: 0;\n    order: 0;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.centered-layout-list .post-entry-title-content {\n    -ms-flex-order: 1;\n    order: 1;\n    width: 100%;\n    padding: 20px 20px 0;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.centered-layout-list .post-entry-content {\n    -ms-flex-order: 2;\n    order: 2;\n    padding-top: 0;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .fancy-categories {\n    top: 10px;\n    left: 10px;\n    bottom: auto;\n    right: auto;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .fancy-date a {\n    top: 10px;\n    right: 10px;\n    left: auto;\n    bottom: auto;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .post-entry-content {\n    padding: 20px;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .entry-title {\n    margin: 3px 0 5px;\n    font-size: 20px;\n    line-height: 26px;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .entry-meta {\n    margin: 5px 0 5px;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .entry-excerpt {\n    margin: 15px 0 0;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .post-details {\n    margin: 5px 0 10px;\n  }\n  #page .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 .post-details.details-type-link {\n    margin-bottom: 2px;\n  }\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255:not(.resize-by-browser-width) .dt-css-grid {\n  grid-row-gap: 30px;\n  grid-column-gap: 30px;\n  grid-template-columns: repeat(auto-fill,minmax(,1fr));\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255:not(.resize-by-browser-width) .dt-css-grid .double-width {\n  grid-column: span 2;\n}\n.cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255:not(.resize-by-browser-width) .dt-css-grid,\n.no-cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255:not(.resize-by-browser-width) .dt-css-grid {\n  display: flex;\n  flex-flow: row wrap;\n  margin: -15px;\n}\n.cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255:not(.resize-by-browser-width) .dt-css-grid .wf-cell,\n.no-cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255:not(.resize-by-browser-width) .dt-css-grid .wf-cell {\n  flex: 1 0 ;\n  max-width: 100%;\n  padding: 15px;\n  box-sizing: border-box;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid {\n  grid-template-columns: repeat(5,1fr);\n  grid-template-rows: auto;\n  grid-column-gap: 30px;\n  grid-row-gap: 30px;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .double-width {\n  grid-column: span 2;\n}\n.cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid {\n  margin: -15px;\n}\n.cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell {\n  width: 20%;\n  padding: 15px;\n}\n.cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell.double-width {\n  width: calc(20%) * 2;\n}\n.blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width:not(.centered-layout-list):not(.content-bg-on) .dt-css-grid {\n  grid-row-gap: 0px;\n}\n@media screen and (max-width: 1199px) {\n  .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid {\n    grid-template-columns: repeat(3,1fr);\n  }\n  .cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell,\n  .no-cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell {\n    width: 33.333333333333%;\n  }\n  .cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell.double-width,\n  .no-cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell.double-width {\n    width: calc(33.333333333333%)*2;\n  }\n}\n@media screen and (max-width: 991px) {\n  .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid {\n    grid-template-columns: repeat(2,1fr);\n  }\n  .cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell,\n  .no-cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell {\n    width: 50%;\n  }\n  .cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell.double-width,\n  .no-cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell.double-width {\n    width: calc(50%)*2;\n  }\n}\n@media screen and (max-width: 767px) {\n  .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid {\n    grid-template-columns: repeat(1,1fr);\n  }\n  .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .double-width {\n    grid-column: span 1;\n  }\n  .cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell,\n  .no-cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell {\n    width: 100%;\n  }\n  .cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell.double-width,\n  .no-cssgridlegacy.no-cssgrid .blog-shortcode.blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255.resize-by-browser-width .dt-css-grid .wf-cell.double-width {\n    width: calc(100%)*2;\n  }\n}\n</style><div class="blog-shortcode blog-masonry-shortcode-id-ce5b722fc16493aa51b69ffdf860e255 mode-grid classic-layout-list content-bg-on jquery-filter scale-img dt-css-grid-wrap dt-icon-bg-off resize-by-browser-width loading-effect-none description-under-image " data-padding="15px" data-cur-page="1" data-post-limit="-1" data-pagination-mode="none" data-desktop-columns-num="5" data-v-tablet-columns-num="2" data-h-tablet-columns-num="3" data-phone-columns-num="1" data-width="0px" data-columns="0"><div class="dt-css-grid" ><div class="visible wf-cell" data-post-id="7871" data-date="2022-04-19T21:41:08-03:00" data-name="Elevador de Transferência para Piscinas pra PcD ou Mobilidade Reduzida"><article class="post project-odd visible post-7871 type-post status-publish format-standard has-post-thumbnail hentry category-lance-pcd category-67 description-off" data-name="Elevador de Transferência para Piscinas pra PcD ou Mobilidade Reduzida" data-date="2022-04-19T21:41:08-03:00">\n\n<div class="post-thumbnail-wrap">\n\t<div class="post-thumbnail">\n\t\t\n\t\t\n\t\t<a href="https://cintespbr.institucional.ws/elevador-de-transferencia-para-piscinas-pra-pcd-ou-mobilidade-reduzida/" class="post-thumbnail-rollover layzr-bg layzr-bg" ><img fetchpriority="high" decoding="async" class="iso-lazy-load preload-me iso-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20768%20512&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/prescr.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/prescr.jpg 768w" loading="eager" style="--ratio: 768 / 512" sizes="(max-width: 768px) 100vw, 768px" alt="" title="prescr" width="768" height="512"  /></a>\t</div>\n</div>\n\n\n<div class="post-entry-content">\n\n\t<h3 class="entry-title">\n\t\t<a href="https://cintespbr.institucional.ws/elevador-de-transferencia-para-piscinas-pra-pcd-ou-mobilidade-reduzida/" title="Elevador de Transferência para Piscinas pra PcD ou Mobilidade Reduzida" rel="bookmark">Elevador de Transferência para Piscinas pra PcD ou Mobilidade Reduzida</a>\n\t</h3>\n\n\t<div class="entry-meta"><a href="https://cintespbr.institucional.ws/2022/04/19/" title="21:41" class="data-link" rel="bookmark"><time class="entry-date updated" datetime="2022-04-19T21:41:08-03:00">19/04/2022</time></a></div>\n\t\n\t\n</div></article></div><div class="visible wf-cell" data-post-id="7854" data-date="2022-04-19T21:26:00-03:00" data-name="Equipamento de Prescrição"><article class="post project-odd visible post-7854 type-post status-publish format-standard has-post-thumbnail hentry category-lance-pcd category-67 description-off" data-name="Equipamento de Prescrição" data-date="2022-04-19T21:26:00-03:00">\n\n<div class="post-thumbnail-wrap">\n\t<div class="post-thumbnail">\n\t\t\n\t\t\n\t\t<a href="https://cintespbr.institucional.ws/equipamento-de-prescricao/" class="post-thumbnail-rollover layzr-bg layzr-bg" ><img fetchpriority="high" decoding="async" class="iso-lazy-load preload-me iso-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20768%20512&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/prescr.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/prescr.jpg 768w" loading="eager" style="--ratio: 768 / 512" sizes="(max-width: 768px) 100vw, 768px" alt="" title="prescr" width="768" height="512"  /></a>\t</div>\n</div>\n\n\n<div class="post-entry-content">\n\n\t<h3 class="entry-title">\n\t\t<a href="https://cintespbr.institucional.ws/equipamento-de-prescricao/" title="Equipamento de Prescrição" rel="bookmark">Equipamento de Prescrição</a>\n\t</h3>\n\n\t<div class="entry-meta"><a href="https://cintespbr.institucional.ws/2022/04/19/" title="21:26" class="data-link" rel="bookmark"><time class="entry-date updated" datetime="2022-04-19T21:26:00-03:00">19/04/2022</time></a></div>\n\t\n\t\n</div></article></div><div class="visible wf-cell" data-post-id="7850" data-date="2022-04-19T21:22:05-03:00" data-name="Cadeira de Rodas para Esgrima"><article class="post project-odd visible post-7850 type-post status-publish format-standard has-post-thumbnail hentry category-lance-pcd category-67 description-off" data-name="Cadeira de Rodas para Esgrima" data-date="2022-04-19T21:22:05-03:00">\n\n<div class="post-thumbnail-wrap">\n\t<div class="post-thumbnail">\n\t\t\n\t\t\n\t\t<a href="https://cintespbr.institucional.ws/cadeira-de-rodas-para-esgrima/" class="post-thumbnail-rollover layzr-bg layzr-bg" ><img decoding="async" class="iso-lazy-load preload-me iso-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20768%20512&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/esgrima-dest.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/esgrima-dest.jpg 768w" loading="eager" style="--ratio: 768 / 512" sizes="(max-width: 768px) 100vw, 768px" alt="" title="esgrima dest" width="768" height="512"  /></a>\t</div>\n</div>\n\n\n<div class="post-entry-content">\n\n\t<h3 class="entry-title">\n\t\t<a href="https://cintespbr.institucional.ws/cadeira-de-rodas-para-esgrima/" title="Cadeira de Rodas para Esgrima" rel="bookmark">Cadeira de Rodas para Esgrima</a>\n\t</h3>\n\n\t<div class="entry-meta"><a href="https://cintespbr.institucional.ws/2022/04/19/" title="21:22" class="data-link" rel="bookmark"><time class="entry-date updated" datetime="2022-04-19T21:22:05-03:00">19/04/2022</time></a></div>\n\t\n\t\n</div></article></div><div class="visible wf-cell" data-post-id="7844" data-date="2022-04-19T21:12:52-03:00" data-name="Cadeira de Rodas para Basquetebol"><article class="post project-odd visible post-7844 type-post status-publish format-standard has-post-thumbnail hentry category-lance-pcd category-67 description-off" data-name="Cadeira de Rodas para Basquetebol" data-date="2022-04-19T21:12:52-03:00">\n\n<div class="post-thumbnail-wrap">\n\t<div class="post-thumbnail">\n\t\t\n\t\t\n\t\t<a href="https://cintespbr.institucional.ws/cadeira-de-rodas-para-basquetebol/" class="post-thumbnail-rollover layzr-bg layzr-bg" ><img decoding="async" class="iso-lazy-load preload-me iso-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20768%20512&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/basq.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/basq.jpg 768w" loading="eager" style="--ratio: 768 / 512" sizes="(max-width: 768px) 100vw, 768px" alt="" title="basq" width="768" height="512"  /></a>\t</div>\n</div>\n\n\n<div class="post-entry-content">\n\n\t<h3 class="entry-title">\n\t\t<a href="https://cintespbr.institucional.ws/cadeira-de-rodas-para-basquetebol/" title="Cadeira de Rodas para Basquetebol" rel="bookmark">Cadeira de Rodas para Basquetebol</a>\n\t</h3>\n\n\t<div class="entry-meta"><a href="https://cintespbr.institucional.ws/2022/04/19/" title="21:12" class="data-link" rel="bookmark"><time class="entry-date updated" datetime="2022-04-19T21:12:52-03:00">19/04/2022</time></a></div>\n\t\n\t\n</div></article></div><div class="visible wf-cell" data-post-id="7840" data-date="2022-04-19T21:09:09-03:00" data-name="Cadeira de Rodas para Rúgbi"><article class="post project-odd visible post-7840 type-post status-publish format-standard has-post-thumbnail hentry category-lance-pcd category-67 description-off" data-name="Cadeira de Rodas para Rúgbi" data-date="2022-04-19T21:09:09-03:00">\n\n<div class="post-thumbnail-wrap">\n\t<div class="post-thumbnail">\n\t\t\n\t\t\n\t\t<a href="https://cintespbr.institucional.ws/cadeira-de-rodas-para-rugbi/" class="post-thumbnail-rollover layzr-bg layzr-bg" ><img decoding="async" class="iso-lazy-load preload-me iso-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20768%20512&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/rug.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/rug.jpg 768w" loading="eager" style="--ratio: 768 / 512" sizes="(max-width: 768px) 100vw, 768px" alt="" title="rug" width="768" height="512"  /></a>\t</div>\n</div>\n\n\n<div class="post-entry-content">\n\n\t<h3 class="entry-title">\n\t\t<a href="https://cintespbr.institucional.ws/cadeira-de-rodas-para-rugbi/" title="Cadeira de Rodas para Rúgbi" rel="bookmark">Cadeira de Rodas para Rúgbi</a>\n\t</h3>\n\n\t<div class="entry-meta"><a href="https://cintespbr.institucional.ws/2022/04/19/" title="21:09" class="data-link" rel="bookmark"><time class="entry-date updated" datetime="2022-04-19T21:09:09-03:00">19/04/2022</time></a></div>\n\t\n\t\n</div></article></div><div class="visible wf-cell" data-post-id="7836" data-date="2022-04-19T20:59:57-03:00" data-name="Cadeira de Rodas para Tênis de Quadra"><article class="post project-odd visible post-7836 type-post status-publish format-standard has-post-thumbnail hentry category-lance-pcd category-67 description-off" data-name="Cadeira de Rodas para Tênis de Quadra" data-date="2022-04-19T20:59:57-03:00">\n\n<div class="post-thumbnail-wrap">\n\t<div class="post-thumbnail">\n\t\t\n\t\t\n\t\t<a href="https://cintespbr.institucional.ws/cadeira-de-rodas-para-tenis-de-quadra/" class="post-thumbnail-rollover layzr-bg layzr-bg" ><img decoding="async" class="iso-lazy-load preload-me iso-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20768%20512&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/cadeira-dest.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/cadeira-dest.jpg 768w" loading="eager" style="--ratio: 768 / 512" sizes="(max-width: 768px) 100vw, 768px" alt="" title="cadeira dest" width="768" height="512"  /></a>\t</div>\n</div>\n\n\n<div class="post-entry-content">\n\n\t<h3 class="entry-title">\n\t\t<a href="https://cintespbr.institucional.ws/cadeira-de-rodas-para-tenis-de-quadra/" title="Cadeira de Rodas para Tênis de Quadra" rel="bookmark">Cadeira de Rodas para Tênis de Quadra</a>\n\t</h3>\n\n\t<div class="entry-meta"><a href="https://cintespbr.institucional.ws/2022/04/19/" title="20:59" class="data-link" rel="bookmark"><time class="entry-date updated" datetime="2022-04-19T20:59:57-03:00">19/04/2022</time></a></div>\n\t\n\t\n</div></article></div><div class="visible wf-cell" data-post-id="7827" data-date="2022-04-19T20:36:15-03:00" data-name="Prótese de punho e mão para amputação transradial de membro superior (MSD)"><article class="post project-odd visible post-7827 type-post status-publish format-standard has-post-thumbnail hentry category-lance-pcd category-67 description-off" data-name="Prótese de punho e mão para amputação transradial de membro superior (MSD)" data-date="2022-04-19T20:36:15-03:00">\n\n<div class="post-thumbnail-wrap">\n\t<div class="post-thumbnail">\n\t\t\n\t\t\n\t\t<a href="https://cintespbr.institucional.ws/protese-de-punho-e-mao-para-amputacao-transradial-de-membro-superior-msd/" class="post-thumbnail-rollover layzr-bg layzr-bg" ><img decoding="async" class="iso-lazy-load preload-me iso-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20768%20512&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/protese-de-punho.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/protese-de-punho.jpg 768w" loading="eager" style="--ratio: 768 / 512" sizes="(max-width: 768px) 100vw, 768px" alt="" title="protese de punho" width="768" height="512"  /></a>\t</div>\n</div>\n\n\n<div class="post-entry-content">\n\n\t<h3 class="entry-title">\n\t\t<a href="https://cintespbr.institucional.ws/protese-de-punho-e-mao-para-amputacao-transradial-de-membro-superior-msd/" title="Prótese de punho e mão para amputação transradial de membro superior (MSD)" rel="bookmark">Prótese de punho e mão para amputação transradial de membro superior (MSD)</a>\n\t</h3>\n\n\t<div class="entry-meta"><a href="https://cintespbr.institucional.ws/2022/04/19/" title="20:36" class="data-link" rel="bookmark"><time class="entry-date updated" datetime="2022-04-19T20:36:15-03:00">19/04/2022</time></a></div>\n\t\n\t\n</div></article></div><div class="visible wf-cell" data-post-id="7822" data-date="2022-04-19T20:21:27-03:00" data-name="Calha para Bocha Paralímpica"><article class="post project-odd visible post-7822 type-post status-publish format-standard has-post-thumbnail hentry category-lance-pcd category-67 description-off" data-name="Calha para Bocha Paralímpica" data-date="2022-04-19T20:21:27-03:00">\n\n<div class="post-thumbnail-wrap">\n\t<div class="post-thumbnail">\n\t\t\n\t\t\n\t\t<a href="https://cintespbr.institucional.ws/calha-para-bocha-paralimpica/" class="post-thumbnail-rollover layzr-bg layzr-bg" ><img decoding="async" class="iso-lazy-load preload-me iso-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20768%20512&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/calha-dest.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/calha-dest.jpg 768w" loading="eager" style="--ratio: 768 / 512" sizes="(max-width: 768px) 100vw, 768px" alt="" title="calha dest" width="768" height="512"  /></a>\t</div>\n</div>\n\n\n<div class="post-entry-content">\n\n\t<h3 class="entry-title">\n\t\t<a href="https://cintespbr.institucional.ws/calha-para-bocha-paralimpica/" title="Calha para Bocha Paralímpica" rel="bookmark">Calha para Bocha Paralímpica</a>\n\t</h3>\n\n\t<div class="entry-meta"><a href="https://cintespbr.institucional.ws/2022/04/19/" title="20:21" class="data-link" rel="bookmark"><time class="entry-date updated" datetime="2022-04-19T20:21:27-03:00">19/04/2022</time></a></div>\n\t\n\t\n</div></article></div><div class="visible wf-cell" data-post-id="7768" data-date="2022-04-07T01:29:20-03:00" data-name="Banco Universal Multirregulável sem fixação por cintas para a Modalidade Paralímpica do Arremesso"><article class="post project-odd visible post-7768 type-post status-publish format-standard has-post-thumbnail hentry category-lance-pcd category-67 description-off" data-name="Banco Universal Multirregulável sem fixação por cintas para a Modalidade Paralímpica do Arremesso" data-date="2022-04-07T01:29:20-03:00">\n\n<div class="post-thumbnail-wrap">\n\t<div class="post-thumbnail">\n\t\t\n\t\t\n\t\t<a href="https://cintespbr.institucional.ws/banco-universal-multirregulavel-sem-fixacao-por-cintas-para-a-modalidade-paralimpica-do-arremesso/" class="post-thumbnail-rollover layzr-bg layzr-bg" ><img decoding="async" class="iso-lazy-load preload-me iso-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20768%20512&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/Banco-de-Arremesso.png" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/Banco-de-Arremesso.png 768w" loading="eager" style="--ratio: 768 / 512" sizes="(max-width: 768px) 100vw, 768px" alt="" title="Banco de Arremesso" width="768" height="512"  /></a>\t</div>\n</div>\n\n\n<div class="post-entry-content">\n\n\t<h3 class="entry-title">\n\t\t<a href="https://cintespbr.institucional.ws/banco-universal-multirregulavel-sem-fixacao-por-cintas-para-a-modalidade-paralimpica-do-arremesso/" title="Banco Universal Multirregulável sem fixação por cintas para a Modalidade Paralímpica do Arremesso" rel="bookmark">Banco Universal Multirregulável sem fixação por cintas para a Modalidade Paralímpica do Arremesso</a>\n\t</h3>\n\n\t<div class="entry-meta"><a href="https://cintespbr.institucional.ws/2022/04/07/" title="01:29" class="data-link" rel="bookmark"><time class="entry-date updated" datetime="2022-04-07T01:29:20-03:00">07/04/2022</time></a></div>\n\t\n\t\n</div></article></div></div><!-- iso-container|iso-grid --></div>[/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Texto: Cristiane de Paula – ASCOM CINTESP.Br/UFU Revisão: Cleudmar Araújo – Coord. CONTESP.Br/UFU A grande novidade do Lançamento de inovações em Tecnologia Assistiva &#8211; LANCE PcD 2022. Foram lançados 21 produtos que envolvem também novas metodologias e serviços. Um volume de lançamentos de inovações em Tecnologia Assistiva inédito no Brasil, desenvolvidos por um Centro&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7820,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-7815",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7815",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7815",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7815/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7910,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7815/revisions/7910",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7820",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7815",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7815",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7815",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7808,
        date: "2022-04-11T23:02:35",
        date_gmt: "2022-04-12T02:02:35",
        guid: {
            rendered: "https://cintespbr.org/?p=7808",
        },
        modified: "2022-05-17T21:53:41",
        modified_gmt: "2022-05-18T00:53:41",
        slug: "referencia-mundial-da-esgrima-paralimpica-mundial-se-apresenta-em-uberlandia-no-lance-pcd-2022-utilizando-uma-das-tecnologias-desenvolvidas-pelo-cintesp-br-ufu",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/referencia-mundial-da-esgrima-paralimpica-mundial-se-apresenta-em-uberlandia-no-lance-pcd-2022-utilizando-uma-das-tecnologias-desenvolvidas-pelo-cintesp-br-ufu/",
        title: {
            rendered:
                "Referência Mundial da esgrima paralímpica se apresenta utilizando uma das tecnologias desenvolvidas pelo CINTESP.Br/UFU",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_7809" style="width: 955px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7809" class="wp-image-7809 size-full" src="https://cintespbr.org/wp-content/uploads/2022/04/guissone.png" alt="" width="945" height="694" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/guissone.png 945w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/guissone-300x220.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/guissone-768x564.png 768w" sizes="(max-width: 945px) 100vw, 945px" /><p id="caption-attachment-7809" class="wp-caption-text">Ivan Schwantes e Jovane Guissone na apresentação de esgrima Foto: DIRCO/UFU</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_7810" style="width: 955px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7810" class="wp-image-7810 size-full" src="https://cintespbr.org/wp-content/uploads/2022/04/pres.png" alt="" width="945" height="650" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/pres.png 945w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/pres-300x206.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/pres-768x528.png 768w" sizes="(max-width: 945px) 100vw, 945px" /><p id="caption-attachment-7810" class="wp-caption-text">Antônio Guedes – Ministério da Cidadania Foto: DIRCO/UFU</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]<span style="font-size: 8pt;">Texto: Cristiane de Paula – ASCOM CINTESP.Br/UFU<br />\nRevisão: Cleudmar Araújo – Coord. CONTESP.Br/UFU</span></p>\n<p style="text-align: justify;">A apresentação de esgrima em cadeira de rodas foi um show à parte que serviu para colocar à prova de fogo, na ponta da espada um dos equipamentos desenvolvidos e patenteados pelo CINTESP.Br/UFU.</p>\n<p style="text-align: justify;">No palco, foram instaladas as duas chapas de alumínio para a realização da partida e nelas os dispositivos para prenderem cadeiras, equipamentos utilizados em competições e também novidade para a maioria do público presente no LANCE PcD 2022.</p>\n<p style="text-align: justify;">Os dispositivos fizeram parte da apresentação de esgrima paralímpica que foi realizada pelo paratleta esgrimista, Jovane Guissone, segundo no ranking mundial, e o técnico e treinador do Comitê Paralímpico Brasileiro (CPB), Ivan Schwantes. Na oportunidade, o atleta utilizou e testou ao vivo, a cadeira de rodas para esgrima fabricada a partir de um dos equipamentos entregues pelo CINTESP.Br/UFU.</p>\n<p style="text-align: justify;">A cadeira personalizada com um processo de prescrição automatizado permite o desenvolvimento do modelo em tempo real, com metodologia inovadora de prescrição para diversos tipos de cadeiras de rodas, nesta edição, o CINTESP.Br/UFU entregou 5 modelos(esgrima, basquete, parabadminton, rúgbi e tênis de quadra).</p>\n<p style="text-align: justify;">Jovane Guissone é um dos paratletas que participaram dos processos de prescrição. Os atletas colaboram com os pesquisadores testando as cadeiras de rodas enquanto realizam treinamentos ou até mesmo em jogos, <strong><em>“está aprovada, nunca tive uma cadeira feita pra mim, pro meu jogo, ainda vamos fazer ajustes para ficar do jeito que gosto, mas neste primeiro teste eu já sinto que vou poder buscar melhor performance nos jogos”</em></strong>, disse Jovane.</p>\n<p style="text-align: justify;">Jovane continuará a utilizar a cadeira e passará a indicar ajustes para melhorar a cadeira. Com as informações os pesquisadores poderão dar continuidade à inovação tecnológica no equipamento que prescreve vários modelos, sob medida, de cadeira de rodas. <strong><em>“Nós temos Centros e pesquisadores de altíssimo nível, nós temos atletas de alto nível, então precisamos pensar em produzir nosso conhecimento para que o Brasil possa ser, já nos próximos anos, top 5 no mundo nos próximos jogos”</em></strong>, disse Antônio Guedes, Secretário Nacional de Paradesporto do Ministério da Cidadania, presente no LANCE PcD 2022.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Texto: Cristiane de Paula – ASCOM CINTESP.Br/UFU Revisão: Cleudmar Araújo – Coord. CONTESP.Br/UFU A apresentação de esgrima em cadeira de rodas foi um show à parte que serviu para colocar à prova de fogo, na ponta da espada um dos equipamentos desenvolvidos e patenteados pelo CINTESP.Br/UFU. No palco, foram instaladas as&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7809,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 34],
        tags: [],
        class_list: [
            "post-7808",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-esporte-paralimpico",
            "category-57",
            "category-34",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7808",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7808",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7808/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7907,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7808/revisions/7907",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7809",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7808",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7808",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7808",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7804,
        date: "2022-04-11T22:50:43",
        date_gmt: "2022-04-12T01:50:43",
        guid: {
            rendered: "https://cintespbr.org/?p=7804",
        },
        modified: "2022-07-11T23:12:07",
        modified_gmt: "2022-07-12T02:12:07",
        slug: "assessor-estrategico-da-presidencia-da-caixa-economica-federal-conhece-equipamentos-e-programas-do-cintesp-br-ufu-em-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/assessor-estrategico-da-presidencia-da-caixa-economica-federal-conhece-equipamentos-e-programas-do-cintesp-br-ufu-em-uberlandia/",
        title: {
            rendered:
                "Assessor estratégico da presidência da Caixa Econômica Federal conhece equipamentos e programas do CINTESP.Br/UFU em Uberlândia",
        },
        content: {
            rendered:
                '<div id="attachment_8072" style="width: 954px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-8072" class="wp-image-8072 size-full" src="https://cintespbr.org/wp-content/uploads/2022/04/caixa-1.png" alt="" width="944" height="708" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/caixa-1.png 944w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/caixa-1-300x225.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/caixa-1-768x576.png 768w" sizes="(max-width: 944px) 100vw, 944px" /><p id="caption-attachment-8072" class="wp-caption-text">Assessor estratégico da presidência Caixa em visita ao SESI e experimentando um equipamento desenvolvido para compor a “1ª Academia Experimental para cadeirantes” no Brasil e desenvolvido pelo CINTESP.Br/UFU.</p></div>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula – ASCOM CINTESP.Br/UFU</span></p>\n<p><span style="font-size: 8pt;">Revisão: Cleudmar Araújo – Coord. Geral CINTESP.Br/UFU</span></p>\n<p style="text-align: justify;">Representante da presidência da Caixa Econômica Federal, veio a Uberlândia, nesta quinta-feira (7), motivado pelo que foi apresentado no evento de lançamento dos produtos e serviços desenvolvidos em Tecnologia Assistiva produzidos do CINTESP.Br/UFU.</p>\n<p style="text-align: justify;">O assessor estratégico da presidência conversou com paratletas, com técnicos, com o presidente do Praia Clube Uberlândia, com o diretor da Futel e com pesquisador do CINTESP.Br/UFU. No SESI Gravatás Álvaro Pires conheceu a estrutura voltada ao esporte olímpico e paralímpico e alguns dos 21 equipamentos em tecnologia assistiva entregues há menos de uma semana, em cerimônia especial, para serem utilizados na preparação e treinamentos de paratletas da cidade.</p>\n<p style="text-align: justify;">Com o pesquisador do CINTESP.Br/UFU, Mário Rodrigues, o assessor estratégico da Caixa conheceu uma das cadeiras feitas por um método inovador de prescrição de cadeiras de alto rendimento, uma cadeira “petra” projetada com estrutura parametrizada em função das características antropométricas do atleta e um dos equipamentos que fazem parte da academia experimental para cadeirantes que possibilita o treinamento muscular em velocidade para braços e que possui um sistema inovador de resistência de baixa inércia do tipo came-mola-seguidor.</p>\n<p style="text-align: justify;">A visita faz parte do programa de apoio ao paradesporto da Caixa. O objetivo é apoiar e aumentar a prática do esporte no Brasil, oferecendo a base para crianças e jovens chegarem ao alto rendimento, “achei a estrutura de Uberlândia sensacional, tem uma ciência instalada aqui muito grande, com laboratórios e profissionais muito bons, a estrutura física também é muito boa com profissionais gabaritados, fiquei bem impressionado com o que eu vi aqui hoje”, completou o assessor estratégico da presidência da Caixa.</p>\n<p style="text-align: justify;">Sobre as parcerias que podem acontecer, entre a Caixa e a cidade de Uberlândia, o assessor disse que serão para fortalecerem as estruturas de base que já existem possibilitando mais vagas para a iniciação e descobertas de novos talentos. “Nós priorizamos as questões técnicas e matemáticas das coisas, então, a gente escolhe projetos onde o dinheiro de nosso financiamento atenda o maior número possível de crianças, Uberlândia atende esse perfil e está em uma boa colocação e vai de encontro ao que a Caixa quer, que é trazer crianças para a prática de esportes e assim melhorar a vida e a saúde”, completa conclui Representante da presidência da Caixa Econômica Federal</p>\n<p style="text-align: justify;">O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU) é vinculado à Universidade Federal de Uberlândia (UFU), com financiamentos do Ministério da Ciência, Tecnologia e Inovação (MCTI) e Ministério Público do Trabalho (MPT/Uberlândia-MG), atua em formato de redes colaborativas  e parcerias com a Prefeitura Municipal de Uberlândia por meio da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel), o Comitê Paralímpico Brasileiro (CPB), o Praia Clube de Uberlândia, Grupo Algar com o Instituto Brain/Algar e Sesi Gravatás (Fiemg). “A visita do Representante da presidência da Caixa Econômica Federal, foi motivada pelo evento LANCE PcD 2022 que o CINTESP.Br promoveu, onde foram lançadas inovações em tecnologia assistiva para o paradesporto e vida diária. Estes equipamentos já estão sendo utilizados por paratletas do Praia Clube, da FUTEL, da APARU e da CDDU aqui no SESI. Ficamos otimistas ao ouvir dele que a Caixa tem muito interesse em participar desses projetos ligados ao paradesporto”, disse Mário Rodrigues.</p>\n<p style="text-align: justify;">\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula – ASCOM CINTESP.Br/UFU Revisão: Cleudmar Araújo – Coord. Geral CINTESP.Br/UFU Representante da presidência da Caixa Econômica Federal, veio a Uberlândia, nesta quinta-feira (7), motivado pelo que foi apresentado no evento de lançamento dos produtos e serviços desenvolvidos em Tecnologia Assistiva produzidos do CINTESP.Br/UFU. O assessor estratégico da presidência conversou com paratletas,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7806,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-7804",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7804",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7804",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7804/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8073,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7804/revisions/8073",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7806",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7804",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7804",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7804",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7798,
        date: "2022-04-11T22:37:54",
        date_gmt: "2022-04-12T01:37:54",
        guid: {
            rendered: "https://cintespbr.org/?p=7798",
        },
        modified: "2022-06-30T00:13:00",
        modified_gmt: "2022-06-30T03:13:00",
        slug: "cintesp-br-ufu-realiza-lance-pcd-2022-para-entregar-21-produtos-de-tecnologia-assistiva-para-o-paradesporto-e-vida-diaria",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-ufu-realiza-lance-pcd-2022-para-entregar-21-produtos-de-tecnologia-assistiva-para-o-paradesporto-e-vida-diaria/",
        title: {
            rendered:
                "LANCE PcD 2022 chama a atenção pelo incentivo ao empreendedorismo com inovação e possibilidade de novos recordes paralímpicos",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<div id="attachment_7799" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7799" class="wp-image-7799 size-large" src="https://cintespbr.org/wp-content/uploads/2022/04/cerimonia-1024x338.png" alt="" width="1024" height="338" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/cerimonia-1024x338.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/cerimonia-300x99.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/cerimonia-768x253.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/cerimonia-1536x507.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/cerimonia.png 1912w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-7799" class="wp-caption-text">Cerimônia de Lançamento de produtos desenvolvidos no CINTESP.Br/UFU &#8211; Salão de eventos SESI Fotos: DIRCO/UFU</p></div>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula – ASCOM CINTESP.Br/UFU<br />\nRevisão: Cleudmar Araújo – Coord. CINTESP.Br/UFU</span></p>\n<p style="text-align: justify;">O Lançamento em Tecnologias Assistivas( LANCE PcD) 2022 foi um dos maiores eventos, realizados no Brasil, considerando a quantidade de produtos e de serviços em Tecnologia Assistiva, produzidos e entregues por um Centro de Pesquisas vinculado à uma Universidade Federal.</p>\n<p style="text-align: justify;">A cerimônia proporcionou mais que o lançamento dos produtos, possibilitou aos apoiadores e financiadores reforçarem e ampliarem, publicamente, a rede de parceiros que fazem parte dos projetos, pesquisas e testes de validação. <strong><em>“Precisamos enxergar a importância de termos instituições como as Universidades, como os Institutos de pesquisas, como as organizações do terceiro setor trazendo a devolutiva social que o estado está fazendo utilizando os recursos da população</em></strong>”, disse Felipe Bellucci, coordenador geral de Tecnologias Habilitadoras da Secretaria de Empreendedorismo e Inovação Ministério de Ciência, Tecnologia e Inovações do MCTI.</p>\n<p style="text-align: justify;">Este foi o cenário promovido pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos – CINTESP.Br/UFU, instituído no final de 2019 pelo, então ministro Astronauta Marcos Pontes.</p>\n<p style="text-align: justify;">Desde então,  CINTESP.Br/UFU desenvolve pesquisas em um formato de redes colaborativas atuando no âmbito da Universidade Federal de Uberlândia.</p>\n<p style="text-align: justify;">Foi uma das cerimônias mais esperadas pelo público atendido motivado pelas inovações em Tecnologia Assistiva (TA) desenvolvida pelo CINTESP.Br/UFU, <strong>“<em>eu tenho certeza que a partir das tecnologias entregues aqui hoje muitos resultados serão gerados, agora, já nas Paralimpíadas de Paris em 2024</em></strong><em>”, </em>disse Yohansson Nascimento, vice-presidente do CPB que esteve presente no evento.</p>\n<p style="text-align: justify;">O SESI completa a rede de apoio, voltada ao paradesporto implementada pela Prefeitura de Uberlândia, “<em>hoje temos 33 atletas com bolsa atleta, sendo que 5 tem bolsa pódio e com 2 treinadores da FUTEL que são da seleção brasileira. É deste cenário, deste ambiente que estamos falando”, </em>disse o diretor da Fundação de Turismo, Esporte e Lazer do Município, Édson Zanatta.</p>\n<p style="text-align: justify;">Participaram mais de 200 pessoas sendo mais de 10% de paratletas e técnicos ligados ao CPB e de outros estados. O evento foi transmitido pelo canal do youtube da Universidade Federal de Uberlândia (UFU) e teve acompanhamento remoto por mais de 600 pessoas. <strong><em>“Então, o que importa para todos nós é que essas tecnologias cheguem para todas essas pessoas, esse é o nosso grande objetivo e nós estamos falando aqui de 20 anos de trabalho”, </em></strong>completou Cleudmar Araújo, coordenador do CINTESP.Br/UFU.</p>\n<p>Assista a Cobertura completa do evento LANCES PcD 2022: <a href="https://www.youtube.com/watch?v=ebj9rERa_lA&amp;t=466s">https://www.youtube.com/watch?v=ebj9rERa_lA&amp;t=466s</a>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Texto: Cristiane de Paula – ASCOM CINTESP.Br/UFU Revisão: Cleudmar Araújo – Coord. CINTESP.Br/UFU O Lançamento em Tecnologias Assistivas( LANCE PcD) 2022 foi um dos maiores eventos, realizados no Brasil, considerando a quantidade de produtos e de serviços em Tecnologia Assistiva, produzidos e entregues por um Centro de Pesquisas vinculado à uma Universidade Federal. A&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7803,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-7798",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7798",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7798",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7798/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7904,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7798/revisions/7904",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7803",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7798",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7798",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7798",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7768,
        date: "2022-04-07T01:29:20",
        date_gmt: "2022-04-07T04:29:20",
        guid: {
            rendered: "https://cintespbr.org/?p=7768",
        },
        modified: "2022-04-12T15:32:39",
        modified_gmt: "2022-04-12T18:32:39",
        slug: "banco-universal-multirregulavel-sem-fixacao-por-cintas-para-a-modalidade-paralimpica-do-arremesso",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/banco-universal-multirregulavel-sem-fixacao-por-cintas-para-a-modalidade-paralimpica-do-arremesso/",
        title: {
            rendered:
                "Banco Universal Multirregulável sem fixação por cintas para a Modalidade Paralímpica do Arremesso",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7771&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;7771&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7769,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [67],
        tags: [],
        class_list: [
            "post-7768",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-lance-pcd",
            "category-67",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7768",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7768",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7768/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7773,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7768/revisions/7773",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7769",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7768",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7768",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7768",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7694,
        date: "2022-03-31T18:24:02",
        date_gmt: "2022-03-31T21:24:02",
        guid: {
            rendered: "https://cintespbr.org/?p=7694",
        },
        modified: "2022-09-03T12:32:52",
        modified_gmt: "2022-09-03T15:32:52",
        slug: "cintesp-br-ufu-em-destaque-no-mcti",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-ufu-em-destaque-no-mcti/",
        title: {
            rendered: "CINTESP.Br/UFU em destaque no MCTI",
        },
        content: {
            rendered:
                '<div id="viewlet-above-content-body">\n<div id="media">\n<h2 class="documentFirstHeading">MCTI participa de lançamento de produtos de tecnologia assistiva em Uberlândia (MG)</h2>\n<p><span style="color: #333333;"><em><span style="font-size: 12pt;">Produtos serão usados no esporte paralímpico e no dia a dia de pessoas com mobilidade reduzida</span></em></span></p>\n<p class="discreet" style="text-align: center;"><img loading="lazy" decoding="async" class="aligncenter wp-image-7739 size-full" src="https://cintespbr.org/wp-content/uploads/2022/04/fc72be2b-2962-40d7-94c1-4bab55678caa.png" alt="" width="633" height="421" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/04/fc72be2b-2962-40d7-94c1-4bab55678caa.png 633w, https://cintespbr.institucional.ws/wp-content/uploads/2022/04/fc72be2b-2962-40d7-94c1-4bab55678caa-300x200.png 300w" sizes="(max-width: 633px) 100vw, 633px" />Foto: Valter de Paula – Prefeitura de Uberlândia</p>\n</div>\n</div>\n<div id="content-core">\n<div id="parent-fieldname-text" class="">\n<div>\n<p style="text-align: justify;">O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (Cintesp.BR), da Universidade Federal de Uberlândia (UFU), promoveu na segunda-feira (28), na cidade mineira, o evento “Lance PcD 2022”. O objetivo foi lançar 21 produtos e serviços de tecnologia assistiva voltados a paratletas e que também auxiliarão a vida diária das pessoas com deficiência e mobilidade reduzida.</p>\n<p style="text-align: justify;">Desde 2019, o CINTESP.Br recebe apoio financeiro do MCTI para o desenvolvimento de protótipos dessas tecnologias. O Ministério da Ciência, Tecnologia e Inovações foi representado no evento pelo diretor de Tecnologias Aplicadas, Eduardo Soriano, e o coordenador-geral de Tecnologias Habilitadoras, Felipe Bellucci, ambos da Secretaria de Empreendedorismo e Inovação (SEMPI).</p>\n<p style="text-align: justify;">As tecnologias apresentadas no Lance PcD 2022 incluem equipamentos que irão fazer parte da 1ª Academia Experimental para Cadeirantes; modelos inovadores de cadeiras de rodas para o alto rendimento, projetadas por metodologias inéditas de prescrição; além de equipamentos e acessórios especializados para esportes paralímpicos, nas modalidades do arremesso paralímpico, atletismo, bocha paralímpica e natação.</p>\n<p style="text-align: justify;">Foi destacado também no lançamento a implantação do Centro Nacional de Tecnologias para Pessoas com Deficiência e Doenças Raras – CNT-MCTI, prevista para o segundo semestre de 2022. Os representantes do MCTI visitaram o terreno que abrigará o CNT-MCTI e se reuniram com dirigentes da UFU e pesquisadores para acompanhar os projetos apoiados pelo ministério.</p>\n<p style="text-align: justify;">O CNT/MCTI é uma iniciativa do Ministério da Ciência, Tecnologia e Inovações (MCTI), em parceria com a Universidade Federal de Uberlândia, o Cintesp.BR/UFU, o grupo Algar/Instituto Brain e o Comitê Paralímpico Brasileiro.</p>\n<p>FONTE: MCTI</p>\n<p>&nbsp;</p>\n<p style="text-align: center;"><a href="https://cintespbr.org/?page_id=7643"><span style="font-size: 14pt; color: #0000ff;">CLIQUE AQUI E SAIBA MAIS SOBRE O <strong>LANCE PCD 2022</strong></span></a></p>\n</div>\n<p>&nbsp;</p>\n</div>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>MCTI participa de lançamento de produtos de tecnologia assistiva em Uberlândia (MG) Produtos serão usados no esporte paralímpico e no dia a dia de pessoas com mobilidade reduzida Foto: Valter de Paula – Prefeitura de Uberlândia O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (Cintesp.BR), da Universidade Federal de Uberlândia (UFU), promoveu&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7695,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 43, 62],
        tags: [],
        class_list: [
            "post-7694",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-mcti",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7694",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7694",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7694/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8113,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7694/revisions/8113",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7695",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7694",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7694",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7694",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7677,
        date: "2022-03-26T00:16:26",
        date_gmt: "2022-03-26T03:16:26",
        guid: {
            rendered: "https://cintespbr.org/?p=7677",
        },
        modified: "2022-05-18T15:28:18",
        modified_gmt: "2022-05-18T18:28:18",
        slug: "7677",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/7677/",
        title: {
            rendered:
                "Lançamento de Inovações em Tecnologia Assistiva na cidade de Uberlândia será um marco no Brasil",
        },
        content: {
            rendered:
                '<p style="text-align: justify;"><img loading="lazy" decoding="async" class="alignnone wp-image-7646 size-large" src="https://cintespbr.org/wp-content/uploads/2022/03/TOP-1024x196.png" alt="" width="1024" height="196" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/03/TOP-1024x196.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/TOP-300x57.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/TOP-768x147.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/TOP-1536x293.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/TOP.png 1926w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p style="text-align: justify;">      A partir do dia 28 de março de 2022, às 14h, no SESI/GRAVATÁS, na cidade de Uberlândia, o lançamento de produtos em tecnologia assistiva vai contribuir para melhorar ainda mais a qualidade de vida e a inclusão social de pessoas com deficiência (PcD) da cidade e do Brasil. Trata-se do “LANCE PcD 2022”, um dos maiores eventos de lançamento de inovações em tecnologia assistiva no País.<br />\nA cidade de Uberlândia/MG é um dos grandes centros financeiros do País, sendo também destaque em acessibilidade com ampla rede de associações e entidades direcionadas para as pessoas com deficiência (PcD). Destaca-se também na educação com instituições de alta qualidade, como a Universidade Federal de Uberlândia. Por meio da FUTEL/Prefeitura de Uberlândia possui diversas ações para o esporte, lazer e recreação para jovens e adultos. No esporte, somente em 2022, em Uberlândia, foram cerca de 11 mil vagas, gratuitas, para iniciação esportiva em 25 modalidades esportivas, sendo 580 no paradesporto e 600 no alto rendimento. As modalidades do atletismo, natação e halterofilismo ficaram concentradas no SESI Gravatás, além de 8 modalidades de iniciação esportiva olímpica.<br />\nO Lance PcD é uma realização do, Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br/UFU), da Universidade Federal de Uberlândia, do Ministério da Ciência, Tecnologia e Inovações (MCTI) e Prefeitura Municipal de Uberlândia, e promete ser um marco histórico no Brasil considerando a iniciativa de lançar, em um único evento, equipamentos e serviços em tecnologia assistiva prontos para o uso.<br />\nOs produtos que serão lançados abrangem as áreas do esporte paralímpico e vida diária, como equipamentos que irão fazer parte da 1ª Academia Experimental para Cadeirantes, modelos inovadores de cadeiras de rodas para o alto rendimento, projetadas por metodologias inéditas de prescrição, além de equipamentos e acessórios especializados para esportes paralímpicos nas modalidades do arremesso paralímpico, atletismo, bocha paralímpica e natação.<br />\nAlgumas das tecnologias lançadas auxiliarão na vida diária das pessoas. Histórias motivadoras de sucesso e de luta, na busca de autonomia e qualidade de vida serão apresentadas no evento. Serão lançados 20 produtos e serviços que estarão prontos também para fomentar o empreendedorismo que vem sendo apoiado pela SEMPI/MCTI. “Queremos fazer desde momento um marco para o Brasil, temos uma rede de parceiros e financiadores que empenharam confiança na ciência, pesquisadores e nas ações já desenvolvidas na cidade de Uberlândia em favor do esporte paralímpico e inclusão de pessoas com deficiência, mobilidade reduzida e doenças raras. Nosso objetivo é que um lançamento dessa proporção possa se repetir, será nosso ‘LANCE PcD’, voltado para as pessoas com deficiência, por meio do lançamento anual de inovações em tecnologia assistiva, desenvolvidas pelo CINTESP.Br/UFU, FUTEL/Prefeitura de Uberlândia e seus apoiadores e financiadores”, complementa Cleudmar Araújo, coordenador do CINTESP.Br/UFU.<br />\nOs equipamentos fazem parte de projetos desenvolvidos pelo CINTESP.Br/UFU com financiamentos do Ministério da Ciência, Tecnologia e Inovação e Ministério Público do Trabalho, Região Uberlândia e tiveram a participação direta de paratletas de Uberlândia e de várias cidades do Brasil. A participação de paratletas no desenvolvimento das tecnologias tem o objetivo de incentivar a iniciação esportiva e contribuir para o alto rendimento na busca de novos índices, recordes e medalhas. Algumas tecnologias e equipamentos são inovações mundiais.<br />\nO lançamento dos equipamentos (LANCE PcD 2022) acontecerá no SESI Gravatás, em Uberlândia, que possui espaço com estrutura esportiva homologada para competições internacionais. Os equipamentos ficarão instalados no local para serem utilizados pelos paratletas. A programação chama a atenção pelo número de equipamentos e inovação tecnológica que eles apresentam, além da união de instituições em rede colaborativa destacando, o Comitê Paralímpico Brasileiro(CPB), Futel, Praia Clube, Clube Desportivo para Deficientes de Uberlândia (CDDU), a Associação dos Paraplégicos de Uberlândia (Aparu), a Associação dos Deficientes Visuais do Triângulo Mineiro (Adevitrim) e a Associação dos Deficientes Visuais de Uberlândia (Adeviudi).<br />\nEm 2022, o evento também mostrará ações empreendedoras na cidade de Uberlândia, como a implantação do Centro Nacional de Tecnologias para Pessoas com Deficiência e Doenças Raras – CNT/MCTI. O CNT/MCTI é uma iniciativa do Ministério da Ciência, Tecnologia e Inovações (MCTI) em parceria com a Universidade Federal de Uberlândia, o Cintesp.Br/Ufu, o grupo Algar/Instituto Brain e o Comitê Paralímpico Brasileiro.</p>\n<p>&nbsp;</p>\n<p><img loading="lazy" decoding="async" class="wp-image-7678 aligncenter" src="https://cintespbr.org/wp-content/uploads/2022/03/imagem_destaque_imagem_chamada_sdfd54554-300x170.png" alt="" width="495" height="280" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/03/imagem_destaque_imagem_chamada_sdfd54554-300x170.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/imagem_destaque_imagem_chamada_sdfd54554.png 750w" sizes="(max-width: 495px) 100vw, 495px" /></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>      A partir do dia 28 de março de 2022, às 14h, no SESI/GRAVATÁS, na cidade de Uberlândia, o lançamento de produtos em tecnologia assistiva vai contribuir para melhorar ainda mais a qualidade de vida e a inclusão social de pessoas com deficiência (PcD) da cidade e do Brasil. Trata-se do “LANCE PcD&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7679,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-7677",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7677",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7677",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7677/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7724,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7677/revisions/7724",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7679",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7677",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7677",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7677",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7637,
        date: "2022-03-03T10:51:25",
        date_gmt: "2022-03-03T13:51:25",
        guid: {
            rendered: "https://cintespbr.org/?p=7637",
        },
        modified: "2022-05-18T15:28:47",
        modified_gmt: "2022-05-18T18:28:47",
        slug: "o-que-sao-tecnologias-assistivas-e-a-importancia-das-inovacoes-para-a-inclusao-de-pessoas-com-deficiencia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/o-que-sao-tecnologias-assistivas-e-a-importancia-das-inovacoes-para-a-inclusao-de-pessoas-com-deficiencia/",
        title: {
            rendered:
                "O que são tecnologias assistivas e a importância das inovações para a inclusão de pessoas com deficiência",
        },
        content: {
            rendered:
                '<p><span style="font-size: 8pt;">Texto: Cristiane de Paula-Ascom CINTESP.Br</span></p>\n<p style="text-align: justify;">A adaptação à nova condição de vida para as pessoas que passam a ter limitações de locomoção, de interação em competição de igualdade ou simplesmente de serem autónomas são consideradas de extrema dificuldade para pessoas com deficiência, mobilidade reduzida e com doenças raras que as tornam mais ou menos debilitantes.</p>\n<p style="text-align: justify;">São exemplos de tecnologias assistivas (T.A.), toda intervenção tecnológica na promoção da inclusão seja no esporte, no lazer, na saúde, na educação e na vida diária. As ferramentas podem ser desde a brinquedos passando por roupas adaptadas a softwares e hardwares especiais para serem usados como instrumentos e suportes para acessibilidade. Nessas linhas podem ser incluídos todos dispositivos para adequação da postura, equipamentos alternativos de comunicação, órteses, aparelhos de escuta assistida, materiais protéticos, lápis adaptados, auxílios visuais e tantas outras inovações criadas para darem suporte para o sucesso do processo de inclusão.</p>\n<p style="text-align: justify;"><img loading="lazy" decoding="async" class="aligncenter wp-image-7638 size-large" src="https://cintespbr.org/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-02-at-10.13.36-1024x576.jpeg" alt="" width="1024" height="576" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-02-at-10.13.36-1024x576.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-02-at-10.13.36-300x169.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-02-at-10.13.36-768x432.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-02-at-10.13.36.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p style="text-align: justify;">A Lei Brasileira de Inclusão da Pessoa com Deficiência Lei 13.146/2015. (Estatuto da Pessoa com Deficiência), tem como o principal objetivo assegurar e promover, em condições de igualdade, o exercício dos direitos e das liberdades fundamentais por pessoa com deficiência, visando à sua inclusão social e cidadania. Desta forma, incentiva e cria recursos para a implantação de soluções de apoio e ferramentas para promoverem a inclusão da pessoa com deficiência, com mobilidade reduzida e com doença rara à participação plena e efetiva na sociedade em igualdade de condições com as demais pessoas.</p>\n<p style="text-align: justify;">A tecnologia assistiva tem ganhado força no Brasil, mais recursos liberados, mais centros de pesquisa especializados e maior atenção para a promoção de uma cultura cada vez mais inclusiva têm se tornado uma aliada, no caso da pessoa com deficiência, pode ser o fator determinante para promover a inclusão seja no esporte, no lazer, na saúde, na educação e na vida diária. Um dos centros de referência no Brasil está localizado em Uberlândia, o Centro Brasileiro de Referência em Inovações tecnológicas para Esportes Paralímpicos (CINTESP.Br).</p>\n<p style="text-align: justify;">Continuar a lidar com tarefas do cotidiano e com as demandas da vida diária se tornam atividades difíceis e complexas. “Perdi dois anos da minha vida com depressão e com vergonha de mim mesmo por estar em uma cadeira de rodas e sem saber como recomeçar, o esporte com o basquete e a esgrima em cadeira de rodas me devolveram a vida”, relata o segundo melhor jogador de esgrima do mundo, o brasileiro Jovane Guissone. Basquete, esgrima e todas as atividades em cadeira de rodas são exemplos de tecnologia assistiva.</p>\n<p style="text-align: justify;">Vinculado à Universidade Federal de Uberlândia (UFU) o CINTESP.Br atua em rede colaborativa com mais de 60 pesquisadores de diferentes Universidades é financiado pelo Ministério da Ciência, Tecnologia e Inovação (MCTI) e pelo Ministério Público do Trabalho (MPT/Uberlândia-MG), atuando em formato de redes colaborativas  em parceria com a Prefeitura Municipal de Uberlândia por meio da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel), o Comitê Paralímpico Brasileiro (CPB), o Praia Clube de Uberlândia, Grupo Algar e o Instituto Brain/Algar.</p>\n<p style="text-align: justify;"><img loading="lazy" decoding="async" class="wp-image-7605 alignleft" src="https://cintespbr.org/wp-content/uploads/2022/02/destacada-Esgrima-300x181.png" alt="" width="391" height="236" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/02/destacada-Esgrima-300x181.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/02/destacada-Esgrima-1024x618.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/02/destacada-Esgrima-768x463.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/02/destacada-Esgrima.png 1482w" sizes="(max-width: 391px) 100vw, 391px" />Jovane Guissone é um dos paratletas que participam das pesquisas do CINTESP.Br na linha de equipamentos para alto rendimento dos paratletas brasileiros. Ressaltando a importância do uso das tecnologias assistivas para gerar ferramentas, equipamentos e metodologias para oportunizar a autonomia e a participação das pessoas com deficiência, mobilidade reduzida e doenças raras na sociedade e garantir qualidade de vida na inclusão social e produtiva.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula-Ascom CINTESP.Br A adaptação à nova condição de vida para as pessoas que passam a ter limitações de locomoção, de interação em competição de igualdade ou simplesmente de serem autónomas são consideradas de extrema dificuldade para pessoas com deficiência, mobilidade reduzida e com doenças raras que as tornam mais ou menos debilitantes.&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6335,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-7637",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7637",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7637",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7637/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7639,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7637/revisions/7639",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6335",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7637",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7637",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7637",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7621,
        date: "2022-03-02T09:07:20",
        date_gmt: "2022-03-02T12:07:20",
        guid: {
            rendered: "https://cintespbr.org/?p=7621",
        },
        modified: "2022-03-26T00:18:58",
        modified_gmt: "2022-03-26T03:18:58",
        slug: "inovacao-tecnologica-para-o-esporte-lazer-educacao-e-qualidade-de-vida-em-acessibilidade-cada-vez-mais-forte-em-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/inovacao-tecnologica-para-o-esporte-lazer-educacao-e-qualidade-de-vida-em-acessibilidade-cada-vez-mais-forte-em-uberlandia/",
        title: {
            rendered:
                "Inovação tecnológica para o esporte, lazer, educação e qualidade de vida em acessibilidade cada vez mais forte em Uberlândia.",
        },
        content: {
            rendered:
                '<div style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" class="wp-image-7622 size-large" src="https://cintespbr.org/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24-1024x682.jpeg" alt="" width="1024" height="682" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24-1024x682.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24-300x200.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24-768x512.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /><p class="wp-caption-text">Imagem: PMU</p></div>\n<p>&nbsp;</p>\n<p><span style="font-size: 10pt;">Texto: Cristiane de Paula-Ascom CINTESP.Br</span></p>\n<p><span style="font-size: 10pt;">Revisão: Cleudmar Araújo-coor. CINTESP.Br</span></p>\n<p style="text-align: justify;">Um centro de referência nacional em inovação na área de tecnologia assistiva, para pessoas com deficiência, com mobilidade reduzida e doenças raras, vinculado à uma Universidade Federal apoiado por Ministérios do Governo Federal gerando rede colaborativa com pesquisadores, empresas e somando parcerias com instituições de serviços e empresas públicas, este é o ambiente cada vez mais forte que se apresenta em Uberlândia.</p>\n<p style="text-align: justify;">CINTESP.Br, vinculado à Universidade Federal de Uberlândia (UFU), financiado pelo Ministério da Ciência, Tecnologia e Inovação (MCTI) e pelo Ministério Público do Trabalho (MPT/Uberlândia-MG), atuando em formato de redes colaborativas  em parceria com a Prefeitura Municipal de Uberlândia por meio da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel), o Comitê Paralímpico Brasileiro (CPB), o Praia Clube de Uberlândia, Grupo Algar com o Instituto Brain/Algar e Sesi Gravatás (Fiemg).</p>\n<p style="text-align: justify;">Na sede do CINTESP.Br, os paratletas: Jovane Guissone segundo no ranking mundial 2021 de esgrima, Rafael Hoffmann eleito melhor do Campeonato Brasileiro de rúgbi em 2019 e José Júnior vice-campeão Sul Americano de basquete em cadeira de rodas participaram das pesquisas, já em fase final, para prescrição e fabricação de cadeiras de rodas personalizadas. No equipamento o paratleta passa por avaliações de modelos com mais de 20 ajustes que vão poder adequar à condição física e à necessidade de jogo de cada paratleta, o objetivo é oferecer condições de melhor rendimento nos treinos e nas competições preservando o conforto do atleta. “Eu acho que a cadeira vai ficar muito boa, estou sugerindo algumas medidas para diminuir as fraturas em determinados pontos da cadeira quando eu levo impacto muito forte do adversário, queremos uma cadeira com o maior a resistência daquela que eu uso em quadra”, disse Rafael Hoffmann do rúgbi.</p>\n<p style="text-align: justify;">O CINTESP.Br trabalha atualmente com mais de 40 inovações em tecnologia assistiva, termo usado para identificar dispositivos, técnicas e processos que podem prover assistência e reabilitação e melhorar a qualidade de vida de pessoas com deficiência, mobilidade reduzida e doenças raras. Atua com mais de 60 pesquisadores em ambiente multidisciplinar e em rede colaborativa com outras Faculdades e empresas brasileiras. Desde 2019, com financiamento do MCTI, o CINTESP.Br tem sido referência, na UFU, na produção de inovações e geração de patentes com quase 2 por mês.</p>\n<p style="text-align: justify;">Também esteve em Uberlândia, Tayana Medeiros, destaque nas Paralimpíadas de Tóquio, ela veio conhecer o potencial da cidade e programas voltados para o paradesporto de alto rendimento. Tayana conversou com pesquisadores do CINTESP.Br e com dirigentes do Praia Clube, maior Clube de Lazer da América Latina e entre os principais apoiadores brasileiros do paradesporto, do alto rendimento à iniciação”, nós entendemos que o apoio ao atleta não é apenas alguns meses que antecedem uma grande competição, é constante e com apoio integral”, destaca Carlos Augusto Braga, pres. do Praia Clube.</p>\n<p style="text-align: justify;">Com mais de 10 anos com projetos de apoio e incentivo ao paradesporto, o Praia Clube iniciou com a natação, hoje são 5 modalidades (natação, halterofilismo, tênis em cadeira de rodas, atletismo e bocha), quase 60 atletas de 17 a 55 anos de idade se destacando em competições Nacionais e Internacionais. Com o fortalecimento dos projetos já atua com uma rede de 10 empresas investidoras no paradesporto.</p>\n<p><strong>Tradição de Uberlândia no mundo paralímpico</strong></p>\n<div style="width: 994px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" class="wp-image-7623 size-full" src="https://cintespbr.org/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24-2.jpeg" alt="" width="984" height="655" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24-2.jpeg 984w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24-2-300x200.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24-2-768x511.jpeg 768w" sizes="(max-width: 984px) 100vw, 984px" /><p class="wp-caption-text">Imagem: Praia Clube de Uberlândia</p></div>\n<p>&nbsp;</p>\n<p style="text-align: justify;">Única cidade do interior do país a ter um Centro de Treinamento oficial do Comitê Paralímpico Brasileiro (CPB), as ações de apoio e incentivo ao paradesporto são desenvolvidas pela Fundação Uberlandense do Turismo, Esporte e Lazer (Futel). A ginástica artística foi a primeira modalidade, já com 20 atletas treinando. A Prefeitura, por meio a Futel, incentiva a iniciação em escolinhas que tem matriculadas cerca de 13 mil alunos. A rede é fortalecida com as parcerias feitas com as parcerias entre associações como a Associação dos Paraplégicos de Uberlândia (APARU), a Associação paralímpica Uberlandense de deficientes visuais (APAVU), <em>Clube</em> Desportivo para Deficientes de <em>Uberlândia</em> (<em>CDDU</em>), Associação dos Deficientes Visuais de Uberlândia (ADEVIUDI) e com o acordo de cooperação com o Praia Clube com o objetivo de fortalecer não só a iniciação como o preparo na formação de campeões e assistência no alto rendimento, “estamos oportunizando de forma gratuita o acesso à prática para jovens atletas, oferecendo suporte aos nossos atletas de alto rendimento”, disse o prefeito Odelmo Leão.</p>\n<p style="text-align: justify;">A resposta a estrutura de apoio ao esporte Paralímpico aparece na representação da delegação uberlandense que representa mais de 30% da delegação brasileira, no Mundial de halterofilismo realizado ano passado, na Geórgia, Uberlândia foi representada por 8 paratletas sendo a maior equipe da delegação brasileira, no Campeonato Brasileiro Masculino de bocha paralímpica de 2021, a cidade também se destacou com Uberlândia se destaca com 5 competidores, sendo a terceira maior equipe.</p>\n<p style="text-align: justify;">No mais recente Meeting 2021 da CAIXA a cidade de Uberlândia foi representada por quase 100 paratletas. As mais recentes conquistas e reconhecimento vieram do Japão, nos Jogos Paralímpicos de Tóquio, a melhor campanha brasileira da história, Uberlândia também esteve presente com paratletas da cidade,  “Isso demonstra a importância do investimento feito pela Prefeitura de Uberlândia, por meio da Futel, no paradesporto local, que hoje é referência nacional em diversas modalidades”, disse o diretor geral da Futel, Edson Zanatta.</p>\n<p style="text-align: justify;">Neste cenário a cidade fortalece a cultura de inclusão em acessibilidade e se consolida como referência na união de alta tecnologia com esporte e lazer para pessoas com deficiência, mobilidade reduzida e doenças raras. Em uma semana o CINTESP.Br e o Praia Clube receberam paratletas referências mundiais em esgrima, basquete, rúgbi e halterofilismo indicados pelo CPB. “Eu acho muito legal que um trabalho feito por todo mundo onde todos ganham, nessa parceria todo mundo cresce junto, alunos pesquisadores doutores o município a prefeitura e nós os paratletas”, conclui Jovani Guissoni atleta da esgrima.</p>\n<p style="text-align: justify;">Os paratletas da esgrima, do basquete e do rugbi vieram fazer parte dos projetos de desenvolvimento e fabricação de cadeiras de rodas para alto rendimento com possibilidades de somar ao grupo de paratletas de alta performance de Uberlândia e ainda no ano passado o CINTESP.Br concluiu a prescrição e entregou a primeira cadeira personalizada para o tênis de quadra ao atleta de Uberlândia, Gustavo Carneiro. “Isso que é inovador, além do projeto, a metodologia, isso não tem em lugar nenhum do mundo já está patenteado e pronto serem fabricadas e chegar à comunidade”, completa Cleudmar Araújo, coord. do CINTESP.Br/UFU.</p>\n<div id="attachment_7624" style="width: 474px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7624" class="wp-image-7624" src="https://cintespbr.org/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24-1-300x225.jpeg" alt="" width="464" height="348" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24-1-300x225.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24-1-1024x768.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24-1-768x576.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/03/WhatsApp-Image-2022-03-01-at-17.17.24-1.jpeg 1280w" sizes="(max-width: 464px) 100vw, 464px" /><p id="caption-attachment-7624" class="wp-caption-text">imagem: CINTESP.Br</p></div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; Texto: Cristiane de Paula-Ascom CINTESP.Br Revisão: Cleudmar Araújo-coor. CINTESP.Br Um centro de referência nacional em inovação na área de tecnologia assistiva, para pessoas com deficiência, com mobilidade reduzida e doenças raras, vinculado à uma Universidade Federal apoiado por Ministérios do Governo Federal gerando rede colaborativa com pesquisadores, empresas e somando parcerias com instituições de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7623,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-7621",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7621",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7621",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7621/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7627,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7621/revisions/7627",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7623",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7621",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7621",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7621",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7618,
        date: "2022-02-27T10:23:10",
        date_gmt: "2022-02-27T13:23:10",
        guid: {
            rendered: "https://cintespbr.org/?p=7618",
        },
        modified: "2022-05-18T15:29:27",
        modified_gmt: "2022-05-18T18:29:27",
        slug: "jovane-guissone-referencia-mundial-na-esgrima-em-cadeira-de-rodas-eu-tinha-vergonha-da-minha-condicao-na-cadeira-de-rodas-mas-o-esporte-mudou-tudo",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/jovane-guissone-referencia-mundial-na-esgrima-em-cadeira-de-rodas-eu-tinha-vergonha-da-minha-condicao-na-cadeira-de-rodas-mas-o-esporte-mudou-tudo/",
        title: {
            rendered:
                "Jovane Guissone, referência mundial na esgrima em cadeira de rodas: &#8220;eu tinha vergonha da minha condição na cadeira de rodas, mas o esporte mudou tudo&#8221;",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://youtu.be/sKkpKOGoZ14&#8243;][vc_column_text]Jovane Guissone, segundo no ranking mundial de esgrima em cadeira de rodas e a carreira de sucesso meteórica. Jovane esteve em Uberlândia e agora faz parte do projeto para fabricação de cadeira de rodas personalizada. Receberá a primeira cadeira de rodas brasileira sob medida para o jogo de esgrima[/vc_column_text][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://youtu.be/sKkpKOGoZ14&#8243;][vc_column_text]Jovane Guissone, segundo no ranking mundial de esgrima em cadeira de rodas e a carreira de sucesso meteórica. Jovane esteve em Uberlândia e agora faz parte do projeto para fabricação de cadeira de rodas personalizada. Receberá a primeira cadeira de rodas brasileira sob medida para o jogo de esgrima[/vc_column_text][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7620,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 34, 62],
        tags: [],
        class_list: [
            "post-7618",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-57",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7618",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7618",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7618/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7619,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7618/revisions/7619",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7620",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7618",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7618",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7618",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7611,
        date: "2022-02-27T09:52:46",
        date_gmt: "2022-02-27T12:52:46",
        guid: {
            rendered: "https://cintespbr.org/?p=7611",
        },
        modified: "2022-03-02T09:10:40",
        modified_gmt: "2022-03-02T12:10:40",
        slug: "pesquisadores-do-cintesp-br-ufu-realizam-prescricao-para-a-fabricacao-de-cadeiras-de-rodas-para-basquete-rugbi-e-esgrima",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/pesquisadores-do-cintesp-br-ufu-realizam-prescricao-para-a-fabricacao-de-cadeiras-de-rodas-para-basquete-rugbi-e-esgrima/",
        title: {
            rendered:
                "Pesquisadores do CINTESP.Br/UFU realizam prescrição para a fabricação de cadeiras de rodas para basquete, rúgbi e esgrima",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<div id="attachment_7612" style="width: 2570px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7612" class="wp-image-7612 size-full" src="https://cintespbr.org/wp-content/uploads/2022/02/ImagensPost-scaled.jpg" alt="" width="2560" height="571" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/02/ImagensPost-scaled.jpg 2560w, https://cintespbr.institucional.ws/wp-content/uploads/2022/02/ImagensPost-300x67.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/02/ImagensPost-1024x228.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/02/ImagensPost-768x171.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/02/ImagensPost-1536x343.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/02/ImagensPost-2048x457.jpg 2048w" sizes="(max-width: 2560px) 100vw, 2560px" /><p id="caption-attachment-7612" class="wp-caption-text">Sessões de prescrição para fabricação de cadeiras de rodas com José Jr (basquete), Rafael Horffman (rúgbi) e Jovane Guissone (esgrima)</p></div>\n<p style="font-size: 8pt;">Texto: Cristiane de Paula-Ascom CINTESP.Br<br />\nRevisão: Cleudmar Araújo-coord. CINTESP.Br</p>\n<p style="text-align: justify;">A série de prescrições foi a maior já feita pelo CINTESP.Br / UFU, em uma semana os pesquisadores fizeram a prescrição para a fabricação de cadeiras de rodas para 3 modalidades: rúgbi, esgrima e basquete. Os paratletas foram indicados pelo Comitê Paralímpico Brasileiro (CBP), todos já são referência mundial nas suas categorias, Jovane Guissone segundo no ranking mundial 2021 de esgrima, Rafael Hoffmann eleito melhor do Campeonato Brasileiro de rúgbi em 2019 e José Júnior vice-campeão Sul Americano de basquete em cadeira de rodas. No equipamento para prescrição de cadeira de rodas personalizada o paratleta passa por avaliações de modelos com mais de 20 ajustes que vão poder adequar à condição física e à necessidade de jogo de cada paratleta.</p>\n<p style="text-align: justify;">As prescrições foram feitas na sede do CINTESP.Br, instalada na Arena Sabiazinho, por meio de acordo de parceria com a Prefeitura de Uberlândia/ Fundação de Esporte e Lazer (FUTEL). A sede está equipada para ser a unidade de desenvolvimento com laboratórios de biomecânica, manufatura aditiva, modelagem computacional além do Laboratório de Projetos Mecânicos (LPM) instalado na Universidade Federal de Uberlândia. Os projetos do CINTESPBr têm financiamento do Ministério de Ciências Tecnologia e Inovações (MCTI), do Ministério Público do Trabalho de Uberlândia e em parceria com o Comitê Paralímpico Brasileiro (CPB), com o grupo Algar por meio do Instituto Brain e agora com o Praia Clube e Sesi Gravatás da Fiemg.</p>\n<p>[/vc_column_text][vc_video link=&#8221;https://youtu.be/CCiMH6mdJL4&#8243;][vc_column_text]</p>\n<p style="text-align: justify;">De acordo com o coordenador do CINTESP.Br, Cleudmar Araújo, a parceria com a Futel, utilizando as instalações esportivas do Sesi Gravatás, permitirá ampliar a assistência aos paratletas e otimizar as pesquisas. Nos ambientes de treino os pesquisadores vão poder acompanhar, de perto, o uso das inovações em tecnologia assistiva em condições reais de treinamento juntamente dos treinadores e preparadores físicos. “Não para por aí, a ideia é que fazendo a prescrição de todas essas modalidades já deixarmos tudo pré-ajustado, acrescenta o coordenador.</p>\n<p style="text-align: justify;">A segunda etapa da prescrição é feita pelo pesquisador que insere as medidas em uma tabela no computador, o programa faz os ajustes para montar o molde da cadeira de rodas personalizada. Com o projeto pronto, o pesquisador do CINTESP.Br pode enviar a prescrição direto para fábrica ganhando tempo e qualidade com um equipamento 100% personalizado. “Isso que é inovador, além do projeto, a metodologia, isso não tem em lugar nenhum do mundo,  é mais que uma condição de uma prescrição e o CINTESP.Br passa a acompanhar o atleta e  não só o de alto rendimento mas o de iniciação também”, completa Cleudmar Araújo.</p>\n<p style="text-align: justify;">A previsão é de fabricar as cadeiras de rodas em até 30 dias, o processo ainda continua com o atleta usando a cadeira de rodas personalizada em sua cidade, nos treinamentos e jogos testando as condições em campo e passando informações de ajustes aos pesquisadores de Uberlândia. “Eu sei que eles disseram que vão fazer uma Ferrari para mim então vamos ver cada ponto que eu fizer lá em Paris em 2024 eu vou gritar CINTESP” conclui Jovane.</p>\n<p style="text-align: justify;">O acompanhamento passa a ser contínuo com entrosamento entre pesquisador e atleta que passará novas informações de ajustes necessários para o rendimento ideal para o alto rendimento e de qualidade de vida. “Eu acho que a cadeira vai ficar muito boa, estou sugerindo algumas medidas para diminuir as fraturas em determinados pontos da cadeira quando eu levo impacto muito forte do adversário, queremos uma cadeira com o maior a resistência daquela que eu uso em quadra”, disse Rafael Hoffmann do rúgbi.</p>\n<p style="text-align: justify;">As pesquisas desenvolvidas no CINTESP.Br poderão oferecer além de melhores condições para novos recordes e novos índices de alta performance, ainda fomentar a economia oferecendo produtos prontos para atender a sociedade. “Na verdade, essas inovações em tecnologia assistiva já são produtos e se tiver alguma empresa com interesse de fabricar ele está pronto, foi patenteado e já passou por todos os processos legais para sair dos laboratórios e chegar à comunidade”, disse Cleudimar Araújo coordenador do CINTESP.Br</p>\n<p style="text-align: justify;">“Eu acho muito legal que um trabalho feito por todo mundo onde todos ganham, nessa parceria todo mundo cresce junto, alunos pesquisadores doutores o município a prefeitura e nós os paratletas”, conclui Jovani Guissoni atleta da esgrima.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Texto: Cristiane de Paula-Ascom CINTESP.Br Revisão: Cleudmar Araújo-coord. CINTESP.Br A série de prescrições foi a maior já feita pelo CINTESP.Br / UFU, em uma semana os pesquisadores fizeram a prescrição para a fabricação de cadeiras de rodas para 3 modalidades: rúgbi, esgrima e basquete. Os paratletas foram indicados pelo Comitê Paralímpico Brasileiro (CBP), todos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7614,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-7611",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7611",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7611",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7611/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7617,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7611/revisions/7617",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7614",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7611",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7611",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7611",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7570,
        date: "2022-02-18T16:58:55",
        date_gmt: "2022-02-18T19:58:55",
        guid: {
            rendered: "https://cintespbr.org/?p=7570",
        },
        modified: "2022-02-22T16:41:50",
        modified_gmt: "2022-02-22T19:41:50",
        slug: "cintesp-br-vinculado-a-ufu-recebe-o-vice-campeao-sul-americano-de-basquete-em-cadeira-de-rodas",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-vinculado-a-ufu-recebe-o-vice-campeao-sul-americano-de-basquete-em-cadeira-de-rodas/",
        title: {
            rendered:
                "CINTESP.Br, vinculado à UFU, recebe o vice-campeão Sul-americano de basquete em cadeira de rodas.",
        },
        content: {
            rendered:
                '<div id="attachment_7579" style="width: 744px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7579" class="wp-image-7579" src="https://cintespbr.org/wp-content/uploads/2022/02/imagens-300x107.jpg" alt="" width="734" height="262" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2022/02/imagens-300x107.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2022/02/imagens-1024x366.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2022/02/imagens-768x275.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2022/02/imagens-1536x549.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2022/02/imagens-2048x732.jpg 2048w" sizes="(max-width: 734px) 100vw, 734px" /><p id="caption-attachment-7579" class="wp-caption-text">Prescrição de cadeira de rodas com José Júnior, vice-campeão Sul-americano de basquete em cadeira de rodas, na sala de prescrição do CINTESP.Br</p></div>\n<p style="padding-left: 40px;"><span style="font-size: 10pt;"><em>Texto: Cristiane de Paula-Ascom CINTESP.Br</em></span></p>\n<p style="padding-left: 40px;"><span style="font-size: 10pt;"><em>Revisão: Cleudmar Amaral – coord. geral CINTESP.Br</em></span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Iniciar a fabricação da primeira cadeira personalizada para o basquete utilizando inovações em tecnologia assistiva para paratletas de alta performance, esta foi a razão da visita do atual vice-campeão Sul-americano de basquete em cadeira de rodas, José Júnior, no CINTESP.Br. José Júnior joga pelo time da ANDEF-Cobras (Associação Niteroiense dos Deficientes Físicos).</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A pesquisa é desenvolvida pelo CINTESP.Br, vinculado à Universidade Federal de Uberlândia (UFU), financiada pelo Ministério de Ciência, Tecnologia e Inovação (MCTI) e em parceria Prefeitura de Uberlândia por meio da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel) e Comitê Paralímpico Brasileiro (CPB).</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Com o direcionamento do pesquisador Lucas Cardoso, autor do projeto, o paratleta fez vários testes de conformidade, rendimento e segurança no equipamento que irá prescrever as medidas para fabricação da cadeira de rodas personalizada desenvolvida pelo Cintesp.Br, vinculado à Universidade Federal de Uberlândia (UFU). “Minha expectativa é muito grande com esse equipamento, essa novidade. Para eu chegar a um modelo bom para jogar eu vou ajustando minha cadeira na base das tentativas e erros e isso gasta dinheiro e tempo para jogar cada dia melhor. Já estou é ansioso pra experimentar, pra jogar com ela”, disse José Júnior, jogador de basquete em cadeira de rodas que fez parte do time da seleção brasileira vice-campeã Sul-americana de basquete em cadeira de rodas.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O equipamento oferece mais de 30 ajustes levando em conta as medidas anatômicas do paratleta, as necessidades de conforto de acordo com o tipo de deficiência e cada exigência específica de esforço para executar as manobras em uma partida de basquete atingindo o melhor rendimento. Os ajustes são feitos de acordo com as medidas que serão associadas para indicar um modelo personalizado da cadeira de rodas ideal para o basquete. O Equipamento de Prescrição de Cadeiras de Rodas (SWCE), desenvolvido pelo CINTESP.Br oferece condições ao atleta com deficiência, uma liberdade de escolha dentro do que melhor corresponde ao seu conforto e segurança, a partir de uma análise ergoantropométrica diretamente relacionada à sua cinesiologia de propulsão. “Foi muito rico esse nosso trabalho para fabricar a cadeira de rodas do José Júnior, ele trouxe informações importantes para a prescrição, detalhes técnicos que só o atleta pode nos oferecer”, completou Lucas Cardoso, pesquisador do CINTESP.Br, autor do projeto. A cadeira de rodas, já em fase final, fabricada de forma personalizada será utilizada em ambiente relevante, ou seja, em condições diretas de jogo pelo próprio atleta para orientação de novos ajustes, até chegar ao modelo ótimo para o alto rendimento.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A prescrição aconteceu na sede do CINTESP.Br, na Arena Sabiazinho, em parceria com a Prefeitura de Uberlândia por meio da (Futel), que trabalham em cooperação técnico científica juntamente com o Comitê Paralímpico Brasileiro com apoio do Ministério da Ciência, Tecnologia e Inovação (MCTI).  “Maravilhosa essa nossa parceria que possibilita um conjunto de esforços para melhorar o esporte paralímpico, reforça todo o apoio que a Prefeitura de Uberlândia já presta ao esporte paralímpico e somando às pesquisas do CINTESP.Br”, destaca o diretor da FUTEL Edson Zanatta que esteve na sede do CINTESP.Br para receber o paratleta.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Acompanharam os trabalhos dos pesquisadores do CINTESP.Br, parte do time de basquete em cadeira de rodas da cidade de Araguari, que já se apresentaram como novos candidatos para reforçar o time com as inovações do CINTESP.Br em tecnologia assistiva. “Nosso time há mais de 15 anos joga de forma independente, agora o Município inicia o poio ao basquete paralímpico e nossa meta é igualar aos times de alto rendimento e essa parceria do CINTESP.Br vai ser essencial”, disse Rômulo Monteiro, coordenador de esportes paralímpicos de Araguari que acompanhou os trabalhos.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O Equipamento de Prescrição de Cadeiras de Rodas (SWCE), desenvolvido pelo CINTESP.Br oferecerá condições ao atleta com deficiência liberdade de escolha dentro do que melhor corresponde ao seu conforto e segurança, a partir de uma análise ergoantropométrica diretamente relacionada à sua cinesiologia de propulsão. “O CINTESP.Br atua mais que um centro de inovação em tecnologia assistiva, atua como parceiro do atleta pois trabalha diretamente para ele com interação contínua no processo que pode oferecer em tempo real todas as medidas para o fabricante e apoiar durante o processo de fabricação”, completa Cleudmar Araújo, coordenador geral do CINTESP.Br.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Quem sabe agora com o CINTESP.Br, Uberlândia poderá atrair de volta os nossos jogadores de basquete em cadeira de rodas, temos um centro de referência e pesquisadores a nossa disposição, disse Clayton Barbosa, pres. do Conselho da Associação dos Paraplégicos de Uberlândia (APARU), que também acompanhou a visita do vice-campeão Sul-americano, de basquete em cadeira de rodas, José Jr.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A previsão dos pesquisadores do CINTESP.Br é de fabricar este modelo em 30 dias.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">As próximas prescrições serão feitas com os paratletas: Jovane Guissone da esgrima Categoria: B, medalha de prata na espada nos Jogos Paralímpicos de Tóquio 2020 e considerado no Prêmio CPB/Loterias Caixa como melhor atleta por modalidade.  E com o paratleta Rafael Hoffmann da equipe brasileira de rúgbi e atleta Paralímpico Rio 2016 Rugby em Cadeira de Rodas (Tetraplegia nível C5-C6). Rafael também participou da seleção brasileira de Rugby no Desafio Mundial de Rugbi em Cadeira de Rodas (WWRC 2019), na cidade de Tóquio, Japão o Brasil ficou em 8º lugar.</span></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula-Ascom CINTESP.Br Revisão: Cleudmar Amaral – coord. geral CINTESP.Br Iniciar a fabricação da primeira cadeira personalizada para o basquete utilizando inovações em tecnologia assistiva para paratletas de alta performance, esta foi a razão da visita do atual vice-campeão Sul-americano de basquete em cadeira de rodas, José Júnior, no CINTESP.Br. José Júnior joga&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7580,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-7570",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7570",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7570",
                },
            ],
            "version-history": [
                {
                    count: 18,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7570/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7599,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7570/revisions/7599",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7580",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7570",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7570",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7570",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7534,
        date: "2022-01-06T20:11:18",
        date_gmt: "2022-01-06T23:11:18",
        guid: {
            rendered: "https://cintespbr.org/?p=7534",
        },
        modified: "2022-01-06T20:34:18",
        modified_gmt: "2022-01-06T23:34:18",
        slug: "dispositivo-tipo-calha-para-uso-em-jogo-de-bocha-adaptada",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/dispositivo-tipo-calha-para-uso-em-jogo-de-bocha-adaptada/",
        title: {
            rendered:
                "DISPOSITIVO TIPO CALHA PARA USO EM JOGO DE BOCHA ADAPTADA",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h3-size style-dashed accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>DISPOSITIVO TIPO CALHA PARA USO EM JOGO DE BOCHA ADAPTADA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;2535&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][vc_single_image image=&#8221;2536&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;2533&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<h2><strong>DESCRIÇÃO:</strong></h2>\n<p style="text-align: justify;">A presente invenção se refere a um dispositivo tipo calha para ser utilizado em jogos de bocha na classe BC3. Esta calha utiliza uma curva de descida do tipo braquistócrona que minimiza o tempo de descida da bola e suaviza o movimento de descida. Trata-se de uma nova concepção de calha, leve e modular para ser prototipada  em impressora 3D.</p>\n<p>&nbsp;</p>\n<p><span style="font-size: 14pt;"><strong>REGISTRO:</strong> BR 10 2015 017987 1</span>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column]<div class="dt-fancy-separator h4-size style-dashed accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>Pesquisadores envolvidos<span class="separator-holder separator-right"></span></div></div>[vc_separator][vc_separator][dt_team_masonry order=&#8221;asc&#8221; orderby=&#8221;title&#8221; post_content_paddings=&#8221;5px 5px 5px 5px&#8221; img_max_width=&#8221;130px&#8221; image_paddings=&#8221;5px 5px 5px 5px&#8221; img_border_radius=&#8221;100px&#8221; bwb_columns=&#8221;desktop:4|h_tablet:4|v_tablet:2|phone:1&#8243; gap_between_posts=&#8221;10&#8243; post_title_font_size=&#8221;14px&#8221; post_title_line_height=&#8221;16px&#8221; custom_title_color=&#8221;#000000&#8243; post_title_bottom_margin=&#8221;0px&#8221; team_position_font_size=&#8221;11px&#8221; team_position_line_height=&#8221;14px&#8221; team_position_color=&#8221;#7a7a7a&#8221; show_team_desc=&#8221;n&#8221; read_more_button_text=&#8221;Conhecer&#8221; soc_icon_border_width=&#8221;0px&#8221; soc_icon_color=&#8221;#ffffff&#8221; loading_mode=&#8221;standard&#8221; st_posts_per_page=&#8221;8&#8243; posts_offset=&#8221;0&#8243; category=&#8221;66&#8243;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;2535&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][vc_single_image image=&#8221;2536&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;2533&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text] DESCRIÇÃO: A presente invenção se refere a um dispositivo tipo calha para ser utilizado em jogos de bocha na classe BC3. Esta calha utiliza uma curva de descida do tipo braquistócrona que minimiza o tempo de descida da bola e suaviza o movimento&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 2535,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [63],
        tags: [],
        class_list: [
            "post-7534",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-prototipo",
            "category-63",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7534",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7534",
                },
            ],
            "version-history": [
                {
                    count: 7,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7534/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7542,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7534/revisions/7542",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/2535",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7534",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7534",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7534",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7513,
        date: "2022-01-06T16:04:36",
        date_gmt: "2022-01-06T19:04:36",
        guid: {
            rendered: "https://cintespbr.org/?p=7513",
        },
        modified: "2022-01-06T16:31:10",
        modified_gmt: "2022-01-06T19:31:10",
        slug: "dispositivo-mecanico-para-geracao-programada-de-torque-resistente",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/dispositivo-mecanico-para-geracao-programada-de-torque-resistente/",
        title: {
            rendered:
                "DISPOSITIVO MECÂNICO PARA GERAÇÃO PROGRAMADA DE TORQUE RESISTENTE",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h3-size style-dashed accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>DISPOSITIVO MECÂNICO PARA GERAÇÃO PROGRAMADA DE TORQUE RESISTENTE<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;2625&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;2626&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<h2><strong>DESCRIÇÃO:</strong></h2>\n<p style="text-align: justify;">A presente invenção se refere a um dispositivo mecânico e seu método de projeto, formado por um conjunto composto por uma mola, um seguidor de rolete e um came com um perfil especial, que quando aplicado a uma máquina convencional para musculação é capaz de fornecer com precisão uma resistência dinâmica específica ao movimento de contração de um músculo esquelético, com o objetivo de aprimorar suas capacidades. O dispositivo, diferentemente dos sistemas convencionais, mantém o perfil de resistência requerido para o exercício em qualquer velocidade de execução, controlando os efeitos perturbadores das forças de inércia. Com este dispositivo é possível realizar treinamentos musculares em maiores velocidades, podendo ser utilizado em diferentes configurações de equipamentos de musculação.</p>\n<p>&nbsp;</p>\n<p><span style="font-size: 14pt;"><strong>REGISTRO:</strong> PI 1003925-2</span>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column]<div class="dt-fancy-separator h4-size style-dashed accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>Pesquisadores envolvidos<span class="separator-holder separator-right"></span></div></div>[vc_separator][vc_separator][dt_team_masonry order=&#8221;asc&#8221; orderby=&#8221;title&#8221; img_border_radius=&#8221;0px&#8221; post_title_bottom_margin=&#8221;0px&#8221; show_team_desc=&#8221;n&#8221; read_more_button=&#8221;default_button&#8221; read_more_button_text=&#8221;Conhecer&#8221; soc_icon_border_width=&#8221;0px&#8221; soc_icon_color=&#8221;#ffffff&#8221; loading_mode=&#8221;standard&#8221; st_posts_per_page=&#8221;8&#8243; posts_offset=&#8221;0&#8243; category=&#8221;65&#8243;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;2625&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;2626&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text] DESCRIÇÃO: A presente invenção se refere a um dispositivo mecânico e seu método de projeto, formado por um conjunto composto por uma mola, um seguidor de rolete e um came com um perfil especial, que quando aplicado a uma máquina convencional para musculação é capaz de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 2625,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [63],
        tags: [],
        class_list: [
            "post-7513",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-prototipo",
            "category-63",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7513",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7513",
                },
            ],
            "version-history": [
                {
                    count: 8,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7513/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7525,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7513/revisions/7525",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/2625",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7513",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7513",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7513",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7318,
        date: "2021-12-16T20:49:51",
        date_gmt: "2021-12-16T23:49:51",
        guid: {
            rendered: "https://cintespbr.org/?p=7318",
        },
        modified: "2022-04-11T22:44:30",
        modified_gmt: "2022-04-12T01:44:30",
        slug: "cintesp-br-ufu-fazem-doacao-de-calhas-para-iniciacao-esportiva-na-modalidade-bocha-paralimpica-classe-bc3",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-ufu-fazem-doacao-de-calhas-para-iniciacao-esportiva-na-modalidade-bocha-paralimpica-classe-bc3/",
        title: {
            rendered:
                "CINTESP.Br/UFU faz doação de calhas para iniciação esportiva na modalidade bocha paralímpica &#8211; classe BC3",
        },
        content: {
            rendered:
                '<div id="attachment_7319" style="width: 554px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7319" class="wp-image-7319" src="https://cintespbr.org/wp-content/uploads/2021/12/IMG-20211214-WA0014-300x200.jpg" alt="" width="544" height="362" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/12/IMG-20211214-WA0014-300x200.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/IMG-20211214-WA0014-1024x682.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/IMG-20211214-WA0014-768x512.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/IMG-20211214-WA0014.jpg 1280w" sizes="(max-width: 544px) 100vw, 544px" /><p id="caption-attachment-7319" class="wp-caption-text">Foto Secom-Valter de Paula</p></div>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula &#8211; Ascom CINTESP.Br</span></p>\n<p><span style="font-size: 8pt;">Revisão Cleudmar Araújo – coord. geral CINTESP.Br</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A Entrega foi realizada na sala de reuniões do gabinete do prefeito de Uberlândia, durante a solenidade de parceria, realizada nesta terça-feira (15), entre Fundação Uberlandense do Turismo, Esporte e Lazer (FUTEL), e a Federação das Indústrias do Estado de Minas Gerais (FIEMG). Na cerimônia foi celebrado o convênio de parceria com duração de dez anos para a utilização das estruturas esportivas do SESI Gravatás para treinamento paralímpico na cidade de Uberlândia, uma das melhores instalações do país e homologadas para receber competições internacionais.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">A doação de 6 calhas aconteceu com a presença do Pró-reitor de extensão e cultura da Universidade Federal de Uberlândia, prof. Dr. Hélder Silveira. Na cerimônia, o coordenador geral do CINTESP.Br, prof. Dr. Cleudmar destacou a parceria com a Prefeitura de Uberlândia por meio da FUTEL e a importância do CINTESP.Br.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O CINTESP.Br é um Centro de Referência Nacional em tecnologia assistiva, vinculado à Universidade Federal de Uberlândia e faz parte do Centro Nacional de Tecnologia para Pessoas com Deficiência e Doenças  Raras (CNT-MCTI) com financiamento do Ministério da Ciência, Tecnologia e Inovação (MCTI) e foi criado para fortalecer o esporte paralímpico de alto rendimento, bem como na iniciação esportiva e o relevante papel para melhorar a qualidade de vida de pessoas com deficiência, com mobilidade reduzida e doenças raras, atendendo a setores não só do esporte, como também da saúde, educação, lazer e vida diária.  “Não faz sentido desenvolvermos inovações tecnológicas que vão facilitar e melhorar a qualidade de vida das pessoas para ficarem dentro dos laboratórios, a entrega dessa calha e outras 3 é um grande passo nesse sentido”, disse o coordenador prof. Dr. Cleudmar Araújo.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">Na área do esporte paralímpico, o CINTESP.Br/UFU vem desenvolvendo diversas inovações tecnológicas. Os protótipos entregues são frutos de um projeto de quase 8 anos de estudo. A calha é voltada para a prática da bocha paralímpica-classe BC3. Nesta modalidade, o atleta arremessa a bola ao alvo com o auxílio de uma calha. Com um projeto inovador, envolvendo ciência, esta calha tem como diferenciais uma curva otimizada fabricada por impressão 3D, sistema modular “tipo Lego” que reduz drasticamente seu volume e peso, facilitando seu transporte. Também tem como diferencial a melhoria da eficiência do desvio da bola, com uma seção transversal otimizada e, finalmente, possui custo acessível comparativamente às calhas importadas para o alto rendimento.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">O CINTESP.Br/UFU em parceria com o PRAIA CLUBE ainda atua como ações de pesquisa e extensão na área do paradesporto. A doação de hoje veio para comemorar a assinatura deste importante acordo que tem o objetivo de fomentar o esporte, com o apoio da FUTEL, da FIEMG e do PRAIA CLUBE. O CINTESP.Br/UFU é um elo para o desenvolvimento de tecnologias que auxiliaram os paratletas e treinadores para melhoria da performance, e que passa a contar de forma efetiva da estrutura do SESI Gravatás para treinamento paraesportivo e validação de tecnologias.</span></p>\n<p style="text-align: justify;"><span style="font-size: 12pt;">De acordo com o Pró-reitor de extensão e cultura da UFU, a cerimônia com a entrega de um equipamento inovador em tecnologia assistiva, desenvolvido por pesquisadores universitários, representou um marco na promoção da pesquisa em favor da sociedade, neste caso, para beneficiar atletas de alto rendimento no esporte paralímpico e na iniciação paradesportiva. “O CINTESP.Br é a expressão do compromisso desta universidade com o bem estar comum, com a qualidade de vida das pessoas, com a pesquisa comprometida com o desenvolvimento social e com a ciência e tecnologia em prol da vida”, disse o Pró-reitor Hélder Silveira.</span></p>\n<div id="attachment_7320" style="width: 469px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7320" class="wp-image-7320" src="https://cintespbr.org/wp-content/uploads/2021/12/IMG-20211214-WA0018-300x225.jpg" alt="" width="459" height="344" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/12/IMG-20211214-WA0018-300x225.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/IMG-20211214-WA0018-1024x768.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/IMG-20211214-WA0018-768x576.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/IMG-20211214-WA0018.jpg 1280w" sizes="(max-width: 459px) 100vw, 459px" /><p id="caption-attachment-7320" class="wp-caption-text">Foto Secom-Valter de Paula</p></div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula &#8211; Ascom CINTESP.Br Revisão Cleudmar Araújo – coord. geral CINTESP.Br A Entrega foi realizada na sala de reuniões do gabinete do prefeito de Uberlândia, durante a solenidade de parceria, realizada nesta terça-feira (15), entre Fundação Uberlandense do Turismo, Esporte e Lazer (FUTEL), e a Federação das Indústrias do Estado de Minas&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7319,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-7318",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7318",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7318",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7318/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7408,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7318/revisions/7408",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7319",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7318",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7318",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7318",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7269,
        date: "2021-12-11T10:09:22",
        date_gmt: "2021-12-11T13:09:22",
        guid: {
            rendered: "https://cintespbr.org/?p=7269",
        },
        modified: "2021-12-28T18:55:47",
        modified_gmt: "2021-12-28T21:55:47",
        slug: "ufu-participa-da-semana-nacional-de-ciencia-e-tecnologia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ufu-participa-da-semana-nacional-de-ciencia-e-tecnologia/",
        title: {
            rendered:
                "UFU participa da Semana Nacional de Ciência e Tecnologia",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<h4>Evento, em Brasília, abordou o tema ‘A transversalidade da ciência, tecnologia e inovações para o planeta</h4>\n<p style="text-align: justify;">A Universidade Federal de Uberlândia (UFU) participou da 18ª Semana Nacional de Ciência e Tecnologia 2021 (SNCT), realizada de 3 a 10 de dezembro no Pavilhão de Exposições do Parque da Cidade, em Brasília.</p>\n<p style="text-align: justify;">O evento, coordenado pelo Ministério da Ciência, Tecnologia e Inovações (MCTI), teve como proposta mostrar como a ciência, a tecnologia e as inovações estão presentes nas mais diferentes áreas da sociedade.</p>\n<p>[/vc_column_text][vc_video link=&#8221;https://www.youtube.com/watch?v=ubvjTS7t9kU&amp;t=106s&#8221;][vc_column_text]</p>\n<p style="text-align: justify;">No estande da UFU, o diretor de Inovação e Transferência de Tecnologia da UFU, Thiago Paluma, apresentou os trabalhos da Agência Intelecto e do Centro de Incubação de Atividades Empreendedoras (Ciaem).</p>\n<p style="text-align: justify;">A Agência Intelecto é o núcleo de inovação tecnológica da Pró-Reitoria de Pesquisa e Pós-Graduação (PROPP/UFU) e o Ciaem é a incubadora de empresas de bases tecnológicas da UFU.</p>\n<p style="text-align: justify;">“A importância desse evento é poder debater um pouco o tema do empreendedorismo, da inovação, tanto a partir de uma visão da administração pública, quanto a interface da administração pública com outros entes externos à universidade”, destacou Paluma.</p>\n<p>[/vc_column_text][vc_video link=&#8221;https://www.youtube.com/watch?v=OkblFH8EATU&#8221;][vc_column_text]</p>\n<p style="text-align: justify;">O docente Robinson Sabino da Silva, do Instituto de Ciências Biomédicas (Icbim/UFU) mostrou o equipamento para diagnóstico de doenças por meio da saliva. “Nesse sistema, a gente utiliza um microlitro de saliva apenas”, destaca ele.</p>\n<p style="text-align: justify;">O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (Cintesp.Br), vinculado à UFU, apresentou quatro protótipos em fase de finalização. Três deles irão para o Comitê Paraolímpico Brasileiro (CPB): a calha paraolímpica para a bocha categoria BC3, o banco de arremesso e o elevador de piscina, utilizado para a transferência do paratleta da cadeira de rodas para a piscina.</p>\n<p>[/vc_column_text][vc_video link=&#8221;https://www.youtube.com/watch?v=PpJ8LFMbvLw&#8221;][vc_column_text]A 18ª Semana Nacional de Ciência e Tecnologia abordou o tema &#8220;A transversalidade da ciência, tecnologia e inovações para o planeta&#8221;.</p>\n<p>&nbsp;</p>\n<div class="field field-name-data-publicacao-autor field-type-ds field-label-inline clearfix">\n<div class="field-label">Por: Portal Comunica UFU</div>\n</div>\n<div class="field field-name-field-autoria field-type-text field-label-inline clearfix">\n<div class="field-items">\n<div class="field-item even">Cristiane de Paula (Cintesp.Br)</div>\n</div>\n</div>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Evento, em Brasília, abordou o tema ‘A transversalidade da ciência, tecnologia e inovações para o planeta A Universidade Federal de Uberlândia (UFU) participou da 18ª Semana Nacional de Ciência e Tecnologia 2021 (SNCT), realizada de 3 a 10 de dezembro no Pavilhão de Exposições do Parque da Cidade, em Brasília. O evento, coordenado pelo&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7273,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [61, 47, 62],
        tags: [],
        class_list: [
            "post-7269",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-18a-snct",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-61",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7269",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7269",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7269/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7274,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7269/revisions/7274",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7273",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7269",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7269",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7269",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7263,
        date: "2021-12-11T09:51:27",
        date_gmt: "2021-12-11T12:51:27",
        guid: {
            rendered: "https://cintespbr.org/?p=7263",
        },
        modified: "2021-12-28T18:56:47",
        modified_gmt: "2021-12-28T21:56:47",
        slug: "cintesp-br-vinculado-a-ufu-participa-da-18a-semana-nacional-da-ciencia-e-tecnologia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-vinculado-a-ufu-participa-da-18a-semana-nacional-da-ciencia-e-tecnologia/",
        title: {
            rendered:
                "Cintesp.Br, vinculado à UFU, participa da 18ª Semana Nacional da Ciência e Tecnologia",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<h3>Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos expõe equipamentos em Brasília</h3>\n<p style="text-align: justify;">O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (Cintesp.Br) está participando da 18ª Semana Nacional da Ciência e Tecnologia (SNCT), no Pavilhão de Exposições do Parque da Cidade, em Brasília. O evento, de iniciativa do Ministério da Ciência, Tecnologia e Inovações (MCTI), teve início na sexta (3/12) e termina no dia 10 de dezembro.</p>\n<p style="text-align: justify;">O Cintesp.Br, participa pela segunda vez de uma edição da exposição. Este ano, estão sendo apresentados quatro protótipos em fase de finalização. Três deles irão para o Comitê Paraolímpico Brasileiro (CPB): a calha paraolímpica para a bocha categoria BC3, o banco de arremesso e o elevador de piscina, utilizado para a transferência do paratleta da cadeira de rodas para a piscina.</p>\n<p>Confira imagens do stand do Cintesp na SNCT (imagens: Cristiane de Paula/Cintesp.Br)[/vc_column_text][vc_video link=&#8221;https://www.youtube.com/watch?v=Rz-yTKaHP1w&amp;t=3s&#8221;][vc_column_text]</p>\n<p style="text-align: justify;">O evento tem como proposta mostrar como a ciência, a tecnologia e as inovações estão presentes nas mais diferentes áreas da sociedade. O objetivo é mobilizar a população, em especial crianças e jovens, para a importância do assunto por meio de atividades lúdicas, oficinas, palestras e interação de especialistas com o público.</p>\n<p style="text-align: justify;">Com o tema &#8220;A transversalidade da ciência, tecnologia e inovações para o planeta&#8221;, a SNCT deste ano oferece, ainda, a oportunidade para o cidadão brasileiro conhecer e discutir os resultados, a relevância e os impactos da pesquisa científico-tecnológica, principalmente daquelas realizadas no país, e suas aplicações. A ideia é destacar a importância desses conteúdos na rotina de todos e no desenvolvimento do Brasil.</p>\n<div class="field field-name-data-publicacao-autor field-type-ds field-label-inline clearfix">\n<div class="field-label"><em>Por: Marco Cavalcanti</em></div>\n</div>\n<div class="field field-name-field-autoria field-type-text field-label-inline clearfix">\n<div class="field-label"><em>Por: Com informações da EBC e Cristiane de Paula (Cintesp.Br)</em></div>\n</div>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos expõe equipamentos em Brasília O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (Cintesp.Br) está participando da 18ª Semana Nacional da Ciência e Tecnologia (SNCT), no Pavilhão de Exposições do Parque da Cidade, em Brasília. O evento, de iniciativa do Ministério da&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7246,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [61, 47, 62],
        tags: [],
        class_list: [
            "post-7263",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-18a-snct",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-61",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7263",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7263",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7263/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7265,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7263/revisions/7265",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7246",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7263",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7263",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7263",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7258,
        date: "2021-12-11T09:35:08",
        date_gmt: "2021-12-11T12:35:08",
        guid: {
            rendered: "https://cintespbr.org/?p=7258",
        },
        modified: "2021-12-27T23:04:38",
        modified_gmt: "2021-12-28T02:04:38",
        slug: "cintesp-br-e-noticia-no-jornal-da-ufu-18a-semana-nacional-de-ciencia-e-tecnologia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-e-noticia-no-jornal-da-ufu-18a-semana-nacional-de-ciencia-e-tecnologia/",
        title: {
            rendered:
                "CINTESP.Br É NOTÍCIA NO JORNAL DA UFU  &#8211; 18ª SEMANA NACIONAL DE CIÊNCIA E TECNOLOGIA",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://youtu.be/vYkDYHlizJY&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://youtu.be/vYkDYHlizJY&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7262,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [61, 57, 62],
        tags: [],
        class_list: [
            "post-7258",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-18a-snct",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-61",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7258",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7258",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7258/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7260,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7258/revisions/7260",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7262",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7258",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7258",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7258",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7281,
        date: "2021-12-10T13:15:12",
        date_gmt: "2021-12-10T16:15:12",
        guid: {
            rendered: "https://cintespbr.org/?p=7281",
        },
        modified: "2021-12-27T23:04:38",
        modified_gmt: "2021-12-28T02:04:38",
        slug: "cintesp-br-na-18-semana-nacional-de-ciencia-e-tecnologia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-na-18-semana-nacional-de-ciencia-e-tecnologia/",
        title: {
            rendered:
                "CINTESP.Br na 18° Semana Nacional de Ciência e Tecnologia",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-7254 size-large" src="https://cintespbr.org/wp-content/uploads/2021/12/SNCT-35-1024x768.jpeg" alt="" width="1024" height="768" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/12/SNCT-35-1024x768.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/SNCT-35-300x225.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/SNCT-35-768x576.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/SNCT-35-1536x1152.jpeg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/SNCT-35.jpeg 1600w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p style="text-align: justify;">A <strong>18° Semana Nacional de Ciência e Tecnologia</strong> foi um evento repleto de conhecimento, e o CINTESP.Br teve seu reconhecimento frente as ações que desenvolve. Porém, nada seria possível sem o apoio de profissionais e parceiros que possibilitaram o andamento e a atenção devida a todos que nos visitaram nessa semana. De modo especial, agradecemos a equipe extraordinária de montagem e execução do nosso estande como pesquisadores e estagiários disponibilizados pela SEMPI (Secretaria de Empreendedorismo e Inovação). Além disso, ressaltamos o Ministro da Ciência, Tecnologia e Inovações, Marcos César Pontes (representado pelo Cel. Eduardo Temporim) como ministro amigo da Ciência e dos Pesquisadores.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>A 18° Semana Nacional de Ciência e Tecnologia foi um evento repleto de conhecimento, e o CINTESP.Br teve seu reconhecimento frente as ações que desenvolve. Porém, nada seria possível sem o apoio de profissionais e parceiros que possibilitaram o andamento e a atenção devida a todos que nos visitaram nessa semana. De modo especial, agradecemos a equipe&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7254,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-7281",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7281",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7281",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7281/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7282,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7281/revisions/7282",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7254",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7281",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7281",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7281",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7164,
        date: "2021-12-03T08:17:47",
        date_gmt: "2021-12-03T11:17:47",
        guid: {
            rendered: "https://cintespbr.org/?p=7164",
        },
        modified: "2021-12-27T23:04:38",
        modified_gmt: "2021-12-28T02:04:38",
        slug: "cintesp-br-se-prepara-para-participar-do-maior-evento-de-tecnologia-do-mcti-a-semana-nacional-de-ciencia-e-tecnologia-em-brasilia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-se-prepara-para-participar-do-maior-evento-de-tecnologia-do-mcti-a-semana-nacional-de-ciencia-e-tecnologia-em-brasilia/",
        title: {
            rendered:
                "CINTESP.Br se prepara para participar do maior evento de tecnologia do MCTI, a Semana Nacional de Ciência e Tecnologia em Brasília",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h3-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>CINTESP.Br se prepara para participar do maior evento de tecnologia do MCTI, a Semana Nacional de Ciência e Tecnologia em Brasília <span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_7165" style="width: 1341px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7165" class="wp-image-7165" src="https://cintespbr.org/wp-content/uploads/2021/12/bocha-1024x567.jpg" alt="" width="1331" height="737" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/12/bocha-1024x567.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/bocha-300x166.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/bocha-768x425.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/bocha-1536x850.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/bocha-2048x1134.jpg 2048w" sizes="(max-width: 1331px) 100vw, 1331px" /><p id="caption-attachment-7165" class="wp-caption-text">Partida bocha paralímpica categoria BC3, uso da calha</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]<img loading="lazy" decoding="async" class="aligncenter wp-image-7166 " src="https://cintespbr.org/wp-content/uploads/2021/12/Cerimonia-1024x737.jpeg" alt="" width="843" height="606" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/12/Cerimonia-1024x737.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/Cerimonia-300x216.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/Cerimonia-768x553.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/12/Cerimonia.jpeg 1080w" sizes="(max-width: 843px) 100vw, 843px" />[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]<span style="font-size: 8pt;">Texto: Cristiane de Paula ASCOM CINTESP.Br</span></p>\n<p style="text-align: justify;">A Transversalidade da Ciência, Tecnologia e Inovações para o Planeta, este será o tema da 18ª Semana Nacional de Ciência e Tecnologia que terá a abertura logo mais, às 14h, no Pavilhão de Exposições do Parque da Cidade em Brasília &#8211; DF. Até o dia 10/12,  a população poderá conhecer o que é desenvolvido em tecnologia e inovação produzidas no Brasil.</p>\n<p style="text-align: justify;">Na exposição de inovações deste ano, o CINTESP.Br, Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos, vinculado à Universidade Federal de Uberlândia (UFU), preparou 3 das mais de 10 inovações que fará entrega ao Comitê Paralímpico Brasileiro. “Desta vez optamos por fazer algo diferente na Semana Nacional, algo que aproxime a população ainda mais de nossas inovações em tecnologia assistiva, vamos levar equipamentos para o envolvimento da população, especialmente das crianças, estamos levando calhas lúdicas para elas jogarem a bocha paralímpica. É que nós queremos dar a oportunidade de vivência usando nossas invenções, assim poderemos atender também uma das linhas de ação do MCTI que é de popularizar a ciência por meio da educação e aproximar a sociedade dos centros de pesquisa e de extensão”, disse o coordenador do CINTESP.Br, Cleudmar Amaral.</p>\n<p style="text-align: justify;">A bocha paralímpica já conta com mais de 800 paratletas brasileiros praticantes, é considerado um jogo de estratégia e de raciocínio, onde o jogador tem o desafio de colocar a bola que arremessa o mais perto da bola principal, bola branca, usada como alvo para pontuação. A partida é desenvolvida em 4 sets e o jogador com direito a 6 bolas para cada set. O objetivo é somar pontos por aproximação da bola branca, o jogador pode, dentro da área delimitada, optar por afastar a bola do adversário ou bloquear, ganha quem somar mais pontos com maior número de bolas próximo da bola alvo.</p>\n<p style="text-align: justify;">A modalidade foi criada inicialmente para pessoas com paralisia cerebral com disfunção motora generalizada e inicialmente foram criadas as classes BC1, BC2 e BC4, divididos por grau de deficiência. As categorias atendem aos paratletas que, mesmo com a disfunção motora, conseguem lançar a bola com as mãos. Mais tarde foi criada a categoria BC3, voltada para os jogadores com maior grau de deficiência, que nem conseguem lançar a bola com as mãos. Para essa categoria surgiu a calha paralímpica, um equipamento que ajuda o atleta a lançar a bola por meio de uma vareta acoplada em um capacete e a bola entra no jogo por meio da calha que direciona a trajetória escolhida pelo jogador. “A bocha abriu uma possibilidade não só para quem tem paralisia cerebral como também para outras pessoas com distrofia muscular, osteogênese imperfeita, problema de má formação congênita, lesão medular, enfim, deu mais chances para estas pessoas poderem participar e terem uma atividade física de acordo com suas possibilidades” completou Márcia Campeão, professora de educação física e coordenadora técnica de bocha paralímpica do CPB.</p>\n<p style="text-align: justify;">Além da calha lúdica o CINTESP.Br estará apresentando em seu stand na SNCT, um elevador de piscina que também poderá ser experimentado e o banco de arremessos. Nos próximos 3 meses o CINTESP.Br espera fazer a entrega de pelo menos 10 equipamentos de inovação em tecnologia assistiva para alto rendimento que serão usados pelo Comitê Paralímpico Brasileiro.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text][/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Texto: Cristiane de Paula ASCOM CINTESP.Br A Transversalidade da Ciência, Tecnologia e Inovações para o Planeta, este será o tema da 18ª Semana Nacional de Ciência e Tecnologia que terá a abertura logo mais, às 14h, no Pavilhão de Exposições do Parque da Cidade em Brasília &#8211; DF. Até o dia 10/12,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7171,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [61, 57, 62],
        tags: [],
        class_list: [
            "post-7164",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-18a-snct",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-61",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7164",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7164",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7164/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7170,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7164/revisions/7170",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7171",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7164",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7164",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7164",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4442,
        date: "2021-11-15T21:24:13",
        date_gmt: "2021-11-16T00:24:13",
        guid: {
            rendered: "https://cintespbr.org/?p=4442",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "tecnologia-assistiva-recordes-paralimpicos-e-a-influencia-da-alta-performance-dos-paratletas-para-a-vida-diaria-da-sociedade",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/tecnologia-assistiva-recordes-paralimpicos-e-a-influencia-da-alta-performance-dos-paratletas-para-a-vida-diaria-da-sociedade/",
        title: {
            rendered:
                "Tecnologia assistiva, recordes paralímpicos e a influência da alta performance dos paratletas para a vida diária da sociedade",
        },
        content: {
            rendered:
                '<p style="text-align: left;"><em><span style="font-size: 8pt;"><img loading="lazy" decoding="async" class=" wp-image-6627 aligncenter" src="https://cintespbr.org/wp-content/uploads/2021/08/dst-300x204.png" alt="" width="472" height="321" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/08/dst-300x204.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/dst-1024x695.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/dst-768x521.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/dst-1536x1042.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/dst.png 1777w" sizes="(max-width: 472px) 100vw, 472px" /></span></em></p>\n<p style="text-align: left;"><em><span style="font-size: 8pt;">Texto: Cristiane de Paula Ascom CINTESP.Br</span></em></p>\n<p style="text-align: justify;">A pessoa com deficiência no Brasil nos últimos anos tem recebido cada vez mais atenção e isso está dentro do contexto da visibilidade da pessoa com deficiência.  De acordo com o secretário nacional de paradesporto do Ministério da Cidadania, Angtonio Guedes, as ações realizadas pelas Universidades e Centros de Pesquisa acontecem cada vez mais em rede compartilhando conhecimento e fazendo as inovações se complementarem, ainda de acordo com o secretário, esse comportamento reforça cada vez mais que a pessoa com deficiência não está desconectada de uma cidade para a outra e que a sociedade não é desconectada.</p>\n<p style="text-align: justify;">Em Uberlândia o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos  (CINTESP.Br), vinculado à Universidade Federal de Uberlândia (UFU), trabalha em parceria com o Comitê Paralímpico Brasileiro (CPB) e a Fundação Uberlandense de Turismo Esporte e Lazer (FUTEL) em busca de desenvolver novas tecnologia assistiva para melhorar a performance do paratleta de alto rendimento. E as pesquisas acontecem de forma multidisciplinar e em rede colaborativa com o setor acadêmico, entidades de pesquisa, sociedade, instituições públicas e privadas com o principal objetivo de fortalecer, otimizar e reduzir o custo das pesquisas e o tempo de transferência para o atleta paralímpico como também para toda a sociedade, pessoas com deficiência e com mobilidade reduzida e financeiramente acessível.</p>\n<p style="text-align: justify;">No mundo do paradesporto o resultado dessa integração crescente aparece na aceleração do registro de novas tecnologias assistivas, melhora dos índices dos parateltas de alto rendimento e novos recordes que chegam a colocar o atleta paralímpico bem perto dos índices olímpicos.</p>\n<p style="text-align: justify;">Realidade comprovada nas Paralimpíadas de Tóquio com quebras de recordes em proporções maiores das que foram registradas nas Olimpíadas. Um dos exemplos foi a performance dos paratletas na corrida dos 100 metros onde a evolução da classe de amputados, que depende de próteses, chegou a uma redução de 16 segundos no tempo de prova, superando a evolução de desempenho na mesma prova do atleta olímpico que foi de 13 segundos. “Essa equiparação pode ser levada para melhor qualidade de vida, para a verdadeira inclusão social e produtiva de uma pessoa com deficiência”, disse o coordenador de ciências do esporte  do Comitê Paralímpico Brasileiro,  Thiago Lourenço durante a live realizada o mês passado, no 1º Encontro NUTECA – Núcleo de Tecnologia Assistiva, da Universidade São Judas de São Paulo.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula Ascom CINTESP.Br A pessoa com deficiência no Brasil nos últimos anos tem recebido cada vez mais atenção e isso está dentro do contexto da visibilidade da pessoa com deficiência.  De acordo com o secretário nacional de paradesporto do Ministério da Cidadania, Angtonio Guedes, as ações realizadas pelas Universidades e Centros de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6627,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 34, 62],
        tags: [],
        class_list: [
            "post-4442",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-57",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4442",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4442",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4442/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7129,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4442/revisions/7129",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6627",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4442",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4442",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4442",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7101,
        date: "2021-11-08T16:12:10",
        date_gmt: "2021-11-08T19:12:10",
        guid: {
            rendered: "https://cintespbr.org/?p=7101",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "cpb-abre-inscricoes-para-voluntariado-nas-paralimpiadas-escolares-2021-ate-o-dia-10-de-novembro",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cpb-abre-inscricoes-para-voluntariado-nas-paralimpiadas-escolares-2021-ate-o-dia-10-de-novembro/",
        title: {
            rendered:
                "CPB abre inscrições para voluntariado nas Paralimpíadas Escolares 2021 até o dia 10 de novembro",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-7102 size-full" src="https://cintespbr.org/wp-content/uploads/2021/11/ad401e525f36489bb4eeee3e02e5a6d6.png" alt="" width="1011" height="571" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/11/ad401e525f36489bb4eeee3e02e5a6d6.png 1011w, https://cintespbr.institucional.ws/wp-content/uploads/2021/11/ad401e525f36489bb4eeee3e02e5a6d6-300x169.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/11/ad401e525f36489bb4eeee3e02e5a6d6-768x434.png 768w" sizes="(max-width: 1011px) 100vw, 1011px" /></p>\n<p style="text-align: justify;">    O Comitê Paralímpico Brasileiro (CPB), por meio da Diretoria de Desenvolvimento Esportivo do CPB, abriu nesta quarta-feira, 3, as inscrições para o voluntariado das Paralimpíadas Escolares 2021. A competição acontecerá no Centro de Treinamento Paralímpico, em São Paulo, de 22 a 27 de novembro. Ao todo, 34 vagas estão disponíveis.</p>\n<p style="text-align: justify;">Para se inscrever, é preciso ter idade mínima de 18 anos e ter disponibilidade do dia 22, a partir das 8h, ao dia 26 de novembro, até às 18h. Não é obrigatório ter graduação, mas é um diferencial ser graduado nas áreas de Saúde e/ou Educação Física.<br />\nA inscrição é via formulário,<a href="https://forms.gle/FXzAsM4xwpZXZvbS8" target="_blank" rel="noopener"> através deste link, </a>até o dia 10 de novembro. A diretoria de Desenvolvimento Esportivo do CPB realizará a triagem e a seleção dos inscritos.</p>\n<p style="text-align: justify;">O CPB arcará com hospedagem, exclusivamente para atuantes em modalidades esportivas, alimentação e camisas do evento. No ato da inscrição, o candidato deverá sinalizar a necessidade de hospedagem.<br />\nA lista final dos voluntários para a edição deste ano das Paralimpíadas Escolares será divulgada no dia 12 de novembro. Os candidatos aprovados receberão o contrato de voluntário para assinatura e confirmação da vaga.</p>\n<p><strong>FONTE: Assessoria de Comunicação do Comitê Paralímpico Brasileiro </strong></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>    O Comitê Paralímpico Brasileiro (CPB), por meio da Diretoria de Desenvolvimento Esportivo do CPB, abriu nesta quarta-feira, 3, as inscrições para o voluntariado das Paralimpíadas Escolares 2021. A competição acontecerá no Centro de Treinamento Paralímpico, em São Paulo, de 22 a 27 de novembro. Ao todo, 34 vagas estão disponíveis. Para se inscrever,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7102,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-7101",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7101",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7101",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7101/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7105,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7101/revisions/7105",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7102",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7101",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7101",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7101",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7065,
        date: "2021-10-31T12:46:42",
        date_gmt: "2021-10-31T15:46:42",
        guid: {
            rendered: "https://cintespbr.org/?p=7065",
        },
        modified: "2021-12-27T23:04:38",
        modified_gmt: "2021-12-28T02:04:38",
        slug: "prototipo-de-banco-de-arremesso-desenvolvido-pelo-cintesp-br-surpreende-comissao-tecnica-do-cpb-durante-o-meeting-paralimpico-em-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/prototipo-de-banco-de-arremesso-desenvolvido-pelo-cintesp-br-surpreende-comissao-tecnica-do-cpb-durante-o-meeting-paralimpico-em-uberlandia/",
        title: {
            rendered:
                "Protótipo de banco de arremesso desenvolvido pelo CINTESP.Br surpreende comissão técnica do CPB durante o Meeting Paralímpico em Uberlândia",
        },
        content: {
            rendered:
                '<div style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" class="wp-image-7066 size-large" src="https://cintespbr.org/wp-content/uploads/2021/10/foto-destaque-1024x696.jpg" alt="" width="1024" height="696" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/10/foto-destaque-1024x696.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/foto-destaque-300x204.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/foto-destaque-768x522.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/foto-destaque-1536x1044.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/foto-destaque.jpg 1862w" sizes="(max-width: 1024px) 100vw, 1024px" /><p class="wp-caption-text">Apresentação do banco de arremessos à árbitros e comissão técnica do CPB</p></div>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula &#8211; Ascom CINTESP.Br</span></p>\n<p style="text-align: justify;">A apresentação do banco de arremesso, um dos projetos que estão sendo desenvolvidos pelo CINTESP.Br, aconteceu durante o Meeting Paralímpico Loterias Caixa que foi realizado, neste final de semana, em Uberlândia. Tão logo acabaram as competições do período da manhã os pesquisadores levaram o protótipo para a pista de arremesso do SESI Gravatás e convidaram os árbitros e comissão técnica do Comitê Paralímpico Brasileiro para conhecerem a inovação tecnológica que, de acordo um os árbitros vai impactar e mudar a cultura do paratletismo mundial.</p>\n<p style="text-align: justify;">O banco multi-regulável que está na fase final de testes,  está sendo projetado para a modalidade paralímpica do arremesso de peso, dardo, disco e club. O banco apresenta como inovação diversas regulagens que permitirão configurar as posições do assento para atender à necessidade de cada paratleta, de acordo com a deficiência, possibilitando melhorar a performance. “Em um dos testes com os paratletas fizemos uma inclinação no assento de apenas 3 graus e eles perceberam a diferença e adoraram”, disse Leandro Garcia, pesquisador do CINTESP.Br e treinador de paratletlismo equipe APARU/Futel. “Com todas essas possibilidades de ajustes poderemos ter um grande impacto no aproveitamento dos arremessos com a conquista de novos índices”, completa Marcelo Novello, árbitro internacional há 30 anos.</p>\n<p style="text-align: justify;">Outro aspecto inovador do banco de arremesso será o uso universal, por permitir configurações de ajustes diferentes, o modelo desenvolvido pelos pesquisadores do CINTESP.Br, tem como meta atender todos so paratletas. Atualmente cada paratleta precisa levar seu próprio equipamento para treinar e para competir exigindo a troca de banco em cada prova. “E o impacto vai ser em favor da divulgação do paraesporte já que favorecerá na transmissão das provas que terão menor tempo de intervalo entre uma apresentação e outra, oferecendo maior tempo de exibição, é bom pra mídia, pro patrocinador, pro público que terá uma competição mais motivante, mais dinâmica, vai ser bom pra todo mundo”, comentou Marcelo, árbitro do CPB.</p>\n<p style="text-align: justify;">A apresentação foi em caráter extraoficial, serviu para a comissão técnica e árbitros do CPB, que participaram do Meeting de Uberlândia avaliarem o protótipo e contribuírem com os pesquisadores oferecendo mais informações para essa fase final de fabricação. &#8220;É tudo que o Comitê Internacional de Paratletismo já vem pedindo, sugerindo e poderemos aqui sermos os primeiros em apresentar uma solução para uso mundial”, disse Júlio Trigo da comissão de eventos do CPB.</p>\n<p style="text-align: justify;">O projeto do banco de arremesso já está em fase final de ajustes para fabricação, “nós estamos planejando apresentar o banco ao Comitê Paralímpico ainda este ano no Meeting da Caixa que acontecerá em São Paulo, disse Silvio Santos, pesquisador do CINTESP.Br.</p>\n<p style="text-align: justify;"><strong>Mais superação e novas marcas no Meeting Paralímpico Loterias Caixa</strong></p>\n<p style="text-align: justify;">O Meeting em Uberlândia teve a participação de 126 paratletas sendo 102 da cidade e a confirmação de nomes já revelados no para halterofilismo. O destaque foi Valéria Alves, do Clube Desportivo para Deficientes de Uberlândia (CDDU)/ Praia/ Futel. Na categoria até 86 kg, ela conquistou o ouro levantando com 82 kg na barra. Valéria tem 20 anos de idade, esta é a segunda competição oficial que participa e já superou a marca  de 78kg que a classificou para o Mundial que acontece na Geórgia. “Estou muito feliz, um sonho, sonhei muito e consegui. Antes mesmo da minha primeira competição eu consegui uma vaga para o Mundial”, disse Valéria em entrevista ao CPB.</p>\n<p style="text-align: justify;">No paratletismo o destaque foi Rodrigo Parreira (classe T36) no salto em distância. Ele saltou 5m80, superando os 5m76, recorde paralímpico, registrado em Tóquio. Rodrigo compete pela Associação dos Paraplégicos de Uberlândia (APARU).</p>\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Texto: Cristiane de Paula &#8211; Ascom CINTESP.Br A apresentação do banco de arremesso, um dos projetos que estão sendo desenvolvidos pelo CINTESP.Br, aconteceu durante o Meeting Paralímpico Loterias Caixa que foi realizado, neste final de semana, em Uberlândia. Tão logo acabaram as competições do período da manhã os pesquisadores levaram o protótipo para a pista&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7066,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 62],
        tags: [],
        class_list: [
            "post-7065",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7065",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7065",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7065/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7077,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7065/revisions/7077",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7066",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7065",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7065",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7065",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7041,
        date: "2021-10-28T20:36:34",
        date_gmt: "2021-10-28T23:36:34",
        guid: {
            rendered: "https://cintespbr.org/?p=7041",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "berlandia-se-destaca-para-o-mundial-de-para-halterofilismo-que-acontecera-na-georgia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/berlandia-se-destaca-para-o-mundial-de-para-halterofilismo-que-acontecera-na-georgia/",
        title: {
            rendered:
                "Uberlândia se destaca para o Mundial de Para Halterofilismo que acontecerá na Geórgia",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h3-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>Uberlândia se destaca para o Mundial de Para Halterofilismo que acontecerá na Geórgia<span class="separator-holder separator-right"></span></div></div>[vc_row_inner][vc_column_inner width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_7042" style="width: 2456px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7042" class="wp-image-7042 size-full" src="https://cintespbr.org/wp-content/uploads/2021/10/halt.jpg" alt="" width="2446" height="1881" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/10/halt.jpg 2446w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/halt-300x231.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/halt-1024x787.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/halt-768x591.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/halt-1536x1181.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/halt-2048x1575.jpg 2048w" sizes="(max-width: 2446px) 100vw, 2446px" /><p id="caption-attachment-7042" class="wp-caption-text">Lara Lima e o treinador Weverton Santos Foto: FUTEL</p></div>\n<p>[/vc_column_text][/vc_column_inner][vc_column_inner width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_7043" style="width: 1968px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7043" class="wp-image-7043 size-full" src="https://cintespbr.org/wp-content/uploads/2021/10/halt2.jpg" alt="" width="1958" height="1624" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/10/halt2.jpg 1958w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/halt2-300x249.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/halt2-1024x849.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/halt2-768x637.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/halt2-1536x1274.jpg 1536w" sizes="(max-width: 1958px) 100vw, 1958px" /><p id="caption-attachment-7043" class="wp-caption-text">Modelo e protótipo do equipamento para treinamento muscular (bíceps) com vibração</p></div>\n<p>[/vc_column_text][/vc_column_inner][/vc_row_inner][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]<strong><span style="font-size: 8pt;">Texto: Cristiane de Paula – Ascom CINTESP.Br</span></strong></p>\n<p style="text-align: justify;">   Uberlândia ganhou destaque na convocação de paratletas do halterofilismo para representar o Brasil no Mundial, marcado para acontecer entre 27 de novembro e 5 de dezembro, em Tbilisi, na Geórgia. De Uberlândia, participarão 8 paratletas sendo a maior equipe da delegação brasileira.</p>\n<p style="text-align: justify;">A convocação foi anunciada pelo novo diretor de esportes de alto rendimento do Comitê Paralímpico Brasileiro, Jonas Freire. Os paratletas uberlandenses são Mateus de Assis, Gabriel Serafim, André Luiz, Luciano Dantas, Ângela Teixeira, Elizete Araújo, Valéria Alves e a Lara Lima que participou das paralimpíadas de Tóquio. Weverton Santos é o treinador da equipe. Todos os paratletas fazem parte do “Clube Desportivo para Deficientes de Uberlândia” que tem parcerias com a Futel e recentemente também firmou apoio com o Praia Clube. A Equipe uberlandense representa mais de 30% da delegação brasileira. “Isso demonstra a importância do investimento feito pela Prefeitura de Uberlândia, por meio da Futel, no paradesporto local, que hoje é referência nacional em diversas modalidades”, disse o diretor geral da Futel, Edson Zanatta.</p>\n<p style="text-align: justify;">O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br) já é referência em pesquisas e desenvolvimento de equipamentos para o alto rendimento no paradesporto, com mais de 60 projetos em desenvolvimento, para atender os paratletas nacionais. Entre os projetos estão o equipamento de treinamento muscular dos membros superiores com vibração mecânica bilateral e o equipamento de musculação para cadeirantes com sistema de resistência came-mola-seguidor, que podem contribuir com melhorias no condicionamento muscular e na reabilitação física dos paratletas do halterofilismo, entre outras diversas modalidades. De acordo com o escopo dos projetos, de autoria de Thiago Gomes Cardoso e de Márcio Peres de Souza (pesquisadores do CINTESP.Br), os equipamentos, de caráter inovador, possibilitam – entre outras funções – a utilização para treinamentos paralímpicos, proporcionando uma atividade biomecânica associada ao gesto motor de propulsão de uma cadeira de rodas. Além disso, as características modulares e multirreguláveis destes equipamentos permite o treinamento diferenciado e personalizado para as necessidades fisiológicas de cada paratleta.</p>\n<p style="text-align: justify;">Para o especialista em hemodinâmica e pesquisador do CINTESP.Br, Fernando de Fazzio o novo equipamento poderá ainda garantir maior segurança nos treinamentos. “Considerando a inovação do sistema de vibração que será associado e que poderemos realizar o treinamento especifico dentro de um laboratório, há uma grande expectativa de obtermos ganhos significativos nos desempenhos, principalmente, dos atletas que aqui estamos acompanhando, o atleta de alto rendimento, o atleta paraolímpico”, completa o pesquisador. Fernando de Fazzio é formado em medicina pela UFU e especializado em Hemodinâmica e Cardiologia intervencionista no Instituto do Coração da Faculdade de Medicina da Universidade de São Paulo.</p>\n<p style="text-align: justify;">Um dos aspectos do CINTESP.Br é a formação multidisciplinar, são aproximadamente 50 pesquisadores, envolvendo profissionais técnicos, estudantes de graduação e de pós-graduação e docentes da UFU e de outras Universidades. As pesquisas envolvem desde a prescrição de equipamentos, de dispositivos e de próteses; ao desenvolvimento de aparelhos biomecânicos de treinamento, passando pela habilitação e reabilitação física; a criação de recursos didático-pedagógicos para o ensino de línguas e da matemática; o projeto de arranjos físicos e modelos arquitetônicos inteligentes baseados em acessibilidade e ergonomia; a criação de novos materiais aplicáveis à engenharia biomecânica; o estudo da qualidade de vida para pessoas com doenças raras; o desenvolvimento das técnicas de manufatura aditiva aplicada e outras mais.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_row_inner][vc_column_inner width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column_inner][vc_column_inner width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column_inner][/vc_row_inner][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Texto: Cristiane de Paula – Ascom CINTESP.Br    Uberlândia ganhou destaque na convocação de paratletas do halterofilismo para representar o Brasil no Mundial, marcado para acontecer entre 27 de novembro e 5 de dezembro, em Tbilisi, na Geórgia. De Uberlândia, participarão 8 paratletas sendo a maior equipe da delegação brasileira. A&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7042,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 34, 62],
        tags: [],
        class_list: [
            "post-7041",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-57",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7041",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7041",
                },
            ],
            "version-history": [
                {
                    count: 10,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7041/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7076,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7041/revisions/7076",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7042",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7041",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7041",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7041",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7014,
        date: "2021-10-23T00:34:55",
        date_gmt: "2021-10-23T03:34:55",
        guid: {
            rendered: "https://cintespbr.org/?p=7014",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "paratletas-de-uberlandia-vivem-um-dos-melhores-momentos-e-aproveitam-para-ampliar-a-pontuacao-no-ranking-nacional",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/paratletas-de-uberlandia-vivem-um-dos-melhores-momentos-e-aproveitam-para-ampliar-a-pontuacao-no-ranking-nacional/",
        title: {
            rendered:
                "Paratletas de Uberlândia vivem um dos melhores momentos e aproveitam para ampliar a pontuação no ranking nacional",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h4-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>Paratletas de Uberlândia vivem um dos melhores momentos e aproveitam para ampliar a pontuação no ranking nacional<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_7015" style="width: 1782px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7015" class="wp-image-7015 size-full" src="https://cintespbr.org/wp-content/uploads/2021/10/img1.jpg" alt="" width="1772" height="1218" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/10/img1.jpg 1772w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/img1-300x206.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/img1-1024x704.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/img1-768x528.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/img1-1536x1056.jpg 1536w" sizes="(max-width: 1772px) 100vw, 1772px" /><p id="caption-attachment-7015" class="wp-caption-text">Wellington Fernandes lançamento de dardo</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_7016" style="width: 1626px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7016" class="wp-image-7016 size-full" src="https://cintespbr.org/wp-content/uploads/2021/10/img2.jpg" alt="" width="1616" height="1108" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/10/img2.jpg 1616w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/img2-300x206.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/img2-1024x702.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/img2-768x527.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/img2-1536x1053.jpg 1536w" sizes="(max-width: 1616px) 100vw, 1616px" /><p id="caption-attachment-7016" class="wp-caption-text">Imagem: Rede Social &#8211; Leandro Garcia-técnico e equipe Aparu</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]<span style="font-size: 8pt;">Texto: Cristiane de Paula – ASCOM CINTESP.Br</span></p>\n<p style="text-align: justify;">Classificatório para o Campeonato Brasileiro de Atletismo da Confederação Brasileira de Desportos para Deficientes Intelectuais (CBDI) em São Paulo e Brasileiro de bocha em Joinville/SC, estes são apenas dois eventos que acontecem nestes últimos dias de outubro e importantes para superar marcas e somar pontos.</p>\n<p style="text-align: justify;">No caso do atletismo, que acontece neste final de semana na cidade de São Paulo, Uberlândia está representada pela equipe da Futel/Aparu composta por 4 paratletas: Wellington Fernandes (campeão mundial no heptatlo em 2019) que competirá nas provas de heptatlo e lançamento de dardo, Ana Luiza Ferreira (tricampeã brasileira em lançamento de dardo e lançamento de disco), Gabriel Antônio para competir nos 200, 400, 800 e 1.500 metros rasos, Daniel Lira nos 110 metros com barreira e nos 100 metros rasos e  o técnico Leandro Garcia.</p>\n<p style="text-align: justify;">O evento de São Paulo é classificatório para o Campeonato Brasileiro de Atletismo da Confederação Brasileira de Desportos para Deficientes Intelectuais (CBDI).</p>\n<p style="text-align: justify;">“Esse meeting tem uma importância especial por ser o primeiro evento nacional pós pandemia e valendo índice para a classificação do campeonato brasileiro, que vai acontecer de 15 a 17 de novembro em São Paulo, Brasileiro e nós temos boas expectativas com grandes chances de classificação”, disse Leandro Garcia.</p>\n<p style="text-align: justify;">Outro importante evento para o final deste mês será o Campeonato Brasileiro Masculino de bocha paralímpica 2021 &#8211; principal e intermediário, que acontecerá de 25 a 31 de outubro, em Joinville/SC. Este Brasileiro é considerado um dos maiores eventos da categoria e reunirá quase 100 paratletas. Para esta competição Uberlândia se destaca com a terceira maior equipe, serão 5 competidores, entre eles Matheus Carvalho, bronze na bocha individual e uma de ouro por equipe nos Jogos Parapan-Americanos de 2019, disputados em Lima, no Peru.</p>\n<p style="text-align: justify;"><strong>Novos tempos</strong></p>\n<p style="text-align: justify;">Desde os Jogos Paralímpicos de Tóquio o paradesporto vem colhendo bons resultados, garantem os atletas e comissões técnicas. Uberlândia, em especial, apresenta novidades com parcerias envolvendo novos investidores, como o recente anúncio do Praia Clube que inicia o apoio aos paratletas do halterofilismo do Clube Desportivo de Deficientes de Uberlândia (CDDU) e com o trabalho do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos CINTESP.Br que desenvolve equipamentos e dispositivos para atender o Comitê Paralímpico Brasileiro com os atletas de alto rendimento e iniciação.</p>\n<p style="text-align: justify;">Entre os projetos em fase final de desenvolvimento estão o equipamento que permitirá a prescrição para fabricação de cadeira de rodas personalizada o que permitirá atender com maior precisão às necessidades do paratleta, a calha para a bocha, na categoria BC3, voltada para atletas com maior grau de comprometimento motor (paralisia cerebral e de condições similares, com origem não cerebral), e o banco de arremesso para o paratletismo, todos em fase de testes além de um elevador de transferência para a natação.</p>\n<p style="text-align: justify;">“Neste ano tenho percebido um grande movimento em torno da gestão de novos incentivos, em torno do esporte paralímpico. E, o CINTESP pode impactar não só no paradesporto, mas, sabemos que a partir dessa experiência pode impactar em toda uma rede produtiva e melhorar a qualidade de vida das pessoas com deficiência, cada vez mais acessível, gerando oportunidade para que as pessoas demonstrem talento, assim como o esporte é uma grande ferramenta, a tecnologia também é”, acrescenta Leandro Garcia, treinador da equipe de atletismo paralímpico da Aparu/Futel.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Texto: Cristiane de Paula – ASCOM CINTESP.Br Classificatório para o Campeonato Brasileiro de Atletismo da Confederação Brasileira de Desportos para Deficientes Intelectuais (CBDI) em São Paulo e Brasileiro de bocha em Joinville/SC, estes são apenas dois eventos que acontecem nestes últimos dias de outubro e importantes para superar marcas e somar&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7015,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 34, 62],
        tags: [],
        class_list: [
            "post-7014",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-57",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7014",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7014",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7014/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7033,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7014/revisions/7033",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7015",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7014",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7014",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7014",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 7002,
        date: "2021-10-21T17:40:10",
        date_gmt: "2021-10-21T20:40:10",
        guid: {
            rendered: "https://cintespbr.org/?p=7002",
        },
        modified: "2021-12-27T23:04:38",
        modified_gmt: "2021-12-28T02:04:38",
        slug: "7002",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/7002/",
        title: {
            rendered:
                "Novos índices dos atletas do halterofilismo podem levar Uberlândia para o Mundial na Geórgia",
        },
        content: {
            rendered:
                '<div id="attachment_7003" style="width: 567px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-7003" class="wp-image-7003" src="https://cintespbr.org/wp-content/uploads/2021/10/51585617300_73beb2fcc2_k-300x209.jpg" alt="" width="557" height="388" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/10/51585617300_73beb2fcc2_k-300x209.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/51585617300_73beb2fcc2_k-1024x715.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/51585617300_73beb2fcc2_k-768x536.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/51585617300_73beb2fcc2_k-1536x1073.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/51585617300_73beb2fcc2_k.jpg 2048w" sizes="(max-width: 557px) 100vw, 557px" /><p id="caption-attachment-7003" class="wp-caption-text"><strong> Foto: Ale Cabral &#8211; CPB</strong> &#8211; Ângela Faria Teixeira, categoria até 67 kg uma das paratletas de Uberlândia CDDU/Praia/Futel</p></div>\n<p>&nbsp;</p>\n<p><em><span style="font-size: 8pt;">Texto Cristiane de Paula Ascom CINTESP.Br</span></em></p>\n<p style="text-align: justify;">A seletiva para escolher os melhores rendimentos dos atletas do parahalterofilismo brasileiro aconteceu semana passada no Centro de Treinamento Paralímpico, em São Paulo. A equipe de Uberlândia faz parte do Clube Desportivo de Deficientes de Uberlândia (CDDU) que treina no Centro de Referência Paralímpico Brasileiro (CRPB) de Para Halterofilismo que funciona no UTC. Os atletas recebem o apoio da FUTEL e recentemente a equipe fechou parceria do Praia Clube.</p>\n<p style="text-align: justify;">\n<p style="text-align: justify;">Seis paratletas do halterofilismo acompanhados pelo treinador Weverton Santos foram para a seletiva em São Paulo, 4 deles alcançaram índices que os colocam aptos para a seleção do Comitê Paralímpico Brasileiro. “Tivemos excelentes resultados, a preocupaçao era o fato deles terem ficado tanto tempo sem competir, mas responderam muito bem aos resultados que almejávamos”, disse o treinador.</p>\n<p style="text-align: justify;">Os paratletas, que atingiram novos índices foram: Ângela Faria Teixeira, da categoria até 67 kg, Valeria Alves dos Santos  categoria &#8211; 86kg junior e Gabriel Serafim de Lima da categoria até 49 Kg e André Luiz Paz da categoria 97 Kg, “Será uma grande satisfação poder representar o Brasil pela primeira vez em um Mundial. Será minha primeira viagem para a Europa. Até então, tinha representado o país somente na América do Sul. Vou ficar muito feliz”, disse André que superou sua antiga marca de171 kg e ergueu 182 kg nesta Seletiva.</p>\n<p style="text-align: justify;">O Mundial de halterofilismo acontecerá de 27 de novembro a 5 de dezembro, em Tbilisi, na Geórgia. A convocação final deve ser divulgada ainda nesta semana com a lista dos paratletas em halterofilismo que vão representar o Brasil na competição.</p>\n<p>&nbsp;</p>\n<p><em><strong>Fonte: site CPB</strong></em></p>\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; Texto Cristiane de Paula Ascom CINTESP.Br A seletiva para escolher os melhores rendimentos dos atletas do parahalterofilismo brasileiro aconteceu semana passada no Centro de Treinamento Paralímpico, em São Paulo. A equipe de Uberlândia faz parte do Clube Desportivo de Deficientes de Uberlândia (CDDU) que treina no Centro de Referência Paralímpico Brasileiro (CRPB) de Para&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7003,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 60, 62],
        tags: [],
        class_list: [
            "post-7002",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-destaque-paralimpico",
            "category-todas-as-noticias",
            "category-57",
            "category-60",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7002",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=7002",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7002/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7005,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/7002/revisions/7005",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7003",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=7002",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=7002",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=7002",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6994,
        date: "2021-10-20T20:46:54",
        date_gmt: "2021-10-20T23:46:54",
        guid: {
            rendered: "https://cintespbr.org/?p=6994",
        },
        modified: "2021-12-28T00:03:33",
        modified_gmt: "2021-12-28T03:03:33",
        slug: "diretor-do-cintesp-br-participa-do-1o-encontro-nuteca-nucleo-de-tecnologia-assistiva",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/diretor-do-cintesp-br-participa-do-1o-encontro-nuteca-nucleo-de-tecnologia-assistiva/",
        title: {
            rendered:
                "Coordenador Geral do CINTESP.Br participa do 1º Encontro NUTECA Núcleo de Tecnologia Assistiva",
        },
        content: {
            rendered:
                '<p><a href="https://www.sympla.com.br/1-encontro-nuteca--nucleo-de-tecnologia-assistiva__1367252#sympla-streeming-mr"><img loading="lazy" decoding="async" class="aligncenter wp-image-6995" src="https://cintespbr.org/wp-content/uploads/2021/10/Post--1024x326.png" alt="" width="693" height="221" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/10/Post--1024x326.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/Post--300x96.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/Post--768x245.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/Post--1536x490.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/Post-.png 1716w" sizes="(max-width: 693px) 100vw, 693px" /></a></p>\n<p>A Universidade São Judas Tadeu tem o prazer de convidá-lo para participar do “1º Encontro NUTECA – Núcleo de Tecnologia Assistiva” que será realizado no dia 23 de outubro das 09h00 às 18h00.</p>\n<p>O Encontro, uma realização do Grupo de Pesquisa em Psicologia do Esporte e do Exercício e do Grupo de Estudos em Educação Física para Pessoas com Deficiência, tem por objetivo oficializar a fundação do NUTECA bem como divulgar à comunidade os diferentes projetos em andamento e os parceiros institucionais.</p>\n<p>Programa:</p>\n<p>Link para o período da manhã: https://www.youtube.com/watch?v=v0nOhupJ_7s</p>\n<p>9h00 Abertura</p>\n<p>Sandra Ortiz – Gerencia de Pesquisa da VPA</p>\n<p>Maria Luiza de Jesus Miranda – Coordenadora do Programa Stricto Sensu em Educação Física</p>\n<p>Antonio Guedes &#8211; Secretário Nacional do Paradesporto</p>\n<p>Participação Especial – Maciel Santos (atleta de bocha paralímpica)</p>\n<p>Coordenação: Regina Brandão e Graciele Massoli</p>\n<p>10h00 às 12h00 &#8211; Mesa 1 &#8211; Esporte adaptado e tecnologias assistivas: tendências e perspectivas</p>\n<p>Cleudmar Amaral de Araújo &#8211; Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos &#8211; CINTESP</p>\n<p>Thiago Lourenço &#8211; Coordenador Científico do Comitê Paralímpico Brasileiro</p>\n<p>Regina Brandão &#8211; Coordenadora do NUTECA</p>\n<p>Graciele Massoli Rodrigues &#8211; Vice coordenadora do NUTECA</p>\n<p>Coordenação: Regina Brandão e Ana Paula Mastrocola</p>\n<p>Link para o período da tarde: https://www.youtube.com/watch?v=rSQfDCHm1wo</p>\n<p>13h30 às 15h30 &#8211; Mesa 2 – Esporte e atividade física de todos, para todos, com todos</p>\n<p>Alessandro Tosin &#8211; Técnico da Seleção Brasileira de Goalball</p>\n<p>Kelly Antunes &#8211; Atleta</p>\n<p>Marcelo Haiachi &#8211; Universidade Federal de Sergipe, Gestor de Parabadminton da Confederação Brasileira de Badminton</p>\n<p>Carla Montenegro &#8211; Centro de Reabilitação com Idosos, doentes crônicos e Educação em diabetes &#8211; Hospital Albert Einstein</p>\n<p>Coordenação: Graciele Massoli Rodrigues e Milena Pedro de Morais</p>\n<p>15h30 às 17h30 &#8211; Mesa 3 &#8211; Pesquisas e programas: esportes adaptados</p>\n<p>Ciro Winckler &#8211; UNIFESP</p>\n<p>Denise Silva Neves &#8211; Programa de Esportes e Atividades Motoras Adaptadas &#8211; PEAMA</p>\n<p>Gilberto Martins Freire &#8211; Universidade Tecnológica Federal do Paraná</p>\n<p>Neiza de Lourdes Frederico Fumes &#8211; Associação Brasileira de Atividade Motora Adaptada &#8211; SOBAMA</p>\n<p>Roberta Miguel &#8211; Ottobock Brasil</p>\n<p>Coordenação: Regina Brandão e Graciele Massoli Rodrigues</p>\n<p>17h30 &#8211; Encerramento</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>A Universidade São Judas Tadeu tem o prazer de convidá-lo para participar do “1º Encontro NUTECA – Núcleo de Tecnologia Assistiva” que será realizado no dia 23 de outubro das 09h00 às 18h00. O Encontro, uma realização do Grupo de Pesquisa em Psicologia do Esporte e do Exercício e do Grupo de Estudos em Educação&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7001,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-6994",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6994",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6994",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6994/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7410,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6994/revisions/7410",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7001",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6994",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6994",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6994",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6972,
        date: "2021-10-14T16:43:23",
        date_gmt: "2021-10-14T19:43:23",
        guid: {
            rendered: "https://cintespbr.org/?p=6972",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "oito-halterofilistas-conquistam-novos-indices-em-seletiva-no-ct-paralimpico-para-mundial-da-modalidade-em-novembro",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/oito-halterofilistas-conquistam-novos-indices-em-seletiva-no-ct-paralimpico-para-mundial-da-modalidade-em-novembro/",
        title: {
            rendered:
                "Oito halterofilistas conquistam novos índices em Seletiva no CT Paralímpico para Mundial da modalidade em novembro",
        },
        content: {
            rendered:
                '<div id="attachment_6973" style="width: 1021px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6973" class="wp-image-6973 size-full" src="https://cintespbr.org/wp-content/uploads/2021/10/b3b48039b31c46aeaca2589487b03aaf.jpg" alt="" width="1011" height="571" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/10/b3b48039b31c46aeaca2589487b03aaf.jpg 1011w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/b3b48039b31c46aeaca2589487b03aaf-300x169.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/10/b3b48039b31c46aeaca2589487b03aaf-768x434.jpg 768w" sizes="(max-width: 1011px) 100vw, 1011px" /><p id="caption-attachment-6973" class="wp-caption-text">Halterofilista se prepara para realizar movimento durante Seletiva da modalidade no CT Paralímpico | Foto: Ale Cabral / CPB</p></div>\n<p style="text-align: left;">Oito halterofilistas conquistaram novos índices para o Campeonato Mundial de halterofilismo, que será realizado de 27 de novembro a 5 de dezembro, em Tbilisi, na Geórgia, durante Seletiva realizada nesta quarta-feira, 13, no Centro de Treinamento Paralímpico, em São Paulo. Agora, eles e os demais atletas que já tinham índice em suas categorias aguardam a lista final de convocação que deve ser divulgada ainda nesta semana para representarem o Brasil na competição.</p>\n<p>Entre os índices novos, foram três atletas adultos: André Luiz Paz, da categoria até 97 kg, Ângela Faria Teixeira, da categoria até 67 kg, e João França Júnior, que disputou os Jogos Paralímpicos de Tóquio pela categoria até 49 kg e agora retornou para a categoria até 54 kg, para a qual ainda não tinha índice e que vai focar para Paris 2024.</p>\n<p style="text-align: justify;">&#8220;Será uma grande satisfação poder representar o Brasil pela primeira vez em um Mundial. Será minha primeira viagem para a Europa. Até então, tinha representado o país somente na América do Sul. Vou ficar muito feliz&#8221;, afirmou André Luiz Paz, atleta de Uberlândia, 33 anos, e que teve amputação de perna devido a um acidente automobilístico. Seu índice era de 171 kg e ele ergueu 182 kg na Seletiva.</p>\n<p style="text-align: justify;">Os outros cinco índices inéditos foram obtidos por atletas da categoria júnior, que também contará com disputas no Mundial em Tbilisi, na Geórgia. Clayton Duarte Costa (até 59kg), Gabriel Serafim de Lima (até 49kg), Murilo Major (até 54kg), Tayná de Alcântara (até 45kg) e Valéria Alves dos Santos (até 86kg) foram os halterofilistas que bateram as marcas nesta classe.</p>\n<p style="text-align: justify;">Outros três atletas também bateram o índice em suas respectivas categorias nesta manhã, mas já tinham a marca estabelecida anteriormente e participaram da Seletiva apenas para adquirir ritmo de competição. Foram os casos de Márcia Menezes (mais de 86kg), Ezequiel de Souza Correa (até 72kg), e Lucas Manoel dos Santos (até 49 kg). Lucas, inclusive, tem índice tanto para a categoria júnior quanto para a adulta (open sênior) e poderá competir pelas duas no Mundial da modalidade.</p>\n<p style="text-align: justify;">Já João França Júnior, atleta potiguar que nasceu com artrogripose, doença que comprometeu o movimento de suas pernas, chegou a erguer 162 kg, apesar dos 127 kg que tinha como índice na sua nova categoria (até 54 kg).</p>\n<p style="text-align: justify;">&#8220;Na categoria 49 kg, eu tinha que ficar muito magro, então, eu sofria bastante. Agora, eu tenho um espaço para crescer [fisicamente] mais. Espero no Mundial estar melhor ainda para representar a nossa nação&#8221;, apontou.</p>\n<p><strong>Patrocínio</strong><br />\nO halterofilismo tem patrocínio das Loterias Caixa</p>\n<p>FONTE &#8211; cpb.org.br</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Oito halterofilistas conquistaram novos índices para o Campeonato Mundial de halterofilismo, que será realizado de 27 de novembro a 5 de dezembro, em Tbilisi, na Geórgia, durante Seletiva realizada nesta quarta-feira, 13, no Centro de Treinamento Paralímpico, em São Paulo. Agora, eles e os demais atletas que já tinham índice em suas categorias aguardam a&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6973,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-6972",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6972",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6972",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6972/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6976,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6972/revisions/6976",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6973",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6972",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6972",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6972",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6892,
        date: "2021-09-27T13:41:14",
        date_gmt: "2021-09-27T16:41:14",
        guid: {
            rendered: "https://cintespbr.org/?p=6892",
        },
        modified: "2021-12-27T23:04:38",
        modified_gmt: "2021-12-28T02:04:38",
        slug: "ministerio-da-cidadania-e-comite-paralimpico-brasileiro-conhecem-projetos-do-cintesp-br",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ministerio-da-cidadania-e-comite-paralimpico-brasileiro-conhecem-projetos-do-cintesp-br/",
        title: {
            rendered:
                "MINISTÉRIO DA CIDADANIA E COMITÊ PARALÍMPICO BRASILEIRO CONHECEM PROJETOS DO CINTESP.Br",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h4-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>MINISTÉRIO DA CIDADANIA E COMITÊ PARALÍMPICO BRASILEIRO CONHECEM PROJETOS DO CINTESP.Br<span class="separator-holder separator-right"></span></div></div>[vc_column_text]</p>\n<div id="attachment_6893" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6893" class="wp-image-6893 size-large" src="https://cintespbr.org/wp-content/uploads/2021/09/entrega-1024x382.jpg" alt="" width="1024" height="382" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/09/entrega-1024x382.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/entrega-300x112.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/entrega-768x286.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/entrega-1536x572.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/entrega.jpg 1948w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-6893" class="wp-caption-text">José Guedes secretário paradesporto Ministério Cidadania e Alberto Martins diretor técnico do Comitê Paralímpico Brasileiro e comitiva</p></div>\n<p><span style="font-size: 8pt;">Texto: Cristiane de Paula &#8211; Ascom CINTESP.Br</span><br />\n<span style="font-size: 8pt;">Revisão Cleudmar Amaral – diretor CINTESP.Br</span>[/vc_column_text][vc_column_text]</p>\n<p style="text-align: justify;">Em visita a Uberlândia, o secretário nacional de paradesporto, José Guedes, do Ministério da Cidadania, juntamente com o diretor técnico do Comitê Paralímpico Brasileiro (CPB) conheceram duas inovações tecnológica assistiva, desenvolvidas no CINTESP.Br, direcionadas a atletas paralímpicos da Bocha Classe BC3 e arremesso de peso, que estão prestes a serem apresentadas ao CPB.</p>\n<p style="text-align: justify;">A apresentação dos equipamentos foi feita pela equipe de pesquisadores do CINTESP.Br e seu diretor, Cleudmar Amaral, na sede do SESI Gravatás, na tarde do dia 25. Na comitiva do secretário ainda estavam: Alberto Martins &#8211; Diretor técnico do Comitê Paralímpico Brasileiro, Guto Braga &#8211; Presidente do Praia Clube, Edson Zanatta &#8211; Diretor da Futel, Emerson Brasileiro  &#8211; Diretor de esportes da Futel, Leandro Garcia &#8211; Técnico de esportes paralímpicos da Futel, Silvio Santos, Diego Alves e Juliana Braga &#8211; Pesquisadores do CINTESP.Br, além de representantes da FIEMG e do SESI.</p>\n<p style="text-align: justify;">O primeiro equipamento apresentado foi um banco multi-regulável projetado para a modalidade paralímpica do arremesso de peso, dardo, disco e club que está em fase final de testes. O equipamento apresenta como inovação diversas regulagens que permitirá ser configurado com dimensões e ajustes otimizados aos atletas das diversas categorias. Atualmente, cada atleta precisa levar sua própria cadeira para o treinamento e competição. A proposta é que, em caso de aprovação pelo CPB, este banco possa ser utilizado diretamente nas competições evitando com que os atletas necessitem levar seus bancos para competição, reduzindo drasticamente custos de transportes e transtornos, uma vez que, estes bancos são pesados e possuem grandes dimensões. Outro aspecto inovador deste equipamento é a possibilidade dos atletas testarem diferentes configurações e regulagens visando a melhoria da performance do arremesso. Este tipo de avaliação é impossível porque seus bancos foram fabricados com uma geometria específica. As regulagens são feitas somente nas normas das diferentes modalidades do arremesso paralímpico. Os bancos dos atletas, em geral, são fabricados buscando atender as necessidades individuais para a melhor performance do atleta. “Essa cadeira vai revolucionar a prática dessas modalidades, podendo melhorar os atuais índices e possibilitar um número maior de paratletas participando de competições oficiais, já que o atleta não precisará levar o seu banco. O CINTESP.Br faz o seu principal papel que é desenvolver inovações para a comunidade, aqui na área da cidadania e direitos humanos  ampliando a acessibilidade e favorecendo a inclusão”, disse o diretor do CINTESP.</p>\n<p style="text-align: justify;">Os testes com o banco multi-regulável já acontecem há duas semanas. Para colaborar com os pesquisadores, foram convidados mais de 10 paratletas de Uberlândia de diferentes modalidades e deficiência. Nos testes, os atletas simulam os movimentos de arremesso e apontam o que deve ser corrigido para o banco oferecer conforto e segurança para o atleta explorar o máximo do potencial e melhorar a performance do arremesso. “Fantástico esse banco, vai ser muito bom, vocês estão de parabéns”, disse Matheus de Jesus Tibúrcio, paratleta de 22 anos.</p>\n<p style="text-align: justify;">O segundo protótipo apresentado à comitiva do secretário nacional de paradesporto foi a calha para a bocha paralímpica utilizada na classe BC3. Na oportunidade foram apresentadas 02 modelos, um direcionado para o esporte de alto rendimento e outro modelo direcionado para jovens atletas que estão iniciando no esporte. Em ambos protótipos, a inovação está no processo de fabricação que utiliza manufatura aditiva (Impressão 3D) feita em ABS em estrutura modular tipo “Lego” onde as peças se encaixam e com isso, consegue-se uma drástica redução do peso e volume da calha. Esta redução permite facilidade de transporte que geram transtorno para as delegações com as atuais calhas convencionais desenvolvidas no mundo. A diferença básica da calha de iniciação ao esporte é que possui uma maior quantidade de peças fabricadas por impressão 3D e que reduzem drasticamente seu custo. Utilizando tecnologia que permite maior precisão dos arremessos, os protótipos, além de todas estas vantagens, possuem custo significativamente menor do que calhas similares importadas consideradas, até o momento, as melhores. Segundo o diretor do Cintesp.Br a calha de alto rendimento tem um custo cinco vezes menor do que uma importada e com um peso completo aproximado de 16 quilos contra cerca de 40 quilos de outras versões de calhas” e serão uma tecnologia genuína e de fabricação totalmente nacional. No caso da calha, o paratleta Mateus Carvalho medalhista de ouro e bronze dos Jogos Parapan-Americanos de 2019 fez testes iniciais e vem contribuindo significativamente para o desenvolvimento do protótipo.  “Vamos dar suporte em várias áreas, como no halterofilismo, natação, atletismo e outras modalidades com o apoio de diversos pesquisadores em um formato de rede colaborativa onde faz parte diversos apoiadores, como por exemplo, o Ministério da Ciência, Tecnologia e Inovações &#8211; MCTI”, completa o diretor Cleudmar.</p>\n<p style="text-align: justify;">O diretor técnico do CPB, Alberto Martins ficou entusiasmado com os protótipos apresentados e da importância das testes com paratletas locais, “É muito importante que estas calhas e equipamentos sejam efetivamente testados pelos atletas para que possam ser utilizados nas diferentes associações”, disse Alberto Martins. Para  o Presidente do Praia Clube destacou a integração das instituições somando força para Uberlândia se manter em destaque entre as cidades do interior no apoio ao paraesporte e inovação tecnológica, “A sinergia entre o Cintesp.Br, a FUTEL, o Praia Clube e seus profissionais poderão desenvolver grandes projetos no paradesporto em parceria com o CPB e o segmento de esportes paralímpicos sob a gestão do Secretário José Guedes”, completou Guto Braga. O Secretário Guedes reforçou a importância dos projetos e das parcerias, “A interação do Ministério da Cidadania na área do esporte paralímpico na cidade de Uberlândia é muito importante, principalmente, com o envolvimento do Praia Clube, da Futel, e do segmento de pesquisas e inovações envolvendo o Cintesp.Br”. José Guedes adiantou que em breve voltará a Uberlândia para conhecer novas tecnologias que estão sendo desenvolvidas no CINTESP.Br.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Texto: Cristiane de Paula &#8211; Ascom CINTESP.Br Revisão Cleudmar Amaral – diretor CINTESP.Br[/vc_column_text][vc_column_text] Em visita a Uberlândia, o secretário nacional de paradesporto, José Guedes, do Ministério da Cidadania, juntamente com o diretor técnico do Comitê Paralímpico Brasileiro (CPB) conheceram duas inovações tecnológica assistiva, desenvolvidas no CINTESP.Br, direcionadas a atletas paralímpicos da Bocha Classe BC3&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6896,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-6892",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6892",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6892",
                },
            ],
            "version-history": [
                {
                    count: 8,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6892/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6922,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6892/revisions/6922",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6896",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6892",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6892",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6892",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6878,
        date: "2021-09-21T18:21:20",
        date_gmt: "2021-09-21T21:21:20",
        guid: {
            rendered: "https://cintespbr.org/?p=6878",
        },
        modified: "2021-12-27T23:04:38",
        modified_gmt: "2021-12-28T02:04:38",
        slug: "6878",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/6878/",
        title: {
            rendered:
                "CINTESP.Br promove entrega especial de kits lúdicos no mês de destaque para conscientização pela inclusão social e profissional das pessoas com deficiência",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h3-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>CINTESP.Br promove entrega especial de kits lúdicos no mês de destaque para conscientização pela inclusão social e profissional das pessoas com deficiência<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<div id="attachment_6888" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6888" class="wp-image-6888 size-large" src="https://cintespbr.org/wp-content/uploads/2021/09/entrega1-1-1024x347.png" alt="" width="1024" height="347" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/09/entrega1-1-1024x347.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/entrega1-1-300x102.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/entrega1-1-768x260.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/entrega1-1-1536x520.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/entrega1-1.png 1975w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-6888" class="wp-caption-text">Ana Paula Borges – secretária, Edna A. da Silva Souza – supervisora, Abadia Silva Almeida – professora, Ana Sara Tomé – pesquisadora CINTESP.Br</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]<span style="font-size: 8pt;">Texto Cristiane de Paula &#8211; Ascom CINTESP.Br</span></p>\n<p><span style="font-size: 8pt;">Revisão Ana Sara Tomé</span></p>\n<p style="text-align: justify;">Como atividade de setembro, mês de luta pela Inclusão Social e Profissional das Pessoas com Deficiência o CINTESP.Br, em Uberlândia promoveu a distribuição de kits lúdicos escolares para mais de 2.500 crianças. O Projeto CRESCER- Caminhos da Inclusão é patrocinado pelo Ministério da Ciência, Tecnologia e Inovação e integra as ações da Secretaria de Articulação e Promoção da Ciência (SEAPC), sob a coordenação do Departamento de Articulação e Comunicação da SEAPC do MCTI. O principal objetivo do Projeto é de oferecer novas ferramentas de apoio para as atividades escolares quando o tema for inclusão com acessibilidade e despertar o interesse pelo conhecimento promovendo a ciência. Já faz parte do planejamento da Secretaria de Estado da Educação pra que toda Escola seja acessível e esse material vai proporcionar o trabalho com mais argumentos com nossos alunos”, disse Ana Paula Borges, secretária da Escola.</p>\n<p style="text-align: justify;">A escola que recebeu os kits faz parte da Rede Estadual do Estado de Minas Gerais e está localizada na região Sul de Uberlândia. A Escola Dona Alexandra Pedreiro tem quase mil alunos e foi uma das primeiras da rede pública do Estado a completar todo o projeto arquitetônico de adaptação do prédio para ficar totalmente acessível. “O CINTESP.Br realiza esta distribuição do material KIT lúdico CRESCER também realizado em rede colaborativa e ficamos muito encantados com o projeto da Escola e estes recursos lúdicos pedagógicos poderão somar ao trabalho já desenvolvido pela Escola com toda a comunidade que é o fortalecimento da acessibilidade para a inclusão”, disse a pesquisadora do CINTESP.Br, Ana Sara Tomé.</p>\n<p>Foram ao todo 150 kits, além de 400 exemplares do livro CRESCER e  material sobre as ações do MCTI em favor da ciência, tecnologia e inovação por um Brasil inclusivo, um livro da história da Semana Nacional da Ciência, Tecnologia e Inovação, materiais de conscientização sobre cuidados com a higienização e a proteção contra a COVID-19 e jogos infantis como um quebra cabeça e materiais de montar.[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_6882" style="width: 972px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6882" class="wp-image-6882 size-full" src="https://cintespbr.org/wp-content/uploads/2021/09/entrega3.png" alt="" width="962" height="722" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/09/entrega3.png 962w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/entrega3-300x225.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/entrega3-768x576.png 768w" sizes="(max-width: 962px) 100vw, 962px" /><p id="caption-attachment-6882" class="wp-caption-text">Mapa tátil instalado na porta de acesso da Escola e placa com descrição tátil na entrada da sala de aula</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_6883" style="width: 923px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6883" class="wp-image-6883 size-full" src="https://cintespbr.org/wp-content/uploads/2021/09/Entrega4.png" alt="" width="913" height="730" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/09/Entrega4.png 913w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/Entrega4-300x240.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/Entrega4-768x614.png 768w" sizes="(max-width: 913px) 100vw, 913px" /><p id="caption-attachment-6883" class="wp-caption-text">Mapa tátil instalado na porta de acesso da Escola e placa com descrição tátil na entrada da sala de aula</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">O trabalho de adaptação durou mais de 3 anos entre o estudo de viabilidade de engenharia até as obras e instalação de equipamentos de identificação, de segurança, de acesso e de localização. A entrada dos alunos ganhou um mapa tátil que tem a localização de todas as instalações com descrição em braile, os acessos ganharam rampas, as portas das salas e banheiros foram trocadas e foi instalado piso tátil por toda a escola. “As placas de identificação e todas as adaptações são importantes para que todas as crianças, todas as pessoas tenham mesmos direitos de acesso à educação, um processo de transformação que nos deixou muito gratos”, completa a secretária Ana Paula.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][/vc_column][/vc_row][vc_row][vc_column][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Texto Cristiane de Paula &#8211; Ascom CINTESP.Br Revisão Ana Sara Tomé Como atividade de setembro, mês de luta pela Inclusão Social e Profissional das Pessoas com Deficiência o CINTESP.Br, em Uberlândia promoveu a distribuição de kits lúdicos escolares para mais de 2.500 crianças. O Projeto CRESCER- Caminhos da Inclusão é patrocinado pelo Ministério da&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6879,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-6878",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6878",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6878",
                },
            ],
            "version-history": [
                {
                    count: 7,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6878/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6923,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6878/revisions/6923",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6879",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6878",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6878",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6878",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6837,
        date: "2021-09-17T18:06:58",
        date_gmt: "2021-09-17T21:06:58",
        guid: {
            rendered: "https://cintespbr.org/?p=6837",
        },
        modified: "2021-12-27T22:46:16",
        modified_gmt: "2021-12-28T01:46:16",
        slug: "aulas-presenciais-na-universidade-federal-de-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/aulas-presenciais-na-universidade-federal-de-uberlandia/",
        title: {
            rendered:
                "Aulas presenciais na Universidade Federal de Uberlândia.",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h2-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>Aulas presenciais na Universidade Federal de Uberlândia.<span class="separator-holder separator-right"></span></div></div>[vc_single_image image=&#8221;6838&#8243; img_size=&#8221;full&#8221;][vc_column_text]Reitor da UFU, Valder Steffen Júnior, anunciou que começa a ser planejado o retorno presencial das aulas, o que poderá acontecer no final de novembro.<br />\nAs primeiras atividades que devem reto ar à normalidade deveão ser as realizadas em laboratórios de pesquisas.[/vc_column_text][vc_btn title=&#8221;Confira a entrevista no &#8220;Notícia da Hora&#8220;&#8221; color=&#8221;pink&#8221; size=&#8221;lg&#8221; link=&#8221;url:https%3A%2F%2Ffb.watch%2F80GgncnJOU%2F|target:_blank&#8221;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;6838&#8243; img_size=&#8221;full&#8221;][vc_column_text]Reitor da UFU, Valder Steffen Júnior, anunciou que começa a ser planejado o retorno presencial das aulas, o que poderá acontecer no final de novembro. As primeiras atividades que devem reto ar à normalidade deveão ser as realizadas em laboratórios de pesquisas.[/vc_column_text][vc_btn title=&#8221;Confira a entrevista no &#8220;Notícia da Hora&#8220;&#8221; color=&#8221;pink&#8221; size=&#8221;lg&#8221; link=&#8221;url:https%3A%2F%2Ffb.watch%2F80GgncnJOU%2F|target:_blank&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6838,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [62],
        tags: [],
        class_list: [
            "post-6837",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-todas-as-noticias",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6837",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6837",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6837/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6841,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6837/revisions/6841",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6838",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6837",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6837",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6837",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6800,
        date: "2021-09-05T13:26:54",
        date_gmt: "2021-09-05T16:26:54",
        guid: {
            rendered: "https://cintespbr.org/?p=6800",
        },
        modified: "2021-12-27T23:02:10",
        modified_gmt: "2021-12-28T02:02:10",
        slug: "05-09-dia-mundial-de-concientizacao-da-fibriose-cistica",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/05-09-dia-mundial-de-concientizacao-da-fibriose-cistica/",
        title: {
            rendered:
                "05/09 &#8211; Dia mundial de Concientização da Fibriose Cística",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-6801 size-large" src="https://cintespbr.org/wp-content/uploads/2021/09/postdorencas-raras-1024x540.jpg" alt="" width="1024" height="540" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/09/postdorencas-raras-1024x540.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/postdorencas-raras-300x158.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/postdorencas-raras-768x405.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/postdorencas-raras-1536x810.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/postdorencas-raras-2048x1080.jpg 2048w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n',
            protected: false,
        },
        excerpt: {
            rendered: "",
            protected: false,
        },
        author: 4,
        featured_media: 6801,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-6800",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6800",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6800",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6800/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6802,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6800/revisions/6802",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6801",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6800",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6800",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6800",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6793,
        date: "2021-09-05T13:05:38",
        date_gmt: "2021-09-05T16:05:38",
        guid: {
            rendered: "https://cintespbr.org/?p=6793",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "confira-todos-os-resultados-dos-brasileiros-nos-jogos-paralimpicos-de-toquio-2020",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/confira-todos-os-resultados-dos-brasileiros-nos-jogos-paralimpicos-de-toquio-2020/",
        title: {
            rendered:
                "Confira todos os resultados dos brasileiros nos Jogos Paralímpicos de Tóquio 2020",
        },
        content: {
            rendered:
                '<p>&nbsp;</p>\n<div class="row img-main align_center">\n<div class="imagem-principal-detalhe">\n<div style="width: 1021px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" class="img-responsive" src="https://www.cpb.org.br/upload/noticia/50b89e5d46574dbca52740de79f12612.jpg" alt="Foto: Takuma Matsushita/CPB." width="1011" height="571" /><p class="wp-caption-text">Foto: Takuma Matsushita/CPB.</p></div>\n<div class="ssk-sticky ssk-center ssk-lg"></div>\n</div>\n</div>\n<div class="texto">\n<p>Os Jogos Paralímpicos de Tóquio se encerraram neste domingo, 5, e o Brasil fez sua melhor campanha com 72 medalhas, sendo 22 de ouro, 20 de prata e 30 de bronze, que lhe rendeu a sétima posição no megaevento (atrás de China, Grã-Bretanha, Comitê Paralímpico Russo, EUA, Holanda e Ucrânia).</p>\n<p>A delegação brasileira contou com 259 atletas (incluindo guias, calheiros, goleiros e timoneiro), sendo 163 homens e 96 mulheres, além de comissão técnica, médica e administrativa, totalizando 435 pessoas. Jamais uma missão brasileira em Jogos Paralímpicos no exterior teve tamanha proporção.</p>\n<p><strong><a href="https://www.cpb.org.br/upload/link/67917bee6b544a468cdaef06b6a45d48.xlsx" target="_blank" rel="noopener">CONFIRA AQUI TODOS OS RESULTADOS DOS BRASILEIROS</a></strong></p>\n<p><strong>Patrocínio</strong><br />\nA delegação brasileira dos Jogos Paralímpicos de Tóquio conta com o patrocínio das Loterias Caixa.</p>\n<p><strong>Fonte: cpb.org.br)</strong></p>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; Os Jogos Paralímpicos de Tóquio se encerraram neste domingo, 5, e o Brasil fez sua melhor campanha com 72 medalhas, sendo 22 de ouro, 20 de prata e 30 de bronze, que lhe rendeu a sétima posição no megaevento (atrás de China, Grã-Bretanha, Comitê Paralímpico Russo, EUA, Holanda e Ucrânia). A delegação brasileira contou&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6794,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-6793",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6793",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6793",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6793/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6796,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6793/revisions/6796",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6794",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6793",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6793",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6793",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6790,
        date: "2021-09-05T12:34:49",
        date_gmt: "2021-09-05T15:34:49",
        guid: {
            rendered: "https://cintespbr.org/?p=6790",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "parabens-aos-nossos-paratletas",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/parabens-aos-nossos-paratletas/",
        title: {
            rendered: "PARABÉNS AOS NOSSOS PARATLETAS",
        },
        content: {
            rendered:
                '<h4>A melhor campanha de todos os tempos: Brasil termina os Jogos Paralímpicos de Tóquio com recorde de ouros e feitos inéditos</h4>\n<div id="attachment_6791" style="width: 1021px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6791" class="wp-image-6791 size-full" src="https://cintespbr.org/wp-content/uploads/2021/09/05e5d66fed2b43bfa86a7a954e44fb24.jpg" alt="" width="1011" height="571" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/09/05e5d66fed2b43bfa86a7a954e44fb24.jpg 1011w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/05e5d66fed2b43bfa86a7a954e44fb24-300x169.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/09/05e5d66fed2b43bfa86a7a954e44fb24-768x434.jpg 768w" sizes="(max-width: 1011px) 100vw, 1011px" /><p id="caption-attachment-6791" class="wp-caption-text">Carol Santiago exibe suas medalhas conquistadas no Centro Aquático de Tóquio/Foto: Alê Cabral/CPB</p></div>\n<p style="text-align: justify;">As disputas dos Jogos Paralímpicos de Tóquio se encerraram no início da madrugada deste domingo, 5, e o Brasil se despediu com 72  medalhas, sendo 22 de ouro, 20 de prata e 30 de  bronze, na sétima colocação no quadro, cumprindo a meta do top 10 estabelecida no planejamento estratégico do CPB de 2017. Trata-se da melhor participação na história dos Jogos Paralímpicos.</p>\n<p>&#8220;O Comitê Paralímpico Brasileiro celebra, além da maior campanha de todos os tempos, o atingimento de todas as metas, como de participação de mulheres, participação de atletas jovens, participação de atletas de classes baixas [atletas com as deficiências mais severas]. Aprendemos muitas lições que vamos colocá-las em prática nos três anos que restam até a próxima edição de Jogos Paralímpicos, em Paris 2024&#8221;, comentou Mizael Conrado, bicampeão paralímpico de futebol de 5, em Atenas 2004 e Pequim 2008, e presidente do Comitê Paralímpico Brasileiro.</p>\n<p>A delegação brasileira foi composta por 259 atletas (incluindo atletas-guia, calheiros, goleiros e timoneiro), além de comissão técnica, médica e administrativa, totalizando 435 pessoas. Dos atletas com deficiência, 68 eram das chamadas &#8220;classes baixas&#8221; (com deficiência severa). Foram 42 homens e 26 mulheres. Trinta e nove participantes tinham menos de 23 anos, cerca de 17% do total da equipe nacional paralímpica.</p>\n<p>Em nenhuma outra edição a missão brasileira havia conquistado tantas medalhas de ouro. As 22 láureas obtidas na capital japonesa superaram as 21 de Londres 2012. No número total de pódios, o Brasil igualou a marca alcançada no Rio 2016. Foram 72 medalhas no Japão, tal qual nos Jogos Paralímpicos disputados em solo brasileiro, há cinco anos.</p>\n<p>Tais recordes foram puxados pela natação, que obteve o seu melhor desempenho em toda a história dos Jogos, com 23 medalhas (oito de ouro, cinco de prata e dez de bronze). O atletismo foi a modalidade que mais garantiu medalhas ao Brasil em Tóquio: 28 (oito de ouro, nove de prata e 11 de bronze) e também na soma de todas as participações brasileiras nas edições anteriores do megaevento (170 no total).</p>\n<p>O último brasileiro a pisar no pódio em solo japonês foi o gaúcho Alex Douglas da Silva, na classe T46 (deficiência em membros superiores). No começo da noite de sábado, 4, ele que finalizou a maratona no segundo lugar com o tempo de 2h27min, e recorde sul-americano, conquistando a medalha de prata.</p>\n<p>O Brasil também conquistou resultados expressivos na canoagem, esporte que está apenas em sua segunda participação no programa dos Jogos Paralímpicos &#8211; a estreia foi no Rio 2016. Fernando Rufino obteve a medalha de ouro nos 200m da classe VL2. Luís Carlos Cardoso, nos 200m (KL1) e Giovane de Paula, 200m, (VL3) ficaram com a prata. As três medalhas colocaram o país na terceira colocação da modalidade em Tóquio.</p>\n<p>&#8220;Este ouro eu dedico ao ano difícil de pandemia que as pessoas tiveram. Eu dedico a todos que perderam pessoas queridas, eu perdi gente que amava. Este ouro é uma forma de alegrar o povo. O brasileiro é um povo lutador e vibrou comigo&#8221;, disse Rufino, após sua conquista, no sábado, 4.</p>\n<p>No halterofilismo, o Brasil subiu ao lugar mais alto do pódio pela primeira vez na história. A responsável pelo feito foi Mariana D’Andrea, que levantou 137 kg na disputa entre atletas da categoria até 73kg.</p>\n<p>Outro ouro inédito para a missão brasileira foi conquistado pela judoca Alana Maldonado (categoria até 70kg), primeira mulher brasileira a ser campeã no judô na história dos Jogos Paralímpicos.</p>\n<p>Os Jogos de Tóquio também foram marcados pela primeira medalha de ouro para o goalball brasileiro. A Seleção masculina, bronze no Rio, venceu a Lituânia &#8211;  até então atual campeã paralímpica &#8211; em duas oportunidades, inclusive com uma goleada por 11 a 2 na estreia. Na final, contra a China, os brasileiros conquistaram a medalha dourada com uma vitória por 7 a 2.</p>\n<p>O grande nome brasileiro no Centro Aquático de Tóquio foi a pernambucana Carol Santiago, da classe S12 (para atletas com baixa visão), dona de cinco medalhas: quatro individuais (três de ouro e uma de bronze) e uma prata no revezamento 4x100m até 49 pontos (soma do número da classe dos integrantes).</p>\n<p>Ouro nos 50m e 100m livre, assim como nos 100m peito, a pernambucana bateu dois recordes paralímpicos em Tóquio: nos 50m livre (26s82) e 100m peito (1min14s89). No primeiro estilo, inclusive, ela conseguiu o feito em duas oportunidades, primeiro nas eliminatórias e depois quebrou a sua própria marca na final.</p>\n<p>Carol quebrou um jejum de 17 anos sem que Brasil pudesse celebrar uma campeã paralímpica na natação. Até então, Fabiana Sugimori, da classe carregava a honraria, conquistada em Sydney 2000 e Atenas 2004, ambas nos 50m livre da classe S11 (para cegos).</p>\n<p>A paulista Mariana D&#8217;Andrea, de 23 anos, conquistou a primeira medalha de ouro brasileira no halterofilismo na história dos Jogos Paralímpicos. A atleta, da categoria até 73kg, levantou 137 quilos e superou a chinesa Lili Xu, que ficou com a prata (134 quilos). O bronze foi para a francesa Souhad Ghazouani (132 quilos).</p>\n<p>&#8220;Esperava muito por este momento. Não tem gratidão maior do que ganhar esta medalha após cinco anos de treinamento. Agradeço a todos pela torcida e pela oração. Quero deixar registrado aqui, que se você tem sonho, corra atrás dos seus objetivos e os conquiste&#8221;, disse Mariana. Além do ouro da atleta, o Brasil tem outra medalha no halterofilismo paralímpico: a prata de Evânio Rodrigues da Silva nos Jogos Paralímpicos Rio 2016.</p>\n<p>A judoca Alana Maldonado, de 26 anos, foi a primeira mulher brasileira da modalidade a subir no lugar mais alto do pódio em uma edição de Jogos Paralímpicos. Na decisão, com um wazari, a paulista de Tupã derrotou a georgiana Ina Kaldan e conquistou o primeiro e único ouro para o judô brasileiro em Tóquio. Vale ressaltar que Alana também já havia sido a primeira brasileira campeã mundial de judô, em 2018.</p>\n<p>&#8220;Agradeço a toda a minha família e à comissão técnica, que estiveram sempre do meu lado neste ciclo tão difícil. Sou outra atleta em relação aos Jogos do Rio. No Brasil, estava do lado dos meus amigos e da minha família. Agora, fui campeã na terra do judô. Obrigado a todos que torceram. Esta medalha não é só minha. É de todos&#8221;, disse Alana.</p>\n<p>Destaque também para o parataekwondo, esporte estreante no programa paralímpico. Com três representantes na capital japonesa, o país conquistou três medalhas: um ouro com o paulista Nathan Torquato, uma prata, com a paulista Débora Menezes, e um bronze com a paraibana Silvana Fernandes), terminando a competição na liderança do ranking da modalidade.</p>\n<p>O paulista Nathan Torquato, da classe K44 até 61kg, subiu ao lugar mais alto do pódio no primeiro dia do parataekwondo no programa paralímpico. Na final, ele derrotou o egípcio Mohamed Elzayat, no Makuhari Messe Hall.</p>\n<p>A luta decisiva nem deveria ter acontecido. O egípcio sofreu uma lesão no rosto durante a semifinal e, por segurança, não voltaria para a final. Mas os atletas chegaram a subir na área de combate e, após um golpe do brasileiro, os médicos interromperam o duelo e confirmaram Nathan como campeão.</p>\n<p>“Primeira medalha da história do parataekwondo. Estou muito feliz por fazer parte disso e dessa conquista. Foi difícil, senti um pouco na primeira luta, mas cresci ao longo da competição e o resultado foi incrível”, comemorou Nathan. “Já lutei no convencional, depois fiz a migração para o paradesporto e foi a melhor escolha da minha vida”, completou o atleta.</p>\n<p>No atletismo, Beth Gomes confirmou o favoritismo e conquistou a medalha de ouro no lançamento de disco, na classe F52, com a marca de 17,62m, novo recorde mundial da prova. As ucranianas Iana Lebiedieva (15,48m) e Zoia Ovsii (14,37m) completaram o pódio.</p>\n<p>Aos 56 anos, a paulista foi a última a fazer seus lançamentos e superou suas adversárias logo na primeira tentativa ao cravar 15,68m. Mesmo com a medalha garantida no peito, Beth seguiu competindo até alcançar a marca que lhe valeu o ouro e o recorde mundial.</p>\n<p>“Mesmo sabedores da capacidade de nossa equipe, de nossos atletas, mais uma vez eles mostraram que podem ir além daquilo que a gente imagina, daquilo que a gente espera. São capazes de muito mais do que a gente pode prever. Tivemos performances espetaculares, com um brilho que me emocionou muitas vezes. Com certeza esses atletas nos mostram que faz todo o sentido esse trabalho, e isso traz ainda mais responsabilidade para seguirmos pensando num Brasil ainda melhor e que pode mais”, afirmou Mizael Conrado.</p>\n<p><strong>Daniel Dias</strong></p>\n<p>O nadador, agora aposentado oficialmente das piscinas após os Jogos de Tóquio, foi eleito neste sábado, 4, membro do Conselho de Atletas do Comitê Paralímpico Internacional (IPC, em inglês). O multimedalhista foi um dos seis escolhidos para o grupo, que representará os competidores pelos próximos três anos até os Jogos de Paris em 2024.</p>\n<p><strong>Patrocínios</strong></p>\n<p>A delegação brasileira tem o patrocínio das Loterias Caixa.</p>\n<p><strong>FONTE: https://www.cpb.org.br/</strong></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>A melhor campanha de todos os tempos: Brasil termina os Jogos Paralímpicos de Tóquio com recorde de ouros e feitos inéditos As disputas dos Jogos Paralímpicos de Tóquio se encerraram no início da madrugada deste domingo, 5, e o Brasil se despediu com 72  medalhas, sendo 22 de ouro, 20 de prata e 30 de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6791,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-6790",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6790",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6790",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6790/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6792,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6790/revisions/6792",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6791",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6790",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6790",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6790",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6781,
        date: "2021-09-05T12:28:03",
        date_gmt: "2021-09-05T15:28:03",
        guid: {
            rendered: "https://cintespbr.org/?p=6781",
        },
        modified: "2021-12-27T23:02:10",
        modified_gmt: "2021-12-28T02:02:10",
        slug: "pesquisas-do-cintesp-br-conectam-diversas-areas-da-universidade-federal-de-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/pesquisas-do-cintesp-br-conectam-diversas-areas-da-universidade-federal-de-uberlandia/",
        title: {
            rendered:
                "Pesquisas do CINTESP.Br conectam diversas áreas da Universidade Federal de Uberlândia",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h3-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>Pesquisas do CINTESP.Br conectam diversas áreas da Universidade Federal de Uberlândia<span class="separator-holder separator-right"></span></div></div>[vc_single_image image=&#8221;6782&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221; onclick=&#8221;img_link_large&#8221;][vc_column_text]Cristiane de Paula – ASCOM CINTESP.Br</p>\n<p>Revisão: Cleudmar Araújo – Diretor CINTESP.Br</p>\n<p>&nbsp;</p>\n<p style="text-align: justify;">Interação e conectividade são duas das diretrizes seguidas pela coordenação do CINTESP.Br, em Uberlândia para o desenvolvimento das pesquisas, tendo como foco principal promover a saúde, o bem-estar, a habilitação física e a inclusão social.</p>\n<p style="text-align: justify;">Com o entendimento de promover o conhecimento, gerar oportunidades e desenvolver inovação tecnológica que possa ser transferida para a sociedade, contemplando o máximo das necessidades das pessoas com deficiência e doenças raras, o CINTESP.Br desenvolve pesquisas integrando diversas áreas do conhecimento da Universidade Federal de Uberlândia (UFU) e outras Instituições de ensino superior, em diversas regiões do país, parceiras do CINTESP.Br.</p>\n<p style="text-align: justify;">São aproximadamente 50 pesquisadores, envolvendo profissionais técnicos, estudantes de graduação e de pós-graduação e docentes, atuando em mais de 60 projetos onde a multidisciplinaridade permeia os mais variados projetos que passam pela educação, saúde, lazer, esporte e vida diária.</p>\n<p style="text-align: justify;">No CINTESP.Br as linhas de pesquisas envolvem desde a prescrição de equipamentos, de dispositivos e de próteses; ao desenvolvimento de aparelhos biomecânicos de treinamento, passando pela habilitação e reabilitação física; a criação de recursos didático-pedagógicos para o ensino de línguas e da matemática; o projeto de arranjos físicos e modelos arquitetônicos inteligentes baseados em acessibilidade e ergonomia; a criação de novos materiais aplicáveis à engenharia biomecânica; o estudo da qualidade de vida para pessoas com doenças raras; o desenvolvimento das técnicas de manufatura aditiva aplicada e outras mais.</p>\n<p style="text-align: justify;">Cleiton Soares Camilo Junior está finalizando o mestrado em engenharia mecânica na UFU. Faz parte da equipe do CINTESP.Br com ênfase em tecnologia assistiva e processos de fabricação.  Atualmente, coordena o projeto de um elevador de piscina e também apoia outros projetos dando suporte na análise estrutural e fabricação. “Trabalhar com os projetos do Cintesp.Br ajuda a desenvolver minhas habilidades teóricas e práticas, pois estou envolvido tanto em modelagem e simulação quanto em fabricação. Isso é bom para mim, pois eu planejo cursar um doutorado no exterior e o Cintesp.Br vem ajudando a construir minha experiência profissional. Eu espero poder contribuir para essa população, muitas vezes esquecida, disponibilizando um elevador de piscina bom e financeiramente acessível”, disse o pesquisador.</p>\n<p style="text-align: justify;">Atualmente, diversos projetos em desenvolvimento no CINTESP.Br, buscam atender demandas do Comitê Paralímpico Brasileiro (CPB) no sentido de melhorar o rendimento dos paratletas de alta performance. Um exemplo, é o projeto de uma calha desenvolvida em formato modular, similar a um sistema “Lego”, por impressão 3D, com volume útil menor utilizada na modalidade da bocha paralímpica classe BC3 que também possui outras inovações como: o menor peso, detalhes no formato que permitem maior precisão nos lançamentos e o uso de 100% de tecnologia nacional permitindo a redução de custo em mais de 50%. Para este invento, que está em fase final de produção para testes com os atletas paralímpicos, foi preciso envolver além da engenharia mecânica, a fisioterapia, educação física e medicina. Outro exemplo, é uma base de apoio para a realização de exames de Raio-X para tratamento de lesões ligamentares do tornozelo, ou ainda diversos dispositivos e recursos para maior inclusão e acessibilidade nas áreas da educação e vida diária que envolvem a pedagogia associada com a engenharia mecânica e outras áreas da saúde, o que reforça o conceito de expandir e fortalecer as pesquisas em todas as áreas do conhecimento no âmbito da UFU e formar redes colaborativas para o desenvolvimento de projetos de forma sinérgica em um menor tempo possível para que as pessoas possam usufruir de tais tecnologias. “A natureza das pesquisas em tecnologia assistiva é essencialmente transdisciplinar. Envolve diversas áreas do conhecimento que trabalham de forma coordenada e complementar entre si, no sentido da cooperação assim, o CINTESP.Br desenvolve suas iniciativas em redes colaborativas contendo múltiplas disciplinas”, complementa Lucas Cardoso, pesquisador e Doutor em Engenharia Mecânica da UFU.</p>\n<p>[/vc_column_text][vc_media_grid grid_id=&#8221;vc_gid:1630855352635-8301ed00-2b31-5&#8243; include=&#8221;6784,6785,6786&#8243;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;6782&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221; onclick=&#8221;img_link_large&#8221;][vc_column_text]Cristiane de Paula – ASCOM CINTESP.Br Revisão: Cleudmar Araújo – Diretor CINTESP.Br &nbsp; Interação e conectividade são duas das diretrizes seguidas pela coordenação do CINTESP.Br, em Uberlândia para o desenvolvimento das pesquisas, tendo como foco principal promover a saúde, o bem-estar, a habilitação física e a inclusão social. Com o entendimento&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6788,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-6781",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6781",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6781",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6781/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6789,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6781/revisions/6789",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6788",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6781",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6781",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6781",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6726,
        date: "2021-08-29T13:42:10",
        date_gmt: "2021-08-29T16:42:10",
        guid: {
            rendered: "https://cintespbr.org/?p=6726",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "carol-santiago-bate-recorde-paralimpico-duas-vezes-e-conquista-mais-um-ouro-gabriel-geraldo-tambem-sobe-no-lugar-mais-alto-do-podio",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/carol-santiago-bate-recorde-paralimpico-duas-vezes-e-conquista-mais-um-ouro-gabriel-geraldo-tambem-sobe-no-lugar-mais-alto-do-podio/",
        title: {
            rendered:
                "Carol Santiago bate recorde paralímpico duas vezes e conquista mais um ouro; Gabriel Geraldo também sobe no lugar mais alto do pódio",
        },
        content: {
            rendered:
                '<div class="row img-main align_center">\n<div class="imagem-principal-detalhe">\n<div style="width: 1021px" class="wp-caption alignnone"><img loading="lazy" decoding="async" class="img-responsive" src="https://www.cpb.org.br/upload/noticia/a4435651d5f147d2a8eb198842cd0079.jpeg" alt="Carol Santiago celebra logo após saber que havia conquistado a medalha de ouro em Tóquio/Foto:Ale Cabral / CPB " width="1011" height="571" /><p class="wp-caption-text">Carol Santiago celebra logo após saber que havia conquistado a medalha de ouro em Tóquio/Foto:Ale Cabral / CPB</p></div>\n<div class="ssk-sticky ssk-center ssk-lg"></div>\n</div>\n<p>A nadadora Carol Santiago, de 36 anos, conquistou a medalha de ouro nos 50m livre, na classe S13 (para atletas com deficiência visual), batendo o recorde paralímpico (26s82) e superando a sua própria marca anterior (26s87), alcançada nas eliminatórias da mesma prova nos Jogos Paralímpicos de Tóquio. A recifense, inclusive, também é a detentora do recorde mundial (26s72).</p>\n</div>\n<div class="texto">A prata ficou com Anna Krivshina, do Comitê Paralímpico Russo, que fechou a final com 27s06. O pódio foi completado pela italiana Carlotta Gilli, que conquistou o bronze com 27s07.<br />\n&#8220;Estou muito feliz. É incrível estar aqui nesta competição tão importante. Sempre gostei de competir. Eu me senti bem desde o primeiro dia em que cheguei ao Japão. Estou emocionada. Tenho recebido muito carinho. Quando terminei a prova, soube que tinha ganhado porque ouvi o pessoal gritando o meu nome. Agradeço a todos pela torcida e pelos brasileiros que têm chorado e dado risadas com a gente&#8221;, disse a nadadora, que, na capital japonesa, já havia conquistado a medalha de bronze nos 100m costas da classe S12.Este foi o nono ouro do Brasil nos Jogos Paralímpicos de Tóquio &#8211; o terceiro na natação. Além de Carol, o Brasil subiu ao lugar mais alto do pódio com <a href="https://www.cpb.org.br/noticia/detalhe/3522/alana-se-torna-a-1a-mulher-brasileira-campea-no-judo-em-jogos-paralimpicos">Alana (judô na categoria até 70kg)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3520/mariana-dandrea-conquista-o-1o-ouro-do-halterofilismo-brasileiro-em-jogos-paralimpicos">Mariana D&#8217;Andrea (halterofilismo na categoria até 73kg</a>), <a href="https://www.cpb.org.br/noticia/detalhe/3498/gabriel-bandeira-bate-recorde-paralimpico-e-conquista-primeira-medalha-de-ouro-para-o-brasil-nos-jogos-de-toquio">Gabriel Bandeira (100m borboleta na classe S14)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3508/wendell-belarmino-vence-os-50m-livre-e-conquista-mais-um-ouro-para-o-brasil-no-jogos-paralimpicos-de-toquio">Wendell Belarmino (50m na classe S11)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3516/silvania-costa-supera-pouca-preparacao-e-revela-alivio-apos-conquista-do-seu-segundo-ouro-em-jogos-paralimpicos">Silvânia Costa (salto em distância na classe T11)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3510/petrucio-ferreira-mantem-escrita-bate-recorde-paralimpico-e-conquista-bicampeonato-dos-100m-nos-jogos-de-toquio">Petrucio Ferreira (100m rasos na classe T47)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3505/atletismo-comeca-com-ouros-de-fundista-yeltsin-jacques-e-saltadora-silvania-costa-nos-jogos-paralimpicos-de-toquio">Yeltsin Jacques (5.000m da classe T11)</a> e <a href="https://www.cpb.org.br/noticia/detalhe/3511/wallace-dos-santos-quebra-recorde-mundial-e-conquista-primeiro-ouro-nas-provas-de-campo-do-atletismo-nos-jogos-de-toquio">Wallace dos Santos (arremesso de peso pela classe F55).</a></p>\n<p>Somando este pódio, o Brasil já conquistou 330 medalhas na história dos Jogos Paralímpicos. Além disso, o país chegou à 96ª medalha de ouro &#8211; faltando quatro para a 100ª.  Ainda são 117 de prata e 117 de bronze.</p>\n<p><strong>Histórico</strong><br />\nCarol nasceu com síndrome de Morning Glory, alteração congênita na retina que reduz seu campo de visão. Praticou natação convencional até o fim de 2018, quando migrou para o esporte paralímpico. Na seletiva brasileira de natação, em junho, Carol bateu o recorde mundial dos 50m livre.</p>\n<p>Multimedalhista em mundiais e Jogos Parapan-Americanos, Carol já foi ouro nos 50m e 100m livre, além de prata nos 100m costas e no revezamento 4x100m livre 49 pontos no Mundial de Londres 2019. Também conquistou o ouro nos 50m livre, nos 100m livre, nos 100m costas e nos 400m livre nos Jogos Parapan-Americanos Lima 2019.</p>\n<p><strong>Segundo ouro do dia</strong></p>\n<p>E as alegrias para o Brasil não pararam por aí. Gabriel Geraldo brilhou e conquistou a segunda medalha de ouro para o país no dia ao vencer os 200m livre da classe S2, com o tempo de 4min06s52. O chileno Alberto Abarza (4min14s17) ficou com a prata e Vladimir Danilenko, do Comitê Paralímpico Russo, com o bronze. Bruno Becker (4min22s63), o outro representante brasileiro na prova, terminou na quarta colocação.</p>\n<p>&#8220;Espero que esse seja o primeiro (ouro) de muitos outros. Era isso que eu queria. Foi para isso que eu vim. Consegui baixar o meu tempo, fiz o novo recorde das américas. Treinamos forte, estava tudo controlado, eu sabia o que fazer e o resultado veio. Não existe emoção maior&#8221;, comemorou Gabriel Geraldo.</p>\n<p>Ao longo da prova, Gabriel optou por revezar estilos &#8211; o nado livre permite adoção de qualquer técnica. Nos primeiros 100m, o brasileiro nadou com a barriga virada para baixo. Dos 100m aos 150m, ele virou-se para cima e nadou costas. Por fim, fechou novamente de barriga para baixo.</p>\n<p>Essa foi a segunda medalha de Gabriel Geraldo em Tóquio. Ele foi o primeiro medalhista do Brasil nesta edição dos Jogos Paralímpicos de Tóquio ao faturar a prata dos 100m costas, na classe S2.</p>\n<p>Gabriel tem focomelia, doença congênita que impede a formação normal de braços e pernas, e conheceu a natação por meio de um professor de Educação Física da escola onde estudava, nos Jogos Escolares de Minas Gerais (JEMG).</p>\n<p>Entre as principais conquistas, além das duas medalhas em Tóquio estão o ouro nos 50 e 100m livre e bronze nos 50m costas e nos 50m borboleta nos Jogos Parapan-Americanos de Lima 2019.</p>\n<p><strong>Transmissão</strong><br />\nOs Jogos Paralímpicos de Tóquio 2020 contam com a transmissão ao vivo dos canais SporTV e da TV Brasil.</p>\n<p><strong>Patrocínio</strong><br />\nA delegação brasileira tem o patrocínio das Loterias Caixa.</p>\n</div>\n<div></div>\n<div>Fonte: cpb.org.br</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>A nadadora Carol Santiago, de 36 anos, conquistou a medalha de ouro nos 50m livre, na classe S13 (para atletas com deficiência visual), batendo o recorde paralímpico (26s82) e superando a sua própria marca anterior (26s87), alcançada nas eliminatórias da mesma prova nos Jogos Paralímpicos de Tóquio. A recifense, inclusive, também é a detentora do&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6727,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-6726",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6726",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6726",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6726/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6729,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6726/revisions/6729",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6727",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6726",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6726",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6726",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6723,
        date: "2021-08-29T13:39:31",
        date_gmt: "2021-08-29T16:39:31",
        guid: {
            rendered: "https://cintespbr.org/?p=6723",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "alana-se-torna-a-1a-mulher-brasileira-campea-no-judo-em-jogos-paralimpicos",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/alana-se-torna-a-1a-mulher-brasileira-campea-no-judo-em-jogos-paralimpicos/",
        title: {
            rendered:
                "Alana se torna a 1ª mulher brasileira campeã no judô em Jogos Paralímpicos",
        },
        content: {
            rendered:
                '<div class="row img-main align_center">\n<div class="imagem-principal-detalhe">\n<div style="width: 1021px" class="wp-caption alignnone"><img loading="lazy" decoding="async" class="img-responsive" src="https://www.cpb.org.br/upload/noticia/0f91ea81725c4e9eb62b2fddb5e432d6.jpeg" alt="Alana Maldonado vibra com a sua vitória nos Jogos de Tóquio/Mikihito Matsui/CPB" width="1011" height="571" /><p class="wp-caption-text">Alana Maldonado vibra com a sua vitória nos Jogos de Tóquio/Mikihito Matsui/CPB</p></div>\n<div class="ssk-sticky ssk-center ssk-lg"></div>\n</div>\n<p>&nbsp;</p>\n</div>\n<div class="texto">A judoca Alana Maldonado, de 26 anos, é a primeira mulher brasileira da modalidade a subir no lugar mais alto do pódio em uma edição de Jogos Paralímpicos. Na madrugada deste domingo (horário de Brasília), com um wazari, a paulista de Tupã derrotou a georgiana Ina Kaldan, na final da categoria até 70kg, e conquistou o primeiro ouro para o judô brasileiro em Tóquio. Vale ressaltar que Alana também já havia sido a primeira brasileira campeã mundial de judô, em 2018.</p>\n<p>&#8220;Agradeço a toda a minha família e à comissão técnica, que estiveram sempre do meu lado neste ciclo tão difícil. Sou outra atleta em relação aos Jogos do Rio. No Brasil, estava do lado dos meus amigos e da minha família. Agora, fui campeã na terra do judô. Obrigado a todos que torceram. Esta medalha não é só minha. É de todos&#8221;, disse Alana.</p>\n<p>Este foi o oitavo ouro do Brasil nos Jogos Paralímpicos de Tóquio. Além de Alana, o Brasil subiu ao lugar mais alto do pódio com <a href="https://www.cpb.org.br/noticia/detalhe/3520/mariana-dandrea-conquista-o-1o-ouro-do-halterofilismo-brasileiro-em-jogos-paralimpicos">Mariana D&#8217;Andrea (halterofilismo na categoria até 73kg)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3498/gabriel-bandeira-bate-recorde-paralimpico-e-conquista-primeira-medalha-de-ouro-para-o-brasil-nos-jogos-de-toquio">Gabriel Bandeira (100m borboleta na classe S14)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3508/wendell-belarmino-vence-os-50m-livre-e-conquista-mais-um-ouro-para-o-brasil-no-jogos-paralimpicos-de-toquio">Wendell Belarmino (50m na classe S11)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3516/silvania-costa-supera-pouca-preparacao-e-revela-alivio-apos-conquista-do-seu-segundo-ouro-em-jogos-paralimpicos">Silvânia Costa (salto em distância na classe T11)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3510/petrucio-ferreira-mantem-escrita-bate-recorde-paralimpico-e-conquista-bicampeonato-dos-100m-nos-jogos-de-toquio">Petrucio Ferreira (100m rasos na classe T47)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3505/atletismo-comeca-com-ouros-de-fundista-yeltsin-jacques-e-saltadora-silvania-costa-nos-jogos-paralimpicos-de-toquio">Yeltsin Jacques (5.000m da classe T11)</a> e <a href="https://www.cpb.org.br/noticia/detalhe/3511/wallace-dos-santos-quebra-recorde-mundial-e-conquista-primeiro-ouro-nas-provas-de-campo-do-atletismo-nos-jogos-de-toquio">Wallace dos Santos (arremesso de peso pela classe F55)</a>.</p>\n<p>Somando este pódio, o Brasil já conquistou 327 medalhas na história dos Jogos Paralímpicos. Além disso, o país chegou à 95ª medalha de ouro &#8211; faltando cinco para a 100ª.  Ainda são 117 de prata e 115 de bronze.</p>\n<p><strong>Histórico </strong><br />\nAlana descobriu a doença de Stargardt aos 14 anos. Já praticava judô desde os quatro, mas, somente em 2014, quando entrou para a faculdade, começou no judô paralímpico. Ela é líder do ranking mundial em sua categoria.</p>\n<p>Além do ouro paralímpico e mundial, a judoca foi prata nos Jogos Parapan-Americanos de Toronto 2015 e Lima 2019, bem como nos Jogos Paralímpicos Rio 2016.</p>\n<p><strong>Transmissão</strong><br />\nOs Jogos Paralímpicos de Tóquio 2020 contam com a transmissão ao vivo dos canais SporTV e da TV Brasil.</p>\n<p><strong>Patrocínio</strong><br />\nA delegação brasileira tem o patrocínio das Loterias Caixa.</div>\n<div></div>\n<div>Fonte: cpb.org.br</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; A judoca Alana Maldonado, de 26 anos, é a primeira mulher brasileira da modalidade a subir no lugar mais alto do pódio em uma edição de Jogos Paralímpicos. Na madrugada deste domingo (horário de Brasília), com um wazari, a paulista de Tupã derrotou a georgiana Ina Kaldan, na final da categoria até 70kg, e&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6724,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-6723",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6723",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6723",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6723/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6725,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6723/revisions/6725",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6724",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6723",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6723",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6723",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6719,
        date: "2021-08-29T13:35:15",
        date_gmt: "2021-08-29T16:35:15",
        guid: {
            rendered: "https://cintespbr.org/?p=6719",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "mariana-dandrea-conquista-o-1o-ouro-do-halterofilismo-brasileiro-em-jogos-paralimpicos",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/mariana-dandrea-conquista-o-1o-ouro-do-halterofilismo-brasileiro-em-jogos-paralimpicos/",
        title: {
            rendered:
                "Mariana D&#8217;Andrea conquista o 1º ouro do halterofilismo brasileiro em Jogos Paralímpicos",
        },
        content: {
            rendered:
                '<div class="row img-main align_center">\n<div class="imagem-principal-detalhe">\n<div style="width: 1021px" class="wp-caption alignnone"><img loading="lazy" decoding="async" class="img-responsive" src="https://www.cpb.org.br/upload/noticia/378248c36898419ead1e7893eb0c5518.jpeg" alt="Mariana D\'Andrea fez história e mostra a sua medalha dourada conquistada nos Jogos Paralímpicos de Tóquio/Foto: Takuma Matsushita/CPB" width="1011" height="571" /><p class="wp-caption-text">Mariana D&#8217;Andrea fez história e mostra a sua medalha dourada conquistada nos Jogos Paralímpicos de Tóquio/Foto: Takuma Matsushita/CPB</p></div>\n<div class="ssk-sticky ssk-center ssk-lg"></div>\n</div>\n<p>A paulista Mariana D&#8217;Andrea, de 23 anos, conquistou a primeira medalha de ouro brasileira no halterofilismo na história dos Jogos Paralímpicos. Na madrugada deste domingo, a atleta, da categoria até 73kg, levantou 137 quilos e superou a chinesa Lili Xu, que ficou com a prata (134 quilos). O bronze foi para a francesa Souhad Ghazouani (132 quilos).</p>\n</div>\n<div class="texto">&#8220;Esperava muito por este momento. Não tem gratidão maior do que ganhar esta medalha após cinco anos de treinamento. Agradeço a todos pela torcida e pela oração. Quero deixar registrado aqui, que se você tem sonho, corra atrás dos seus objetivos e os conquiste&#8221;, disse Mariana. Além do ouro da atleta, o Brasil tem outra medalha no halterofilismo paralímpico: a prata de Evânio Rodrigues da Silva nos Jogos Paralímpicos Rio 2016.</div>\n<div></div>\n<div class="texto">Este foi o sétimo ouro do Brasil nos Jogos Paralímpicos de Tóquio. Além de Mariana, o Brasil subiu ao lugar mais alto do pódio com <a href="https://www.cpb.org.br/noticia/detalhe/3498/gabriel-bandeira-bate-recorde-paralimpico-e-conquista-primeira-medalha-de-ouro-para-o-brasil-nos-jogos-de-toquio">Gabriel Bandeira (100m borboleta na classe S14)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3508/wendell-belarmino-vence-os-50m-livre-e-conquista-mais-um-ouro-para-o-brasil-no-jogos-paralimpicos-de-toquio">Wendell Belarmino (50m na classe S11)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3516/silvania-costa-supera-pouca-preparacao-e-revela-alivio-apos-conquista-do-seu-segundo-ouro-em-jogos-paralimpicos">Silvânia Costa (salto em distância na classe T11)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3510/petrucio-ferreira-mantem-escrita-bate-recorde-paralimpico-e-conquista-bicampeonato-dos-100m-nos-jogos-de-toquio">Petrucio Ferreira (100m rasos na classe T47)</a>, <a href="https://www.cpb.org.br/noticia/detalhe/3505/atletismo-comeca-com-ouros-de-fundista-yeltsin-jacques-e-saltadora-silvania-costa-nos-jogos-paralimpicos-de-toquio">Yeltsin Jacques (5.000m da classe T11)</a> e <a href="https://www.cpb.org.br/noticia/detalhe/3511/wallace-dos-santos-quebra-recorde-mundial-e-conquista-primeiro-ouro-nas-provas-de-campo-do-atletismo-nos-jogos-de-toquio">Wallace dos Santos (arremesso de peso pela classe F55)</a>.</p>\n<p>Somando este pódio, o Brasil já conquistou 326 medalhas na história dos Jogos Paralímpicos. Além disso, com esta vitória de Mariana, o país chegou à 94ª medalha de ouro &#8211; faltando seis para a 100ª.  Ainda são 117 de prata e 115 de bronze.</p>\n<p><strong>Histórico</strong></p>\n<p>Líder do ranking mundial na sua categoria, Mariana tem nanismo. Seu atual técnico, Valdecir Lopes, a viu na rua, em 2015, e a convidou para praticar halterofilismo. Além deste ouro conquistado em Tóquio, a atleta, natural da cidade de Itu, foi ouro na etapa de Tbilisi da Copa do Mundo 2021 e também subiu ao lugar mais alto do pódio nos Jogos Parapan-Americanos de Lima 2019.</p>\n<p><strong>Transmissão</strong><br />\nOs Jogos Paralímpicos de Tóquio 2020 contam com a transmissão ao vivo dos canais SporTV e da TV Brasil.</p>\n<p><strong>Patrocínio</strong><br />\nA delegação brasileira tem o patrocínio das Loterias Caixa.</p>\n<p><strong>Fonte: cpb.org</strong></div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>A paulista Mariana D&#8217;Andrea, de 23 anos, conquistou a primeira medalha de ouro brasileira no halterofilismo na história dos Jogos Paralímpicos. Na madrugada deste domingo, a atleta, da categoria até 73kg, levantou 137 quilos e superou a chinesa Lili Xu, que ficou com a prata (134 quilos). O bronze foi para a francesa Souhad Ghazouani&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6720,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-6719",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6719",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6719",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6719/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6721,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6719/revisions/6721",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6720",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6719",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6719",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6719",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6700,
        date: "2021-08-25T20:54:34",
        date_gmt: "2021-08-25T23:54:34",
        guid: {
            rendered: "https://cintespbr.org/?p=6700",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "mcti-financia-pesquisas-com-tecnologias-que-auxiliam-atletas-paralimpicos-e-outras-pessoas-com-deficiencia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/mcti-financia-pesquisas-com-tecnologias-que-auxiliam-atletas-paralimpicos-e-outras-pessoas-com-deficiencia/",
        title: {
            rendered:
                "MCTI financia pesquisas com tecnologias que auxiliam atletas paralímpicos e outras pessoas com deficiência",
        },
        content: {
            rendered:
                '<h4>O Ministério da Ciência, Tecnologia e Inovações financia projetos voltados para o desenvolvimento de tecnologias assistivas que auxiliam pessoas com deficiência ou com mobilidade reduzida</h4>\n<div id="attachment_6701" style="width: 778px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6701" class="wp-image-6701 size-full" src="https://cintespbr.org/wp-content/uploads/2021/08/0ad04f2c-4896-40e1-8701-c562273e4843.jpeg" alt="" width="768" height="616" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/08/0ad04f2c-4896-40e1-8701-c562273e4843.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/0ad04f2c-4896-40e1-8701-c562273e4843-300x241.jpeg 300w" sizes="(max-width: 768px) 100vw, 768px" /><p id="caption-attachment-6701" class="wp-caption-text">Ale Cabral/CPB</p></div>\n<p>&nbsp;</p>\n<p style="text-align: justify;">      Nesta terça-feira (24) começam os Jogos Paralímpicos de Tóquio, no Japão. O Brasil enviou a maior delegação da história, serão 435 componentes. Deste total, 259 são atletas, atletas-guias, calheiros, goleiros e timoneiros. Na última edição dos jogos, no Rio em 2016, o Brasil ficou em oitavo lugar no ranking de medalhas. Neste ano, os atletas paralímpicos brasileiros vão competir em 20 das 22 modalidades presentes na competição. O planejamento do Comitê Paralímpico Brasileiro (CPB) é ficar entre as 10 principais potências mundiais. Essa projeção é do diretor técnico do comitê, Alberto Martins, em entrevista para o portal do MCTI – Ministério da Ciência, Tecnologia e Inovações em julho deste ano.</p>\n<p style="text-align: justify;">“Nós temos uma expectativa muito boa de terminar a competição entre as 10 maiores potências do mundo. Fizemos um planejamento estratégico que foi feito em 2017 abrangendo dois ciclos, até 2024”, revelou.</p>\n<p style="text-align: justify;">Para promover melhor desempenho nas práticas esportivas um dos principais aliados dos atletas é a tecnologia assistiva, um conjunto de equipamentos, produtos ou sistemas desenvolvidos para melhorar as capacidades funcionais das pessoas com deficiência contribuindo no direito de igualdade de condições e oportunidades com as demais pessoas. Desde uma simples bengala até uma complexa prótese de braço ou perna, a tecnologia assistiva tem auxiliado na melhor qualidade de vida das pessoas e na inclusão social. De acordo com dados do Censo de 2010 realizado pelo Instituto Brasileiro de Geografia e Estatística (IBGE) 23% da população do país necessita de alguma tecnologia assistiva.</p>\n<p style="text-align: justify;">No Brasil tecnologias com essa finalidade, é prioridade do MCTI, que vem implementado políticas públicas para a promoção da ciência, tecnologia e inovação no campo da tecnologia assistiva, um exemplo está na implantação do Centro Nacional de Tecnologias para pessoas com deficiência e doenças raras (CNT/MCTI), que fica na cidade de Uberlândia em Minas gerais e é uma inciativa do governo federal por meio do MCTI. O ministro da Ciência, Tecnologia, Inovações, astronauta Marcos Pontes, destacou a necessidade do uso deste tipo de tecnologia no país. “Mais de 50 milhões de pessoas precisam de algum tipo de dispositivo, algum tipo de equipamento para melhorar a qualidade de vida. A ideia desse centro não é só o desenvolvimento dessas tecnologias que permitem melhorar a qualidade de vida das pessoas, mas também baratear o custo dessas tecnologias”.</p>\n<p style="text-align: justify;">Neste contexto os jogos paralímpicos são uma verdadeira vitrine onde diversas tecnologias desenvolvidas no Brasil poderão ser vistas em ação durante as competições. Para o atleta paralímpico da natação, Victor Alan Nogueira a tecnologia assistiva tem um papel de promover o bem-estar da pessoa com deficiência. “Se não fosse por ela [prótese que utiliza], eu não teria as facilidades que eu tenho hoje como me locomover, que é uma atividade básica no meu dia a dia. Com ela eu também posso dirigir e fazer outras atividades funcionais que incrementam no meu treino externo fora da água”, explica.</p>\n<p style="text-align: justify;"><strong>Desenvolvimento de tecnologia assitiva</strong></p>\n<p style="text-align: justify;">No Centro de Tecnologia da Informação Renato Acher (CTI), unidade de pesquisa vinculada ao MCTI, diversas pesquisas neste sentido estão sendo desenvolvidas. O pesquisador do centro, Pedro Noritomi, detalha como é feita uma prótese com base na tecnologia disponível no CTI. “Temos equipamentos que permitem criar soluções em tecnologia assistiva. Virtualmente enviamos para uma impressora tridimensional (3D) e ela então vai materializar essa solução usando uma tecnologia baseada em alta energia. Esse tipo de tecnologia permitiu a gente desenvolver soluções cada vez mais adaptadas a anatomia individual de cada paciente”.</p>\n<p style="text-align: justify;">O MCTI, por meio da empresa pública Financiadora de Estudos e Projetos (FINEP), vinculada ao ministério, investe em projetos que desenvolvem tecnologias assitivas. Só em 2020 foram aprovadas 35 propostas com o financiamento de R$ 55 milhões para o desenvolvimento destas tecnologias.</p>\n<p style="text-align: justify;">“Nós promovemos em 2020 uma ação conjunta do MCTI com o Ministério da Saúde para selecionar projetos para pesquisa de desenvolvimento tecnológico que contribuam para a atualização tecnológica do SUS e que busquem promover independência, autonomia e inclusão social e melhoria da qualidade de vida de pessoas com deficiência, pessoas idosas e com mobilidade reduzida”, declarou o superintendente de Inovação da Finep/MCTI, Rodrigo Secioso.</p>\n<p style="text-align: left;"><strong>Desafio para os jovens</strong></p>\n<p>Esta iniciativa visa estimulem a criação de inovações em tecnologia assistiva para vida diária, conscientizando sobre a importância da inclusão social, inclusão produtiva e acessibilidade. O Desafio – Ideias Brilhantes MCTI em inovações em Tecnologia Assistiva é um projeto educacional e tem como objetivos estimular o interesse pelas Ciências, Tecnologia e Inovação, especialmente pela Tecnologia Assistiva, além de prover aos professores ferramentas para o ensino dinâmico e participativo em áreas que abrangem o conteúdo de Tecnologia Assistiva para Vida Diária, estimular a socialização de professores e alunos através de atividades em equipe e fomentar a formação de recursos humanos para atuação na área de Tecnologia Assistiva. O Desafio tem abrangência nacional e é voltada para alunos do Ensino Fundamental II, do 6º ao 9º ano. Cada escola participa com uma equipe de 4 alunos e 1 professor. O 1º Desafio Ideias Brilhantes MCTI é uma iniciativa criada pela Secretaria de Articulação e Promoção da Ciência (SEAPC) em parceria com instituições de ensino públicas e privadas de todo país.</p>\n<p>&nbsp;</p>\n<p>FONTE: MCTI</p>\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O Ministério da Ciência, Tecnologia e Inovações financia projetos voltados para o desenvolvimento de tecnologias assistivas que auxiliam pessoas com deficiência ou com mobilidade reduzida &nbsp;       Nesta terça-feira (24) começam os Jogos Paralímpicos de Tóquio, no Japão. O Brasil enviou a maior delegação da história, serão 435 componentes. Deste total, 259 são&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6701,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 34, 62],
        tags: [],
        class_list: [
            "post-6700",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-57",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6700",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6700",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6700/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6707,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6700/revisions/6707",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6701",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6700",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6700",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6700",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6654,
        date: "2021-08-24T23:56:03",
        date_gmt: "2021-08-25T02:56:03",
        guid: {
            rendered: "https://cintespbr.org/?p=6654",
        },
        modified: "2021-12-27T23:04:38",
        modified_gmt: "2021-12-28T02:04:38",
        slug: "universidade-federal-de-uberlandia-com-a-agencia-intelecto-e-o-cintesp-br-fortalecem-a-rede-de-producao-e-protecao-de-patentes",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/universidade-federal-de-uberlandia-com-a-agencia-intelecto-e-o-cintesp-br-fortalecem-a-rede-de-producao-e-protecao-de-patentes/",
        title: {
            rendered:
                "Universidade Federal de Uberlândia com a Agência Intelecto e o CINTESP.Br® fortalecem a rede de produção e proteção de patentes",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_row_inner][vc_column_inner][vc_single_image image=&#8221;6674&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column_inner][/vc_row_inner][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]25 de Agosto 2021</p>\n<p>Cristiane de Paula – Ascom CINTESP.Br</p>\n<p>&nbsp;</p>\n<p style="text-align: justify;">Redes Inteligentes, Redes Colaborativas, Smart grids, Tecnologia Assistiva, Tecnologia da Informação e muito mais. Nunca a inovação esteve tão presente e provocativa quanto nas últimas décadas e a Universidade Federal de Uberlândia (UFU), na condição de destaque nacional, já se preparava para entrar com experiência nessa concorrida busca pela fabricação de novos recursos e equipamentos para a sociedade.</p>\n<p style="text-align: justify;">Para não ficar de fora da corrida pela inovação com garantias de proteção intelectual e também para entrar no mercado, a UFU, com a aprovação Conselho Universitário (CONSUN), criou em 2006, ligada à Pró-reitora de Pesquisa e Pós-Graduação, a Agência Intelecto, que passou a ser o principal agente na promoção de pesquisas, de cuidado da proteção legal do conhecimento gerado na Universidade, além de estimular e orientar a transferência dessa tecnologia para o setor produtivo e de ter parte dos lucros. A Intelecto dá à UFU melhor oportunidade de participar da exploração industrial e de compartilhar os ganhos econômicos com a exploração das invenções protegidas ao atender as demandas da sociedade. De acordo com a Resolução 08/2006, que autorizou a criação da Agência, o ganho financeiro com a transferência da tecnologia é de acordo com um percentual negociado do lucro da empresa que irá explorar a inovação no mercado. Esse percentual é repassado em partes iguais em forma de royalties sendo 1/3 para a Pró-reitoria de Pesquisa e Pós-graduação, 1/3 para a unidade acadêmica e 1/3 para ser dividido entre os pesquisadores do projeto. “Muitos de nossos contratos com as empresas são sigilosos, em alguns casos a empresa participa com investimentos direcionando a inovação para o mercado que ela deseja explorar a invenção”, disse Thiago Paluma, diretor de inovação da Pró- reitoria de Pesquisa e Pós-Graduação da UFU.</p>\n<p style="text-align: justify;">Uma das mais recentes tecnologias transferidas foi para atender o setor agrícola. A inovação foi adquirida por uma empresa nacional, com sede no Rio Grande do Sul. A pesquisa foi sobre o melhoramento genético de vegetais, mais especificamente de hortaliças com o objetivo de resistência a pragas e doenças causadas por fungos, vírus e bactérias, com intuito de reduzir a aplicação de defensivos agrícolas nas lavouras e foi desenvolvida na Estação Experimental de Hortaliças, do Campus da UFU da cidade de Monte Carmelo.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<div id="attachment_6659" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6659" class="wp-image-6659 size-large" src="https://cintespbr.org/wp-content/uploads/2021/08/ufumte-1024x845.png" alt="" width="1024" height="845" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/08/ufumte-1024x845.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/ufumte-300x248.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/ufumte-768x634.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/ufumte-1536x1268.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/ufumte-2048x1691.png 2048w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-6659" class="wp-caption-text">Na Estação Experimental são desenvolvidas atividades de ensino, pesquisa e extensão. (Foto: Divulgação/GEN-HORT)</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">A Intelecto passa a reforçar o foco no atendimento aos pesquisadores da UFU e até mesmo com empresas interessadas em fazer parcerias com a Universidade. Com essa interlocução é iniciada uma Rede Reforçada em favor das pesquisas e da extensão. Neste sentido reforça a cultura pelo estímulo à produção de pesquisa aplicada servindo de estímulo para a produção de novas tecnologias e para que as inovações cheguem mais rapidamente à sociedade. “Nós já conseguimos um grande avanço, basta ver o aumento de registro de patentes e de vermos pesquisadores estimulados retomando projetos para a transferência de tecnologia, como o CINTESP.Br vem fazendo. Agora nosso próximo desafio é estimular o setor empresarial e a criação de startups para termos mais facilidade de promovermos essa transferência de tecnologia para as novas invenções chegarem mais rápido à população”, disse Carlos Henrique de Carvalho Pró-reitor de Pesquisa e Pós-Graduação da UFU.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<div id="attachment_6661" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6661" class="wp-image-6661 size-large" src="https://cintespbr.org/wp-content/uploads/2021/08/grafico-1024x527.png" alt="" width="1024" height="527" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/08/grafico-1024x527.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/grafico-300x154.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/grafico-768x395.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/grafico-1536x790.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/grafico-2048x1054.png 2048w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-6661" class="wp-caption-text">Fonte: Agência Intelecto</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">Com a alta concentração de pesquisadores e elevado número de pedidos de patentes o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br), vinculado à UFU, passou a ser um dos principais parceiros da Agência. Só no ano passado o CINTESP.Br produziu 14 invenções e que tiveram registro de pedido de patente, mais que o dobro do solicitado em 2018. “Desenvolver inovações tecnológicas assistiva no Brasil é um grande desafio, principalmente, equipamentos e dispositivos que auxiliem pessoas com deficiência de menor renda a melhorarem a inclusão e a qualidade de vida. Em geral, são tecnologias personalizadas e que requerem um esforço da ciência visando soluções inovadoras e de custo acessível. Por exemplo, no esporte e na saúde ainda existe uma grande dependência da importação. Por isso, é importante a criação e a proteção intelectual destas soluções visando dar subsídios para que novas empresas possam investir neste segmento. Neste caso, a Agência Intelecto vem sendo fundamental apoiando e auxiliando nos pedidos de proteção intelectual junto à Universidade Federal de Uberlândia. Uma parceria que vem desde 2012 e que está cada vez mais consolidada, atualmente, o CINTESP.Br possui mais de 30 pedidos de proteção e existe uma previsão de dobrar este número nos próximos anos&#8230;” comentou o Diretor do CINTESP.Br, Cleudmar A. Araújo.</p>\n<p>&nbsp;</p>\n<p>Agora, completando 15 anos, a Agência vai reunir em uma live os principais ganhos para a sociedade com o trabalho desenvolvido pela Agência. Estarão presentes o presidente do CNPq e representantes das Secretarias de Estado e Municipal da Ciência Tecnologia, Desenvolvimento e Inovação, além de pesquisadores da UFU, da Intelecto e Reitoria da UFU, como consta no roteiro da programação. No dia 25 de agosto, ao vivo no canal da UFU, pelo youtube.[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;6663&#8243; img_size=&#8221;full&#8221; onclick=&#8221;img_link_large&#8221;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;6664&#8243; img_size=&#8221;full&#8221; onclick=&#8221;img_link_large&#8221;][/vc_column][/vc_row][vc_row][vc_column][vc_btn title=&#8221;CLIQUE AQUI E ACOMPANHE A LIVE&#8221; color=&#8221;danger&#8221; size=&#8221;lg&#8221; link=&#8221;url:https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DoujLegkcl-Q&#8221;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_row_inner][vc_column_inner][vc_single_image image=&#8221;6674&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column_inner][/vc_row_inner][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]25 de Agosto 2021 Cristiane de Paula – Ascom CINTESP.Br &nbsp; Redes Inteligentes, Redes Colaborativas, Smart grids, Tecnologia Assistiva, Tecnologia da Informação e muito mais. Nunca a inovação esteve tão presente e provocativa quanto nas últimas décadas e a Universidade Federal de Uberlândia (UFU), na condição de destaque nacional, já se preparava&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6669,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-6654",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6654",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6654",
                },
            ],
            "version-history": [
                {
                    count: 12,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6654/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6667,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6654/revisions/6667",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6669",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6654",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6654",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6654",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6644,
        date: "2021-08-22T22:02:09",
        date_gmt: "2021-08-23T01:02:09",
        guid: {
            rendered: "https://cintespbr.org/?p=6644",
        },
        modified: "2022-07-08T00:13:44",
        modified_gmt: "2022-07-08T03:13:44",
        slug: "cintesp-br-leva-kits-ludicos-pedagogicos-em-programa-social-em-praca-publica",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-leva-kits-ludicos-pedagogicos-em-programa-social-em-praca-publica/",
        title: {
            rendered:
                "CINTESP.Br® leva kits lúdicos pedagógicos em Programa social em praça pública",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column width=&#8221;1/6&#8243;][/vc_column][vc_column width=&#8221;4/6&#8243;][vc_column_text]</p>\n<div id="attachment_6645" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6645" class="wp-image-6645 size-large" src="https://cintespbr.org/wp-content/uploads/2021/08/Unisocial-1024x370.jpg" alt="" width="1024" height="370" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/08/Unisocial-1024x370.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/Unisocial-300x109.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/Unisocial-768x278.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/Unisocial-1536x556.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/Unisocial.jpg 1880w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-6645" class="wp-caption-text">Unisocial bairro Jardim Ipanema Uberlândia</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/6&#8243;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]15 agosto 2021</p>\n<p>Cristiane de Paula – Ascom CINTESP.Br</p>\n<p style="text-align: justify;">Desta vez a entrega do material lúdico pedagógico do Projeto CRESCER Caminhos da inclusão aconteceu em praça pública. Foi atendendo ao convite da Igreja Universal para ampliar as ações já desenvolvidas em mais de 5 anos de Campanha com o UNISOCIAL para oferecer atendimentos em saúde, esporte, lazer e cidadania em bairros de classe média baixa.</p>\n<p style="text-align: justify;">A Campanha aconteceu no bairro Jardim Ipanema região Leste de Uberlândia e pode ter atendido a quase mil famílias. Para apoiar a Ação o CINTESP.Br levou 250 kits. A distribuição foi feita pelos voluntários da Campanha que montaram um stand para divulgação do material. <strong>“É muito importante para nós termos esse material em nossas ações, aqui tem informações importantes para oferecer e garantir a acessibilidade e inclusão a todos, assim como das pessoas com deficiência de uma forma efetiva à população, no qual percebemos e atendemos que raramente tem acesso”, disse o pastor Jonas.</strong></p>\n<p style="text-align: justify;">O Projeto Caminhos da Inclusão integra ações para promover o     conhecimento e o despertar para a acessibilidade. Foi criado pela Secretaria de Articulação e Promoção da Ciência (SEAPC) sob a coordenação do Departamento de Articulação e Comunicação do Ministério da Ciência, Tecnologia e Inovação (MCTI) e por meio do CINTESP.Br os materiais são distribuídos às instituições não governamentais.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text][/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">O Projeto já atendeu este ano 8 instituições de finalidades diferentes em um total de cerca de 1500 famílias que poderão ser alcançadas. Os materiais são divididos em kits lúdicos educacionais formado por um exemplar do Livro “CRESCER”, revista das ações do MCTI em prol da ciência, tecnologia e inovação por um Brasil de qualidade, além de um livreto da história da semana nacional da ciência, tecnologia e inovação criado pelo MCTI para divulgar as inovações tecnológicas do Brasil e um folheto de conscientização sobre a importância da higienização e os cuidados para a proteção contra o COVID além de jogos infantis como um quebra cabeça.</p>\n<p style="text-align: justify;">O Projeto Unisocial é formado por grupos de ações específicas que contribuem por meio do auxílio material e, principalmente, do cuidado espiritual. São beneficiadas crianças, adolescentes, jovens e idosos, e também com doações de alimentos e brinquedos além de programas específicos voltados para hospitais e presídios. Também há prestação de serviços voluntários, como atendimento médico, odontológico e de enfermagem, e orientação de assistentes sociais, advogados e outros profissionais, o que torna a obra social e melhor qualidade de vida das pessoas.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column width=&#8221;1/6&#8243;][/vc_column][vc_column width=&#8221;4/6&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/6&#8243;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]15 agosto 2021 Cristiane de Paula – Ascom CINTESP.Br Desta vez a entrega do material lúdico pedagógico do Projeto CRESCER Caminhos da inclusão aconteceu em praça pública. Foi atendendo ao convite da Igreja Universal para ampliar as ações já desenvolvidas em mais de 5 anos de Campanha com o UNISOCIAL para&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6647,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-6644",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6644",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6644",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6644/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8064,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6644/revisions/8064",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6647",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6644",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6644",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6644",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6609,
        date: "2021-08-17T20:27:28",
        date_gmt: "2021-08-17T23:27:28",
        guid: {
            rendered: "https://cintespbr.org/?p=6609",
        },
        modified: "2022-07-08T00:15:56",
        modified_gmt: "2022-07-08T03:15:56",
        slug: "cintesp-br-se-destaca-na-universidade-federal-de-uberlandia-no-registro-de-novas-invencoes",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-br-se-destaca-na-universidade-federal-de-uberlandia-no-registro-de-novas-invencoes/",
        title: {
            rendered:
                "CINTESP.Br® se destaca na Universidade Federal de Uberlândia no registro de novas invenções.",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column]<div class="dt-fancy-separator h2-size accent-title-color" style="width: 100%;"><div class="dt-fancy-title"><span class="separator-holder separator-left"></span>CINTESP.Br® se destaca na Universidade Federal de Uberlândia no registro de novas invenções.<span class="separator-holder separator-right"></span></div></div>[vc_column_text]Cristiane de Paula – Ascom CINTESP.Br</p>\n<p>&nbsp;</p>\n<p style="text-align: justify;">O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos &#8211; CINTESP.Br® em Uberlândia, vem se destacando no registro de pedidos de patentes feitos pela Universidade Federal de Uberlândia. No ano passado o Centro fechou com no mínimo, uma nova invenção por mês. Nas últimas décadas, a condução das pesquisas ganhou novos caminhos impulsionados pela demanda em tecnologia assistiva (recursos e serviços que contribuem para proporcionar ou ampliar habilidades funcionais de pessoas com deficiência).</p>\n<p style="text-align: justify;">CINTESP.Br® possui um formato misto de atuação com profissionais e academia com alunos de graduação, de pós e de doutorado. Essa forma de atuação é baseada em rede colaborativa com instituições públicas e privadas onde o principal objetivo é o desenvolvimento de tecnologia assistiva nas áreas do esporte, saúde, lazer, educação e vida diária para aumentar a acessibilidade e melhorar a qualidade de vida para ampliar a inclusão de pessoas com deficiência e doenças raras. “Nesse formato de rede colaborativa podemos chegar a um menor tempo e menor custo de transferência destas tecnologias para a sociedade e para o setor produtivo ou articulado com os agentes socio econômicos como principal foco as classes sociais de baixa renda”, disse Cleudmar Araújo, diretor geral do CINTESP.Br®</p>\n<p style="text-align: justify;">As Instituições públicas de ensino superior no Brasil estão entre as maiores depositantes de patentes do país, mostrando o forte potencial destes Centros de Pesquisa universitários e de seus pesquisadores. Nesse caminho o CINTESP.Br/UFU se destaca pelo ritmo de novas invenções feitas por seus pesquisadores dentro da Universidade Federal de Uberlândia. Especialmente na área da tecnologia assistiva para favorecer a vida de pessoas com deficiência, pessoas com mobilidade reduzida e pessoas com doenças raras com a finalidade de resolver problemas de barreiras de acessibilidade e promover a inclusão social.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_masonry_media_grid element_width=&#8221;6&#8243; grid_id=&#8221;vc_gid:1657250144270-3ba9aa80-8b04-2&#8243; include=&#8221;5016,3278&#8243;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<h2><strong>HISTÓRIA DE CONQUISTAS</strong></h2>\n<p style="text-align: justify;">Para acompanhar essa tendência mundial, de inovação em tecnologia assistiva, em 2002 o Laboratório de Projetos Mecânicos Prof. Henner A. Gomide (LPM), sob a coordenação do professor Cleudmar Araújo, deu início ao direcionamento das pesquisas em Engenharia Biomecânica e tecnologia assistiva.</p>\n<p style="text-align: justify;">Com os resultados conquistados pelo novo planejamento a UFU criou em 2012 o “Núcleo de Habilitação e Reabilitação em Esportes Paralímpicos-NH/Resp em parceria com o MCTI e Centro Nacional de Referência em Tecnologia Assistiva (CNRTA).</p>\n<p style="text-align: justify;">Com essa nova perspectiva, o volume de trabalhos na área de tecnologia assistiva ganhou destaque nacional, o número de pedidos de patentes aumentou em mais de 100%.</p>\n<p style="text-align: justify;">Com o destaque dos trabalhos na área de inovação em tecnologia assistiva, por meio de um acordo de parceria técnica e científica com o Ministério de Ciência Tecnologia e Inovação (MCTI), o NH/Resp passou a ser um Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos – CINTESP.Br®. “O nosso principal foco é tentar resolver barreiras de acessibilidade de pessoas com deficiência e doenças raras por meio da inventividade e inovações de dispositivos e equipamentos. Também podemos, por exemplo, resolver um problema proporcionando novo uso de algo que já existe, isso é inovação”, disse Lucas Cardoso, pesquisador do CINTESP.Br®.</p>\n<p style="text-align: justify;">Com esse princípio, os pesquisadores do CINTESTP.Br® passaram a superar as barreiras da inclusão desenvolvendo dispositivos e equipamentos, por exemplo, para proporcionar maior rendimento aos paratletas brasileiros, atendendo demandas do Comitê Paralímpico Brasileiro. A produção de pesquisas subiu e o número de invenções registradas no Instituto Nacional de Propriedade Industrial (INPI), órgão do governo responsável por contabilizar títulos industriais mais que dobrou, de 6 solicitadas em 2018 para 14 pedidos protocolados no ano passado.</p>\n<p style="text-align: justify;">Atualmente, com cerca de 60 pesquisadores, o CINTESP.Br® tem 37 inventos depositados no INPI, em processo para serem convertidos em patentes. O mais recente deles, que passou por testes, foi o equipamento que permitirá a fabricação de cadeiras de rodas personalizadas a partir de informações individuais do cadeirante. O equipamento foi testado pelo paratleta campeão mineiro de Tênis em Cadeiras de Rodas Gustavo Carneiro. Além desse equipamento ainda existem outros já conhecidos por paratletas que vão participar das Paralimpíadas deste ano, que estão em fase final de fabricação para serem validados, como a calha paraolímpica, a cadeira de rodas para competições de velocidade, o elevador de piscina para transferência de paratletas e outros mais que estão sendo desenvolvidos para aumentar o rendimento nas competições e melhorar a vida de pessoas com deficiência e doenças raras quando estes equipamentos forem transferidos para uso geral da sociedade.</p>\n<p style="text-align: justify;">Além das pesquisas para atender o CPB, o CINTESP.Br® iniciou recentemente uma nova vertente de trabalhos para atender a sociedade, educação, lazer e vida diária. Com estas linhas de pesquisas, o CINTESP.Br® já reuniu outras 20 novas invenções de recursos lúdicos pedagógicos, de brinquedos e de equipamentos que promovem a ciência, a educação e a sustentabilidade no lazer e vida diária de pessoas com deficiência e doenças raras. Essa nova linha de atuação vem para atender a demanda do MCTI com um Projeto ligado à Secretaria de Articulação e Promoção da Ciência (SEAPC). “É necessário ainda vencer barreiras como custos, estimular empresas a investirem neste segmento e mais startups. Estamos focando no planejamento para que este formato de rede colaborativa para que essa tecnologia realmente chegue para essas pessoas e essa vai ser nossa luta aqui no CINTESP.Br®, concluiu o diretor</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/4&#8243;][vc_single_image image=&#8221;3142&#8243; img_size=&#8221;full&#8221;][/vc_column][vc_column width=&#8221;3/4&#8243; css=&#8221;.vc_custom_1629242715346{background-color: #7de5ed !important;}&#8221;][vc_column_text]“É necessário ainda vencer barreiras como custos, estimular empresas a investirem neste segmento e mais startups. Estamos focando no planejamento para que este formato de rede colaborativa para que essa tecnologia realmente chegue para essas pessoas e essa vai ser nossa luta aqui no CINTESP.Br®, concluiu o diretor[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text]Cristiane de Paula – Ascom CINTESP.Br &nbsp; O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos &#8211; CINTESP.Br® em Uberlândia, vem se destacando no registro de pedidos de patentes feitos pela Universidade Federal de Uberlândia. No ano passado o Centro fechou com no mínimo, uma nova invenção por mês. Nas últimas décadas, a&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6627,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-6609",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6609",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6609",
                },
            ],
            "version-history": [
                {
                    count: 18,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6609/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8066,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6609/revisions/8066",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6627",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6609",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6609",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6609",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6598,
        date: "2021-08-16T21:28:04",
        date_gmt: "2021-08-17T00:28:04",
        guid: {
            rendered: "https://cintespbr.org/?p=6598",
        },
        modified: "2021-12-27T23:02:11",
        modified_gmt: "2021-12-28T02:02:11",
        slug: "santa-casa-de-misericordia-de-araguari-recebe-do-cintesp-br-material-ludico-pedagogico-voltado-a-cultura-da-inclusao-em-acessibilidade",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/santa-casa-de-misericordia-de-araguari-recebe-do-cintesp-br-material-ludico-pedagogico-voltado-a-cultura-da-inclusao-em-acessibilidade/",
        title: {
            rendered:
                "Santa Casa de Misericórdia de Araguari recebe do CINTESP.Br® material lúdico pedagógico voltado à cultura da inclusão em acessibilidade",
        },
        content: {
            rendered:
                '<div id="attachment_6599" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6599" class="wp-image-6599 size-large" src="https://cintespbr.org/wp-content/uploads/2021/08/imgPost-1024x765.png" alt="" width="1024" height="765" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/08/imgPost-1024x765.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/imgPost-300x224.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/imgPost-768x573.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/imgPost-1536x1147.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/imgPost-2048x1529.png 2048w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-6599" class="wp-caption-text">Bruna Martins do Hospital Santa Casa recebendo os kits de Ana Sara Tomé, pesquisadora do CINTESP.Br®</p></div>\n<p>30 julho 2021</p>\n<p>Cristiane de Paula – Ascom CINTESP.Br</p>\n<p>&nbsp;</p>\n<p style="text-align: justify;">O Hospital Santa Casa de Misericórdia, da cidade de Araguari/MG, é a primeira instituição fora de Uberlândia a receber do CINTESP.Br os kits lúdicos pedagógicos do Projeto CRESCER – Caminhos da Inclusão. Foram entregues cerca de 250 kits para serem usados nos setores de atendimento do Hospital, especialmente na pediatria.</p>\n<p style="text-align: justify;">Caminhos da inclusão integra ações para promover o conhecimento e o despertar para a acessibilidade. Foi criado pela Secretaria de Articulação e Promoção da Ciência (SEAPC) sob a coordenação do Departamento de Articulação e Comunicação do Ministério da Ciência, Tecnologia e Inovação (MCTI) e por meio do CINTESP.Br os materiais são distribuídos às instituições não governamentais.</p>\n<p style="text-align: justify;">O Projeto já atendeu este ano 7 instituições de finalidades diferentes em um total de cerca de 1350 famílias que poderão serem alcançadas. Os materiais são divididos em kits lúdicos educacionais formado por um exemplar do Livro  “CRESCER”, revista das ações do MCTI em prol da ciência, tecnologia e inovação por um Brasil de qualidade, além de um livreto da história da semana nacional da ciência, tecnologia e inovação criado pelo MCTI para divulgar as inovações tecnológicas do Brasil e um folheto de conscientização sobre a importância da higienização e os cuidados para a proteção contra o COVID19 além de jogos infantis como um quebra cabeça.</p>\n<p style="text-align: justify;">A Santa Casa de Misericórdia de Araguari tem mais de cem anos de fundação, é uma instituição sem fins lucrativos referência no atendimento obstétrico e pediátrico na cidade. “Tão logo soubemos desse material distribuído pelo CINTESP.Br entramos em contato e vamos poder oferecer uma atividade muito atrativa dentro de nosso atendimento social famílias de nossos pacientes, é um material muito interessante”, disse Dr. Daniel Ferreira Moreira, ginecologista do Hospital.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>30 julho 2021 Cristiane de Paula – Ascom CINTESP.Br &nbsp; O Hospital Santa Casa de Misericórdia, da cidade de Araguari/MG, é a primeira instituição fora de Uberlândia a receber do CINTESP.Br os kits lúdicos pedagógicos do Projeto CRESCER – Caminhos da Inclusão. Foram entregues cerca de 250 kits para serem usados nos setores de atendimento&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6599,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-6598",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6598",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6598",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6598/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6628,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6598/revisions/6628",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6599",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6598",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6598",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6598",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6508,
        date: "2021-08-01T22:23:03",
        date_gmt: "2021-08-02T01:23:03",
        guid: {
            rendered: "https://cintespbr.org/?p=6508",
        },
        modified: "2021-12-27T23:02:11",
        modified_gmt: "2021-12-28T02:02:11",
        slug: "instituicao-com-mais-de-20-anos-em-uberlandia-ligada-a-rede-nacional-cristina-cavanis-recebe-material-do-projeto-caminhos-da-inclusao",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/instituicao-com-mais-de-20-anos-em-uberlandia-ligada-a-rede-nacional-cristina-cavanis-recebe-material-do-projeto-caminhos-da-inclusao/",
        title: {
            rendered:
                "Instituição com mais de 20 anos em Uberlândia, ligada à rede Nacional Cristina Cavanis, recebe material do Projeto Caminhos da Inclusão",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<div id="attachment_6509" style="width: 1187px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6509" class="wp-image-6509 size-full" src="https://cintespbr.org/wp-content/uploads/2021/08/introPost.png" alt="" width="1177" height="431" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/08/introPost.png 1177w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/introPost-300x110.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/introPost-1024x375.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/introPost-768x281.png 768w" sizes="(max-width: 1177px) 100vw, 1177px" /><p id="caption-attachment-6509" class="wp-caption-text">Entrega de kits Instituição Cristina Cavanis. Elaine Bragança, Prof. De Libras, Neiry Lane Guedes educadora social, Janete Machado assistente social, Daniela Fernandes Coord. Adm. e Ana Sara Tomé</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">O CINTESP.Br em Uberlândia tem levado o Programa CRESCER- Caminhos da Inclusão por diversas Escolas e Instituições não Governamentais. É uma iniciativa do Centro Nacional de Tecnologia (CNT) para ser uma ferramenta pedagógica e lúdica visa contribuir para a promoção da diversidade e inclusão em acessibilidade. O Programa integra ações da Secretaria de Articulação e Promoção da Ciência (SEAPC) sob a coordenação do Departamento de Articulação e Comunicação da SEAPC do Ministério da Ciência, Tecnologia e Inovação (MCTI).</p>\n<p style="text-align: justify;">Faz parte do Programa a distribuição de livros da edição CRESCER com exercícios e brinquedos de montar que levam a criança ao entendimento lúdico pedagógico, assim como o incentivo à leitura, como direito de todos através de brincadeiras e promove a percepção sob o olhar às diferenças e igualdade, assim como a cultura na rotina da criança. Além do livro que logo atrai a atenção das crianças, foram entregues materiais sobre as ações do MCTI em favor da ciência, tecnologia e inovação por um Brasil inclusivo, livros sobre a história da Semana Nacional da Ciência, Tecnologia e Inovação, materiais de conscientização sobre cuidados com a saúde e a proteção contra a COVID-19.</p>\n<p style="text-align: justify;">A entrega dos 250 kits lúdicos pedagógicos aconteceu, respeitando as normas de segurança de controle da COVID-19, durante uma das aulas do Projeto “Convivência” de reforço do Instituto Cristina Cavanis que existe há 21 anos em Uberlândia.  A Organização Não Governamental oferece atendimento educacional em contra turno para mais de 150 crianças de bairros da Região Sul da cidade, além de oferecer o “Serviço Coletivo Jovem Empregabilidade” que oferece apoio aos jovens na inserção no mercado de trabalho. “Quando vocês trazem este programa para a instituição sentimos inclusão e vamos levar para nossas crianças porque sabemos que esse material vai nos ajudar nesse trabalho de transformação de vidas, é com parceria que a instituição está aberta há mais de 21 anos aqui em Uberlândia”, disse Daniela Fernandes coordenadora administrativa da Instituição.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_6510" style="width: 1290px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6510" class="wp-image-6510 size-full" src="https://cintespbr.org/wp-content/uploads/2021/08/WhatsApp-Image-2021-07-28-at-16.27.50.jpeg" alt="" width="1280" height="958" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/08/WhatsApp-Image-2021-07-28-at-16.27.50.jpeg 1280w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/WhatsApp-Image-2021-07-28-at-16.27.50-300x225.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/WhatsApp-Image-2021-07-28-at-16.27.50-1024x766.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/WhatsApp-Image-2021-07-28-at-16.27.50-768x575.jpeg 768w" sizes="(max-width: 1280px) 100vw, 1280px" /><p id="caption-attachment-6510" class="wp-caption-text">Alunas da Instituição Cristina Cavanis</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_6511" style="width: 1042px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6511" class="wp-image-6511 size-full" src="https://cintespbr.org/wp-content/uploads/2021/08/WhatsApp-Image-2021-07-29-at-14.13.41.jpeg" alt="" width="1032" height="774" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/08/WhatsApp-Image-2021-07-29-at-14.13.41.jpeg 1032w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/WhatsApp-Image-2021-07-29-at-14.13.41-300x225.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/WhatsApp-Image-2021-07-29-at-14.13.41-1024x768.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/08/WhatsApp-Image-2021-07-29-at-14.13.41-768x576.jpeg 768w" sizes="(max-width: 1032px) 100vw, 1032px" /><p id="caption-attachment-6511" class="wp-caption-text">Elaine Bragança, Ana Sara e Marcel Moraes</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">Para a entrega na Instituição Cristina Cavanis o CINTESP.Br contou com a participação da pedagoga e professora de Libras, Elaine Cristina Barbosa de Paula Bragança, ela compartilhou um pouco de sua história, e a interação e comunicação com as crianças foram feitas em Língua Brasileira de Sinais – Libras, no qual foi traduzida pela Intérprete de Libras e pesquisadora do CINTESP.Br, Ana Sara Tomé.</p>\n<p style="text-align: justify;">“Fiquei extremamente feliz em participar desta ação, agradeço imensamente o convite, é de grande importância aproveitar todos os momentos para despertar e incentivar crianças e jovens e valorizar o seu potencial, pois, todos nós, cada um entender e respeitar às diferenças, podemos ter igualdade de convívio e despertar as crianças pela educação, assim vamos construir uma sociedade unida e de espaços e ações totalmente acessíveis, afirmou Elaine. A palestra despertou a atenção dos alunos e revelou a dedicação de Marcel Moraes, um jovem de 16 anos, aluno do ensino médio que faz reforço escolar na Instituição. Após a palestra Marcel foi buscar mais informações a respeito da Língua de Sinais e contou já conhecer um pouco da língua. Desde o início da pandemia tem se dedicado a estudar Libras e Francês pela internet. “Eu quero ser médico e preciso me especializar para atender todo tipo de paciente e achei incrível esse material”, disse Marcel.</p>\n<p style="text-align: justify;">O CINTESP.Br em Uberlândia iniciou a distribuição dos kits lúdicos pedagógicos por meio do Programa CRESCER, Caminhos da Inclusão em abril deste ano e já atendeu mais de 600 crianças por meio de Escolas e Instituições assistenciais da cidade. Hoje, nesta entrega ficamos emocionados com a iniciativa espontânea do Marcel, um jovem de classe média baixa que busca sozinho, estudar e aprender Libras gratuitamente pela internet. Aí sim percebemos que estamos no caminho certo e ainda temos muito que fazer, isso motiva para ações de fortalecimento educacional e social do Programa que o CINTESP.Br no qual vem distribuindo para nossa sociedade. “Foi excepcional a interação do jovem Marcel, onde em conversa com a professora de Libras Elaine Bragança, apresentou a datilologia de alguns sinais que aprendeu em Libras”, disse Ana Sara Tomé, pesquisadora do CINTESP.Br na área de educação inclusiva.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text] O CINTESP.Br em Uberlândia tem levado o Programa CRESCER- Caminhos da Inclusão por diversas Escolas e Instituições não Governamentais. É uma iniciativa do Centro Nacional de Tecnologia (CNT) para ser uma ferramenta pedagógica e lúdica visa contribuir para a promoção da diversidade e inclusão em acessibilidade. O Programa integra ações da Secretaria de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6513,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-6508",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6508",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6508",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6508/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6514,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6508/revisions/6514",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6513",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6508",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6508",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6508",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6495,
        date: "2021-07-27T11:03:14",
        date_gmt: "2021-07-27T14:03:14",
        guid: {
            rendered: "https://cintespbr.org/?p=6495",
        },
        modified: "2021-12-27T23:04:38",
        modified_gmt: "2021-12-28T02:04:38",
        slug: "crescer-caminhos-da-inclusao-criado-pelo-centro-nacional-de-tecnologias-e-implementado-pelo-cintesp-br-e-recebido-por-instituicao-de-apoio-a-adocao-em-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/crescer-caminhos-da-inclusao-criado-pelo-centro-nacional-de-tecnologias-e-implementado-pelo-cintesp-br-e-recebido-por-instituicao-de-apoio-a-adocao-em-uberlandia/",
        title: {
            rendered:
                "CRESCER &#8211; Caminhos da Inclusão criado pelo Centro Nacional de Tecnologias e implementado pelo CINTESP.Br é recebido por Instituição de apoio a adoção em Uberlândia.",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<div id="attachment_6496" style="width: 1815px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6496" class="wp-image-6496 size-full" src="https://cintespbr.org/wp-content/uploads/2021/07/entrega-de-kits.png" alt="" width="1805" height="657" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/entrega-de-kits.png 1805w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/entrega-de-kits-300x109.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/entrega-de-kits-1024x373.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/entrega-de-kits-768x280.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/entrega-de-kits-1536x559.png 1536w" sizes="(max-width: 1805px) 100vw, 1805px" /><p id="caption-attachment-6496" class="wp-caption-text">Ana Sara Tomé, pesquisadora do CINTESP.Br® e Fernanda Nascimento Silveira coordenadora de projetos da Pontes de Amor</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]23 julho 2021</p>\n<p>Cristiane de Paula – Ascom CINTESP.Br®</p>\n<p>&nbsp;</p>\n<p style="text-align: justify;">Oferecer material lúdico pedagógico promovendo a cultura da inclusão por meio da educação, este é um dos objetivos do Projeto Caminhos da Inclusão, de iniciativa e estruturado pelo CNT, (Centro Nacional de Tecnologias para Pessoas com Deficiência e Doenças Raras). O CINTESP.Br®, em Uberlândia, executa o Programa levando os materiais lúdicos pedagógicos e brinquedos educativos até às Escolas e Instituições sem fins lucrativos que desenvolvem ações sociais e protetivas às famílias e crianças de baixa renda. Caminhos da Inclusão foi criado, este ano, pelo CNT, uma iniciativa que faz parte das ações da Secretaria de Articulação e Promoção da Ciência (SEAPC) O Programa é coordenado pelo Diretor Carlos Rogério Antunes da Silva do Departamento de Articulação e Comunicação da SEAPC do Ministério da Ciência, Tecnologia e Inovação (MCTI).</p>\n<p style="text-align: justify;">Desta vez, o Programa ampliou o perfil do público atendido, a entrega dos materiais lúdicos pedagógicos foi feita à Organização Filantrópica sem fins lucrativos Pontes de Amor, que atua junto à Vara da Infância e da Juventude, Órgãos e Conselhos de Direito da Criança e do Adolescente. “Nós trabalhamos nos processos de apoio e de habilitação junto aos pais que buscam adotar uma criança e também atuamos no apoio à nova composição familiar, damos nos processos de pós adoção com acompanhamento educacional e psicológico e toda a ferramenta, como estas que estamos recebendo hoje, tem importância no processo educacional para ampliar o entendimento de inclusão e vamos trabalhar estes materiais dos kits com nossas crianças”, disse Fernanda  Nascimento Silveira coordenadora de projetos da Pontes de Amor.</p>\n<p style="text-align: justify;">O Programa Caminhos da Inclusão distribuiu o primeiro volume do livro CRESCER que apresenta histórias para despertar na criança conceitos como: igualdade, acessibilidade, inclusão, respeito e tecnologia assistiva, interagindo com as diversidades inerentes de cada criança. O material do Programa foi entregue pela pesquisadora do CINTESP.Br® dos Programas Sociais Ana Sara Tomé, “o trabalho feito pela Instituição Pontes do Amor é muito importante para o fortalecimento de novos laços familiares e divulgar o que é feito aqui também faz parte de nossas ações que passam a acontecer quando recebemos das Instituições as intenções de participar de nossos Programas sociais, como o Caminhos da Inclusão”, disse a pesquisadora Ana Sara.</p>\n<p style="text-align: justify;"> Foram ao todo 100 kits, além do livro CRESCER também foi entregue material sobre as ações do MCTI em favor da ciência, tecnologia e inovação por um Brasil inclusivo, um livro da história da Semana Nacional da Ciência, Tecnologia e Inovação, materiais de conscientização sobre cuidados com a higienização e a proteção contra a COVID-19 e jogos infantis como um quebra cabeça e materiais de montar.</p>\n<p style="text-align: justify;">A instituição Pontes de Amor trabalha com 4 instituições e atualmente 50 famílias são acompanhadas. O trabalho desenvolvido pela Organização é filiada à Associação Nacional dos Grupos de Apoio à Adoção (ANGAAD) e tem reconhecimento internacional</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]23 julho 2021 Cristiane de Paula – Ascom CINTESP.Br® &nbsp; Oferecer material lúdico pedagógico promovendo a cultura da inclusão por meio da educação, este é um dos objetivos do Projeto Caminhos da Inclusão, de iniciativa e estruturado pelo CNT, (Centro Nacional de Tecnologias para Pessoas com Deficiência e Doenças Raras). O CINTESP.Br®, em Uberlândia,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6497,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-6495",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6495",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6495",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6495/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6498,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6495/revisions/6498",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6497",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6495",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6495",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6495",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6436,
        date: "2021-07-22T00:09:03",
        date_gmt: "2021-07-22T03:09:03",
        guid: {
            rendered: "https://cintespbr.org/?p=6436",
        },
        modified: "2022-07-08T00:17:28",
        modified_gmt: "2022-07-08T03:17:28",
        slug: "o-programa-de-distribuicao-de-kits-ludicos-pedagogicos-do-cnt-chega-a-uma-escola-municipal-de-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/o-programa-de-distribuicao-de-kits-ludicos-pedagogicos-do-cnt-chega-a-uma-escola-municipal-de-uberlandia/",
        title: {
            rendered:
                "O Programa de distribuição de kits lúdicos pedagógicos do CNT chega a uma Escola Municipal de Uberlândia",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<div id="attachment_6437" style="width: 1216px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6437" class="wp-image-6437 size-full" src="https://cintespbr.org/wp-content/uploads/2021/07/img-Post.png" alt="" width="1206" height="334" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/img-Post.png 1206w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/img-Post-300x83.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/img-Post-1024x284.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/img-Post-768x213.png 768w" sizes="(max-width: 1206px) 100vw, 1206px" /><p id="caption-attachment-6437" class="wp-caption-text">Diretora Simone Silveira da Escola Municipal Prof. Milton de Magalhães Porto, e professoras Fernanda Soares Faria e Maria de Lourdes Nunes com pesquisadora Ana Sara Tomé dos Programas Sociais do CNT</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p>21 julho 2021</p>\n<p>Texto Cristiane de Paula – Ascom Cinstesp.br®</p>\n<p>&nbsp;</p>\n<p style="text-align: justify;">Desta vez o Programa Caminhos da Inclusão do CNT (Centro Nacional de Tecnologias para Pessoas com Deficiência e Doenças Raras) “Caminhos da Inclusão” chegou à uma escola pública, a Professor Milton de Magalhães Porto, da Rede Municipal de Uberlândia.</p>\n<p style="text-align: justify;">Na Escola Municipal Milton de Magalhães Porto foram entregues 250 kits lúdicos educacionais, a pesquisadora do CINTESP.Br®, dos Programas Sociais do CNT, Ana Sara Tomé, falou em reunião com a direção e professores da educação especial sobre as diversas ações apoiadas pelo Programa Caminhos da Inclusão, entre eles as Olimpíadas do Conhecimento promovidas pelo MCTI e a Gincana 1º Desafio &#8220;Ideias Brilhantes&#8221; Tecnologia Assistiva para a Vida Diária voltado para estudantes do ensino fundamental dois, do 6º ao 9º ano, de escolas de todo Brasil, programas apresentados no site do MCTI. O projeto contará com apoio das instituições vinculadas ao Ministério da Ciência, Tecnologia e Inovações e de colaboradores que por meio de palestras e premiações contribuirão para a medida.</p>\n<p style="text-align: justify;">“Estamos muito felizes de recebermos esse material e essas formas de incentivo como os Programas do Ministério a respeito da inclusão e da acessibilidade vamos repassar para nossos alunos, aqui temos cerca de 750 crianças e já até estamos pensando em propor um desafio aos professores de criarmos um livro da Escola com o trabalho dos alunos sobre o que entenderem desse material, é muito bom promover essa cultura de inclusão já nos primeiros anos de escola”, disse a diretora Simone Silveira.</p>\n<p style="text-align: justify;">“Caminhos da Inclusão” foi criado há 3 meses e já envolveu mais de 500 crianças na cultura da inclusão por meio da educação. O Programa do CNT é desenvolvido por meio do CINTESP.Br®, em Uberlândia e faz parte das ações da Secretaria de Articulação e Promoção da Ciência (SEAPC), coordenado pelo Diretor Carlos Rogério Antunes da Silva do Departamento de Articulação e Comunicação da SEAPC do Ministério da Ciência, Tecnologia e Inovação (MCTI).</p>\n<p style="text-align: justify;">O Programa compreende em distribuir o primeiro volume do livro CRESCER que apresenta, histórias para despertar na criança conceitos como igualdade, acessibilidade, inclusão, respeito e tecnologia assistiva, interagindo com as diversidades inerentes de cada criança. Também foi entregue material sobre as ações do MCTI em favor da ciência, tecnologia e inovação por um Brasil inclusivo, um livro da história da Semana Nacional da Ciência, Tecnologia e Inovação, materiais de conscientização sobre cuidados com a higienização e a proteção contra a COVID-19 e jogos infantis como um quebra cabeça e materiais de montar.</p>\n<p style="text-align: justify;">A Escola Professor Milton de Magalhães Porto está em funcionamento há mais de 20 anos, faz parte da Rede Pública Municipal de Uberlândia e trabalha os conceitos de acessibilidade, empreendedorismo e sustentabilidade, foi a primeira escola pública no Brasil a receber do Greenpeace equipamento fotovoltaico para geração de energia solar.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_6441" style="width: 739px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6441" class="wp-image-6441" src="https://cintespbr.org/wp-content/uploads/2021/07/img_entrega2.png" alt="" width="729" height="500" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/img_entrega2.png 1243w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/img_entrega2-300x206.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/img_entrega2-1024x703.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/img_entrega2-768x527.png 768w" sizes="(max-width: 729px) 100vw, 729px" /><p id="caption-attachment-6441" class="wp-caption-text">“Todas as crianças podem ser felizes seja ela deficiente ou não, e que devemos tratar todos iguais, porque não posso fazer com o outro o que eu não quero que faça comigo”, disse Helena Santana Costa 8 anos, aluna do 3º ano do fundamental e a pintura feita em um dos trabalhos da revista CRESCER</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/4&#8243;][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text] 21 julho 2021 Texto Cristiane de Paula – Ascom Cinstesp.br® &nbsp; Desta vez o Programa Caminhos da Inclusão do CNT (Centro Nacional de Tecnologias para Pessoas com Deficiência e Doenças Raras) “Caminhos da Inclusão” chegou à uma escola pública, a Professor Milton de Magalhães Porto, da Rede Municipal de Uberlândia. Na Escola Municipal&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6452,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-6436",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6436",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6436",
                },
            ],
            "version-history": [
                {
                    count: 14,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6436/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8067,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6436/revisions/8067",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6452",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6436",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6436",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6436",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6434,
        date: "2021-07-20T23:08:27",
        date_gmt: "2021-07-21T02:08:27",
        guid: {
            rendered: "https://cintespbr.org/?p=6434",
        },
        modified: "2022-05-18T15:34:00",
        modified_gmt: "2022-05-18T18:34:00",
        slug: "desafio-ideias-brilhantes-mcti",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/desafio-ideias-brilhantes-mcti/",
        title: {
            rendered: "DESAFIO IDÉIAS BRILHANTES MCTI",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="alignnone wp-image-6432 size-full" src="https://cintespbr.org/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-21-at-12.45.33.jpeg" alt="" width="768" height="438" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-21-at-12.45.33.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-21-at-12.45.33-300x171.jpeg 300w" sizes="(max-width: 768px) 100vw, 768px" /></p>\n<p style="text-align: justify;">O ministro da Ciência, Tecnologia e Inovações, astronauta Marcos Pontes, vai anunciar nesta terça-feira (20) um projeto que tem o objetivo de melhorar as habilidades das crianças em Tecnologia Assistiva. A proposta também quer realizar a conscientização da inclusão social e produtiva por meio da realização de competições. O 1º Desafio &#8220;Ideias Brilhantes&#8221; MCTI, Tecnologia Assistiva para a Vida Diária é uma iniciativa do Ministério criada pela Secretaria de Articulação e Promoção da Ciência (SEAPC) em parceria com instituições de ensino públicas e privadas de todo país. Quem quiser saber mais sobre o assunto deve acessar o link <a class="external-link" href="https://www.sympla.com.br/1-desafio-ideias-brilhantes-mcti---tecnologia-assistiva-para-a-vida-diaria__1287577" target="_blank" rel="noopener" data-tippreview-enabled="true" data-tippreview-image="" data-tippreview-title="" data-tippy="">https://www.sympla.com.br/1-desafio-ideias-brilhantes-mcti&#8212;tecnologia-assistiva-para-a-vida-diaria__1287577 </a>com informações adicionais.</p>\n<p>Saiba mais clicando <a href="https://www.gov.br/mcti/pt-br/acompanhe-o-mcti/noticias/2021/07/ministro-anuncia-hoje-programa-de-incentivo-a-tecnologia-assistiva-para-criancas">AQUI</a></p>\n<p>FONTE: www.gov.br/mcti</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O ministro da Ciência, Tecnologia e Inovações, astronauta Marcos Pontes, vai anunciar nesta terça-feira (20) um projeto que tem o objetivo de melhorar as habilidades das crianças em Tecnologia Assistiva. A proposta também quer realizar a conscientização da inclusão social e produtiva por meio da realização de competições. O 1º Desafio &#8220;Ideias Brilhantes&#8221; MCTI, Tecnologia&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6432,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-6434",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6434",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6434",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6434/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6435,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6434/revisions/6435",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6432",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6434",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6434",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6434",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6334,
        date: "2021-07-06T21:42:55",
        date_gmt: "2021-07-07T00:42:55",
        guid: {
            rendered: "https://cintespbr.org/?p=6334",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "uberlandia-envia-a-maior-delegacao-de-atletas-de-todos-os-tempos-para-competir-em-paraolimpiadas",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/uberlandia-envia-a-maior-delegacao-de-atletas-de-todos-os-tempos-para-competir-em-paraolimpiadas/",
        title: {
            rendered:
                "Uberlândia envia a maior delegação de atletas de todos os tempos para competir em Paraolimpíadas",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;6336&#8243; img_size=&#8221;full&#8221;][vc_column_text]Imagens: rede social CPB[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;6338&#8243; img_size=&#8221;full&#8221;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Cristiane de Paula- jornalista CINTESP.Br</p>\n<p>06/07/2021</p>\n<p style="text-align: justify;">Uberlândia manteve a tradição de cidade do interior que investe e apoia o paraesporte, superamos o número de paratletas que participaram dos últimos Jogos Paralímpicos.</p>\n<p style="text-align: justify;">Na lista de convocados para os Jogos Paraolímpicos do Japão, estão 10 paratletas de Uberlândia representando em 5 modalidades, natação é nossa maior equipe. Nos Jogos de 2016, no Rio de Janeiro foram 8 convocados.</p>\n<p style="text-align: justify;">A divulgação da lista foi transmitida ao vivo pelas Redes Sociais do Comitê paralímpico Brasileiro (CPB).  Estiveram presentes Mizael Conrado, presidente do Comitê Paralímpico Brasileiro, Yohanssem Nascimento vice-presidente do CPB, Alberto Martins diretor técnico do CPB e Tai Lopes do setor de comunicação do CPB.</p>\n<p style="text-align: justify;">Na bocha adaptada o convocado para as Paraolimpíadas de Tóquio é o atleta Mateus Carvalho que tem medalhas de ouro e bronze dos Jogos Parapan-Americanos de 2019. No halterofilismo será Lara Aparecida Lima ela é a sexta colocada no ranking paraolímpico, até 41kg, ambos do Clube Desportivo para Deficientes de Uberlândia (CDDU) e com apoio da FUTEL. Gustavo Carneiro também foi convocado para as competições de tênis de quadra em cadeira de rodas, ele é o 41º no ranking mundial. No paratletismo já era esperada a convocação de Rodrigo Parreira da Associação dos paraplégicos de Uberlândia – APARU, ele que é o 6º no ranking Mundial no salto à distância e vai para a segunda participação em Jogos Paralímpicos, em 2016 Rodrigo conseguiu medalhas de Prata em salto à distância e Bronze nos 100 metros rasos.</p>\n<p style="text-align: justify;">A maior equipe da delegação de Uberlândia será a da natação, foram classificados 6 paratletas, todos do Praia Clube e com estreias que se destacaram nas últimas competições quebrando recordes mundiais, como é o caso do paratleta nadador Gabriel Bandeira recorde das Américas nos 100m peito, ainda fazem parte da equipe de natação os paratletas Gabriel Melone de Oliveira, João Pedro Brutos de Oliveira, Laila Suzigan Abate, Ruan Felipe Lima de Souza, Vanilton Antônio do Nascimento Filho.</p>\n<p style="text-align: left;">As Paraolimpíadas 2021 será realizada no Japão entre 24 de agosto a 05 de setembro. Uberlândia mandará representantes nas modalidades de bocha adaptada, halteres, tênis de campo e natação.</p>\n<p style="text-align: justify;">A convocação de hoje foi considerada a mais esperada de todos os tempos, já que os Jogos Paralímpicos no Japão deveriam ter acontecido no ano passado, mas foram adiados por causa da pandemia. Essa convocação apresentou características de superação, como por exemplo na renovação, do total de 231 paratletas, 86 estarão estreando em Jogos internacionais e com 2 paratletas sendo os mais jovens convocados até hoje, entre eles o João Pedro Brutos de 17 anos, nadador do Praia Clube.</p>\n<p style="text-align: justify;">No balanço geral, o presidente do CPB considerou ainda que essa convocação pode ser chamada de “convocação da superação”, superando todas as expectativas e atingindo metas, como a de garantir maior participação feminina e maior participação de paratletas de classe econômica considerada de baixa renda. “Podemos comprovar, nessa convocação, nosso compromisso de inclusão por meio do esporte, para chegar até aqui houve muito esforço, suor e muita preparação. Esperamos ainda que estes Jogos sejam a alavanca que representará a recuperação de nossos povos já que o esporte significa resiliência e autoestima e que esse grande evento possa contribuir para o ressurgimento, inclusive da economia de nossa sociedade”, disse Mizael Conrado pres. Do CPB</p>\n<p>[/vc_column_text][ultimate_heading main_heading=&#8221;VAMOS TORCER PELOS NOSSOS PARATLETAS E APOIAR O PARAESPORTE&#8221;]</p>\n<h3>CINTESP.Br® APOIA CPB</h3>\n<p>[/ultimate_heading][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/3&#8243;][vc_column_text]</p>\n<div id="attachment_6335" style="width: 242px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6335" class="wp-image-6335 size-medium" src="https://cintespbr.org/wp-content/uploads/2021/07/dest-232x300.png" alt="" width="232" height="300" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/dest-232x300.png 232w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/dest-791x1024.png 791w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/dest-768x994.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/dest-1187x1536.png 1187w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/dest.png 1266w" sizes="(max-width: 232px) 100vw, 232px" /><p id="caption-attachment-6335" class="wp-caption-text">Gustavo Carneiro, no CINTESP.Br® em teste de equipamento para fabricação de cadeira de rodas personalizada</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;2/3&#8243;][vc_column_text]</p>\n<div id="attachment_6337" style="width: 621px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6337" class="wp-image-6337 size-full" src="https://cintespbr.org/wp-content/uploads/2021/07/prototipoparatleta2.jpg" alt="" width="611" height="344" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/prototipoparatleta2.jpg 611w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/prototipoparatleta2-300x169.jpg 300w" sizes="(max-width: 611px) 100vw, 611px" /><p id="caption-attachment-6337" class="wp-caption-text">Protótipo de cadeira de rodas para corrida desenvolvido pelo CINTESP.Br®</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">Neste sentido o Centro Brasileiro de Referência em Inovações Tecnológicas para o Esporte Paralímpico (CINTESP.Br®), vinculado à Universidade Federal de Uberlândia/UFU, criado por uma iniciativa do Ministério de Ciência Tecnologia e Inovação (MCTI), em apoio ao Comitê Paralímpico Brasileiro (CPB) e as pessoas com deficiência se destaca em pesquisas voltadas à tecnologia assistiva e desenvolve equipamentos para oferecer alto rendimento aos paratletas. Como por exemplo o equipamento para fabricação personalizada de cadeira de rodas que foi testado pelo tenista paratleta Gustavo Carneiro. O equipamento permitirá a personalização de diferentes modelos e configurações de cadeiras de rodas, atendendo corretamente as necessidades do usuário, permitindo que ele tenha o maior benefício possível, melhorando a sua qualidade de vida para pessoas com deficiência e mais rendimentos para os paratletas. Outro equipamento desenvolvido pelo CINTESP.Br® foi a cadeira de rodas para corrida, protótipo validado pelo Paratleta do Comitê Paralímpico Brasileiro Ariosvaldo Fernandes, conhecido por Parré.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;6336&#8243; img_size=&#8221;full&#8221;][vc_column_text]Imagens: rede social CPB[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;6338&#8243; img_size=&#8221;full&#8221;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Cristiane de Paula- jornalista CINTESP.Br 06/07/2021 Uberlândia manteve a tradição de cidade do interior que investe e apoia o paraesporte, superamos o número de paratletas que participaram dos últimos Jogos Paralímpicos. Na lista de convocados para os Jogos Paraolímpicos do Japão, estão 10 paratletas de Uberlândia&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6357,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-6334",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6334",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6334",
                },
            ],
            "version-history": [
                {
                    count: 19,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6334/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6358,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6334/revisions/6358",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6357",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6334",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6334",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6334",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6360,
        date: "2021-07-05T22:03:42",
        date_gmt: "2021-07-06T01:03:42",
        guid: {
            rendered: "https://cintespbr.org/?p=6360",
        },
        modified: "2021-12-27T23:02:11",
        modified_gmt: "2021-12-28T02:02:11",
        slug: "ministerio-da-ciencia-tecnologia-e-inovacao-e-cintesp-br-participam-de-apresentacao-em-rede-colaborativa-cultural-em-instituicao-de-ensino-de-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ministerio-da-ciencia-tecnologia-e-inovacao-e-cintesp-br-participam-de-apresentacao-em-rede-colaborativa-cultural-em-instituicao-de-ensino-de-uberlandia/",
        title: {
            rendered:
                "Ministério da Ciência Tecnologia e Inovação e CINTESP.BR® participam de Apresentação em Rede Colaborativa Cultural em Instituição de Ensino de Uberlândia",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_6364" style="width: 310px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6364" class="wp-image-6364 size-medium" src="https://cintespbr.org/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-04-at-13.11.39-300x240.jpeg" alt="" width="300" height="240" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-04-at-13.11.39-300x240.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-04-at-13.11.39.jpeg 720w" sizes="(max-width: 300px) 100vw, 300px" /><p id="caption-attachment-6364" class="wp-caption-text">Entrega de kits pela Miriene Macedo, Pres.do Instituto Educacional Germinare/ Escola</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_6363" style="width: 310px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6363" class="wp-image-6363 size-medium" src="https://cintespbr.org/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-04-at-13.11.37-300x240.jpeg" alt="" width="300" height="240" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-04-at-13.11.37-300x240.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-04-at-13.11.37.jpeg 720w" sizes="(max-width: 300px) 100vw, 300px" /><p id="caption-attachment-6363" class="wp-caption-text">“Clovin” Autor do Projeto do Instituto Saúde &amp; Equilíbrio</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">Em Rede Cultural e colaborativa com Circo leitura e Arte, foi desta forma que o Cintesp.Br® participou do encerramento das atividades pedagógicas do primeiro semestre 2021 no Complexo Educacional Ameduca, em Uberlândia.</p>\n<p style="text-align: justify;">A participação do Cintesp.Br® foi por meio do Programa de Ação Social do Centro Nacional de Tecnologia-CNT, Caminhos da Inclusão na educação e patrocínio do Ministério da Ciência, Tecnologia e Inovação – MCTI Secretaria de Articulação e Promoção da Ciência – SEAPC, Carlos Rogério Antunes da Silva &#8211; Diretor do Departamento de Articulação e Comunicação – SEAPC.</p>\n<p>Para colaborar com as atividades, foram distribuídos 100 kits lúdicos pedagógicos em um total de 500 itens, entre eles um exemplar do Livro “Caminhos da inclusão” “CRESCER”, direcionando ao conhecimento da ciência, fortalecimento cultural e social das crianças, bem como a tecnologia com vistas à educação, saúde, inovação, por meio do incentivo à leitura, brinquedos lúdicos, direcionados às crianças e jovens atendidas através dos programas assistenciais da Instituição.[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_6366" style="width: 310px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6366" class="wp-image-6366 size-medium" src="https://cintespbr.org/wp-content/uploads/2021/07/imagem3-300x216.png" alt="" width="300" height="216" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/imagem3-300x216.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/imagem3.png 538w" sizes="(max-width: 300px) 100vw, 300px" /><p id="caption-attachment-6366" class="wp-caption-text">Crianças recebendo kits lúdicos pedagógicos</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_6367" style="width: 310px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6367" class="wp-image-6367 size-medium" src="https://cintespbr.org/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-04-at-13.11.37-1-300x240.jpeg" alt="" width="300" height="240" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-04-at-13.11.37-1-300x240.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-04-at-13.11.37-1.jpeg 720w" sizes="(max-width: 300px) 100vw, 300px" /><p id="caption-attachment-6367" class="wp-caption-text">Apresentação Clovin / bike free stile</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">A apresentação cultural ficou por conta do Instituto Saúde &amp; Equilíbrio de autoria do ciclista, palestrante e gestor Clóvison Elberth Alves Gonçalves- Clovin. O Instituto Saúde &amp; Equilíbrio completou 15 anos se apresentando em 63 cidades as apresentações mesclam, por meio de Rede Colaborativa, oficinas culturais por meio de projetos, malabarismo, artes circenses em escolas e instituições com apresentações e palestras itinerantes. Com o Projeto Circo na Escola, une didática com atrações lúdicas de cunho educacional. “Nós acreditamos que através da arte, da cultura e do lúdico ajudamos crianças a se tornarem melhores seres humanos, se perceberem melhores, na nossa arte com modalidades livres quem tem deficiência é que se torna campeão”, disse Clovin.</p>\n<p style="text-align: justify;">Com o Programa Ação Social Caminhos da Inclusão do CNT, a Secretaria de Articulação e Promoção da Ciência do MCTI fortalece a educação como principal eixo para o verdadeiro caminho para inclusão, socialização das crianças, tal como na saúde, garantindo mais qualidade de vida. O fortalecimento das ações sociais por intermédio da rede colaborativa, fortifica o processo educacional e ações sociais da instituição. Assim, o projeto visa levar a conscientização às pessoas ao verdadeiro caminho da inclusão e propõe contribuir para arte e cultura e educação e o pleno desenvolvimento socioemocional das crianças, levando conhecimento sobre respeito à diversidade com equidade a todas as diferenças humanas, tal como das pessoas com deficiência e doenças raras. Desse modo, a participação de Escolas e Instituições se dão por meio de convites que propõe o fortalecimento de ações afirmativas ao pleno crescimento de crianças e jovens. “São 23 anos de AMEDUCA, trabalhando com as diferenças humanas e nós acreditamos que estes momentos de diversificação cultural trazem para as crianças a fortalecerem a interação e romper barreiras, e com a pandemia eles não podem interagir, mas o social, o artístico e o cultural traz vida para a Escola, por isso essas parcerias são importantes”, completa Haline Oliveira, diretora Escolar.</p>\n<p>A escola Ameduca em Uberlândia é mantida pelo Instituto Educacional Germinare, formada por um complexo Educacional com o objetivo de trabalhar por uma sociedade mais solidária, propõe por meio de ações estimular o desenvolvimento didático-pedagógico de crianças, propondo o crescimento intelectual, pessoal, social e afetivo bem como o estímulo de criança ao desenvolvimento dos valores humanos e sociais.[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text] Em Rede Cultural e colaborativa com Circo leitura e Arte, foi desta forma que o Cintesp.Br® participou do encerramento das atividades pedagógicas do primeiro semestre 2021 no Complexo Educacional Ameduca, em Uberlândia. A participação do Cintesp.Br® foi por meio do Programa de Ação Social do Centro Nacional de Tecnologia-CNT, Caminhos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6371,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-6360",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6360",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6360",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6360/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6369,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6360/revisions/6369",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6371",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6360",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6360",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6360",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6329,
        date: "2021-07-01T13:17:56",
        date_gmt: "2021-07-01T16:17:56",
        guid: {
            rendered: "https://cintespbr.org/?p=6329",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "divulgado-o-poster-oficial-da-paralimpiada-de-toquio",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/divulgado-o-poster-oficial-da-paralimpiada-de-toquio/",
        title: {
            rendered: "Divulgado o Pôster Oficial da Paralimpíada de Tóquio.",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="alignnone wp-image-6330 size-large" src="https://cintespbr.org/wp-content/uploads/2021/07/WhatsApp-Image-2021-06-23-at-13.32.14-1024x626.jpeg" alt="" width="1024" height="626" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-06-23-at-13.32.14-1024x626.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-06-23-at-13.32.14-300x183.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-06-23-at-13.32.14-768x469.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-06-23-at-13.32.14.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><strong>Esta é a primeira vez que um pôster separado é selecionado para os Jogos Paraolímpicos.</strong></p>\n<p style="text-align: justify;">O pôster que será usado para simbolizar e promover os Jogos Paraolímpicos foi selecionado pelo Comitê Paraolímpico Internacional (IPC). A arte para o cartaz foi criada pela unidade de design gráfico Goo Choki Par e apresentada pelos Organizadores das Paralimpíadas junto com outras 20 propostas que concorriam no processo de seleção.</p>\n<p style="text-align: justify;">Esta foi a primeira vez que se dedica um tema exclusivamente para representar os Jogos Paralímpicos.</p>\n<p style="text-align: justify;">As Paralimpíadas serão realizadas no Japão de 24 de agosto a 5 de setembro.</p>\n<p style="text-align: justify;"> O pôster ficará em exibição no Museu Olímpico do Japão, em Tóquio, até 5 de setembro e a imagem será utilizada em produtos para recordação dos Jogos.</p>\n<p style="text-align: justify;"><strong>Os primeiros Jogos</strong></p>\n<p style="text-align: justify;">Os Jogos Paralímpicos foram criados após a Segunda Grande Guerra, tem origem em Stoke Mandeville, na Inglaterra, mas só foram realizados em 1960 em Roma, na Itália. As primeiras competições esportivas, para deficientes físicos, surgiram como forma de reabilitar militares feridos na Segunda Guerra Mundial.</p>\n<p style="text-align: justify;">A idéia partiu do neurologista alemão, de origem judaica, Ludwig Guttmann. Ele observou que, antes da Segunda Guerra, os deficientes eram tidos como pessoas de vidas de curta duração e de má qualidade, não havendo grandes esforços para reabilitar deficientes físicos.</p>\n<p style="text-align: justify;">Guttmann iniciou uma forma de mudar essa realidade unindo trabalho e esporte em sua filosofia de tratamento de seus pacientes. As primeiras modalidades foram:  o basquetebol, o tiro com arco, os dardos e o bilhar para auxiliar no tratamento. E com a recuperação de veteranos de guerra ele conseguiu chamar a atenção e motivou cada vez mais a adaptação de esportes e sua prática.</p>\n<p style="text-align: justify;">Até que em 1943, o Governo britânico colocou Guttmann para chefiar o Centro Nacional de Traumatismos, em Stoke Mandeville, como parte de um plano de reabilitação de soldados que serviram na Segunda Guerra Mundial. O local ficou conhecido como &#8220;Enfermaria X&#8221; (Ward X, em inglês) que possuia inicialmente 26 leitos para mutilados de guerra e pacientes paralíticos, e logo, a unidade se tornou o Centro Nacional de Lesões da Coluna, no Hospital de Stoke Mandeville.</p>\n<div id="attachment_6331" style="width: 402px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-6331" class="wp-image-6331" src="https://cintespbr.org/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-04-at-12.15.35-300x170.jpeg" alt="" width="392" height="222" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-04-at-12.15.35-300x170.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/07/WhatsApp-Image-2021-07-04-at-12.15.35.jpeg 720w" sizes="(max-width: 392px) 100vw, 392px" /><p id="caption-attachment-6331" class="wp-caption-text">Ludwig Guttmann era médico e foi quem colocou a semente para o que viria a ser os Jogos Paralímpicos FOTO: Bettmann/Corbis)</p></div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Esta é a primeira vez que um pôster separado é selecionado para os Jogos Paraolímpicos. O pôster que será usado para simbolizar e promover os Jogos Paraolímpicos foi selecionado pelo Comitê Paraolímpico Internacional (IPC). A arte para o cartaz foi criada pela unidade de design gráfico Goo Choki Par e apresentada pelos Organizadores das Paralimpíadas&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6330,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-6329",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6329",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6329",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6329/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6332,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6329/revisions/6332",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6330",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6329",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6329",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6329",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6200,
        date: "2021-06-13T16:55:50",
        date_gmt: "2021-06-13T19:55:50",
        guid: {
            rendered: "https://cintespbr.org/?p=6200",
        },
        modified: "2022-07-08T00:18:24",
        modified_gmt: "2022-07-08T03:18:24",
        slug: "parabens-gustavo-carneiro",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/parabens-gustavo-carneiro/",
        title: {
            rendered:
                "PARABÉNS GUSTAVO CARNEIRO! Paratleta de Uberlândia Gustavo Carneiro está classificado para as Paralimpíadas de Tóquio",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]<strong>Paratleta de Uberlândia Gustavo Carneiro está classificado para as Paralimpíadas de Tóquio</strong></p>\n<p>&nbsp;</p>\n<p>Texto: Cristiane de Paula &#8211; CINTESP.Br</p>\n<p style="text-align: justify;">Gustavo Carneiro participou em abril de um dos testes de validação do equipamento para fabricação personalizada de cadeira de rodas, projeto desenvolvido pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINSTESP.Br®), em Uberlândia, uma iniciativa do Ministério de Ciência Tecnologia e Inovação (MCTI), em apoio ao Comitê Paralímpico Brasileiro (CPB) e as pessoas com deficiência, está em fase final de testes. Gustavo Carneiro está entre os cinco tenistas brasileiros classificados para as disputas de tênis de quadra em cadeira de rodas.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_media_grid grid_id=&#8221;vc_gid:1657250292627-d2ceabe1-d828-5&#8243; include=&#8221;6203,5637&#8243;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">A confirmação da classificação de Gustavo foi feita pela Federação Internacional de Tênis (ITF) confirmou a classificação dos brasileiros de acordo com o ranking das diferentes categorias. O evento será entre 24 de agosto e 5 de setembro na capital japonesa.  Os tenistas classificados são: os mineiros Daniel Rodrigues, Gustavo Carneiro, Rafael Medeiros, Meirycoll Duval e o catarinense Ymanitu Silva. Os jogos acontecerão entre 24 de agosto e 5 de setembro na capital japonesa.</p>\n<p style="text-align: left;">Na categoria Open Masculino, eram 56 vagas em disputa. O Brasil será representado pelos mineiros Daniel Rodrigues (11º no ranking), Gustavo Carneiro (41º) e Rafael Medeiros (46º). Na categoria Open Feminino, são 32 atletas. A mineira Meirycoll Duval, 28ª do ranking, carimbou o passaporte. Na quad, o catarinense Ymanitu Silva, 10º do mundo, será um dos 16 atletas a buscar a medalha de ouro.</p>\n<p style="text-align: justify;">Os cinco são integrantes do Bolsa Atleta, programa de patrocínio individual do Governo Federal Brasileiro, executado pela Secretaria Especial do Esporte do Ministério da Cidadania. Daniel e Ymanitu pertencem à categoria Pódio, a principal do programa, voltada para atletas que se posicionam entre os 20 melhores do ranking mundial em suas modalidades. A Bolsa Pódio prevê repasses mensais que variam entre R$ 5 mil e R$ 15 mil mensais, de acordo com a performance esportiva do atleta. Rafael integra a categoria Olímpica/Paralímpica. Meirycoll e Gustavo pertencem à categoria Internacional.</p>\n<p style="text-align: justify;">&#8220;Chorei muito quando soube. É um sonho que sempre tive desde 2011, quando mal sabia pegar na raquete. Receber a classificação dizendo que estou indo por mérito, por dedicação a todo o trabalho que foi feito, faz com que eu tenha mais motivação ainda&#8221;, Meirycoll Duval, classificada no Open Feminino</p>\n<p style="text-align: justify;">Todos os tenistas classificados já tomaram a primeira dose da vacina para Covid-19 e irão receber a segunda dose antes da viagem para a Ásia, que está marcada para 8 de agosto. No Japão, a primeira parada será em Hamamatsu, onde a delegação fará a aclimatação antes de competir em Tóquio.</p>\n<p style="text-align: justify;">&#8220;Alcançar essa classificação para os Jogos Paralímpicos é resultado do trabalho e dedicação de atletas e treinadores. Ficamos felizes também pelo reconhecimento do trabalho da CBT, que atua incansavelmente para que os atletas possam participar do máximo de eventos e treinamentos. É um trabalho de longo prazo, que cada vez vem dando mais resultados&#8221;, afirma Jesus Tajra, vice-presidente da Confederação Brasileira de Tênis.</p>\n<p style="text-align: justify;">&#8220;Viver essa experiência de uma paralimpíada novamente me mostra que estou no caminho certo. Foram cinco anos de preparação e investimentos, tanto no meu físico quanto em equipamentos, como cadeira e raquetes. Os profissionais que me cercam para esse treinamento me dão doses diárias de força e otimismo. O que mais quero levar comigo é o carinho e a torcida de todos os que vibram por mim&#8221;, afirmou Ymanitu Silva.</p>\n<p style="text-align: justify;"><strong>Fonte: Comitê Paralímpico Brasileiro</strong></p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text]Paratleta de Uberlândia Gustavo Carneiro está classificado para as Paralimpíadas de Tóquio &nbsp; Texto: Cristiane de Paula &#8211; CINTESP.Br Gustavo Carneiro participou em abril de um dos testes de validação do equipamento para fabricação personalizada de cadeira de rodas, projeto desenvolvido pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINSTESP.Br®), em Uberlândia,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6210,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-6200",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6200",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6200",
                },
            ],
            "version-history": [
                {
                    count: 15,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6200/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8068,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6200/revisions/8068",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6210",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6200",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6200",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6200",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6196,
        date: "2021-06-05T22:19:16",
        date_gmt: "2021-06-06T01:19:16",
        guid: {
            rendered: "https://cintespbr.org/?p=6196",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "vinte-e-nove-nadadores-conquistam-indice-para-os-jogos-de-toquio-em-seletiva-paralimpica",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/vinte-e-nove-nadadores-conquistam-indice-para-os-jogos-de-toquio-em-seletiva-paralimpica/",
        title: {
            rendered:
                "Vinte e nove nadadores conquistam índice para os Jogos de Tóquio em seletiva paralímpica",
        },
        content: {
            rendered:
                '<div class="row img-main align_center">\n<div class="imagem-principal-detalhe">\n<div style="width: 1021px" class="wp-caption alignnone"><img loading="lazy" decoding="async" class="img-responsive" src="https://www.cpb.org.br/upload/noticia/0e01a736f6a249fa88702e5def1cdfef.jpg" alt="Ruan Souza (SB9) obteve o índice para os Jogos de Tóquio nos 100m peito nesta sábado durante a Fase de Treinamento Seletiva da natação. Foto: Alê Cabral/CPB" width="1011" height="571" /><p class="wp-caption-text">Ruan Souza (SB9) obteve o índice para os Jogos de Tóquio nos 100m peito nesta sábado durante a Fase de Treinamento Seletiva da natação. Foto: Alê Cabral/CPB</p></div>\n<div class="ssk-sticky ssk-center ssk-lg"></div>\n</div>\n</div>\n<div class="texto" style="text-align: justify;">\n<p>A Fase de Treinamento Seletiva de natação terminou neste sábado, 5, no Centro de Treinamento Paralímpico, em São Paulo, e 29 conquistaram o índice para os Jogos Paralímpicos de Tóquio 2020, sendo 11 mulheres e 18 homens. Ao todo, 58 nadadores participaram desta seletiva, que teve como objetivo definir os atletas que comporão a Seleção de natação para os Jogos na capital japonesa.</p>\n<p>Este sábado, 5, marcou o último dia da Seletiva, em que três atletas com deficiência intelectual obtiveram marcas elegíveis para figurar na Seleção que representará o país no Japão: as gêmeas Beatriz e Débora Carneiro (SB14) nos 100m peito, <a href="https://www.cpb.org.br/noticia/detalhe/3345/atleta-mineiro-bate-indice-na-seletiva-de-natacao-em-seu-primeiro-ano-entre-paralimpicos" target="_blank" rel="noopener"><u><strong>o mineiro João Pedro Brutus (SB14) com 1min07s04</strong></u></a>, seguido do paulista Gabriel Bandeira (SB14) com 1min10s54, que já possuía outros índices. Nesta mesma prova, o paulista Ruan Souza (SB9) com 1min10s54 também obteve o índice necessário. Outro atleta a conquistar marca elegível neste sábado foi paranaense Bruno Becker nos 200m livre.</p>\n<p>&#8220;A qualidade técnica foi melhor do que o esperado. Estávamos muito tempo sem competição, não sabíamos ao certo como os atletas iriam nadar, apesar das tomadas de tempo. Nós não tínhamos a perspectiva de ter tantos atletas com índice, tanto que o nosso critério era bem amplo. Foi bom ver que o planejamento estratégico da modalidade, pós-Jogos Rio 2016 até os Jogos de Tóquio, deu certo. É uma Seleção muito nova, isso é muito importante&#8221;, analisou o técnico-chefe da Seleção Brasileira, Leonardo Tomasello.</p>\n<p>Para a natação, o Brasil possui 35 vagas nos Jogos de Tóquio. Pelos critérios do Comitê Paralímpico Brasileiro (CPB), que atua como confederação da modalidade, já estão confirmados nos Jogos de Tóquio os campeões mundiais de 2019: Edênia Garcia (S3), Wendell Belarmino (S11), Carol Santiago (S12) e Daniel Dias (S5). <a href="https://www.cpb.org.br/upload/link/bf3a2feb0d604a1197fb4d5c6dd48324.pdf" target="_blank" rel="noopener"><u><strong>Confira aqui os critérios.  </strong></u></a></p>\n<p>No primeiro dia da seletiva, quarta-feira, 2, quatro atletas alcançaram os índices: Phelipe Rodrigues (S10), Talisson Glock (S6) e Gabriel Cristiano (S8) nos 100m livre, e Susana Schnarndorf (SM4) nos 150m medley.</p>\n<p>&#8220;Estou extremamente feliz de ter conquistado o índice. Eu travo uma batalha diariamente por conta da minha deficiência. Tive que reaprender a nadar literalmente, mas nunca deixei de acreditar no meu sonho&#8221;, celebrou a gaúcha Susana Schnarndorf, medalhista paralímpica no revezamento 4x50m livre 20 pontos nos Jogos Rio 2016, que tem múltipla falência dos sistemas (MSA).</p>\n<p>&#8220;Um ano e meio sem competições, é muito importante a gente voltar a ter ritmo. Mesmo com as tomadas de tempo internas, não é a mesma coisa sentir a pressão e estar do lado das pessoas que competem com você. Os melhores atletas do Brasil estavam aqui buscando o índice para Tóquio. Eu estava bastante ansioso, não vou mentir, especialmente antes da minha primeira prova. Nos 50m livre eu consegui fazer a minha quarta ou quinta melhor marca pessoal. A gente vê que precisa melhorar, mas também que está no caminho certo, apesar das circunstâncias&#8221;, contou o medalhista paralímpico e mundial Phelipe Rodrigues.</p>\n<p><strong>Leia mais<br />\n<a href="https://www.cpb.org.br/noticia/detalhe/3328/primeiro-dia-de-seletiva-de-natacao-comeca-com-conquista-de-indices-para-toquio" target="_blank" rel="noopener">Primeiro dia de seletiva de natação começa com conquista de índices para Tóquio</a><br />\n<a href="https://www.cpb.org.br/noticia/detalhe/3334/dez-atletas-fazem-indice-para-toquio-na-manha-de-quinta-feira-durante-seletiva-de-natacao-paralimpica" target="_blank" rel="noopener">Dez atletas fazem índice para Tóquio na manhã de quinta-feira durante seletiva de natação paralímpica</a></strong><br />\n<a href="https://www.cpb.org.br/noticia/detalhe/3336/nadadores-paralimpicos-conquistam-novos-indices-para-toquio-durante-seletiva-de-natacao-desta-sexta" target="_blank" rel="noopener"><strong>Nadadores paralímpicos conquistam novos índices para Tóquio durante seletiva de natação desta sexta</strong></a></p>\n<p>O segundo dia de provas, quinta-feira, 3, teve o maior número de atletas obtendo o índice pela primeira vez, 13 nadadores ao todo.</p>\n<p><a href="https://www.cpb.org.br/noticia/detalhe/3335/conheca-os-atletas-da-classe-s1-com-indice-para-toquio-na-seletiva-de-natacao-paralimpica" target="_blank" rel="noopener"><u><strong>José Ronaldo (S1), Gabriel Feiten (S1)</strong></u></a>, Gabriel Geraldo (S2), Maiara Barreto (S3) nos 50m costas. Douglas Matera (S13) e Gabriel Bandeira (S14) nos 100m borboleta. Gabriel Melone (S6), Samuel Oliveira e Joana Neves (S5) nos 50m borboleta e Ronystony Cordeiro (S4) nos 50m costas. Na prova de maior distância da natação paralímpica, os 400m livre, Laila Suzigan (S6) Caio Amorim (S8) e Matheus Rheine (S11) nadaram abaixo do índice.</p>\n<p>Na sexta-feira, 4, dia da prova mais rápida da natação, os 50m livre, seis atletas obtiveram o índice nesta prova: Ruiter Gonçalves (S9), Lídia Cruz (S4), Patrícia Pereira (S4), Mariana Gesteira (S9), Cecília Araújo (S8) e Eric Tobera (S4). Já nos 100m costas, segunda prova do dia, Ana Karolina Soares (S14) foi mais rápida que o exigido pelo critério. <a href="https://www.youtube.com/channel/UCQwwtBWAnxCwSuMyFzHpssw" target="_blank" rel="noopener"><u><strong>As finais destas provas foram transmitidas pelo CPB no Youtube, confira aqui. </strong></u></a></p>\n<p>Agora, os nadadores aguardam a validação da elegibilidade pelo Comitê Paralímpico Internacional (IPC, sigla em inglês) e a convocação oficial do CPB, o que deve ocorrer até o final de junho, para confirmarem as suas vagas nos Jogos de Tóquio.</p>\n<p>Fonte: www.cpb.org.br</p>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>A Fase de Treinamento Seletiva de natação terminou neste sábado, 5, no Centro de Treinamento Paralímpico, em São Paulo, e 29 conquistaram o índice para os Jogos Paralímpicos de Tóquio 2020, sendo 11 mulheres e 18 homens. Ao todo, 58 nadadores participaram desta seletiva, que teve como objetivo definir os atletas que comporão a Seleção&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6197,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-6196",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6196",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6196",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6196/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6198,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6196/revisions/6198",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6197",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6196",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6196",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6196",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6192,
        date: "2021-06-01T22:09:51",
        date_gmt: "2021-06-02T01:09:51",
        guid: {
            rendered: "https://cintespbr.org/?p=6192",
        },
        modified: "2022-05-18T15:34:01",
        modified_gmt: "2022-05-18T18:34:01",
        slug: "governo-federal-sanciona-marco-legal-das-startups-e-do-empreendedorismo-inovador",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/governo-federal-sanciona-marco-legal-das-startups-e-do-empreendedorismo-inovador/",
        title: {
            rendered:
                "Governo Federal sanciona Marco Legal das Startups e do Empreendedorismo Inovador",
        },
        content: {
            rendered:
                '<h3><img loading="lazy" decoding="async" style="font-size: 14px; font-weight: normal;" src="https://www.gov.br/mcti/pt-br/acompanhe-o-mcti/noticias/2021/06/governo-federal-sanciona-marco-legal-das-startups-e-do-empreendedorismo-inovador/51217829682_bdfbb6496c_k.jpg/@@images/ba221a8a-4c9e-4168-8e36-9937b26d833c.jpeg" alt="51217829682_bdfbb6496c_k.jpg" width="768" height="512" /></h3>\n<p>Foto: Alan Santos/PR</p>\n<h4>Instrumento fundamental para o desenvolvimento do ecossistema de empreendedorismo inovador foi sancionado nesta terça-feira (1°)</h4>\n<div id="viewlet-above-content-body">\n<div id="media">\n<p class="discreet"><span style="text-align: justify;">O presidente da República, Jair Bolsonaro, sancionou nesta terça-feira (1°) o novo Marco Legal das Startups e do Empreendedorismo Inovador. A sanção do PLP 146/2019 contou com a presença do secretário-executivo do MCTI &#8211;  Ministério da Ciência, Tecnologia e Inovações, Sergio Freitas, e do Secretário de Empreendedorismo e Inovação, Paulo Alvim. A lei que institui o novo Marco Legal das Startups, publicada na quarta-feira (2) no </span><a class="external-link" style="text-align: justify;" title="" href="https://pesquisa.in.gov.br/imprensa/jsp/visualiza/index.jsp?data=02/06/2021&amp;jornal=515&amp;pagina=1&amp;totalArquivos=131" target="_self" rel="noopener" data-tippreview-enabled="false" data-tippreview-image="" data-tippreview-title="">Diário Oficial da União (DOU)</a><span style="text-align: justify;">, traz importantes mudanças nas regras para este tipo de empresa, facilitando a inserção e a competitividade do Brasil no mercado global e impactando positivamente o empreendedorismo inovador no País.</span></p>\n</div>\n</div>\n<div id="content-core">\n<div id="parent-fieldname-text" class="">\n<p style="text-align: justify;">“O Marco Legal das Startups é fruto de quatro anos de trabalho do MCTI e do Governo Federal. Mais de 70 atores públicos e privados colaboraram com o Governo na identificação das dores dos empreendedores brasileiros e na proposição de soluções para facilitar o nascimento e o crescimento de mais startups no Brasil”, destacou Paulo Alvim.</p>\n<p style="text-align: justify;">O MCTI acompanhou toda a tramitação inicial do Projeto de Lei na Câmara dos Deputados, o encaminhamento ao Senado Federal, posterior retorno e aprovação definitiva para encaminhamento e sanção presidencial.</p>\n<p style="text-align: justify;"><strong>Regras</strong></p>\n<p style="text-align: justify;">São consideradas startups as organizações empresariais ou societárias com atuação na inovação aplicada a modelo de negócios ou a produtos e serviços ofertados. Essas empresas devem ter receita bruta anual de até R$ 16 milhões e até dez anos de inscrição no Cadastro Nacional da Pessoa Jurídica (CNPJ). Também precisam declarar em seus atos constitutivos que fazem uso do modelo de negócio inovador em sua atividade.</p>\n<p style="text-align: justify;">Com a nova legislação, as startups poderão receber investimentos de pessoas físicas ou jurídicas, que poderão resultar ou não em participação no capital social da startup, a depender da modalidade escolhida pelas partes.</p>\n<p style="text-align: justify;">O investidor que realizar o aporte de capital sem ingressar no capital social não será considerado sócio, nem possuirá direito a gerência ou voto na administração da empresa investida. Essa medida afasta a responsabilização do investidor, que não responderá por qualquer dívida da startup, exceto em caso de conduta dolosa, ilícita ou de má-fé por parte do investidor.</p>\n<p style="text-align: justify;">Outra forma de as startups receberem recursos é por meio de empresas que possuem obrigações de investimento em pesquisa, desenvolvimento e inovação decorrentes de outorgas realizadas por agências reguladoras, como ANP e Aneel. A medida permite que essas empresas aportem suas obrigações em Fundos Patrimoniais ou Fundos de Investimento em Participações (FIP) que invistam em startups ou, ainda, em programas, editais ou concursos destinados a financiamento e aceleração de startups gerenciados por instituições públicas. Essa obrigatoriedade de investimento já existe e a possibilidade de seu direcionamento para apoio a startups trará forte injeção de recursos nas startups com soluções para esses setores.</p>\n<p style="text-align: justify;">O Marco Legal também prevê a possibilidade de programas de ambiente regulatório experimental, o chamado sandbox regulatório, em que órgãos ou agências com competência de regulação setorial, isoladamente ou em conjunto, podem afastar normas de sua competência para que empresas inovadoras experimentem modelos de negócios inovadores e testem técnicas e tecnologias, com acompanhamento do regulador.</p>\n<p style="text-align: justify;">Os órgãos e agências competentes ficam responsáveis por definir os critérios de seleção das empresas participantes do sandbox regulatório, bem como as normas que poderão ser suspensas e o período de duração de cada programa. A medida trará maior segurança jurídica para startups e empresas inovarem, preservando e apoiando a modernização do quadro regulatório.</p>\n<p style="text-align: justify;">Outra solução definida pelo Marco Legal é a criação de modalidade de compra pública, que possibilita a realização de testes de inovação e posterior contratação direta de soluções desenvolvidas por startups para a Administração Pública. A legislação vigente de compras públicas na prática inviabiliza a contratação de soluções inovadoras desenvolvidas por startups, por conta do excesso de exigências formais para as empresas e pela necessidade de especificação exaustiva dos objetos de contratação.</p>\n<p style="text-align: justify;">O secretário de Empreendedorismo e Inovação do MCTI, Paulo Alvim, garante que o ministério vai continuar trabalhando em conjunto com seus parceiros no governo – em especial o Ministério da Economia. “Trabalharemos com o ecossistema de inovação como um todo, tanto para regulamentar o Marco Legal como para editar novos atos normativos que venham a cobrir eventuais lacunas não atendidas pela lei sancionada. Além disso, o ministério trabalhará intensamente na disseminação dos dispositivos do Marco Legal na sociedade”.</p>\n<p>Fonte: www.gov.br/mcti</p>\n</div>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Foto: Alan Santos/PR Instrumento fundamental para o desenvolvimento do ecossistema de empreendedorismo inovador foi sancionado nesta terça-feira (1°) O presidente da República, Jair Bolsonaro, sancionou nesta terça-feira (1°) o novo Marco Legal das Startups e do Empreendedorismo Inovador. A sanção do PLP 146/2019 contou com a presença do secretário-executivo do MCTI &#8211;  Ministério da Ciência,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 6193,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-6192",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6192",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6192",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6192/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6195,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6192/revisions/6195",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/6193",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6192",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6192",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6192",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6097,
        date: "2021-05-30T12:36:48",
        date_gmt: "2021-05-30T15:36:48",
        guid: {
            rendered: "https://cintespbr.org/?p=6097",
        },
        modified: "2021-07-24T22:58:04",
        modified_gmt: "2021-07-25T01:58:04",
        slug: "signe-communication-haptique",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/signe-communication-haptique/",
        title: {
            rendered: "Signe: COMMUNICATION HAPTIQUE",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: COMMUNICATION HAPTIQUE<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/KUqpUZSn_gc&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuration de la main:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Signe: COMMUNICATION HAPTIQUE</strong></span></p>\n<p><span style="color: #ffff00;">Le bras replié vers soi, main ouverte, paume vers le bas; Main active ouverte, mouvement touchant le bras et l&#8217;avant-bras passif</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/KUqpUZSn_gc&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: COMMUNICATION HAPTIQUE Le bras replié vers soi, main ouverte, paume vers le bas; Main active ouverte, mouvement touchant le bras et l&#8217;avant-bras passif[/vc_message][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4687,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6097",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6097",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6097",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6097/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6458,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6097/revisions/6458",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4687",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6097",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6097",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6097",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6087,
        date: "2021-05-30T12:20:38",
        date_gmt: "2021-05-30T15:20:38",
        guid: {
            rendered: "https://cintespbr.org/?p=6087",
        },
        modified: "2021-08-02T19:38:30",
        modified_gmt: "2021-08-02T22:38:30",
        slug: "signe-syndrome-dusher-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/signe-syndrome-dusher-2/",
        title: {
            rendered: "Signe: SYNDROME D&#8217;USHER 2",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE SURDICÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: SYNDROME D&#039;USHER 2<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/RHYwXGijDVk&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuration de la main:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Signe: SYNDROME D&#8217;USHER 2</strong></span></p>\n<p><span style="color: #ffff00;">Espace neutre à hauteur de poitrine ; main passive immobile. Faire se rejoindre le bout de tous les doigts ; main active ouverte avec la paume face à la main passive, faire un mouvement ondulatoire latéral de haut en bas.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/RHYwXGijDVk&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: SYNDROME D&#8217;USHER 2 Espace neutre à hauteur de poitrine ; main passive immobile. Faire se rejoindre le bout de tous les doigts ; main active ouverte&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4669,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6087",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6087",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6087",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6087/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6528,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6087/revisions/6528",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4669",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6087",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6087",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6087",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6080,
        date: "2021-05-30T12:12:03",
        date_gmt: "2021-05-30T15:12:03",
        guid: {
            rendered: "https://cintespbr.org/?p=6080",
        },
        modified: "2021-07-24T23:17:03",
        modified_gmt: "2021-07-25T02:17:03",
        slug: "sinal-guia-interprete-1",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-guia-interprete-1/",
        title: {
            rendered: "Signe: GUIDE INTERPRÈTE",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: GUIDE INTERPRÈTE<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/Yp3vao1Sxpg&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<strong><span style="color: #ffff00;">Configuration de la main:</span></strong></p>\n<p><span style="color: #ffff00;"><strong>Signe: GUIDE INTERPRÈTE</strong></span></p>\n<p><span style="color: #ffff00;">Le bras est replié vers soi, la main est ouverte et la paume face à soi; la main  avec les doigts courbés tiennent le bout des doigts de la main passive. Les faire bouger latéralement. Ensuite, la main passive est ouverte devant soi et la paume est vers le haut; la main active ouverte avec la paume vers le bas touche la main passive et fait tourner le poignet avec la paume maintenue vers le haut.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/Yp3vao1Sxpg&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: GUIDE INTERPRÈTE Le bras est replié vers soi, la main est ouverte et la paume face à soi; la main  avec les doigts courbés tiennent le&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4684,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6080",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6080",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6080",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6080/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6468,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6080/revisions/6468",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4684",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6080",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6080",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6080",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6078,
        date: "2021-05-30T12:09:07",
        date_gmt: "2021-05-30T15:09:07",
        guid: {
            rendered: "https://cintespbr.org/?p=6078",
        },
        modified: "2021-07-24T23:18:55",
        modified_gmt: "2021-07-25T02:18:55",
        slug: "sinal-guia-interprete-2-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-guia-interprete-2-2/",
        title: {
            rendered: "Signe: GUIDE INTERPRÈTE 2",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: GUIDE INTERPRÈTE 2<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/5x6NtxaukCY&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<strong><span style="color: #ffff00;">Configuration de la main:</span></strong></p>\n<p><span style="color: #ffff00;"><strong>Signe: GUIDE INTERPRÈTE 2</strong></span></p>\n<p><span style="color: #ffff00;">La main passive est ouverte devant soi et la paume est vers le haut; la main active est ouverte et la paume vers le bas. En touchant la main passive, faire tourner le poignet avec la paume vers le haut. Ensuite, replié vers soi le bras passif, la main ouverte et la paume face à soi; la main active avec les doigts courbés tiennent le bout des doigts de la main passive. Les faire bouger latéralement.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/5x6NtxaukCY&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: GUIDE INTERPRÈTE 2 La main passive est ouverte devant soi et la paume est vers le haut; la main active est ouverte et la paume vers&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4684,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6078",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6078",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6078",
                },
            ],
            "version-history": [
                {
                    count: 7,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6078/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6470,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6078/revisions/6470",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4684",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6078",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6078",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6078",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6076,
        date: "2021-05-30T12:06:15",
        date_gmt: "2021-05-30T15:06:15",
        guid: {
            rendered: "https://cintespbr.org/?p=6076",
        },
        modified: "2021-07-24T23:22:00",
        modified_gmt: "2021-07-25T02:22:00",
        slug: "sinal-guia-vidente-2-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-guia-vidente-2-2/",
        title: {
            rendered: "Signe: GUIDE D’AVEUGLE 2",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: GUIDE D’AVEUGLE 2<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/pYbI7cXKl0w&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuration de la main:</strong></span></p>\n<p><strong><span style="color: #ffff00;">Signe: GUIDE D’AVEUGLE 2</span></strong></p>\n<p><span style="color: #ffff00;">Espace neutre, main passive avec le pouce, l&#8217;index et le majeur tendus vers le bas. Main active fermée avec le pouce, l&#8217;index et le majeur tenant le pouce de la main passive. On les fait bouger latéralement.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/pYbI7cXKl0w&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: GUIDE D’AVEUGLE 2 Espace neutre, main passive avec le pouce, l&#8217;index et le majeur tendus vers le bas. Main active fermée avec le pouce, l&#8217;index et&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4679,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6076",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6076",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6076",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6076/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6472,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6076/revisions/6472",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4679",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6076",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6076",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6076",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6068,
        date: "2021-05-30T11:57:10",
        date_gmt: "2021-05-30T14:57:10",
        guid: {
            rendered: "https://cintespbr.org/?p=6068",
        },
        modified: "2021-07-24T23:20:45",
        modified_gmt: "2021-07-25T02:20:45",
        slug: "sinal-guia-vidente-4",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-guia-vidente-4/",
        title: {
            rendered: "Signe: GUIDE D’AVEUGLE",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: GUIDE D’AVEUGLE<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/lVIZED4dR_o&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<strong><span style="color: #ffff00;">Configuration de la main:</span></strong></p>\n<p><strong><span style="color: #ffff00;">Signe: GUIDE D’AVEUGLE</span></strong></p>\n<p><span style="color: #ffff00;">Espace neutre, main passive avec le pouce, l&#8217;index et le majeur tendus vers le bas. Main active avec les doigts majeur, annulaire et l&#8217;auriculaire détachés, joindre le pouce et l’index, en touchant le pouce de la main passive et en les faisant bouger latéralement.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/lVIZED4dR_o&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: GUIDE D’AVEUGLE Espace neutre, main passive avec le pouce, l&#8217;index et le majeur tendus vers le bas. Main active avec les doigts majeur, annulaire et l&#8217;auriculaire&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4679,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6068",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6068",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6068",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6068/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6471,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6068/revisions/6471",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4679",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6068",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6068",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6068",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6067,
        date: "2021-05-30T11:57:10",
        date_gmt: "2021-05-30T14:57:10",
        guid: {
            rendered: "https://cintespbr.org/?p=6067",
        },
        modified: "2021-07-24T23:11:16",
        modified_gmt: "2021-07-25T02:11:16",
        slug: "sinal-surdocegueira-ou-surdocego-ou-surdocega",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-surdocegueira-ou-surdocego-ou-surdocega/",
        title: {
            rendered: "Signe: LA SURDICÉCITÉ OU LES SOURDAVEUGLES",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: LA SURDICÉCITÉ OU LES SOURDAVEUGLES<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/0ggeVRJw5lY&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuration de la main:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Signe: LA SURDICÉCITÉ OU LES SOURDAVEUGLES</strong></span></p>\n<p><span style="color: #ffff00;">Avec la paume de la main ouverte, les doigts fermés et le pouce tendu, effectuer une légère rotation avec un mouvement vers l&#8217;oreille et devant l&#8217;œil.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/0ggeVRJw5lY&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: LA SURDICÉCITÉ OU LES SOURDAVEUGLES Avec la paume de la main ouverte, les doigts fermés et le pouce tendu, effectuer une légère rotation avec un mouvement&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4676,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6067",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6067",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6067",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6067/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6465,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6067/revisions/6465",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4676",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6067",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6067",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6067",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6066,
        date: "2021-05-30T11:57:10",
        date_gmt: "2021-05-30T14:57:10",
        guid: {
            rendered: "https://cintespbr.org/?p=6066",
        },
        modified: "2021-08-02T19:42:21",
        modified_gmt: "2021-08-02T22:42:21",
        slug: "sinal-tadoma-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-tadoma-2/",
        title: {
            rendered: "Signe: TADOMA",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE SURDICÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: TADOMA<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/TNVsDvDBYd4&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;">Configuration de la main:</span></p>\n<p><span style="color: #ffff00;"><strong>Signe: TADOMA</strong></span></p>\n<p><span style="color: #ffff00;">La main est placée sur le menton, le pouce d’un côté du menton, l&#8217;index et le majeur tendus de l&#8217;autre côté du menton, les autres doigts sont repliés. Faire des mouvements alternatifs vers l&#8217;avant.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/TNVsDvDBYd4&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: TADOMA La main est placée sur le menton, le pouce d’un côté du menton, l&#8217;index et le majeur tendus de l&#8217;autre côté du menton, les autres&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4674,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6066",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6066",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6066",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6066/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6531,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6066/revisions/6531",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4674",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6066",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6066",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6066",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6064,
        date: "2021-05-30T11:50:40",
        date_gmt: "2021-05-30T14:50:40",
        guid: {
            rendered: "https://cintespbr.org/?p=6064",
        },
        modified: "2021-08-02T19:40:02",
        modified_gmt: "2021-08-02T22:40:02",
        slug: "sinal-sindrome-de-usher-3",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-sindrome-de-usher-3/",
        title: {
            rendered: "Signe: SYNDROME D&#8217;USHER",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE SURDICÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: SYNDROME D&#039;USHER<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/2tXPkZ-dyaw&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuration de la main:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Signe: SYNDROME D&#8217;USHER</strong></span></p>\n<p><span style="color: #ffff00;">Espace neutre à hauteur de poitrine ; main passive immobile. Faire se rejoindre le bout de tous les doigts ; Main active repliée avec la paume face à la main passive, l’ouvrir légèrement en la faisant glisser sur le côté à gauche.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/2tXPkZ-dyaw&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: SYNDROME D&#8217;USHER Espace neutre à hauteur de poitrine ; main passive immobile. Faire se rejoindre le bout de tous les doigts ; Main active repliée avec&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4669,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6064",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6064",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6064",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6064/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6529,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6064/revisions/6529",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4669",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6064",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6064",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6064",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6056,
        date: "2021-05-30T11:45:49",
        date_gmt: "2021-05-30T14:45:49",
        guid: {
            rendered: "https://cintespbr.org/?p=6056",
        },
        modified: "2021-07-24T23:00:05",
        modified_gmt: "2021-07-25T02:00:05",
        slug: "sinal-retinose-pigmentar-3",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-retinose-pigmentar-3/",
        title: {
            rendered: "Signe: RÉTINITE PIGMENTAIRE",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: RÉTINITE PIGMENTAIRE<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/hGFe7RHQSGY&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuration de la main:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Signe: RÉTINITE PIGMENTAIRE</strong></span></p>\n<p><span style="color: #ffff00;">Doigts index et majeur croisés et les autres doigts fermés; Toucher légèrement le côté du front, faire tourner ses 2 doigts index et majeur, comme pour effectuer un « V », l&#8217;index à la verticale, le majeur à l&#8217;horizontale et le bout du pouce entre les deux.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/hGFe7RHQSGY&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: RÉTINITE PIGMENTAIRE Doigts index et majeur croisés et les autres doigts fermés; Toucher légèrement le côté du front, faire tourner ses 2 doigts index et majeur,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4667,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6056",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6056",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6056",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6056/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6459,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6056/revisions/6459",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4667",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6056",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6056",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6056",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6055,
        date: "2021-05-30T11:45:49",
        date_gmt: "2021-05-30T14:45:49",
        guid: {
            rendered: "https://cintespbr.org/?p=6055",
        },
        modified: "2021-07-24T23:12:34",
        modified_gmt: "2021-07-25T02:12:34",
        slug: "sinal-bengala-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-bengala-2/",
        title: {
            rendered: "Signe: LA CANNE",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: LA CANNE<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/BUnQZ3v6Sg0&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<strong><span style="color: #ffff00;">Configuration de la main:</span></strong></p>\n<p><span style="color: #ffff00;"><strong>Signe: LA CANNE</strong></span></p>\n<p><span style="color: #ffff00;">Bras passif replié horizontalement devant le corps et à hauteur de la poitrine, main ouverte, paume vers le bas; Main active fermée avec l&#8217;index tendu, en touchant l&#8217;avant-bras passif avec un mouvement simultané de droite à gauche.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/BUnQZ3v6Sg0&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: LA CANNE Bras passif replié horizontalement devant le corps et à hauteur de la poitrine, main ouverte, paume vers le bas; Main active fermée avec l&#8217;index&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4499,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6055",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6055",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6055",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6055/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6466,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6055/revisions/6466",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4499",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6055",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6055",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6055",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6054,
        date: "2021-05-30T11:45:49",
        date_gmt: "2021-05-30T14:45:49",
        guid: {
            rendered: "https://cintespbr.org/?p=6054",
        },
        modified: "2021-07-24T23:15:42",
        modified_gmt: "2021-07-25T02:15:42",
        slug: "sinal-instrutor-mediador",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-instrutor-mediador/",
        title: {
            rendered: "Signe: INSTRUCTEUR MÉDIATEUR",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: INSTRUCTEUR MÉDIATEUR<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/VGzXnhqeDV8&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<strong><span style="color: #ffff00;">Configuration de la main:</span></strong></p>\n<p><span style="color: #ffff00;"><strong>Signe: INSTRUCTEUR MÉDIATEUR</strong></span></p>\n<p><span style="color: #ffff00;">Espace neutre à hauteur de poitrine, main passive fermée avec le petit doigt tendu, paume vers l&#8217;avant; Main active avec la paume vers l&#8217;avant, les bouts des doigts sont joints à côté de la main passive, avec un mouvement d&#8217;ouverture et de fermeture 2 fois</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/VGzXnhqeDV8&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: INSTRUCTEUR MÉDIATEUR Espace neutre à hauteur de poitrine, main passive fermée avec le petit doigt tendu, paume vers l&#8217;avant; Main active avec la paume vers l&#8217;avant,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4694,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6054",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6054",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6054",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6054/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6467,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6054/revisions/6467",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4694",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6054",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6054",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6054",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6053,
        date: "2021-05-30T11:45:49",
        date_gmt: "2021-05-30T14:45:49",
        guid: {
            rendered: "https://cintespbr.org/?p=6053",
        },
        modified: "2021-07-24T23:06:47",
        modified_gmt: "2021-07-25T02:06:47",
        slug: "sinal-libras-tatil-3",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-libras-tatil-3/",
        title: {
            rendered: "Signe: LANGUE DES SIGNES TACTILE",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: LANGUE DES SIGNES TACTILE<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/ici-MFga3Hs&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<strong><span style="color: #ffff00;">Configuration de la main:</span></strong></p>\n<p><span style="color: #ffff00;"><strong>Signe: LANGUE DES SIGNES TACTILE</strong></span></p>\n<p><span style="color: #ffff00;">Espace neutre à hauteur de poitrine, mains ouvertes, paumes vers le bas l&#8217;une sur l&#8217;autre. En alternance, bouger les doigts de la main qui est en dessous.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/ici-MFga3Hs&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: LANGUE DES SIGNES TACTILE Espace neutre à hauteur de poitrine, mains ouvertes, paumes vers le bas l&#8217;une sur l&#8217;autre. En alternance, bouger les doigts de la&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4699,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6053",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6053",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6053",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6053/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6463,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6053/revisions/6463",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4699",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6053",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6053",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6053",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6052,
        date: "2021-05-30T11:45:49",
        date_gmt: "2021-05-30T14:45:49",
        guid: {
            rendered: "https://cintespbr.org/?p=6052",
        },
        modified: "2021-07-24T23:08:22",
        modified_gmt: "2021-07-25T02:08:22",
        slug: "sinal-libras-tatil-2-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-libras-tatil-2-2/",
        title: {
            rendered: "Signe: LANGUE DES SIGNES TACTILE 2",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: LANGUE DES SIGNES TACTILE 2<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/2bxU7Fxm2wQ&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<strong><span style="color: #ffff00;">Configuration de la main:</span></strong></p>\n<p><span style="color: #ffff00;"><strong>Signe: LANGUE DES SIGNES TACTILE 2</strong></span></p>\n<p><span style="color: #ffff00;">Espace neutre à hauteur de poitrine, mains ouvertes, paumes vers le bas l&#8217;une sur l&#8217;autre. En alternance, bouger les doigts de la main qui est en dessous avec le poignet en mouvement circulaire.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/2bxU7Fxm2wQ&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: LANGUE DES SIGNES TACTILE 2 Espace neutre à hauteur de poitrine, mains ouvertes, paumes vers le bas l&#8217;une sur l&#8217;autre. En alternance, bouger les doigts de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4699,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6052",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6052",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6052",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6052/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6464,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6052/revisions/6464",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4699",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6052",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6052",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6052",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6050,
        date: "2021-05-30T11:32:38",
        date_gmt: "2021-05-30T14:32:38",
        guid: {
            rendered: "https://cintespbr.org/?p=6050",
        },
        modified: "2021-07-24T23:02:04",
        modified_gmt: "2021-07-25T02:02:04",
        slug: "signe-retine",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/signe-retine/",
        title: {
            rendered: "Signe: RÉTINE",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: RÉTINE<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/g6yeindL11E&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<strong><span style="color: #ffff00;">Configuration de la main:</span></strong></p>\n<p><strong><span style="color: #ffff00;">Signe: RÉTINE</span></strong></p>\n<p><span style="color: #ffff00;">Espace neutre à hauteur de poitrine; Main passive fermée, le bout des doigts joints; Main active ouverte avec les doigts un peu repliés; la fermer puis, du bout des doigts, touchez les doigts de la main passive, en alternance</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/g6yeindL11E&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: RÉTINE Espace neutre à hauteur de poitrine; Main passive fermée, le bout des doigts joints; Main active ouverte avec les doigts un peu repliés; la fermer&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4704,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6050",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6050",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6050",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6050/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6460,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6050/revisions/6460",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4704",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6050",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6050",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6050",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6048,
        date: "2021-05-29T23:47:20",
        date_gmt: "2021-05-30T02:47:20",
        guid: {
            rendered: "https://cintespbr.org/?p=6048",
        },
        modified: "2021-07-24T23:23:38",
        modified_gmt: "2021-07-25T02:23:38",
        slug: "signe-cintesp-br",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/signe-cintesp-br/",
        title: {
            rendered: "Signe: CINTESP.Br",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: CINTESP.Br<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/fJfPZVKQIhY&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<strong><span style="color: #ffff00;">Configuration de la main:</span></strong></p>\n<p><span style="color: #ffff00;"><strong>Signe: CINTESP.Br</strong></span></p>\n<p><span style="color: #ffff00;">Les mains ouvertes, les pouces collés aux index par le bout des doigts, placer une main derrière l’autre, touchant le côté des index et des pouces l&#8217;un contre l&#8217;autre. Main active en mouvement circulaire vers l&#8217;avant.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/fJfPZVKQIhY&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: CINTESP.Br Les mains ouvertes, les pouces collés aux index par le bout des doigts, placer une main derrière l’autre, touchant le côté des index et des&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4720,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6048",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6048",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6048",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6048/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6473,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6048/revisions/6473",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4720",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6048",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6048",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6048",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6046,
        date: "2021-05-29T23:45:31",
        date_gmt: "2021-05-30T02:45:31",
        guid: {
            rendered: "https://cintespbr.org/?p=6046",
        },
        modified: "2021-07-24T23:04:56",
        modified_gmt: "2021-07-25T02:04:56",
        slug: "signe-mcti",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/signe-mcti/",
        title: {
            rendered: "Signe: MCTI",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: MCTI<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/Y8c0dKJa6uU&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<strong><span style="color: #ffff00;">Configuration de la main:</span></strong></p>\n<p><span style="color: #ffff00;"><strong>Signe: MCTI &#8211; Ministère de la science, de la technologie et de l&#8217;innovation</strong></span></p>\n<p><span style="color: #ffff00;">Main passive devant le corps, le pouce tendu, les doigts collés et courbés avec la paume vers le côté. Main active fermée, paume vers l&#8217;avant touchant la paume de la main passive, la faire glisser sur le côté en ouvrant les doigts.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/Y8c0dKJa6uU&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: MCTI &#8211; Ministère de la science, de la technologie et de l&#8217;innovation Main passive devant le corps, le pouce tendu, les doigts collés et courbés avec&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4722,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6046",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6046",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6046",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6046/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6462,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6046/revisions/6462",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4722",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6046",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6046",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6046",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6006,
        date: "2021-05-29T14:14:52",
        date_gmt: "2021-05-29T17:14:52",
        guid: {
            rendered: "https://cintespbr.org/?p=6006",
        },
        modified: "2021-08-02T19:41:19",
        modified_gmt: "2021-08-02T22:41:19",
        slug: "sinal-universidade-federal-de-uberlandia-ufu-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-universidade-federal-de-uberlandia-ufu-2/",
        title: {
            rendered: "Signe: UNIVERSITÉ FÉDÉRALE D’UBERLÂNDIA &#8211; UFU",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDICÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe: UNIVERSITÉ FÉDÉRALE D’UBERLÂNDIA - UFU<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/TNVsDvDBYd4&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuration de la main:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Signe: UNIVERSITÉ FÉDÉRALE D’UBERLÂNDIA &#8211; UFU</strong></span></p>\n<p><span style="color: #ffff00;">Les mains fermées avec les index et le majeur levés et joints devant le corps avec la paume vers l&#8217;avant et positionnés l&#8217;un à côté de l&#8217;autre. Main active vers le côté puis faire un mouvement semi-circulaire vers le bas.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/TNVsDvDBYd4&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuration de la main: Signe: UNIVERSITÉ FÉDÉRALE D’UBERLÂNDIA &#8211; UFU Les mains fermées avec les index et le majeur levés et joints devant le corps avec la paume vers l&#8217;avant et&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4726,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6006",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6006",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6006",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6006/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6530,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6006/revisions/6530",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4726",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6006",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6006",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6006",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 6002,
        date: "2021-05-29T14:02:33",
        date_gmt: "2021-05-29T17:02:33",
        guid: {
            rendered: "https://cintespbr.org/?p=6002",
        },
        modified: "2021-07-24T23:03:50",
        modified_gmt: "2021-07-25T02:03:50",
        slug: "signe-projet-obscurite-silence",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/signe-projet-obscurite-silence/",
        title: {
            rendered: "Signe: PROJET OBSCURITÉ &#038; SILENCE",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSAIRE DE LA SURDITÉCÉCITÉ<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Signe : PROJET OBSCURITÉ &amp; SILENCE<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/ySCu1C0bzAU&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]</p>\n<p id="tw-target-text" class="tw-data-text tw-text-large XcVN5d tw-ta" dir="ltr" data-placeholder="Tradução"><strong><span class="Y2IQFc" lang="fr">Configuration de la main:</span></strong></p>\n<p>Mains ouvertes et séparées devant le corps à la hauteur des épaules, fermer les doigts en ramenant la main au centre. Fermez ensuite la main active en joignant le bout des doigts, l&#8217;index levé vers la bouche et la paume sur le côté.[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/ySCu1C0bzAU&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;] Configuration de la main: Mains ouvertes et séparées devant le corps à la hauteur des épaules, fermer les doigts en ramenant la main au centre. Fermez ensuite la main active&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4726,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [59],
        tags: [],
        class_list: [
            "post-6002",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossaire-de-la-surdicecite",
            "category-59",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6002",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=6002",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6002/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6461,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/6002/revisions/6461",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4726",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=6002",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=6002",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=6002",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5949,
        date: "2021-05-23T21:59:17",
        date_gmt: "2021-05-24T00:59:17",
        guid: {
            rendered: "https://cintespbr.org/?p=5949",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "boletim-23-05-2021-rumo-a-toquio",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/boletim-23-05-2021-rumo-a-toquio/",
        title: {
            rendered: "BOLETIM 23/05/2021 &#8211; RUMO A TÓQUIO",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<h3 style="text-align: justify;"><strong>Esperamos o retorno de nossos paratletas brasileiros com muito orgulho. Com o desempenho deles nos Campeonatos Europeus estamos mais perto das Paralimpíadas de Tóquio</strong>.</h3>\n<div id="attachment_5950" style="width: 1034px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5950" class="wp-image-5950 size-large" src="https://cintespbr.org/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-23-at-19.02.37-1-1024x438.jpeg" alt="" width="1024" height="438" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-23-at-19.02.37-1-1024x438.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-23-at-19.02.37-1-300x128.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-23-at-19.02.37-1-768x329.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-23-at-19.02.37-1.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-5950" class="wp-caption-text">Imagem CPB Encerramento Copa do Mundo na Geórgia com Tayana Medeiros, João Maria de França e Mateus Assis.</p></div>\n<p>&nbsp;</p>\n<p>Texto Cristiane de Paula – Ascom CINTESP.Br</p>\n<p>Fonte: <strong>Ascom CPB  </strong>23/05/2021</p>\n<p><strong>As boas notícias vêm da Geórgia e de Portugal onde aconteceram as competições da Copa do Mundo em halterofilismo e Open Europeu de natação respectivamente.</strong></p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_5926" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5926" class="wp-image-5926 size-large" src="https://cintespbr.org/wp-content/uploads/2021/05/Lara-1024x576.jpg" alt="" width="1024" height="576" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/05/Lara-1024x576.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/Lara-300x169.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/Lara-768x432.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/Lara.jpg 1434w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-5926" class="wp-caption-text">Imagem MGTV1: Lara com medalha de ouro</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p style="text-align: justify;">No halterofilismo os uberlandenses Lara Aparecida e Mateus Assis somaram à equipe de 8 paratletas brasileiros que competiram em Tbilisi, capital da Geórgia na Copa do Mundo de Halterofilismo. Mateus conquistou prata por equipes mistas até 80kg.  E, na sexta-feira( 21) Lara, da categoria de até 41kg, conquistou as medalhas de ouro, na categoria júnior e bronze, na categoria adulto levantando 90 kgs. Ao todo, o Brasil conquistou sete medalhas na Geórgia.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<p style="text-align: justify;">Na natação, os meninos do Praia Clube, Gabriel Bandeira e João Pedro Brutus se destacaram no Open Europeu de natação. Ao todo foram 7 medalhas, sendo seis de ouro e uma de prata. Gabriel  conquistou o seu sexto ouro na etapa de Madeira, Portugal, do World Series da modalidade, circuito internacional da natação organizado pelo Comitê Paralímpico Internacional (IPC, sigla em inglês).</p>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_5957" style="width: 834px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5957" class="wp-image-5957 " src="https://cintespbr.org/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-23-at-19.02.37-2-e1621817230546-300x183.jpeg" alt="" width="824" height="503" /><p id="caption-attachment-5957" class="wp-caption-text">Imagem CPB Gabriel Bandeira recordista das Américas</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">O destaque desse Open foi a quebra de recorde, Gabriel, estreante em competições internacionais paralímpicas, estabeleceu novo tempo de 54s99, nos 100m borboleta da classe S14 (para nadadores com deficiência intelectual), novo recorde das Américas. Os atletas que representaram o Brasil foram: Gabriel Bandeira, João Pedro Brutus e André Luiz Bento. Todos são da classe S14, para atletas com deficiência intelectual.</p>\n<p style="text-align: justify;">O Centro Brasileiro de Referência em Inovações Tecnológicas para o Esporte Paralímpico (CINTESP.Br®) é vinculado à Universidade Federal de Uberlândia (UFU) e com apoio do Ministério de Ciência e Tecnologia (MCTI) auxilia o Comitê Paralímpico Brasileiro (CPB) na preparação em todas as modalidades do paratleta iniciante ao de alto rendimento. As tecnologias desenvolvidas pelo CINTESP.Br® também são transferidas para atender à sociedade nas áreas de saúde, educação, esporte lazer e vida diária para pessoas com deficiência, mobilidade reduzida e doenças raras.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Esperamos o retorno de nossos paratletas brasileiros com muito orgulho. Com o desempenho deles nos Campeonatos Europeus estamos mais perto das Paralimpíadas de Tóquio. &nbsp; Texto Cristiane de Paula – Ascom CINTESP.Br Fonte: Ascom CPB  23/05/2021 As boas notícias vêm da Geórgia e de Portugal onde aconteceram as competições da Copa do Mundo em&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5950,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 34, 62],
        tags: [],
        class_list: [
            "post-5949",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-57",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5949",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5949",
                },
            ],
            "version-history": [
                {
                    count: 10,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5949/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5961,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5949/revisions/5961",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5950",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5949",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5949",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5949",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5936,
        date: "2021-05-22T20:41:08",
        date_gmt: "2021-05-22T23:41:08",
        guid: {
            rendered: "https://cintespbr.org/?p=5936",
        },
        modified: "2021-12-27T23:06:44",
        modified_gmt: "2021-12-28T02:06:44",
        slug: "boletim-georgia-22-05-2021-eliminatorias-rumo-as-paralimpiadas-de-toquio",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/boletim-georgia-22-05-2021-eliminatorias-rumo-as-paralimpiadas-de-toquio/",
        title: {
            rendered:
                "BOLETIM 22/05/2021 &#8211; Eliminatórias rumo às Paralimpíadas de Tóquio",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column width=&#8221;2/3&#8243;][vc_column_text]</p>\n<div id="attachment_5937" style="width: 599px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5937" class="wp-image-5937 size-full" src="https://cintespbr.org/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-22-at-20.22.29.jpeg" alt="" width="589" height="347" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-22-at-20.22.29.jpeg 589w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-22-at-20.22.29-300x177.jpeg 300w" sizes="(max-width: 589px) 100vw, 589px" /><p id="caption-attachment-5937" class="wp-caption-text">Arquivo pessoal Instagram &#8211; Gabriel Bandeira</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/3&#8243;][vc_column_text]</p>\n<div id="attachment_5941" style="width: 256px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5941" class="wp-image-5941 size-medium" src="https://cintespbr.org/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-22-at-20.22.28-246x300.jpeg" alt="" width="246" height="300" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-22-at-20.22.28-246x300.jpeg 246w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-22-at-20.22.28.jpeg 469w" sizes="(max-width: 246px) 100vw, 246px" /><p id="caption-attachment-5941" class="wp-caption-text">Arquivo pessoal Instagram &#8211; João Brutus</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<h3 style="text-align: center;"><strong>SENSACIONAL OS RESULTADOS DE ONTEM</strong></h3>\n<p><strong>Pela manhã:</strong></p>\n<p>João Brutus, estreando em jogos internacionais com o Comitê Paralímpico Brasileiro e Gabriel, ambos paratletas do Praia Clube, bateram recorde das Américas nos 100m peito e ficou em primeiro para as finais.</p>\n<p>Gabriel Bandeira, da equipe Paralímpica de Natação do Praia Clube, conquistou Ouro com recorde das Américas nos 100m peito e João brutos vice campeão.</p>\n<p>Gabriel bateu o recorde brasileiro nos 200m medley e classificou em primeiro para final e o João Brutos classificou com o quinto tempo pra final!</p>\n<p><strong>Pela tarde mais recordes:</strong></p>\n<p>Gabriel ficou em primeiro nos 200m medley com recorde das Américas e Brutos em quinto!</p>\n<p>Gabriel se classificou em terceiro para as finais 100m livres quebrando o recorde brasileiro da prova.</p>\n<p>João Brutus encerra sua participação no aberto Europeu com a décima posição na prova de 100m livres. Gabriel recorde das Américas nos 100m livres e campeão da prova ficando a 0;00,08 centésimos do recorde mundial.</p>\n<p><img loading="lazy" decoding="async" class="size-medium wp-image-5533 aligncenter" src="https://cintespbr.org/wp-content/uploads/2021/03/CPB-300x111.png" alt="" width="300" height="111" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/CPB-300x111.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/CPB.png 387w" sizes="(max-width: 300px) 100vw, 300px" /><img loading="lazy" decoding="async" class="size-medium wp-image-3861 aligncenter" src="https://cintespbr.org/wp-content/uploads/2020/09/Logo-nova-1-300x60.png" alt="" width="300" height="60" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/Logo-nova-1-300x60.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/Logo-nova-1.png 319w" sizes="(max-width: 300px) 100vw, 300px" /></p>\n<p>Até o Próximo boletim do Campeonato Europeu para Natação, em Portugal. CINTESP.Br® e CPB com os paratletas rumo à Paralimpíadas de Tóquio.[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column width=&#8221;2/3&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/3&#8243;][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text] SENSACIONAL OS RESULTADOS DE ONTEM Pela manhã: João Brutus, estreando em jogos internacionais com o Comitê Paralímpico Brasileiro e Gabriel, ambos paratletas do Praia Clube, bateram recorde das Américas nos 100m peito e ficou em primeiro para as finais. Gabriel Bandeira, da equipe Paralímpica de Natação do Praia Clube, conquistou&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5938,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 34, 62],
        tags: [],
        class_list: [
            "post-5936",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-57",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5936",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5936",
                },
            ],
            "version-history": [
                {
                    count: 9,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5936/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5962,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5936/revisions/5962",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5938",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5936",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5936",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5936",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5922,
        date: "2021-05-21T21:18:52",
        date_gmt: "2021-05-22T00:18:52",
        guid: {
            rendered: "https://cintespbr.org/?p=5922",
        },
        modified: "2021-12-27T23:06:45",
        modified_gmt: "2021-12-28T02:06:45",
        slug: "paratletas-do-halterofilismo-de-uberlandia-estreiam-com-medalhas-nos-jogos-classificatorios-da-georgia-para-as-paralimpiadas-de-toquio",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/paratletas-do-halterofilismo-de-uberlandia-estreiam-com-medalhas-nos-jogos-classificatorios-da-georgia-para-as-paralimpiadas-de-toquio/",
        title: {
            rendered:
                "Paratletas do halterofilismo de Uberlândia estreiam com medalhas nos jogos classificatórios da Geórgia para as Paralimpíadas de Tóquio",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_5926" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5926" class="wp-image-5926 size-large" src="https://cintespbr.org/wp-content/uploads/2021/05/Lara-1024x576.jpg" alt="" width="1024" height="576" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/05/Lara-1024x576.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/Lara-300x169.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/Lara-768x432.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/Lara.jpg 1434w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-5926" class="wp-caption-text">imagem MGTV1: Lara com medalha de ouro</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_5925" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5925" class="wp-image-5925 size-large" src="https://cintespbr.org/wp-content/uploads/2021/05/2-1-1024x549.jpg" alt="" width="1024" height="549" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/05/2-1-1024x549.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/2-1-300x161.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/2-1-768x412.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/2-1.jpg 1325w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-5925" class="wp-caption-text">imagem MGTV1: Lara competindo na Geórgia</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Texto Cristiane de Paula/ CINTESP.Br®</p>\n<p>Maio/2021</p>\n<p style="text-align: justify;">   Parabéns Lara Lima e Mateus Assis, do Clube Desportivo para Deficientes de Uberlândia (CDDU), associação parceira da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel) e Weverton Santos, o treinador.</p>\n<p style="text-align: justify;">Lara, da categoria de até 41kg, conquistou as primeiras medalhas da nossa equipe. Ela ganhou medalhas de ouro, na categoria júnior e bronze, na categoria adulto levantando 90 kgs.</p>\n<p style="text-align: justify;"><em>“Volto pra casa com duas medalhas de ouro e bronze e com o recorde das Américas. Ainda tenho Dubai, as competições ainda não encerraram para a classificação para Tóquio, conto com mais energias”, disse a Lara em entrevista ao MGTV1.</em></p>\n<p style="text-align: justify;">O ciclo para as classificações para as Paraolimpíadas de Tóquio já está na fase final, a próxima etapa vai ser em Dubai. O Centro Brasileiro de Referência em Inovações Tecnológicas para o Esporte Paralímpico (CINTESP.Br®) é vinculado à Universidade Federal de Uberlândia (UFU) e com apoio do Ministério de Ciência e Tecnologia (MCTI) auxilia o Comitê Paralímpico Brasileiro (CPB) na preparação em todas as modalidades do paratleta iniciante ao de alto rendimento.  A paratleta Lara é avaliada sistemática e tecnicamente em Uberlândia, pela equipe do CINTESP.Br®, assim como o atleta Mateus, que também está na Geórgia disputando vaga para as Paralimpíadas de Toquio.</p>\n<div id="attachment_5929" style="width: 463px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5929" class="wp-image-5929" src="https://cintespbr.org/wp-content/uploads/2021/05/parat-300x300.jpg" alt="" width="453" height="453" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/05/parat-300x300.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/parat-1024x1022.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/parat-150x150.jpg 150w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/parat-768x766.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/parat.jpg 1236w" sizes="(max-width: 453px) 100vw, 453px" /><p id="caption-attachment-5929" class="wp-caption-text">Imagem GE/Triângulo Lara Mateus e Weverton embarcando para Geórgia</p></div>\n<p style="padding-left: 40px; text-align: justify;"><em>“É claro que sempre pensamos nos desafios pela frente e os laboratórios e os centros de pesquisa como o de Uberlândia é um que a gente conta para que no futuro a gente possa alcançar melhores resultados e com mais facilidades seja por meio de avaliações ou por meio de equipamentos que possam ser criados”, </em>disse Weverton, treinador da equipe, em entrevista ao CINTESP.Br®.</p>\n<div id="attachment_5708" style="width: 541px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5708" class="wp-image-5708" src="https://cintespbr.org/wp-content/uploads/2021/04/Sem-titulo-1-2-300x209.png" alt="" width="531" height="370" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/04/Sem-titulo-1-2-300x209.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/Sem-titulo-1-2-1024x714.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/Sem-titulo-1-2-768x535.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/Sem-titulo-1-2.png 1460w" sizes="(max-width: 531px) 100vw, 531px" /><p id="caption-attachment-5708" class="wp-caption-text">Imagem CINTESP.Br: Gustavo em teste de validação em Uberlândia</p></div>\n<p style="text-align: justify;">Recentemente, Gustavo Carvalho, jogador de tênis em cadeira de Rodas, participou de mais um ciclo de testes de validação de um equipamento para fabricação de cadeira de rodas personalizada, desenvolvido pelo CINTESP.Br®, em Uberlândia. O Equipamento de Prescrição de Cadeiras de Rodas Personalizadas (SWCE) possui multi-regulagens com 36 ajustes modulares para atender às necessidades anatômicas do cadeirante, ampliando a percepção psicomotora, seus limites físicos e seu autoconhecimento fisiológico desenvolvendo melhor performance. As tecnologias desenvolvidas pelo CINTESP.Br® também são transferidas para atender à sociedade nas áreas de saúde, educação, esporte lazer e vida diária para pessoas com deficiência, mobilidade reduzida e doenças raras.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Texto Cristiane de Paula/ CINTESP.Br® Maio/2021    Parabéns Lara Lima e Mateus Assis, do Clube Desportivo para Deficientes de Uberlândia (CDDU), associação parceira da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel) e Weverton Santos, o treinador. Lara, da categoria de até 41kg, conquistou as primeiras medalhas da nossa equipe. Ela&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5929,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 34, 62],
        tags: [],
        class_list: [
            "post-5922",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-57",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5922",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5922",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5922/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5930,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5922/revisions/5930",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5929",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5922",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5922",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5922",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5888,
        date: "2021-05-18T22:01:34",
        date_gmt: "2021-05-19T01:01:34",
        guid: {
            rendered: "https://cintespbr.org/?p=5888",
        },
        modified: "2021-12-27T23:02:11",
        modified_gmt: "2021-12-28T02:02:11",
        slug: "acao-social-do-cintesp-br-em-uberlandia-promove-projeto-com-incentivo-e-promocao-a-leitura-a-acao-de-forma-ludica-visa-contribuir-para-o-processo-inclusivo-e-lanca-o-desafio-do-livro",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/acao-social-do-cintesp-br-em-uberlandia-promove-projeto-com-incentivo-e-promocao-a-leitura-a-acao-de-forma-ludica-visa-contribuir-para-o-processo-inclusivo-e-lanca-o-desafio-do-livro/",
        title: {
            rendered:
                "Ação social do CINTESP.BR® em Uberlândia promove Projeto com incentivo e promoção à leitura.",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]<em>A leitura lúdica é uma das ferramentas adotadas pelo CINTESP.Br® para o despertar a uma questão que deve estar no cotidiano da criança e de toda a família. </em>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_5890" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5890" class="wp-image-5890 size-large" src="https://cintespbr.org/wp-content/uploads/2021/05/1-1024x767.jpg" alt="" width="1024" height="767" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/05/1-1024x767.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/1-300x225.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/1-768x575.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/1.jpg 1298w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-5890" class="wp-caption-text">Coord. geral CINTESP.Br® e diretoria Escola AMEDUCA &#8211; Entrega kit p</p></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]</p>\n<div id="attachment_5891" style="width: 1034px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5891" class="wp-image-5891 size-large" src="https://cintespbr.org/wp-content/uploads/2021/05/2-1024x767.jpg" alt="" width="1024" height="767" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/05/2-1024x767.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/2-300x225.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/2-768x575.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/2.jpg 1242w" sizes="(max-width: 1024px) 100vw, 1024px" /><p id="caption-attachment-5891" class="wp-caption-text">Coord. Geral CINTESP.Br e Direção Escola AMEDUCA- Uberlândia</p></div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]<em>Texto: Cristiane de Paula</em></p>\n<p><em>Revisão: Daniela Yoshida</em></p>\n<p><em>24/04/2021</em></p>\n<p style="text-align: justify;">Um dos Projetos Sociais do <em>CINTESP.Br®</em> apoiado pelo Ministério da Ciência Tecnologia e Inovação-MCTI, envolve diretamente a Educação e a Saúde, e a ferramenta utilizada é a leitura para crianças de forma lúdica e com interação. Para isso uma das ações é a distribuição de Livros e kits pedagógicos às Instituições de Assistência Social e de Ensino que solicitam inovação na forma conhecimento para inclusão com acessibilidade. E o desafio é envolver toda a sociedade por meio das Instituições de Educação que trabalham com o estímulo e incentivo a leitura para que possam contar suas histórias de forma lúdica visando o fortalecimento de política pública valorização cultural.</p>\n<p style="text-align: justify;">O material distribuído faz parte do kit lúdico educacional que é formado por um exemplar do Livro “Caminhos da inclusão “CRESCER”, revista das ações do MCTI por um Brasil de qualidade de vida com igualdade de acessos, além de um livreto da história da semana nacional da ciência, tecnologia e inovação criado pelo MCTI para divulgar as inovações tecnológicas do Brasil e um folheto de conscientização da importância da higienização e os cuidados para a proteção contra a Covid-19.</p>\n<div id="attachment_5895" style="width: 510px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5895" class="wp-image-5895" src="https://cintespbr.org/wp-content/uploads/2021/05/reuniao-300x224.jpg" alt="" width="500" height="373" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/05/reuniao-300x224.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/reuniao-1024x766.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/reuniao-768x574.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/reuniao.jpg 1345w" sizes="(max-width: 500px) 100vw, 500px" /><p id="caption-attachment-5895" class="wp-caption-text">Reunião coord. geral CINTESP.Br e diretoria Escola AMEDUCA</p></div>\n<p style="text-align: justify;">O livro “CRESCER” foi apresentado à direção e equipe psicopedagógica da escola Ameduca, localizada no bairro Cidade Jardim, Região Sul de Uberlândia, que atende crianças da educação infantil ao ensino médio e tem cerca de 30% dos alunos com algum tipo de deficiência e que relatam terem encontrado dificuldade na escola regular.</p>\n<p style="text-align: justify;">Nesta Ação Social, além de 100 exemplares do livro “CRESCER” ainda foram distribuídos materiais educativos sobre a prevenção à Covid-19 e as ações do MCTI para um Brasil mais inclusivo e  o respeito às diferenças humanas. “Nossa metodologia de ensino é fundamentada em muito estudos e pesquisas e oferece conhecimento para termos uma sociedade mais solidária, respeitando e legitimando as diferenças coletivas e individuais, sempre buscando novos caminhos e esse material vem de encontro ao que buscamos” disse Miriene Ferreira Macedo, diretora da Escola Ameduca.</p>\n<p style="text-align: justify;">Durante a visita à escola, para a entrega do kit lúdico pedagógico, a coordenadora geral do CINTESP.Br, Daniela Yoshida, conheceu os espaços para a educação infantil e se reuniu com a direção para apresentar as ações do CINTESP.Br®, que apoiado pelo MCTI desenvolve vários Projetos nas áreas não apenas da Educação como também de lazer, saúde, esporte para pessoas com doenças raras e com deficiência e desenvolve pesquisas em Tecnologia Assistiva para os paratletas olímpicos e inicia a transferência dessa tecnologia para crianças iniciantes no paraesporte, e pessoas com deficiência e com doenças raras. “Não podemos deixar de atender toda nossa população que precisa da tecnologia assistiva para ter qualidade de vida, isso é trabalhar com acessibilidade, oferecer a todos os mesmos recursos que nós do CINTESP.Br® desenvolvemos para o paratleta de alto rendimento e aliada às pesquisas vamos levando metodologias e ferramentas pedagógicas para o entendimento de inclusão com acessibilidade”, disse a coordenadora geral Daniela Yoshida.</p>\n<p style="text-align: justify;"><strong>BRILHAR PARA SER MAIS ALTO E ACOLHER</strong></p>\n<p style="text-align: justify;">Durante o encontro e a distribuição do kit lúdico pedagógico, a coordenadora do CINTESP.Br® lançou o desafio para a Escola, reunir em um livro e de forma lúdica as histórias de superação vivida pelos alunos e mostrar os métodos que estão oferecendo acessibilidade e inclusão durante os ciclos escolares oferecidos pela Escola. O material será diagramado e impresso pelo CINTESP.Br® para publicação e lançamento na Feira Nacional de Acessibilidade a ser realizada no final do ano em Brasília. “Precisamos conhecer, contar as nossas histórias e levar inclusão com acessibilidade que estão dando certo de forma que possa envolver adultos e crianças, mostrar que a questão da igualdade está em aceitar as diferenças, é o desafio da superação diária e o que estamos entregando hoje é pouco, mas é para mostrar que juntos podemos muito mais”, completa a coordenadora.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text]A leitura lúdica é uma das ferramentas adotadas pelo CINTESP.Br® para o despertar a uma questão que deve estar no cotidiano da criança e de toda a família. [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text] [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]Texto: Cristiane de Paula Revisão: Daniela Yoshida 24/04/2021 Um dos Projetos Sociais do CINTESP.Br® apoiado pelo Ministério da Ciência Tecnologia e Inovação-MCTI, envolve diretamente a&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5890,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-5888",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5888",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5888",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5888/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5931,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5888/revisions/5931",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5890",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5888",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5888",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5888",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5821,
        date: "2021-05-10T20:07:08",
        date_gmt: "2021-05-10T23:07:08",
        guid: {
            rendered: "https://cintespbr.org/?p=5821",
        },
        modified: "2021-12-27T22:46:33",
        modified_gmt: "2021-12-28T01:46:33",
        slug: "inovacao-na-saude",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/inovacao-na-saude/",
        title: {
            rendered: "INOVAÇÃO NA SAÚDE",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_text_separator title=&#8221;INOVAÇÃO NA SAÚDE.&#8221;][vc_column_text]</p>\n<p style="text-align: justify;"><strong>Pesquisadores Brasileiros Desenvolvem Materiais Biocompatíveis para Implante de Recuperação de Lesões no Joelho.</strong></p>\n<p style="text-align: justify;">O Brasil está perto de imprimir em 3D o primeiro menisco com material biocompatível com o organismo humano genuinamente brasileiro.</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;5827&#8243; img_size=&#8221;400&#215;400&#8243; add_caption=&#8221;yes&#8221; alignment=&#8221;center&#8221;][vc_column_text css=&#8221;.vc_custom_1620695276786{margin-top: -5px !important;border-top-width: -5px !important;padding-top: -2px !important;}&#8221;]Flávia Pedrini &#8211; Doutorando. Manuseando células no fluxo laminar[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;5828&#8243; img_size=&#8221;400&#215;400&#8243; add_caption=&#8221;yes&#8221; alignment=&#8221;center&#8221;][vc_column_text css=&#8221;.vc_custom_1620695429112{margin-top: -5px !important;border-top-width: -5px !important;padding-top: -2px !important;}&#8221;]Professora Dra. Eliana Duek – Responsável pela pesquisa[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">A pesquisa já está na fase de impressão, os materiais biocompatíveis mostraram condições biológicas e resistência mecânica em testes em vitros para implante de recuperação de lesões no joelho. As pesquisas estão sendo desenvolvidas na Faculdade de Ciências Médicas da PUC Campus Sorocaba  sobre a coordenação da Drª Eliana Duek.</p>\n<p style="text-align: justify;">O processo de fabricação de meniscos já está bastante avançado, os pesquisadores da Faculdade de Ciências Médicas e da Saúde, PUC Sorocaba, interior de São Paulo, sob a coordenação da pesquisadora especialista em materiais poliméricos, Eliana Duek, finalizaram os testes in vitro e com implantes em coelhos, agora já começam a imprimir modelos de próteses para humanos. “Nós acreditamos que em 1 ou 2 anos, dependendo das exigências da ANVISA, que tem controles rígidos de qualidade, esse nosso material inovador, já poderá estar no mercado e por ser genuinamente nacional poderá ter custo muito menor, se comparado ao único comercializado até hoje de origem inglesa”, completa a pesquisadora.</p>\n<p><img loading="lazy" decoding="async" class="wp-image-5838 aligncenter" src="https://cintespbr.org/wp-content/uploads/2021/05/tecido-300x286.png" alt="" width="350" height="334" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/05/tecido-300x286.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/tecido-1024x975.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/tecido-768x731.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/05/tecido.png 1044w" sizes="(max-width: 350px) 100vw, 350px" /></p>\n<p style="text-align: justify;">O aspecto inovador da pesquisa está no material para a fabricação da prótese de menisco. As pesquisas desenvolvidas na PUC-SP, Campus Sorocaba, sintetizaram um novo material  à base de polímeros bioabsorvíveis, deixando a prótese de menisco 100% mais segura, podendo ser absorvida pelo organismo em até 5 meses, até a formação do novo tecido sem nenhuma complicação causada pelo implante. De acordo com a pesquisadora, o dispositivo não é tóxico e se degrada enquanto cresce um tecido fibrocartilaginoso, resultando na recuperação total do menisco. “Então se o material se degradar em até 30 semanas, será excelente dando maior prazo para total recuperação”, acrescenta a pesquisadora.</p>\n<p style="text-align: justify;">Os avanços dos resultados alcançados pelos pesquisadores da PUC Sorocaba poderão reduzir os custos do setor da saúde e melhorar a qualidade de vida dos pacientes com problemas na região do joelho.</p>\n<p style="text-align: justify;">De acordo com Instituto Nacional de Traumatologia e Ortopedia (INTO), referência no SUS, a osteoartrose dos joelhos atinge mais de 12% da população com mais de 60 anos de idade. Nessa parcela da população ainda encontram pessoas na faixa etária produtiva como atletas de final de semana e os atletas de alta performance, especialmente os praticantes de modalidades de muito contato físico. “Hoje em dia a maioria das pessoas não usa próteses e com o tempo vai desgastando a cartilagem que cobre o osso e leva a artrite e artroses, o novo menisco vai prevenir essas complicações”, completa a pesquisadora Eliana Duek.</p>\n<p style="text-align: justify;">Com base na tabela SUS, apenas o procedimento cirúrgico de joelho pode chegar a pouco mais de 4 mil Reais, para o caso de reconstrução ligamentar intra-articular do joelho (cruzado posterior) e para mais de R$ 15 mil Reais na Rede Particular, sem falar dos custos da internação e pós operatório.</p>\n<p style="text-align: justify;">Com a matéria prima desenvolvida pelos pesquisadores da PUC Campus Sorocaba, os tratamentos poderão ser de menor custo e maior benefício ao paciente, já que a matéria prima, genuinamente nacional, permitirá que a prótese seja fabricada por impressão 3D e personalizada, atendendo às medidas e necessidades anatômicas do paciente.</p>\n<p style="text-align: left;">O processo de impressão passa por etapas para se chegar a precisão da peça fabricada. Para isso o paciente é submetido a uma tomografia do joelho, os dados são colocados no computador e o programa desenha o menisco para a impressão.</p>\n<p style="text-align: justify;">O trabalho dos pesquisadores de biomateriais de polímeros da PUC de Sorocaba ainda envolve outra linha de pesquisas para implante de menisco utilizando células implantadas do próprio paciente na região lesionada e posteriormente o implante da prótese. O objetivo dessa segunda linha de pesquisas é oferecer maior condições de recuperação do tecido e menor risco de rejeição. “Essa forma de implante com células é muito nova, no mercado não existe esse tipo de tratamento, o que poderá ser muito usada no futuro”, conclui a pesquisadora.</p>\n<p>&nbsp;</p>\n<p><em>Texto: Coordenação Geral – CINTESP.Br®</em></p>\n<p><em>Daniela M. Yoshida; Cristiane de Paula </em>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_text_separator title=&#8221;INOVAÇÃO NA SAÚDE.&#8221;][vc_column_text] Pesquisadores Brasileiros Desenvolvem Materiais Biocompatíveis para Implante de Recuperação de Lesões no Joelho. O Brasil está perto de imprimir em 3D o primeiro menisco com material biocompatível com o organismo humano genuinamente brasileiro. [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;5827&#8243; img_size=&#8221;400&#215;400&#8243; add_caption=&#8221;yes&#8221; alignment=&#8221;center&#8221;][vc_column_text css=&#8221;.vc_custom_1620695276786{margin-top: -5px !important;border-top-width: -5px !important;padding-top: -2px !important;}&#8221;]Flávia Pedrini &#8211; Doutorando. Manuseando células&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5827,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [62],
        tags: [],
        class_list: [
            "post-5821",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-todas-as-noticias",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5821",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5821",
                },
            ],
            "version-history": [
                {
                    count: 22,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5821/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5866,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5821/revisions/5866",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5827",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5821",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5821",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5821",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5707,
        date: "2021-04-18T00:02:26",
        date_gmt: "2021-04-18T03:02:26",
        guid: {
            rendered: "https://cintespbr.org/?p=5707",
        },
        modified: "2022-07-08T00:08:26",
        modified_gmt: "2022-07-08T03:08:26",
        slug: "inovacao-tecnologica-em-prescricao-de-cadeira-de-rodas-personalizadas-e-mais-um-dos-equipamentos-desenvolvidos-pelo-cintesp-br-em-parceria-com-mcti-uma-tecnologia-assistiva-nacional",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/inovacao-tecnologica-em-prescricao-de-cadeira-de-rodas-personalizadas-e-mais-um-dos-equipamentos-desenvolvidos-pelo-cintesp-br-em-parceria-com-mcti-uma-tecnologia-assistiva-nacional/",
        title: {
            rendered:
                "Inovação tecnológica em prescrição de cadeira de rodas personalizadas é mais um dos equipamentos desenvolvidos pelo CINTESP.Br® em parceria com MCTI, uma tecnologia assistiva nacional.",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">O equipamento para fabricação de cadeira de rodas personalizada foi aprovado pelo Campeão mineiro de Tênis de quadra em Cadeiras de Rodas Gustavo Carneiro</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">O equipamento para fabricação personalizada de cadeira de rodas desenvolvido pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINSTESP.Br), em Uberlândia, uma iniciativa do Ministério de Ciência Tecnologia e Inovação (MCTI), em apoio ao Comitê Paralímpico Brasileiro (CPB) e as pessoas com deficiência, está em fase final de testes.</p>\n<p style="text-align: justify;">O objetivo do CINTESP.Br® e do MCTI é atender às demandas em Tecnologia Assistiva (TA), este novo equipamento é de suma importância para a adequação postural do usuário de cadeira de rodas, por permitir a <em><strong>personalização </strong></em><em>d</em>os diferentes modelos e configurações de cadeiras de rodas, atendendo corretamente as necessidades do usuário, permitindo que ele tenha o maior <strong>benefício</strong> possível, melhorando a sua <strong>qualidade de vida</strong>.</p>\n<p style="text-align: justify;">Os testes foram finalizados nesta última quarta-feira dia 16 de abril no centro de validação de protótipos parte do CINTESP.Br®, localizado na Arena Sabiazinho, em Uberlândia pelo paratleta Gustavo Carneiro, campeão mineiro de Tênis em Cadeiras de Rodas, um dos melhores paratletas jogadores de tênis, no Ranking Mundial. “O equipamento de prescrição de cadeira de rodas personalizadas permite a configurações de diferentes tipos de cadeiras de rodas, sendo destinado as pessoas com deficiência para o esporte ou para a vida diária de forma a contribuir com a saúde e a qualidade de vida”.</p>\n<p style="text-align: justify;">O Equipamento de Prescrição de Cadeiras de Rodas Personalizadas (SWCE) possui multi-regulagens com 36 ajustes modulares que se modelam às necessidades anatômicas do cadeirante, dando a pessoa com deficiência liberdade de escolha dentro do que melhor corresponde ao seu conforto e segurança, a partir de uma análise ergoantropométrica diretamente relacionada à sua cinesiologia de propulsão.</p>\n<p style="text-align: justify;">Com o equipamento, o gesto motor de impulsão da cadeira também pode ser avaliado sob a ótima de diversas combinações de ajustes possíveis, que exploram a capacidade biomecânica do cadeirante, ampliando a sua percepção psicomotora, seus limites físicos e seu autoconhecimento fisiológico.</p>\n<p style="text-align: justify;">Uma vez configurado para a anatomia do cadeirante, na melhor condição de conforto, segurança, desempenho e estabilidade, o equipamento permite o registro direto e preciso de todas as medidas ergoantropométricas do cadeirante, gerando uma base de dados que é implementada no escopo de projeto da Cadeira de Rodas dentro da escolha do usuário, passando por um tratamento de otimização, por meio de desenho parametrizado em software de CAD (desenho assistido por computador).</p>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_video link=&#8221;https://youtu.be/iDXNv5_eMbg&#8221;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">Ao final deste processo, são geradas fichas de fabricação com o modelo preciso da Cadeira de Rodas Personalizada, correlacionado às configurações ajustadas no Equipamento, que são enviadas para um fabricante especializado. O resultado desta metodologia deve ser a entrega de uma cadeira de rodas personalizada para a vida diária ou para o alto rendimento para o cadeirante avaliado.</p>\n<p style="text-align: justify;">Considerando “o método convencional baseado apenas em tirar medidas com fita métrica e mandar para a fábrica, este novo método desenvolvido pelo CINTESP.Br® poderá de fato resolvendo essa limitação, viabilizando uma modelagem física em tempo real, baseada numa experiência psicomotora direta” disse Lucas Cardoso, pesquisador responsável pelo Projeto.</p>\n<p style="text-align: justify;">Esta iniciativa do Ministério da Ciência, Tecnologia e Inovação (MCTI) em apoiar o desenvolvimento de inovação na área de Tecnologia Assistiva, juntamente com o CINTESP.Br®, visa desenvolver tecnologia assistiva nacional de valor acessível para atender a demanda da sociedade, considerando os objetivos da pessoa com deficiência, priorizando sua independência de mobilidade, seja no esporte ou na vida diária, entre outros fatores, tais como a condição física e motora, saúde, qualidade de vida, e as especificidades.</p>\n<p>&nbsp;</p>\n<p>Esta iniciativa abrange diversos fatores na sociedade brasileira, com a transferência da tecnologia ao setor produtivo, a intenção é estimular o ciclo de P&amp;D dinâmico, flexível e diversificado em inovação, entre outros, fatores que impactam o crescimento socioeconômico do país.[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] O equipamento para fabricação de cadeira de rodas personalizada foi aprovado pelo Campeão mineiro de Tênis de quadra em Cadeiras de Rodas Gustavo Carneiro [/vc_column_text][/vc_column][/vc_row][vc_row][vc_column][vc_column_text] O equipamento para fabricação personalizada de cadeira de rodas desenvolvido pelo Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINSTESP.Br), em Uberlândia, uma iniciativa do Ministério de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5716,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-5707",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5707",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5707",
                },
            ],
            "version-history": [
                {
                    count: 8,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5707/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8060,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5707/revisions/8060",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5716",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5707",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5707",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5707",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5672,
        date: "2021-04-10T09:29:16",
        date_gmt: "2021-04-10T12:29:16",
        guid: {
            rendered: "https://cintespbr.org/?p=5672",
        },
        modified: "2022-07-08T00:06:08",
        modified_gmt: "2022-07-08T03:06:08",
        slug: "inclusao-com-leitura-e-diversao-encerram-a-semana-internacional-do-livro-infantil",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/inclusao-com-leitura-e-diversao-encerram-a-semana-internacional-do-livro-infantil/",
        title: {
            rendered:
                "INCLUSÃO COM LEITURA E DIVERSÃO ENCERRAM A SEMANA INTERNACIONAL DO LIVRO INFANTIL",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]<strong>Considerando a Semana Internacional do Livro Infantil e o dia Mundial da Saúde, o CINTESP.Br® realizou a distribuição e forma de doação de exemplares de material lúdico para o estímulo à leitura e a inclusão.</strong>[/vc_column_text][vc_row_inner][vc_column_inner width=&#8221;1/6&#8243;][/vc_column_inner][vc_column_inner width=&#8221;2/3&#8243;][vc_single_image image=&#8221;5673&#8243; img_size=&#8221;400&#215;400&#8243; alignment=&#8221;center&#8221;][/vc_column_inner][vc_column_inner width=&#8221;1/6&#8243;][/vc_column_inner][/vc_row_inner][vc_column_text]<em>Presidente da ADVEM, Tânia Mesquita e a pediatra Márcia Berbert recebendo kits lúdicos pedagógicos na Ação Social do CINTESP.Br® com a Coordenadora Geral do CINTESP.Br® , Daniela M. Yoshida</em>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]<em>Texto / Revisão: </em></p>\n<p><em>Coordenação Geral CINTESP.br®</em></p>\n<p><em>Daniela Moura Yoshida, Cristiane de Paula</em></p>\n<p><em>Abril 2021</em>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">O <em>CINTESP.Br® </em>em prol a inclusão e acessibilidade destas as ações realizadas as datas especiais levando a conscientização sobre a importância dos cuidados à saúde, da luta contra o câncer, do esporte iniciante, da leitura, da importância do Braille e libras, assim com a importância da conscientização a respeito do autismo.</p>\n<p style="text-align: justify;"><em>CINTESP.Br® </em>representado pela Cood. Geral Daniela Yoshida, Ana Sara Guia Interprete e Cristiane de Paula Divulgação e Imprensa <em>CINTESP.Br®</em>, realizaram uma visita de interação e contribuição ao trabalho que vem sendo realizado pela a ADVEM, <a href="https://www.facebook.com/advem.org.br/">Associação Desenvolvendo Vida e Missão</a>, em Uberlândia. Respeitando as normas de segurança contra a covid-19 de prevenção e controle do Ministério da Saúde e Agência Nacional de Vigilância Sanitária – ANVISA.</p>\n<p style="text-align: justify;">Este é um projeto Social do <em>CINTESP.Br®</em> em levar o conhecimento, a inclusivo e os cuidados com a saúde, foram doados nesta visita 200 kits lúdicos pedagógicos em um total de 1000 itens, direcionado ao conhecimento da ciência, tecnologia, inovação, inclusão e saúde, por meio da leitura e brinquedos lúdicos, direcionados às crianças atendidas pelos programas de saúde e assistenciais da Instituição.</p>\n<p style="text-align: justify;">A ADVEM tem um importante trabalho na sociedade Uberlandense voltado à saúde, à proteção social e à acessibilidade com inclusão. O <em>CINTESP.Br®</em>, por meio do apoiado do MCTI visa contribuir com ações sociais levamos conscientização e acessibilidade dentro da sua linha de pesquisa, extensão e desenvolvimento direcionado a Tecnologia assistiva nas áreas da Saúde, Educação, Esporte, Lazer e Vida Diária para pessoas com deficiência e doenças raras.</p>\n<p style="text-align: justify;">O projeto conta a distribuição de kit lúdico educacional formado por um exemplar do Livro “Caminhos da inclusão “CRESCER”, revista das ações do MCTI em prol da ciência, tecnologia e inovação por um Brasil de qualidade, além de um livreto da história da semana nacional da ciência, tecnologia e inovação criado pelo MCTI para divulgar as inovações tecnológicas do brasil e um folheto de conscientização da importância da higienização e os cuidados para a proteção contra o COVID além de jogos infantis como um quebra cabeça.</p>\n<p style="text-align: justify;">O CINTESP.Br® “Sabemos que a educação é o futuro de todas as nações e o pilar da inclusão, socialização, saúde e qualidade de vida vem desenvolvendo ações sociais, um projeto em que visa levar a conscientização e o conhecimento as crianças do caninho da inclusão e da importância do respeito as pessoas com deficiência e doenças raras<strong>, </strong>Segundo a Coord. Geral do CINSTESP.Br Daniela Yoshida Levar o conhecimento de forma lúdica inclusiva a criança é um trabalho para garantir um futuro com igualdade sem diferenças. Este foi um posto discutido na reunião e reforçado pela a pediatra, Márcia Berbert. De acordo com Tânia Mesquita, a presidente da ADVEM, o material será distribuído para as famílias atendidas pela instituição. “Já vamos iniciar essa distribuição hoje, com as famílias que vieram receber nossas doações de cestas com verduras”, disse a presidente da ADVEM.</p>\n<p style="text-align: justify;">A doação do kit, com o exemplar do livro “CRESCER”, fez parte das atividades alusiva à Semana Internacional do Livro Infantil, celebrado no dia 2 de abril.  O Livro criado pelo CINTESP.Br® em parceria com o Grupo Luta Pela Vida, Faculdade de Educação Física e Fisioterapia- FAEFI, com o apoio do Ministério de Ciência, Tecnologia e Inovação – MCTI.</p>\n<p style="text-align: justify;">De forma interativa o livro apresenta histórias para despertar na criança conceitos como igualdade, acessibilidade, inclusão, respeito e tecnologia assistiva interagindo com as diversidades inerentes de cada criança. Os exemplares facilitarão de forma lúdica as crianças e adultos compreenderem na vida real o caminho da igualdade com o objetivo de contribuir na formação das crianças e no desenvolvimento e inclusão da criança com deficiência e doença rara.</p>\n<p>[/vc_column_text][vc_row_inner][vc_column_inner css=&#8221;.vc_custom_1618057752683{margin-bottom: -15px !important;}&#8221;][vc_single_image image=&#8221;5654&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][/vc_column_inner][/vc_row_inner][vc_column_text css=&#8221;.vc_custom_1618058573048{margin-top: -20px !important;padding-top: -10px !important;}&#8221;]Imagens cedidas: Oficinas Advem</p>\n<p>[/vc_column_text][vc_column_text]</p>\n<p style="text-align: justify;">A ADVEM é uma Instituição Não Governamental que atende famílias em situação de vulnerabilidade econômica e social na cidade de Uberlândia. Em seus Programas busca promover ações socioassistenciais, visando a convivência e o fortalecimento de vínculos familiares, através do desenvolvimento de atividades educativas, culturais, assistência social, lazer, esportivas e na área de assistência social à saúde em benefício da comunidade de baixa renda. Em suas ações desenvolve atividades no Contra Turno Escolar com atividades escolares e de lazer e esporte, na geração de renda com Curso de Artesanato para jovens e adultos, no apoio ao menor infrator com o Programa de atendimento aos adolescentes infratores encaminhados pelo CREAS – Centro de Referência Especializado de Assistência Social e com o Programa de Assistência Social à Saúde realiza diversos atendimentos na área da saúde como: odontológico, oftalmológico.</p>\n<p>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text]Considerando a Semana Internacional do Livro Infantil e o dia Mundial da Saúde, o CINTESP.Br® realizou a distribuição e forma de doação de exemplares de material lúdico para o estímulo à leitura e a inclusão.[/vc_column_text][vc_row_inner][vc_column_inner width=&#8221;1/6&#8243;][/vc_column_inner][vc_column_inner width=&#8221;2/3&#8243;][vc_single_image image=&#8221;5673&#8243; img_size=&#8221;400&#215;400&#8243; alignment=&#8221;center&#8221;][/vc_column_inner][vc_column_inner width=&#8221;1/6&#8243;][/vc_column_inner][/vc_row_inner][vc_column_text]Presidente da ADVEM, Tânia Mesquita e a pediatra Márcia Berbert recebendo kits lúdicos pedagógicos na&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5684,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-5672",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5672",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5672",
                },
            ],
            "version-history": [
                {
                    count: 16,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5672/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8059,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5672/revisions/8059",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5684",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5672",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5672",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5672",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5652,
        date: "2021-04-07T14:28:05",
        date_gmt: "2021-04-07T17:28:05",
        guid: {
            rendered: "https://cintespbr.org/?p=5652",
        },
        modified: "2021-12-27T23:02:50",
        modified_gmt: "2021-12-28T02:02:50",
        slug: "leitura-diversao-e-acessibilidade",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/leitura-diversao-e-acessibilidade/",
        title: {
            rendered: "LEITURA DIVERSÃO E ACESSIBILIDADE",
        },
        content: {
            rendered:
                '<p><em><strong>Cristiane de Paula Ascom/CINTESP.Br</strong></em></p>\n<h4>Na semana Internacional do Livro Infantil a ação do CINTESP. Br é para o estímulo à leitura e a inclusão. Em comemoração à semana Internacional do Livro Infantil, o CINTESP.Br fará a doação de exemplares do Livro “Caminhos da inclusão “CRESCER”</h4>\n<div id="attachment_5653" style="width: 464px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5653" class="wp-image-5653" src="https://cintespbr.org/wp-content/uploads/2021/04/Sem-titulo-1-1-300x200.png" alt="" width="454" height="302" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/04/Sem-titulo-1-1-300x200.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/Sem-titulo-1-1-1024x681.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/Sem-titulo-1-1-768x511.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/Sem-titulo-1-1.png 1085w" sizes="(max-width: 454px) 100vw, 454px" /><p id="caption-attachment-5653" class="wp-caption-text">Imagem: Livro “Crescer”</p></div>\n<p style="text-align: justify;">A leitura é um dos caminhos para aventura e promoção o desenvolvimento da criança, aproveitando a Semana Internacional do Livro o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos – CINTESP.Br®, em parceria com o Ministério da Ciência Tecnologia e Inovação- MCTI fará uma Ação Social, no dia 8 de abril, às 15h, na sede da Associação Desenvolvendo Vida e Missão – ADVEM, em Uberlândia, fará a doação de 200 exemplares do livro “Crescer”.</p>\n<p style="text-align: justify;">O livro faz parte do Projeto “Recursos Metodológicos Lúdicos Pedagógicos Acessíveis para Inclusão” é uma produção interdisciplinar desenvolvido pelo CINTESP.Br® apoiado pelo MCTI para promover a inclusão na educação da criança com deficiência e doenças raras.</p>\n<p style="text-align: justify;">De forma interativa o livro apresenta histórias para despertar na criança conceitos como igualdade, acessibilidade, inclusão, respeito e tecnologia assistiva interagindo com as diversidades inerentes de cada criança. Os exemplares facilitarão de forma lúdica as crianças e adultos compreenderem na vida real o caminho da igualdade com o objetivo de contribuir na formação das crianças e no desenvolvimento e inclusão da criança com deficiência e doença rara.</p>\n<div id="attachment_5654" style="width: 663px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5654" class="wp-image-5654" src="https://cintespbr.org/wp-content/uploads/2021/04/c-300x63.png" alt="" width="653" height="137" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/04/c-300x63.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/c-1024x214.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/c-768x160.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/c-1536x321.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/c-2048x428.png 2048w" sizes="(max-width: 653px) 100vw, 653px" /><p id="caption-attachment-5654" class="wp-caption-text">Imagens cedidas: Oficinas Advem</p></div>\n<p style="text-align: justify;">A  ADVEM é uma Instituição Não Governamental que atende famílias em situação de vulnerabilidade econômica e social na cidade de  Uberlândia. Em seus Programas busca promover ações socioassistenciais, visando a convivência e o fortalecimento de vínculos familiares, através do desenvolvimento de atividades educativas, culturais, assistência social, lazer, esportivas e na área de assistência social à saúde em benefício da comunidade de baixa renda. Em suas ações desenvolve atividades no  Contra Turno Escolar com atividades escolares e de lazer e esporte, na geração de renda com Curso de Artesanato para jovens e adultos, no apoio ao menor infrator com o Programa de atendimento aos adolescentes infratores encaminhados pelo CREAS – Centro de Referência Especializado de Assistência Social e com o Programa de Assistência Social à Saúde realiza diversos atendimentos na área da saúde como: odontológico, oftalmológico.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Cristiane de Paula Ascom/CINTESP.Br Na semana Internacional do Livro Infantil a ação do CINTESP. Br é para o estímulo à leitura e a inclusão. Em comemoração à semana Internacional do Livro Infantil, o CINTESP.Br fará a doação de exemplares do Livro “Caminhos da inclusão “CRESCER” A leitura é um dos caminhos para aventura e promoção&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5609,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-5652",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5652",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5652",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5652/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5655,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5652/revisions/5655",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5609",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5652",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5652",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5652",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5634,
        date: "2021-04-06T16:32:48",
        date_gmt: "2021-04-06T19:32:48",
        guid: {
            rendered: "https://cintespbr.org/?p=5634",
        },
        modified: "2022-07-11T23:13:43",
        modified_gmt: "2022-07-12T02:13:43",
        slug: "paratletismo-brasileiro-e-a-tecnologia-para-alta-performace",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/paratletismo-brasileiro-e-a-tecnologia-para-alta-performace/",
        title: {
            rendered:
                "PARATLETISMO BRASILEIRO E  A TECNOLOGIA PARA ALTA PERFORMANCE",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;5637&#8243; img_size=&#8221;300&#215;300&#8243; add_caption=&#8221;yes&#8221; alignment=&#8221;center&#8221; lazy_loading=&#8221;true&#8221;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;5636&#8243; img_size=&#8221;300&#215;300&#8243;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: center;"><strong>O Campeão mineiro de Tênis de quadra em Cadeiras de Rodas testará novo equipamento para melhorar o desempenho nos jogos </strong></p>\n<p style="text-align: justify;"><em>     O </em>CINTESP.Br®<em>, inicia em Uberlândia, o processo de validação de um dos seus equipamentos desenvolvidos voltados para o esporte paralímpico e vida diária. O equipamento de alta tecnologia e inovador permitirá fazer a prescrição completa e individual da pessoa com deficiência e doença rara para a fabricação personalizada de careira de rodas.</em></p>\n<p style="text-align: justify;">      O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos &#8211; CINTESP.Br®, parte integrante da Universidade Federal de Uberlândia-MG é uma iniciativa do Ministério da Ciência, Tecnologia e Inovação (MCTI) para o desenvolvimento de Tecnologia Assistiva.</p>\n<p style="text-align: justify;">      A “Metodologia do equipamento permite a Prescrição de Cadeiras de Rodas personalizadas” é um Projeto inovador no mundo em prescrição de cadeira de rodas personalizadas para o esporte e para vida diária. O Equipamento faz parte de linhas de pesquisa dedicado ao esporte paralímpico, dentro dos cinco tópicos de pesquisas do CINTESP.Br®, que atua também com pesquisas na Saúde, Educação, Esporte, Lazer e Vida diária para pessoas com deficiência e doenças raras em parceria com MCTI apoiando as políticas públicas do Governo Federal em acessibilidade e inclusão.</p>\n<p style="text-align: justify;">      O Projeto consiste em um equipamento que permitirá a fabricação de uma cadeira de rodas personalizada a partir de informações individuais de cada pessoa com deficiência. No caso do paratleta, jogador de tênis, os dados que farão parte do processo de fabricação da cadeira de rodas personalizada, levam em conta a experiência em quadra, as medidas do corpo do atleta, as condições clínicas e cognitivas bem como os movimentos de ação e reação durante o jogo. as informações serão colocadas no equipamento que permitirá a modelagem da cadeira de rodas.</p>\n<p style="text-align: justify;">      A segunda etapa dos testes será realizado dia 08 às 10h as Sede do CINTESP.Br®, na Arena Sabiazinho, em Uberlândia pelo paratleta Gustavo Carneiro, campeão mineiro de Tênis em Cadeiras de Rodas, Campeão Mineiro e Brasileiro de Peteca, Campeão Brasileiro de Squash e está entre os 40 melhores paratletas jogadores de tênis, no Ranking Mundial.</p>\n<p style="text-align: justify;">      O paratleta irá submeter o equipamento a diferentes testes biomecânicos seja de propulsão, de conforto, de segurança e de adequação ergonômica. A partir desse conjunto de informações, que também envolve a prescrição parametrizada, o equipamento será configurado e submetido as simulações para oferecer experiências psicomotoras realísticas, até chegar aos parâmetros validados pelo paratleta para a fabricação personalizada da cadeira de rodas.</p>\n<p style="text-align: justify;">     Em todos os Projetos de equipamentos O CINTESP.Br® e CPB trabalham em conjunto para atender à demanda dos paratletas que buscam alta performance e melhor posicionamento no Ranking Mundial.</p>\n<p style="text-align: justify;"><strong>AO VIVO</strong></p>\n<p style="text-align: justify;"><strong>    </strong>O Campeão Gustavo ainda estará ao vivo na quinta-feira, dia 15 de abril, às 14h pelo canal do Instagram do @CINTESP.Br  em um bate papo descontraído o motivador. Gustavo vai falar sobre a importância de incentivar o esporte para crianças os futuros medalhistas do Brasil.</p>\n<p style="text-align: justify;">    Uma iniciativa do CINTESP.Br® onde também serão apresentadas as Ações em tecnologia assistiva na Saúde, educação, esporte, lazer e vida diária e sobre os recursos para levar acessibilidade e inclusão  a todas as pessoas com deficiência, mobilidade reduzida e doenças raras do Brasil para o mundo.</p>\n<p style="text-align: justify;">    A Live acontecerá na Sede do CINTESP.Br®, em Uberlândia, local onde Gustavo fará os testes no equipamento para fabricação da cadeira de rodas personalizada, “um sonho para alcançar desempenho dos grandes campeões mundiais.”, disse Gustavo.</p>\n<p>&nbsp;</p>\n<div id="attachment_5635" style="width: 389px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5635" class="wp-image-5635 " src="https://cintespbr.org/wp-content/uploads/2021/04/WhatsApp-Image-2021-04-05-at-17.51.01-300x285.jpeg" alt="" width="379" height="361" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/04/WhatsApp-Image-2021-04-05-at-17.51.01-300x285.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/WhatsApp-Image-2021-04-05-at-17.51.01.jpeg 397w" sizes="(max-width: 379px) 100vw, 379px" /><p id="caption-attachment-5635" class="wp-caption-text">Desenho da cadeira personalizada que será construída a partir das prescrições do equipamento desenvolvido pelo CINTESP.Br, em Uberlândia e testado pelo tenista de quadra paratleta Gustavo Carneiro.</p></div>\n<p>&nbsp;</p>\n<p><em><strong>Créditos: Cristiane de Paula Ascom /CINTESP.Br</strong></em>[/vc_column_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;5637&#8243; img_size=&#8221;300&#215;300&#8243; add_caption=&#8221;yes&#8221; alignment=&#8221;center&#8221; lazy_loading=&#8221;true&#8221;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_single_image image=&#8221;5636&#8243; img_size=&#8221;300&#215;300&#8243;][/vc_column][/vc_row][vc_row][vc_column][vc_column_text] O Campeão mineiro de Tênis de quadra em Cadeiras de Rodas testará novo equipamento para melhorar o desempenho nos jogos      O CINTESP.Br®, inicia em Uberlândia, o processo de validação de um dos seus equipamentos desenvolvidos voltados para o esporte paralímpico e vida diária.&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5637,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-5634",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5634",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5634",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5634/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8074,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5634/revisions/8074",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5637",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5634",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5634",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5634",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5606,
        date: "2021-04-02T23:11:03",
        date_gmt: "2021-04-03T02:11:03",
        guid: {
            rendered: "https://cintespbr.org/?p=5606",
        },
        modified: "2022-07-08T00:00:33",
        modified_gmt: "2022-07-08T03:00:33",
        slug: "acao-social-do-cintespbr-com-apoio-do-ministerio-da-ciencia-tecnologia-e-inovacao-mcti-oferece-leitura-com-diversao-aos-projetos-de-educacao-do-hospital-do-cancer-de-uberlandia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/acao-social-do-cintespbr-com-apoio-do-ministerio-da-ciencia-tecnologia-e-inovacao-mcti-oferece-leitura-com-diversao-aos-projetos-de-educacao-do-hospital-do-cancer-de-uberlandia/",
        title: {
            rendered:
                "Ação Social do CINTESP.Br®, com apoio do Ministério da Ciência, Tecnologia e Inovação &#8211; MCTI oferece leitura com diversão aos Projetos de educação do Hospital do Câncer de Uberlândia.",
        },
        content: {
            rendered:
                '<div id="attachment_5607" style="width: 574px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5607" class="wp-image-5607 size-full" src="https://cintespbr.org/wp-content/uploads/2021/04/1mg-1.png" alt="" width="564" height="376" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/04/1mg-1.png 564w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/1mg-1-300x200.png 300w" sizes="(max-width: 564px) 100vw, 564px" /><p id="caption-attachment-5607" class="wp-caption-text">Foto Ass.Com: GLPV (Viviana Andrade, Analista de Relacionamento GLPV, Daniela Yoshida, Coord. Geral CINTESP.Br, Zaida Afonso- diretora Social GLPV)</p></div>\n<p><em>Assessoria comunicação e Relações Públicas &#8211; CINTESP.Br</em></p>\n<p style="text-align: justify;">A leitura é um caminho para o desenvolvimento e inclusão da criança com deficiência e doença rara, com esta visão o CINTESP.Br® em parceria com o MCTI, vem desenvolvendo projetos na área de recursos metodológicos lúdicos pedagógicos acessíveis promovendo a inclusão por meio da leitura. O CINTESP.Br® compreende que as práticas de incentivo à leitura podem colaborar, com a diversidade, respeitando a etnia, cor, deficiência física, gênero, classe social entre outras, abrindo de fato as portas para a igualdade e a inclusão das pessoas com deficiência e doenças raras na sociedade.</p>\n<p style="text-align: justify;">O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br®), apoiado pelo Ministério da Ciência, Tecnologia e Inovação (MCTI), no desenvolvimento de tecnologia assistiva para pessoas com deficiência e doenças raras dentro de 5 áreas:  Saúde,  educação, esporte, lazer e vida diária.</p>\n<p style="text-align: justify;">É na Educação que o CINTESP.Br® busca apoiar o incentivo à leitura com Ações Sociais por meio de doação de exemplares do Livro “CRESCER”, lançado em 2020 na 17º Semana Nacional de Ciência e Tecnologia em Brasília.</p>\n<p style="text-align: justify;">No primeiro semestre de 2021 está previsto a doação de 1000 (mil) exemplares do livro do Livro “CRESCER” e 500 (quinhentos) Brinquedos.</p>\n<p style="text-align: justify;">Já foram doados, 200 exemplares do livro e brinquedos como quebra-cabeça, dobraduras de foguetes e satélites, óculos com realidade virtual, tabuleiro de dama, com o sentido apoiar as ações humanitárias do Grupo Luta Pela Vida do Hospital do Câncer em Uberlândia, que vem buscando levar a leitura para crianças pacientes internadas na oncopediátricos.</p>\n<p style="text-align: justify;">O livro faz parte do Projeto “Recursos Metodológicos Lúdicos Pedagógicos Acessíveis para Inclusão” é uma produção interdisciplinar desenvolvido pelo CINTESP.Br® apoiado pelo MCTI para promover a inclusão na educação da criança com deficiência e doenças raras.</p>\n<p style="text-align: justify;">De forma interativa o livro apresenta histórias para despertar na criança conceitos como igualdade, acessibilidade, inclusão, respeito e tecnologia assistiva interagindo com as diversidades inerentes de cada criança. Os exemplares facilitarão de forma lúdica as crianças e adultos compreenderem na vida real o caminho da igualdade.</p>\n<div id="attachment_5609" style="width: 351px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-5609" class="wp-image-5609" src="https://cintespbr.org/wp-content/uploads/2021/04/tststs-300x248.png" alt="" width="341" height="282" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/04/tststs-300x248.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/tststs-1024x847.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/tststs-768x635.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/tststs.png 1366w" sizes="(max-width: 341px) 100vw, 341px" /><p id="caption-attachment-5609" class="wp-caption-text">Copyright © Livro Crescer Todos direitos Reservados – CINTESP.Br®</p></div>\n<p style="text-align: justify;">Na última semana de março respeitando as normas de segurança contra a Covid-19, o CINTESP.Br® representado pela coordenadora geral do CINTESP.Br, Daniela Yoshida, realizou a entrega dos livros e brinquedos para as crianças internadas na oncopediátricos e para a brinquedoteca do Hospital do câncer de Uberlândia, que nesta ocasião estava sendo representado pela diretora Social do Grupo Luta Pela Vida  Zaida Afonso, acompanhada pela Analista de Relacionamento do Grupo Luta Pela Vida, Viviana Pereira Andrade e pelo Assistente de Comunicação Guilherme Guedes Dezopa.</p>\n<p style="text-align: justify;">A primeira Ação Social do CINTESP.Br aconteceu em homenagem ao mês do livro infantil, comemorado em abril e vai fazer parte do kit de presentes que serão distribuídos pelo Grupo Luta Pela Vida às crianças, na semana da Páscoa.</p>\n<p><img loading="lazy" decoding="async" class="aligncenter wp-image-5610 " src="https://cintespbr.org/wp-content/uploads/2021/04/dede-300x98.png" alt="" width="643" height="210" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/04/dede-300x98.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/dede-1024x334.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/dede-768x251.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/04/dede.png 1238w" sizes="(max-width: 643px) 100vw, 643px" /></p>\n<p>&nbsp;</p>\n<p style="text-align: justify;">Na oportunidade foram doados brinquedos de montar, quebra-cabeça, óculos infantis para brincadeiras em 3D e livros de pesquisa a respeito de técnicas para atividades para envolver crianças com deficiência visual e apresentados os Projetos da área de Ação Social do CINTESP.Br® que envolve metodologia e ferramentas voltados à Educação, Saúde, Lazer, Vida diária para pessoas com deficiência e doenças raras.</p>\n<p style="text-align: justify;">O Grupo Luta Pela Vida é uma Instituição sem fins lucrativos fundada em 1996 com o objetivo de oferecer melhores condições aos pacientes tratados pelo setor oncológico da Universidade Federal de Uberlândia. Com o apoio da sociedade, o Grupo Luta Pala Vida constrói, equipa e mantém o Hospital do Câncer em Uberlândia, referência no atendimento para 80 municípios. Atualmente com 8.600 pacientes, atendidos nas especialidades de oncologia clínica, quimioterapia, radioterapia, oncopediatria, Hematologia, Internação de adultos e crianças, oferece apoio psicossocial aos pacientes, Cuidados Paliativos e Programas específicos de educação, para as crianças em tratamento e com uma brinquedoteca para minimizar o impacto de um ambiente escolar na rotina das crianças internadas.</p>\n<p style="text-align: justify;">Na visão do CINTESP.Br®, apoiado pelo Ministério da Ciência, Tecnologia e Inovação – MCTI, a acessibilidade, a inclusão social e produtiva são desafios brasileiros importantes, que devem ser objetos de políticas públicas que articulem a ciência, tecnologia e inovação visando à qualidade de vida das pessoas.</p>\n<p>&nbsp;</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Assessoria comunicação e Relações Públicas &#8211; CINTESP.Br A leitura é um caminho para o desenvolvimento e inclusão da criança com deficiência e doença rara, com esta visão o CINTESP.Br® em parceria com o MCTI, vem desenvolvendo projetos na área de recursos metodológicos lúdicos pedagógicos acessíveis promovendo a inclusão por meio da leitura. O CINTESP.Br® compreende que&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5607,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [62],
        tags: [],
        class_list: [
            "post-5606",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-todas-as-noticias",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5606",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5606",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5606/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8055,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5606/revisions/8055",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5607",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5606",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5606",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5606",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5492,
        date: "2021-03-23T16:55:56",
        date_gmt: "2021-03-23T19:55:56",
        guid: {
            rendered: "https://cintespbr.org/?p=5492",
        },
        modified: "2021-12-27T23:05:06",
        modified_gmt: "2021-12-28T02:05:06",
        slug: "natacao-de-uberlandia-rumo-a-paraolimpiada-no-japao",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/natacao-de-uberlandia-rumo-a-paraolimpiada-no-japao/",
        title: {
            rendered: "Natação de Uberlândia rumo à Paraolimpíada no Japão.",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]<img loading="lazy" decoding="async" class="aligncenter wp-image-5497 size-large" src="https://cintespbr.org/wp-content/uploads/2021/03/NATACAO-1024x705.png" alt="" width="1024" height="705" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/NATACAO-1024x705.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/NATACAO-300x206.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/NATACAO-768x528.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/NATACAO-1536x1057.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/NATACAO.png 1891w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p><a href="https://www.cpb.org.br/">Comitê Paralímpico Brasileiro</a> em parceria com o CINTESP.Br<em><sup>® </sup></em> apoiado pelo MCTI contribuindo para o alto rendimento dos nadadores convocados de Uberlândia.[/vc_column_text]<style type="text/css" data-type="the7_shortcodes-inline-css">#default-btn-7d2fdaaf090ea549e4e3296e7995ed44.ico-right-side > i {\n  margin-right: 0px;\n  margin-left: 8px;\n}\n#default-btn-7d2fdaaf090ea549e4e3296e7995ed44 > i {\n  margin-right: 8px;\n}\n</style><div class="btn-align-center"><a href="url:https%3A%2F%2Fgloboesporte.globo.com%2Fmg%2Ftriangulo-mineiro%2F|target:_blank" class="default-btn-shortcode dt-btn dt-btn-m link-hover-off" id="default-btn-7d2fdaaf090ea549e4e3296e7995ed44" style="width:300px;"><span>CONFIRA A REPORTAGEM NA ÍNTEGRA</span></a></div>[/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Comitê Paralímpico Brasileiro em parceria com o CINTESP.Br®  apoiado pelo MCTI contribuindo para o alto rendimento dos nadadores convocados de Uberlândia.[/vc_column_text][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5497,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 57, 62],
        tags: [],
        class_list: [
            "post-5492",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-destaque-2",
            "category-todas-as-noticias",
            "category-47",
            "category-57",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5492",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5492",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5492/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5498,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5492/revisions/5498",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5497",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5492",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5492",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5492",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5463,
        date: "2021-03-21T22:21:13",
        date_gmt: "2021-03-22T01:21:13",
        guid: {
            rendered: "https://cintespbr.org/?p=5463",
        },
        modified: "2021-12-27T23:02:50",
        modified_gmt: "2021-12-28T02:02:50",
        slug: "rede-colaborativa-uniao-de-esforcos-pela-producao-cientifica-em-tecnologia-assistiva",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/rede-colaborativa-uniao-de-esforcos-pela-producao-cientifica-em-tecnologia-assistiva/",
        title: {
            rendered:
                "REDE COLABORATIVA UNIÃO DE ESFORÇOS PELA PRODUÇÃO CIENTÍFICA EM TECNOLOGIA ASSISTIVA",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="alignnone wp-image-5464 size-large" src="https://cintespbr.org/wp-content/uploads/2021/03/Destacada-redes-1024x640.png" alt="" width="1024" height="640" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Destacada-redes-1024x640.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Destacada-redes-300x188.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Destacada-redes-768x480.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Destacada-redes.png 1287w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p style="text-align: justify;"><em>O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (</em>CINTESP.Br<em><sup>®</sup></em><em>), apoiado pelo Ministério da Ciência, Tecnologia e Inovação (MCTI) e instalado em Uberlândia-MG, realizou no primeiro semestre importante avanço pela otimização das pesquisas brasileiras voltadas à educação, esporte, lazer e vida diária e em especial ao esporte paralímpico.</em></p>\n<p style="text-align: justify;">Em plena pandemia os pesquisadores do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br<em><sup>®</sup></em>), com os pesquisadores trabalhando dentro de todas as regras de segurança epidemiológica não desaceleram o ritmo dos trabalhos.</p>\n<p style="text-align: justify;"> O Centro tem a composição multidisciplinar voltado a ciência, tecnologia e inovação em Tecnologia Assistiva nas áreas da pesquisa e extensão e desenvolvimento, atuando em forma de rede colaborativa com o setor acadêmico, entidades de pesquisa, sociedade, instituições publicas e privadas. O conceito de trabalho em rede busca fortalecer, otimizar reduzir o custo das pesquisas resultando em menor tempo do projeto à transferência de tecnologia, desenvolvidas nas instituições públicas e privadas visando auxiliar a promoção das políticas de C,T&amp;I, diretamente ligadas à Tecnológica Assistiva(TA). E 2021 os trabalhos então voltados para o conceito em rede colaborativa o que permitirá o que é desenvolvido na área acadêmica chegar mais rapidamente até a população.</p>\n<p style="text-align: justify;">A estratégia veio do MCTI com a criação, no final do ano passado, o Centro Nacional de Tecnologia (CNT), em parceria com o CINTESP.Br<em><sup>®</sup></em>, a Universidade Federal de Uberlândia (UFU), o Comitê Paralímpico Brasileiro (CPB), a Fundação Uberlandense De Turismo Esporte e Lazer (FUTEL) e o Grupo Algar.</p>\n<p style="text-align: justify;">O principal objetivo é o de promover Políticas Públicas que viabilizem a apropriação das inovações tecnológicas ao setor industrial e às práticas esportivas paralímpicas. O principal objetivo é acelerar a pesquisa, extensão e o desenvolvimento de inovações na área de Tecnologia Assistiva, visando a melhoria da qualidade de vida das pessoas com deficiência e doenças raras, o aumento da inclusão social a inclusão produtiva e o apoio aos atletas paralímpicos do início ao alto rendimento, atuando diretamente na saúde, educação, esporte, lazer e vida diária.</p>\n<p style="text-align: justify;">A parceria passa a ser interministerial envolvendo diversos Ministérios em especial o Ministério da Saúde e o Ministério da Mulher, da Família e dos Direitos Humanos (MMFDH), que atuarão em parceria com MCTI para identificar as demandas da população em tecnologia assistiva para que as novas tecnologias desenvolvidas pelos pesquisadores nacionais e internacionais se conectem pela Rede Colaborativa com o setor produtivo e instituições não governamentais otimizando assim a entrega à sociedade brasileira, público alvo para tecnologia assistiva.</p>\n<p style="text-align: justify;">A plataforma que está sendo desenvolvida pelo MCTI vai servir de banco de dados que será alimentada pelas diversas áreas do Governo Federal e pela rede de colaboradores, para que o CNT possa conhecer e trabalhar no atendimento a demanda da população e o resultado de todo o trabalho chegar à sociedade em menor tempo, menor custo e dependendo o mínimo de tecnologia externa.</p>\n<p style="text-align: left;"><em>Assessoria de comunicação CINTESP.Br<sup>®</sup></em></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br®), apoiado pelo Ministério da Ciência, Tecnologia e Inovação (MCTI) e instalado em Uberlândia-MG, realizou no primeiro semestre importante avanço pela otimização das pesquisas brasileiras voltadas à educação, esporte, lazer e vida diária e em especial ao esporte paralímpico. Em plena pandemia os pesquisadores&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5466,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-5463",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5463",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5463",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5463/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5479,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5463/revisions/5479",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5466",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5463",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5463",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5463",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5453,
        date: "2021-03-18T23:12:05",
        date_gmt: "2021-03-19T02:12:05",
        guid: {
            rendered: "https://cintespbr.org/?p=5453",
        },
        modified: "2021-12-27T23:02:50",
        modified_gmt: "2021-12-28T02:02:50",
        slug: "nota-de-pesar",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/nota-de-pesar/",
        title: {
            rendered: "Nota de Pesar",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-5455 size-large" src="https://cintespbr.org/wp-content/uploads/2021/03/homenagem-1-1024x650.png" alt="" width="1024" height="650" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/homenagem-1-1024x650.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/homenagem-1-300x190.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/homenagem-1-768x488.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/homenagem-1-1536x975.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/homenagem-1.png 2048w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n',
            protected: false,
        },
        excerpt: {
            rendered: "",
            protected: false,
        },
        author: 4,
        featured_media: 5455,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-5453",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5453",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5453",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5453/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5456,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5453/revisions/5456",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5455",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5453",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5453",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5453",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5409,
        date: "2021-03-18T20:47:06",
        date_gmt: "2021-03-18T23:47:06",
        guid: {
            rendered: "https://cintespbr.org/?p=5409",
        },
        modified: "2021-12-27T22:49:46",
        modified_gmt: "2021-12-28T01:49:46",
        slug: "live-o-cerebro-na-sindrome-de-down",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/live-o-cerebro-na-sindrome-de-down/",
        title: {
            rendered: "LIVE &#8211; O Cérebro na Síndrome de Down",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<p><img loading="lazy" decoding="async" class="aligncenter wp-image-5410 size-large" src="https://cintespbr.org/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-18-at-19.28.36-1024x1024.jpeg" alt="" width="1024" height="1024" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-18-at-19.28.36-1024x1024.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-18-at-19.28.36-300x300.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-18-at-19.28.36-150x150.jpeg 150w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-18-at-19.28.36-768x768.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/WhatsApp-Image-2021-03-18-at-19.28.36.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<h4>No dia 21 de março, domingo às 15 horas, será realizado uma LIVE no Instagram, com o tema: <strong>“O cérebro na Síndrome de Down”.</strong></h4>\n<p>O <a href="https://www.instagram.com/drluizgeneticista/">Dr. Luiz Roberto da Silva</a>, Médico Geneticista e Pediatra, conversará com os especialistas convidados <a href="https://www.instagram.com/nivea.macedo.5/">Dra. Nívea Macedo</a>, Médica Neuropediatra, e o <a href="https://www.instagram.com/camposmarcos91/">Dr. Marcos Campos</a>, Médico Neurologista,  a respeito desse assunto tão relevante, celebrando o dia internacional da Síndrome de Down.[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/6&#8243;][/vc_column][vc_column width=&#8221;2/3&#8243;][vc_single_image image=&#8221;5412&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221; onclick=&#8221;custom_link&#8221; link=&#8221;https://www.instagram.com/drluizgeneticista/&#8221;][/vc_column][vc_column width=&#8221;1/6&#8243;][/vc_column][/vc_row][vc_row][vc_column][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] No dia 21 de março, domingo às 15 horas, será realizado uma LIVE no Instagram, com o tema: “O cérebro na Síndrome de Down”. O Dr. Luiz Roberto da Silva, Médico Geneticista e Pediatra, conversará com os especialistas convidados Dra. Nívea Macedo, Médica Neuropediatra, e o Dr. Marcos Campos, Médico Neurologista,  a respeito desse&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5429,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [62, 46],
        tags: [],
        class_list: [
            "post-5409",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-todas-as-noticias",
            "category-ultimas-noticias",
            "category-62",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5409",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5409",
                },
            ],
            "version-history": [
                {
                    count: 11,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5409/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5426,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5409/revisions/5426",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5429",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5409",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5409",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5409",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5386,
        date: "2021-03-12T18:58:10",
        date_gmt: "2021-03-12T21:58:10",
        guid: {
            rendered: "https://cintespbr.org/?p=5386",
        },
        modified: "2022-05-18T15:34:01",
        modified_gmt: "2022-05-18T18:34:01",
        slug: "vacina-nasal-brasileira-contra-a-covid-19-estara-em-testes-clinicos-em-humanos-este-ano",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/vacina-nasal-brasileira-contra-a-covid-19-estara-em-testes-clinicos-em-humanos-este-ano/",
        title: {
            rendered:
                "VACINA NASAL BRASILEIRA CONTRA A COVID-19 ESTARÁ EM TESTES CLINICOS EM HUMANOS ESTE ANO",
        },
        content: {
            rendered:
                '<p style="text-align: justify;"><img loading="lazy" decoding="async" class="wp-image-5387 alignleft" src="https://cintespbr.org/wp-content/uploads/2021/03/158885082_245790410529308_6074798204873026730_n-300x300.jpg" alt="" width="418" height="418" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/158885082_245790410529308_6074798204873026730_n-300x300.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/158885082_245790410529308_6074798204873026730_n-1024x1024.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/158885082_245790410529308_6074798204873026730_n-150x150.jpg 150w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/158885082_245790410529308_6074798204873026730_n-768x768.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/03/158885082_245790410529308_6074798204873026730_n.jpg 1080w" sizes="(max-width: 418px) 100vw, 418px" />Uma vacina nasal brasileira contra o SARS-CoV-2, o vírus causador da Covid-19, entrará em fase de testes clínicos em humanos no segundo semestre deste ano. As pesquisas sobre a vacina, que poderá ter total produção nacional, estão em fase de desenvolvimento, sob a coordenação dos grupos de pesquisa liderados pelos doutores Jorge Kalil, professor titular de Imunologia Clínica e Alergia da Faculdade de Medicina da Universidade de São Paulo (USP) e diretor do laboratório de Imunologia do Incor, e Ricardo Gazinelli, diretor do Centro de Tecnologia de Vacinas e professor titular de Imunologia e Bioquímica da Universidade Federal de Minas Gerais (UFMG). O doutor Gazinelli também é diretor do laboratório de Imunologia da FIOCRUZ de Belo Horizonte.</p>\n<p style="text-align: justify;">Ambos são, ainda, bolsistas de Produtividade em Pesquisa do CNPq/MCTI e coordenadores de Institutos Nacionais de Ciência e Tecnologia (INCT), programa coordenado pelo CNPq/MCTI e Ministério da Ciência, Tecnologia e Inovações (MCTI): o Instituto Nacional de Ciência e Tecnologia de Vacinas (INCTV) e o Instituto de Investigação em Imunologia (iii-INCT). O financiamento, pelo MCTI, do estudo, no valor aproximado de R$ 6 milhões, repassado pelo CNPq/MCTI, é parte dos recursos extraordinários liberados por meio de medidas provisórias no ano passado, para o combate à Covid-19.</p>\n<p>Leia a matéria completa em www.gov.br/cnpq</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Uma vacina nasal brasileira contra o SARS-CoV-2, o vírus causador da Covid-19, entrará em fase de testes clínicos em humanos no segundo semestre deste ano. As pesquisas sobre a vacina, que poderá ter total produção nacional, estão em fase de desenvolvimento, sob a coordenação dos grupos de pesquisa liderados pelos doutores Jorge Kalil, professor titular&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5387,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 62],
        tags: [],
        class_list: [
            "post-5386",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-todas-as-noticias",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5386",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5386",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5386/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5388,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5386/revisions/5388",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5387",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5386",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5386",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5386",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5351,
        date: "2021-03-08T18:03:34",
        date_gmt: "2021-03-08T21:03:34",
        guid: {
            rendered: "https://cintespbr.org/?p=5351",
        },
        modified: "2021-05-15T22:36:40",
        modified_gmt: "2021-05-16T01:36:40",
        slug: "mulheres-a-voz-que-faz-a-diferenca",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/mulheres-a-voz-que-faz-a-diferenca/",
        title: {
            rendered: "MULHERES, A VOZ QUE FAZ A DIFERENÇA",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<p style="text-align: justify;">Na semana do Dia Internacional da Mulher o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos – CINTESP.Br®&#xfe0f; homenageia as mulheres que nunca desistiram de suas causas, mesmo com deficiências, com doenças raras, lutaram pelo direito à igualdade, à acessibilidade e à inclusão. O CINTESP.Br®&#xfe0f;, por meio de seus pesquisadores e pesquisadoras vem buscando, há 12 anos, tecnologias e ferramentas para somar à força e à coragem dessas mulheres brasileiras.<br />\nO CINTESP.Br®&#xfe0f; traz esta homenagem em uma breve linha histórica com a representatividade das mulheres brasileiras que marcaram suas passagens pela história de nossa nação.</p>\n<h4 style="text-align: justify;"><strong>Sobre o CINTESP.Br®&#xfe0f;</strong></h4>\n<p style="text-align: justify;">O CINTESP.Br®&#xfe0f; é um Centro institucional multidisciplinar de pesquisa e extensão, voltado para ciência, tecnologia e inovação em Tecnologia Assistiva, da Universidade Federal de Uberlândia -UFU, tem o apoio do Ministério da Ciência, Tecnologia e Inovações – MCTI e do Ministério da Mulher, da Família e dos Direitos Humanos &#8211; MMFDH. Entre suas principais funções está a de desenvolver inovações tecnológicas voltadas para as pessoas com deficiência, com mobilidade reduzida e doenças raras, a fim de proporcionar acessibilidade, a autonomia e a inclusão na saúde, na educação, no esporte, lazer e na vida diária.<br />\nO CINTESP.Br®&#xfe0f;, iniciou sua história na luta voltada para as pessoas com deficiência e pessoas com doenças raras, a fim de proporcionar acessibilidade, a autonomia e a inclusão social. Neste sentido vem desenvolvendo atividades com o apoio de duas grandes mulheres.<br />\nDentre as homenageadas o CINTESP.Br®&#xfe0f; apresenta duas mulheres que estão na frente dos ousados Programas do CINTESP.Br®&#xfe0f;; a secretária de articulação e promoção da ciência do MCTI, Christiane Corrêa que defende a aplicação da ciência, tecnologia e inovações na interferência direta no cotidiano das mulheres de todas as classes sociais para oferecer inclusão, acessibilidade para melhor qualidade de vida. E dentro do CINTESP.Br®&#xfe0f; os trabalhos da Coordenadora Geral, Daniela Moura Yoshida, que entre as ações que desenvolve criou o Departamento Aplicado aos Raros, Educação, Inclusão e Saúde – DAREIS.</p>\n<p>[/vc_column_text]<style type="text/css" data-type="the7_shortcodes-inline-css">.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav a {\n  width: 36px;\n  height: 36px;\n  border-radius: 500px;\n}\n.dt-arrow-border-on.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav a:not(:hover):before {\n  border-width: 0px;\n}\n.dt-arrow-hover-border-on.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav a:hover:after {\n  border-width: 0px;\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav a.owl-prev {\n  top: 50%;\n  transform: translateY(calc(-50% + 0px));\n  left: -43px;\n}\n@media all and (-ms-high-contrast: none) {\n  .gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav a.owl-prev {\n    transform: translateY(-50%);\n    margin-top: 0px;\n  }\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav a.owl-prev i {\n  padding: 0px 0px 0px 0px;\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav a.owl-next {\n  top: 50%;\n  transform: translateY(calc(-50% + 0px));\n  right: -43px;\n}\n@media all and (-ms-high-contrast: none) {\n  .gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav a.owl-next {\n    transform: translateY(-50%);\n    margin-top: 0px;\n  }\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav a.owl-next i {\n  padding: 0px 0px 0px 0px;\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav i {\n  font-size: 18px;\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav a:not(:hover) i,\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav a:not(:hover) i:before {\n  color: #ffffff;\n  background: none;\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav a:hover i,\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-nav a:hover i:before {\n  color: rgba(255,255,255,0.75);\n  background: none;\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-dots {\n  top: calc(100% + 20px);\n  left: 50%;\n  transform: translateX(calc(-50% + 0px));\n}\n@media all and (-ms-high-contrast: none) {\n  .gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-dots {\n    transform: translateX(-50%);\n    margin-left: 0px;\n  }\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .owl-dot {\n  width: 10px;\n  height: 10px;\n  margin: 0 8px;\n}\n@media screen and (max-width: 778px) {\n  .gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d.hide-arrows .owl-nav a {\n    display: none;\n  }\n}\n@media screen and (max-width: 778px) {\n  .gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d.reposition-arrows .owl-nav .owl-prev {\n    top: 50%;\n    transform: translateY(calc(-50% + 0px));\n    left: 10px;\n  }\n  .gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d.reposition-arrows .owl-nav .owl-next {\n    top: 50%;\n    transform: translateY(calc(-50% + 0px));\n    right: 10px;\n  }\n}\n@media screen and (max-width: 778px) and all and (-ms-high-contrast: none) {\n  .gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d.reposition-arrows .owl-nav .owl-prev {\n    transform: translateY(-50%);\n    margin-top: 0px;\n  }\n}\n@media screen and (max-width: 778px) and all and (-ms-high-contrast: none) {\n  .gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d.reposition-arrows .owl-nav .owl-next {\n    transform: translateY(-50%);\n    margin-top: 0px;\n  }\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d figure,\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .rollover,\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d img,\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d .gallery-rollover {\n  border-radius: 0px;\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d.enable-bg-rollover .gallery-rollover {\n  background: -webkit-linear-gradient();\n  background: linear-gradient();\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d.enable-img-shadow .owl-stage-outer {\n  padding: 14px 0;\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d.enable-bg-rollover.hover-scale figure .rollover:after {\n  background: -webkit-linear-gradient();\n  background: linear-gradient();\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d.gallery-shortcode .gallery-zoom-ico {\n  width: 44px;\n  height: 44px;\n  line-height: 44px;\n  border-radius: 100px;\n  margin: -22px 0 0 -22px;\n  border-width: 0px;\n}\n.dt-icon-bg-on.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d.gallery-shortcode .gallery-zoom-ico {\n  background: rgba(255,255,255,0.3);\n  box-shadow: none;\n}\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d.gallery-shortcode .gallery-zoom-ico:before,\n.gallery-carousel-shortcode.gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d.gallery-shortcode .gallery-zoom-ico span {\n  font-size: 32px;\n  line-height: 44px;\n  color: #ffffff;\n  background: none;\n}\n</style><div class="owl-carousel gallery-carousel-shortcode gallery-shortcode  dt-gallery-container dt-owl-carousel-call gallery-carousel-shortcode-id-3a15e49d29799ec4657def139cfc737d quick-scale-img enable-bg-rollover meta-info-off dt-arrow-border-on dt-arrow-hover-border-on bullets-small-dot-stroke reposition-arrows dt-icon-bg-off arrows-bg-on disable-arrows-hover-bg arrows-hover-bg-on hover-fade " data-scroll-mode="1" data-col-num="6" data-wide-col-num="6" data-laptop-col="5" data-h-tablet-columns-num="4" data-v-tablet-columns-num="3" data-phone-columns-num="1" data-col-gap="10" data-stage-padding="0" data-speed="600" data-autoplay="false" data-autoplay_speed="6000" data-arrows="true" data-bullet="false" data-next-icon="icon-ar-017-r" data-prev-icon="icon-ar-017-l" data-img-shadow-size="12px" data-img-shadow-spread="3px"><div data-post-id="5345" data-date="2021-03-08T17:43:42-03:00" data-name="Daniela Moura Yoshida diretora de comunicação e relações internacionais _ CINTESP.Br"><figure class="post"><a href="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Daniela-Moura-Yoshida-diretora-de-comunicacao-e-relacoes-internacionais-_-CINTESP.Br_.jpeg" class="rollover dt-pswp-item layzr-bg" data-large_image_width="972" data-large_image_height="990" data-dt-img-description="" title="Daniela Moura Yoshida diretora de comunicação e relações internacionais _ CINTESP.Br"><img decoding="async" class="preload-me owl-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20972%20972&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Daniela-Moura-Yoshida-diretora-de-comunicacao-e-relacoes-internacionais-_-CINTESP.Br_.jpeg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Daniela-Moura-Yoshida-diretora-de-comunicacao-e-relacoes-internacionais-_-CINTESP.Br_.jpeg 972w" loading="eager" style="--ratio: 972 / 972" sizes="(max-width: 972px) 100vw, 972px" alt="" width="972" height="972"  /><span class="gallery-rollover"><span class="gallery-zoom-ico icomoon-the7-font-the7-zoom-06"><span></span></span></span></a></figure></div><div data-post-id="5343" data-date="2021-03-08T17:43:37-03:00" data-name="Carolina de Jesus Quarto de despejo, lançado em 1960"><figure class="post"><a href="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Carolina-de-Jesus-Quarto-de-despejo-lancado-em-1960.jpg" class="rollover dt-pswp-item layzr-bg" data-large_image_width="1024" data-large_image_height="614" data-dt-img-description="" title="Carolina de Jesus Quarto de despejo, lançado em 1960"><img decoding="async" class="preload-me owl-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20614%20614&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Carolina-de-Jesus-Quarto-de-despejo-lancado-em-1960.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Carolina-de-Jesus-Quarto-de-despejo-lancado-em-1960.jpg 614w" loading="eager" style="--ratio: 614 / 614" sizes="(max-width: 614px) 100vw, 614px" alt="" width="614" height="614"  /><span class="gallery-rollover"><span class="gallery-zoom-ico icomoon-the7-font-the7-zoom-06"><span></span></span></span></a></figure></div><div data-post-id="5349" data-date="2021-03-08T17:43:49-03:00" data-name="Zilda Arns Fundadora da Pastoral da Criança"><figure class="post"><a href="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Zilda-Arns-Fundadora-da-Pastoral-da-Crianca.jpg" class="rollover dt-pswp-item layzr-bg" data-large_image_width="630" data-large_image_height="430" data-dt-img-description="" title="Zilda Arns Fundadora da Pastoral da Criança"><img decoding="async" class="preload-me owl-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20430%20430&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Zilda-Arns-Fundadora-da-Pastoral-da-Crianca.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Zilda-Arns-Fundadora-da-Pastoral-da-Crianca.jpg 430w" loading="eager" style="--ratio: 430 / 430" sizes="(max-width: 430px) 100vw, 430px" alt="" width="430" height="430"  /><span class="gallery-rollover"><span class="gallery-zoom-ico icomoon-the7-font-the7-zoom-06"><span></span></span></span></a></figure></div><div data-post-id="5359" data-date="2021-03-08T18:14:49-03:00" data-name="Valentina Tereshkova primeira mulher a ter ido ao espaço"><figure class="post"><a href="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Valentina-Tereshkova-primeira-mulher-a-ter-ido-ao-espaco-.jpeg" class="rollover dt-pswp-item layzr-bg" data-large_image_width="680" data-large_image_height="453" data-dt-img-description="" title="Valentina Tereshkova primeira mulher a ter ido ao espaço"><img decoding="async" class="preload-me owl-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20453%20453&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Valentina-Tereshkova-primeira-mulher-a-ter-ido-ao-espaco-.jpeg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Valentina-Tereshkova-primeira-mulher-a-ter-ido-ao-espaco-.jpeg 453w" loading="eager" style="--ratio: 453 / 453" sizes="(max-width: 453px) 100vw, 453px" alt="" width="453" height="453"  /><span class="gallery-rollover"><span class="gallery-zoom-ico icomoon-the7-font-the7-zoom-06"><span></span></span></span></a></figure></div><div data-post-id="5347" data-date="2021-03-08T17:43:47-03:00" data-name="Raimunda Putani Yawnawá _ Pajé Yawnawá"><figure class="post"><a href="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Raimunda-Putani-Yawnawa-_-Paje-Yawnawa.jpg" class="rollover dt-pswp-item layzr-bg" data-large_image_width="630" data-large_image_height="420" data-dt-img-description="" title="Raimunda Putani Yawnawá _ Pajé Yawnawá"><img decoding="async" class="preload-me owl-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20420%20420&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Raimunda-Putani-Yawnawa-_-Paje-Yawnawa.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Raimunda-Putani-Yawnawa-_-Paje-Yawnawa.jpg 420w" loading="eager" style="--ratio: 420 / 420" sizes="(max-width: 420px) 100vw, 420px" alt="" width="420" height="420"  /><span class="gallery-rollover"><span class="gallery-zoom-ico icomoon-the7-font-the7-zoom-06"><span></span></span></span></a></figure></div><div data-post-id="5346" data-date="2021-03-08T17:43:45-03:00" data-name="Lara Lima paratleta halteres CPB"><figure class="post"><a href="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Lara-Lima-paratleta-halteres-CPB.jpg" class="rollover dt-pswp-item layzr-bg" data-large_image_width="2048" data-large_image_height="1277" data-dt-img-description="" title="Lara Lima paratleta halteres CPB"><img decoding="async" class="preload-me owl-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%201277%201277&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Lara-Lima-paratleta-halteres-CPB.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Lara-Lima-paratleta-halteres-CPB.jpg 1277w" loading="eager" style="--ratio: 1277 / 1277" sizes="(max-width: 1277px) 100vw, 1277px" alt="" width="1277" height="1277"  /><span class="gallery-rollover"><span class="gallery-zoom-ico icomoon-the7-font-the7-zoom-06"><span></span></span></span></a></figure></div><div data-post-id="5344" data-date="2021-03-08T17:43:40-03:00" data-name="Christiane Corrêa Secretária de Articulação e Promoção _ MCTI,"><figure class="post"><a href="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Christiane-Correa-Secretaria-de-Articulacao-e-Promocao-_-MCTI.jpeg" class="rollover dt-pswp-item layzr-bg" data-large_image_width="1280" data-large_image_height="853" data-dt-img-description="" title="Christiane Corrêa Secretária de Articulação e Promoção _ MCTI,"><img decoding="async" class="preload-me owl-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20853%20853&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Christiane-Correa-Secretaria-de-Articulacao-e-Promocao-_-MCTI.jpeg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Christiane-Correa-Secretaria-de-Articulacao-e-Promocao-_-MCTI.jpeg 853w" loading="eager" style="--ratio: 853 / 853" sizes="(max-width: 853px) 100vw, 853px" alt="" width="853" height="853"  /><span class="gallery-rollover"><span class="gallery-zoom-ico icomoon-the7-font-the7-zoom-06"><span></span></span></span></a></figure></div><div data-post-id="5342" data-date="2021-03-08T17:43:36-03:00" data-name="Carlota Pereira de Queirós _Médica e deputada"><figure class="post"><a href="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Carlota-Pereira-de-Queiros-_Medica-e-deputada.jpg" class="rollover dt-pswp-item layzr-bg" data-large_image_width="620" data-large_image_height="350" data-dt-img-description="" title="Carlota Pereira de Queirós _Médica e deputada"><img decoding="async" class="preload-me owl-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20350%20350&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Carlota-Pereira-de-Queiros-_Medica-e-deputada.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/Carlota-Pereira-de-Queiros-_Medica-e-deputada.jpg 350w" loading="eager" style="--ratio: 350 / 350" sizes="(max-width: 350px) 100vw, 350px" alt="" width="350" height="350"  /><span class="gallery-rollover"><span class="gallery-zoom-ico icomoon-the7-font-the7-zoom-06"><span></span></span></span></a></figure></div></div>[/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Na semana do Dia Internacional da Mulher o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos – CINTESP.Br®&#xfe0f; homenageia as mulheres que nunca desistiram de suas causas, mesmo com deficiências, com doenças raras, lutaram pelo direito à igualdade, à acessibilidade e à inclusão. O CINTESP.Br®&#xfe0f;, por meio de seus pesquisadores e pesquisadoras&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5362,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [58],
        tags: [],
        class_list: [
            "post-5351",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-hoomenagem",
            "category-58",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5351",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5351",
                },
            ],
            "version-history": [
                {
                    count: 8,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5351/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5868,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5351/revisions/5868",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5362",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5351",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5351",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5351",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5254,
        date: "2021-03-04T21:27:08",
        date_gmt: "2021-03-05T00:27:08",
        guid: {
            rendered: "https://cintespbr.org/?p=5254",
        },
        modified: "2021-12-27T23:06:45",
        modified_gmt: "2021-12-28T02:06:45",
        slug: "paratletas-de-uberlandia-concluem-o-treino-com-a-selecao-brasileira-de-halterofilismo-realizado-em-sp-rumo-a-paraolimpiada-de-toquio",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/paratletas-de-uberlandia-concluem-o-treino-com-a-selecao-brasileira-de-halterofilismo-realizado-em-sp-rumo-a-paraolimpiada-de-toquio/",
        title: {
            rendered:
                "PARATLETAS DE UBERLÂNDIA CONCLUEM O TREINO COM A SELEÇÃO BRASILEIRA DE HALTEROFILISMO REALIZADO EM SP RUMO À PARAOLIMPÍADA DE TÓQUIO",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_column_text]</p>\n<div dir="auto">\n<p style="text-align: justify;">Foram 5 dias de treino focado nas vagas para as Paraolimíadas de Tóquio. Eles voltam para Uberlândia cheios de energia e otimistas com os resultados. Mateus Assis, Lara Lima paratletas de halterofilismo e o treinador Weverton Santos da equipe do Clube Desportivo para Deficientes de Uberlândia – CDDU, associação parceira da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel) concluíram, agora pela manhã, o último dia de treino em equipe com os paratletas da seleção brasileira que aconteceu no Centro de Treinamento Paraolímpico, em São Paulo.</p>\n<p style="text-align: left;">Os treinos com a Seleção Brasileira de halterofilismo aconteceram no Centro de Treinamento Paralímpico, em São Paulo.</p>\n<p style="text-align: justify;">A equipe, na foto feita pelo treinador Weverton, estão os paratletas: Lara Lima e Mateus Assis de Uberlândia, Bruno Carra e Mariana Andrea de Itu/Sp, Evânio Rodrigues da Bahia, Ailton Bento da Paraíba, João França da Natal/RN eTayana Madeiros do Rio de Janeiro. Ainda somam a equipe os treinadores Weverton Santos, Valdecir Lopes e Carlos Willians e mais um técnico convidado Felipe Aidar.</p>\n<p style="text-align: justify;">No início do ano outro paratleta também já treinou em São Paulo, Mateus Carvalho e o assistente esportivo Oscar Carvalho foram convocados para a primeira fase de treinamento da seleção brasileira de bocha paralímpica.</p>\n<div class="nc684nl6" style="text-align: justify;"><a href="https://www.gov.br/mcti/pt-br">Ministério da Ciência, Tecnologia e Inovações</a></div>\n<div class="nc684nl6" style="text-align: justify;"><a href="https://www.cpb.org.br/">Comitê Paralímpico Brasileiro &#8211; CPB</a></div>\n</div>\n<p>[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column]<style type="text/css" data-type="the7_shortcodes-inline-css">.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a figure,\n.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a .rollover,\n.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a img,\n.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a .gallery-rollover {\n  border-radius: 0px;\n}\n.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.enable-bg-rollover .gallery-rollover {\n  background: -webkit-linear-gradient();\n  background: linear-gradient();\n}\n.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.enable-bg-rollover.hover-scale figure .rollover:after {\n  background: -webkit-linear-gradient();\n  background: linear-gradient();\n}\n.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a .gallery-zoom-ico {\n  width: 44px;\n  height: 44px;\n  line-height: 44px;\n  border-radius: 100px;\n  margin: -22px 0 0 -22px;\n  border-width: 0px;\n  color: #ffffff;\n}\n.dt-icon-bg-on.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a .gallery-zoom-ico {\n  background: rgba(255,255,255,0.3);\n  box-shadow: none;\n}\n.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a .gallery-zoom-ico:before,\n.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a .gallery-zoom-ico span {\n  font-size: 32px;\n  line-height: 44px;\n  color: #ffffff;\n}\n.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a:not(.resize-by-browser-width) .dt-css-grid {\n  grid-row-gap: 10px;\n  grid-column-gap: 10px;\n  grid-template-columns: repeat(auto-fill,minmax(,1fr));\n}\n.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a:not(.resize-by-browser-width) .dt-css-grid .double-width {\n  grid-column: span 2;\n}\n.cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a:not(.resize-by-browser-width) .dt-css-grid,\n.no-cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a:not(.resize-by-browser-width) .dt-css-grid {\n  display: flex;\n  flex-flow: row wrap;\n  margin: -5px;\n}\n.cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a:not(.resize-by-browser-width) .dt-css-grid .wf-cell,\n.no-cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a:not(.resize-by-browser-width) .dt-css-grid .wf-cell {\n  flex: 1 0 ;\n  max-width: 100%;\n  padding: 5px;\n  box-sizing: border-box;\n}\n.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid {\n  grid-template-columns: repeat(3,1fr);\n  grid-template-rows: auto;\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n}\n.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .double-width {\n  grid-column: span 2;\n}\n.cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid {\n  margin: -5px;\n}\n.cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell {\n  width: 33.333333333333%;\n  padding: 5px;\n}\n.cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell.double-width {\n  width: calc(33.333333333333%) * 2;\n}\n.gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width:not(.centered-layout-list):not(.content-bg-on) .dt-css-grid {\n  grid-row-gap: 10px - ;\n}\n@media screen and (max-width: 1199px) {\n  .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid {\n    grid-template-columns: repeat(3,1fr);\n  }\n  .cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell,\n  .no-cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell {\n    width: 33.333333333333%;\n  }\n  .cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell.double-width,\n  .no-cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell.double-width {\n    width: calc(33.333333333333%)*2;\n  }\n}\n@media screen and (max-width: 991px) {\n  .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid {\n    grid-template-columns: repeat(2,1fr);\n  }\n  .cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell,\n  .no-cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell {\n    width: 50%;\n  }\n  .cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell.double-width,\n  .no-cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell.double-width {\n    width: calc(50%)*2;\n  }\n}\n@media screen and (max-width: 767px) {\n  .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid {\n    grid-template-columns: repeat(2,1fr);\n  }\n  .cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell,\n  .no-cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell {\n    width: 50%;\n  }\n  .cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell.double-width,\n  .no-cssgridlegacy.no-cssgrid .gallery-shortcode.gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a.resize-by-browser-width .dt-css-grid .wf-cell.double-width {\n    width: calc(50%)*2;\n  }\n}\n</style><div class="gallery-shortcode dt-gallery-container gallery-masonry-shortcode-id-c49f1b18a56c86821c31396b082c159a mode-grid jquery-filter dt-icon-bg-off quick-scale-img dt-css-grid-wrap enable-bg-rollover resize-by-browser-width hover-fade loading-effect-none description-on-hover" data-padding="5px" data-cur-page="1" data-post-limit="-1" data-pagination-mode="none" data-desktop-columns-num="3" data-v-tablet-columns-num="2" data-h-tablet-columns-num="3" data-phone-columns-num="2" data-width="0px" data-columns="0"><div class="dt-css-grid" ><div class="wf-cell" data-post-id="5257" data-date="2021-03-06T21:24:30-03:00" data-name="156222981_536278587773263_3084690955688561084_o"><figure class="post visible"><a href="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/156222981_536278587773263_3084690955688561084_o.jpg" class="rollover dt-pswp-item layzr-bg" data-large_image_width="1280" data-large_image_height="622" data-dt-img-description="" title="156222981_536278587773263_3084690955688561084_o"><img decoding="async" class="preload-me iso-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20490%20490&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/156222981_536278587773263_3084690955688561084_o.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/156222981_536278587773263_3084690955688561084_o.jpg 490w" loading="eager" style="--ratio: 490 / 490" sizes="(max-width: 490px) 100vw, 490px" alt="" width="490" height="490"  /><span class="gallery-rollover"><span class="gallery-zoom-ico icomoon-the7-font-the7-zoom-06"><span></span></span></span></a></figure></div><div class="wf-cell" data-post-id="5258" data-date="2021-03-06T21:24:35-03:00" data-name="156353095_536278584439930_4337987988949728216_o"><figure class="post visible"><a href="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/156353095_536278584439930_4337987988949728216_o.jpg" class="rollover dt-pswp-item layzr-bg" data-large_image_width="1280" data-large_image_height="622" data-dt-img-description="" title="156353095_536278584439930_4337987988949728216_o"><img decoding="async" class="preload-me iso-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20490%20490&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/156353095_536278584439930_4337987988949728216_o.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/156353095_536278584439930_4337987988949728216_o.jpg 490w" loading="eager" style="--ratio: 490 / 490" sizes="(max-width: 490px) 100vw, 490px" alt="" width="490" height="490"  /><span class="gallery-rollover"><span class="gallery-zoom-ico icomoon-the7-font-the7-zoom-06"><span></span></span></span></a></figure></div><div class="wf-cell" data-post-id="5259" data-date="2021-03-06T21:24:37-03:00" data-name="156543291_536278574439931_9087606484140212136_o"><figure class="post visible"><a href="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/156543291_536278574439931_9087606484140212136_o.jpg" class="rollover dt-pswp-item layzr-bg" data-large_image_width="1280" data-large_image_height="622" data-dt-img-description="" title="156543291_536278574439931_9087606484140212136_o"><img decoding="async" class="preload-me iso-lazy-load aspect" src="data:image/svg+xml,%3Csvg%20xmlns%3D&#39;http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&#39;%20viewBox%3D&#39;0%200%20490%20490&#39;%2F%3E" data-src="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/156543291_536278574439931_9087606484140212136_o.jpg" data-srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/03/156543291_536278574439931_9087606484140212136_o.jpg 490w" loading="eager" style="--ratio: 490 / 490" sizes="(max-width: 490px) 100vw, 490px" alt="" width="490" height="490"  /><span class="gallery-rollover"><span class="gallery-zoom-ico icomoon-the7-font-the7-zoom-06"><span></span></span></span></a></figure></div></div><!-- iso-container|iso-grid --></div>[/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_column_text] Foram 5 dias de treino focado nas vagas para as Paraolimíadas de Tóquio. Eles voltam para Uberlândia cheios de energia e otimistas com os resultados. Mateus Assis, Lara Lima paratletas de halterofilismo e o treinador Weverton Santos da equipe do Clube Desportivo para Deficientes de Uberlândia – CDDU, associação parceira da Fundação Uberlandense do&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5258,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-5254",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5254",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5254",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5254/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5262,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5254/revisions/5262",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5258",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5254",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5254",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5254",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5316,
        date: "2021-03-04T13:17:18",
        date_gmt: "2021-03-04T16:17:18",
        guid: {
            rendered: "https://cintespbr.org/?p=5316",
        },
        modified: "2021-12-27T23:07:06",
        modified_gmt: "2021-12-28T02:07:06",
        slug: "paratletas-da-equipe-cddu-futel-sao-convocados-para-selecao-brasileira-de-halterofilismo",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/paratletas-da-equipe-cddu-futel-sao-convocados-para-selecao-brasileira-de-halterofilismo/",
        title: {
            rendered:
                "Paratletas da equipe CDDU/Futel são convocados para seleção brasileira de halterofilismo",
        },
        content: {
            rendered:
                '<h3>TREINAMENTOS TÊM COMO OBJETIVO PREPARAR A EQUIPE PARA COMPETIÇÕES INTERNACIONAIS</h3>\n<div class="elementor-element elementor-element-8c17f03 elementor-widget elementor-widget-theme-post-featured-image elementor-widget-image" data-id="8c17f03" data-element_type="widget" data-widget_type="theme-post-featured-image.default">\n<div class="elementor-widget-container">\n<div class="elementor-image">\n<figure class="wp-caption"><img loading="lazy" decoding="async" class="attachment-full size-full" src="https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Halterofilismo-Sele%C3%A7%C3%A3o-brasileira.jpg" sizes="(max-width: 1280px) 100vw, 1280px" srcset="https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Halterofilismo-Seleção-brasileira.jpg 1280w, https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Halterofilismo-Seleção-brasileira-300x225.jpg 300w, https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Halterofilismo-Seleção-brasileira-768x576.jpg 768w, https://www.uberlandia.mg.gov.br/wp-content/uploads/2021/03/Halterofilismo-Seleção-brasileira-1024x768.jpg 1024w" alt="" width="1280" height="960" /><figcaption class="widget-image-caption wp-caption-text"></figcaption></figure>\n</div>\n</div>\n</div>\n<div class="elementor-element elementor-element-27b24a0 elementor-widget elementor-widget-theme-post-content" data-id="27b24a0" data-element_type="widget" data-widget_type="theme-post-content.default">\n<div class="elementor-widget-container">\n<p style="text-align: justify;">Os paratletas do Clube Desportivo para Deficientes de Uberlândia (CDDU) – associação parceira da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel) – Lara Lima e Mateus Assis e o treinador Weverton Santos foram convocados para participar, ao longo dessa semana, da primeira fase de treinamento da seleção brasileira de halterofilismo paralímpico. O evento tem como objetivo preparar a equipe para competições internacionais previstas para 2021 e está sendo realizado no Centro de Treinamento Paralímpico, em São Paulo.</p>\n<p style="text-align: justify;">De acordo com o profissional de educação física da Futel e treinador da equipe  e da seleção brasileira de halterofilismo, Weverton Santos, foram convocados apenas oito paratletas em todo o país, sendo dois deles de Uberlândia. “Isso demonstra a qualidade do trabalho realizado pela Prefeitura de Uberlândia, por meio da Futel, junto ao paradesporto na cidade. Nossa expectativa é ter uma boa semana de treinamento para que possamos alcançar excelentes resultados nas competições internacionais de 2021 e garantir uma vaga nas Paralimpíadas de Tóquio”, destacou.</p>\n<p style="text-align: justify;"><strong>Paratletas</strong></p>\n<p style="text-align: left;">Lara Lima e Mateus Assis têm uma série de conquistas nacionais e internacionais no halterofilismo paralímpico. Dentre elas estão a medalha de ouro de Mateus na Copa do Mundo de Halterofilismo 2020, na Nigéria, e as duas medalhas de prata de Lara na mesma competição.</p>\n</div>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>TREINAMENTOS TÊM COMO OBJETIVO PREPARAR A EQUIPE PARA COMPETIÇÕES INTERNACIONAIS Os paratletas do Clube Desportivo para Deficientes de Uberlândia (CDDU) – associação parceira da Fundação Uberlandense do Turismo, Esporte e Lazer (Futel) – Lara Lima e Mateus Assis e o treinador Weverton Santos foram convocados para participar, ao longo dessa semana, da primeira fase de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5317,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-5316",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5316",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5316",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5316/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5318,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5316/revisions/5318",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5317",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5316",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5316",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5316",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5128,
        date: "2021-02-26T11:38:55",
        date_gmt: "2021-02-26T14:38:55",
        guid: {
            rendered: "https://cintespbr.org/?p=5128",
        },
        modified: "2021-12-27T23:07:06",
        modified_gmt: "2021-12-28T02:07:06",
        slug: "centro-de-treinamento-paralimpico-e-primordial-na-preparacao-da-selecao-brasileira-de-volei-sentado",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/centro-de-treinamento-paralimpico-e-primordial-na-preparacao-da-selecao-brasileira-de-volei-sentado/",
        title: {
            rendered:
                "Centro de Treinamento Paralímpico é primordial na preparação da Seleção Brasileira de Vôlei Sentado",
        },
        content: {
            rendered:
                '<div class="row img-main align_center">\n<div class="imagem-principal-detalhe">\n<p><img decoding="async" class="img-responsive" src="https://www.cpb.org.br/upload/noticia/da11413359e340e6aa310572b8c2397b.JPG" alt="Seleção Brasileira feminina de vôlei sentado ficará no CT Paralímpico, em SP, até sábado, 28. Foto: Divulgação CBVD" /></p>\n<div class="ssk-sticky ssk-center ssk-lg"></div>\n</div>\n<p>Seleção Brasileira feminina de vôlei sentado ficará no CT Paralímpico, em SP, até sábado, 28. Foto: Divulgação CBVD</p>\n</div>\n<div class="texto">\n<p>A volta da Seleção Brasileira Feminina de Vôlei Sentado ao Centro de Treinamento Paralímpico Brasileiro é primordial para o aperfeiçoamento e preparação das atletas que vão competir nos Jogos Paralímpicos de Tóquio, em agosto deste ano.</p>\n<p>Boa parte das atletas que hoje compõem o time, assim como a comissão técnica e a equipe da Confederação Brasileira de Voleibol para Deficientes (CBVD) se fazem presentes no CT durante toda esta semana, de 21 a 28 de fevereiro, para a realização de treinos intensos e diários.</p>\n<p>Segundo o técnico da seleção, Agtonio Guedes, a logística do CT não só facilita o desenvolvimento dos treinos, como ajuda e muito no rendimento das jogadoras. “O CT é muito importante para todos os esportes paralímpicos, especialmente para o voleibol sentado. Aqui não gastamos tempo com mobilidade do hotel pro local de treino, e isso faz com que o tempo de descanso das atletas seja maior. Consequentemente, elas ficam mais preparadas para a alta carga de treino que programamos para esses dias”, conta.</p>\n<p>O Centro de Treinamento oferece tudo em um só lugar, como alojamento, quadra, restaurante, academia e piscina para <em>recovery.</em> “Estamos muito felizes com o retorno e a realização dos nossos treinos de forma sistematizada. Em janeiro, trabalhamos em Aracaju e menos de um mês depois estamos novamente reunidos. Essa continuidade que o Comitê Paralímpico Brasileiro e a CBVD estão proporcionando é muito importante para a Seleção do vôlei sentado”, acrescenta Guedes.</p>\n<p>Ainda de acordo com o técnico, a previsão é que o time continue com a fase de treinamentos mensal até julho. “Estamos num processo de evolução, ainda na segunda fase pós-pandemia. A partir de agora, naturalmente, elas vão evoluir nos quesitos técnicos, táticos e físicos. O foco desta semana está no nosso sistema ofensivo, levantamento, ataque e, principalmente, passe”, explica Agtonio Guedes.</p>\n<p>Para a jogadora Laiana Rodrigues, fazer parte da seleção brasileira e ter sido convocada para esse intensivão é muito gratificante. Além de que, as fases de treinos no CT são indispensáveis e se fazem necessárias nesse momento. “Tivemos aí um bom tempo sem treino de quadra tendo que ficar em casa. Mas, durante esse período, adaptamos nosso ambiente para poder fazer os treinamentos cognitivos e algumas coisas relacionadas a técnica. Recebemos toda assistência mesmo de forma virtual, então, deu pra suprir”.</p>\n<p>Durante toda esta semana da 2ª fase de treinamento 2021, são realizados dois treinos diários com bola na quadra. “Normalmente, treino quatro vezes por semana num tempo de três horas cada. Tem também toda uma preocupação em se alimentar e estar bem psicologicamente, para que a gente possa ter um bom desempenho em quadra”, observa a atleta profissional Laiana.</p>\n<p>Para outras meninas que sonham em fazer parte da seleção brasileira, ela aconselha: “Não desistam! A gente ainda tem poucas atletas no Brasil porque falta mais coragem de ousar e acreditar que esse sonho é possível. Ter o esporte como carreira é muito especial pra mim, é maravilhoso, e foi sempre um sonho desde adolescente. Hoje, a maior vontade e desejo é conquistar a medalha de ouro”, finaliza Laiana Rodrigues.</p>\n<p><em>*Com informações da Confederação Brasileira de Voleibol para Deficientes (CBVD)</em></p>\n<p><strong>FONTE: Assessoria de Comunicação do Comitê Paralímpico Brasileiro (imp@cpb.org.br)</strong></p>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Seleção Brasileira feminina de vôlei sentado ficará no CT Paralímpico, em SP, até sábado, 28. Foto: Divulgação CBVD A volta da Seleção Brasileira Feminina de Vôlei Sentado ao Centro de Treinamento Paralímpico Brasileiro é primordial para o aperfeiçoamento e preparação das atletas que vão competir nos Jogos Paralímpicos de Tóquio, em agosto deste ano. Boa&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5129,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [57, 34, 62],
        tags: [],
        class_list: [
            "post-5128",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-destaque-2",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-57",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5128",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5128",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5128/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5140,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5128/revisions/5140",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5129",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5128",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5128",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5128",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5131,
        date: "2021-02-25T11:41:30",
        date_gmt: "2021-02-25T14:41:30",
        guid: {
            rendered: "https://cintespbr.org/?p=5131",
        },
        modified: "2021-12-27T23:07:06",
        modified_gmt: "2021-12-28T02:07:06",
        slug: "rodolpho-riskalla-vence-primeira-competicao-do-ano-de-adestramento-no-catar",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/rodolpho-riskalla-vence-primeira-competicao-do-ano-de-adestramento-no-catar/",
        title: {
            rendered:
                "Rodolpho Riskalla vence primeira competição do ano de adestramento no Catar",
        },
        content: {
            rendered:
                '<div class="row img-main align_center">\n<div class="imagem-principal-detalhe">\n<p><img decoding="async" class="img-responsive" src="https://www.cpb.org.br/upload/noticia/006388b1c1fd4cf5beb2f944149d1b01.jpg" alt="Rodolpho Riskalla com Don Henrico participam da primeira competição de 2021 em Doha. Foto: in2strides" /></p>\n<div class="ssk-sticky ssk-center ssk-lg"></div>\n</div>\n<p>Rodolpho Riskalla com Don Henrico participam da primeira competição de 2021 em Doha. Foto: in2strides</p>\n</div>\n<div class="texto">\n<p>O cavaleiro brasileiro Rodolpho Riskalla retornou nesta quinta-feira, 25, com força total ao picadeiro no Concurso Internacional CPEDI3 Shaqab, em Doha, no Catar. Rodolpho montou Don Henrico, experiente hannoverano de 18 anos, e venceu a prova Grau IV com expressivos 76,468% de aproveitamento. Em segundo lugar, chegou a top holandesa Lotte Krijnsen, montando Rosenstolz, com 72,542%.</p>\n<p>&#8220;Fiquei supercontente com minha prova. O Don Henrico está muito bem e conseguir competir &#8211; meio a essa situação da Covid-19 em que muitas provas são canceladas &#8211; é muito importante na preparação para os Jogos Paralímpicos. Agora temos mais dois dias de prova e tenho que continuar indo bem&#8221;, destacou Rodolpho.</p>\n<p>E não é de hoje que Rodolpho &#8211; forte candidato a medalha em Tóquio &#8211; vence no fantástico estádio Al Shaqab, em Doha. Tanto em 2019 e 2020, o cavaleiro faturou a 1ª colocação nas três provas que disputou.</p>\n<p>Rodolpho, hoje com 37 anos, pratica adestramento desde a infância e aderiu ao adestramento paraequestre no início de 2016 seis meses após a perda da parte inferior das duas pernas, a mão direita e dedo da mão esquerda em decorrência de uma meningite. Menos de um ano depois defendeu o país nos Jogos Paralímpicos Rio 2016 e, em 2018, foi o melhor brasileiro nos Jogos Equestres Mundiais 2018 nos EUA com duas medalhas de prata no adestramento paraquestre.</p>\n<p>O cavaleiro reside na França há cerca de 10 anos e recém mudou para Alemanha, onde conta com três cavalos a sua disposição. Além do adestramento paraquestre, Rodolpho também compete com sucesso em provas de adestramento convencional. Don Henrico, sua montaria na competição esse final de semana em Doha, é de propriedade da ex-amazona olímpica alemã Ann Katrin Lisenhof.</p>\n<p>No Adestramento Paraquestre, as disputas são divididas em cinco graus &#8211; I,II,III,IV e V &#8211; grau de dificuldade crescente de acordo com a classificação funcional do atleta.</p>\n<p><em>*Com informações da Confederação Brasileira de Hipismo (CBH)</em></p>\n<p><strong>FONTE: Assessoria de Comunicação do Comitê Paralímpico Brasileiro (imp@cpb.org.br)</strong></p>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Rodolpho Riskalla com Don Henrico participam da primeira competição de 2021 em Doha. Foto: in2strides O cavaleiro brasileiro Rodolpho Riskalla retornou nesta quinta-feira, 25, com força total ao picadeiro no Concurso Internacional CPEDI3 Shaqab, em Doha, no Catar. Rodolpho montou Don Henrico, experiente hannoverano de 18 anos, e venceu a prova Grau IV com expressivos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5132,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-5131",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5131",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5131",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5131/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5141,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5131/revisions/5141",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5132",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5131",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5131",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5131",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5144,
        date: "2021-02-25T05:56:51",
        date_gmt: "2021-02-25T08:56:51",
        guid: {
            rendered: "https://cintespbr.org/?p=5144",
        },
        modified: "2021-12-27T22:49:46",
        modified_gmt: "2021-12-28T01:49:46",
        slug: "adolescentes-poliglotas-em-contexto-remoto-abre-edital-para-tres-novas-turmas",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/adolescentes-poliglotas-em-contexto-remoto-abre-edital-para-tres-novas-turmas/",
        title: {
            rendered:
                "Adolescentes Poliglotas em Contexto Remoto&#8217; abre edital para três novas turmas",
        },
        content: {
            rendered:
                '<h3>Projeto oferece um total de 45 vagas a estudantes do Ensino Fundamental, entre 11 e 14 anos; inscrições ocorrem nos dias 1º e 2 de março</h3>\n<div class="caption caption-center">\n<div class="caption-width-container"></div>\n</div>\n<p><img loading="lazy" decoding="async" class="aligncenter wp-image-5145 size-full" src="https://cintespbr.org/wp-content/uploads/2021/02/imagem_destaque_foto_poliglotas_trace_effects.jpeg" alt="" width="961" height="718" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/02/imagem_destaque_foto_poliglotas_trace_effects.jpeg 961w, https://cintespbr.institucional.ws/wp-content/uploads/2021/02/imagem_destaque_foto_poliglotas_trace_effects-300x224.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/02/imagem_destaque_foto_poliglotas_trace_effects-768x574.jpeg 768w" sizes="(max-width: 961px) 100vw, 961px" /></p>\n<p>A Diretoria de Relações Internacionais e Interinstitucionais da Universidade Federal de Uberlândia (DRII/UFU) lança <a href="http://www.comunica.ufu.br/sites/comunica.ufu.br/files/conteudo/noticia/anexo_edital_poliglotas_fevereiro_2021.pdf" target="_blank" rel="noopener"><strong>EDITAL</strong></a> para novas turmas do projeto de extensão &#8220;Adolescentes Poliglotas em Contexto Remoto&#8221;. O programa ajuda no aprendizado e familiarização de adolescentes com os idiomas espanhol, francês e inglês e suas respectivas culturas. As incrições têm início às 12h do dia 1º de março (segunda-feira) e vão até as 12 horas do dia seguinte.</p>\n<p>Estão sendo ofertadas 45 vagas, sendo 15 para cada uma das três turmas, sempre às quartas-feiras: das 10h às 11h30; das 13h às 14h30; e das 15h às 16h30. Para participar do projeto, é necessário que o estudante tenha entre 11 e 14 anos e comprove que está cursando os últimos anos do Ensino Fundamental (do 6º ao 9º anos). Além disso, o aluno deve ter a disponibilidade de frequentar uma hora e meia de aulas <em>on-lines</em> semanais no Google Meet e duas horas e meia semanais para as tarefas de casa.</p>\n<p>O projeto &#8220;Adolescentes Poliglotas em Contexto Remoto&#8221; é uma ação de interface do Instituto de Letras e Linguística (ILEEL/UFU) e da DRII com o objetivo de propiciar uma postura plurilíngue e de acolhimento da diversidade.</p>\n<p>&nbsp;</p>\n<p><strong>Procedimentos</strong></p>\n<p>As inscrições devem ser feitas exclusivamente por meio do <strong><u><a href="https://docs.google.com/forms/d/e/1FAIpQLSd-3cwQlhdAzN424R1oK5Jq6HasopNEKQ69t_Y4ExYtwnPB7w/closedform" target="_blank" rel="noopener">formulário <em>on-line</em></a></u></strong>. Os candidatos precisam preencher o formulário e fazer <em>upload</em> dos documentos obrigatórios, que são as cópias da cédula de identidade (RG) ou da Certidão de Nascimento e do documento comprobatório que o estudante está cursando as séries finais do Ensino Fundamental.</p>\n<p>O resultado do processo de inscrição será via <em>e-mail</em> e WhatsApp indicados no formulário de inscrição, informando posicionamento na lista de inscritos ou de espera.</p>\n<p>&nbsp;</p>\n<div class="field-label">Autor:  Gabriel Caixeta</div>\n<div>Fonte: http://www.comunica.ufu.br</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Projeto oferece um total de 45 vagas a estudantes do Ensino Fundamental, entre 11 e 14 anos; inscrições ocorrem nos dias 1º e 2 de março A Diretoria de Relações Internacionais e Interinstitucionais da Universidade Federal de Uberlândia (DRII/UFU) lança EDITAL para novas turmas do projeto de extensão &#8220;Adolescentes Poliglotas em Contexto Remoto&#8221;. O programa ajuda no&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5145,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [62, 46],
        tags: [],
        class_list: [
            "post-5144",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-todas-as-noticias",
            "category-ultimas-noticias",
            "category-62",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5144",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5144",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5144/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5293,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5144/revisions/5293",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5145",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5144",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5144",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5144",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5134,
        date: "2021-02-24T11:43:33",
        date_gmt: "2021-02-24T14:43:33",
        guid: {
            rendered: "https://cintespbr.org/?p=5134",
        },
        modified: "2021-12-27T23:07:06",
        modified_gmt: "2021-12-28T02:07:06",
        slug: "selecao-brasileira-de-judo-retorna-ao-ct-paralimpico-com-foco-em-readaptacao-tecnica",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/selecao-brasileira-de-judo-retorna-ao-ct-paralimpico-com-foco-em-readaptacao-tecnica/",
        title: {
            rendered:
                "Seleção Brasileira de judô retorna ao CT Paralímpico com foco em readaptação técnica",
        },
        content: {
            rendered:
                '<div>\n<div class="detalhe-texto ">\n<div class="row img-main align_center">\n<div class="imagem-principal-detalhe">\n<p><img decoding="async" class="img-responsive" src="https://www.cpb.org.br/upload/noticia/29dce65d59964424bc64a77af8c97efe.jpg" alt="Foto: Alê Cabral / CPB" /></p>\n<div class="ssk-sticky ssk-center ssk-lg"></div>\n</div>\n<p>Foto: Alê Cabral / CPB</p>\n</div>\n<div class="texto">\n<p>Treze judocas estão no Centro de Treinamento Paralímpico, em São Paulo, para a primeira fase de treinamento da Seleção Brasileira de 2021.  Eles ficarão concentrados no local até o domingo, 28. É a primeira vez que a equipe nacional se reúne depois da interrupção dos treinos presenciais devido à pandemia de covid-19.</p>\n<p>Para promover o retorno dos atletas, o Comitê Paralímpico Brasileiro (CPB) submeteu todos os atletas desta modalidade aos critérios exigidos pelo protocolo sanitário elaborado desde <a href="https://cpb.org.br/noticia/detalhe/2966/dez-informacoes-importantes-sobre-a-reabertura-parcial-do-ct-paralimpico" target="_blank" rel="noopener"><u><strong>a reabertura parcial do CT, em julho do ano passado.</strong></u></a></p>\n<p>O plano de retorno deste ano inclui a área de hospedagem do local, que prevê, no máximo, duas pessoas por acomodação e que todas as refeições serão servidas nos quartos. Não será permitido o uso do restaurante ou áreas comuns do residencial.</p>\n<p>“Durante toda a pandemia, monitoramos os atletas à distância. Cada atleta tinha uma realidade e passou por dificuldades bem particulares, então tivemos que adaptar o treinamento individualmente. Esta fase é importantíssima para avaliarmos as condições dos atletas. Para isso, estamos realizando avaliações de força e potência, por meio de teste isocinético, da plataforma de salto, teste de preensão manual e composição corporal. Além disso, os atletas vão precisar de um tempo para readaptação técnica, que eles deverão conquistar com os treinamentos”, explicou Jaime Bragança, técnico da Seleção Brasileira de judô.</p>\n<p>Um dos atletas convocados é a paulista do Guarujá Giulia Pereira, que foi a responsável por levar o judô brasileiro ao lugar mais alto do pódio no primeiro dia de disputas nos Jogos Parapan-Americanos de Lima 2019. A judoca de 21 anos nasceu prematura, no quinto mês de gestação, e com 30% da visão, e, ao passar dos anos, perdeu a visão gradativamente.</p>\n<p>“É uma felicidade gigantesca voltar ao CT. Parece que é a minha primeira convocação. No meio do momento que estamos passando, estamos seguindo todo o protocolo e os treinos estão cada vez melhores. Seguimos na preparação para os Jogos Paralímpicos de Tóquio”, relatou Giulia, que é da categoria até 48kg.</p>\n<h2><strong>Confira Abaixo A Lista De Atletas Convocados Pela Confederação Brasileira De Desportos De Deficientes Visuais (CBDV): </strong></h2>\n<p>ALANA MARTINS MALDONADO (- 70 kg): Amei/SP<br />\nANTÔNIO TENÓRIO DA SILVA (- 100 kg): Cesec/SP<br />\nARTHUR CAVALCANTI DA SILVA (- 90 kg): Adevirn/RN<br />\nGIULIA DOS SANTOS PEREIRA (- 48kg): Cesec/SP<br />\nHARLLEY DAMIÃO PEREIRA ARRUDA (- 81 kg): Cesec/SP<br />\nKARLA FERREIRA CARDOSO (- 52 kg): Ceibc/RJ<br />\nLUAN SIMÕES PIMENTEL (- 73 kg): Ismac/MS<br />\nLÚCIA DA SILVA TEIXEIRA ARAÚJO (- 57 kg): Cesec/SP<br />\nMARIA NÚBEA DOS SANTOS LINS (- 52 kg): Reação/RJ<br />\nMEG RODRIGUES VITORINO EMMERICH (+ 70 kg): IRM/PR<br />\nREBECA DE SOUZA SILVA (+ 70 kg): Amei/SP<br />\nTHIEGO MARQUES DA SILVA (- 60 kg): Aepa/PA<br />\nWILIANS SILVA DE ARAÚJO (+ 100 kg): Ceibc/RJ</p>\n<p><strong>FONTE: Assessoria de Comunicação do Comitê Paralímpico Brasileiro (imp@cpb.org.br)</strong></p>\n</div>\n</div>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Foto: Alê Cabral / CPB Treze judocas estão no Centro de Treinamento Paralímpico, em São Paulo, para a primeira fase de treinamento da Seleção Brasileira de 2021.  Eles ficarão concentrados no local até o domingo, 28. É a primeira vez que a equipe nacional se reúne depois da interrupção dos treinos presenciais devido à pandemia&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5135,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-5134",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5134",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5134",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5134/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5142,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5134/revisions/5142",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5135",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5134",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5134",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5134",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5089,
        date: "2021-02-16T21:54:10",
        date_gmt: "2021-02-17T00:54:10",
        guid: {
            rendered: "https://cintespbr.org/?p=5089",
        },
        modified: "2022-06-29T23:38:53",
        modified_gmt: "2022-06-30T02:38:53",
        slug: "movimento-paralimpico-fundamentos-basicos-do-esporte",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/movimento-paralimpico-fundamentos-basicos-do-esporte/",
        title: {
            rendered: "MOVIMENTO PARALÍMPICO: FUNDAMENTOS BÁSICOS DO ESPORTE",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="alignnone wp-image-5090 size-full" src="https://cintespbr.org/wp-content/uploads/2021/02/40245397153-58ee60476d-k-768x512-1.jpg" alt="" width="768" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/02/40245397153-58ee60476d-k-768x512-1.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2021/02/40245397153-58ee60476d-k-768x512-1-300x200.jpg 300w" sizes="(max-width: 768px) 100vw, 768px" /></p>\n<h1 class="hero3__titulo">MOVIMENTO PARALÍMPICO: FUNDAMENTOS BÁSICOS DO ESPORTE</h1>\n<p>Curso realizado pelo Comitê Paralímpico Brasileiro e pelo Impulsiona promove inclusão na aula de Educação Física</p>\n<p>&nbsp;</p>\n<div class="col-md-7">\n<div class="singleTax__box">\n<h2 class="singleTax__title">DESCRIÇÃO DO CURSO</h2>\n<div class="singleTax__text">\n<p>Segundo o IBGE, cerca de 45 milhões de brasileiros possuem algum tipo de deficiência. Para que tenhamos uma sociedade mais inclusiva, é importante que se ensinem lições de respeito e empatia aos jovens ainda no ambiente escolar.</p>\n<p>Uma das ferramentas mais eficientes para isso é, sem dúvidas, o esporte. Com o objetivo de capacitar professores de Educação Física para discutirem e ensinarem esportes para pessoas com deficiência, o Comitê Paralímpico Brasileiro (CPB) e o Impulsiona lançaram o curso <strong>Movimento Paralímpico: fundamentos básicos do esporte</strong>.</p>\n<p>Com carga horária de 46 horas, o conteúdo é dividido em seis módulos:</p>\n<ol>\n<li>Os esportes na Base Nacional Comum Curricular (BNCC)</li>\n<li>Esporte Paralímpico: História e Estrutura</li>\n<li>Comitê Paralímpico Brasileiro</li>\n<li>Tipos de deficiência elegíveis</li>\n<li>Aspectos gerais da classificação esportiva</li>\n<li>O esporte Paralímpico na escola</li>\n</ol>\n<p>Além de promover a inclusão dos alunos com deficiência na Educação Física, o curso <strong>Movimento Paralímpico: fundamentos básicos do esporte </strong>também consegue gerar empatia nos jovens sem deficiência. Ao caminharem pela quadra e praticarem chute ao gol vendados, por exemplo, os estudantes se colocam na posição das pessoas cegas. O professor pode, então, trazer questionamentos que ultrapassem as fronteiras do esporte: será que é fácil para um deficiente visual ou um cadeirante pegar um ônibus? A rua da sua casa é acessível? O que pode melhorar na nossa escola para gerar mais inclusão?</p>\n<p>O curso <strong>Movimento Paralímpico: fundamentos básicos do esporte </strong>está disponível na plataforma de ensino à distância do Ministério da Educação, o AVAMEC. Este ambiente online, além de gratuito, permite que o professor acesse o conteúdo a qualquer hora, pelo computador, celular ou tablet. Para finalizar o curso, o aluno terá que ler todo conteúdo e realizar uma avaliação dentro do prazo de 60 dias. Após concluir essas etapas, poderá emitir uma declaração de conclusão de curso. O certificado será enviado pela Universidade Federal de Uberlândia.</p>\n<h2><a href="https://impulsiona.org.br/esporte-paralimpico/"><strong>Faça a inscrição clicando aqui</strong></a></h2>\n<p>&nbsp;</p>\n</div>\n</div>\n</div>\n<div class="offset-md-1 col-md-4">\n<div class="singleTax__box">\n<h2 class="singleTax__SobreTitle">Sobre o Curso</h2>\n<div class="singleTax__Sobre">\n<div class="singleTax__SobreRow">\n<div class="singleTax__SobreItem -name">Público</div>\n<div class="singleTax__SobreItem -value"><a title="Acessar o conteúdo do público Coordenador Pedagógico" href="https://impulsiona.org.br/publico/coordenador">Coordenador Pedagógico</a>, <a title="Acessar o conteúdo do público Educador" href="https://impulsiona.org.br/publico/educador">Educador</a>, <a title="Acessar o conteúdo do público Professor" href="https://impulsiona.org.br/publico/professor">Professor</a></div>\n</div>\n<div class="singleTax__SobreRow">\n<div class="singleTax__SobreItem -name">Unidades Temáticas da BNCC</div>\n<div class="singleTax__SobreItem -value">Brincadeiras e Jogos, Esportes, Práticas corporais de aventura</div>\n</div>\n<div class="singleTax__SobreRow">\n<div class="singleTax__SobreItem -name">Carga Horária</div>\n<div class="singleTax__SobreItem -value">46 horas</div>\n</div>\n<div class="singleTax__SobreRow">\n<div class="singleTax__SobreItem -name">Segmentos de Ensino</div>\n<div class="singleTax__SobreItem -value">EF I, EF II, EM</div>\n</div>\n<p><a class="singleTax__SobreLinkmore" title="Acessar a página Sobre" href="https://impulsiona.org.br/sobre/#estrategia-pedagogica">Saiba mais sobre nossa estratégia pedagógica.</a></p>\n</div>\n</div>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>MOVIMENTO PARALÍMPICO: FUNDAMENTOS BÁSICOS DO ESPORTE Curso realizado pelo Comitê Paralímpico Brasileiro e pelo Impulsiona promove inclusão na aula de Educação Física &nbsp; DESCRIÇÃO DO CURSO Segundo o IBGE, cerca de 45 milhões de brasileiros possuem algum tipo de deficiência. Para que tenhamos uma sociedade mais inclusiva, é importante que se ensinem lições de respeito&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 8048,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-5089",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5089",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5089",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5089/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 8047,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5089/revisions/8047",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/8048",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5089",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5089",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5089",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5015,
        date: "2021-02-03T22:18:06",
        date_gmt: "2021-02-04T01:18:06",
        guid: {
            rendered: "https://cintespbr.org/?p=5015",
        },
        modified: "2021-12-27T23:02:50",
        modified_gmt: "2021-12-28T02:02:50",
        slug: "finep-e-mcti-divulgam-resultado-final-da-chamada-publica-sobre-tecnologia-assistiva",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/finep-e-mcti-divulgam-resultado-final-da-chamada-publica-sobre-tecnologia-assistiva/",
        title: {
            rendered:
                "FINEP E MCTI DIVULGAM RESULTADO FINAL DA CHAMADA PÚBLICA SOBRE TECNOLOGIA ASSISTIVA",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-5016 size-full" src="https://cintespbr.org/wp-content/uploads/2021/02/210203_mcti_boletim_diario.jpg" alt="" width="1289" height="725" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2021/02/210203_mcti_boletim_diario.jpg 1289w, https://cintespbr.institucional.ws/wp-content/uploads/2021/02/210203_mcti_boletim_diario-300x169.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2021/02/210203_mcti_boletim_diario-1024x576.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2021/02/210203_mcti_boletim_diario-768x432.jpg 768w" sizes="(max-width: 1289px) 100vw, 1289px" /></p>\n<p>&nbsp;</p>\n<p style="text-align: justify;">No dia 29 de janeiro de 2021, foi publicado o resultado final da Chamada Pública MCTI/FINEP – MS/SCTIE/DGIITS 06-2020 sobre Tecnologia Assistiva, uma parceria entre o Ministério da Ciência, Tecnologia e Inovações (MCTI), por meio da Secretaria de Empreendedorismo e Inovação (SEMPI), e a Financiadora de Inovação e Pesquisa (FINEP), empresa pública da pasta.<br />\nForam avaliadas um total de 68 propostas habilitadas na primeira fase, resultando em 34 projetos selecionados. A qualidade das propostas se refletiu na aprovação de cerca de R$ 24 milhões em projetos no âmbito da cooperação ICT-empresa (15 projetos aprovados) e de aproximadamente R$ 33 milhões em subvenção econômica (19 projetos aprovados), totalizando mais de R$ 57 milhões mobilizados na chamada.<br />\nEssa chamada teve o objetivo de fomentar a pesquisa, desenvolvimento tecnológico e inovação em projetos que envolvam risco tecnológico e/ou contribuam com a atualização tecnológica do SUS em Tecnologia Assistiva, a fim de promover a independência, autonomia, inclusão social e melhoria da qualidade de vida para pessoas com deficiência, pessoas idosas e outras com mobilidade reduzida, bem como facilitar a atuação dessas pessoas no seu cotidiano.<br />\nTecnologia Assistiva pode ser definida, de acordo com a Lei nº 13.146/2015, como “produtos, equipamentos, dispositivos, recursos, metodologias, estratégias, práticas e serviços que objetivem promover a funcionalidade, relacionada à atividade e à participação da pessoa com deficiência ou com mobilidade reduzida, visando à sua autonomia, independência, qualidade de vida e inclusão social”.<br />\nCom o fomento a esses projetos, o ministério espera contribuir para uma política de Estado que eleve o desenvolvimento tecnológico e a inovação no País, visando a comercialização de produtos e serviços de alto valor agregado, de forma a reduzir o déficit tecnológico e atingir a soberania nacional no segmento da Tecnologia Assistiva.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; No dia 29 de janeiro de 2021, foi publicado o resultado final da Chamada Pública MCTI/FINEP – MS/SCTIE/DGIITS 06-2020 sobre Tecnologia Assistiva, uma parceria entre o Ministério da Ciência, Tecnologia e Inovações (MCTI), por meio da Secretaria de Empreendedorismo e Inovação (SEMPI), e a Financiadora de Inovação e Pesquisa (FINEP), empresa pública da pasta.&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5016,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-5015",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5015",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5015",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5015/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5019,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5015/revisions/5019",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5016",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5015",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5015",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5015",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5011,
        date: "2021-01-23T23:57:38",
        date_gmt: "2021-01-24T02:57:38",
        guid: {
            rendered: "https://cintespbr.org/?p=5011",
        },
        modified: "2021-12-27T23:07:06",
        modified_gmt: "2021-12-28T02:07:06",
        slug: "confederacao-brasileira-de-tiro-com-arco-tem-nova-diretoria-para-ciclo-2021-2025",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/confederacao-brasileira-de-tiro-com-arco-tem-nova-diretoria-para-ciclo-2021-2025/",
        title: {
            rendered:
                "Confederação Brasileira de Tiro com Arco tem nova diretoria para ciclo 2021-2025",
        },
        content: {
            rendered:
                '<div class="row img-main align_center">\n<div class="imagem-principal-detalhe"><img decoding="async" class="img-responsive" src="https://www.cpb.org.br/upload/noticia/efa24bfc5fc74f638b485eb983df18f3.jpg" alt="Foto: Daniel Zappe/MPIX/CPB" /></p>\n<div class="ssk-sticky ssk-center ssk-lg"></div>\n</div>\n<p>Foto: Daniel Zappe/MPIX/CPB</p>\n</div>\n<div class="texto">A Confederação Brasileira de Tiro com Arco (CBTArco) realizou na última semana, no Rio de Janeiro, a cerimônia de posse de João Cruz como presidente da entidade para o ciclo 2021-2025. O vice-presidente será Alberto César dos Santos Moreira, que também atuará como diretor da modalidade paralímpica.</p>\n<p>João, de 52 anos, era presidente da Federação de Tiro com Arco do Rio de Janeiro e trabalhou na coordenação de projetos esportivos no município de Maricá (RJ) por mais de seis anos. Esta será a primeira vez que assumirá a presidência da CBTArco. Já Alberto Moreira foi presidente da Federação de Tiro com Arco de Alagoas.</p>\n<p>“O mais importante é fazermos o que uma confederação tem de fazer: valorizar o atleta. As confederações existem por causa dos atletas olímpicos e paralímpicos. E não o contrário. Então, a nossa ótica principal é colocar o atleta em primeiro plano durante a nossa gestão”, afirmou João Cruz.</p>\n<p>“Temos um apreço muito grande pelo Comitê Paralímpico Brasileiro e agradecemos publicamente por todo o trabalho que o CPB tem feito para a nossa modalidade paralímpica. Fico até emocionado em falar sobre a importância do suporte que o Comitê oferece aos atletas do tiro com arco”, completou.</p>\n<p>Tiro com arco é uma das 14 modalidades em que o Brasil já possui vaga garantida para os Jogos Paralímpicos de Tóquio.</p>\n<p><strong>FOTNTE: Assessoria de Comunicação do Comitê Paralímpico Brasileiro (imp@cpb.org.br) </strong></div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Foto: Daniel Zappe/MPIX/CPB A Confederação Brasileira de Tiro com Arco (CBTArco) realizou na última semana, no Rio de Janeiro, a cerimônia de posse de João Cruz como presidente da entidade para o ciclo 2021-2025. O vice-presidente será Alberto César dos Santos Moreira, que também atuará como diretor da modalidade paralímpica. João, de 52 anos, era&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5012,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-5011",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5011",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5011",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5011/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5013,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5011/revisions/5013",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5012",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5011",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5011",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5011",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5008,
        date: "2021-01-23T23:55:37",
        date_gmt: "2021-01-24T02:55:37",
        guid: {
            rendered: "https://cintespbr.org/?p=5008",
        },
        modified: "2021-12-27T23:07:07",
        modified_gmt: "2021-12-28T02:07:07",
        slug: "focada-em-medalha-nos-jogos-de-toquio-selecao-brasileira-de-volei-sentado-retoma-treinos-em-sergipe",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/focada-em-medalha-nos-jogos-de-toquio-selecao-brasileira-de-volei-sentado-retoma-treinos-em-sergipe/",
        title: {
            rendered:
                "Focada em medalha nos Jogos de Tóquio, Seleção Brasileira de vôlei sentado retoma treinos em Sergipe",
        },
        content: {
            rendered:
                '<p>&nbsp;</p>\n<div class="row img-main align_center">\n<div class="imagem-principal-detalhe"><img decoding="async" class="img-responsive" src="https://www.cpb.org.br/upload/noticia/2afe931c488142eab88030e36eda8e0a.jpg" alt="A Seleção masculina de vôlei sentado conquistou a vaga para os Jogos Paralímpicos de Tóquio ao faturar a medalha de ouro no Parapan de Lima em 2019. Foto: Washington Alves/EXEMPLUS/CPB" /></p>\n<div class="ssk-sticky ssk-center ssk-lg"></div>\n</div>\n<p>A Seleção masculina de vôlei sentado conquistou a vaga para os Jogos Paralímpicos de Tóquio ao faturar a medalha de ouro no Parapan de Lima em 2019. Foto: Washington Alves/EXEMPLUS/CPB</p>\n</div>\n<div class="texto">A Seleção Brasileira masculina de vôlei sentado realiza nesta semana a primeira fase de treinamentos em Sergipe. A equipe, que já possui vaga garantida para os Jogos Paralímpicos de Tóquio, em agosto, retorna às quadras para treino coletivo após dez meses distante devido à pandemia do Covid-19.</p>\n<p>Os treinos são divididos em parte física na academia e treinos coletivos na quadra do Colégio Master, em Aracaju. Reunidos desde o último domingo, 17, os atletas da equipe masculina treinam até este sábado, 23. Ao todo, 15 atletas foram convocados, sendo dois pela primeira vez.</p>\n<p>“Nossa grande preocupação é não saturar os atletas. Todos estavam fazendo atividades em casa e alguns clubes já conseguiram retomar os treinos e isso também nos ajudou. A gente precisa dar entrosamento, mas a fase de treinamentos está sendo ótima. Os atletas responderam super bem, todos estão se dedicando bastante. Precisamos trabalhar muito sério para alcançar nosso objetivo, uma medalha em Tóquio”, explicou o técnico da Seleção masculina, Célio Mediato.</p>\n<p>Para atingir o melhor nível técnico, tático, físico e mental, a Confederação Brasileira de Voleibol para Deficientes (CBVD) montou um cronograma de atividades de 17 a 23 de janeiro, com o time masculino, e de 24 a 30 com a equipe feminina, atual medalhista de bronze no Rio 2016, ambas com vaga para os Jogos na capital japonesa.</p>\n<p>As vagas para os Jogos de Tóquio foram conquistadas nos Jogos Parapan-Americanos de Lima 2019. Na ocasião, a equipe masculina faturou a medalha de outro e a feminina a prata.</p>\n<p><strong>Patrocínio </strong><br />\nO vôlei sentado tem patrocínio das Loterias Caixa.</p>\n<p><strong>FONTE: Assessoria de Comunicação do Comitê Paralímpico Brasileiro (imp@cpb.org.br)</strong></div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; A Seleção masculina de vôlei sentado conquistou a vaga para os Jogos Paralímpicos de Tóquio ao faturar a medalha de ouro no Parapan de Lima em 2019. Foto: Washington Alves/EXEMPLUS/CPB A Seleção Brasileira masculina de vôlei sentado realiza nesta semana a primeira fase de treinamentos em Sergipe. A equipe, que já possui vaga garantida&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5009,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62, 46],
        tags: [],
        class_list: [
            "post-5008",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-ultimas-noticias",
            "category-34",
            "category-62",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5008",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5008",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5008/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5010,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5008/revisions/5010",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5009",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5008",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5008",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5008",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 5005,
        date: "2021-01-23T23:52:04",
        date_gmt: "2021-01-24T02:52:04",
        guid: {
            rendered: "https://cintespbr.org/?p=5005",
        },
        modified: "2021-12-28T17:27:31",
        modified_gmt: "2021-12-28T20:27:31",
        slug: "processo-de-adesao-a-organizacao-europeia-para-a-pesquisa-nuclear-cern",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/processo-de-adesao-a-organizacao-europeia-para-a-pesquisa-nuclear-cern/",
        title: {
            rendered:
                "Processo de adesão à Organização Europeia para a Pesquisa Nuclear (CERN)",
        },
        content: {
            rendered:
                '<div id="viewlet-above-content-body">\n<h3>Em reunião, ministro Marcos Pontes anunciou que presidente Jair Bolsonaro deu aval para dar seguimento ao processo que torna o país membro associado do CERN</h3>\n<div></div>\n<div id="media"><img loading="lazy" decoding="async" src="https://www.gov.br/mcti/pt-br/acompanhe-o-mcti/noticias/2021/01/brasil-avanca-em-processo-de-adesao-a-organizacao-europeia-para-a-pesquisa-nuclear/img_8140.jpg/@@images/8f781c66-95df-4d3a-9cad-05b4b18e725b.jpeg" alt="IMG_8140.jpg" width="768" height="546" /></p>\n<p class="discreet">Foto: Leonardo Marques &#8211; ASCOM/MCTI</p>\n</div>\n</div>\n<div id="content-core">\n<div id="parent-fieldname-text" class="">\n<div>\n<p>Oministro da Ciência, Tecnologia e Inovações, Marcos Pontes, afirmou, nesta quinta-feira (21), que o presidente da República, Jair Bolsonaro, deu aval para dar prosseguimento ao processo de adesão do Brasil como membro associado da Organização Europeia para a Pesquisa Nuclear (CERN). O anúncio foi feito durante uma reunião virtual entre o ministro e a diretora-geral do CERN, Fabiola Gianotti.</p>\n<p>“Tenho boas notícias. Ontem, conversei com o presidente Bolsonaro e com o ministro Braga Netto (Casa Civil) e expliquei sobre a importância do processo. Informei que o Brasil daria andamento à documentação para, finalmente, oficializar a participação do Brasil como membro associado do CERN”, revelou Marcos Pontes, confirmando a aprovação do presidente para dar seguimento ao processo de adesão.</p>\n<p>A inclusão do Brasil como membro associado do CERN deverá acarretar diversos benefícios para o país como: transferência de conhecimento em diversas áreas de C,T&amp;I;  cooperação com o Sirius, acelerador de partículas vinculado ao Centro Nacional de Pesquisa em Energia e Materiais (CNPEM/MCTI); cooperação em materiais avançados e minerais estratégicos, como o nióbio; acesso a postos de trabalho e capacitação de pesquisadores e mão-de-obra especializada nacional; popularização e difusão da ciência; participação na construção da agenda científica mundial; oportunidades para indústria nacional, a partir da participação em licitações;</p>\n<p>A diretora-geral do CERN reforçou que está acompanhando o processo de adesão do Brasil à organização de perto e disse acreditar que há varias possibilidades de atuação convergente entre as nações, como no caso laboratório Sirius e também nos setores de ciência, tecnologia e inovação. “Essa associação do Brasil ao CERN é importante e fortalece as possibilidades de parceria”, frisou.</p>\n<p>O processo de acesso do Brasil à organização europeia para a pesquisa nuclear teve início em 2010, quando o CERN estendeu possibilidade de países não-europeus virem a se tornar membros associados, desde que atendessem a critérios específicos de elegibilidade.</p>\n<p>De acordo com o chefe da Assessoria Especial de Assuntos Internacionais do MCTI, Bernardo Milano, os próximos passos do processo formal de adesão do Brasil vão incluir uma série de reuniões e discussões com outros ministérios do governo federal, com representantes da indústria nacional e membros da comunidade científica brasileira. O objetivo é mapear oportunidades concretas de curto e médio prazo da adesão ao CERN.</p>\n<p><strong>O CERN</strong></p>\n<p>Fundada em 1954, a Organização Europeia para a Pesquisa Nuclear é um dos maiores, mais avançados e mais respeitados centros científicos do mundo. Voltado para a pesquisa em física de altas energias, se situa na fronteira da Suíça com a França. Com 23 países membros plenos (Alemanha, Áustria, Bélgica, Bulgária, Dinamarca, Eslováquia, Espanha, Finlândia, França, Grécia, Hungria, Israel, Itália, Noruega, Países Baixos, Polônia, Portugal, República Tcheca, Romênia, Sérvia, Suécia, Suíça e Reino Unido), 8 países associados (Chipre, Croácia, Eslovênia, Índia, Lituânia, Paquistão, Turquia e Ucrânia) e 3 países com status de observadores (Japão, Rússia e Estados Unidos), o CERN desenvolve pesquisas que contam com a participação de milhares de cientistas de mais de uma centena de nacionalidades.</p>\n<p>Entre os maiores feitos da organização europeia estão a comprovação do bóson de Higgs (“partícula de Deus”), construção do LHC (Grande Colisor Hadrônico), maior e mais potente acelerador de partículas do mundo, a invenção da World Wide Web (www), em 1989, e experimentos e descobertas sobre a antimatéria.</p>\n<p>A reunião virtual contou com a participação da embaixadora do Brasil em Genebra, Maria Nazareth Farani Azevêdo; do secretário-executivo do MCTI, Leônidas de Araújo Medeiros Junior; do secretário de Pesquisa e Formação Científica, Marcelo Morales, e do subsecretário de Unidades Vinculadas do MCTI, Darcton Damião.</p>\n</div>\n<p>Fonte: MCTI</p>\n</div>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Em reunião, ministro Marcos Pontes anunciou que presidente Jair Bolsonaro deu aval para dar seguimento ao processo que torna o país membro associado do CERN Foto: Leonardo Marques &#8211; ASCOM/MCTI Oministro da Ciência, Tecnologia e Inovações, Marcos Pontes, afirmou, nesta quinta-feira (21), que o presidente da República, Jair Bolsonaro, deu aval para dar prosseguimento ao&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 5006,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43, 46],
        tags: [],
        class_list: [
            "post-5005",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-ultimas-noticias",
            "category-43",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5005",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=5005",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5005/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5007,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/5005/revisions/5007",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/5006",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=5005",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=5005",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=5005",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4953,
        date: "2021-01-12T21:12:48",
        date_gmt: "2021-01-13T00:12:48",
        guid: {
            rendered: "https://cintespbr.org/?p=4953",
        },
        modified: "2021-12-27T23:07:07",
        modified_gmt: "2021-12-28T02:07:07",
        slug: "novo-ciclo-paralimpico-marca-inicio-de-segunda-gestao-de-mizael-conrado-e-nova-diretoria-do-cpb",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/novo-ciclo-paralimpico-marca-inicio-de-segunda-gestao-de-mizael-conrado-e-nova-diretoria-do-cpb/",
        title: {
            rendered:
                "Novo ciclo paralímpico marca início de segunda gestão de Mizael Conrado e nova diretoria do CPB",
        },
        content: {
            rendered:
                '<p>&nbsp;</p>\n<div class="row img-main align_center">\n<div class="imagem-principal-detalhe"><img decoding="async" class="img-responsive" src="https://cpb.org.br/upload/noticia/b3b1533781b84636a1f82748922db42f.jpg" alt="Edênia Garcia, Mizael Conrado e Yohansson Nascimento posam para foto durante assembleia no CT Paralímpico. Foto: Ale Cabral/CPB" /></p>\n<div class="ssk-sticky ssk-center ssk-lg"></div>\n</div>\n<p>Edênia Garcia, Mizael Conrado e Yohansson Nascimento posam para foto durante assembleia no CT Paralímpico. Foto: Ale Cabral/CPB</p>\n</div>\n<div class="texto">O Comitê Paralímpico Brasileiro (CPB) deu início nesta segunda-feira, 4, ao novo ciclo paralímpico que visará a participação brasileira nos Jogos Paralímpicos de Tóquio, em 2021, e de Paris, em 2024, além dos Jogos de Inverno em Pequim, em 2022, e dos Campeonatos Mundiais de cada modalidade.</p>\n<p>O período marcará também a segunda gestão do presidente Mizael Conrado, <a href="https://cpb.org.br/noticia/detalhe/3126/mizael-conrado-e-reeleito-presidente-do-cpb-por-aclamacao-yohansson-nascimento-sera-o-vice" target="_blank" rel="noopener noreferrer"><u><strong>reeleito por aclamação no último mês de dezembro</strong></u></a> para a posição para o ciclo 2021-2025. O ex-atleta do atletismo Yohansson Nascimento foi eleito vice-presidente e formará a nova diretoria executiva da entidade. Já a nadadora Edênia Garcia (classe S4) foi eleita presidente do conselho fiscal do CPB.</p>\n<p>Esta é a primeira vez na história do Movimento Paralímpico nacional que a diretoria eleita do Comitê será formada somente por atletas medalhistas. Eleito presidente pela primeira vez em 2017, Mizael Conrado foi o primeiro medalhista paralímpico a assumir o cargo do CPB. Ele foi bicampeão paralímpico de futebol de cinco nos Jogos de Atenas 2004 e Pequim 2008, além de ter sido considerado o melhor jogador do mundo da modalidade em 1998.</p>\n<p>Já o alagoano Yohansson Nascimento se aposentou das pistas em 2020 para concorrer à vice-presidência do CPB. Durante a carreira foi ouro nos 200m em Londres 2012 pela classe T45 (para atletas com deficiência nos membros superiores), além das pratas no revezamento 4x100m em Pequim 2008, nos 400m em Londres 2012 e no revezamento 4x100m no Rio 2016.</p>\n<p>Também conquistou bronze nos 200m em Pequim 2008 e nos nos 100m no Rio 2016. Foi ainda medalhista mundial e em Jogos Parapan-americanos.</p>\n<p>Já presidente eleita do conselho fiscal, Edênia, tem três medalhas paralímpicas: prata nos 50m costas em Atenas 2004, bronze nos 50m livre em Pequim 2008, e prata nos 50m costas em Londres 2012.</p>\n<p>Foi também a primeira mulher brasileira a conquistar o título de tetracampeã mundial paralímpica (50m costas em 2002, 2006, 2010 e 2019). A nadadora é ainda pentacampeã parapan-americana (Mar del Plata 2003, Rio 2007, Guadalajara 2011, Toronto 2015 e Lima 2019).</p>\n<p>“Precisamos deixar os nossos mais sinceros e profundos agradecimentos aos vice-presidentes Maria Naíse de Moraes Pedrosa e Ivaldo Brandão pela inestimável contribuição para o desenvolvimento do CPB no ciclo que se encerrou em 31 de dezembro último. A participação de vocês foi de crucial importância na sustentabilidade e maturidade de todo o ecossistema paralímpico nacional, não somente nos últimos quatro anos, mas ao longo das décadas de atuação no movimento. Cabe a nós, agora na companhia do campeão paralímpico Yohansson Nascimento na condição de vice-presidente, e a medalhista paralímpica e tetracampeã mundial, Edênia Garcia, presidente do conselho fiscal, prosseguirmos com o trabalho nos anos vindouros. Uma configuração jamais experimentada antes na diretoria executiva do Comitê Paralímpico Brasileiro, com ex-atletas no centro da gestão. É, por óbvio, razão suficiente para nos encher de orgulho e aumentar a esperança de grandes e impactantes conquistas aos atletas paralímpicos brasileiros. Feliz ano novo a todos”, escreveu Mizael Conrado, bicampeão paralímpico de futebol de cinco nos Jogos de Atenas 2004 e Pequim 2008 e presidente do CPB, em suas redes sociais nesta segunda.</p>\n<p>Durante a sua primeira gestão (desde 2017), o Brasil <a href="https://cpb.org.br/noticia/detalhe/2530/brasil-faz-campanha-historica-no-parapan-de-lima-com-124-ouros-entre-as-308-medalhas-conquistadas" target="_blank" rel="noopener noreferrer"><u><strong>conseguiu bater recorde de medalhas nos Jogos Parapan</strong></u></a> de Lima 2019, assim como no Mundial de atletismo do mesmo ano, quando contou com o <a href="https://cpb.org.br/noticia/detalhe/2677/com-dois-ouros-brasil-encerra-domingo-no-segundo-lugar-no-quadro-de-medalhas-do-mundial-de-atletismo" target="_blank" rel="noopener noreferrer"><u><strong>seu melhor desempenho na história da competição</strong></u></a> ao ficar somente atrás da China no quadro de medalhas.</p>\n<p>Também houve o lançamento do projeto Centro de Formação Esportiva, com a participação de mais de 500 crianças com idade escolar por ano, além do surgimento do Festival Paralímpico em 2018, que já movimentou mais de 100 mil pessoas com deficiência em 70 cidades do país.</p>\n<p>Ainda sob seu mandato, foi realizado o lançamento do curso <a href="https://impulsiona.org.br/esporte-paralimpico/" target="_blank" rel="noopener noreferrer"><u><strong>EaD Movimento Paralímpico: fundamentos básicos do esporte</strong></u></a>, que <a href="https://cpb.org.br/noticia/detalhe/3085/cpb-forma-7-mil-professores-por-ano-e-leva-cursos-a-mais-de-2-mil-cidades-do-pais-confira-as-inscricoes-em-aberto" target="_blank" rel="noopener noreferrer"><u><strong>forma mais de 7 mil professores por ano</strong></u></a>, além das qualificações online e gratuitas de arbitragem e habilitação técnica.</p>\n<p><strong>Fonte: Assessoria de Comunicação do Comitê Paralímpico Brasileiro (imp@cpb.org.br)</strong></div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; Edênia Garcia, Mizael Conrado e Yohansson Nascimento posam para foto durante assembleia no CT Paralímpico. Foto: Ale Cabral/CPB O Comitê Paralímpico Brasileiro (CPB) deu início nesta segunda-feira, 4, ao novo ciclo paralímpico que visará a participação brasileira nos Jogos Paralímpicos de Tóquio, em 2021, e de Paris, em 2024, além dos Jogos de Inverno&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4954,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-4953",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4953",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4953",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4953/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4955,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4953/revisions/4955",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4954",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4953",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4953",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4953",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4949,
        date: "2021-01-12T21:09:35",
        date_gmt: "2021-01-13T00:09:35",
        guid: {
            rendered: "https://cintespbr.org/?p=4949",
        },
        modified: "2021-12-27T23:07:07",
        modified_gmt: "2021-12-28T02:07:07",
        slug: "maior-atleta-paralimpico-do-brasil-daniel-dias-anuncia-sua-aposentadoria-apos-jogos-de-toquio",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/maior-atleta-paralimpico-do-brasil-daniel-dias-anuncia-sua-aposentadoria-apos-jogos-de-toquio/",
        title: {
            rendered:
                "Maior atleta paralímpico do Brasil, Daniel Dias anuncia sua aposentadoria após Jogos de Tóquio",
        },
        content: {
            rendered:
                '<div class="row img-main align_center">\n<div class="imagem-principal-detalhe"><img decoding="async" class="img-responsive" src="https://cpb.org.br/upload/noticia/2dffce7d29764a1c807ec2bf4619a53c.JPG" alt="Dono de 24 medalhas paralímpicas, Daniel Dias anuncia aposentadoria após os Jogos Paralímpicos de Tóquio, em agosto." /></p>\n<div class="ssk-sticky ssk-center ssk-lg"></div>\n</div>\n<p>Dono de 24 medalhas paralímpicas, Daniel Dias anuncia aposentadoria após os Jogos Paralímpicos de Tóquio, em agosto.</p>\n</div>\n<div class="texto">O multimedalhista Daniel Dias anunciou nesta terça-feira, 12, a sua aposentadoria das piscinas após os Jogos Paralímpicos de Tóquio, que acontecerão em agosto deste ano. O maior nadador paralímpico do mundo no masculino, dono de 24 medalhas paralímpicas, comunicou, <u><strong><a href="https://www.instagram.com/tv/CJ8pa5LJg-i/?utm_source=ig_web_copy_link" target="_blank" rel="noopener noreferrer">por meio de um vídeo em suas redes sociais</a></strong></u>, que o evento na capital japonesa será sua última competição na carreira.</p>\n<p>Natural de Campinas, interior de São Paulo, Daniel tem má-formação congênita nos membros superiores e na perna direita e compete pela classe S5. O atleta começou a competir em 2006 após assistir ao também nadador Clodoaldo Silva na televisão durante os Jogos Paralímpicos de Atenas 2004.</p>\n<p>“Sem dúvida é o maior evento do Movimento Paralímpico e poder dizer o adeus nessa competição é um momento espetacular, um momento de muita alegria. A vida do atleta é feita de ciclos, fases, e por isso eu decidi parar, resolvi dar o adeus à piscina porque eu vejo que a minha contribuição com a natação paralímpica já foi excepcional. Foi além do que eu esperava”, comentou o atleta que deverá nadar quatro provas individuais e, possivelmente, um revezamento em Tóquio 2021.</p>\n<p>O Comitê Paralímpico Brasileiro foi comunicado da decisão e agradeceu ao atleta por todos os anos de dedicação ao esporte e à causa da pessoa com deficiência.</p>\n<p>“Daniel Dias faz parte da história do esporte não somente do Brasil, mas do mundo inteiro. Sua contribuição é imensurável tanto no âmbito esportivo quanto no aspecto social pela capacidade de demonstrar ao mundo toda a eficiência que a pessoa com deficiência pode ter. E não apenas nas piscinas, mas também fora delas. Temos certeza de que esta sua transição de carreira será tão bem-sucedida quanto o que mostrou nas piscinas pelo mundo”, completou Mizael Conrado, bicampeão paralímpico de futebol de cinco nos Jogos de Atenas 2004 e Pequim 2008 e presidente reeleito do CPB.</p>\n<p>Ao longo da carreira, Daniel acumulou 24 medalhas em Jogos Paralímpicos, sendo 14 de ouro, sete de prata e três de bronze, 40 medalhas em Campeonatos Mundiais, sendo 31 ouros, sete pratas e dois bronzes, e 33 pódios em Jogos Parapan-americanos, sendo todas de ouro. Além disso, é o único brasileiro a ter três Troféus Laureus (em 2009, 2013 e 2016), considerado o “Oscar do Esporte”, em sua estante.</p>\n<p>“Não quero que seja uma despedida triste, vai ser um momento de muita alegria, muitos sorrisos. Eu não tenho dúvidas disso. E que nós possamos desfrutar destas últimas braçadas, últimos mergulhos, últimos apitos, enfim, que seja um momento de muita alegria não só para mim, mas para vocês que sempre me acompanharam, torceram e vibraram.”</p>\n<p>Daniel reside e treina na cidade de Bragança Paulista, é casado e pai de três filhos, Asaph (6), Daniel (5) e Hadassa (1). Em 2014, fundou o Instituto Daniel Dias com o intuito de oferecer treinamentos de natação paralímpica às pessoas com deficiência da cidade de Bragança Paulista e região. Após aposentadoria, o atleta focará na instituição.</p>\n<p>“Pretendo estar mais à frente do Instituto Daniel Dias, quero poder me dedicar mais em sua gestão, pois tenho grandes planos de crescimento para ele. Vou continuar a ministrar as minhas palestras e clínicas de natação e sigo na atuação como membro do Conselho Nacional de Atletas e da Assembleia Geral do Comitê Paralímpico Brasileiro”, finalizou.</p>\n<p><strong>Time São Paulo </strong><br />\nO atleta Daniel Dias é integrante do Time São Paulo, parceria entre o CPB e a Secretaria de Estado dos Direitos da Pessoa com Deficiência de São Paulo que beneficia 61 atletas e dois atletas-guia de 11 modalidades.</p>\n<p><strong>Fonte: Assessoria de Comunicação do Comitê Paralímpico Brasileiro (imp@cpb.org.br)  </strong></div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Dono de 24 medalhas paralímpicas, Daniel Dias anuncia aposentadoria após os Jogos Paralímpicos de Tóquio, em agosto. O multimedalhista Daniel Dias anunciou nesta terça-feira, 12, a sua aposentadoria das piscinas após os Jogos Paralímpicos de Tóquio, que acontecerão em agosto deste ano. O maior nadador paralímpico do mundo no masculino, dono de 24 medalhas paralímpicas,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4950,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-4949",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4949",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4949",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4949/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4951,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4949/revisions/4951",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4950",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4949",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4949",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4949",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4848,
        date: "2020-12-15T21:52:06",
        date_gmt: "2020-12-16T00:52:06",
        guid: {
            rendered: "https://cintespbr.org/?p=4848",
        },
        modified: "2022-05-17T22:10:02",
        modified_gmt: "2022-05-18T01:10:02",
        slug: "centro-nacional-de-tecnologia-e-oficialmente-lancado",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/centro-nacional-de-tecnologia-e-oficialmente-lancado/",
        title: {
            rendered:
                "Centro Nacional de Tecnologias para Pessoas com Deficiência e Doenças Raras (CNT-MCTI) é apresentado em evento do CINTESP.Br/UFU",
        },
        content: {
            rendered:
                '<p style="text-align: justify;">Foi um anúncio que superou as expectativas, fechando com chave de ouro a proposta do LANCE PcD de apresentar os resultados da rede colaborativa para o desenvolvimento em Inovação Tecnológica em Tecnologia Assistiva (TA) formada em Uberlândia.</p>\n<p style="text-align: justify;">A cidade foi escolhida pelo Ministério de Ciência, Tecnologia e Inovações (MCTI) para receber o Centro Nacional de Tecnologias para Pessoas com Deficiência e Doenças Raras – CNT-MCTI, reforçando a vocação de Uberlândia em desenvolver Programas de inovação tecnológica em tecnologia assistiva (TA) e acessibilidade.</p>\n<p style="text-align: justify;">O CNT-MCTI é uma iniciativa do Ministério de Ciência, Tecnologia e Inovações em parceria com a Universidade Federal de Uberlândia,  grupo Algar e  CINTESP.Br.</p>\n<p style="text-align: justify;">O objetivo é de fazer do CNT-MCTI referência no país na busca de soluções empreendedoras para a transferência de tecnologias para a sociedade brasileira com incentivo a criação de startups com foco em tecnologia assistiva. As áreas contempladas de atuação do CNT-MCTI serão para o desenvolvimento de inovações em tecnologia assistiva para a saúde, a educação, o esporte, o lazer e a vida-diária.</p>\n<p style="text-align: justify;">O novo Centro de Pesquisas, faz parte da Política de Desenvolvimento Científico, Tecnológico e Inovação para Qualidade de Vida do MCTI e será dedicado à criação de um ambiente de colaboração entre academia, governo e o setor privado. Com mais esta ação o Governo Federal espera ampliar o incentivo industrial no setor e fortalecer o atual alinhamento das competências em ciência, tecnologia, empreendedorismo e inovação voltadas para tecnologia assistiva.</p>\n<p style="text-align: justify;">A estrutura do CNT envolve um projeto de R$ 11 milhões, em sua fase inicial, e encontra-se em análise na financiadora de projetos, a FINEP, de acordo com o Reitor da UFU, professor Valder Steffen Júnior.</p>\n<p style="text-align: justify;">A expectativa é de que a primeira parte desses recursos, cerca de 5 milhões, seja liberada rapidamente para iniciar a construção das instalações que ficarão no Campus Glória da UFU, aqui em Uberlândia. Pelo projeto, a primeira fase de implantação do CNT-MCTI será de 1300 m<sup>2</sup>. Estamos trabalhando em coordenação com a secretaria de empreendedorismo e inovação do Ministério da Ciência, Tecnologia e Inovações buscando a cultura empreendedora para a tecnologia assistiva. <strong><em>“Enxergamos que aqui podem ser gerados empregos além de inovação e vamos trabalhar fortemente nisso, juntamente com a iniciativa privada. O que nós vemos aqui em Uberlândia é o fruto de todas essas ações”</em></strong>, disse Felipe Bellucci, coordenador-geral de tecnologias habilitadoras (CGTH) da Secretaria de Empreendedorismo e Inovação do MCTI.</p>\n<p style="text-align: justify;">Ainda de acordo com o secretário da SEMPI/MCTI, o Objetivo é criar para o Brasil, mais um ambiente favorável para que as tecnologias assistivas cheguem para as pessoas de maneira mais ágil. <strong><em>“Temos o envolvimento do CINTESP.Br, da rede de laboratórios multiusuários da UFU, das competências instaladas na UFU e em rede de laboratórios que já tem equipamentos instalados e com colaboração de diversos outros parceiros. O CNT é um sonho para a Universidade Federal de Uberlândia e também para a nossa região, muitas pessoas serão beneficiadas pelas atividades desse Centro”</em></strong>, disse o Reitor da UFU, professor Valder Steffan Júnior quando anunciou a criação do NCT/MCTI em Uberlândia.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Foi um anúncio que superou as expectativas, fechando com chave de ouro a proposta do LANCE PcD de apresentar os resultados da rede colaborativa para o desenvolvimento em Inovação Tecnológica em Tecnologia Assistiva (TA) formada em Uberlândia. A cidade foi escolhida pelo Ministério de Ciência, Tecnologia e Inovações (MCTI) para receber o Centro Nacional de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 7735,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [52, 47, 55, 43, 62],
        tags: [],
        class_list: [
            "post-4848",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintesp-na-17-snct",
            "category-cintespbr-em-acao",
            "category-cnt",
            "category-mcti",
            "category-todas-as-noticias",
            "category-52",
            "category-47",
            "category-55",
            "category-43",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4848",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4848",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4848/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7908,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4848/revisions/7908",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/7735",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4848",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4848",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4848",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4727,
        date: "2020-12-08T19:56:45",
        date_gmt: "2020-12-08T22:56:45",
        guid: {
            rendered: "https://cintespbr.org/?p=4727",
        },
        modified: "2021-06-13T22:26:33",
        modified_gmt: "2021-06-14T01:26:33",
        slug: "sinal-projeto-escuridao-e-silencio",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-projeto-escuridao-e-silencio/",
        title: {
            rendered: "Sinal: PROJETO ESCURIDÃO E SILÊNCIO",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: PROJETO ESCURIDÃO E SILÊNCIO<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/w7H86H2CVTw&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;">Sinal: Projeto Escuridão &amp; Silêncio</span></p>\n<p><span style="color: #ffff00;">Mãos abertas e separadas em frente ao corpo, na altura dos ombros, fecho os os dedos trazendo a mão para o centro. Em seguida mão ativa fechada unindo as pontas dos dedos com indicador levantado encostando na boca e a palma para o lado</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/w7H86H2CVTw&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: Projeto Escuridão &amp; Silêncio Mãos abertas e separadas em frente ao corpo, na altura dos ombros, fecho os os dedos trazendo a mão para o centro. Em&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4726,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4727",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4727",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4727",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4727/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6215,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4727/revisions/6215",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4726",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4727",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4727",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4727",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4724,
        date: "2020-12-08T19:51:48",
        date_gmt: "2020-12-08T22:51:48",
        guid: {
            rendered: "https://cintespbr.org/?p=4724",
        },
        modified: "2021-06-13T23:04:29",
        modified_gmt: "2021-06-14T02:04:29",
        slug: "sinal-universidade-federal-de-uberlandia-ufu",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-universidade-federal-de-uberlandia-ufu/",
        title: {
            rendered: "Sinal: UNIVERSIDADE FEDERAL DE UBERLÂNDIA &#8211; UFU",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: UNIVERSIDADE FEDERAL DE UBERLÂNDIA - UFU<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/p-rJkXlsQsA&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;">Sinal: Universidade Federal de Uberlândia &#8211; UFU</span></p>\n<p><span style="color: #ffff00;">Mãos fechadas com dedos indicadores e polegares levantados e unidos, em frente ao corpo com a palma para frente e posicionadas uma ao lado da outra. Mão ativa em direção a lateral em movimento semicircular para baixo.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/p-rJkXlsQsA&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: Universidade Federal de Uberlândia &#8211; UFU Mãos fechadas com dedos indicadores e polegares levantados e unidos, em frente ao corpo com a palma para frente e posicionadas&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4726,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4724",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4724",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4724",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4724/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6233,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4724/revisions/6233",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4726",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4724",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4724",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4724",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4721,
        date: "2020-12-08T19:46:57",
        date_gmt: "2020-12-08T22:46:57",
        guid: {
            rendered: "https://cintespbr.org/?p=4721",
        },
        modified: "2021-06-13T22:28:13",
        modified_gmt: "2021-06-14T01:28:13",
        slug: "sinal-mcti",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-mcti/",
        title: {
            rendered: "Sinal: MCTI",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: MCTI<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/DlwMLSRQquc&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: </strong>MCTI &#8211; Ministério da Ciência, Tecnologia e Inovações</span></p>\n<p><span style="color: #ffff00;">Mão passiva em frente ao corpo, polegar destacados dedos unidos e curvados com a palma para o lado. Mão ativa fechada, palma para frente encostando na palma da mão passiva, arrasto-a para o lado abrindo os dedos.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/DlwMLSRQquc&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: MCTI &#8211; Ministério da Ciência, Tecnologia e Inovações Mão passiva em frente ao corpo, polegar destacados dedos unidos e curvados com a palma para o lado. Mão&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4722,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4721",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4721",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4721",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4721/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6216,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4721/revisions/6216",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4722",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4721",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4721",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4721",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4718,
        date: "2020-12-08T19:39:31",
        date_gmt: "2020-12-08T22:39:31",
        guid: {
            rendered: "https://cintespbr.org/?p=4718",
        },
        modified: "2021-06-13T22:29:11",
        modified_gmt: "2021-06-14T01:29:11",
        slug: "sinal-cintesp-br",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-cintesp-br/",
        title: {
            rendered: "Sinal: CINTESP.Br",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: CINTESP.Br<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/HcDy_Oraj9A&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: </strong>CINTESP.Br</span></p>\n<p><span style="color: #ffff00;">Mãos abertas, polegares unidos aos indicadores pelas pontas dos dedos, posicionadas uma atrás da outra, encostando a lateral das pontas dos dedos indicadores e polegares. Mão ativa em movimento circular para frente.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/HcDy_Oraj9A&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: CINTESP.Br Mãos abertas, polegares unidos aos indicadores pelas pontas dos dedos, posicionadas uma atrás da outra, encostando a lateral das pontas dos dedos indicadores e polegares. Mão&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4720,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4718",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4718",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4718",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4718/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6217,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4718/revisions/6217",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4720",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4718",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4718",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4718",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4703,
        date: "2020-12-07T20:41:17",
        date_gmt: "2020-12-07T23:41:17",
        guid: {
            rendered: "https://cintespbr.org/?p=4703",
        },
        modified: "2021-06-13T22:30:13",
        modified_gmt: "2021-06-14T01:30:13",
        slug: "sinal-retina",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-retina/",
        title: {
            rendered: "Sinal: RETINA",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: RETINA<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/YffvPjo7VYE&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: RETINA:</strong></span></p>\n<p><span style="color: #ffff00;">Espaço neutro na altura do peito; Mão passiva fechada unindo as pontas dos dedos; Mão ativa aberta com dedos curvados, fechar a mão e em seguida tocar alternadamente com as pontas dos dedos em cima dos dedos da mão passiva.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/YffvPjo7VYE&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: RETINA: Espaço neutro na altura do peito; Mão passiva fechada unindo as pontas dos dedos; Mão ativa aberta com dedos curvados, fechar a mão e em seguida&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4704,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4703",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4703",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4703",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4703/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6218,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4703/revisions/6218",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4704",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4703",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4703",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4703",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4701,
        date: "2020-12-07T20:38:31",
        date_gmt: "2020-12-07T23:38:31",
        guid: {
            rendered: "https://cintespbr.org/?p=4701",
        },
        modified: "2021-06-13T22:31:18",
        modified_gmt: "2021-06-14T01:31:18",
        slug: "sinal-libras-tatil-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-libras-tatil-2/",
        title: {
            rendered: "Sinal: LIBRAS TÁTIL 2",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: LIBRAS TÁTIL 2<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/4BtxLmeyzaQ&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: LIBRAS TÁTIL 2:</strong></span></p>\n<p><span style="color: #ffff00;">Espaço neutro na altura do peito, Mãos abertas com as palmas para baixo uma sobre a outra. Mão que está embaixo movimentando os dedos alternadamente com o pulso em movimento circular.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/4BtxLmeyzaQ&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: LIBRAS TÁTIL 2: Espaço neutro na altura do peito, Mãos abertas com as palmas para baixo uma sobre a outra. Mão que está embaixo movimentando os dedos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4699,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4701",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4701",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4701",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4701/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6219,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4701/revisions/6219",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4699",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4701",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4701",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4701",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4697,
        date: "2020-12-07T20:33:20",
        date_gmt: "2020-12-07T23:33:20",
        guid: {
            rendered: "https://cintespbr.org/?p=4697",
        },
        modified: "2021-06-13T22:32:13",
        modified_gmt: "2021-06-14T01:32:13",
        slug: "sinal-libras-tatil",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-libras-tatil/",
        title: {
            rendered: "Sinal: LIBRAS TÁTIL",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: LIBRAS TÁTIL<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/a3QEV6lMeeI&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: LIBRAS TÁTIL 1: </strong></span></p>\n<p><span style="color: #ffff00;">Espaço neutro na altura do peito, Mãos abertas com as palmas para baixo uma sobre a outra. Mão que está embaixo movimentar os dedos alternadamente.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/a3QEV6lMeeI&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: LIBRAS TÁTIL 1: Espaço neutro na altura do peito, Mãos abertas com as palmas para baixo uma sobre a outra. Mão que está embaixo movimentar os dedos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4699,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4697",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4697",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4697",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4697/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6220,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4697/revisions/6220",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4699",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4697",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4697",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4697",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4693,
        date: "2020-12-07T20:29:22",
        date_gmt: "2020-12-07T23:29:22",
        guid: {
            rendered: "https://cintespbr.org/?p=4693",
        },
        modified: "2021-06-13T22:33:44",
        modified_gmt: "2021-06-14T01:33:44",
        slug: "sinal-bengala",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-bengala/",
        title: {
            rendered: "Sinal: INSTRUTOR MEDIADOR",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: INSTRUTOR MEDIADOR<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/a34Ioe7dBV8&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: INSTRUTOR MEDIADOR:</strong></span></p>\n<p><span style="color: #ffff00;">Espaço neutro na altura do peito; Mão passiva fechada com dedo mínimo destacado, palma para frente; Mão ativa com a palma para frente, dedos unidos pelas pontas, ao lado da mão passiva, com movimento de abrir e fechar duas vezes.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/a34Ioe7dBV8&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: INSTRUTOR MEDIADOR: Espaço neutro na altura do peito; Mão passiva fechada com dedo mínimo destacado, palma para frente; Mão ativa com a palma para frente, dedos unidos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4694,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4693",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4693",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4693",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4693/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6221,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4693/revisions/6221",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4694",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4693",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4693",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4693",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4690,
        date: "2020-12-07T20:24:39",
        date_gmt: "2020-12-07T23:24:39",
        guid: {
            rendered: "https://cintespbr.org/?p=4690",
        },
        modified: "2021-06-13T22:36:20",
        modified_gmt: "2021-06-14T01:36:20",
        slug: "sinal-retinose-pigmentar-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-retinose-pigmentar-2/",
        title: {
            rendered: "Sinal: BENGALA",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: BENGALA<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/wyf_OdPb-pc&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: BENGALA:</strong></span></p>\n<p><span style="color: #ffff00;">Braço passivo dobrado, na horizontal em frente ao corpo e na altura do peito, mão aberta com palma para baixo; Mão ativa fechada com o dedo indicador destacado, tocando o antebraço passivo, com movimento simultâneo da direita para a esquerda.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/wyf_OdPb-pc&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: BENGALA: Braço passivo dobrado, na horizontal em frente ao corpo e na altura do peito, mão aberta com palma para baixo; Mão ativa fechada com o dedo&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4499,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4690",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4690",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4690",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4690/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6222,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4690/revisions/6222",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4499",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4690",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4690",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4690",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4596,
        date: "2020-12-04T00:52:50",
        date_gmt: "2020-12-04T03:52:50",
        guid: {
            rendered: "https://cintespbr.org/?p=4596",
        },
        modified: "2021-06-13T22:37:56",
        modified_gmt: "2021-06-14T01:37:56",
        slug: "sinal-retinose-pigmentar",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-retinose-pigmentar/",
        title: {
            rendered: "Sinal: RETINOSE PIGMENTAR",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: RETINOSE PIGMENTAR<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/jqn_6c51aME&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: RETINOSE PIGMENTAR:</strong></span></p>\n<p><span style="color: #ffff00;">Mão com dedo indicador e médio entrelaçados e os outros fechados, tocar levemente ao lado da testa, mudando a configuração da mão para dedo indicador na vertical, médio na horizontal e a ponta do polegar encostando entre ambos.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/jqn_6c51aME&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: RETINOSE PIGMENTAR: Mão com dedo indicador e médio entrelaçados e os outros fechados, tocar levemente ao lado da testa, mudando a configuração da mão para dedo indicador&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4667,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4596",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4596",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4596",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4596/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6223,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4596/revisions/6223",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4667",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4596",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4596",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4596",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4594,
        date: "2020-12-04T00:50:27",
        date_gmt: "2020-12-04T03:50:27",
        guid: {
            rendered: "https://cintespbr.org/?p=4594",
        },
        modified: "2021-06-13T22:57:15",
        modified_gmt: "2021-06-14T01:57:15",
        slug: "sinal-sindrome-de-usher-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-sindrome-de-usher-2/",
        title: {
            rendered: "Sinal: SÍNDROME DE USHER 2",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: SÍNDROME DE USHER 2<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/sbtjz1UbfFU&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal:  SÍNDROME DE USHER 2:</strong></span></p>\n<p><span style="color: #ffff00;">Espaço neutro na altura do peito; Mão passiva parada e fechada unida pelas pontas dos dedos; Mão ativa aberta com a palma para trás à frente da mão passiva, com movimento lateral ondulado para cima e para baixo.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/sbtjz1UbfFU&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal:  SÍNDROME DE USHER 2: Espaço neutro na altura do peito; Mão passiva parada e fechada unida pelas pontas dos dedos; Mão ativa aberta com a palma para&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4669,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4594",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4594",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4594",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4594/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6230,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4594/revisions/6230",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4669",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4594",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4594",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4594",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4592,
        date: "2020-12-04T00:46:42",
        date_gmt: "2020-12-04T03:46:42",
        guid: {
            rendered: "https://cintespbr.org/?p=4592",
        },
        modified: "2021-06-13T22:39:03",
        modified_gmt: "2021-06-14T01:39:03",
        slug: "sinal-sindrome-de-usher",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-sindrome-de-usher/",
        title: {
            rendered: "Sinal: SÍNDROME DE USHER",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: SÍNDROME DE USHER<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/YJK9e4IRgIs&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: SÍNDROME DE USHER 1:</strong></span></p>\n<p><span style="color: #ffff00;">Espaço neutro na altura do peito; Mão passiva parada e fechada unida pelas pontas dos dedos; Mão ativa levemente fechada com a palma para trás à frente da mão passiva, abrir levemente movendo-a para o lado</span>.[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/YJK9e4IRgIs&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: SÍNDROME DE USHER 1: Espaço neutro na altura do peito; Mão passiva parada e fechada unida pelas pontas dos dedos; Mão ativa levemente fechada com a palma&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4669,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4592",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4592",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4592",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4592/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6224,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4592/revisions/6224",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4669",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4592",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4592",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4592",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4590,
        date: "2020-12-04T00:44:03",
        date_gmt: "2020-12-04T03:44:03",
        guid: {
            rendered: "https://cintespbr.org/?p=4590",
        },
        modified: "2021-06-13T22:59:27",
        modified_gmt: "2021-06-14T01:59:27",
        slug: "sinal-tadoma",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-tadoma/",
        title: {
            rendered: "Sinal: TADOMA",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: TADOMA<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/xkpwrw1KRb0&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal:</strong>  <strong>TADOMA:</strong></span></p>\n<p><span style="color: #ffff00;">Mão fechada com a palma para trás, dedos polegar, indicador e médio destacados e levemente curvados encaixando-se no queixo.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/xkpwrw1KRb0&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal:  TADOMA: Mão fechada com a palma para trás, dedos polegar, indicador e médio destacados e levemente curvados encaixando-se no queixo.[/vc_message][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4674,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4590",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4590",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4590",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4590/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6231,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4590/revisions/6231",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4674",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4590",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4590",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4590",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4584,
        date: "2020-12-04T00:36:55",
        date_gmt: "2020-12-04T03:36:55",
        guid: {
            rendered: "https://cintespbr.org/?p=4584",
        },
        modified: "2021-06-13T23:03:04",
        modified_gmt: "2021-06-14T02:03:04",
        slug: "sinal-surdocegueira-ou-surdo-cego-ou-surdo-cega",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-surdocegueira-ou-surdo-cego-ou-surdo-cega/",
        title: {
            rendered: "Sinal: SURDOCEGUEIRA OU SURDOCEGO OU SURDOCEGA",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: SURDOCEGUEIRA OU SURDOCEGO OU SURDOCEGA<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/yhK-FG8R8ao&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal:</strong>  <strong>SURDOCEGUEIRA &#8211; SURDOCEGO &#8211; SURDOCEGA:</strong></span></p>\n<p><span style="color: #ffff00;">Com a palma da mão aberta com os dedos fechados e com polegar estendido, rotacionar levemente com movimento no ouvido e à frente do olho.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/yhK-FG8R8ao&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal:  SURDOCEGUEIRA &#8211; SURDOCEGO &#8211; SURDOCEGA: Com a palma da mão aberta com os dedos fechados e com polegar estendido, rotacionar levemente com movimento no ouvido e à&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4676,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4584",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4584",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4584",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4584/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6232,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4584/revisions/6232",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4676",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4584",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4584",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4584",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4582,
        date: "2020-12-04T00:31:52",
        date_gmt: "2020-12-04T03:31:52",
        guid: {
            rendered: "https://cintespbr.org/?p=4582",
        },
        modified: "2021-06-13T22:40:27",
        modified_gmt: "2021-06-14T01:40:27",
        slug: "sinal-guia-vidente-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-guia-vidente-2/",
        title: {
            rendered: "Sinal: GUIA VIDENTE 2",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: GUIA-VIDENTE 2<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/O1w1HCG3_ZA&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: GUIA-VIDENTE 2:</strong></span></p>\n<p><span style="color: #ffff00;">Espaço neutro, mão passiva com dedos polegar, indicador e médio destacados e pontas para baixo; Mão ativa com dedos médio, anelar e mínimo destacados, as pontas dos dedos polegar e indicador unidas encostando no polegar da mão passiva. Mover as mãos para o lado.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/O1w1HCG3_ZA&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: GUIA-VIDENTE 2: Espaço neutro, mão passiva com dedos polegar, indicador e médio destacados e pontas para baixo; Mão ativa com dedos médio, anelar e mínimo destacados, as&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4679,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4582",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4582",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4582",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4582/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6225,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4582/revisions/6225",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4679",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4582",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4582",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4582",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4578,
        date: "2020-12-04T00:25:12",
        date_gmt: "2020-12-04T03:25:12",
        guid: {
            rendered: "https://cintespbr.org/?p=4578",
        },
        modified: "2021-06-13T22:43:04",
        modified_gmt: "2021-06-14T01:43:04",
        slug: "sinal-guia-vidente",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-guia-vidente/",
        title: {
            rendered: "Sinal: GUIA VIDENTE",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: GUIA-VIDENTE 1<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/egiXu9TT6PE&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: GUIA-VIDENTE 1:</strong></span></p>\n<p><span style="color: #ffff00;">Espaço neutro, mão passiva com dedos polegar, indicador e médio destacados e pontas para baixo; Mão ativa fechada com dedos polegar, indicador e médio segurando com as pontas dos dedos o polegar da mão passiva. Mover as mãos para o lado.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/egiXu9TT6PE&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: GUIA-VIDENTE 1: Espaço neutro, mão passiva com dedos polegar, indicador e médio destacados e pontas para baixo; Mão ativa fechada com dedos polegar, indicador e médio segurando&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4679,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4578",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4578",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4578",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4578/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6226,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4578/revisions/6226",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4679",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4578",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4578",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4578",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4557,
        date: "2020-12-03T03:15:07",
        date_gmt: "2020-12-03T06:15:07",
        guid: {
            rendered: "https://cintespbr.org/?p=4557",
        },
        modified: "2021-06-13T22:44:12",
        modified_gmt: "2021-06-14T01:44:12",
        slug: "sinal-guia-interprete-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-guia-interprete-2/",
        title: {
            rendered: "Sinal: GUIA-INTÉRPRETE 2",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: GUIA-INTÉRPRETE 2<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/4h9g2dHetsI&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: GUIA-INTÉRPRETE 2:</strong></span></p>\n<p><span style="color: #ffff00;">Mão passiva em frente ao corpo com a palma para cima; Mão ativa aberta com a palma para baixo tocando a palma da mão passiva, girar o pulso ficando com a palma para cima. Em seguida braço passivo dobrado na horizontal em frente ao corpo na altura do peito, mão aberta com a palma para trás; Mão ativa dedos curvados com a palma para frente segurando as pontas dos dedos da mão passiva. Mover as mãos para o lado.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/4h9g2dHetsI&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: GUIA-INTÉRPRETE 2: Mão passiva em frente ao corpo com a palma para cima; Mão ativa aberta com a palma para baixo tocando a palma da mão passiva,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4684,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4557",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4557",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4557",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4557/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6227,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4557/revisions/6227",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4684",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4557",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4557",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4557",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4555,
        date: "2020-12-03T03:12:38",
        date_gmt: "2020-12-03T06:12:38",
        guid: {
            rendered: "https://cintespbr.org/?p=4555",
        },
        modified: "2021-06-13T22:46:58",
        modified_gmt: "2021-06-14T01:46:58",
        slug: "sinal-comunicacao-haptica",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/sinal-comunicacao-haptica/",
        title: {
            rendered: "Sinal: COMUNICAÇÃO HÁPTICA",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>Sinal: COMUNICAÇÃO HÁPTICA:<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/1yAK8G0W4V0&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: COMUNICAÇÃO HÁPTICA:</strong></span></p>\n<p><span style="color: #ffff00;">Braço passivo dobrado na horizontal em frente ao corpo na altura do peito, mão aberta com a palma para baixo; Mão ativa aberta, movimento tocando o braço e antebraço passivo.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/1yAK8G0W4V0&#8243;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: COMUNICAÇÃO HÁPTICA: Braço passivo dobrado na horizontal em frente ao corpo na altura do peito, mão aberta com a palma para baixo; Mão ativa aberta, movimento tocando&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4687,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4555",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4555",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4555",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4555/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6229,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4555/revisions/6229",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4687",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4555",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4555",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4555",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4546,
        date: "2020-12-03T03:00:12",
        date_gmt: "2020-12-03T06:00:12",
        guid: {
            rendered: "https://cintespbr.org/?page_id=4546",
        },
        modified: "2021-06-13T22:45:24",
        modified_gmt: "2021-06-14T01:45:24",
        slug: "glossario-de-surdocegueira",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/glossario-de-surdocegueira/",
        title: {
            rendered: "SINAL GUIA INTÉRPRETE 1",
        },
        content: {
            rendered:
                '<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>GLOSSÁRIO DE SURDOCEGUEIRA<span class="separator-holder separator-right"></span></div></div>[/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;]<div class="dt-fancy-separator h2-size style-disabled" style="width: 100%;"><div class="dt-fancy-title" style="color: #ffffff;"><span class="separator-holder separator-left"></span>SINAL GUIA INTÉRPRETE<span class="separator-holder separator-right"></span></div></div>[vc_video link=&#8221;https://youtu.be/kQr_yW1ales&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]<span style="color: #ffff00;"><strong>Configuração de Mão:</strong></span></p>\n<p><span style="color: #ffff00;"><strong>Sinal: GUIA-INTÉRPRETE 1:</strong></span></p>\n<p><span style="color: #ffff00;">Braço passivo dobrado na horizontal em frente ao corpo na altura do peito, mão aberta com a palma para trás; Mão ativa dedos curvados com a palma para frente segurando as pontas dos dedos da mão passiva. Mover as mãos para o lado. Em seguida, mão passiva em frente ao corpo com a palma para cima; Mão ativa aberta com a palma para baixo tocando a palma da mão passiva, girar o pulso ficando com a palma para cima.</span>[/vc_message][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content_no_spaces&#8221; bg_type=&#8221;bg_color&#8221; bg_color_value=&#8221;#3406db&#8221;][vc_column][/vc_column][/vc_row][vc_row type=&#8221;vc_default&#8221; full_width=&#8221;stretch_row_content&#8221; equal_height=&#8221;yes&#8221; margin_top=&#8221;5&#8243; margin_bottom=&#8221;10&#8243; bg_type=&#8221;bg_color&#8221; bg_override=&#8221;ex-full&#8221; css=&#8221;.vc_custom_1606879028484{padding-top: 0px !important;padding-bottom: 0px !important;}&#8221; bg_color_value=&#8221;#181aa0&#8243;][vc_column width=&#8221;1/4&#8243;][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_video link=&#8221;https://youtu.be/kQr_yW1ales&#8221;][vc_message message_box_style=&#8221;solid&#8221; message_box_color=&#8221;black&#8221; icon_type=&#8221;the7&#8243; icon_the7=&#8221;Defaults-quote-left&#8221;]Configuração de Mão: Sinal: GUIA-INTÉRPRETE 1: Braço passivo dobrado na horizontal em frente ao corpo na altura do peito, mão aberta com a palma para trás; Mão ativa dedos curvados com&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4684,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [51],
        tags: [],
        class_list: [
            "post-4546",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-glossario-de-surdocegueira",
            "category-51",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4546",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4546",
                },
            ],
            "version-history": [
                {
                    count: 7,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4546/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 6228,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4546/revisions/6228",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4684",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4546",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4546",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4546",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4463,
        date: "2020-11-17T22:43:16",
        date_gmt: "2020-11-18T01:43:16",
        guid: {
            rendered: "https://cintespbr.org/?p=4463",
        },
        modified: "2021-12-27T23:07:07",
        modified_gmt: "2021-12-28T02:07:07",
        slug: "cpb-faz-parceria-com-universidade-de-toquio-para-capacitar-profissionais-de-paises-novatos-em-jogos-paralimpicos",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cpb-faz-parceria-com-universidade-de-toquio-para-capacitar-profissionais-de-paises-novatos-em-jogos-paralimpicos/",
        title: {
            rendered:
                "CPB faz parceria com universidade de Tóquio para capacitar profissionais de países novatos em Jogos Paralímpicos",
        },
        content: {
            rendered:
                '<div id="attachment_4464" style="width: 1021px" class="wp-caption alignnone"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-4464" class="wp-image-4464 size-full" src="https://cintespbr.org/wp-content/uploads/2020/11/9db04386978f4aec8aef788655e531c4.jpg" alt="" width="1011" height="571" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/11/9db04386978f4aec8aef788655e531c4.jpg 1011w, https://cintespbr.institucional.ws/wp-content/uploads/2020/11/9db04386978f4aec8aef788655e531c4-300x169.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/11/9db04386978f4aec8aef788655e531c4-768x434.jpg 768w" sizes="(max-width: 1011px) 100vw, 1011px" /><p id="caption-attachment-4464" class="wp-caption-text">Foto: Daniel Zappe/CPB/MPIX</p></div>\n<p>O Comitê Paralímpico Brasileiro (CPB) fechou uma parceria com a Nippon Sport Science University, de Tóquio, para participar de um programa de capacitação de profissionais de países que nunca participaram de nenhuma edição dos Jogos Paralímpicos.</p>\n<p>O programa de Educação Paralímpica é um dos pilares do planejamento estratégico do CPB e tem como um dos seus objetivos promover cursos online e gratuitos para profissionais de educação física. O CPB forma por ano, em média, 7 mil professores por meio do seu curso <a href="https://impulsiona.org.br/esporte-paralimpico/" target="_blank" rel="noopener noreferrer"><u><strong>EaD Movimento Paralímpico: fundamentos básicos do esporte</strong></u></a>, além de oferecer qualificações online e gratuitas de arbitragem e habilitação técnica em atletismo, natação e halterofilismo e turmas presenciais em áreas como classificação, gestão, fisioterapia, iniciação, além de arbitragem e habilitação técnica (<strong>saiba como se inscrever no final do texto</strong>).</p>\n<p>Nesta semana, professores do atletismo paralímpico nacional, ligados à área da Educação Paralímpica do CPB, farão um “camping virtual” com cerca de 25 participantes, entre atletas e treinadores, de países latino-americanos como Guatemala, Honduras, Paraguai e Uruguai, e Guiné-Bissau, da África.</p>\n<p>Rosicler Ravache é uma das profissionais do país que vão ministrar as apresentações. Coordenadora de paradesporto na Secretaria de Esportes de Joinville (SC), tem ampla experiência com iniciação esportiva de atletas com deficiência, ministra palestras e cursos e já acompanhou a Seleção Brasileira de Jovens em competições internacionais.</p>\n<p>Outro professor será Eduardo Leonel, ex-atleta da modalidade e atual coordenador técnico da equipe de atletismo paralímpico da cidade de Santos. Também palestra e realiza cursos na área.</p>\n<p>“O Brasil é uma potência paralímpica, e sentimo-nos no dever de difundir e promover o conhecimento e qualificação aos países que ainda não possuem um Movimento Paralímpico consolidado como o brasileiro. Gerar oportunidades para pessoas com deficiência em todo o mundo a partir do capital de conhecimento que nós temos aqui é uma satisfação e uma forma de fortalecer ainda mais a cultura do esporte para pessoas com deficiência no mundo”, afirma Mizael Conrado, bicampeão paralímpico de futebol de cinco em Atenas 2004 e Pequim 2008, e presidente do CPB.</p>\n<p>A ação, chamada NSSU Expansion of Para Sports Participants (ampliação de participantes no paradesporto, em inglês), faz parte do projeto Sport for Tomorrow (Esporte para o amanhã, em inglês), que é financiado pela Japan Sport Agency (Ministério do Esporte do Japão), assistido pelo Comitê Paralímpico do Japão, e conta com o apoio do IPC (Comitê Paralímpico Internacional) por meio da Fundação Agitos.</p>\n<p>O objetivo principal do programa é maximizar o número de países participantes nos Jogos Paralímpicos em Tóquio (o recorde histórico foi de 164 países em Londres 2012) e, em longo prazo, estabelecer o aumento da inclusão social nas nações atendidas.</p>\n<p>Consiste também no desenvolvimento de treinadores e atletas paralímpicos pelo mundo e no apoio dos países à participação em Jogos e competições internacionais.</p>\n<p><strong>CONFIRA ABAIXO OS CURSOS NO BRASIL COM INSCRIÇÕES ABERTAS:</strong></p>\n<p>Todos os cursos são lecionados por profissionais do CPB com ampla experiência e vivência prática nos temas ou em áreas ofertados para formação.</p>\n<p><strong>Atletismo</strong></p>\n<p>O CPB está com inscrições abertas para suas clínicas de atualização em atletismo. As aulas online serão gratuitas e voltadas para profissionais da Educação Física de todo o Brasil que já concluíram o curso de habilitação técnica da modalidade.</p>\n<p>Serão realizadas clínicas para todos os níveis de graduação em atletismo e a programação terá datas e conteúdos específicos para cada turma. <a href="https://www.cpb.org.br/noticia/detalhe/3093/cpb-lanca-clinicas-online-de-atualizacao-para-profissionais-que-atuam-com-atletismo" target="_blank" rel="noopener noreferrer"><u><strong>Saiba mais aqui</strong></u></a>.</p>\n<p><strong>Natação</strong></p>\n<p>O CPB também está com inscrições abertas para suas clínicas de atualização em natação. As aulas online serão gratuitas e voltadas para profissionais da Educação Física de todo o Brasil que já concluíram o curso de habilitação técnica da modalidade.</p>\n<p>Serão realizadas clínicas para todos os níveis de graduação em natação e a programação terá datas e conteúdos específicos para cada turma. <a href="https://www.cpb.org.br/noticia/detalhe/3103/cpb-lanca-clinicas-online-de-atualizacao-para-profissionais-que-atuam-com-natacao" target="_blank" rel="noopener noreferrer"><u><strong>Saiba mais aqui</strong></u></a>.</p>\n<p><strong>Halterofilismo</strong></p>\n<p>O CPB também está com inscrições abertas para suas clínicas de atualização em halterofilismo. As aulas online serão gratuitas e voltadas para profissionais da Educação Física de todo o Brasil que já concluíram o curso de habilitação técnica da modalidade.</p>\n<p>Serão realizadas clínicas para todos os níveis de graduação em halterofilismo e a programação terá datas e conteúdos específicos para cada turma. <a href="https://cpb.org.br/noticia/detalhe/3109/cpb-lanca-clinicas-online-de-atualizacao-para-profissionais-que-atuam-com-halterofilismo" target="_blank" rel="noopener noreferrer"><u><strong>Saiba mais aqui</strong></u></a></p>\n<p>Para mais informações ou dúvidas, os interessados podem enviar um e-mail para <strong>educ.paralimpica@cpb.org.br</strong>.</p>\n<p><strong>Assessoria de Comunicação do Comitê Paralímpico Brasileiro</strong></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O Comitê Paralímpico Brasileiro (CPB) fechou uma parceria com a Nippon Sport Science University, de Tóquio, para participar de um programa de capacitação de profissionais de países que nunca participaram de nenhuma edição dos Jogos Paralímpicos. O programa de Educação Paralímpica é um dos pilares do planejamento estratégico do CPB e tem como um dos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4464,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-4463",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4463",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4463",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4463/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4465,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4463/revisions/4465",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4464",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4463",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4463",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4463",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4425,
        date: "2020-11-08T09:43:44",
        date_gmt: "2020-11-08T12:43:44",
        guid: {
            rendered: "https://cintespbr.org/?p=4425",
        },
        modified: "2021-12-27T23:07:07",
        modified_gmt: "2021-12-28T02:07:07",
        slug: "cpb-lanca-clinicas-online-de-atualizacao-para-profissionais-que-atuam-com-halterofilismo",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cpb-lanca-clinicas-online-de-atualizacao-para-profissionais-que-atuam-com-halterofilismo/",
        title: {
            rendered:
                "CPB lança clínicas online de atualização para profissionais que atuam com halterofilismo",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-4426 size-full" src="https://cintespbr.org/wp-content/uploads/2020/11/96edaad657ef48ff93c7a7520b4813aa.png" alt="" width="1011" height="571" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/11/96edaad657ef48ff93c7a7520b4813aa.png 1011w, https://cintespbr.institucional.ws/wp-content/uploads/2020/11/96edaad657ef48ff93c7a7520b4813aa-300x169.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/11/96edaad657ef48ff93c7a7520b4813aa-768x434.png 768w" sizes="(max-width: 1011px) 100vw, 1011px" /></p>\n<p>O Comitê Paralímpico Brasileiro (CPB), por meio da sua área de <a href="https://cpb.org.br/ocomite/educacaoparalimpica" target="_blank" rel="noopener noreferrer"><u><strong>Educação Paralímpica</strong></u></a>, está com inscrições abertas para suas clínicas de atualização em halterofilismo. As aulas online serão gratuitas e voltadas para profissionais da Educação Física de todo o Brasil que já concluíram o curso de habilitação técnica da modalidade, também realizado pelo CPB.</p>\n<p>Saiba mais em <a href="https://cpb.org.br/noticia/detalhe/3109/cpb-lanca-clinicas-online-de-atualizacao-para-profissionais-que-atuam-com-halterofilismo">cpb.org.br</a></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O Comitê Paralímpico Brasileiro (CPB), por meio da sua área de Educação Paralímpica, está com inscrições abertas para suas clínicas de atualização em halterofilismo. As aulas online serão gratuitas e voltadas para profissionais da Educação Física de todo o Brasil que já concluíram o curso de habilitação técnica da modalidade, também realizado pelo CPB. Saiba mais&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4426,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-4425",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4425",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4425",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4425/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4427,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4425/revisions/4427",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4426",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4425",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4425",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4425",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4422,
        date: "2020-11-08T09:32:14",
        date_gmt: "2020-11-08T12:32:14",
        guid: {
            rendered: "https://cintespbr.org/?p=4422",
        },
        modified: "2021-12-27T22:49:46",
        modified_gmt: "2021-12-28T01:49:46",
        slug: "podcast-ciencia-ao-pe-do-ouvido-aborda-saude-do-homem-e-masculinidades",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/podcast-ciencia-ao-pe-do-ouvido-aborda-saude-do-homem-e-masculinidades/",
        title: {
            rendered:
                "Podcast &#8216;Ciência ao Pé do Ouvido&#8217; aborda saúde do homem e masculinidades",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-4423 size-full" src="https://cintespbr.org/wp-content/uploads/2020/11/imagem_destaque_a7b3601c-b023-4559-9525-501c21bb51bd.jpeg" alt="" width="1280" height="725" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/11/imagem_destaque_a7b3601c-b023-4559-9525-501c21bb51bd.jpeg 1280w, https://cintespbr.institucional.ws/wp-content/uploads/2020/11/imagem_destaque_a7b3601c-b023-4559-9525-501c21bb51bd-300x170.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/11/imagem_destaque_a7b3601c-b023-4559-9525-501c21bb51bd-1024x580.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/11/imagem_destaque_a7b3601c-b023-4559-9525-501c21bb51bd-768x435.jpeg 768w" sizes="(max-width: 1280px) 100vw, 1280px" /></p>\n<p style="font-weight: 400;">Chegamos ao Novembro Azul, o mês da campanha de conscientização sobre os cuidados com a saúde do homem. Afinal, em média, os homens vivem sete anos a menos que as mulheres. Por que isso acontece? Os convidados do episódio #09 do podcast &#8220;Ciência ao Pé do Ouvido&#8221; vão responder a essa e outras perguntas.</p>\n<h3 style="font-weight: 400;"><strong>Ouça gratuitamente no <u><a href="https://anchor.fm/cienciaaopedoouvido/episodes/09---Por-que-os-homens-vivem-menos-elvjvm/a-a3o5sg5">ANCHOR</a></u>, no <u><a href="https://open.spotify.com/episode/18fbcKywnvJCDYejFNniEN">SPOTIFY</a></u> ou em outros aplicativos de podcast. </strong></h3>\n<p>O podcast “Ciência ao Pé do Ouvido” é produzido pela Divisão de Divulgação Científica da Diretoria de Comunicação Social (Dirco) da Universidade Federal de Uberlândia (UFU).</p>\n<p>&nbsp;</p>\n<p>Fonte: http://www.comunica.ufu.br/</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Chegamos ao Novembro Azul, o mês da campanha de conscientização sobre os cuidados com a saúde do homem. Afinal, em média, os homens vivem sete anos a menos que as mulheres. Por que isso acontece? Os convidados do episódio #09 do podcast &#8220;Ciência ao Pé do Ouvido&#8221; vão responder a essa e outras perguntas. Ouça&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4423,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [62, 46],
        tags: [],
        class_list: [
            "post-4422",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-todas-as-noticias",
            "category-ultimas-noticias",
            "category-62",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4422",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4422",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4422/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4424,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4422/revisions/4424",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4423",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4422",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4422",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4422",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4389,
        date: "2020-11-01T16:12:13",
        date_gmt: "2020-11-01T19:12:13",
        guid: {
            rendered: "https://cintespbr.org/?p=4389",
        },
        modified: "2020-11-01T16:21:15",
        modified_gmt: "2020-11-01T19:21:15",
        slug: "novembro-azul-cuidados-do-homem-com-a-prostata-e-a-saude",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/novembro-azul-cuidados-do-homem-com-a-prostata-e-a-saude/",
        title: {
            rendered:
                "Novembro Azul &#8211; Cuidados do Homem com a Próstata e a Saúde",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="alignnone wp-image-4390 size-full" src="https://cintespbr.org/wp-content/uploads/2020/11/novembro-azul.jpg" alt="" width="2120" height="690" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/11/novembro-azul.jpg 2120w, https://cintespbr.institucional.ws/wp-content/uploads/2020/11/novembro-azul-300x98.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/11/novembro-azul-1024x333.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/11/novembro-azul-768x250.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/11/novembro-azul-1536x500.jpg 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2020/11/novembro-azul-2048x667.jpg 2048w" sizes="(max-width: 2120px) 100vw, 2120px" /></p>\n<p style="text-align: justify;">A cada dia 42 homens morrem em decorrência do câncer de próstata e aproximadamente 3 milhões vivem com a doença, sendo essa, a segunda maior causa de morte por câncer em homens no Brasil. São estimados para este ano 68.220 novos casos, segundo o Instituto Nacional do Câncer (Inca).</p>\n<p style="text-align: justify;">O câncer de próstata permanece como a neoplasia sólida mais comum e a segunda maior causa de óbito oncológico no sexo masculino. Segundo dados do Instituto Nacional do Câncer (INCA), estão estimados 65.840 casos novos de câncer de próstata para cada ano do triênio 2020-2022. Esse valor corresponde a um risco estimado de 62,95 casos novos a cada 100 mil homens, constituindo o tipo de câncer mais incidente nos homens (excetuando-se o câncer de pele não melanoma) em todas as regiões do país.</p>\n<p style="text-align: justify;">Apesar dos avanços terapêuticos, cerca de 25% dos pacientes com câncer de próstata ainda morrem devido à doença. Atualmente, cerca de 20% ainda são diagnosticados em estágios avançados, embora um declínio importante tenha ocorrido nas últimas décadas em decorrência, principalmente, de políticas para o diagnóstico precoce da doença e maior conscientização da população masculina.</p>\n<p style="text-align: justify;">O rastreamento universal de toda população masculina (sem considerar idade, raça e história familiar) apresenta controvérsias, pois pode diagnosticar, entre outros, câncer de próstata de baixa agressividade, que não necessita de tratamento, cujos pacientes são submetidos a biópsias, que têm potencial de complicações (infecção local), e, eventualmente, tratamentos radicais com potencial impacto na qualidade de vida.</p>\n<p style="text-align: justify;">Individualizar a abordagem é fundamental neste sentido. A identificação de pacientes com risco de desenvolver a doença de forma mais agressiva, por meio de parâmetros clínicos ou laboratoriais, pode ajudar a individualizar a indicação e frequência das avaliações periódicas. Entre diversos fatores, a idade, a raça e a história familiar apresentam-se como os mais importantes3. Análise recente de dois estudos avaliando tardiamente os resultados quanto à mortalidade câncer-específica mostra vantagem a favor desses programas com diminuição da taxa de mortalidade de 25% a 31% (estudo ERSPC) e de 27% a 32% (estudo PLCO) em comparação aos pacientes que não foram randomizados.</p>\n<p style="text-align: justify;">Para pacientes diagnosticados com tumores de baixo risco, a visão contemporânea é o oferecimento do regime de observação vigilante como conduta e consiste em avaliações periódicas por meio de toque retal e dosagens do PSA, reservando-se a ressonância magnética da pelve e/ou biópsia prostática para ser realizada em intervalos variados. O tratamento definitivo deve ser indicado caso seja identificada progressão da doença em pacientes com expectativa de vida maior que 10 (dez) anos, poupando pacientes com tumores “indolentes” das consequências do tratamento.</p>\n<p style="text-align: justify;">Por outro lado, pacientes portadores de tumores classificados como de risco de progressão alto ou moderado podem, em fases iniciais, ser adequadamente tratados e curados.</p>\n<p style="text-align: justify;">A Sociedade Brasileira de Urologia mantém sua recomendação de que os homens, a partir de 50 anos e mesmo sem apresentar sintomas, devem procurar um profissional especializado, para avaliação individualizada tendo como objetivo o diagnóstico precoce do câncer de próstata. Os homens que integrarem o grupo de risco (raça negra ou com parentes de primeiro grau com câncer de próstata) devem começar seus exames mais precocemente, a partir dos 45 anos. Após os 75 anos, somente homens com perspectiva de vida maior do que 10 anos poderão fazer essa avaliação.</p>\n<p>Fonte: https://portaldaurologia.org.br</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>A cada dia 42 homens morrem em decorrência do câncer de próstata e aproximadamente 3 milhões vivem com a doença, sendo essa, a segunda maior causa de morte por câncer em homens no Brasil. São estimados para este ano 68.220 novos casos, segundo o Instituto Nacional do Câncer (Inca). O câncer de próstata permanece como&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 0,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [50],
        tags: [],
        class_list: [
            "post-4389",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "hentry",
            "category-novembro-azul",
            "category-50",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4389",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4389",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4389/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4397,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4389/revisions/4397",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4389",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4389",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4389",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4353,
        date: "2020-10-20T22:50:33",
        date_gmt: "2020-10-21T01:50:33",
        guid: {
            rendered: "https://cintespbr.org/?p=4353",
        },
        modified: "2021-12-27T22:49:46",
        modified_gmt: "2021-12-28T01:49:46",
        slug: "diretor-geral-do-cintesp-br-participa-de-mesa-redonda-no-17o-conpeex-simposios-tematicos",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/diretor-geral-do-cintesp-br-participa-de-mesa-redonda-no-17o-conpeex-simposios-tematicos/",
        title: {
            rendered:
                "DIRETOR GERAL DO CINTESP.BR PARTICIPA DE MESA REDONDA NO 17º CONPEEX &#8211; SIMPÓSIOS TEMÁTICOS",
        },
        content: {
            rendered:
                '<p>O Diretor geral do CINTESP.Br participa nesta quinta-feira (22/10/2020)  do CONPEX &#8211; Simpósios Temáticos</p>\n<p>Nesta ocasião, juntamente com os palestrantes Estevam Barbosa de Las Casas (UFMG), Diogo de Souza Rabelo (UFG) participará de uma MESA REDONDA. com o tema: As novas Fronteiras das Engenharias.</p>\n<p><img loading="lazy" decoding="async" class="aligncenter wp-image-4354 size-full" src="https://cintespbr.org/wp-content/uploads/2020/10/conpeex.png" alt="" width="2637" height="1747" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/10/conpeex.png 2637w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/conpeex-300x199.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/conpeex-1024x678.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/conpeex-768x509.png 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/conpeex-1536x1018.png 1536w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/conpeex-2048x1357.png 2048w" sizes="(max-width: 2637px) 100vw, 2637px" /></p>\n<p>&nbsp;</p>\n<p>Acesso <a href="https://www.youtube.com/watch?v=rrYwNlxQKpQ">https://www.youtube.com/watch?v=rrYwNlxQKpQ</a> e acompanhe.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O Diretor geral do CINTESP.Br participa nesta quinta-feira (22/10/2020)  do CONPEX &#8211; Simpósios Temáticos Nesta ocasião, juntamente com os palestrantes Estevam Barbosa de Las Casas (UFMG), Diogo de Souza Rabelo (UFG) participará de uma MESA REDONDA. com o tema: As novas Fronteiras das Engenharias. &nbsp; Acesso https://www.youtube.com/watch?v=rrYwNlxQKpQ e acompanhe.</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4354,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [62, 46],
        tags: [],
        class_list: [
            "post-4353",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-todas-as-noticias",
            "category-ultimas-noticias",
            "category-62",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4353",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4353",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4353/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4355,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4353/revisions/4355",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4354",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4353",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4353",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4353",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4294,
        date: "2020-10-16T21:00:36",
        date_gmt: "2020-10-17T00:00:36",
        guid: {
            rendered: "https://cintespbr.org/?p=4294",
        },
        modified: "2021-12-27T23:07:07",
        modified_gmt: "2021-12-28T02:07:07",
        slug: "bolha-paralimpica-completa-tres-meses-com-quase-300-testes-realizados",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/bolha-paralimpica-completa-tres-meses-com-quase-300-testes-realizados/",
        title: {
            rendered:
                "Bolha paralímpica completa três meses com quase 300 testes realizados",
        },
        content: {
            rendered:
                '<div id="attachment_4295" style="width: 1021px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-4295" class="wp-image-4295 size-full" src="https://cintespbr.org/wp-content/uploads/2020/10/6654fdad117b45b6af63f892d009498c.jpg" alt="" width="1011" height="571" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/10/6654fdad117b45b6af63f892d009498c.jpg 1011w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/6654fdad117b45b6af63f892d009498c-300x169.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/6654fdad117b45b6af63f892d009498c-768x434.jpg 768w" sizes="(max-width: 1011px) 100vw, 1011px" /><p id="caption-attachment-4295" class="wp-caption-text">Foto: Ale Cabral/CPB</p></div>\n<p>O Comitê Paralímpico Brasileiro (CPB) registrou apenas um caso de contaminação por Covid-19 desde a reabertura parcial do Centro de Treinamento Paralímpico, na capital paulista, realizada em julho, após autorização da prefeitura de São Paulo. No período, foram quase 300 testes realizados em atletas e profissionais das comissões técnicas.</p>\n<p>Atualmente, cerca de 40 atletas de atletismo, natação e tênis de mesa e frequentam o CT Paralímpico diariamente para a realização dos treinamentos. Apenas essas modalidades foram autorizadas a retornar às atividades porque possuem o centro de excelência no próprio local.</p>\n<p>&#8220;Conseguimos, baseado no nosso protocolo de segurança, promover um retorno seguro às atividades esportivas dos atletas paralímpicos do Brasil. Com isso, demonstramos, novamente, termos optado pelo melhor caminho durante este período de incertezas que ainda vivemos&#8221;, afirma Mizael Conrado, bicampeão paralímpico de futebol de cinco em Atenas 2004 e Pequim 2008, e presidente do CPB.</p>\n<p>A equipe médica do CPB tem submetido os atletas e treinadores a testes de PCR e sorologia com frequência, além de outras medidas de prevenção, como áreas específicas de circulação e rodízio de atletas durante os treinos, com limites de quantidade de pessoas por atividade e normas de distanciamento durante a permanência no CT.</p>\n<p>Os procedimentos que estão sendo seguidos contemplam também outros momentos da rotina diária dos atletas, desde a sua saída de casa até o seu retorno à residência, como cuidados no transporte, em elevadores, acessos às estruturas esportivas, processamento de roupas, sanitização, alimentação e suplementação, entre outros.</p>\n<p>Neste período, foram realizados 187 testes de PCR e outros 73 de sorologia em atletas e integrantes de comissão técnica que frequentaram o local desde então.</p>\n<p>O protocolo, que contou com a coordenação do médico-chefe do CPB, Hésojy Gley, e apoio das áreas técnicas, enfermagem e fisioterapia, pode ser <a href="https://www.cpb.org.br/upload/link/28047173215541dc83df3f670e29a600.pdf" target="_blank" rel="noopener noreferrer"><u><strong>acessado neste link</strong></u></a>.</p>\n<p>&#8220;Já são três meses em que a rotina de treinamento praticamente voltou ao normal. Posso dizer que passou rápido, muito mais rápido do que os 113 dias em casa esperando a reabertura do CT. Claro que não está tudo liberado ainda. Todos nós precisamos fazer adaptações, como por exemplo preparar nossa alimentação em casa já que o restaurante permanece fechado por questão de segurança. Mas só em ter uma piscina no padrão do nosso CT, a academia funcionando e a comissão técnica próxima da gente, podemos trabalhar 100%, o que é fundamental para a nossa preparação&#8221;, afirma o nadador pernambucano Phelipe Rodrigues, da classe S10.</p>\n<p>&#8220;Está sendo bem positivo este retorno com a segurança que o CPB está nos proporcionando. Com certeza, havia uma preocupação dos atletas em relação aos protocolos e à rotina de treinos no CT. Mas, estamos sendo testados periodicamente, com medição de temperatura e oxigenação, com trajetos pré-definidos da entrada até ao espaço das mesas de tênis. Não podemos nem pegar as bolinhas que caem no chão durante os treinos antes de serem higienizadas. Então, todas essas medidas permitem que nós, atletas, fiquemos focados apenas nos treinamentos&#8221;, completa a gaúcha Danielle Rauen, da classe 9 do tênis de mesa.</p>\n<p>Além disso, o CT Paralímpico permanecerá com as demais atividades, calendário de competições e treinamentos suspensos por tempo indeterminado. Funcionários e demais profissionais que atuam no local diariamente continuam em isolamento ou em trabalho home office.</p>\n<p>&#8220;O protocolo traz confiança para os atletas. Independentemente das fases de reabertura que São Paulo e demais estados estão aplicando, o CPB continua mantendo as rotinas preventivas ao vírus sob rígidos padrões. Com isso, ficamos muito tranquilos e seguros para treinar&#8221;, finaliza a paranaense Lorena Spoladore, da classe T11 (atletas com deficiência visual) do atletismo.</p>\n<p><strong>Assessoria de Comunicação do Comitê Paralímpico Brasileiro (imp@cpb.org.br)</strong></p>\n<p>Fonte: https://cpb.org.br/</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O Comitê Paralímpico Brasileiro (CPB) registrou apenas um caso de contaminação por Covid-19 desde a reabertura parcial do Centro de Treinamento Paralímpico, na capital paulista, realizada em julho, após autorização da prefeitura de São Paulo. No período, foram quase 300 testes realizados em atletas e profissionais das comissões técnicas. Atualmente, cerca de 40 atletas de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4295,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-4294",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4294",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4294",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4294/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4296,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4294/revisions/4296",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4295",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4294",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4294",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4294",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4289,
        date: "2020-10-12T21:30:54",
        date_gmt: "2020-10-13T00:30:54",
        guid: {
            rendered: "https://cintespbr.org/?p=4289",
        },
        modified: "2021-12-27T22:49:46",
        modified_gmt: "2021-12-28T01:49:46",
        slug: "bate-papo-ciencia-e-tecnologia-no-dia-a-dia-especial-dia-das-criancas",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/bate-papo-ciencia-e-tecnologia-no-dia-a-dia-especial-dia-das-criancas/",
        title: {
            rendered:
                "Bate Papo Ciência e Tecnologia no dia a dia &#8211; Especial Dia das Crianças",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="aligncenter wp-image-4290 size-full" src="https://cintespbr.org/wp-content/uploads/2020/10/WhatsApp-Image-2020-10-12-at-20.33.43.jpeg" alt="" width="1024" height="1280" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/10/WhatsApp-Image-2020-10-12-at-20.33.43.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/WhatsApp-Image-2020-10-12-at-20.33.43-240x300.jpeg 240w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/WhatsApp-Image-2020-10-12-at-20.33.43-819x1024.jpeg 819w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/WhatsApp-Image-2020-10-12-at-20.33.43-768x960.jpeg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n',
            protected: false,
        },
        excerpt: {
            rendered: "",
            protected: false,
        },
        author: 4,
        featured_media: 4291,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [],
        class_list: [
            "post-4289",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4289",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4289",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4289/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4292,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4289/revisions/4292",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4291",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4289",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4289",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4289",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4251,
        date: "2020-10-03T22:40:42",
        date_gmt: "2020-10-04T01:40:42",
        guid: {
            rendered: "https://cintespbr.org/?p=4251",
        },
        modified: "2021-12-27T22:49:46",
        modified_gmt: "2021-12-28T01:49:46",
        slug: "outubro-rosa",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/outubro-rosa/",
        title: {
            rendered: "OUTUBRO ROSA:  Se cuidar é uma luta de todas",
        },
        content: {
            rendered:
                '<p>[vc_row][vc_column][vc_single_image image=&#8221;4247&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;]<div class="dt-fancy-separator h1-size" style="width: 100%;"><div class="dt-fancy-title" style="color: #ff007f;"><span class="separator-holder separator-left"></span>Outubro Rosa: Se cuidar é uma luta de todas<span class="separator-holder separator-right"></span></div></div>[vc_wp_text]</p>\n<p style="text-align: justify;">O Brasil celebra no dia 11 de Outubro o Dia Nacional da Pessoa com Deficiência Física.<br />\nA data foi instituída pela Lei Nº 2.795, promulgada em 15 de abril de 1981 pelo governo de São Paulo e posteriormente comemorada em todo o território nacional.</p>\n<p style="text-align: justify;">A finalidade é promover a conscientização da sociedade sobre as ações que devem ser realizadas para garantir a qualidade de vida e a promoção dos direitos das pessoas com deficiência física.</p>\n<p style="text-align: justify;">Segundo dados do Censo de 2010, o Brasil possui mais de 45 milhões de pessoas com algum tipo de deficiência, o que representa 24% da população. Deste total, mais de 13 milhões são pessoas com deficiência física – aquelas que possuem alguma perda em sua formação de natureza fisiológica ou anatômica que atrapalhe o desenvolvimento de algumas atividades.</p>\n<h3>Outubro Rosa</h3>\n<p>Esta campanha é dedicada à conscientização do câncer de mama.</p>\n<p>E também dedicado as pessoas com deficiência física.</p>\n<p style="text-align: justify;">06/10 – Dia Mundial da Paralisia Cerebral<br />\n10/10 – Dia Mundial da Saúde Mental<br />\n11/10 – Dia da Pessoa com Deficiência Física<br />\n20/10 – Dia Mundial e Nacional da Osteoporose<b><br />\n</b>25/10 – Dia Nacional do Combate ao Preconceito às Pessoas com Nanismo</p>\n<p>[/vc_wp_text][/vc_column][/vc_row]</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_single_image image=&#8221;4247&#8243; img_size=&#8221;full&#8221; alignment=&#8221;center&#8221;][vc_wp_text] O Brasil celebra no dia 11 de Outubro o Dia Nacional da Pessoa com Deficiência Física. A data foi instituída pela Lei Nº 2.795, promulgada em 15 de abril de 1981 pelo governo de São Paulo e posteriormente comemorada em todo o território nacional. A finalidade é promover a conscientização da&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4247,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [],
        class_list: [
            "post-4251",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4251",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4251",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4251/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4352,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4251/revisions/4352",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4247",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4251",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4251",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4251",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4241,
        date: "2020-10-03T21:48:37",
        date_gmt: "2020-10-04T00:48:37",
        guid: {
            rendered: "https://cintespbr.org/?p=4241",
        },
        modified: "2021-12-27T23:07:07",
        modified_gmt: "2021-12-28T02:07:07",
        slug: "comite-organizador-de-toquio-2020-divulga-cronograma-do-revezamento-da-tocha-paralimpica",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/comite-organizador-de-toquio-2020-divulga-cronograma-do-revezamento-da-tocha-paralimpica/",
        title: {
            rendered:
                "Comitê Organizador de Tóquio 2020 divulga cronograma do revezamento da tocha paralímpica",
        },
        content: {
            rendered:
                '<div id="attachment_4242" style="width: 839px" class="wp-caption aligncenter"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-4242" class="wp-image-4242" src="https://cintespbr.org/wp-content/uploads/2020/10/9ab353906eaf4dc2a264a9b3f6d9d5a1-300x169.jpg" alt="" width="829" height="467" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/10/9ab353906eaf4dc2a264a9b3f6d9d5a1-300x169.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/9ab353906eaf4dc2a264a9b3f6d9d5a1-768x434.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/10/9ab353906eaf4dc2a264a9b3f6d9d5a1.jpg 1011w" sizes="(max-width: 829px) 100vw, 829px" /><p id="caption-attachment-4242" class="wp-caption-text">Foto de divulgação da Tocha Paralímpica de Tóquio 2020</p></div>\n<p>O Comitê Organizador dos Jogos Olímpicos e Paralímpicos de Tóquio 2020 divulgou na segunda-feira, 28, um novo cronograma para o revezamento da tocha paralímpica dos Jogos de Tóquio, adiados para agosto de 2021.</p>\n<p>No novo plano, foi estabelecido que o revezamento será realizado de 12 a 24 de agosto, durante o período de transição dos Jogos Olímpicos para os Jogos Paralímpicos. O objetivo é criar uma atmosfera festiva na preparação para os Jogos Paralímpicos, mantendo a dinâmica gerada pelo megaevento anterior.</p>\n<p>Alinhado com o conceito do revezamento da tocha “Compartilhe sua Luz”, três pessoas que se encontram pela primeira vez, se reunirão para formar equipes de corredores. Espera-se que os Jogos Paralímpicos de Tóquio 2020 ofereçam às pessoas a oportunidade de refletir sobre uma nova parceria e a sociedade, ajudando a promover uma sociedade mais inclusiva.</p>\n<p><strong>Cronograma  </strong></p>\n<p>As datas programadas para cada província (região) do país asiático em 2021 serão um dia antes das datas programadas originalmente em 2020, ou seja, os dias da semana corresponderão à programação anterior. A partir de 12 de agosto, festivais de iluminação de chamas serão realizados em todas as 47 províncias do Japão.</p>\n<p>As chamas individuais serão reunidas e se tornarão uma única chama paralímpica em um evento de junção de chamas em Tóquio no dia 20 de agosto, quando serão combinadas com uma chama que terá sido acesa em um evento de iluminação chamado “Heritage Flame”, em Stoke Mandeville, na Grã-Bretanha, o berço espiritual do Movimento Paralímpico. O “Flame” fará um tour pela capital japonesa durante o revezamento da tocha Paralímpica de 21 a 24 de agosto, o dia da cerimônia de abertura dos Jogos Paralímpicos de Tóquio 2020.</p>\n<p><strong>Municípios locais  </strong></p>\n<p>A princípio, os mesmos municípios locais na Prefeitura de Shizuoka, Prefeitura de Chiba, Prefeitura de Saitama e Tóquio administrarão os segmentos de Revezamento da Tocha Paralímpica em 2021. A rota planejada e outros aspectos do revezamento em cada município levarão em consideração a situação da Covid-19.</p>\n<p><strong>Os condutores da Tocha Paralímpica  </strong></p>\n<p>Não estão previstas mudanças nos planos anunciados para o revezamento originalmente programado para este ano. Haverá cerca de 1 mil pessoas que conduzirão a tocha e que foram selecionados entre os que se inscreveram em fevereiro de 2020, e eles serão organizados em grupos de três. O Tóquio 2020 anunciará separadamente uma programação detalhada que incluirá os grupos e setores designados a cada um dos portadores da tocha.</p>\n<p><strong>Mudanças do revezamento da tocha paralímpica  </strong></p>\n<p>Em cooperação com todos os oficiais dos Jogos e partes interessadas, os Jogos Paralímpicos remarcados serão &#8220;Jogos simplificados&#8221;. Tóquio 2020, portanto, está pensando em como realizar o revezamento da tocha paralímpica de forma mais simples e eficiente.</p>\n<p>Os pontos em discussão incluem a redução do tamanho dos comboios de veículos, da simplificação das cerimônias de partida nos locais de revezamento da tocha nas prefeituras de Shizuoka, Chiba e Saitama, e o evento de celebração em Tóquio, revisando a decoração e os equipamentos fornecidos nos locais, e a melhora da eficiência de outros aspectos da operação de revezamento e preparações para o revezamento, incluindo uma revisão do número de funcionários e outros funcionários envolvidos.</p>\n<p><strong>Medidas contra Covid-19 durante o revezamento da tocha  </strong></p>\n<p>O Comitê de Tóquio 2020 está revisando uma série de medidas para evitar a propagação da Covid-19 durante o revezamento da tocha, consultando os especialistas e as autoridades de saúde com o objetivo de garantir um evento seguro e protegido, e planeja anunciar detalhes assim que forem decididos.</p>\n<p><em>Fonte: https://www.cpb.org.br/noticia/</em></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O Comitê Organizador dos Jogos Olímpicos e Paralímpicos de Tóquio 2020 divulgou na segunda-feira, 28, um novo cronograma para o revezamento da tocha paralímpica dos Jogos de Tóquio, adiados para agosto de 2021. No novo plano, foi estabelecido que o revezamento será realizado de 12 a 24 de agosto, durante o período de transição dos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4242,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-4241",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4241",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4241",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4241/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4243,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4241/revisions/4243",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4242",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4241",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4241",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4241",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4230,
        date: "2020-09-26T21:05:56",
        date_gmt: "2020-09-27T00:05:56",
        guid: {
            rendered: "https://cintespbr.org/?p=4230",
        },
        modified: "2021-12-27T23:07:07",
        modified_gmt: "2021-12-28T02:07:07",
        slug: "conheca-5-historias-de-atletas-paralimpicos-que-trocaram-de-modalidade-durante-a-carreira-esportiva",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/conheca-5-historias-de-atletas-paralimpicos-que-trocaram-de-modalidade-durante-a-carreira-esportiva/",
        title: {
            rendered:
                "Conheça 5 histórias de atletas paralímpicos que trocaram de modalidade durante a carreira esportiva",
        },
        content: {
            rendered:
                '<div id="attachment_4231" style="width: 788px" class="wp-caption aligncenter"><a href="https://www.cpb.org.br/noticia/detalhe/3064/conheca-5-historias-de-atletas-paralimpicos-que-trocaram-de-modalidade-durante-a-carreira-esportiva"><img loading="lazy" decoding="async" aria-describedby="caption-attachment-4231" class="wp-image-4231" src="https://cintespbr.org/wp-content/uploads/2020/09/da88f284f5d44518bc74bb8f9e187d71-300x169.jpeg" alt="" width="778" height="438" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/da88f284f5d44518bc74bb8f9e187d71-300x169.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/da88f284f5d44518bc74bb8f9e187d71.jpeg 1011w" sizes="(max-width: 778px) 100vw, 778px" /></a><p id="caption-attachment-4231" class="wp-caption-text">Montagem com fotos dos cinco atletas: Jane Karla, Beth Gomes, Fábio bordignon, Silvana Fernandes e Lucilene Sousa</p></div>\n<p>Nem sempre a primeira modalidade que um atleta experimenta é a que o levará ao topo do pódio. Algumas vezes, os atletas praticam outra modalidade por anos antes de escolher em qual seguirá carreira.<br />\nSeparamos cinco histórias que nos incentivam a experimentar novos esportes. Confira na lista abaixo qual era a modalidade anterior de alguns desses atletas</p>\n<p><a href="https://www.cpb.org.br/noticia/detalhe/3064/conheca-5-historias-de-atletas-paralimpicos-que-trocaram-de-modalidade-durante-a-carreira-esportiva">Clique aqui e confiira.</a></p>\n<p>&nbsp;</p>\n<p>Fonte:https://www.cpb.org.br/noticia/detalhe/3064/conheca-5-historias-de-atletas-paralimpicos-que-trocaram-de-modalidade-durante-a-carreira-esportiva</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Nem sempre a primeira modalidade que um atleta experimenta é a que o levará ao topo do pódio. Algumas vezes, os atletas praticam outra modalidade por anos antes de escolher em qual seguirá carreira. Separamos cinco histórias que nos incentivam a experimentar novos esportes. Confira na lista abaixo qual era a modalidade anterior de alguns&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4231,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-4230",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4230",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4230",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4230/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4235,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4230/revisions/4235",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4231",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4230",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4230",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4230",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4225,
        date: "2020-09-26T20:53:19",
        date_gmt: "2020-09-26T23:53:19",
        guid: {
            rendered: "https://cintespbr.org/?p=4225",
        },
        modified: "2021-12-28T17:30:02",
        modified_gmt: "2021-12-28T20:30:02",
        slug: "ministro-do-mcti-marcos-pontes-visita-a-austrospace-associacao-de-empresas-e-instituicoes-dedicadas-a-tecnologia-espacial",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ministro-do-mcti-marcos-pontes-visita-a-austrospace-associacao-de-empresas-e-instituicoes-dedicadas-a-tecnologia-espacial/",
        title: {
            rendered:
                "Ministro do MCTI Marcos Pontes visita a AUSTROSPACE, associação de empresas e instituições dedicadas à tecnologia espacial",
        },
        content: {
            rendered:
                '<p>“É muito difícil para um país fazer atividades espaciais sozinho, por isso a cooperação é tão importante”, afirma Hans Steiner, presidente da AUSTROSPACE, associação de empresas austríacas do setor espacial.<br />\nEm mais um compromisso em Viena, tive a oportunidade de fortalecer os laços de cooperação entre empresas brasileiras e austríacas, criando a possibilidade de novos negócios e tecnologia para os países.</p>\n<p>Confira o vídeo.</p>\n<div id="fb-root"></div>\n<p><script async="1" defer="1" crossorigin="anonymous" src="https://connect.facebook.net/pt_BR/sdk.js#xfbml=1&amp;version=v8.0" nonce="EpZCKMZP"></script></p>\n<div class="fb-video" data-href="https://www.facebook.com/astronauta.marcospontes/videos/247897893266293" data-width="1200">\n<blockquote cite="https://www.facebook.com/astronauta.marcospontes/videos/247897893266293/" class="fb-xfbml-parse-ignore"><p><a href="https://www.facebook.com/astronauta.marcospontes/videos/247897893266293/">Visita à AUSTROSPACE, associação de empresas e instituições dedicadas à tecnologia espacial</a></p>\n<p>“É muito difícil para um país fazer atividades espaciais sozinho, por isso a cooperação é tão importante”, afirma Hans Steiner, diretor-executivo da AUSTROSPACE, associação de empresas austríacas do setor espacial. Em mais um compromisso em Viena, tive a oportunidade de fortalecer os laços de cooperação entre empresas brasileiras e austríacas, criando a possibilidade de novos negócios e tecnologia para ambos os países. Confira o vídeo.Abraços espaciais!#NinguémFicaPraTrás #TecnologiaéMCTI #MCTI #Ministério #Ciência #Tecnologia #Inovações Jair Messias Bolsonaro Governo do Brasil Ministério da Ciência, Tecnologia e Inovações Agência Espacial Brasileira &#8211; AEB Planalto Embaixada do Brasil em Viena / Brasilianische Botschaft in Wien SecomVc #IV</p>\n<p>Publicado por <a href="https://www.facebook.com/astronauta.marcospontes/">Astronauta Marcos Pontes</a> em Sexta-feira, 25 de setembro de 2020</p></blockquote>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>“É muito difícil para um país fazer atividades espaciais sozinho, por isso a cooperação é tão importante”, afirma Hans Steiner, presidente da AUSTROSPACE, associação de empresas austríacas do setor espacial. Em mais um compromisso em Viena, tive a oportunidade de fortalecer os laços de cooperação entre empresas brasileiras e austríacas, criando a possibilidade de novos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4226,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43],
        tags: [],
        class_list: [
            "post-4225",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-43",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4225",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4225",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4225/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4228,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4225/revisions/4228",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4226",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4225",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4225",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4225",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4219,
        date: "2020-09-26T20:36:44",
        date_gmt: "2020-09-26T23:36:44",
        guid: {
            rendered: "https://cintespbr.org/?p=4219",
        },
        modified: "2021-12-28T17:30:13",
        modified_gmt: "2021-12-28T20:30:13",
        slug: "ciencia-e-tudo-tecnologias-sociais",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ciencia-e-tudo-tecnologias-sociais/",
        title: {
            rendered: "CIÊNCIA É TUDO &#8211; Tecnologias Sociais",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://www.youtube.com/watch?v=JhF8WNyQJos&amp;feature=youtu.be&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://www.youtube.com/watch?v=JhF8WNyQJos&amp;feature=youtu.be&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3606,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43],
        tags: [],
        class_list: [
            "post-4219",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-43",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4219",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4219",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4219/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4220,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4219/revisions/4220",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3606",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4219",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4219",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4219",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4195,
        date: "2020-09-23T22:50:30",
        date_gmt: "2020-09-24T01:50:30",
        guid: {
            rendered: "https://cintespbr.org/?p=4195",
        },
        modified: "2021-12-27T23:02:51",
        modified_gmt: "2021-12-28T02:02:51",
        slug: "22-de-setembro-dia-nacional-do-atleta-paralimpico",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/22-de-setembro-dia-nacional-do-atleta-paralimpico/",
        title: {
            rendered:
                "22 de Setembro &#8211; Dia Nacional do Atleta Paralímpico",
        },
        content: {
            rendered:
                '<div style="width: 854px;" class="wp-video"><!--[if lt IE 9]><script>document.createElement(\'video\');</script><![endif]-->\n<video class="wp-video-shortcode" id="video-4195-1" width="854" height="480" preload="metadata" controls="controls"><source type="video/mp4" src="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Video-2020-09-22-at-19.46.28.mp4?_=1" /><a href="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Video-2020-09-22-at-19.46.28.mp4">https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Video-2020-09-22-at-19.46.28.mp4</a></video></div>\n<p>&nbsp;</p>\n<p style="text-align: justify;">O <strong>Dia Nacional do Atleta Paralímpico</strong> é comemorado em <strong>22 de setembro</strong>.</p>\n<p style="text-align: justify;">Esta data visa homenagear, apoiar e divulgar todo o trabalho dos atletas paralímpicos, além de agir como uma ferramenta de inclusão das pessoas com deficiência.</p>\n<p style="text-align: justify;">O objetivo também é pôr em evidência todas as necessidades, reivindicações e lutas enfrentadas pelos esportistas brasileiros com deficiência.</p>\n<p style="text-align: justify;">Os atletas paralímpicos são aqueles que apresentam algum tipo de deficiência e que participam dos Jogos Paralímpicos, uma versão dos Jogos Olímpicos com modalidades adaptadas para esportistas com necessidades especiais.</p>\n<p style="text-align: justify;">Oficialmente, o Dia Nacional do Atleta Paralímpico foi instituído a partir do <strong>decreto de lei nº 12.622, de 8 de maio de 2012</strong>. Esta data é celebrada em sequência ao <strong>Dia Nacional de Luta das Pessoas com Deficiência</strong>, em 21 de setembro.</p>\n<p style="text-align: justify;">A escolha desta data é uma homenagem à criação do Comitê Paralímpico Internacional (CPI), que foi fundado em 22 de setembro de 1989.</p>\n<p><em>Texto extraído do site: calendarr.com/brasil/dia-nacional-do-atleta-paralimpico/</em></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>&nbsp; O Dia Nacional do Atleta Paralímpico é comemorado em 22 de setembro. Esta data visa homenagear, apoiar e divulgar todo o trabalho dos atletas paralímpicos, além de agir como uma ferramenta de inclusão das pessoas com deficiência. O objetivo também é pôr em evidência todas as necessidades, reivindicações e lutas enfrentadas pelos esportistas brasileiros com deficiência. Os&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4198,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-4195",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4195",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4195",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4195/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4199,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4195/revisions/4199",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4198",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4195",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4195",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4195",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4170,
        date: "2020-09-20T23:59:33",
        date_gmt: "2020-09-21T02:59:33",
        guid: {
            rendered: "https://cintespbr.org/?p=4170",
        },
        modified: "2021-12-27T22:49:46",
        modified_gmt: "2021-12-28T01:49:46",
        slug: "mosaico-do-brasil-com-imagens-cbers-4-financiado-pelo-bndes-e-disponibilizado-pelo-inpe",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/mosaico-do-brasil-com-imagens-cbers-4-financiado-pelo-bndes-e-disponibilizado-pelo-inpe/",
        title: {
            rendered:
                "Mosaico do Brasil com imagens CBERS-4 financiado pelo BNDES é disponibilizado pelo INPE",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="wp-image-4171 alignleft" src="https://cintespbr.org/wp-content/uploads/2020/09/mosaico_degradado_comlogo-300x300.jpg" alt="" width="541" height="536" />O projeto Brazil Data Cube do INPE MCTI disponibilizou o primeiro mosaico do Brasil gerado a partir de imagens CBERS-4 WFI, reflectância de superfície, com 64 metros de resolução espacial. Ele foi gerado utilizando o melhor pixel (livre de nuvem e sombras de nuvem) escolhido num período de três meses (Abril, Maio e Junho de 2020) para cada local, com as bandas vermelho, infravermelho próximo e azul. O objetivo do projeto como um todo é criar cubos de dados multidimensionais prontos para análise a partir de imagens de média resolução espacial de satélites de observação da Terra. Os dados abrangem todo o território brasileiro e geram informações de uso e cobertura do solo usando aprendizado de máquina e análise de séries temporais de imagens de satélites.</p>\n<p>Veja o mosaico em:<br />\n<a href="http://brazildatacube.dpi.inpe.br/portal/explore?layer=cbers_full_resolution_tiles" target="_blank" rel="noopener noreferrer">http://brazildatacube.dpi.inpe.br/portal/explore?layer=cbers_full_resolution_tiles</a></p>\n<p>O <a href="http://brazildatacube.org/pt/pagina-inicial-2/" target="_blank" rel="noopener noreferrer">Brazil Data Cube</a> é desenvolvido desde Janeiro de 2019 pelo INPE MCTIC, por Karine Ferreira, Gilberto Queiroz e Lúbia Vinhas. É um subprojeto do Projeto Monitoramento Ambiental dos Biomas Brasileiros, financiado com recursos do Fundo Amazônia, por meio da colaboração financeira BNDES e FUNCATE nº 17.2.0536.1; sucessor do projeto de pesquisa e-Sensing financiado pela FAPESP (2014/08398-6).</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>Além do mosaico com resolução espacial de 64 metros, disponibilizamos também versões com 128 e 250 metros de resolução. Todos podem ser baixados no formato GeoTIFF a partir dos seguintes links:</p>\n<ul>\n<li>Mosaico 64m (resolução original) – 6.1 GB:<br />\n<a href="http://brazildatacube.dpi.inpe.br/Repository/Product/Mosaics/BDC_mosaicBR_CBERS2020.tif" target="_blank" rel="noopener noreferrer">http://brazildatacube.dpi.inpe.br/Repository/Product/Mosaics/BDC_mosaicBR_CBERS2020.tif</a></li>\n<li>Mosaico 128m – 1.9 GB:<br />\n<a href="http://brazildatacube.dpi.inpe.br/Repository/Product/Mosaics/BDC_mosaicBR_CBERS2020_128m.tif" target="_blank" rel="noopener noreferrer">http://brazildatacube.dpi.inpe.br/Repository/Product/Mosaics/BDC_mosaicBR_CBERS2020_128m.tif</a></li>\n<li>Mosaico 250m – 511 MB:<br />\n<a href="http://brazildatacube.dpi.inpe.br/Repository/Product/Mosaics/BDC_mosaicBR_CBERS2020_250m.tif" target="_blank" rel="noopener noreferrer">http://brazildatacube.dpi.inpe.br/Repository/Product/Mosaics/BDC_mosaicBR_CBERS2020_250m.tif</a></li>\n</ul>\n<p>Sistemas de Informações Geográficas podem acessá-los diretamente através do serviço OGC WMS em:<br />\n<a href="http://brazildatacube.dpi.inpe.br/bdc/geoserver/bdc_brmosaic/wms" target="_blank" rel="noopener noreferrer">http://brazildatacube.dpi.inpe.br/bdc/geoserver/bdc_brmosaic/wms</a></p>\n<p>Fonte:http://www.inpe.br/noticias/noticia.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O projeto Brazil Data Cube do INPE MCTI disponibilizou o primeiro mosaico do Brasil gerado a partir de imagens CBERS-4 WFI, reflectância de superfície, com 64 metros de resolução espacial. Ele foi gerado utilizando o melhor pixel (livre de nuvem e sombras de nuvem) escolhido num período de três meses (Abril, Maio e Junho de&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4171,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [],
        class_list: [
            "post-4170",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4170",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4170",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4170/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4172,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4170/revisions/4172",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4171",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4170",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4170",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4170",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4168,
        date: "2020-09-20T23:54:17",
        date_gmt: "2020-09-21T02:54:17",
        guid: {
            rendered: "https://cintespbr.org/?p=4168",
        },
        modified: "2021-12-28T17:30:25",
        modified_gmt: "2021-12-28T20:30:25",
        slug: "ciencia-e-tudo-o-papel-da-ciencia-e-da-engenharia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ciencia-e-tudo-o-papel-da-ciencia-e-da-engenharia/",
        title: {
            rendered: "CIÊNCIA É TUDO: O papel da ciência e da engenharia",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://youtu.be/nG2rosK_rmk&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://youtu.be/nG2rosK_rmk&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3606,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43],
        tags: [],
        class_list: [
            "post-4168",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-43",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4168",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4168",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4168/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4169,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4168/revisions/4169",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3606",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4168",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4168",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4168",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4100,
        date: "2020-09-20T18:27:06",
        date_gmt: "2020-09-20T21:27:06",
        guid: {
            rendered: "https://cintespbr.org/?p=4100",
        },
        modified: "2021-12-27T23:07:07",
        modified_gmt: "2021-12-28T02:07:07",
        slug: "cpb-e-emuseu-do-esporte-lancam-galeria-3d-rumo-a-toquio-para-eternizar-conquistas-do-esporte-paralimpico",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cpb-e-emuseu-do-esporte-lancam-galeria-3d-rumo-a-toquio-para-eternizar-conquistas-do-esporte-paralimpico/",
        title: {
            rendered:
                "CPB e eMuseu do Esporte lançam galeria 3D &#8220;Rumo a Tóquio&#8221; para eternizar conquistas do esporte paralímpico",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="alignnone wp-image-4101" src="https://cintespbr.org/wp-content/uploads/2020/09/5a16e3d08cf646a0879a0576c30c5c6f-300x169.jpeg" alt="" width="779" height="439" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/5a16e3d08cf646a0879a0576c30c5c6f-300x169.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/5a16e3d08cf646a0879a0576c30c5c6f-768x434.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/5a16e3d08cf646a0879a0576c30c5c6f.jpeg 1011w" sizes="(max-width: 779px) 100vw, 779px" /></p>\n<div>\n<div class="detalhe-texto ">\n<div class="texto">\n<p>O Comitê Paralímpico Brasileiro (CPB), em parceria com o eMuseu do Esporte, realizará o lançamento da galeria 3D “Rumo a Tóquio” na próxima segunda-feira, 21, data que celebra o Dia Nacional de Luta da Pessoa com Deficiência. O evento virtual será transmitido <a href="https://www.facebook.com/pg/emuseu.esporte/about/?ref=page_internal" target="_blank" rel="noopener noreferrer"><u><strong>ao vivo pelo Facebook</strong></u></a> e pelo <a href="https://www.youtube.com/channel/UCEq9-Mdx3raO2XKpWnl9sIA" target="_blank" rel="noopener noreferrer"><u><strong>YouTube do eMuseu</strong></u></a>, a partir das 11h.</p>\n<p>A exposição gratuita vai contemplar competições e grandes conquistas dos atletas brasileiros desde os Jogos Paralímpicos Rio 2016. A mostra virtual estará totalmente acessível para pessoas com deficiência visual e auditiva, com audiodescrição e Libras. A curadoria do material foi realizada pela fotógrafa do CPB, Alessandra Cabral. <a href="https://www.emuseudoesporte.com.br/br/home" target="_blank" rel="noopener noreferrer"><u><strong>Acesse aqui o eMuseu</strong></u></a>.</p>\n<p>O evento contará com a participação de grandes nomes do esporte paralímpico recente. Daniel Dias, referência da natação brasileira paralímpica, com 24 medalhas em três edições dos Jogos, sendo 14 de ouro, Yohansson Nascimento, ouro nos 200m rasos em Londres 2012, além de três pratas e dois bronzes, o nadador Phelipe Rodrigues, com cinco pratas e dois bronzes em Jogos Paralímpicos, Edênia Garcia, tetracampeã mundial nos 50m costas e com duas pratas e um bronze nos Jogos, e Rayane Soares, campeã e vice-campeã mundial de atletismo, estarão entre os presentes.</p>\n<p>O evento terá, ainda, duas apresentações artísticas: dança sobre cadeiras de roda, de uma academia filiada à Confederação Brasileira de Dança em Cadeira de Rodas, e uma apresentação do músico Johnatha Bastos, guitarrista que toca com os pés e que fez uma apresentação na cerimônia de encerramento dos Jogos Rio 2016.</p>\n<p>“A sensação de ver meu nome retratado na galeria do Comitê Paralímpico Brasileiro é incrível. Tenho uma carreira que vem sendo construída há anos, e é muito gratificante receber esse reconhecimento e poder ajudar o movimento”, comemora Daniel Dias. “O esporte me mostrou do que somos capazes, me mostrou que não devo colocar limites na minha vida. Não importa se tenho braços ou não, isso não me define. O que me define é o que tenho dentro de mim. E o que tenho dentro de mim é uma força muito grande”, completa.</p>\n<p>Criado para eternizar a memória do esporte e seus atletas, o eMuseu proporciona uma experiência inovadora ao oferecer, de forma gratuita, um passeio imersivo em plataforma 3D. Na galeria do Comitê Paralímpico Brasileiro, os visitantes terão à disposição conteúdos inteiramente acessíveis, tanto em libras quanto em audiodescrição. Para que a história dos ídolos paralímpicos seja conhecida também no exterior, o acervo estará disponível em inglês.</p>\n<p>Com patrocínio da Enel Distribuição Rio, em conjunto com a Secretaria de Esporte, Lazer e Juventude do Rio – por meio da Lei de Incentivo do Esporte, do Governo Estadual –, o eMuseu do Esporte é uma realização da startup Gama Assessoria, em parceria com a Universidade Estadual do Rio de Janeiro (UERJ), através da Incubadora Tecnológica de Empreendimentos Sociais e Cooperativas Sociais (ITECS).</p>\n<p><strong>Programa Loterias Caixa Atletas de Alto Nível</strong></p>\n<p>Os atletas Phelipe Rodrigues, Rayane Soares e Yohansson Nascimento são integrantes do Programa Loterias Caixa Atletas de Alto Nível, programa de patrocínio individual da Loterias Caixa que beneficia 70 atletas e sete atletas-guia</p>\n<p><strong>Assessoria de Comunicação do Comitê Paralímpico Brasileiro (imp@cpb.org.br)</strong></p>\n</div>\n</div>\n<div>Fonte: https://www.cpb.org.br/noticia/</div>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O Comitê Paralímpico Brasileiro (CPB), em parceria com o eMuseu do Esporte, realizará o lançamento da galeria 3D “Rumo a Tóquio” na próxima segunda-feira, 21, data que celebra o Dia Nacional de Luta da Pessoa com Deficiência. O evento virtual será transmitido ao vivo pelo Facebook e pelo YouTube do eMuseu, a partir das 11h. A exposição gratuita&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4101,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-4100",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4100",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4100",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4100/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4156,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4100/revisions/4156",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4101",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4100",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4100",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4100",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4094,
        date: "2020-09-20T18:16:06",
        date_gmt: "2020-09-20T21:16:06",
        guid: {
            rendered: "https://cintespbr.org/?p=4094",
        },
        modified: "2021-12-27T23:07:07",
        modified_gmt: "2021-12-28T02:07:07",
        slug: "influenciadores-digitais-serao-uma-das-atracoes-de-evento-online-do-dia-do-atleta-paralimpico",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/influenciadores-digitais-serao-uma-das-atracoes-de-evento-online-do-dia-do-atleta-paralimpico/",
        title: {
            rendered:
                "Influenciadores digitais serão uma das atrações de evento online do Dia do Atleta Paralímpico",
        },
        content: {
            rendered:
                '<p><img loading="lazy" decoding="async" class="alignnone wp-image-4095" src="https://cintespbr.org/wp-content/uploads/2020/09/17796bb7c0114cd7911531b9cb24890e-300x169.png" alt="" width="789" height="444" /></p>\n<div>\n<div class="detalhe-texto ">\n<div class="texto">\n<p style="text-align: left;">A comemoração do Dia do Atleta Paralímpico deste ano será um pouco diferente. Para celebrar a data, <a href="https://www.cpb.org.br/noticia/detalhe/3053/cpb-realiza-evento-online-em-comemoracao-ao-dia-nacional-do-atleta-paralimpico" target="_blank" rel="noopener noreferrer"><strong>o Comitê Paralímpico Brasileiro (CPB) realizará um evento totalmente online na próxima terça-feira, 22.</strong></a> Além da participação de atletas, o evento também contará com a presença de influenciadores digitais.</p>\n<p style="text-align: left;">A ação será aberta ao público e contará com duas transmissões de debates ao vivo, às 15h e às 18h, na <a href="https://www.facebook.com/ComiteParalimpico" target="_blank" rel="noopener noreferrer"><strong>página oficial do CPB no Facebook</strong></a> e no <a href="https://www.youtube.com/user/cpboficial" target="_blank" rel="noopener noreferrer"><strong>canal do Youtube</strong></a>. Os temas em debate serão: “Esporte como ferramenta de transformação” e “Superação é uma ova!”</p>\n<p style="text-align: left;">A influenciadora Isa Meirelles marcará presença em uma das conversas do dia. Isadora perdeu a visão do olho esquerdo devido ao glaucoma congênito. Mas foi apenas depois que concluiu o curso de graduação em Relações Públicas que começou a se envolver com a causa das pessoas com deficiência. Atualmente, fala com seus mais de 22 mil seguidores no Instagram sobre diversidade, acessibilidade e moda inclusiva.</p>\n<p style="text-align: left;">Outro convidado influente do evento é o youtuber Bruno Carneiro Nunes, o Fred do canal Desimpedidos. Formado em jornalismo, o paulistano sempre sonhou em ser jogador de futebol. Em 2015, foi selecionado para ser um dos apresentadores do canal Desimpedidos que mistura esporte e humor e tem mais 8,5 milhões de inscritos.</p>\n<p style="text-align: left;">Além desses influenciadores, <a href="https://www.cpb.org.br/noticia/detalhe/3055/atletas-ressaltam-a-importancia-de-debate-online-no-dia-do-atleta-paralimpico" target="_blank" rel="noopener noreferrer"><strong>seis atletas paralímpicos participarão dos bate-papos:</strong></a> a parataekwondista Débora Menezes, os velocistas Fabrício Ferreira, Verônica Hipólito e Yohansson Nascimento e os nadadores Roberto Alcalde e Susana Schnarndorf.</p>\n<p style="text-align: left;">Também participarão do evento online o jornalista esportivo Renato Peters, que acompanha o Movimento Paralímpico, e o apresentador e ex-judoca Flávio Canto.</p>\n<p style="text-align: left;">O Dia Nacional do Atleta Paralímpico (22 de setembro) foi instituído via decreto de lei nº 12.622, de 8 de maio de 2012, e comemorado a partir de 2014. A data também dá sequência às comemorações ao Dia Nacional de Luta da Pessoa com Deficiência (21 de setembro), que existe desde 2005 com o objetivo de conscientizar sobre a importância do desenvolvimento de meios de inclusão das pessoas com deficiência na sociedade.</p>\n<p style="text-align: left;"><strong>Programa Loterias Caixa Atletas de Alto Nível </strong><br />\nOs atletas Débora Menezes, Fabrício Ferreira, Roberto Alcalde, Susana Schnarndorf e Yohansson Nascimento são integrantes do Programa Loterias Caixa Atletas de Alto Nível, programa de patrocínio individual da Loterias Caixa que beneficia 70 atletas e sete atletas-guia.</p>\n<p style="text-align: left;"><strong>Time São Paulo </strong><br />\nOs atletas Verônica Hipólito e Yohansson Nascimento são integrantes do Time São Paulo, parceria entre o CPB e a Secretaria de Estado dos Direitos da Pessoa com Deficiência de São Paulo que beneficia 61 atletas e dois atletas-guia de 11 modalidades.</p>\n<p style="text-align: left;"><strong>Assessoria de Comunicação do Comitê Paralímpico Brasileiro (imp@cpb.org.br)</strong></p>\n<p>Fonte: https://www.cpb.org.br/noticia/</p>\n</div>\n</div>\n</div>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>A comemoração do Dia do Atleta Paralímpico deste ano será um pouco diferente. Para celebrar a data, o Comitê Paralímpico Brasileiro (CPB) realizará um evento totalmente online na próxima terça-feira, 22. Além da participação de atletas, o evento também contará com a presença de influenciadores digitais. A ação será aberta ao público e contará com duas transmissões&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4096,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-4094",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4094",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4094",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4094/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4099,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4094/revisions/4099",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4096",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4094",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4094",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4094",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4090,
        date: "2020-09-20T18:06:20",
        date_gmt: "2020-09-20T21:06:20",
        guid: {
            rendered: "https://cintespbr.org/?p=4090",
        },
        modified: "2020-09-20T18:06:20",
        modified_gmt: "2020-09-20T21:06:20",
        slug: "reitor-da-ufu-e-eleito-presidente-de-forum-de-reitores-de-minas-gerais",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/reitor-da-ufu-e-eleito-presidente-de-forum-de-reitores-de-minas-gerais/",
        title: {
            rendered:
                "Reitor da UFU é eleito presidente de fórum de reitores de Minas Gerais",
        },
        content: {
            rendered:
                '<h2>Foripes reúne 19 instituições públicas de ensino superior</h2>\n<p>Fonte: http://www.comunica.ufu.br/noticia/2018/12/reitor-da-ufu-e-eleito-presidente-de-forum-de-reitores-de-minas-gerais</p>\n<p><img loading="lazy" decoding="async" class=" wp-image-4091 aligncenter" src="https://cintespbr.org/wp-content/uploads/2020/09/imagem_destaque_whatsapp_image_2018-12-03_at_18.13.06-300x225.jpeg" alt="" width="768" height="574" /></p>\n<p>&nbsp;</p>\n<p style="font-weight: 400;">O reitor da Universidade Federal de Uberlândia (UFU), Valder Steffen Júnior, foi eleito presidente do Fórum de Dirigentes das Instituições Públicas de Ensino Superior de Minas Gerais (Foripes/MG).</p>\n<p style="font-weight: 400;">A eleição ocorreu no Campus Santa Mônica da UFU, na tarde desta segunda-feira (3/12), durante reunião de representantes de entidades que integram o fórum. O mandato é de um ano.</p>\n<p style="font-weight: 400;">O primeiro vice-presidente será José Ricardo Martins da Silva, reitor do Instituto Federal do Norte de Minas Gerais (IFNMG) e o segundo vice-presidente, Sandro Amadeu Cerveiras, reitor da Universidade Federal de Alfenas (Unifal).</p>\n<p style="font-weight: 400;">Além da eleição de uma nova diretoria, os gestores trataram da renovação do regimento, de projetos e de emendas orçamentárias feitas por parlamentares.</p>\n<p style="font-weight: 400;">O grupo tem atuado junto à Secretaria de Desenvolvimento Econômico, Ciência, Tecnologia e Ensino Superior de Minas Gerais (Sedectes), à Fundação de Amparo à Pesquisa do Estado de Minas Gerais (Fapemig) e ao Congresso Nacional.</p>\n<p style="font-weight: 400;">Entre os principais temas de discussão estão as emendas de bancadas, feitas ao Orçamento Geral da União, visando a liberação de mais recursos para o desenvolvimento do ensino, da pesquisa e da extensão no estado.</p>\n<p><img loading="lazy" decoding="async" class=" wp-image-4092 aligncenter" src="https://cintespbr.org/wp-content/uploads/2020/09/imagem_chamada_dsc_6653-300x199.jpg" alt="" width="513" height="341" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/imagem_chamada_dsc_6653-300x199.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/imagem_chamada_dsc_6653.jpg 476w" sizes="(max-width: 513px) 100vw, 513px" /></p>\n<p style="font-weight: 400;">O Foripes/MG reúne representantes das 11 universidades federais e das duas estaduais, dos cinco institutos federais e do Centro Federal de Educação Tecnológica (Cefet). O reitor da UFU destacou a importância dessas instituições estarem juntas na defesa de seus projetos específicos.</p>\n<p style="font-weight: 400;">“Temos conseguido uma boa presença desse grupo no parlamento em momentos de definição do orçamento, trabalhando com a Comissão de Educação, Comissão de Ciência e Tecnologia. Tudo isso ajuda as nossas instituições mineiras”, explica Steffen Júnior.</p>\n<p style="font-weight: 400;">O fórum foi aberto pelo quarteto de flauta transversal Fluctus, formado por alunos e ex-alunos do curso de Música da UFU e coordenado pela docente Geisa Felipe. Eles apresentaram composições de Pixinguinha com Benedito Lacerda e com Vinícius de Moraes e do francês Eugene Bozza.</p>\n<p style="font-weight: 400;">Na recepção aos dirigentes, além do reitor estavam presentes o vice-reitor, Orlando Mantese, todos os seis pró-reitores das UFU, o prefeito universitário, o chefe de gabinete e assessores da Reitoria.</p>\n<p style="font-weight: 400;">\n<p style="font-weight: 400;"><b><strong>Valder Steffen Júnior</strong></b></p>\n<p style="font-weight: 400;">O reitor da UFU é natural de Rio Claro (SP). Concluiu Engenharia Mecânica na Unicamp em 1976, concluiu seu doutorado pela Université de Franche-Comté (Besançon/França) no final de 1979; defendeu sua tese de Habilitation à Diriger des Recherches em 1991 também em Besançon, França. Realizou dois estágios em nível de pós-doutoramento, o primeiro no INSA de Lyon, na França, 1986-87 e, o outro, na Virginia Tech, EUA, 1999-2000, como Fulbright Scholar. É Editor Senior do Journal of Vibration and Control e Editor-Chefe Associado de Mechanics and Industry. Recebeu em 15 de agosto de 2002 a Comenda da Ordem Nacional do Mérito Científico, concedida pelo Governo Federal. É Membro da Academia Nacional de Engenharia e Membro da Academia Brasileira de Ciências. É Professor Titular da Faculdade de Engenharia Mecânica e Pesquisador Nível 1-A do CNPq.</p>\n<p style="font-weight: 400;">\n<p style="font-weight: 400;"><b><strong>Instituições que integram o Foripes/MG</strong></b>:</p>\n<p style="font-weight: 400;">Centro Federal de Educação Tecnológica &#8211; Cefet/MG</p>\n<p style="font-weight: 400;">Instituto Federal de Minas Gerais &#8211; IFMG</p>\n<p style="font-weight: 400;">Instituto Federal do Norte de Minas Gerais &#8211; IFNMG</p>\n<p style="font-weight: 400;">Instituto Federal do Sudeste de Minas &#8211; IFSEMG</p>\n<p style="font-weight: 400;">Instituto Federal do Sul de Minas &#8211; IF Sul de Minas</p>\n<p style="font-weight: 400;">Instituto Federal do Triângulo Mineiro &#8211; IFTM</p>\n<p style="font-weight: 400;">Universidade do Estado de Minas Gerais &#8211; Uemg</p>\n<p style="font-weight: 400;">Universidade Estadual de Montes Claros &#8211; Unimontes</p>\n<p style="font-weight: 400;">Universidade Federal de Alfenas &#8211; Unifal</p>\n<p style="font-weight: 400;">Universidade Federal de Itajubá &#8211; Unifei</p>\n<p style="font-weight: 400;">Universidade Federal de Juiz de Fora &#8211; UFJF</p>\n<p style="font-weight: 400;">Universidade Federal de Lavras &#8211; Ufla</p>\n<p style="font-weight: 400;">Universidade Federal de Minas Gerais &#8211; UFMG</p>\n<p style="font-weight: 400;">Universidade Federal de Ouro Preto &#8211; Ufop</p>\n<p style="font-weight: 400;">Universidade Federal de São João del-Rei &#8211; UFSJ</p>\n<p style="font-weight: 400;">Universidade Federal de Uberlândia &#8211; UFU</p>\n<p style="font-weight: 400;">Universidade Federal de Viçosa &#8211; UFV</p>\n<p style="font-weight: 400;">Universidade Federal do Triângulo Mineiro &#8211; UFTM</p>\n<p style="font-weight: 400;">Universidade Federal dos Vales do Jequitinhonha e Mucuri &#8211; UFVJM</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Foripes reúne 19 instituições públicas de ensino superior Fonte: http://www.comunica.ufu.br/noticia/2018/12/reitor-da-ufu-e-eleito-presidente-de-forum-de-reitores-de-minas-gerais &nbsp; O reitor da Universidade Federal de Uberlândia (UFU), Valder Steffen Júnior, foi eleito presidente do Fórum de Dirigentes das Instituições Públicas de Ensino Superior de Minas Gerais (Foripes/MG). A eleição ocorreu no Campus Santa Mônica da UFU, na tarde desta segunda-feira (3/12), durante reunião&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 4091,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [],
        class_list: [
            "post-4090",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4090",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4090",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4090/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4093,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4090/revisions/4093",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/4091",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4090",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4090",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4090",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3909,
        date: "2020-09-06T10:38:43",
        date_gmt: "2020-09-06T13:38:43",
        guid: {
            rendered: "https://cintespbr.org/?p=3909",
        },
        modified: "2021-12-28T17:30:42",
        modified_gmt: "2021-12-28T20:30:42",
        slug: "profissao-biologia-ciencia-e-tudo",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/profissao-biologia-ciencia-e-tudo/",
        title: {
            rendered: "CIÊNCIA É TUDO &#8211; Profissão: biologia",
        },
        content: {
            rendered:
                '\n<p>0:53 / 27:05</p>\n\n\n\n<figure class="wp-block-embed-youtube wp-block-embed is-type-video is-provider-youtube wp-embed-aspect-16-9 wp-has-aspect-ratio"><div class="wp-block-embed__wrapper">\n<iframe loading="lazy" title="Profissão: biologia | Ciência é Tudo" width="1200" height="675" src="https://www.youtube.com/embed/VKFCnn2Vy4M?feature=oembed" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>\n</div></figure>\n',
            protected: false,
        },
        excerpt: {
            rendered: "<p>0:53 / 27:05</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3606,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43],
        tags: [48],
        class_list: [
            "post-3909",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "tag-ciencia-mcti-biologia-aprender-estudar",
            "category-43",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3909",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3909",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3909/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4064,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3909/revisions/4064",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3606",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3909",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3909",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3909",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3826,
        date: "2020-08-28T20:58:20",
        date_gmt: "2020-08-28T23:58:20",
        guid: {
            rendered: "https://cintespbr.org/?p=3826",
        },
        modified: "2020-09-20T11:31:31",
        modified_gmt: "2020-09-20T14:31:31",
        slug: "pesquisador-do-cintesp-br-participa-de-palestra-online",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/pesquisador-do-cintesp-br-participa-de-palestra-online/",
        title: {
            rendered: "Pesquisador do CINTESP.Br participa de Palestra OnLine",
        },
        content: {
            rendered:
                '\n<p>O Palestrante José Eduardo Arruda Neto é pesquisador do CINTESP.Br e fará uma palestra sobre ESPORTES PARALÍMPICOS DE ALTO RENDIMENTO, no dia 01/09 das 20h05min às 21h</p>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/08/f2cb236f-d61b-4888-b849-594346e71e12-576x1024.jpg" alt="" class="wp-image-3827" width="717" height="1274" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/08/f2cb236f-d61b-4888-b849-594346e71e12-576x1024.jpg 576w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/f2cb236f-d61b-4888-b849-594346e71e12-169x300.jpg 169w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/f2cb236f-d61b-4888-b849-594346e71e12.jpg 720w" sizes="(max-width: 717px) 100vw, 717px" /></figure></div>\n\n\n\n<p>Participe acessando o Link  <a href="http://meet.google.com/eni-xcbs-gmm">meet.google.com/eni-xcbs-gmm</a> </p>\n\n\n\n<p>Informações &#8211;<a href="https://unitri.edu.br/eventos/"> https://unitri.edu.br/eventos/</a></p>\n\n\n\n<p></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O Palestrante José Eduardo Arruda Neto é pesquisador do CINTESP.Br e fará uma palestra sobre ESPORTES PARALÍMPICOS DE ALTO RENDIMENTO, no dia 01/09 das 20h05min às 21h Participe acessando o Link meet.google.com/eni-xcbs-gmm Informações &#8211; https://unitri.edu.br/eventos/</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3829,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [],
        class_list: [
            "post-3826",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3826",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3826",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3826/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3831,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3826/revisions/3831",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3829",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3826",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3826",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3826",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3922,
        date: "2020-08-18T21:12:00",
        date_gmt: "2020-08-19T00:12:00",
        guid: {
            rendered: "https://cintespbr.org/?p=3922",
        },
        modified: "2020-09-20T17:52:36",
        modified_gmt: "2020-09-20T20:52:36",
        slug: "bate-papo-ciencia-tecnologia-no-dia-a-dia-2",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/bate-papo-ciencia-tecnologia-no-dia-a-dia-2/",
        title: {
            rendered: "Bate Papo Ciência &#038; Tecnologia no Dia a Dia",
        },
        content: {
            rendered:
                '\r\n<h2 class="wp-block-heading">Bate Papo Ciência &amp; Tecnologia no Dia a Dia</h2>\r\n\r\n\r\n\r\n<figure class="wp-block-image size-large"><img loading="lazy" decoding="async" width="1024" height="542" class="wp-image-3940" src="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-1-1-1024x542.jpeg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-1-1-1024x542.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-1-1-300x159.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-1-1-768x407.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-1-1.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" />\r\n<figcaption>Diretor Geral do CINTESP.Br &#8211; Cleudmar Amaral Araújo | <strong>Diretora de Relações Públicas em Tecnologias Assistiva do CINTESP.Br &#8211; Daniela Moura Yoshida</strong> | Chefe da Assessoria Especial de Assuntos Institucionais do MCTI &#8211; Christiane Gonçalves Corrêa | Ministro do MCTI &#8211; Astronauta Marcos Pontes</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<p>Nesta terça-feira, 18/08, às 19h30h o <strong>Diretor Geral Cleudmar Amaral Araújo</strong> e a <strong>Diretora de Relações Públicas em Tecnologias Assistiva Daniela Moura Yoshida</strong>, do <strong>Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br)</strong>, compareceram em Brasília no <strong>Ministério da Ciências, Tecnologia e Inovação &#8211; MCTI</strong> convidados para participar do Bate Papo Ciência e Tecnologia no Dia a Dia com o tema “Tecnologia Assistiva (tecnologias para pessoas com deficiência física) e Doenças Raras” juntamente com o ministro do MCTI, Marcos Pontes, o Secretário Paulo César Rezende De Carvalho Alvim da Secretaria de Empreendedorismo e Inovação SEMPI/MCTI e o Brigadeiro Maurício Ribeiro Gonçalves &#8211; Secretário do SETAP/MCTIC.<br />Nesta ocasião, representando o CINTESP.Br a Diretora de Relações Públicas em Tecnologias Assistiva Daniela Moura Yoshida, entregou ao Ministro do MCTI, Astronauta Marcos Pontes e à Chefe da Assessoria Especial de Assuntos Institucionais Christiane Gonçalves Corrêa, uma placa de agradecimento pelo apoio ao CINTESP.Br para o desenvolvimento de inovações tecnológicas assistivas na área do Esporte, Saúde, Lazer, Vida Diária e Doenças Raras, na promoção da qualidade de vida das pessoas com deficiência.</p>\r\n\r\n\r\n\r\n<figure class="wp-block-gallery columns-3 is-cropped wp-block-gallery-1 is-layout-flex wp-block-gallery-is-layout-flex">\r\n<ul class="blocks-gallery-grid">\r\n<li class="blocks-gallery-item">\r\n<figure><img loading="lazy" decoding="async" width="1024" height="692" class="wp-image-3936" src="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.38-1-1024x692.jpeg" alt="" data-id="3936" data-full-url="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.38-1.jpeg" data-link="https://cintespbr.org/?attachment_id=3936" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.38-1-1024x692.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.38-1-300x203.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.38-1-768x519.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.38-1.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure>\r\n</li>\r\n<li class="blocks-gallery-item">\r\n<figure><img loading="lazy" decoding="async" width="1024" height="602" class="wp-image-3925" src="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.39-1024x602.jpeg" alt="" data-id="3925" data-full-url="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.39.jpeg" data-link="https://cintespbr.org/?attachment_id=3925" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.39-1024x602.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.39-300x176.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.39-768x451.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.39.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure>\r\n</li>\r\n<li class="blocks-gallery-item">\r\n<figure><img loading="lazy" decoding="async" width="1024" height="542" class="wp-image-3927" src="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.41-1024x542.jpeg" alt="" data-id="3927" data-full-url="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.41.jpeg" data-link="https://cintespbr.org/?attachment_id=3927" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.41-1024x542.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.41-300x159.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.41-768x407.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.41.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure>\r\n</li>\r\n<li class="blocks-gallery-item">\r\n<figure><img loading="lazy" decoding="async" width="747" height="1024" class="wp-image-3928" src="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.42-747x1024.jpeg" alt="" data-id="3928" data-full-url="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.42.jpeg" data-link="https://cintespbr.org/?attachment_id=3928" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.42-747x1024.jpeg 747w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.42-219x300.jpeg 219w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.42-768x1053.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.42.jpeg 912w" sizes="(max-width: 747px) 100vw, 747px" /></figure>\r\n</li>\r\n<li class="blocks-gallery-item">\r\n<figure><img loading="lazy" decoding="async" width="1024" height="667" class="wp-image-3923" src="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.37-1024x667.jpeg" alt="" data-id="3923" data-full-url="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.37.jpeg" data-link="https://cintespbr.org/?attachment_id=3923" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.37-1024x667.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.37-300x195.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.37-768x500.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.15.37.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure>\r\n</li>\r\n<li class="blocks-gallery-item">\r\n<figure><img loading="lazy" decoding="async" width="1024" height="542" class="wp-image-3930" src="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-1-1024x542.jpeg" alt="" data-id="3930" data-full-url="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-1.jpeg" data-link="https://cintespbr.org/?attachment_id=3930" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-1-1024x542.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-1-300x159.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-1-768x407.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-1.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure>\r\n</li>\r\n<li class="blocks-gallery-item">\r\n<figure><img loading="lazy" decoding="async" width="1024" height="602" class="wp-image-3931" src="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-2-1024x602.jpeg" alt="" data-id="3931" data-full-url="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-2.jpeg" data-link="https://cintespbr.org/?attachment_id=3931" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-2-1024x602.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-2-300x176.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-2-768x451.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-2.jpeg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure>\r\n</li>\r\n<li class="blocks-gallery-item">\r\n<figure><img loading="lazy" decoding="async" width="747" height="1024" class="wp-image-3934" src="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.32-747x1024.jpeg" alt="" data-id="3934" data-full-url="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.32.jpeg" data-link="https://cintespbr.org/?attachment_id=3934" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.32-747x1024.jpeg 747w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.32-219x300.jpeg 219w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.32-768x1053.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.32.jpeg 912w" sizes="(max-width: 747px) 100vw, 747px" /></figure>\r\n</li>\r\n</ul>\r\n<figcaption class="blocks-gallery-caption">A Diretora de Relações Públicas em Tecnologias Assistiva Daniela Moura Yoshida, entregou ao Ministro do MCTI, Astronauta Marcos Pontes e à Chefe da Assessoria Especial de Assuntos Institucionais Christiane Gonçalves Corrêa, uma placa de agradecimento pelo apoio ao CINTESP.Br</figcaption>\r\n</figure>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter size-large is-resized"><img loading="lazy" decoding="async" class="wp-image-3938" src="https://cintespbr.org/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-4-1024x692.jpeg" alt="" width="512" height="346" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-4-1024x692.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-4-300x203.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-4-768x519.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/09/WhatsApp-Image-2020-09-08-at-00.19.31-4.jpeg 1280w" sizes="(max-width: 512px) 100vw, 512px" />\r\n<figcaption>Brigadeiro Maurício Ribeiro Gonçalves &#8211; Secretário do SETAP/MCTIC e o Secretário Paulo César Rezende De Carvalho Alvim da Secretaria de Empreendedorismo e Inovação SEMPI/MCTI</figcaption>\r\n</figure>\r\n</div>\r\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Bate Papo Ciência &amp; Tecnologia no Dia a Dia Nesta terça-feira, 18/08, às 19h30h o Diretor Geral Cleudmar Amaral Araújo e a Diretora de Relações Públicas em Tecnologias Assistiva Daniela Moura Yoshida, do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br), compareceram em Brasília no Ministério da Ciências, Tecnologia e Inovação &#8211;&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3929,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [],
        class_list: [
            "post-3922",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3922",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3922",
                },
            ],
            "version-history": [
                {
                    count: 7,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3922/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4088,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3922/revisions/4088",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3929",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3922",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3922",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3922",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3720,
        date: "2020-08-17T20:08:59",
        date_gmt: "2020-08-17T23:08:59",
        guid: {
            rendered: "https://cintespbr.org/?p=3720",
        },
        modified: "2020-09-20T11:33:07",
        modified_gmt: "2020-09-20T14:33:07",
        slug: "bate-papo-ciencia-tecnologia-no-dia-a-dia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/bate-papo-ciencia-tecnologia-no-dia-a-dia/",
        title: {
            rendered: "BATE-PAPO CIÊNCIA &#038; TECNOLOGIA NO DIA A DIA",
        },
        content: {
            rendered:
                '\n<h3 class="wp-block-heading">BATE-PAPO CIÊNCIA &amp; TECNOLOGIA NO DIA A DIA</h3>\n\n\n\n<p>  Nesta terça-feira, 18/08, às 19h30h  o diretor geral do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br), professor dr. Cleudmar Araújo participará do Bate Papo Ciência e Tecnologia no Dia a Dia que terá como tema &#8220;Tecnologia Assistiva (tecnologias para pessoas com deficiência física) e Doenças Raras&#8221; juntamente com o ministro do MCTI, Marcos Pontes.</p>\n\n\n\n<p>O evento será transmitido ao vivo no <a rel="noreferrer noopener" href="https://l.facebook.com/l.php?u=https%3A%2F%2Fwww.youtube.com%2FMCTI%3Ffbclid%3DIwAR2Bx8W365wy5QYx3D0USegqPtKaCirJaeX4omJPOhDF4P2nSLtlTWtymVk&amp;h=AT0nIz4GeSYiUWlsREdW91Pb6h30HX49Ovup5CjyGA4JWp4IZA621lBDX5A2raYimdk6asmf6c-3BUljhDJmLBtxWPmkFZsjTMrnUsvbNXWOpm4OT-o-0MfTrLuOmzmntT1u&amp;__tn__=-UK-R&amp;c[0]=AT2l5mDP8X_mG3LpFjpJNS9xOVU1pjtNNkKWTs5wrI4onoFqOs07zcchzTz27HHgawngL5o9zR76HLXpsh7keQsN2Kpmaq2z3dMCtHOwxmgupdVbZNzOLp7gsKj7VqcMcbb5ygUSpr_rs4FgU6Xip4lkqIYhjqHYJraXwxKAe6bO7RV6n6cCn6xY97GWafc" target="_blank">www.youtube.com/MCTI</a></p>\n\n\n\n<p>Participe da live enviando sua pergunta!  </p>\n\n\n\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="819" height="1024" src="https://cintespbr.org/wp-content/uploads/2020/08/WhatsApp-Image-2020-08-18-at-18.55.07-819x1024.jpeg" alt="" class="wp-image-3765" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/08/WhatsApp-Image-2020-08-18-at-18.55.07-819x1024.jpeg 819w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/WhatsApp-Image-2020-08-18-at-18.55.07-240x300.jpeg 240w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/WhatsApp-Image-2020-08-18-at-18.55.07-768x960.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/WhatsApp-Image-2020-08-18-at-18.55.07.jpeg 1024w" sizes="(max-width: 819px) 100vw, 819px" /></figure>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>BATE-PAPO CIÊNCIA &amp; TECNOLOGIA NO DIA A DIA Nesta terça-feira, 18/08, às 19h30h o diretor geral do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP.Br), professor dr. Cleudmar Araújo participará do Bate Papo Ciência e Tecnologia no Dia a Dia que terá como tema &#8220;Tecnologia Assistiva (tecnologias para pessoas com deficiência física)&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3766,
        comment_status: "open",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [],
        class_list: [
            "post-3720",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3720",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3720",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3720/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3772,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3720/revisions/3772",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3766",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3720",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3720",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3720",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3706,
        date: "2020-08-13T21:02:25",
        date_gmt: "2020-08-14T00:02:25",
        guid: {
            rendered: "https://cintespbr.org/?p=3706",
        },
        modified: "2021-12-27T23:03:19",
        modified_gmt: "2021-12-28T02:03:19",
        slug: "com-apoio-do-mcti-prototipo-deve-baratear-fabricacao-de-cadeiras-de-rodas-de-corrida",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/com-apoio-do-mcti-prototipo-deve-baratear-fabricacao-de-cadeiras-de-rodas-de-corrida/",
        title: {
            rendered:
                "Com apoio do MCTI, protótipo deve baratear fabricação de cadeiras de rodas de corrida",
        },
        content: {
            rendered:
                '\n<h4 class="wp-block-heading"> Para isso o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos em parceria com a Universidade Federal de Uberlândia e o MCTI apostam na transferência de tecnologia </h4>\n\n\n\n<figure class="wp-block-image is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/08/prototipoparatleta2.jpg" alt="" class="wp-image-3708" width="781" height="440" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/08/prototipoparatleta2.jpg 611w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/prototipoparatleta2-300x169.jpg 300w" sizes="(max-width: 781px) 100vw, 781px" /></figure>\n\n\n\n<p> Muitas pessoas quando assistem a uma corrida de Fórmula 1 não fazem ideia de que muitas das tecnologias usadas nos velozes carros de corrida, após passarem por testes e se tornarem financeiramente mais acessíveis, são incorporadas nos automóveis de passeio, que circulam dia a dia nas ruas. Como exemplo, temos o freio ABS, a transmissão automática de marcha, o volante multifuncional, dentre outras. Porém, essa transferência de tecnologia não acontece apenas no automobilismo. Um outro exemplo de transferência que visa a diminuição de custos pode ser observado em tecnologias assistivas, como no projeto desenvolvido pelo <strong>Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos</strong> <strong>(CINTESP.Br)</strong>, vinculado a Universidade Federal de Uberlândia (UFU) em parceria com Ministério da Ciência Tecnologia e Inovações (MCTI).</p>\n\n\n\n<p>O projeto desenvolveu um equipamento de prescrição automatizada de cadeira de rodas de corrida personalizadas para o esporte paralímpico. É um protótipo que permite que o paratleta tenha a sensação real da sua futura cadeira de corrida com diferentes tipos de regulagens. A ideia é que o atleta possa testar a cadeira e, após tirar todas as medidas personalizadas, um software transfere os dados em tempo real para a empresa, onde de forma automatizada o projeto da sua nova cadeira é processado e, na sequência, transferido para a linha de produção.</p>\n\n\n\n<p>Neste sábado (15), o paratleta do Comitê Paralímpico Brasileiro, Ariosvaldo Fernandes, conhecido por Parré, irá participar de testes de validação do equipamento. A proposta é desenvolver este equipamento visando a transferência desta tecnologia para a sociedade, empresas do setor, associações e pesquisadores interessados.</p>\n\n\n\n<p>Antes deste protótipo, a empresa fabricante precisava enviar um funcionário para tirar as medidas do atleta. Depois disso, a cadeira era fabricada e enviada para que o atleta a testasse. Quase sempre eram necessários novos ajustes, com o retorno do equipamento para a empresa. Com todo esse trabalho, a estimativa de custo dos itens é alta, em torno de R$50 a R$60 mil. O novo protótipo permite a redução do tempo de desenvolvimento do projeto, aliado ao processo de fabricação e, consequentemente, a previsão é de redução dos custos totais.</p>\n\n\n\n<p>Os benefícios que esse equipamento proporcionará ao paradesporto estão associados ao desenvolvimento de cadeiras de corridas personalizadas, permitindo uso de tecnologia por impressão 3D e buscando uma redução nos custos finais para o esporte e o atleta. A proposta de novos materiais e métodos de fabricação pretende reduzir custos para o esporte paralímpico de alto rendimento, beneficiando os paratletas que não tem condições para custear o equipamento e subsidiando o Comitê Paralímpico Brasileiro nesta área de atuação. E assim como acontece na Fórmula 1 há perspectiva que as tecnologias desenvolvidas hoje pelo protótipo deverão baratear também no futuro os preços de novas cadeiras de rodas para não-atletas.</p>\n\n\n\n<p><strong>O protótipo</strong></p>\n\n\n\n<p>O equipamento de prescrição é utilizado para realizar diversas medições e regulagens de acordo com as características ergo-antropométricas do indivíduo, de forma que é possível avaliar qual a melhor acomodação do atleta. Para obter o melhor desempenho, a&nbsp; propulsão na cadeira de rodas de corrida personalizada é otimizada individualmente, de acordo com a parametrização a ser feita utilizando o equipamento de prescrição. Estas dimensões são alimentadas em tempo real, de forma online, de tal maneira que, o projeto estrutural de uma cadeira de rodas de corrida real é automaticamente implementado, e que reduz de forma drástica os tempos de desenvolvimento do projeto estrutural desta nova cadeira.</p>\n\n\n\n<p>O atleta paralímpico Parré compete em provas de atletismo em cadeira de rodas de corrida na classe T53. Ele representou o Brasil nos Jogos Parapan-Americanos do Rio 2007, Guadalajara 2011, Toronto 2015 e Lima 2019, conquistando diversas medalhas de ouro e prata. Além de uma medalha de Bronze no Campeonato Mundial de Lion em 2011. </p>\n\n\n\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="576" src="https://cintespbr.org/wp-content/uploads/2020/08/prototipoparatleta-1024x576.jpg" alt="" class="wp-image-3707" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/08/prototipoparatleta-1024x576.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/prototipoparatleta-300x169.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/prototipoparatleta-768x432.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/prototipoparatleta.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Para isso o Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos em parceria com a Universidade Federal de Uberlândia e o MCTI apostam na transferência de tecnologia Muitas pessoas quando assistem a uma corrida de Fórmula 1 não fazem ideia de que muitas das tecnologias usadas nos velozes carros de corrida, após passarem&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3707,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-3706",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3706",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3706",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3706/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3719,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3706/revisions/3719",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3707",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3706",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3706",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3706",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3604,
        date: "2020-08-09T15:39:47",
        date_gmt: "2020-08-09T18:39:47",
        guid: {
            rendered: "https://cintespbr.org/?p=3604",
        },
        modified: "2021-12-28T17:31:06",
        modified_gmt: "2021-12-28T20:31:06",
        slug: "ciencia-e-tudo",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ciencia-e-tudo/",
        title: {
            rendered: "CIÊNCIA É TUDO",
        },
        content: {
            rendered:
                '\n<figure class="wp-block-embed-youtube wp-block-embed is-type-video is-provider-youtube wp-embed-aspect-16-9 wp-has-aspect-ratio"><div class="wp-block-embed__wrapper">\n<iframe loading="lazy" title="O uso da tecnologia para a sustentabilidade | Ciência é Tudo" width="1200" height="675" src="https://www.youtube.com/embed/sXwQPiSgous?feature=oembed" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>\n</div></figure>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>https://www.youtube.com/watch?v=sXwQPiSgous&amp;feature=youtu.be</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3606,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43],
        tags: [],
        class_list: [
            "post-3604",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-43",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3604",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3604",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3604/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3605,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3604/revisions/3605",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3606",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3604",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3604",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3604",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3597,
        date: "2020-08-09T15:21:43",
        date_gmt: "2020-08-09T18:21:43",
        guid: {
            rendered: "https://cintespbr.org/?p=3597",
        },
        modified: "2020-09-20T11:34:59",
        modified_gmt: "2020-09-20T14:34:59",
        slug: "mec-week-edicao-2020",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/mec-week-edicao-2020/",
        title: {
            rendered: "MEC WEEK EDIÇÃO 2020",
        },
        content: {
            rendered:
                '\n<p> O Diretor do CINTESP.Br e prof da engenharia mecânica da UFU, estará ministrando uma palestra sobre tecnologia assistiva e inovação tecnológica para pessoas com deficiência e mobilidade reduzida, no esporte, saúde, lazer e vida diária. A palestra será apresentada na Semana da Engenharia Mecânica, <strong><a href="https://starkbotz.wixsite.com/starkbotzufvjm/mec-week">Mec Week</a></strong>, é um evento organizado pela equipe StarkBotz, que ocorrerá entre os dias 10 e 22 de agosto de 2020</p>\n\n\n\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="752" src="https://cintespbr.org/wp-content/uploads/2020/08/Sem-título-1-1024x752.png" alt="" class="wp-image-3624" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/08/Sem-título-1-1024x752.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/Sem-título-1-300x220.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/Sem-título-1-768x564.png 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure>\n\n\n\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="724" height="1024" src="https://cintespbr.org/wp-content/uploads/2020/08/Programação-primeira-semana-1-2-724x1024.jpg" alt="" class="wp-image-3598" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/08/Programação-primeira-semana-1-2-724x1024.jpg 724w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/Programação-primeira-semana-1-2-212x300.jpg 212w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/Programação-primeira-semana-1-2-768x1086.jpg 768w" sizes="(max-width: 724px) 100vw, 724px" /></figure>\n\n\n\n<p> Site do evento: <a href="https://starkbotz.wixsite.com/starkbotzufvjm/mec-week">https://starkbotz.wixsite.com/starkbotzufvjm/mec-week</a><br> Instagram da equipe StarkBotz: <a href="https://www.instagram.com/starkbotz/">https://www.instagram.com/starkbotz/</a><br> Instagram do Mec Week: <a href="https://www.instagram.com/mecweek/">https://www.instagram.com/mecweek/</a> </p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O Diretor do CINTESP.Br e prof da engenharia mecânica da UFU, estará ministrando uma palestra sobre tecnologia assistiva e inovação tecnológica para pessoas com deficiência e mobilidade reduzida, no esporte, saúde, lazer e vida diária. A palestra será apresentada na Semana da Engenharia Mecânica, Mec Week, é um evento organizado pela equipe StarkBotz, que ocorrerá&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3652,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [],
        class_list: [
            "post-3597",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3597",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3597",
                },
            ],
            "version-history": [
                {
                    count: 7,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3597/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3642,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3597/revisions/3642",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3652",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3597",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3597",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3597",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3567,
        date: "2020-08-09T12:08:37",
        date_gmt: "2020-08-09T15:08:37",
        guid: {
            rendered: "https://cintespbr.org/?p=3567",
        },
        modified: "2021-12-28T17:31:21",
        modified_gmt: "2021-12-28T20:31:21",
        slug: "ministro-do-mcti-astronauta-marcos-pontes-agradece",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ministro-do-mcti-astronauta-marcos-pontes-agradece/",
        title: {
            rendered: "Ministro do MCTI, Astronauta Marcos Pontes agradece",
        },
        content: {
            rendered:
                '\n<figure class="wp-block-embed-facebook wp-block-embed is-type-rich is-provider-facebook"><div class="wp-block-embed__wrapper">\n<div id="fb-root"></div><script async="1" defer="1" crossorigin="anonymous" src="https://connect.facebook.net/pt_BR/sdk.js#xfbml=1&amp;version=v8.0" nonce="SlVSUdf8"></script><div class="fb-post" data-href="https://www.facebook.com/923233494377611/posts/3499081003459501/?vh=e&amp;d=w" data-width="750"><blockquote cite="https://www.facebook.com/MCTIC/posts/3499081003459501" class="fb-xfbml-parse-ignore"><p>O ministro do MCTI, Astronauta Marcos Pontes em novo teste RT-PcR para Covid-19 recebeu resultado negativo (Não&#8230;</p>Publicado por <a href="https://www.facebook.com/MCTIC/">Ministério da Ciência, Tecnologia e Inovações</a> em&nbsp;<a href="https://www.facebook.com/MCTIC/posts/3499081003459501">Sábado, 8 de agosto de 2020</a></blockquote></div>\n</div></figure>\n\n\n\n<p> O ministro do MCTI, Astronauta Marcos Pontes em novo teste RT-PcR para Covid-19 recebeu resultado negativo (Não detectado). Marcos Pontes relatou em suas redes sociais que está recuperado e pronto para voltar ao trabalho presencial pelo país.&#8221;Gostaria de agradecer muito a todos vocês pelas mensagens de carinho e pelas orações para pronta recuperação. Muito feliz em saber que milhares de pessoas mandaram uma energia positiva neste momento.</p>\n\n\n\n<p>Obs. &#8220;Para quem estiver curioso se tomei ou não NITAZOXANIDA, a resposta é SIM. Participei como voluntário do estudo clínico.Também estou ansioso pela conclusão e resultado científico. </p>\n\n\n\n<p>Falta pouco se Deus quiser, mas ainda precisamos de voluntários. &#8221; declarou o ministro. </p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O ministro do MCTI, Astronauta Marcos Pontes em novo teste RT-PcR para Covid-19 recebeu resultado negativo (Não detectado). Marcos Pontes relatou em suas redes sociais que está recuperado e pronto para voltar ao trabalho presencial pelo país.&#8221;Gostaria de agradecer muito a todos vocês pelas mensagens de carinho e pelas orações para pronta recuperação. Muito feliz&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3569,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43],
        tags: [],
        class_list: [
            "post-3567",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-43",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3567",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3567",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3567/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3568,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3567/revisions/3568",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3569",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3567",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3567",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3567",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3531,
        date: "2020-08-08T01:50:56",
        date_gmt: "2020-08-08T04:50:56",
        guid: {
            rendered: "https://cintespbr.org/?p=3531",
        },
        modified: "2021-12-27T23:03:19",
        modified_gmt: "2021-12-28T02:03:19",
        slug: "live-mec-week",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/live-mec-week/",
        title: {
            rendered:
                "LIVE &#8211; Inovações tecnológicas assistivas para a sociedade &#8211; ações do CINTESP.Br",
        },
        content: {
            rendered:
                '\n<p></p>\n\n\n\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="905" height="1024" src="https://cintespbr.org/wp-content/uploads/2020/08/lIVE-3-905x1024.png" alt="" class="wp-image-3643" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/08/lIVE-3-905x1024.png 905w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/lIVE-3-265x300.png 265w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/lIVE-3-768x869.png 768w" sizes="(max-width: 905px) 100vw, 905px" /></figure>\n\n\n\n<p>O CINTESP.Br convida a todos a participarem na Live &#8211; Inovações tecnológicas assistivas para a sociedade &#8211; ações do CINTESP.Br<br> <strong>Dia 12 de agosto de 2020 às 10 horas no canal PROVIFOR UFU, no Youtube.</strong> <br> <a href="https://www.youtube.com/channel/UCA6JEvL03bJQnoAaCBlmxBA ">https://www.youtube.com/channel/UCA6JEvL03bJQnoAaCBlmxBA </a></p>\n\n\n\n<p> Um bate-papo ao vivo  entre dois membros da equipe de coordenação do CINTESP.Br, o <strong>Prof. Dr. Cleudmar</strong> e o <strong>Prof. Dr. Silvio</strong>, onde abordarão assuntos sobre os projetos desenvolvidos no <strong>CINTESP.Br</strong> e a parceria com o <strong>Comitê Paralímpico Brasileiro.</strong></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O CINTESP.Br convida a todos a participarem na Live &#8211; Inovações tecnológicas assistivas para a sociedade &#8211; ações do CINTESP.Br Dia 12 de agosto de 2020 às 10 horas no canal PROVIFOR UFU, no Youtube. https://www.youtube.com/channel/UCA6JEvL03bJQnoAaCBlmxBA Um bate-papo ao vivo entre dois membros da equipe de coordenação do CINTESP.Br, o Prof. Dr. Cleudmar e o&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3550,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "template-microsite.php",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-3531",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3531",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3531",
                },
            ],
            "version-history": [
                {
                    count: 16,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3531/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3644,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3531/revisions/3644",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3550",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3531",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3531",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3531",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3579,
        date: "2020-07-29T13:41:09",
        date_gmt: "2020-07-29T16:41:09",
        guid: {
            rendered: "https://cintespbr.org/?p=3579",
        },
        modified: "2021-12-28T17:31:35",
        modified_gmt: "2021-12-28T20:31:35",
        slug: "roberto-rocha-bate-papo-tecnologia-politica-mcti",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/roberto-rocha-bate-papo-tecnologia-politica-mcti/",
        title: {
            rendered:
                "ROBERTO ROCHA &#8211; BATE-PAPO TECNOLOGIA &#038; POLÍTICA MCTI",
        },
        content: {
            rendered:
                '\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="562" src="https://cintespbr.org/wp-content/uploads/2020/08/bate-papo-1-1024x562.png" alt="" class="wp-image-3582" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/08/bate-papo-1-1024x562.png 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/bate-papo-1-300x165.png 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/08/bate-papo-1-768x421.png 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure>\n\n\n\n<p><a href="https://www.facebook.com/watch/live/?v=648864522392867&amp;ref=watch_permalink">https://www.facebook.com/watch/live/?v=648864522392867&amp;ref=watch_permalink</a></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>https://www.facebook.com/watch/live/?v=648864522392867&amp;ref=watch_permalink</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3582,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43],
        tags: [],
        class_list: [
            "post-3579",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "category-43",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3579",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3579",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3579/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3583,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3579/revisions/3583",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3582",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3579",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3579",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3579",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3501,
        date: "2020-07-04T22:41:57",
        date_gmt: "2020-07-05T01:41:57",
        guid: {
            rendered: "https://cintespbr.org/?p=3501",
        },
        modified: "2021-12-27T23:03:19",
        modified_gmt: "2021-12-28T02:03:19",
        slug: "cintesp-faz-doacao-de-mascaras-de-prevencao-a-covid-19-a-futel",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cintesp-faz-doacao-de-mascaras-de-prevencao-a-covid-19-a-futel/",
        title: {
            rendered:
                "CINTESP.Br faz doação de máscaras de prevenção à Covid-19 para a FUTEL",
        },
        content: {
            rendered:
                '\n<h4 class="wp-block-heading">EQUIPAMENTOS SÃO PRODUZIDOS PELO CINTESP.Br, EM IMPRESSORA 3D, COM ACETATO E POLÍMERO ABS  </h4>\n\n\n\n<p></p>\n\n\n\n<p>A Fundação Uberlandense do Turismo, Esporte e Lazer (Futel) recebeu, nesta sexta-feira (3), a doação de 40 máscaras produzidas em impressora 3D pelo Centro Brasileiro de Referência em Inovações Tecnológicas para o Esporte Paralímpico (Cintesp), mantido com apoio da Futel. Os equipamentos serão distribuídos entre servidores da fundação que trabalham em contato direto com o público, como forma de prevenção à Covid-19.</p>\n\n\n\n<p>Segundo uma das dirigentes do Cintesp, a profissional de educação física Regina Caixeta Ribeiro, a máscara é feita com acetato e polímero ABS, considerada eficiente para a prevenção. “Ela é mais confortável e protege o rosto todo. Ou seja, evita a contaminação em locais como os olhos. As máscaras têm sido produzidas pelo Cintesp já há algum tempo e essa é nossa segunda doação, sendo que a primeira foi feita para o Hospital de Clínicas da Universidade Federal de Uberlândia (HC-UFU)”, ressaltou.</p>\n\n\n\n<p><strong>Cintesp</strong></p>\n\n\n\n<p>O Cintesp é um centro multidisciplinar de pesquisadores que desenvolvem inovações tecnológicas voltadas, sobretudo, ao paradesporto. Suas pesquisas são desenvolvidas em instalações na Arena Sabiazinho e na UFU e são direcionadas, supervisionadas e implementadas para pessoas com deficiência, em especial os paratletas.</p>\n\n\n\n<p>O centro funciona por meio de uma parceria entre Futel, o Comitê Paralímpico Brasileiro (CPB), a UFU, a Rede Mineira de Tecnologia Assistiva (RMTA), a Rede Nacional de Pesquisa e Desenvolvimento de Tecnologia Assistiva do Ministério da Ciência, Tecnologia, Inovações e Comunicações e o Centro Nacional de Referência em Tecnologia Assistiva (CNRTA/CTI Campinas).</p>\n\n\n\n<p class="has-small-font-size">Fonte:  <a href="https://www.uberlandia.mg.gov.br/2020/07/03/futel-recebe-doacao-de-mascaras-de-prevencao-ao-covid-19/">https://www.uberlandia.mg.gov.br/2020/07/03/futel-recebe-doacao-de-mascaras-de-prevencao-ao-covid-19/</a> </p>\n\n\n\n<p></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>EQUIPAMENTOS SÃO PRODUZIDOS PELO CINTESP.Br, EM IMPRESSORA 3D, COM ACETATO E POLÍMERO ABS A Fundação Uberlandense do Turismo, Esporte e Lazer (Futel) recebeu, nesta sexta-feira (3), a doação de 40 máscaras produzidas em impressora 3D pelo Centro Brasileiro de Referência em Inovações Tecnológicas para o Esporte Paralímpico (Cintesp), mantido com apoio da Futel. Os equipamentos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3503,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-3501",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3501",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3501",
                },
            ],
            "version-history": [
                {
                    count: 9,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3501/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3515,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3501/revisions/3515",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3503",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3501",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3501",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3501",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3464,
        date: "2020-02-01T13:16:57",
        date_gmt: "2020-02-01T16:16:57",
        guid: {
            rendered: "https://cintespbr.org/?p=3464",
        },
        modified: "2021-12-27T23:07:07",
        modified_gmt: "2021-12-28T02:07:07",
        slug: "os-melhores-do-ano-no-premio-paralimpicos-2019",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/os-melhores-do-ano-no-premio-paralimpicos-2019/",
        title: {
            rendered: "Os melhores do ano no Prêmio Paralímpicos 2019",
        },
        content: {
            rendered:
                '\n<p><strong><em>fontes:</em></strong></p>\n\n\n\n<ul class="wp-block-list"><li><a href="https://www.cpb.org.br/noticia/detalhe/2758/beth-gomes-e-petrucio-ferreira-sao-eleitos-os-melhores-do-ano-no-premio-paralimpicos-2019"><em>https://www.cpb.org.br/noticia/detalhe/2758/beth-gomes-e-petrucio-ferreira-sao-eleitos-os-melhores-do-ano-no-premio-paralimpicos-2019</em></a></li><li><a href="https://globoesporte.globo.com/paralimpiadas/noticia/petrucio-ferreira-e-beth-gomes-vencem-o-premio-paralimpicos-2019.ghtml"><em>https://globoesporte.globo.com/paralimpiadas/noticia/petrucio-ferreira-e-beth-gomes-vencem-o-premio-paralimpicos-2019.ghtml</em></a></li></ul>\n\n\n\n<p>Os prêmios são promovidos\npelo Comitê Paralímpico Brasileiro (CPB)</p>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-01-1024x675.jpg" alt="" class="wp-image-3465" width="512" height="338" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-01-1024x675.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-01-300x198.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-01-768x506.jpg 768w" sizes="(max-width: 512px) 100vw, 512px" /><figcaption>17/12/19 &#8211; São Paulo-SP &#8211; Prêmio Paralímpicos 2019. Foto: Daniel Zappe/Exemplus/CPB<br>O presidente do Comitê Paralímpico Brasileiro <strong>Mizael Conrado de Oliveira<br> </strong>homenageia os atletas do ano no Prêmio Paralímpicos 2019 e reconhece como os heróis, e a todos das equipes do movimento paralímpico brasileiro.</figcaption></figure></div>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-01p-1024x667.jpg" alt="" class="wp-image-3466" width="512" height="334" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-01p-1024x667.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-01p-300x195.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-01p-768x500.jpg 768w" sizes="(max-width: 512px) 100vw, 512px" /><figcaption>17/12/19 &#8211; São Paulo-SP &#8211; Prêmio Paralímpicos 2019. Foto: Daniel Zappe/Exemplus/CPB</figcaption></figure></div>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-01pp-1024x624.jpg" alt="" class="wp-image-3467" width="512" height="312" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-01pp-1024x624.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-01pp-300x183.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-01pp-768x468.jpg 768w" sizes="(max-width: 512px) 100vw, 512px" /><figcaption>17.12.19 &#8211; Prêmio Paralímpicos. Evento realizado no Hotel Unique, em São Paulo, para premiar os melhores atletas do ano &#8211; Beth Gomes e Petrúcio Ferreira (ambos do atletismo). Foto: Ale Cabral/CPB.</figcaption></figure></div>\n\n\n\n<p>O\nCINTESP.Br teve a honra de participar da grande celebração do Paradesporto\nBrasileiro, o <strong>PRÊMIO PARALÍMPICOS 2019</strong>.\nUma noite especial para homenagear as grandes conquistas do paratletas\nBrasileiros de 2019.&nbsp; Realizado dia 17 de\ndezembro &#8211; Hotel Unique, São Paulo, Jardim Paulista. </p>\n\n\n\n<p>A cerimônia foi apresentada pela atriz Cris Vianna e pelo repórter do\nGrupo Globo Renato Peters, contou também com a presença de autoridades como\no&nbsp;general Décio dos Santos Brasil – Secretário Especial do Esporte e\nCidadania.</p>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-02-1024x727.jpg" alt="" class="wp-image-3468" width="512" height="364" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-02-1024x727.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-02-300x213.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-02-768x545.jpg 768w" sizes="(max-width: 512px) 100vw, 512px" /></figure></div>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-03-1024x699.jpg" alt="" class="wp-image-3469" width="512" height="350" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03-1024x699.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03-300x205.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03-768x525.jpg 768w" sizes="(max-width: 512px) 100vw, 512px" /><figcaption>17/12/19 &#8211; São Paulo-SP &#8211; Prêmio Paralímpicos 2019 -Petrucio Ferreira e Elizabeth Gomes. <br>Foto: Daniel Zappe/Exemplus/CPB<br>Destaques do Brasil no último Mundial de Atletismo, realizado em Dubai, nos Emirados Árabes, Petrúcio Ferreira e Beth Gomes foram os vencedores da categoria melhor atleta do ano do Prêmio Paralímpicos 2019. <a href="https://globoesporte.globo.com/paralimpiadas/noticia/petrucio-ferreira-e-beth-gomes-vencem-o-premio-paralimpicos-2019.ghtml">https://globoesporte.globo.com/paralimpiadas/noticia/petrucio-ferreira-e-beth-gomes-vencem-o-premio-paralimpicos-2019.ghtml</a></figcaption></figure></div>\n\n\n\n<p>O Embaixador Mirim Lucio\nKendy, junto a equipe do CINTESP.Br, o Diretor Geral Cleudmar A. Araújo e a\nDiretora de Relações Públicas em Tecnologias Assistivas Daniela Yoshida,\nparticiparam da homenagem a paratleta Beth Gomes vencedora da categoria melhor atleta do ano do Prêmio Paralímpicos 2019</p>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-03p-768x1024.jpeg" alt="" class="wp-image-3470" width="384" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03p-768x1024.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03p-225x300.jpeg 225w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03p.jpeg 774w" sizes="(max-width: 384px) 100vw, 384px" /></figure></div>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-03pp-768x1024.jpeg" alt="" class="wp-image-3471" width="384" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03pp-768x1024.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03pp-225x300.jpeg 225w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03pp.jpeg 774w" sizes="(max-width: 384px) 100vw, 384px" /></figure></div>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-03ppp-768x1024.jpeg" alt="" class="wp-image-3472" width="384" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03ppp-768x1024.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03ppp-225x300.jpeg 225w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03ppp.jpeg 774w" sizes="(max-width: 384px) 100vw, 384px" /><figcaption>O Embaixador Mirim do CINTESP.Br Lucio Kendy, sauda a paratleta Beth Gomes, vencedora da categoria melhor atleta do ano do Prêmio Paralímpicos 2019, com um grande abraço.</figcaption></figure></div>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-03pppp-768x1024.jpeg" alt="" class="wp-image-3473" width="384" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03pppp-768x1024.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03pppp-225x300.jpeg 225w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-03pppp.jpeg 774w" sizes="(max-width: 384px) 100vw, 384px" /><figcaption>Lucio Kendy Embaixador Mirim, o Diretor Geral Cleudmar A. Araújo e a Diretora de Relações Públicas em Tecnologias Assistivas Daniela Yoshida do CINTESP.Br, homenageiam os paratletas Petrúcio Ferreira e Beth Gomes foram os vencedores da categoria melhor atleta do ano do Prêmio Paralímpicos 2019</figcaption></figure></div>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-04.jpg" alt="" class="wp-image-3474" width="500" height="352" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-04.jpg 1000w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-04-300x211.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-04-768x540.jpg 768w" sizes="(max-width: 500px) 100vw, 500px" /><figcaption>O Prêmio Paralímpicos 2019 também coroou na categoria &#8220;atleta da galera&#8221;, Alana Maldonado. </figcaption></figure></div>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-04p-1024x768.jpeg" alt="" class="wp-image-3475" width="512" height="384" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-04p-1024x768.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-04p-300x225.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-04p-768x576.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-04p.jpeg 1032w" sizes="(max-width: 512px) 100vw, 512px" /></figure></div>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-04pp-576x1024.jpg" alt="" class="wp-image-3476" width="288" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-04pp-576x1024.jpg 576w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-04pp-169x300.jpg 169w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-04pp.jpg 581w" sizes="(max-width: 288px) 100vw, 288px" /><figcaption>Daniela Yoshida a Diretora de Relações Públicas em Tecnologias Assistivas do CINTESP.Br, parabeniza a paratleta Alana Maldonado, uma das grandes homenageadas da noite. E destaca para a paratleta Alana as Novas Tecnologias Assistivas para o esporte paralímpico que estão sendo desenvolvidas pelo CINTESP.Br em parceria com MCTIC.</figcaption></figure></div>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-04ppp-768x1024.jpeg" alt="" class="wp-image-3477" width="384" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-04ppp-768x1024.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-04ppp-225x300.jpeg 225w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-04ppp.jpeg 774w" sizes="(max-width: 384px) 100vw, 384px" /><figcaption>Na homenagem o CINTESP.Br conta com Lucio Kendy Embaixador Mirim, o Diretor Geral Cleudmar A. Araújo e a Diretora de Relações Públicas em Tecnologias Assistivas Daniela Yoshida, parabenizam a paratleta Alana Maldonado, uma das grandes homenageadas da noite do Prêmio Paralímpicos 2019.</figcaption></figure></div>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-05-768x1024.jpeg" alt="" class="wp-image-3478" width="384" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-05-768x1024.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-05-225x300.jpeg 225w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-05.jpeg 774w" sizes="(max-width: 384px) 100vw, 384px" /></figure></div>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter is-resized"><img loading="lazy" decoding="async" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAGEM-06-768x1024.jpg" alt="" class="wp-image-3479" width="384" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-06-768x1024.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-06-225x300.jpg 225w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAGEM-06.jpg 774w" sizes="(max-width: 384px) 100vw, 384px" /><figcaption>Na mesma ocasião o CINTESP.Br teve a oportunidade de apresentar as ações e os desenvolvimentos de novas tecnologias relacionadas ao esporte paralímpico que estão sendo desenvolvida em parceria com MCTIC ao general Décio dos Santos Brasil – Secretário Especial do Esporte e Cidadania e ao <em>Décio Roberto Calegari,</em> técnico da Seleção Brasileira de <em>Petra</em> do Comitê Paralímpico Brasileiro-CPB. </figcaption></figure></div>\n\n\n\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="710" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-07-1024x710.jpg" alt="" class="wp-image-3480" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-07-1024x710.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-07-300x208.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-07-768x532.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /><figcaption>17/12/19 &#8211; São Paulo-SP &#8211; Prêmio Paralímpicos 2019. Foto: Daniel Zappe/Exemplus/CPB</figcaption></figure>\n\n\n\n<h4 class="wp-block-heading">Confira a lista de todos os ganhadores do Prêmio Paralímpicos 2019:</h4>\n\n\n\n<p> <strong>Melhor feminino</strong> &#8211; Beth Gomes<br> <strong>Melhor masculino </strong>&#8211; Petrúcio Ferreira<br> <strong>Atleta revelação</strong> &#8211; Wendell Belarmino <br> <strong>Atleta da Galera</strong> &#8211; Alana Maldonado<br> <strong>Melhor técnico individual </strong>&#8211; Pedrinho Almeida<br> <strong>Melhor técnico coletivo </strong>&#8211; Fábio Vasconcelos<br>  <br> <strong>Atletismo </strong>&#8211; Petrúcio Ferreira<br> <strong>Basquete em CR</strong> – Vileide Almeida<br> <strong>Bocha </strong>– Maciel Santos<br> <strong>Canoagem</strong> – Luis Carlos Cardoso <br> <strong>Ciclismo </strong>– Lauro Chaman<br> <strong>Esgrima em CR</strong> – Jovane Guissone<br> <strong>Esportes de Neve</strong> – Cristian Ribera<br> <strong>Futebol de 5</strong> – Raimundo Nonato <br> <strong>Futebol de 7 </strong>– Bira Magalhães<br> <strong>Goalball </strong>– Leomon Moreno<br> <strong>Halterofilismo </strong>– Mariana D’Andrea<br> <strong>Hipismo </strong>– Rodolpho Riskala<br> <strong>Judô</strong> – Meg Emmerich<br> <strong>Natação</strong> – Carol Santiago<br> <strong>Parabadminton </strong>– Vitor Tavares<br> <strong>Parataekwondo</strong> – Débora Menezes<br> <strong>Remo</strong> – Renê Pereira<br> <strong>Rúgbi em CR</strong> – Julio Braz <br> <strong>Tênis de Mesa </strong>– Paulo Salmin<br> <strong>Tênis em CR</strong> – Daniel Rodrigues<br> <strong>Tiro Esportivo</strong> – Alexandre Galgani<br> <strong>Tiro com arco</strong> – Jane Karla Gögel<br> <strong>Triatlo –</strong> Carlos Viana<br> <strong>Vôlei Sentado</strong> – Gilberto da Silva<br>  <br> <strong>Prêmio Personalidade Paralímpica </strong>&#8211; João Doria<br> <strong>Prêmio Aldo Miccolis </strong>&#8211; Grupo Globo<br> <strong>Prêmio Clube Caixa </strong>&#8211; ADI APIN<br> <strong>Prêmio Memória Paralímpica </strong>&#8211; CPSP <br>  <br> <strong>Patrocínio</strong><br> O Prêmio Paralímpicos é patrocinado pelas Loterias Caixa.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>fontes: https://www.cpb.org.br/noticia/detalhe/2758/beth-gomes-e-petrucio-ferreira-sao-eleitos-os-melhores-do-ano-no-premio-paralimpicos-2019 https://globoesporte.globo.com/paralimpiadas/noticia/petrucio-ferreira-e-beth-gomes-vencem-o-premio-paralimpicos-2019.ghtml Os prêmios são promovidos pelo Comitê Paralímpico Brasileiro (CPB) O CINTESP.Br teve a honra de participar da grande celebração do Paradesporto Brasileiro, o PRÊMIO PARALÍMPICOS 2019. Uma noite especial para homenagear as grandes conquistas do paratletas Brasileiros de 2019.&nbsp; Realizado dia 17 de dezembro &#8211; Hotel Unique, São Paulo, Jardim Paulista. A&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3465,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-3464",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3464",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3464",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3464/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3481,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3464/revisions/3481",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3465",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3464",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3464",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3464",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3440,
        date: "2020-02-01T12:30:10",
        date_gmt: "2020-02-01T15:30:10",
        guid: {
            rendered: "https://cintespbr.org/?p=3440",
        },
        modified: "2021-05-15T23:37:53",
        modified_gmt: "2021-05-16T02:37:53",
        slug: "semana-nacional-de-ciencia-e-tecnologia-no-df",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/semana-nacional-de-ciencia-e-tecnologia-no-df/",
        title: {
            rendered: "Semana Nacional de Ciência e Tecnologia no DF",
        },
        content: {
            rendered:
                '\r\n<p>A <strong>16ª Semana Nacional de Ciência e Tecnologia </strong>(SNCT) é coordenada pelo Ministério da Ciência, Tecnologia, Inovações e Comunicações (MCTIC) e realizada nacionalmente desde 2004. Conta com a colaboração do setor público e privado, de fundações de apoio à pesquisa, de entidades e instituições de ensino, divulgação e pesquisa, além de secretarias estaduais e municipais, em especial de Ciência e Tecnologia (C&amp;T) e Educação.</p>\r\n\r\n\r\n\r\n<p>A SNCT abrange todo o território nacional e, em Brasília, organizada pelo MCTIC em parceria com o Governo do Distrito Federal é apresentado ao público do DF o evento âncora com exposições realizadas pelas instituições ligadas à Ciência e Tecnologia do DF e instituições convidadas de outras Unidades Federativas.</p>\r\n\r\n\r\n\r\n<p>O objetivo da SNCT-DF é democratizar o acesso ao conhecimento científico e aproximar a população da ciência, tecnologia e inovação, promovendo e estimulando atividades de divulgação científica no Distrito Federal, proporcionando debates e reflexões.</p>\r\n\r\n\r\n\r\n<p>É importante destacar que, a SNCT tem atraído a cada ano um número maior de participantes. Em sua 15ª edição (2018), contou com 94.858 atividades em 1.506 municípios brasileiros de todos os estados. Trata-se do maior evento de divulgação científica do país e um dos maiores do mundo.</p>\r\n\r\n\r\n\r\n<p><em><strong>fonte:</strong> https://snct.mctic.gov.br/ </em></p>\r\n\r\n\r\n\r\n<h3 class="wp-block-heading"><strong>&#8216;Quem quer ser um cientista?&#8217; </strong></h3>\r\n\r\n\r\n\r\n<p><strong>Semana Nacional de Ciência e Tecnologia no DF</strong></p>\r\n\r\n\r\n\r\n<p><strong>Evento ocorreu no Parque da Cidade no DF; entrada foi gratuita.</strong></p>\r\n\r\n\r\n\r\n<p><em><strong>fonte: </strong></em><strong><em> G1 DF</em></strong><em> (23/10/2019)</em><br /><em><a href="https://g1.globo.com/df/distrito-federal/noticia/2019/10/23/quem-quer-ser-um-cientista-veja-programacao-da-semana-nacional-de-ciencia-e-tecnologia-no-df.ghtml">https://g1.globo.com/df/distrito-federal/noticia/2019/10/23/quem-quer-ser-um-cientista-veja-programacao-da-semana-nacional-de-ciencia-e-tecnologia-no-df.ghtml </a></em></p>\r\n\r\n\r\n\r\n<p>Lucio Kendy, Embaixador Mirim do CINTESP.Br, represento das crianças do Esporte Paralímpico é foi o destaque da página de abertura da g1.globo.com, na abertura da Semana nacional de Ciência e Tecnologia no DF.</p>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3441" src="https://cintespbr.org/wp-content/uploads/2020/02/sntc7.jpg" alt="" width="492" height="369" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/sntc7.jpg 984w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/sntc7-300x225.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/sntc7-768x576.jpg 768w" sizes="(max-width: 492px) 100vw, 492px" />\r\n<figcaption>16ª Semana Nacional de Ciência e Tecnologia — Foto: Brenda Ortiz/ G1</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<p>A exposição reuniu todas as entidades vinculadas ao Ministério da Ciência, Tecnologia, Inovações e Comunicações em um espaço interativo, com o objetivo de mostrar a ciência que é feita no Brasil.</p>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3442" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-02-LUCIO.jpeg" alt="" width="393" height="491" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-02-LUCIO.jpeg 785w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-02-LUCIO-240x300.jpeg 240w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-02-LUCIO-768x961.jpeg 768w" sizes="(max-width: 393px) 100vw, 393px" />\r\n<figcaption>Lucio Kendy, Embaixador Mirim do CINTESP.Br</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3443" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-04-LUCIO-1024x768.jpg" alt="" width="512" height="384" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-04-LUCIO-1024x768.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-04-LUCIO-300x225.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-04-LUCIO-768x576.jpg 768w" sizes="(max-width: 512px) 100vw, 512px" />\r\n<figcaption>Lucio Kendy, Embaixador Mirim do CINTESP.Br</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3444" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-05-LUCIO-1024x768.jpg" alt="" width="512" height="384" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-05-LUCIO-1024x768.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-05-LUCIO-300x225.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-05-LUCIO-768x576.jpg 768w" sizes="(max-width: 512px) 100vw, 512px" />\r\n<figcaption>Lucio Kendy, Embaixador Mirim do CINTESP.Br</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3445" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-07-LUCIO-e1581693595379-768x1024.jpg" alt="" width="384" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-07-LUCIO-e1581693595379-768x1024.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-07-LUCIO-e1581693595379-225x300.jpg 225w" sizes="(max-width: 384px) 100vw, 384px" />\r\n<figcaption>Lucio Kendy, Embaixador Mirim do CINTESP.Br</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<p>O Embaixador Mirim Lucio Kendy, junto a equipe do CINTESP.Br, o Diretor Cleudmar A. Araújo e a Coordenadora Geral Daniela Yoshida, participaram da 16ª Semana Nacional da Ciência e Tecnologia (SNCT), realizada pelo Ministério da Ciência, Tecnologia, Inovações e Comunicações (MCTIC) nos dias 21 e 27 de outubro de 2019, no Pavilhão Expo Brasília do Parque da Cidade, em Brasília (DF). O CINTESP.Br programou diversas atividades em seu estande montado no local em frente ao palco principal, tais como a pratica da boxa como Esporte Paralímpico, uso da calha Paralímpica e exibições de vídeos e lançamento de novas tecnologias Assistivas. Entre os destaques da programação, os visitantes tiveram a possibilidade de fazer parte de uma partida de jogo de boxa Paralímpico com o uso da calha Paralímpica, uma nova tecnologia desenvolvida pelo CINTESP.Br, em impressão 3D, bem como conhecer as dificuldades que um paratleta enfrentam em uma competição Paralímpica, um exemplar na partida foi o uso da cadeira de roda e um capacete adaptado no jogo de boxa Paralímpico, que será testada e validado em São Paulo no Comitê Paralímpico Brasileiro &#8211; CPB.</p>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3446" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-08-1024x693.jpg" alt="" width="512" height="347" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-08-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-08-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-08-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-08.jpg 1649w" sizes="(max-width: 512px) 100vw, 512px" />\r\n<figcaption>Embaixador Mirim Lucio Kendy e a Coordenadora Geral Daniela Yoshida. Fazem demonstração do jogo de boxa Paralímpico com o uso da calha Paralímpica.</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3447" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-09-696x1024.jpg" alt="" width="348" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-09-696x1024.jpg 696w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-09-204x300.jpg 204w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-09-768x1130.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-09.jpg 849w" sizes="(max-width: 348px) 100vw, 348px" /></figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3448" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-11-1024x693.jpg" alt="" width="512" height="347" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-11-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-11-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-11-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-11.jpg 1649w" sizes="(max-width: 512px) 100vw, 512px" />\r\n<figcaption>Embaixador Mirim Lucio Kendy, faz demonstração do uso do capacete adaptado para o jogo de boxa Paralímpico com o uso da calha Paralímpica.</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3449" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-12-1024x693.jpg" alt="" width="512" height="347" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-12-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-12-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-12-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-12.jpg 1649w" sizes="(max-width: 512px) 100vw, 512px" />\r\n<figcaption>Embaixador Mirim Lucio Kendy faz uso de cadeira de rodas para lembrar que o jogo de boxa Paralímpico com o uso da calha Paralímpica e capacete adaptado pode ser um esporte para pessoas e crianças com deficiência em qual quer idade.</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3450" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-13-1024x693.jpg" alt="" width="512" height="347" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-13-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-13-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-13-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-13.jpg 1649w" sizes="(max-width: 512px) 100vw, 512px" /></figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3451" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-14-1024x693.jpg" alt="" width="512" height="347" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-14-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-14-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-14-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-14.jpg 1649w" sizes="(max-width: 512px) 100vw, 512px" /></figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3452" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-15-576x1024.jpeg" alt="" width="288" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-15.jpeg 576w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-15-169x300.jpeg 169w" sizes="(max-width: 288px) 100vw, 288px" />\r\n<figcaption>A Coordenadora Geral Daniela Yoshida. Faz demonstração do jogo de boxa Paralímpico, com o uso da calha Paralímpica e capacete adaptado com crianças sem deficiência, para conscientizar as crianças sobre a inclusão social no esporte.</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3453" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-16-576x1024.jpeg" alt="" width="288" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-16.jpeg 576w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-16-169x300.jpeg 169w" sizes="(max-width: 288px) 100vw, 288px" />\r\n<figcaption>A Coordenadora Geral Daniela Yoshida. Faz demonstração do jogo de boxa Paralímpico, com o uso da calha Paralímpica e capacete adaptado com crianças sem deficiência, para conscientizar as crianças sobre a inclusão social no esporte.</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3454" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-17-1024x768.jpg" alt="" width="512" height="384" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-17-1024x768.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-17-300x225.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-17-768x576.jpg 768w" sizes="(max-width: 512px) 100vw, 512px" /></figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3455" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-18-LUCIO-1024x768.jpg" alt="" width="512" height="384" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-18-LUCIO-1024x768.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-18-LUCIO-300x225.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-18-LUCIO-768x576.jpg 768w" sizes="(max-width: 512px) 100vw, 512px" />\r\n<figcaption>Lucio Kendy o Embaixador Mirim buscou conscientizar as crianças sobre a Inclusão Social no Esporte Adaptado durante a 16ª Semana Nacional da Ciência e Tecnologia fazendo uso de cadeira de rodas para lembrar que o jogo de boxa Paralímpico com o uso da calha Paralímpica e capacete adaptado pode ser um esporte para pessoas e crianças com deficiência em qual idade.</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3456" src="https://cintespbr.org/wp-content/uploads/2020/02/imag-19-576x1024.jpeg" alt="" width="288" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/imag-19-576x1024.jpeg 576w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/imag-19-169x300.jpeg 169w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/imag-19.jpeg 581w" sizes="(max-width: 288px) 100vw, 288px" /></figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3457" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-20-e1581694024448-768x1024.jpg" alt="" width="384" height="512" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-20-e1581694024448-768x1024.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-20-e1581694024448-225x300.jpg 225w" sizes="(max-width: 384px) 100vw, 384px" />\r\n<figcaption>A 16ª Semana Nacional da Ciência e Tecnologia (SNCT), se encerra no estande do CINTESP.Br com a presença do Brigadeiro Maurício Ribeiro Gonçalves (Secretário SETAP/MCTIC), a Maria Cláudia Ferrari de Castro (Diretora DEPDS/MCTIC), o Embaixador Mirim do CINTESP.Br Lucio Kendy, o Diretor Geral-CINTESP.Br Cleudmar A. Araújo e a Coordenadora Geral-CINTESP.Br Daniela Yoshida.</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3458" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-21-LUCIO-1024x576.jpeg" alt="" width="512" height="288" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-21-LUCIO-1024x576.jpeg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-21-LUCIO-300x169.jpeg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-21-LUCIO-768x432.jpeg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-21-LUCIO.jpeg 1032w" sizes="(max-width: 512px) 100vw, 512px" />\r\n<figcaption>A 16ª Semana Nacional da Ciência e Tecnologia (SNCT), se encerra no estande do CINTESP.Br com a presença do Brigadeiro Maurício Ribeiro Gonçalves (Secretário SETAP/MCTIC), o Dino Ishikura (Diretor do Departamento de Tecnologias Estratégicas e de Produção /MCTIC), o Embaixador Mirim do CINTESP.Br Lucio Kendy, o Diretor Geral-CINTESP.Br Cleudmar A. Araújo e a Coordenadora Geral-CINTESP.Br Daniela Yoshida.</figcaption>\r\n</figure>\r\n</div>\r\n\r\n\r\n\r\n<div class="wp-block-image">\r\n<figure class="aligncenter is-resized"><img loading="lazy" decoding="async" class="wp-image-3459" src="https://cintespbr.org/wp-content/uploads/2020/02/IMAG-22-LUCIO-1024x693.jpg" alt="" width="512" height="347" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-22-LUCIO-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-22-LUCIO-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-22-LUCIO-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/IMAG-22-LUCIO.jpg 1649w" sizes="(max-width: 512px) 100vw, 512px" />\r\n<figcaption>A 16ª Semana Nacional da Ciência e Tecnologia (SNCT), se encerra no estande do CINTESP.Br com a presença do Ministro do MCTIC, Astronauta Marcos Pontes.</figcaption>\r\n</figure>\r\n</div>\r\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>A 16ª Semana Nacional de Ciência e Tecnologia (SNCT) é coordenada pelo Ministério da Ciência, Tecnologia, Inovações e Comunicações (MCTIC) e realizada nacionalmente desde 2004. Conta com a colaboração do setor público e privado, de fundações de apoio à pesquisa, de entidades e instituições de ensino, divulgação e pesquisa, além de secretarias estaduais e municipais,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3459,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [],
        class_list: [
            "post-3440",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3440",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3440",
                },
            ],
            "version-history": [
                {
                    count: 5,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3440/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5873,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3440/revisions/5873",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3459",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3440",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3440",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3440",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3379,
        date: "2020-01-20T16:25:42",
        date_gmt: "2020-01-20T19:25:42",
        guid: {
            rendered: "https://cintespbr.org/?p=3379",
        },
        modified: "2021-12-27T23:03:19",
        modified_gmt: "2021-12-28T02:03:19",
        slug: "cpb-estreita-relacoes-com-cintesp-e-funap-para-desenvolvimento-de-material-esportivo-de-baixo-custo",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cpb-estreita-relacoes-com-cintesp-e-funap-para-desenvolvimento-de-material-esportivo-de-baixo-custo/",
        title: {
            rendered:
                "CPB estreita relações com CINTESP e FUNAP para desenvolvimento de material esportivo de baixo custo",
        },
        content: {
            rendered:
                '\n<p><strong><em>Foto: Alê Cabral / CPB</em></strong></p>\n\n\n\n<p><strong><em>fonte: </em></strong><a href="https://www.cpb.org.br/noticia/detalhe/2775/cpb-estreita-relacoes-com-cintesp-e-funap-para-desenvolvimento-de-material-esportivo-de-baixo-custo"><strong><em>https://www.cpb.org.br/noticia/detalhe/2775/cpb-estreita-relacoes-com-cintesp-e-funap-para-desenvolvimento-de-material-esportivo-de-baixo-custo</em></strong></a></p>\n\n\n\n<p>Na manhã desta quinta-feira, 16, membros da Diretoria do Comitê Paralímpico Brasileiro (CPB), do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP) e da Fundação de Assistência ao Preso (FUNAP) se reuniram no Centro de Treinamento Paralímpico, em São Paulo, para planejar uma parceria entre as entidades.<br><br>A proposta é o desenvolvimento de tecnologias relacionadas ao esporte paralímpico pelo CINTESP.Br que possam ser produzidas pela FUNAP, que realiza a industrialização de produtos com a mão de obra da população carcerária do Estado de São Paulo que busca a remissão de pena por meio do trabalho.<br><br>A lista de equipamentos inclusos no projeto são calhas de bocha, bancos de arremesso (atletismo), triciclo (para petra) e cadeiras de rodas esportivas.</p>\n\n\n\n<p>“Nós estamos trabalhando na busca de tecnologias para serem utilizadas no esporte paralímpico de baixo custo e de boa tecnologia. Nós teremos a possibilidade de colocar nos nossos centros de referências e nos nossos centros de formações, tecnologias de baixo custo que poderão auxiliar na descoberta de novos talentos, na iniciação ao esporte paralímpico e até difundir a prática”, disse o diretor técnico do CPB, Alberto Martins.</p>\n\n\n\n<p><strong>Assessoria de Comunicação do Comitê Paralímpico Brasileiro (imp@cpb.org.br)</strong></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Foto: Alê Cabral / CPB fonte: https://www.cpb.org.br/noticia/detalhe/2775/cpb-estreita-relacoes-com-cintesp-e-funap-para-desenvolvimento-de-material-esportivo-de-baixo-custo Na manhã desta quinta-feira, 16, membros da Diretoria do Comitê Paralímpico Brasileiro (CPB), do Centro Brasileiro de Referência em Inovações Tecnológicas para Esportes Paralímpicos (CINTESP) e da Fundação de Assistência ao Preso (FUNAP) se reuniram no Centro de Treinamento Paralímpico, em São Paulo, para planejar uma parceria entre&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3380,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-3379",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3379",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3379",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3379/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3381,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3379/revisions/3381",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3380",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3379",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3379",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3379",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3382,
        date: "2020-01-19T16:30:16",
        date_gmt: "2020-01-19T19:30:16",
        guid: {
            rendered: "https://cintespbr.org/?p=3382",
        },
        modified: "2020-09-20T17:55:40",
        modified_gmt: "2020-09-20T20:55:40",
        slug: "iv-forum-do-dia-mundial-das-doencas-raras",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/iv-forum-do-dia-mundial-das-doencas-raras/",
        title: {
            rendered: "IV FÓRUM DO DIA MUNDIAL DAS DOENÇAS RARAS",
        },
        content: {
            rendered:
                '\r\n<figure class="wp-block-image alignfull"><img loading="lazy" decoding="async" width="1024" height="986" class="wp-image-3383" src="https://cintespbr.org/wp-content/uploads/2020/02/PHOTO-2020-01-31-09-58-50-1024x986.jpg" alt="" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2020/02/PHOTO-2020-01-31-09-58-50-1024x986.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/PHOTO-2020-01-31-09-58-50-300x289.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/PHOTO-2020-01-31-09-58-50-768x739.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2020/02/PHOTO-2020-01-31-09-58-50.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure>\r\n\r\n\r\n\r\n<p style="text-align: center;"><strong>INSCRIÇÕES</strong></p>\r\n\r\n\r\n\r\n<p style="text-align: center;"><a href="https://www.sympla.com.br/iv-forum-do-dia-mundial-das-doencas-raras__767859"><em><strong>https://www.sympla.com.br/iv-forum-do-dia-mundial-das-doencas-raras__767859</strong></em></a></p>\r\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>INSCRIÇÕES https://www.sympla.com.br/iv-forum-do-dia-mundial-das-doencas-raras__767859</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3383,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [],
        class_list: [
            "post-3382",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3382",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3382",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3382/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4089,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3382/revisions/4089",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3383",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3382",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3382",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3382",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3374,
        date: "2019-12-05T16:57:17",
        date_gmt: "2019-12-05T19:57:17",
        guid: {
            rendered: "https://cintespbr.org/?p=3374",
        },
        modified: "2021-12-27T23:03:19",
        modified_gmt: "2021-12-28T02:03:19",
        slug: "cpb-formaliza-acordo-de-cooperacao-tecnica-e-cientifica-em-forum-do-cintesp",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/cpb-formaliza-acordo-de-cooperacao-tecnica-e-cientifica-em-forum-do-cintesp/",
        title: {
            rendered:
                "CPB formaliza acordo de Cooperação Técnica e Científica em Fórum do CINTESP",
        },
        content: {
            rendered:
                '\n<p><strong><em>fonte</em></strong>: <a href="https://cpb.org.br/noticia/detalhe/2596/cpb-formaliza-acordo-de-cooperacao-tecnica-e-cientifica-em-forum-do-cintesp">https://cpb.org.br/noticia/detalhe/2596/cpb-formaliza-acordo-de-cooperacao-tecnica-e-cientifica-em-forum-do-cintesp</a> <br><strong><em>foto:</em></strong> Marcello Zambrana/MPIX/CPB</p>\n\n\n\n<p>Nesta segunda-feira, 30, o Comitê Paralímpico Brasileiro (CPB) formalizou um acordo de cooperação técnica científica com colaboração do Ministério da Ciência, Tecnologia, Inovações e Comunicações (MCTIC), da Fundação Uberlandense doTurismo, Esporte e Lazer (FUTEL) e do &nbsp;Centro de Inovações Tecnológicas em Esportes Paralímpicos (CINTESP).&nbsp;</p>\n\n\n\n<p>A formalização do acordo ocorreu durante o Fórum Nacional do CINTESP, órgão que possui a missão de estruturar cooperações técnicas para o desenvolvimento de atividades de extensão, pesquisas e inovações tecnológicas na área do Esporte Paralímpico. O objetivo do Fórum é conscientizar a sociedade sobre as barreiras que ainda precisam ser enfrentadas para que a pessoa com deficiência possa ser tratada com igualdade, no ambiente profissional ou social.</p>\n\n\n\n<p>O diretor técnico do CPB, Alberto Martins, discursou na mesa com tema &#8220;Pessoas com Deficiência, Atletas Paralímpicos e Tecnologias Assistivas&#8221;. Marcos Pontes, ministro do MCTIC e de Cleudmar Amaral de Araújo, Diretor Geral do CINTESP, estavam na mesa que deu abertura ao fórum.</p>\n\n\n\n<p>A criação de equipamentos e dispositivos inovadores são úteis não só para os atletas brasileiros, como para todas as pessoas com deficiência. &nbsp;A efetivação do CINTESP.Br, atuando em consonância com as necessidades do MCTIC, do CPB e da FUTEL contribuirá para que politicas acessíveis nesta linha proporcionem igualdades de condições para os atletas.&nbsp;</p>\n\n\n\n<p><strong>Assessoria de Comunicação do Comitê Paralímpico Brasileiro (imp@cpb.org.br)</strong></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>fonte: https://cpb.org.br/noticia/detalhe/2596/cpb-formaliza-acordo-de-cooperacao-tecnica-e-cientifica-em-forum-do-cintesp foto: Marcello Zambrana/MPIX/CPB Nesta segunda-feira, 30, o Comitê Paralímpico Brasileiro (CPB) formalizou um acordo de cooperação técnica científica com colaboração do Ministério da Ciência, Tecnologia, Inovações e Comunicações (MCTIC), da Fundação Uberlandense doTurismo, Esporte e Lazer (FUTEL) e do &nbsp;Centro de Inovações Tecnológicas em Esportes Paralímpicos (CINTESP).&nbsp; A formalização do acordo ocorreu durante&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3376,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-3374",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3374",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3374",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3374/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3377,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3374/revisions/3377",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3376",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3374",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3374",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3374",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3355,
        date: "2019-11-17T11:32:26",
        date_gmt: "2019-11-17T14:32:26",
        guid: {
            rendered: "https://cintespbr.org/?p=3355",
        },
        modified: "2021-12-28T17:32:35",
        modified_gmt: "2021-12-28T20:32:35",
        slug: "mctic-formaliza-cintesp-br-como-centro-de-referencia-em-tecnologias-assistivas",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/mctic-formaliza-cintesp-br-como-centro-de-referencia-em-tecnologias-assistivas/",
        title: {
            rendered:
                "MCTI formaliza Cintesp.Br como Centro de Referência em Tecnologias Assistivas",
        },
        content: {
            rendered:
                '\n<p>Chancela permite ao centro captar recursos junto ao ministério para atuar no desenvolvimento de produtos e tecnologias voltados principalmente aos atletas paralímpicos</p>\n\n\n\n<p>por<strong> ASCOM &#8211; publicado 12/11/2019 </strong><br><a href="http://www.mctic.gov.br/mctic/opencms/salaImprensa/noticias/arquivos/2019/11/MCTIC_formaliza_CintespBr_como_Centro_de_Referencia_em_Tecnologias_Assistivas.html"><em>http://www.mctic.gov.br</em></a></p>\n\n\n\n<p><strong>O Ministério da Ciência, Tecnologia, Inovações e Comunicações (MCTIC) formalizou no dia 6/11, em Brasília, o reconhecimento do Centro de Inovações Tecnológicas em Esportes Paralímpicos (Cintesp.Br), da Universidade Federal de Uberlândia (UFU), como o primeiro Centro Nacional de Referência em Inovações para o desporto paralímpico.</strong></p>\n\n\n\n<p>O Acordo de Cooperação Técnica e Científica permite a entidade captar recursos junto ao ministério e estabelecer novas parcerias para ampliar o trabalho que realiza desde 2012 no desenvolvimento de tecnologias assistivas, que ajudam pessoas com deficiência, principalmente voltadas ao esporte.</p>\n\n\n\n<p>O acordo começou a ser firmado em 30 de setembro, durante participação do ministro da Ciência, Tecnologia, Inovações e Comunicações, Marcos Pontes, no Fórum Nacional Cintesp.Br, em Uberlândia (MG). Nesta quinta-feira foi oficializada a assinatura do presidente do Comitê Paralímpico Brasileiro, Mizael Conrado, que se junta a UFU, Fundação Uberlandense do Turismo, Esporte e Lazer (Futel) e o Cintesp.Br como signatários do documento.</p>\n\n\n\n<p>O diretor do centro, Cleudmar Araújo, explica o trabalho desenvolvido pela entidade. “Temos mais de 40 tecnologias como equipamentos para treinamento muscular, avaliação do condicionamento físico, aparelhos para as modalidades paraolímpicas. São protótipos que na escala de maturidade ainda precisam ser otimizados e validados para chegar à escala da efetiva transferência de tecnologia para as pessoas. São pesquisas inovadoras que têm o cunho de resolver aquele problema mais diretamente a um custo adequado”, afirma.</p>\n\n\n\n<p>A diretora do Cintesp.Br Daniela Yoshida destaca a visibilidade que o MCTIC trouxe para o trabalho do centro. “Nós nascemos pela segunda vez. Até então nós não tínhamos a visibilidade que precisávamos para apresentar as tecnologias que desenvolvemos. Isso trouxe empresas para conhecer o que está sendo feito em Uberlândia em tecnologias assistivas, traz novos parceiros ao Cintesp e faz as pessoas reconhecerem que o Brasil tem um centro de desenvolvimento de tecnologias de nível internacional”, diz.</p>\n\n\n\n<p>O ministério também assinou um plano de trabalho para tecnologias assistivas. Entre as metas estão viabilizar uma rede nacional de pesquisa para o esporte paralímpico e identificar, qualificar e transferir tecnologias aplicadas a esse campo. Junto com suas entidades vinculadas, a pasta tem atuado no campo das tecnologias assistivas desde 2005. A coordenadora-geral de Tecnologias para Programas de Desenvolvimento Sustentável e Sociais, Sônia da Costa, destaca que o resultado são mais de 300 núcleos de pesquisa na área. “O nosso ministério passou a ser protagonista desde 2005, quando lançou chamada pela Finep. Desde então são 370 núcleos de pesquisa em tecnologias assistivas e uma série de teses e dissertações. Hoje, nosso desafio é viabilizar essas pesquisas como produto”, relata.</p>\n\n\n\n<ul class="wp-block-gallery columns-2 is-cropped wp-block-gallery-2 is-layout-flex wp-block-gallery-is-layout-flex"><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-3-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-3-1024x693.jpg" alt="" data-id="3354" data-link="https://cintespbr.org/photo-2019-11-16-23-56-07-3/" class="wp-image-3354" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-3-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-3-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-3-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-3.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-2-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-2-1024x693.jpg" alt="" data-id="3353" data-link="https://cintespbr.org/photo-2019-11-16-23-56-07-2/" class="wp-image-3353" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-2-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-2-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-2-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-2.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-1024x693.jpg" alt="" data-id="3352" data-link="https://cintespbr.org/photo-2019-11-16-23-56-07/" class="wp-image-3352" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-3-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-3-1024x693.jpg" alt="" data-id="3351" data-link="https://cintespbr.org/photo-2019-11-16-23-56-06-3/" class="wp-image-3351" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-3-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-3-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-3-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-3.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-2-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-2-1024x693.jpg" alt="" data-id="3350" data-link="https://cintespbr.org/photo-2019-11-16-23-56-06-2/" class="wp-image-3350" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-2-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-2-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-2-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-2.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-2-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-2-1024x693.jpg" alt="" data-id="3345" data-link="https://cintespbr.org/photo-2019-11-16-23-56-09-2/" class="wp-image-3345" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-2-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-2-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-2-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-2.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-3-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-3-1024x693.jpg" alt="" data-id="3346" data-link="https://cintespbr.org/photo-2019-11-16-23-56-09-3/" class="wp-image-3346" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-3-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-3-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-3-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-3.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-2-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-2-1024x693.jpg" alt="" data-id="3347" data-link="https://cintespbr.org/photo-2019-11-16-23-56-11-2/" class="wp-image-3347" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-2-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-2-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-2-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-2.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-13-2-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-13-2-1024x693.jpg" alt="" data-id="3348" data-link="https://cintespbr.org/photo-2019-11-16-23-56-13-2/" class="wp-image-3348" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-13-2-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-13-2-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-13-2-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-13-2.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-1024x693.jpg" alt="" data-id="3349" data-link="https://cintespbr.org/photo-2019-11-16-23-56-06/" class="wp-image-3349" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-06.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-1024x693.jpg" alt="" data-id="3344" data-link="https://cintespbr.org/photo-2019-11-16-23-56-09/" class="wp-image-3344" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-4-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-4-1024x693.jpg" alt="" data-id="3343" data-link="https://cintespbr.org/photo-2019-11-16-23-56-08-4/" class="wp-image-3343" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-4-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-4-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-4-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-4.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-3-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-3-1024x693.jpg" alt="" data-id="3342" data-link="https://cintespbr.org/photo-2019-11-16-23-56-08-3/" class="wp-image-3342" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-3-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-3-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-3-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-3.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-2-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-2-1024x693.jpg" alt="" data-id="3341" data-link="https://cintespbr.org/photo-2019-11-16-23-56-08-2/" class="wp-image-3341" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-2-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-2-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-2-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-2.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-1024x693.jpg" alt="" data-id="3340" data-link="https://cintespbr.org/photo-2019-11-16-23-56-08/" class="wp-image-3340" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-08.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-5-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-5-1024x693.jpg" alt="" data-id="3335" data-link="https://cintespbr.org/photo-2019-11-16-23-56-10-5/" class="wp-image-3335" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-5-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-5-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-5-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-5.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-5-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-5-1024x693.jpg" alt="" data-id="3336" data-link="https://cintespbr.org/photo-2019-11-16-23-56-12-5/" class="wp-image-3336" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-5-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-5-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-5-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-5.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-1024x693.jpg" alt="" data-id="3337" data-link="https://cintespbr.org/photo-2019-11-16-23-56-11/" class="wp-image-3337" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-13-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-13-1024x693.jpg" alt="" data-id="3338" data-link="https://cintespbr.org/photo-2019-11-16-23-56-13/" class="wp-image-3338" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-13-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-13-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-13-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-13.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-4-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-4-1024x693.jpg" alt="" data-id="3339" data-link="https://cintespbr.org/photo-2019-11-16-23-56-07-4/" class="wp-image-3339" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-4-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-4-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-4-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-07-4.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-4-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-4-1024x693.jpg" alt="" data-id="3334" data-link="https://cintespbr.org/photo-2019-11-16-23-56-12-4/" class="wp-image-3334" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-4-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-4-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-4-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-4.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-4-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-4-1024x693.jpg" alt="" data-id="3333" data-link="https://cintespbr.org/photo-2019-11-16-23-56-10-4/" class="wp-image-3333" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-4-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-4-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-4-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-4.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-3-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-3-1024x693.jpg" alt="" data-id="3332" data-link="https://cintespbr.org/photo-2019-11-16-23-56-10-3/" class="wp-image-3332" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-3-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-3-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-3-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-3.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-3-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-3-1024x693.jpg" alt="" data-id="3331" data-link="https://cintespbr.org/photo-2019-11-16-23-56-12-3/" class="wp-image-3331" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-3-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-3-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-3-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-3.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-2-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-2-1024x693.jpg" alt="" data-id="3330" data-link="https://cintespbr.org/photo-2019-11-16-23-56-10-2/" class="wp-image-3330" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-2-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-2-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-2-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-2.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-1024x693.jpg" alt="" data-id="3329" data-link="https://cintespbr.org/photo-2019-11-16-23-56-10/" class="wp-image-3329" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-10.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-4-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-4-1024x693.jpg" alt="" data-id="3328" data-link="https://cintespbr.org/photo-2019-11-16-23-56-09-4/" class="wp-image-3328" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-4-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-4-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-4-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-09-4.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-2-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-2-1024x693.jpg" alt="" data-id="3327" data-link="https://cintespbr.org/photo-2019-11-16-23-56-12-2/" class="wp-image-3327" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-2-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-2-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-2-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-2.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-1024x693.jpg" alt="" data-id="3326" data-link="https://cintespbr.org/photo-2019-11-16-23-56-12/" class="wp-image-3326" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-12.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li><li class="blocks-gallery-item"><figure><a href="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-3-1024x693.jpg"><img loading="lazy" decoding="async" width="1024" height="693" src="https://cintespbr.org/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-3-1024x693.jpg" alt="" data-id="3325" data-link="https://cintespbr.org/photo-2019-11-16-23-56-11-3/" class="wp-image-3325" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-3-1024x693.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-3-300x203.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-3-768x520.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/11/PHOTO-2019-11-16-23-56-11-3.jpg 1280w" sizes="(max-width: 1024px) 100vw, 1024px" /></a></figure></li></ul>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Chancela permite ao centro captar recursos junto ao ministério para atuar no desenvolvimento de produtos e tecnologias voltados principalmente aos atletas paralímpicos por ASCOM &#8211; publicado 12/11/2019 http://www.mctic.gov.br O Ministério da Ciência, Tecnologia, Inovações e Comunicações (MCTIC) formalizou no dia 6/11, em Brasília, o reconhecimento do Centro de Inovações Tecnológicas em Esportes Paralímpicos (Cintesp.Br), da&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3331,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 43],
        tags: [35],
        class_list: [
            "post-3355",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-mcti",
            "tag-cintespbr",
            "category-47",
            "category-43",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3355",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3355",
                },
            ],
            "version-history": [
                {
                    count: 4,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3355/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 7413,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3355/revisions/7413",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3331",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3355",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3355",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3355",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3310,
        date: "2019-10-24T15:29:14",
        date_gmt: "2019-10-24T18:29:14",
        guid: {
            rendered: "https://cintespbr.org/?p=3310",
        },
        modified: "2020-09-20T11:39:57",
        modified_gmt: "2020-09-20T14:39:57",
        slug: "i-forum-surdocegueira",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/i-forum-surdocegueira/",
        title: {
            rendered: "I Fórum Surdocegueira",
        },
        content: {
            rendered:
                '\n<h4 class="wp-block-heading"><strong>I Fórum sobre Surdocegueira em Uberlândia : Reconhecimento enquanto condição única. Conscientizar para incluir. </strong><br>Data: 09 de Novembro  <br>Horário: 08h30 as 18h <br>Local: Câmara Municipal de Uberlândia </h4>\n\n\n\n<div style="height:20px" aria-hidden="true" class="wp-block-spacer"></div>\n\n\n\n<div class="wp-block-button aligncenter is-style-default"><a class="wp-block-button__link" href="INSCRIÇÕhttps://docs.google.com/forms/d/1XKHLcxs4GBJMhYIK2537PKGvOtA-KcKCgAuP8Ouu7ik/viewform?edit_requested=trueES"><strong>INSCRIÇÕES</strong></a></div>\n\n\n\n<div style="height:20px" aria-hidden="true" class="wp-block-spacer"></div>\n\n\n\n<p></p>\n\n\n\n<p>O evento é alusivo ao “21 de Setembro Dia Nacional de Luta das Pessoas com Deficiência” e ao “ Dia 26 de Setembro, Dia Nacional do Surdo”.</p>\n\n\n\n<p>O objetivo do Fórum é conscientizar a sociedade para as barreiras que ainda precisam ser enfrentadas para que a pessoa com deficiência possa ser tratada com igualdade, seja no ambiente profissional ou nos momentos de lazer e esporte.</p>\n\n\n\n<p>O Projeto de Lei Ordinária &#8211; 00607/2019 &#8211; np – Projeto de Lei 898/2019, de autoria da vereadora Flávia Carvalho, que institui o Dia Branco e Vermelho &#8211; Dia da Conscientização Sobre a Surdocegueira no Município de Uberlândia, é uma forma de garantir a integralização das pessoas que tem Surdocegueira na sociedade de maneira igualitária e sem preconceitos. Assim sendo, é reconhecido como um grande marco na luta das pessoas com deficiência. </p>\n\n\n\n<p>O <strong>I Fórum Surdocegueira</strong> evidencia as necessidades, reivindicações e lutas enfrentadas pelos Surdocegos.</p>\n\n\n\n<p>No evento serão apresentadas, Palestrantes de conscientização e informações sobre a Surdocegueira.<br>Serão convidadas pessoas e associações que tem interesse comum no tema e autoridades envolvidas com o tema.</p>\n\n\n\n<p><strong>“Andar com um amigo na escuridão é melhor do que andar sozinho na luz”</strong><br><em>Helen Keller</em></p>\n\n\n\n<p>No dia 27 de junho, é comemorado o Dia internacional das pessoas surdocegas. A data foi escolhida por marcar o nascimento da escritora norte-americana Hellen Keller, primeira pessoa surdocega a conquistar um bacharelado no início do século XX.</p>\n\n\n\n<figure class="wp-block-image alignwide"><a href="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-24-11-23-35-1.jpg"><img loading="lazy" decoding="async" width="1280" height="927" src="https://cintespbr.org/wp-content/uploads/2019/10/PHOTO-2019-10-24-11-23-35-1.jpg" alt="" class="wp-image-3320" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-24-11-23-35-1.jpg 1280w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-24-11-23-35-1-300x217.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-24-11-23-35-1-768x556.jpg 768w, https://cintespbr.institucional.ws/wp-content/uploads/2019/10/PHOTO-2019-10-24-11-23-35-1-1024x742.jpg 1024w" sizes="(max-width: 1280px) 100vw, 1280px" /></a><figcaption>Folder com a programação do evento, clique para aumentar a imagem.</figcaption></figure>\n\n\n\n<p></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>I Fórum sobre Surdocegueira em Uberlândia : Reconhecimento enquanto condição única. Conscientizar para incluir. Data: 09 de Novembro Horário: 08h30 as 18h Local: Câmara Municipal de Uberlândia O evento é alusivo ao “21 de Setembro Dia Nacional de Luta das Pessoas com Deficiência” e ao “ Dia 26 de Setembro, Dia Nacional do Surdo”. O&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3311,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [],
        class_list: [
            "post-3310",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3310",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3310",
                },
            ],
            "version-history": [
                {
                    count: 10,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3310/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3322,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3310/revisions/3322",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3311",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3310",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3310",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3310",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 4071,
        date: "2019-09-20T12:32:07",
        date_gmt: "2019-09-20T15:32:07",
        guid: {
            rendered: "https://cintespbr.org/?p=4071",
        },
        modified: "2021-12-28T17:32:45",
        modified_gmt: "2021-12-28T20:32:45",
        slug: "mcti-no-forum-nacional-cintesp-br",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/mcti-no-forum-nacional-cintesp-br/",
        title: {
            rendered: "MCTI NO FÓRUM NACIONAL CINTESP.BR",
        },
        content: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://youtu.be/y7OugIW28mI&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>[vc_row][vc_column][vc_video link=&#8221;https://youtu.be/y7OugIW28mI&#8221;][/vc_column][/vc_row]</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3091,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [43],
        tags: [48, 49, 30, 33],
        class_list: [
            "post-4071",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-mcti",
            "tag-ciencia-mcti-biologia-aprender-estudar",
            "tag-edital-tecnologia-assistiva-tecnologia",
            "tag-evento",
            "tag-jogos-pan-americanos-lima-2019",
            "category-43",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4071",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=4071",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4071/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 4072,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/4071/revisions/4072",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3091",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=4071",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=4071",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=4071",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 3008,
        date: "2019-09-16T17:30:02",
        date_gmt: "2019-09-16T20:30:02",
        guid: {
            rendered: "https://cintespbr.org/?p=3008",
        },
        modified: "2020-09-20T11:41:20",
        modified_gmt: "2020-09-20T14:41:20",
        slug: "xxii-comemoracao-municipal-da-semana-nacional-da-pessoa-com-deficiencia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/xxii-comemoracao-municipal-da-semana-nacional-da-pessoa-com-deficiencia/",
        title: {
            rendered:
                "XXII Comemoração Municipal da Semana Nacional da Pessoa com Deficiência",
        },
        content: {
            rendered:
                "<h3>inscrições: https://www.sympla.com.br/zeizadojo</h3>\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>inscrições: https://www.sympla.com.br/zeizadojo</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 3009,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [],
        class_list: [
            "post-3008",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3008",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=3008",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3008/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3011,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/3008/revisions/3011",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/3009",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=3008",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=3008",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=3008",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 2886,
        date: "2019-09-15T09:47:22",
        date_gmt: "2019-09-15T12:47:22",
        guid: {
            rendered: "https://cintespbr.org/?p=2886",
        },
        modified: "2021-05-15T23:51:25",
        modified_gmt: "2021-05-16T02:51:25",
        slug: "homenagem",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/homenagem/",
        title: {
            rendered: "Homenagem",
        },
        content: {
            rendered:
                "\r\n<p>Coordenadora Geral do CINTESP.BR Daniela Moura Yoshida será a homenageada Ver. Dr<sup>a </sup>Flavia Carvalho, na Comenda conferida às pessoas e institui­ções que, pelos seus trabalhos, estudos, contribuição, de­sempenho e por sua dedicação no interesse do Município de Uberlândia, no âmbito do Paradesporto, tenham se tornado merecedoras desta distinção.</p>\r\n\r\n\r\n\r\n<p>Data 23/09/2019, no Plenário Homero Santos as 19H.</p>\r\n",
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>Coordenadora Geral do CINTESP.BR Daniela Moura Yoshida será a homenageada Ver. Dra Flavia Carvalho, na Comenda conferida às pessoas e institui­ções que, pelos seus trabalhos, estudos, contribuição, de­sempenho e por sua dedicação no interesse do Município de Uberlândia, no âmbito do Paradesporto, tenham se tornado merecedoras desta distinção. Data 23/09/2019, no Plenário Homero Santos as&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 2887,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [1],
        tags: [],
        class_list: [
            "post-2886",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-uncategorized",
            "category-1",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2886",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=2886",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2886/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 5876,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2886/revisions/5876",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/2887",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=2886",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=2886",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=2886",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 2883,
        date: "2019-09-15T09:43:56",
        date_gmt: "2019-09-15T12:43:56",
        guid: {
            rendered: "https://cintespbr.org/?p=2883",
        },
        modified: "2020-09-20T11:41:50",
        modified_gmt: "2020-09-20T14:41:50",
        slug: "uberlandia-promove-campanha-de-apoio-a-luta-da-pessoa-com-deficiencia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/uberlandia-promove-campanha-de-apoio-a-luta-da-pessoa-com-deficiencia/",
        title: {
            rendered:
                "UBERLÂNDIA PROMOVE CAMPANHA DE APOIO À LUTA DA PESSOA COM DEFICIÊNCIA",
        },
        content: {
            rendered:
                '\n<p>A Campanha de Conscientização dos direitos e luta das pessoas\ncom deficiência acontecerá na Praça Tubal Vilela. A mobilização social abrirá\nas atividades previstas pela Lei Municipal 13.186/2019, de autoria da vereadora\nFlávia Carvalho, pelo dia de Luta das Pessoas com Deficiência. </p>\n\n\n\n<p>O objetivo da Campanha é promover a informação e a difusão\ndos direitos já adquiridos, conscientizar as famílias, a sociedade e o\nMunicípio sobre a inclusão social das pessoas com deficiência e estimular para\nboas práticas na rotina das pessoas. A percepção das diferenças fortalece as\niniciativas diárias de respeito ao próximo. Apenas 2% das vagas para\nestacionamento são reservadas, por Lei Federal, para as pessoas com\ndeficiência. </p>\n\n\n\n<p>A ação envolverá as instituições de referência na cidade e\norganizações de apoio às pessoas com deficiência.</p>\n\n\n\n<p>Já confirmaram presença, o Conselho Municipal de Pessoas com\nDeficiência (COMPOD), APARU, AACD, APAE, ABSW, AACD, Instituto Viva Iris,\nempresa Ergon Líder, Projeto Angel Hair, Classe A Clínica Odontológica,\nvereadora Dra. Flávia Carvalho (autora da Lei que instituiu o Dia Municipal de\nConscientização de Luta da Pessoa com Deficiência.</p>\n\n\n\n<p>Dentro da Campanha será lançado em Uberlândia o Programa\nMulta Moral é Legal, que fará parte do calendário oficial do Município.</p>\n\n\n\n<p>O Programa Multa Moral já vem sendo usado em várias cidades\nbrasileiras como Curitiba, Vila Velha e Porto Alegre como forma de\nconscientizar os motoristas e ser mais uma busca de garantia de acesso ao\ndireito adquirido de uma parcela da população – ter vaga especial reservada\npara pessoas com deficiência.</p>\n\n\n\n<p>Nas vias públicas já temos a garantia de aplicação de multas\nprevistas em lei, pelo uso irregular das vagas especiais. Porém, o mesmo não se\naplica às vagas dentro de estabelecimentos privados, onde é constante a\nreclamação por parte de quem tem o direito impedido.</p>\n\n\n\n<p>O programa Multa Moral tem como principal objetivo\nestabelecer, por meio da educação, uma forma de promover a consciência criativa\ne educação de motoristas. </p>\n\n\n\n<p>Trata se de ações que poderão serem feitas por meio de\ndistribuição de blocos da Multa Moral às instituições de apoio e proteção às\npessoas com deficiência. Em caso de uso indevido da vaga especial, o motorista\ninfrator, receberá a informação que recebeu a Multa Moral promovendo a reflexão\nsobre a consequência na rotina de quem tem direito impedido de usar a vaga\nespecial para pessoa com deficiência.</p>\n\n\n\n<p>Em nossa cidade já temos o Projeto de Lei para implementação\nda Multa Moral, ato que já vem sido reiterado pelo STF como necessidade de\nremodelar atribuições administrativas a serem implantadas pelos municípios.</p>\n\n\n\n<p>Vaga especial&nbsp;é um&nbsp;direito&nbsp;adquirido –\nRespeite o direito do outro.</p>\n\n\n\n<p>Participe desse evento!</p>\n\n\n\n<h3 class="wp-block-heading"><strong>O evento acontecerá na sexta-feira dia 20 de setembro, às 7h30, na Praça Tubal Vilela pela avenida Afonso Pena.</strong></h3>\n\n\n\n<p><strong>Contato: Cristiane de Paula</strong></p>\n\n\n\n<p><strong>34 9 8821 43 49</strong></p>\n\n\n\n<p><a href="mailto:crispaulamg@gamil.com">crispaulamg@gamil.com</a></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>A Campanha de Conscientização dos direitos e luta das pessoas com deficiência acontecerá na Praça Tubal Vilela. A mobilização social abrirá as atividades previstas pela Lei Municipal 13.186/2019, de autoria da vereadora Flávia Carvalho, pelo dia de Luta das Pessoas com Deficiência. O objetivo da Campanha é promover a informação e a difusão dos direitos&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 2884,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [],
        class_list: [
            "post-2883",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2883",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=2883",
                },
            ],
            "version-history": [
                {
                    count: 1,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2883/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 2885,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2883/revisions/2885",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/2884",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=2883",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=2883",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=2883",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 2873,
        date: "2019-09-02T09:12:05",
        date_gmt: "2019-09-02T12:12:05",
        guid: {
            rendered: "https://cintespbr.org/?p=2873",
        },
        modified: "2021-12-27T23:07:07",
        modified_gmt: "2021-12-28T02:07:07",
        slug: "brasil-encerra-jogos-pan-americanos-lima-2019-com-melhor-participacao-da-historia",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/brasil-encerra-jogos-pan-americanos-lima-2019-com-melhor-participacao-da-historia/",
        title: {
            rendered:
                "Brasil encerra Jogos Pan-Americanos Lima 2019 com melhor participação da história",
        },
        content: {
            rendered:
                '\n<h2 class="wp-block-heading">O <em>Brasil ficou em 1º lugar com 308 medalhas&nbsp; </em></h2>\n\n\n\n<p><strong>O paratleta da equipe Aparu/Futel.</strong></p>\n\n\n\n<p>Paratletas de associações\nparceiras da Fundação Uberlandense do Turismo, Esporte e Lazer &#8211; FUTEL\nencerraram sua participação nos jogos Parapan-Americanos de Lima/2019 com a conquista de dez medalhas, sendo\ntrês de ouro, três de prata e quatro de bronze. A competição foi disputada em\nLima, no Peru, entre os dias 23 de agosto e 1° de setembro.</p>\n\n\n\n<h4 class="wp-block-heading"><strong>QUADRO DE MEDALHAS DO PAN-AMERICANO DA CIDADE DE UBERLÂNDIA</strong></h4>\n\n\n\n<h3 class="wp-block-heading"><strong>OURO:</strong></h3>\n\n\n\n<table class="wp-block-table"><tbody><tr><td>\n  Mauro Evaristo de Sousa &#8211; APARU/FUTEL\n  </td><td>\n  Arremesso do peso F63\n  </td></tr><tr><td>\n  Rodrigo Parreira &#8211; APARU/FUTEL\n  </td><td>\n  Salto em distância\n  </td></tr><tr><td>\n  Mateus Carvalho (Oscar Carvalho)\n  </td><td>\n  Bocha por equipe\n  </td></tr><tr><td>\n  Vanilton Nascimento Filho &#8211; Praia\n  Clube\n  </td><td>\n  Revezamento 4 x 100 medley\n  </td></tr><tr><td>\n  Vanilton\n  Nascimento Filho &#8211; Praia Clube\n  </td><td>\n  Revezamento 4 x 100 livre\n  </td></tr><tr><td>\n  Vanilton\n  Nascimento Filho &#8211; Praia Clube\n  </td><td>\n  100 metros borboleta\n  </td></tr><tr><td>\n  Laila\n  Garcia &#8211; Praia Clube\n  </td><td>\n  100 metros peito\n  </td></tr><tr><td>\n  Laila\n  Garcia &#8211; Praia Clube\n  </td><td>\n  200 metros medley\n  </td></tr><tr><td>\n  João Menezes\n  </td><td>\n  Tênis de quadra \n  </td></tr></tbody></table>\n\n\n\n<h4 class="wp-block-heading"><strong>PRATA:</strong></h4>\n\n\n\n<table class="wp-block-table"><tbody><tr><td>\n  Rodrigo Parreira &#8211; APARU/FUTEL\n  </td><td>\n  100 metros rasos\n  </td></tr><tr><td>\n  Lara Ferreira &#8211; CDDU/FUTEL\n  </td><td>\n  Categoria até 41 kg do halterofilismo\n  </td></tr><tr><td>\n  Luciano Dantas &#8211; CDDU/FUTEL\n  </td><td>\n  Categoria de até 59 kg do\n  halterofilismo\n  </td></tr><tr><td>\n  Mateus Carvalho\n  </td><td>\n  Bocha por equipe\n  </td></tr><tr><td>\n  Vanilton Nascimento Filho &#8211; Praia\n  Clube\n  </td><td>\n  100 metros livre\n  </td></tr><tr><td>\n  Laila\n  Garcia &#8211; Praia Clube\n  </td><td>\n  Revezamento 4 x 100 medley\n  </td></tr><tr><td>\n  Laila\n  Garcia &#8211; Praia Clube\n  </td><td>\n  50 metros livre\n  </td></tr><tr><td>\n  Laila Garcia &#8211; Praia Clube\n  </td><td>\n  100 metros livre\n  </td></tr><tr><td>\n  Guilherme\n  Batista Silva &#8211; Praia Clube\n  </td><td>\n  100 metros peito\n  </td></tr><tr><td>\n  Guilherme\n  Batista Silva &#8211; Praia Clube\n  </td><td>\n  400 metros livre\n  </td></tr></tbody></table>\n\n\n\n<h4 class="wp-block-heading"><strong>BRONZE:</strong></h4>\n\n\n\n<table class="wp-block-table"><tbody><tr><td>\n  Luciano\n  Dantas &#8211; CDDU/FUTEL\n  </td><td>\n  Categoria de até 59 kg do\n  halterofilismo\n  </td></tr><tr><td>\n  Amanda\n  Sousa &#8211; CDDU/FUTEL\n  </td><td>\n  Categoria até 73 kg do halterofilismo\n  </td></tr><tr><td>\n  Rodrigo\n  Marques CDDU/FUTEL\n  </td><td>\n  Categoria combinada de 88 kg e 97 kg\n  do halterofilismo\n  </td></tr><tr><td>\n  Mateus\n  Silva CDDU/FUTEL\n  </td><td>\n  Categoria 107 kg do halterofilismo\n  </td></tr><tr><td>\n  Mateus\n  Carvalho\n  </td><td>\n  Bocha individual\n  </td></tr><tr><td>\n  Vanilton\n  Nascimento Filho &#8211; Praia Clube\n  </td><td>\n  400 metros livre\n  </td></tr><tr><td>\n  Vanilton\n  Nascimento Filho &#8211; Praia Clube\n  </td><td>\n  50 metros livre\n  </td></tr><tr><td>\n  Laila\n  Garcia &#8211; Praia Clube\n  </td><td>\n  400 metros livre\n  </td></tr><tr><td>\n  Laila\n  Garcia &#8211; Praia Clube\n  </td><td>\n  Revezamento 4 x 100 livre\n  </td></tr><tr><td>\n  Guilherme\n  Batista Silva &#8211; Praia Clube\n  </td><td>\n  50 metros livre\n  </td></tr><tr><td>\n  Guilherme\n  Batista Silva &#8211; Praia Clube\n  </td><td>\n  200 metros medley\n  </td></tr></tbody></table>\n\n\n\n<p>Com isso, somando CDDU/FUTEL,\nAPARU/FUTEL e Praia Clube, Uberlândia faturou um total de 28 medalhas, o que\ncorresponde a 8,77% das medalhas conquistadas pelo Brasil nos jogos\nParapan-Americanos de Lima/2019.</p>\n\n\n\n<p><strong>Foto:</strong> Wander Roberto</p>\n\n\n\n<p><a href="https://educadora909.com.br/noticias/esporte/brasil-encerra-jogos-pan-americanos-com-melhor-participacao-da-historia/">https://educadora909.com.br/noticias/esporte/brasil-encerra-jogos-pan-americanos-com-melhor-participacao-da-historia/</a></p>\n\n\n\n<h4 class="wp-block-heading">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nPARA\nOS JOGOS DO PAN-AMERICANO 16 UBERLANDENSES FORAM CONVOCADOS PARA LIMA\n\n\n\n</h4>\n\n\n\n<div class="wp-block-image"><figure class="aligncenter"><img loading="lazy" decoding="async" width="800" height="560" src="https://cintespbr.org/wp-content/uploads/2019/09/image005.jpg" alt="" class="wp-image-2893" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/09/image005.jpg 800w, https://cintespbr.institucional.ws/wp-content/uploads/2019/09/image005-300x210.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/09/image005-768x538.jpg 768w" sizes="(max-width: 800px) 100vw, 800px" /></figure></div>\n\n\n\n<p style="text-align:center">Parte da equipe Paralímpica de\nUberlândia | Foto: Divulgação </p>\n\n\n\n<p style="text-align:center"><a href="https://diariodeuberlandia.com.br/noticia/21908/16-uberlandenses-sao-convocados-para-lima">https://diariodeuberlandia.com.br/noticia/21908/16-uberlandenses-sao-convocados-para-lima</a></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O Brasil ficou em 1º lugar com 308 medalhas&nbsp; O paratleta da equipe Aparu/Futel. Paratletas de associações parceiras da Fundação Uberlandense do Turismo, Esporte e Lazer &#8211; FUTEL encerraram sua participação nos jogos Parapan-Americanos de Lima/2019 com a conquista de dez medalhas, sendo três de ouro, três de prata e quatro de bronze. A competição&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 2874,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [33],
        class_list: [
            "post-2873",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "tag-jogos-pan-americanos-lima-2019",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2873",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=2873",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2873/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 2894,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2873/revisions/2894",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/2874",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=2873",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=2873",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=2873",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 2889,
        date: "2019-08-25T09:50:34",
        date_gmt: "2019-08-25T12:50:34",
        guid: {
            rendered: "https://cintespbr.org/?p=2889",
        },
        modified: "2021-12-27T23:07:07",
        modified_gmt: "2021-12-28T02:07:07",
        slug: "tenista-uberabense-e-ouro-no-pan-americano",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/tenista-uberabense-e-ouro-no-pan-americano/",
        title: {
            rendered: "TENISTA UBERABENSE É OURO NO PAN-AMERICANO",
        },
        content: {
            rendered:
                '\n<p><strong><em>fonte</em></strong><em>: </em><a href="https://diariodeuberlandia.com.br/noticia/22186/tenista-uberabense-e-ouro-no-pan-americano"><em>https://diariodeuberlandia.com.br/noticia/22186/tenista-uberabense-e-ouro-no-pan-americano</em></a></p>\n\n\n\n<p><em>Jogos Pan-Americanos | Foto:\nDivulgação/Lima 2019</em>\n\nJoão Menezes, Tenista Uberlandense, de 22 anos, sagrou-se\ncampeão Pan-Americano de tênis. Na disputa contra o chileno Tomás Barrios que\naconteceu, nas quadras de Lima, no Peru. Com o título conquistado no país\nandino, o mineiro automaticamente está classificado para disputa dos Jogos\nOlímpicos de Tóquio 2020. &nbsp;\n\n\n\n</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>fonte: https://diariodeuberlandia.com.br/noticia/22186/tenista-uberabense-e-ouro-no-pan-americano Jogos Pan-Americanos | Foto: Divulgação/Lima 2019 João Menezes, Tenista Uberlandense, de 22 anos, sagrou-se campeão Pan-Americano de tênis. Na disputa contra o chileno Tomás Barrios que aconteceu, nas quadras de Lima, no Peru. Com o título conquistado no país andino, o mineiro automaticamente está classificado para disputa dos Jogos Olímpicos de Tóquio 2020.&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 2890,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-2889",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2889",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=2889",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2889/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3005,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2889/revisions/3005",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/2890",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=2889",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=2889",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=2889",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 2794,
        date: "2019-08-21T10:26:49",
        date_gmt: "2019-08-21T13:26:49",
        guid: {
            rendered: "https://cintespbr.org/?p=2794",
        },
        modified: "2020-09-20T11:42:32",
        modified_gmt: "2020-09-20T14:42:32",
        slug: "surdocegueira-uma-deficiencia-unica-difundindo-novos-conhecimentos-e-novas-perspectivas-para-a-inclusao",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/surdocegueira-uma-deficiencia-unica-difundindo-novos-conhecimentos-e-novas-perspectivas-para-a-inclusao/",
        title: {
            rendered:
                "Surdocegueira: uma deficiência única – difundindo novos conhecimentos e novas perspectivas para a inclusão",
        },
        content: {
            rendered:
                '\n<blockquote class="wp-block-quote is-style-large is-layout-flow wp-block-quote-is-layout-flow"><p><strong>O CINTESP.Br está prestigiando o evento da SURDOCEGUEIRA, com o objetivo de promover a consientização sobre a importancia do desenvolvimento de novas tecnologias assistivas para o esporte e lazer, como meio de inclusão das pessoas com deficiência.</strong></p></blockquote>\n\n\n\n<p>No dia&nbsp;<strong>13 de setembro de 2019, de 8h as 20h</strong>, acontecerá no&nbsp;<strong>AUDITÓRIO 5R C e D</strong>, no Campus Santa Mônica, na Universidade Federal de Uberlândia o evento <strong>“</strong><em><strong>Surdocegueira: uma deficiência única – difundindo novos conhecimentos e novas perspectivas para a inclusão</strong></em><strong>“</strong>, que será&nbsp;voltado às pessoas com surdocegueira, a seus familiares, a profissionais de diferentes áreas sociais, educacionais e da saúde, bem como a qualquer cidadão e/ou profissional interessado nas questões que envolvem a surdocegueira, visando proporcionar e desenvolver conhecimentos relacionadas à temática.</p>\n\n\n\n<p>Neste evento, além de problematizarmos as questões metodológicas de ensino também possibilitaremos momentos de convivência e de interação entre as pessoas surdocegas, bem como entre os surdocegos e os demais participantes criando oportunidade de vínculos e intercâmbios de experiências.</p>\n\n\n\n<h4 class="wp-block-heading" style="text-align:center">Inscrição&nbsp;gratuita no link:&nbsp;<a href="https://forms.gle/RR2NyHqnhJPwShB26">https://forms.gle/RR2NyHqnhJPwShB26</a></h4>\n\n\n\n<h2 class="wp-block-heading" style="text-align:center">CRONOGRAMA</h2>\n\n\n\n<figure class="wp-block-image alignfull"><img loading="lazy" decoding="async" width="720" height="1280" src="https://cintespbr.org/wp-content/uploads/2019/08/CRONOGRAMA1.png" alt="" class="wp-image-2795" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/08/CRONOGRAMA1.png 720w, https://cintespbr.institucional.ws/wp-content/uploads/2019/08/CRONOGRAMA1-169x300.png 169w, https://cintespbr.institucional.ws/wp-content/uploads/2019/08/CRONOGRAMA1-576x1024.png 576w" sizes="(max-width: 720px) 100vw, 720px" /><figcaption>fonte: <a href="http://www.ileel.ufu.br/lpdl/?p=14778">http://www.ileel.ufu.br/lpdl/?p=14778</a></figcaption></figure>\n\n\n\n<p></p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>O CINTESP.Br está prestigiando o evento da SURDOCEGUEIRA, com o objetivo de promover a consientização sobre a importancia do desenvolvimento de novas tecnologias assistivas para o esporte e lazer, como meio de inclusão das pessoas com deficiência. No dia&nbsp;13 de setembro de 2019, de 8h as 20h, acontecerá no&nbsp;AUDITÓRIO 5R C e D, no Campus&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 2796,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [46],
        tags: [30],
        class_list: [
            "post-2794",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-ultimas-noticias",
            "tag-evento",
            "category-46",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2794",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=2794",
                },
            ],
            "version-history": [
                {
                    count: 6,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2794/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3007,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2794/revisions/3007",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/2796",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=2794",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=2794",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=2794",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 2473,
        date: "2019-07-17T16:04:13",
        date_gmt: "2019-07-17T19:04:13",
        guid: {
            rendered: "https://cintespbr.org/?p=2473",
        },
        modified: "2021-12-27T23:03:20",
        modified_gmt: "2021-12-28T02:03:20",
        slug: "ufu-e-comite-paralimpico-brasileiro-firmam-acordo-de-cooperacao-tecnica",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/ufu-e-comite-paralimpico-brasileiro-firmam-acordo-de-cooperacao-tecnica/",
        title: {
            rendered:
                "UFU e Comitê Paralímpico Brasileiro firmam acordo de cooperação técnica",
        },
        content: {
            rendered:
                '\n<div style="height:40px" aria-hidden="true" class="wp-block-spacer"></div>\n\n\n\n<h3 class="wp-block-heading">UFU e Comitê Paralímpico Brasileiro firmam acordo de cooperação técnica</h3>\n\n\n\n<p>Parceria tem duração de cinco anos e amplia a relação entre a universidade e o CPBpor <br>Autor: <em>Naiara Ashaia</em> / <em>(Foto: Alexandre Costa)</em></p>\n\n\n\n<p>O&nbsp;reitor&nbsp;da Universidade Federal de Uberlândia (UFU),&nbsp;Valder Steffen Júnior, e o&nbsp;pró-reitor de Extensão e Cultura, Hélder Eterno da Silveira, assinaram acordo de cooperação técnica entre a universidade e o Comitê Paralímpico Brasileiro (CPB),&nbsp;no dia 04/07. O objetivo é ampliar a contribuição entre as partes na execução de atividades de ensino, pesquisa e extensão na área da Ciência do Esporte Paralímpico.</p>\n\n\n\n<p>Em 2014, a UFU e o CPB assinaram um Protocolo de Intenções. O documento manifestava os interesses de ambas as partes, mas sem detalhamentos sobre as linhas de atuação. Segundo Silveira, o protocolo era frágil perto da quantidade de ações e possibilidades que a universidade pode desenvolver com o CPB.</p>\n\n\n\n<p>O acordo, que tem vigência de cinco anos, pretende ampliar o alcance de atividades de ensino, pesquisa e extensão na área do desporto paralímpico. Para o pró-reitor, “o protocolo de intenções sinaliza, mas o que concretiza é, de fato, esse acordo de cooperação técnica”.</p>\n\n\n\n<p>Para o atual diretor técnico do Comitê Paralímpico Brasileiro, Alberto Martins da Costa, o convênio com a universidade prevê várias oportunidades. “O esporte paralímpico brasileiro é hoje uma das dez maiores potências do mundo e isso só aconteceu quando este se uniu à academia”, afirma.</p>\n\n\n\n<p>A atleta Amanda Sousa pratica halterofilismo há dez anos. Ela ressalta que Uberlândia tem tradição no esporte paralímpico e que o convênio entre o CPB e a universidade é muito importante. “Aliar pesquisa, conhecimento, ciência com a prática faz com que o desempenho de nós, atletas, melhore cada vez mais”, declara. Para ela, o reflexo dessa união é a possibilidade dos atletas executarem o trabalho de uma forma mais eficaz e poder levar o nome da cidade cada vez mais longe.</p>\n\n\n\n<p>O acordo visa o desenvolvimento, realização e certificação de cursos, seminários e congressos sobre a temática. A proposta é dar formação aos professores de educação básica para que eles conheçam e reconheçam o trabalho dos esportistas paralímpicos. Além disso, trazer o assunto para dentro da sala de aula da universidade, desenvolvendo pesquisas voltadas ao conhecimento do esporte paralímpico.</p>\n\n\n\n<p>Segundo Silveira, a universidade tem que ir além dos muros. “A UFU é um catalisador, a nossa ideia é acelerar a velocidade com que essa discussão aconteça e se melhore a partir da participação da universidade”, completa.</p>\n\n\n\n<p>Para mais informações&nbsp;sobre o acordo,&nbsp;<strong><a href="https://castbox.fm/episode/Esporte-paral%C3%ADmpico-id2136837-id168338143?country=br">ouça a entrevista com a servidora da Proexc, Fabíola Amaral</a></strong>.</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>UFU e Comitê Paralímpico Brasileiro firmam acordo de cooperação técnica Parceria tem duração de cinco anos e amplia a relação entre a universidade e o CPBpor Autor: Naiara Ashaia / (Foto: Alexandre Costa) O&nbsp;reitor&nbsp;da Universidade Federal de Uberlândia (UFU),&nbsp;Valder Steffen Júnior, e o&nbsp;pró-reitor de Extensão e Cultura, Hélder Eterno da Silveira, assinaram acordo de cooperação técnica&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 2475,
        comment_status: "closed",
        ping_status: "closed",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [47, 62],
        tags: [],
        class_list: [
            "post-2473",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-cintespbr-em-acao",
            "category-todas-as-noticias",
            "category-47",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2473",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=2473",
                },
            ],
            "version-history": [
                {
                    count: 3,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2473/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 2477,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2473/revisions/2477",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/2475",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=2473",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=2473",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=2473",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
    {
        id: 2977,
        date: "2018-11-02T11:29:16",
        date_gmt: "2018-11-02T14:29:16",
        guid: {
            rendered: "https://cintespbr.org/?p=2977",
        },
        modified: "2021-12-27T23:07:45",
        modified_gmt: "2021-12-28T02:07:45",
        slug: "vi-congresso-paradesportivo-internacional-2018",
        status: "publish",
        type: "post",
        link: "https://cintespbr.institucional.ws/vi-congresso-paradesportivo-internacional-2018/",
        title: {
            rendered: "VI Congresso Paradesportivo Internacional 2018",
        },
        content: {
            rendered:
                '\n<p><strong><em>fonte: </em></strong><em> </em><a href="http://cpb.org.br/noticia/detalhe/291/vi-congresso-paradesportivo-internacional-recebe-aprovacao-de-academicos"><em>http://cpb.org.br/noticia/detalhe/291/vi-congresso-paradesportivo-internacional-recebe-aprovacao-de-academicos</em></a><em>  </em></p>\n\n\n\n<p>Aconteu, de 1º a 4 de novembro, o VI Congresso Paradesportivo Internacional, no Centro de Treinamento Paraolímpico Brasileiro, localizado na rodovia dos Imigrantes, km115, em São Paulo/SP. O objetivo é a troca de experiências e conhecimentos em prol do desporto paralímpico.</p>\n\n\n\n<p><strong>Público-alvo:</strong>&nbsp;pesquisadores, doutores, mestres, alunos de pós-graduação, membros de grupos de pesquisa, professores, estudantes de Educação Física ou profissional de área afins.</p>\n\n\n\n<p><strong>O evento é foi realizado pelo Comitê Paralímpico Brasileiro (CPB) e a Academia Paralímpica (APB).</strong></p>\n\n\n\n<h3 class="wp-block-heading"><strong>Mesa Redonda 1</strong></h3>\n\n\n\n<p><em>Inovações Tecnológicas</em></p>\n\n\n\n<p><em>Moderador</em>: <strong>Prof. Dr. Ciro Winckler</strong> (CPB) &#8211;&nbsp;Coordenador de Ciências do Esporte na Comitê Paraolímpico Brasileiro &#8211;&nbsp;<em><strong>CPB</strong></em>.</p>\n\n\n\n<p><strong>Prof. Dr. Cleudmar Amaral</strong> (UFU) – Diretor do Centro Brasileiro de Referência em Inovações Tecnologicas para o Esporte Paralímpico &#8211; CINTESP.Br.</p>\n\n\n\n<p><strong>Prof. Dr. Rory A. Cooper</strong> (USA) &#8211;&nbsp;Bioengenheiro americano que atualmente atua como Professor Distinto da FISA / PVA, Ex-Presidente, no Departamento de Reabilitação, Ciência e Tecnologia e professor de Bioengenharia, Medicina Física e Reabilitação, e Cirurgia Ortopédica na Universidade de Pittsburgh.</p>\n\n\n\n<p><strong>Prof. Dr. Peter Kuhn&nbsp;</strong>&#8211;&nbsp;presidente da ABOTEC (Associação Brasileira de Ortopedia Técnica).</p>\n\n\n\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="683" src="https://cintespbr.org/wp-content/uploads/2019/09/vi-congresso-paradesportivo-internacional_43866186980_o-1024x683.jpg" alt="" class="wp-image-2981" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/09/vi-congresso-paradesportivo-internacional_43866186980_o-1024x683.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/09/vi-congresso-paradesportivo-internacional_43866186980_o-300x200.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/09/vi-congresso-paradesportivo-internacional_43866186980_o-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /><figcaption>02/11/2018 &#8211; Centro Paralímpico Brasileiro, São Paulo, SP &#8211; VI Congresso Paradesportivo Internacional &#8211; Mesa Redonda 1. Foto: Daniel Zappe/CPB/MPIX.</figcaption></figure>\n\n\n\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="683" src="https://cintespbr.org/wp-content/uploads/2019/09/vi-congresso-paradesportivo-internacional_43866186650_o-1024x683.jpg" alt="" class="wp-image-2980" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/09/vi-congresso-paradesportivo-internacional_43866186650_o-1024x683.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/09/vi-congresso-paradesportivo-internacional_43866186650_o-300x200.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/09/vi-congresso-paradesportivo-internacional_43866186650_o-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /><figcaption>02/11/2018 &#8211; Centro Paralímpico Brasileiro, São Paulo, SP &#8211; VI Congresso Paradesportivo Internacional &#8211; Mesa Redonda 1 &#8211; Dr. Rory A. Cooper. Foto: Daniel Zappe/CPB/MPIX.</figcaption></figure>\n\n\n\n<p><strong>Prof. Dr. Rory A. Cooper</strong> (USA) &#8211; Bioengenheiro americano que atualmente atua como Professor Distinto da FISA / PVA, Ex-Presidente, no Departamento de Reabilitação, Ciência e Tecnologia e professor de Bioengenharia, Medicina Física e Reabilitação, e Cirurgia Ortopédica na Universidade de Pittsburgh.</p>\n\n\n\n<figure class="wp-block-image"><img loading="lazy" decoding="async" width="1024" height="683" src="https://cintespbr.org/wp-content/uploads/2019/09/vi-congresso-paradesportivo-internacional_44959304234_o-1024x683.jpg" alt="" class="wp-image-2982" srcset="https://cintespbr.institucional.ws/wp-content/uploads/2019/09/vi-congresso-paradesportivo-internacional_44959304234_o-1024x683.jpg 1024w, https://cintespbr.institucional.ws/wp-content/uploads/2019/09/vi-congresso-paradesportivo-internacional_44959304234_o-300x200.jpg 300w, https://cintespbr.institucional.ws/wp-content/uploads/2019/09/vi-congresso-paradesportivo-internacional_44959304234_o-768x512.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /><figcaption>02/11/2018 &#8211; Centro Paralímpico Brasileiro, São Paulo, SP &#8211; VI Congresso Paradesportivo Internacional &#8211; Mesa Redonda 1. Foto: Daniel Zappe/CPB/MPIX.</figcaption></figure>\n\n\n\n<p><strong>Prof. Dr. Cleudmar Amaral</strong> (UFU) – Diretor do Centro Brasileiro de Referência em Inovações Tecnologicas para o Esporte Paralímpico &#8211; CINTESP.Br.</p>\n\n\n\n<p><strong>Prof. Dr. Peter Kuhn</strong> &#8211; presidente da ABOTEC (Associação Brasileira de Ortopedia Técnica)</p>\n',
            protected: false,
        },
        excerpt: {
            rendered:
                "<p>fonte: http://cpb.org.br/noticia/detalhe/291/vi-congresso-paradesportivo-internacional-recebe-aprovacao-de-academicos Aconteu, de 1º a 4 de novembro, o VI Congresso Paradesportivo Internacional, no Centro de Treinamento Paraolímpico Brasileiro, localizado na rodovia dos Imigrantes, km115, em São Paulo/SP. O objetivo é a troca de experiências e conhecimentos em prol do desporto paralímpico. Público-alvo:&nbsp;pesquisadores, doutores, mestres, alunos de pós-graduação, membros de grupos de pesquisa, professores,&hellip;</p>\n",
            protected: false,
        },
        author: 4,
        featured_media: 2979,
        comment_status: "open",
        ping_status: "open",
        sticky: false,
        template: "",
        format: "standard",
        meta: {
            footnotes: "",
        },
        categories: [34, 62],
        tags: [],
        class_list: [
            "post-2977",
            "post",
            "type-post",
            "status-publish",
            "format-standard",
            "has-post-thumbnail",
            "hentry",
            "category-esporte-paralimpico",
            "category-todas-as-noticias",
            "category-34",
            "category-62",
            "description-off",
        ],
        _links: {
            self: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2977",
                },
            ],
            collection: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts",
                },
            ],
            about: [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/types/post",
                },
            ],
            author: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/users/4",
                },
            ],
            replies: [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/comments?post=2977",
                },
            ],
            "version-history": [
                {
                    count: 2,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2977/revisions",
                },
            ],
            "predecessor-version": [
                {
                    id: 3006,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/posts/2977/revisions/3006",
                },
            ],
            "wp:featuredmedia": [
                {
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media/2979",
                },
            ],
            "wp:attachment": [
                {
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/media?parent=2977",
                },
            ],
            "wp:term": [
                {
                    taxonomy: "category",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/categories?post=2977",
                },
                {
                    taxonomy: "post_tag",
                    embeddable: true,
                    href: "https://cintespbr.institucional.ws/wp-json/wp/v2/tags?post=2977",
                },
            ],
            curies: [
                {
                    name: "wp",
                    href: "https://api.w.org/{rel}",
                    templated: true,
                },
            ],
        },
    },
];
export { wpPosts };
